
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire49d0"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire49d0"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("i9BKe", function(module, exports) {

$parcel$export(module.exports, "ExtensionType", () => $2726d886f4171354$export$4f037c6ec2da4eeb);
$parcel$export(module.exports, "extensions", () => $2726d886f4171354$export$cc3e2d3244e01b7f);
"use strict";
var $2726d886f4171354$export$4f037c6ec2da4eeb = /* @__PURE__ */ ((ExtensionType2)=>{
    ExtensionType2["Application"] = "application";
    ExtensionType2["WebGLPipes"] = "webgl-pipes";
    ExtensionType2["WebGLPipesAdaptor"] = "webgl-pipes-adaptor";
    ExtensionType2["WebGLSystem"] = "webgl-system";
    ExtensionType2["WebGPUPipes"] = "webgpu-pipes";
    ExtensionType2["WebGPUPipesAdaptor"] = "webgpu-pipes-adaptor";
    ExtensionType2["WebGPUSystem"] = "webgpu-system";
    ExtensionType2["CanvasSystem"] = "canvas-system";
    ExtensionType2["CanvasPipesAdaptor"] = "canvas-pipes-adaptor";
    ExtensionType2["CanvasPipes"] = "canvas-pipes";
    ExtensionType2["Asset"] = "asset";
    ExtensionType2["LoadParser"] = "load-parser";
    ExtensionType2["ResolveParser"] = "resolve-parser";
    ExtensionType2["CacheParser"] = "cache-parser";
    ExtensionType2["DetectionParser"] = "detection-parser";
    ExtensionType2["MaskEffect"] = "mask-effect";
    ExtensionType2["BlendMode"] = "blend-mode";
    ExtensionType2["TextureSource"] = "texture-source";
    ExtensionType2["Environment"] = "environment";
    ExtensionType2["ShapeBuilder"] = "shape-builder";
    ExtensionType2["Batcher"] = "batcher";
    return ExtensionType2;
})($2726d886f4171354$export$4f037c6ec2da4eeb || {});
const $2726d886f4171354$var$normalizeExtension = (ext)=>{
    if (typeof ext === "function" || typeof ext === "object" && ext.extension) {
        if (!ext.extension) throw new Error("Extension class must have an extension object");
        const metadata = typeof ext.extension !== "object" ? {
            type: ext.extension
        } : ext.extension;
        ext = {
            ...metadata,
            ref: ext
        };
    }
    if (typeof ext === "object") ext = {
        ...ext
    };
    else throw new Error("Invalid extension type");
    if (typeof ext.type === "string") ext.type = [
        ext.type
    ];
    return ext;
};
const $2726d886f4171354$export$ba4241979983e013 = (ext, defaultPriority)=>$2726d886f4171354$var$normalizeExtension(ext).priority ?? defaultPriority;
const $2726d886f4171354$export$cc3e2d3244e01b7f = {
    /** @ignore */ _addHandlers: {},
    /** @ignore */ _removeHandlers: {},
    /** @ignore */ _queue: {},
    /**
   * Remove extensions from PixiJS.
   * @param extensions - Extensions to be removed.
   * @returns {extensions} For chaining.
   */ remove (...extensions2) {
        extensions2.map($2726d886f4171354$var$normalizeExtension).forEach((ext)=>{
            ext.type.forEach((type)=>this._removeHandlers[type]?.(ext));
        });
        return this;
    },
    /**
   * Register new extensions with PixiJS.
   * @param extensions - The spread of extensions to add to PixiJS.
   * @returns {extensions} For chaining.
   */ add (...extensions2) {
        extensions2.map($2726d886f4171354$var$normalizeExtension).forEach((ext)=>{
            ext.type.forEach((type)=>{
                const handlers = this._addHandlers;
                const queue = this._queue;
                if (!handlers[type]) {
                    queue[type] = queue[type] || [];
                    queue[type]?.push(ext);
                } else handlers[type]?.(ext);
            });
        });
        return this;
    },
    /**
   * Internal method to handle extensions by name.
   * @param type - The extension type.
   * @param onAdd  - Function handler when extensions are added/registered {@link StrictExtensionFormat}.
   * @param onRemove  - Function handler when extensions are removed/unregistered {@link StrictExtensionFormat}.
   * @returns {extensions} For chaining.
   */ handle (type, onAdd, onRemove) {
        const addHandlers = this._addHandlers;
        const removeHandlers = this._removeHandlers;
        if (addHandlers[type] || removeHandlers[type]) throw new Error(`Extension type ${type} already has a handler`);
        addHandlers[type] = onAdd;
        removeHandlers[type] = onRemove;
        const queue = this._queue;
        if (queue[type]) {
            queue[type]?.forEach((ext)=>onAdd(ext));
            delete queue[type];
        }
        return this;
    },
    /**
   * Handle a type, but using a map by `name` property.
   * @param type - Type of extension to handle.
   * @param map - The object map of named extensions.
   * @returns {extensions} For chaining.
   */ handleByMap (type, map) {
        return this.handle(type, (extension)=>{
            if (extension.name) map[extension.name] = extension.ref;
        }, (extension)=>{
            if (extension.name) delete map[extension.name];
        });
    },
    /**
   * Handle a type, but using a list of extensions with a `name` property.
   * @param type - Type of extension to handle.
   * @param map - The array of named extensions.
   * @param defaultPriority - Fallback priority if none is defined.
   * @returns {extensions} For chaining.
   */ handleByNamedList (type, map, defaultPriority = -1) {
        return this.handle(type, (extension)=>{
            const index = map.findIndex((item)=>item.name === extension.name);
            if (index >= 0) return;
            map.push({
                name: extension.name,
                value: extension.ref
            });
            map.sort((a, b)=>$2726d886f4171354$export$ba4241979983e013(b.value, defaultPriority) - $2726d886f4171354$export$ba4241979983e013(a.value, defaultPriority));
        }, (extension)=>{
            const index = map.findIndex((item)=>item.name === extension.name);
            if (index !== -1) map.splice(index, 1);
        });
    },
    /**
   * Handle a type, but using a list of extensions.
   * @param type - Type of extension to handle.
   * @param list - The list of extensions.
   * @param defaultPriority - The default priority to use if none is specified.
   * @returns {extensions} For chaining.
   */ handleByList (type, list, defaultPriority = -1) {
        return this.handle(type, (extension)=>{
            if (list.includes(extension.ref)) return;
            list.push(extension.ref);
            list.sort((a, b)=>$2726d886f4171354$export$ba4241979983e013(b, defaultPriority) - $2726d886f4171354$export$ba4241979983e013(a, defaultPriority));
        }, (extension)=>{
            const index = list.indexOf(extension.ref);
            if (index !== -1) list.splice(index, 1);
        });
    }
};

});

parcelRegister("c4r3z", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = Promise.all([
    $Gr8vk("b3Ge6"),
    $Gr8vk("dCEEN")
]).then(()=>parcelRequire("gFyHJ"));

});
parcelRegister("Gr8vk", function(module, exports) {
"use strict";

function $07f8f9093a769793$var$load(id) {
    // eslint-disable-next-line no-undef
    return import((parcelRequire("27Lyk")).resolve(id));
}
module.exports = $07f8f9093a769793$var$load;

});


parcelRegister("1Wz6q", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = Promise.all([
    $Gr8vk("b3Ge6"),
    $Gr8vk("5zD7l")
]).then(()=>parcelRequire("danRq"));

});

parcelRegister("7dx1H", function(module, exports) {

var $i9BKe = parcelRequire("i9BKe");

var $7h8HJ = parcelRequire("7h8HJ");

var $lLQso = parcelRequire("lLQso");

var $jXXId = parcelRequire("jXXId");

var $jMNJq = parcelRequire("jMNJq");

var $8xl7d = parcelRequire("8xl7d");

var $aQPld = parcelRequire("aQPld");

var $hNatJ = parcelRequire("hNatJ");
parcelRequire("8QN7n");

"use strict";
(0, $i9BKe.extensions).add((0, $7h8HJ.AlphaMask), (0, $lLQso.ColorMask), (0, $jXXId.StencilMask), (0, $hNatJ.VideoSource), (0, $aQPld.ImageSource), (0, $8xl7d.CanvasSource), (0, $jMNJq.BufferImageSource));

});
parcelRegister("7h8HJ", function(module, exports) {

$parcel$export(module.exports, "AlphaMask", () => $90469dbfa4a0e350$export$3c32667be409917c);

var $i9BKe = parcelRequire("i9BKe");

var $4rhnu = parcelRequire("4rhnu");

var $jzlb7 = parcelRequire("jzlb7");

var $4vXk0 = parcelRequire("4vXk0");
"use strict";
class $90469dbfa4a0e350$export$3c32667be409917c {
    constructor(options){
        this.priority = 0;
        this.pipe = "alphaMask";
        if (options?.mask) this.init(options.mask);
    }
    init(mask) {
        this.mask = mask;
        this.renderMaskToTexture = !(mask instanceof (0, $4rhnu.Sprite));
        this.mask.renderable = this.renderMaskToTexture;
        this.mask.includeInBuild = !this.renderMaskToTexture;
        this.mask.measurable = false;
    }
    reset() {
        this.mask.measurable = true;
        this.mask = null;
    }
    addBounds(bounds, skipUpdateTransform) {
        (0, $jzlb7.addMaskBounds)(this.mask, bounds, skipUpdateTransform);
    }
    addLocalBounds(bounds, localRoot) {
        (0, $4vXk0.addMaskLocalBounds)(this.mask, bounds, localRoot);
    }
    containsPoint(point, hitTestFn) {
        const mask = this.mask;
        return hitTestFn(mask, point);
    }
    destroy() {
        this.reset();
    }
    static test(mask) {
        return mask instanceof (0, $4rhnu.Sprite);
    }
}
$90469dbfa4a0e350$export$3c32667be409917c.extension = (0, $i9BKe.ExtensionType).MaskEffect;

});
parcelRegister("4rhnu", function(module, exports) {

$parcel$export(module.exports, "Sprite", () => $2ddac34a8a6af484$export$3075603db8e6204c);

var $a32F4 = parcelRequire("a32F4");

var $bLlTJ = parcelRequire("bLlTJ");

var $f8J9J = parcelRequire("f8J9J");

var $5BbT9 = parcelRequire("5BbT9");
"use strict";
class $2ddac34a8a6af484$export$3075603db8e6204c extends (0, $5BbT9.ViewContainer) {
    /**
   * @param options - The options for creating the sprite.
   */ constructor(options = (0, $bLlTJ.Texture).EMPTY){
        if (options instanceof (0, $bLlTJ.Texture)) options = {
            texture: options
        };
        const { texture: texture = (0, $bLlTJ.Texture).EMPTY, anchor: anchor, roundPixels: roundPixels, width: width, height: height, ...rest } = options;
        super({
            label: "Sprite",
            ...rest
        });
        this.renderPipeId = "sprite";
        this.batched = true;
        this._didSpriteUpdate = false;
        this._sourceBounds = {
            minX: 0,
            maxX: 1,
            minY: 0,
            maxY: 0
        };
        this._sourceBoundsDirty = true;
        this._anchor = new (0, $a32F4.ObservablePoint)({
            _onUpdate: ()=>{
                this.onViewUpdate();
            }
        });
        if (anchor) this.anchor = anchor;
        else if (texture.defaultAnchor) this.anchor = texture.defaultAnchor;
        this.texture = texture;
        this.allowChildren = false;
        this.roundPixels = roundPixels ?? false;
        if (width !== void 0) this.width = width;
        if (height !== void 0) this.height = height;
    }
    /**
   * Helper function that creates a new sprite based on the source you provide.
   * The source can be - frame id, image, video, canvas element, video element, texture
   * @param source - Source to create texture from
   * @param [skipCache] - Whether to skip the cache or not
   * @returns The newly created sprite
   */ static from(source, skipCache = false) {
        if (source instanceof (0, $bLlTJ.Texture)) return new $2ddac34a8a6af484$export$3075603db8e6204c(source);
        return new $2ddac34a8a6af484$export$3075603db8e6204c((0, $bLlTJ.Texture).from(source, skipCache));
    }
    set texture(value) {
        value || (value = (0, $bLlTJ.Texture).EMPTY);
        const currentTexture = this._texture;
        if (currentTexture === value) return;
        if (currentTexture && currentTexture.dynamic) currentTexture.off("update", this.onViewUpdate, this);
        if (value.dynamic) value.on("update", this.onViewUpdate, this);
        this._texture = value;
        if (this._width) this._setWidth(this._width, this._texture.orig.width);
        if (this._height) this._setHeight(this._height, this._texture.orig.height);
        this.onViewUpdate();
    }
    /** The texture that the sprite is using. */ get texture() {
        return this._texture;
    }
    /**
   * The local bounds of the sprite.
   * @type {rendering.Bounds}
   */ get bounds() {
        if (this._boundsDirty) {
            this._updateBounds();
            this._boundsDirty = false;
        }
        return this._bounds;
    }
    /**
   * The bounds of the sprite, taking the texture's trim into account.
   * @type {rendering.Bounds}
   */ get sourceBounds() {
        if (this._sourceBoundsDirty) {
            this._updateSourceBounds();
            this._sourceBoundsDirty = false;
        }
        return this._sourceBounds;
    }
    /**
   * Checks if the object contains the given point.
   * @param point - The point to check
   */ containsPoint(point) {
        const bounds = this.sourceBounds;
        if (point.x >= bounds.maxX && point.x <= bounds.minX) {
            if (point.y >= bounds.maxY && point.y <= bounds.minY) return true;
        }
        return false;
    }
    /**
   * Adds the bounds of this object to the bounds object.
   * @param bounds - The output bounds object.
   */ addBounds(bounds) {
        const _bounds = this._texture.trim ? this.sourceBounds : this.bounds;
        bounds.addFrame(_bounds.minX, _bounds.minY, _bounds.maxX, _bounds.maxY);
    }
    onViewUpdate() {
        this._didViewChangeTick++;
        this._didSpriteUpdate = true;
        this._sourceBoundsDirty = this._boundsDirty = true;
        if (this.didViewUpdate) return;
        this.didViewUpdate = true;
        const renderGroup = this.renderGroup || this.parentRenderGroup;
        if (renderGroup) renderGroup.onChildViewUpdate(this);
    }
    _updateBounds() {
        (0, $f8J9J.updateQuadBounds)(this._bounds, this._anchor, this._texture, 0);
    }
    _updateSourceBounds() {
        const anchor = this._anchor;
        const texture = this._texture;
        const sourceBounds = this._sourceBounds;
        const { width: width, height: height } = texture.orig;
        sourceBounds.maxX = -anchor._x * width;
        sourceBounds.minX = sourceBounds.maxX + width;
        sourceBounds.maxY = -anchor._y * height;
        sourceBounds.minY = sourceBounds.maxY + height;
    }
    /**
   * Destroys this sprite renderable and optionally its texture.
   * @param options - Options parameter. A boolean will act as if all options
   *  have been set to that value
   * @param {boolean} [options.texture=false] - Should it destroy the current texture of the renderable as well
   * @param {boolean} [options.textureSource=false] - Should it destroy the textureSource of the renderable as well
   */ destroy(options = false) {
        super.destroy(options);
        const destroyTexture = typeof options === "boolean" ? options : options?.texture;
        if (destroyTexture) {
            const destroyTextureSource = typeof options === "boolean" ? options : options?.textureSource;
            this._texture.destroy(destroyTextureSource);
        }
        this._texture = null;
        this._bounds = null;
        this._sourceBounds = null;
        this._anchor = null;
    }
    /**
   * The anchor sets the origin point of the sprite. The default value is taken from the {@link Texture}
   * and passed to the constructor.
   *
   * The default is `(0,0)`, this means the sprite's origin is the top left.
   *
   * Setting the anchor to `(0.5,0.5)` means the sprite's origin is centered.
   *
   * Setting the anchor to `(1,1)` would mean the sprite's origin point will be the bottom right corner.
   *
   * If you pass only single parameter, it will set both x and y to the same value as shown in the example below.
   * @example
   * import { Sprite } from 'pixi.js';
   *
   * const sprite = new Sprite({texture: Texture.WHITE});
   * sprite.anchor.set(0.5); // This will set the origin to center. (0.5) is same as (0.5, 0.5).
   */ get anchor() {
        return this._anchor;
    }
    set anchor(value) {
        typeof value === "number" ? this._anchor.set(value) : this._anchor.copyFrom(value);
    }
    /** The width of the sprite, setting this will actually modify the scale to achieve the value set. */ get width() {
        return Math.abs(this.scale.x) * this._texture.orig.width;
    }
    set width(value) {
        this._setWidth(value, this._texture.orig.width);
        this._width = value;
    }
    /** The height of the sprite, setting this will actually modify the scale to achieve the value set. */ get height() {
        return Math.abs(this.scale.y) * this._texture.orig.height;
    }
    set height(value) {
        this._setHeight(value, this._texture.orig.height);
        this._height = value;
    }
    /**
   * Retrieves the size of the Sprite as a [Size]{@link Size} object.
   * This is faster than get the width and height separately.
   * @param out - Optional object to store the size in.
   * @returns - The size of the Sprite.
   */ getSize(out) {
        out || (out = {});
        out.width = Math.abs(this.scale.x) * this._texture.orig.width;
        out.height = Math.abs(this.scale.y) * this._texture.orig.height;
        return out;
    }
    /**
   * Sets the size of the Sprite to the specified width and height.
   * This is faster than setting the width and height separately.
   * @param value - This can be either a number or a [Size]{@link Size} object.
   * @param height - The height to set. Defaults to the value of `width` if not provided.
   */ setSize(value, height) {
        if (typeof value === "object") {
            height = value.height ?? value.width;
            value = value.width;
        } else height ?? (height = value);
        value !== void 0 && this._setWidth(value, this._texture.orig.width);
        height !== void 0 && this._setHeight(height, this._texture.orig.height);
    }
}

});
parcelRegister("a32F4", function(module, exports) {

$parcel$export(module.exports, "ObservablePoint", () => $702ea64f2b15c76d$export$3755aaad3fd42e52);
"use strict";
class $702ea64f2b15c76d$export$3755aaad3fd42e52 {
    /**
   * Creates a new `ObservablePoint`
   * @param observer - Observer to pass to listen for change events.
   * @param {number} [x=0] - position of the point on the x axis
   * @param {number} [y=0] - position of the point on the y axis
   */ constructor(observer, x, y){
        this._x = x || 0;
        this._y = y || 0;
        this._observer = observer;
    }
    /**
   * Creates a clone of this point.
   * @param observer - Optional observer to pass to the new observable point.
   * @returns a copy of this observable point
   */ clone(observer) {
        return new $702ea64f2b15c76d$export$3755aaad3fd42e52(observer ?? this._observer, this._x, this._y);
    }
    /**
   * Sets the point to a new `x` and `y` position.
   * If `y` is omitted, both `x` and `y` will be set to `x`.
   * @param {number} [x=0] - position of the point on the x axis
   * @param {number} [y=x] - position of the point on the y axis
   * @returns The observable point instance itself
   */ set(x = 0, y = x) {
        if (this._x !== x || this._y !== y) {
            this._x = x;
            this._y = y;
            this._observer._onUpdate(this);
        }
        return this;
    }
    /**
   * Copies x and y from the given point (`p`)
   * @param p - The point to copy from. Can be any of type that is or extends `PointData`
   * @returns The observable point instance itself
   */ copyFrom(p) {
        if (this._x !== p.x || this._y !== p.y) {
            this._x = p.x;
            this._y = p.y;
            this._observer._onUpdate(this);
        }
        return this;
    }
    /**
   * Copies this point's x and y into that of the given point (`p`)
   * @param p - The point to copy to. Can be any of type that is or extends `PointData`
   * @returns The point (`p`) with values updated
   */ copyTo(p) {
        p.set(this._x, this._y);
        return p;
    }
    /**
   * Accepts another point (`p`) and returns `true` if the given point is equal to this point
   * @param p - The point to check
   * @returns Returns `true` if both `x` and `y` are equal
   */ equals(p) {
        return p.x === this._x && p.y === this._y;
    }
    toString() {
        return `[pixi.js/math:ObservablePoint x=${0} y=${0} scope=${this._observer}]`;
    }
    /** Position of the observable point on the x axis. */ get x() {
        return this._x;
    }
    set x(value) {
        if (this._x !== value) {
            this._x = value;
            this._observer._onUpdate(this);
        }
    }
    /** Position of the observable point on the y axis. */ get y() {
        return this._y;
    }
    set y(value) {
        if (this._y !== value) {
            this._y = value;
            this._observer._onUpdate(this);
        }
    }
}

});

parcelRegister("bLlTJ", function(module, exports) {

$parcel$export(module.exports, "Texture", () => $dd4e44a750d6d26c$export$5431306cf43de24a);

var $3vRz3 = parcelRequire("3vRz3");

var $2RwkA = parcelRequire("2RwkA");

var $fM4Mk = parcelRequire("fM4Mk");

var $aGJhg = parcelRequire("aGJhg");

var $kXq8E = parcelRequire("kXq8E");

var $2coCi = parcelRequire("2coCi");

var $jMNJq = parcelRequire("jMNJq");

var $iA5fe = parcelRequire("iA5fe");

var $jNN6Y = parcelRequire("jNN6Y");
"use strict";
class $dd4e44a750d6d26c$export$5431306cf43de24a extends (0, (/*@__PURE__*/$parcel$interopDefault($3vRz3))) {
    /**
   * @param {rendering.TextureOptions} options - Options for the texture
   */ constructor({ source: source, label: label, frame: frame, orig: orig, trim: trim, defaultAnchor: defaultAnchor, defaultBorders: defaultBorders, rotate: rotate, dynamic: dynamic } = {}){
        super();
        /** unique id for this texture */ this.uid = (0, $aGJhg.uid)("texture");
        /** A uvs object based on the given frame and the texture source */ this.uvs = {
            x0: 0,
            y0: 0,
            x1: 0,
            y1: 0,
            x2: 0,
            y2: 0,
            x3: 0,
            y3: 0
        };
        /**
     * This is the area of the BaseTexture image to actually copy to the Canvas / WebGL when rendering,
     * irrespective of the actual frame size or placement (which can be influenced by trimmed texture atlases)
     */ this.frame = new (0, $fM4Mk.Rectangle)();
        /**
     * Does this Texture have any frame data assigned to it?
     *
     * This mode is enabled automatically if no frame was passed inside constructor.
     *
     * In this mode texture is subscribed to baseTexture events, and fires `update` on any change.
     *
     * Beware, after loading or resize of baseTexture event can fired two times!
     * If you want more control, subscribe on baseTexture itself.
     * @example
     * texture.on('update', () => {});
     */ this.noFrame = false;
        /**
     * Set to true if you plan on modifying the uvs of this texture.
     * When this is the case, sprites and other objects using the texture will
     * make sure to listen for changes to the uvs and update their vertices accordingly.
     */ this.dynamic = false;
        /** is it a texture? yes! used for type checking */ this.isTexture = true;
        this.label = label;
        this.source = source?.source ?? new (0, $iA5fe.TextureSource)();
        this.noFrame = !frame;
        if (frame) this.frame.copyFrom(frame);
        else {
            const { width: width, height: height } = this._source;
            this.frame.width = width;
            this.frame.height = height;
        }
        this.orig = orig || this.frame;
        this.trim = trim;
        this.rotate = rotate ?? 0;
        this.defaultAnchor = defaultAnchor;
        this.defaultBorders = defaultBorders;
        this.destroyed = false;
        this.dynamic = dynamic || false;
        this.updateUvs();
    }
    set source(value) {
        if (this._source) this._source.off("resize", this.update, this);
        this._source = value;
        value.on("resize", this.update, this);
        this.emit("update", this);
    }
    /** the underlying source of the texture (equivalent of baseTexture in v7) */ get source() {
        return this._source;
    }
    /** returns a TextureMatrix instance for this texture. By default, that object is not created because its heavy. */ get textureMatrix() {
        if (!this._textureMatrix) this._textureMatrix = new (0, $jNN6Y.TextureMatrix)(this);
        return this._textureMatrix;
    }
    /** The width of the Texture in pixels. */ get width() {
        return this.orig.width;
    }
    /** The height of the Texture in pixels. */ get height() {
        return this.orig.height;
    }
    /** Call this function when you have modified the frame of this texture. */ updateUvs() {
        const { uvs: uvs, frame: frame } = this;
        const { width: width, height: height } = this._source;
        const nX = frame.x / width;
        const nY = frame.y / height;
        const nW = frame.width / width;
        const nH = frame.height / height;
        let rotate = this.rotate;
        if (rotate) {
            const w2 = nW / 2;
            const h2 = nH / 2;
            const cX = nX + w2;
            const cY = nY + h2;
            rotate = (0, $2RwkA.groupD8).add(rotate, (0, $2RwkA.groupD8).NW);
            uvs.x0 = cX + w2 * (0, $2RwkA.groupD8).uX(rotate);
            uvs.y0 = cY + h2 * (0, $2RwkA.groupD8).uY(rotate);
            rotate = (0, $2RwkA.groupD8).add(rotate, 2);
            uvs.x1 = cX + w2 * (0, $2RwkA.groupD8).uX(rotate);
            uvs.y1 = cY + h2 * (0, $2RwkA.groupD8).uY(rotate);
            rotate = (0, $2RwkA.groupD8).add(rotate, 2);
            uvs.x2 = cX + w2 * (0, $2RwkA.groupD8).uX(rotate);
            uvs.y2 = cY + h2 * (0, $2RwkA.groupD8).uY(rotate);
            rotate = (0, $2RwkA.groupD8).add(rotate, 2);
            uvs.x3 = cX + w2 * (0, $2RwkA.groupD8).uX(rotate);
            uvs.y3 = cY + h2 * (0, $2RwkA.groupD8).uY(rotate);
        } else {
            uvs.x0 = nX;
            uvs.y0 = nY;
            uvs.x1 = nX + nW;
            uvs.y1 = nY;
            uvs.x2 = nX + nW;
            uvs.y2 = nY + nH;
            uvs.x3 = nX;
            uvs.y3 = nY + nH;
        }
    }
    /**
   * Destroys this texture
   * @param destroySource - Destroy the source when the texture is destroyed.
   */ destroy(destroySource = false) {
        if (this._source) {
            if (destroySource) {
                this._source.destroy();
                this._source = null;
            }
        }
        this._textureMatrix = null;
        this.destroyed = true;
        this.emit("destroy", this);
        this.removeAllListeners();
    }
    /** call this if you have modified the `texture outside` of the constructor */ update() {
        if (this.noFrame) {
            this.frame.width = this._source.width;
            this.frame.height = this._source.height;
        }
        this.updateUvs();
        this.emit("update", this);
    }
    /** @deprecated since 8.0.0 */ get baseTexture() {
        (0, $kXq8E.deprecation)((0, $kXq8E.v8_0_0), "Texture.baseTexture is now Texture.source");
        return this._source;
    }
}
$dd4e44a750d6d26c$export$5431306cf43de24a.EMPTY = new $dd4e44a750d6d26c$export$5431306cf43de24a({
    label: "EMPTY",
    source: new (0, $iA5fe.TextureSource)({
        label: "EMPTY"
    })
});
$dd4e44a750d6d26c$export$5431306cf43de24a.EMPTY.destroy = (0, $2coCi.NOOP);
$dd4e44a750d6d26c$export$5431306cf43de24a.WHITE = new $dd4e44a750d6d26c$export$5431306cf43de24a({
    source: new (0, $jMNJq.BufferImageSource)({
        resource: new Uint8Array([
            255,
            255,
            255,
            255
        ]),
        width: 1,
        height: 1,
        alphaMode: "premultiply-alpha-on-upload",
        label: "WHITE"
    }),
    label: "WHITE"
});
$dd4e44a750d6d26c$export$5431306cf43de24a.WHITE.destroy = (0, $2coCi.NOOP);

});
parcelRegister("3vRz3", function(module, exports) {
"use strict";
var $28edd11f6c7e9f5f$var$has = Object.prototype.hasOwnProperty, $28edd11f6c7e9f5f$var$prefix = "~";
/**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @private
 */ function $28edd11f6c7e9f5f$var$Events() {}
//
// We try to not inherit from `Object.prototype`. In some engines creating an
// instance in this way is faster than calling `Object.create(null)` directly.
// If `Object.create(null)` is not supported we prefix the event names with a
// character to make sure that the built-in object properties are not
// overridden or used as an attack vector.
//
if (Object.create) {
    $28edd11f6c7e9f5f$var$Events.prototype = Object.create(null);
    //
    // This hack is needed because the `__proto__` property is still inherited in
    // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
    //
    if (!new $28edd11f6c7e9f5f$var$Events().__proto__) $28edd11f6c7e9f5f$var$prefix = false;
}
/**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @private
 */ function $28edd11f6c7e9f5f$var$EE(fn, context, once) {
    this.fn = fn;
    this.context = context;
    this.once = once || false;
}
/**
 * Add a listener for a given event.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} once Specify if the listener is a one-time listener.
 * @returns {EventEmitter}
 * @private
 */ function $28edd11f6c7e9f5f$var$addListener(emitter, event, fn, context, once) {
    if (typeof fn !== "function") throw new TypeError("The listener must be a function");
    var listener = new $28edd11f6c7e9f5f$var$EE(fn, context || emitter, once), evt = $28edd11f6c7e9f5f$var$prefix ? $28edd11f6c7e9f5f$var$prefix + event : event;
    if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
    else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
    else emitter._events[evt] = [
        emitter._events[evt],
        listener
    ];
    return emitter;
}
/**
 * Clear event by name.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} evt The Event name.
 * @private
 */ function $28edd11f6c7e9f5f$var$clearEvent(emitter, evt) {
    if (--emitter._eventsCount === 0) emitter._events = new $28edd11f6c7e9f5f$var$Events();
    else delete emitter._events[evt];
}
/**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @public
 */ function $28edd11f6c7e9f5f$var$EventEmitter() {
    this._events = new $28edd11f6c7e9f5f$var$Events();
    this._eventsCount = 0;
}
/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @public
 */ $28edd11f6c7e9f5f$var$EventEmitter.prototype.eventNames = function eventNames() {
    var names = [], events, name;
    if (this._eventsCount === 0) return names;
    for(name in events = this._events)if ($28edd11f6c7e9f5f$var$has.call(events, name)) names.push($28edd11f6c7e9f5f$var$prefix ? name.slice(1) : name);
    if (Object.getOwnPropertySymbols) return names.concat(Object.getOwnPropertySymbols(events));
    return names;
};
/**
 * Return the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Array} The registered listeners.
 * @public
 */ $28edd11f6c7e9f5f$var$EventEmitter.prototype.listeners = function listeners(event) {
    var evt = $28edd11f6c7e9f5f$var$prefix ? $28edd11f6c7e9f5f$var$prefix + event : event, handlers = this._events[evt];
    if (!handlers) return [];
    if (handlers.fn) return [
        handlers.fn
    ];
    for(var i = 0, l = handlers.length, ee = new Array(l); i < l; i++)ee[i] = handlers[i].fn;
    return ee;
};
/**
 * Return the number of listeners listening to a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Number} The number of listeners.
 * @public
 */ $28edd11f6c7e9f5f$var$EventEmitter.prototype.listenerCount = function listenerCount(event) {
    var evt = $28edd11f6c7e9f5f$var$prefix ? $28edd11f6c7e9f5f$var$prefix + event : event, listeners = this._events[evt];
    if (!listeners) return 0;
    if (listeners.fn) return 1;
    return listeners.length;
};
/**
 * Calls each of the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @public
 */ $28edd11f6c7e9f5f$var$EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
    var evt = $28edd11f6c7e9f5f$var$prefix ? $28edd11f6c7e9f5f$var$prefix + event : event;
    if (!this._events[evt]) return false;
    var listeners = this._events[evt], len = arguments.length, args, i;
    if (listeners.fn) {
        if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);
        switch(len){
            case 1:
                return listeners.fn.call(listeners.context), true;
            case 2:
                return listeners.fn.call(listeners.context, a1), true;
            case 3:
                return listeners.fn.call(listeners.context, a1, a2), true;
            case 4:
                return listeners.fn.call(listeners.context, a1, a2, a3), true;
            case 5:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
            case 6:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
        }
        for(i = 1, args = new Array(len - 1); i < len; i++)args[i - 1] = arguments[i];
        listeners.fn.apply(listeners.context, args);
    } else {
        var length = listeners.length, j;
        for(i = 0; i < length; i++){
            if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);
            switch(len){
                case 1:
                    listeners[i].fn.call(listeners[i].context);
                    break;
                case 2:
                    listeners[i].fn.call(listeners[i].context, a1);
                    break;
                case 3:
                    listeners[i].fn.call(listeners[i].context, a1, a2);
                    break;
                case 4:
                    listeners[i].fn.call(listeners[i].context, a1, a2, a3);
                    break;
                default:
                    if (!args) for(j = 1, args = new Array(len - 1); j < len; j++)args[j - 1] = arguments[j];
                    listeners[i].fn.apply(listeners[i].context, args);
            }
        }
    }
    return true;
};
/**
 * Add a listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $28edd11f6c7e9f5f$var$EventEmitter.prototype.on = function on(event, fn, context) {
    return $28edd11f6c7e9f5f$var$addListener(this, event, fn, context, false);
};
/**
 * Add a one-time listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $28edd11f6c7e9f5f$var$EventEmitter.prototype.once = function once(event, fn, context) {
    return $28edd11f6c7e9f5f$var$addListener(this, event, fn, context, true);
};
/**
 * Remove the listeners of a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {*} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @public
 */ $28edd11f6c7e9f5f$var$EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
    var evt = $28edd11f6c7e9f5f$var$prefix ? $28edd11f6c7e9f5f$var$prefix + event : event;
    if (!this._events[evt]) return this;
    if (!fn) {
        $28edd11f6c7e9f5f$var$clearEvent(this, evt);
        return this;
    }
    var listeners = this._events[evt];
    if (listeners.fn) {
        if (listeners.fn === fn && (!once || listeners.once) && (!context || listeners.context === context)) $28edd11f6c7e9f5f$var$clearEvent(this, evt);
    } else {
        for(var i = 0, events = [], length = listeners.length; i < length; i++)if (listeners[i].fn !== fn || once && !listeners[i].once || context && listeners[i].context !== context) events.push(listeners[i]);
        //
        // Reset the array, or remove it completely if we have no more listeners.
        //
        if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
        else $28edd11f6c7e9f5f$var$clearEvent(this, evt);
    }
    return this;
};
/**
 * Remove all listeners, or those of the specified event.
 *
 * @param {(String|Symbol)} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @public
 */ $28edd11f6c7e9f5f$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
    var evt;
    if (event) {
        evt = $28edd11f6c7e9f5f$var$prefix ? $28edd11f6c7e9f5f$var$prefix + event : event;
        if (this._events[evt]) $28edd11f6c7e9f5f$var$clearEvent(this, evt);
    } else {
        this._events = new $28edd11f6c7e9f5f$var$Events();
        this._eventsCount = 0;
    }
    return this;
};
//
// Alias methods names because people roll like that.
//
$28edd11f6c7e9f5f$var$EventEmitter.prototype.off = $28edd11f6c7e9f5f$var$EventEmitter.prototype.removeListener;
$28edd11f6c7e9f5f$var$EventEmitter.prototype.addListener = $28edd11f6c7e9f5f$var$EventEmitter.prototype.on;
//
// Expose the prefix.
//
$28edd11f6c7e9f5f$var$EventEmitter.prefixed = $28edd11f6c7e9f5f$var$prefix;
//
// Allow `EventEmitter` to be imported as module namespace.
//
$28edd11f6c7e9f5f$var$EventEmitter.EventEmitter = $28edd11f6c7e9f5f$var$EventEmitter;
module.exports = $28edd11f6c7e9f5f$var$EventEmitter;

});

parcelRegister("2RwkA", function(module, exports) {

$parcel$export(module.exports, "groupD8", () => $99d48e5a2f9844ff$export$b7bb6a2a8d203102);

var $eY4rt = parcelRequire("eY4rt");
"use strict";
const $99d48e5a2f9844ff$var$ux = [
    1,
    1,
    0,
    -1,
    -1,
    -1,
    0,
    1,
    1,
    1,
    0,
    -1,
    -1,
    -1,
    0,
    1
];
const $99d48e5a2f9844ff$var$uy = [
    0,
    1,
    1,
    1,
    0,
    -1,
    -1,
    -1,
    0,
    1,
    1,
    1,
    0,
    -1,
    -1,
    -1
];
const $99d48e5a2f9844ff$var$vx = [
    0,
    -1,
    -1,
    -1,
    0,
    1,
    1,
    1,
    0,
    1,
    1,
    1,
    0,
    -1,
    -1,
    -1
];
const $99d48e5a2f9844ff$var$vy = [
    1,
    1,
    0,
    -1,
    -1,
    -1,
    0,
    1,
    -1,
    -1,
    0,
    1,
    1,
    1,
    0,
    -1
];
const $99d48e5a2f9844ff$var$rotationCayley = [];
const $99d48e5a2f9844ff$var$rotationMatrices = [];
const $99d48e5a2f9844ff$var$signum = Math.sign;
function $99d48e5a2f9844ff$var$init() {
    for(let i = 0; i < 16; i++){
        const row = [];
        $99d48e5a2f9844ff$var$rotationCayley.push(row);
        for(let j = 0; j < 16; j++){
            const _ux = $99d48e5a2f9844ff$var$signum($99d48e5a2f9844ff$var$ux[i] * $99d48e5a2f9844ff$var$ux[j] + $99d48e5a2f9844ff$var$vx[i] * $99d48e5a2f9844ff$var$uy[j]);
            const _uy = $99d48e5a2f9844ff$var$signum($99d48e5a2f9844ff$var$uy[i] * $99d48e5a2f9844ff$var$ux[j] + $99d48e5a2f9844ff$var$vy[i] * $99d48e5a2f9844ff$var$uy[j]);
            const _vx = $99d48e5a2f9844ff$var$signum($99d48e5a2f9844ff$var$ux[i] * $99d48e5a2f9844ff$var$vx[j] + $99d48e5a2f9844ff$var$vx[i] * $99d48e5a2f9844ff$var$vy[j]);
            const _vy = $99d48e5a2f9844ff$var$signum($99d48e5a2f9844ff$var$uy[i] * $99d48e5a2f9844ff$var$vx[j] + $99d48e5a2f9844ff$var$vy[i] * $99d48e5a2f9844ff$var$vy[j]);
            for(let k = 0; k < 16; k++)if ($99d48e5a2f9844ff$var$ux[k] === _ux && $99d48e5a2f9844ff$var$uy[k] === _uy && $99d48e5a2f9844ff$var$vx[k] === _vx && $99d48e5a2f9844ff$var$vy[k] === _vy) {
                row.push(k);
                break;
            }
        }
    }
    for(let i = 0; i < 16; i++){
        const mat = new (0, $eY4rt.Matrix)();
        mat.set($99d48e5a2f9844ff$var$ux[i], $99d48e5a2f9844ff$var$uy[i], $99d48e5a2f9844ff$var$vx[i], $99d48e5a2f9844ff$var$vy[i], 0, 0);
        $99d48e5a2f9844ff$var$rotationMatrices.push(mat);
    }
}
$99d48e5a2f9844ff$var$init();
const $99d48e5a2f9844ff$export$b7bb6a2a8d203102 = {
    /**
   * | Rotation | Direction |
   * |----------|-----------|
   * | 0°       | East      |
   * @memberof maths.groupD8
   * @constant {GD8Symmetry}
   */ E: 0,
    /**
   * | Rotation | Direction |
   * |----------|-----------|
   * | 45°↻     | Southeast |
   * @memberof maths.groupD8
   * @constant {GD8Symmetry}
   */ SE: 1,
    /**
   * | Rotation | Direction |
   * |----------|-----------|
   * | 90°↻     | South     |
   * @memberof maths.groupD8
   * @constant {GD8Symmetry}
   */ S: 2,
    /**
   * | Rotation | Direction |
   * |----------|-----------|
   * | 135°↻    | Southwest |
   * @memberof maths.groupD8
   * @constant {GD8Symmetry}
   */ SW: 3,
    /**
   * | Rotation | Direction |
   * |----------|-----------|
   * | 180°     | West      |
   * @memberof maths.groupD8
   * @constant {GD8Symmetry}
   */ W: 4,
    /**
   * | Rotation    | Direction    |
   * |-------------|--------------|
   * | -135°/225°↻ | Northwest    |
   * @memberof maths.groupD8
   * @constant {GD8Symmetry}
   */ NW: 5,
    /**
   * | Rotation    | Direction    |
   * |-------------|--------------|
   * | -90°/270°↻  | North        |
   * @memberof maths.groupD8
   * @constant {GD8Symmetry}
   */ N: 6,
    /**
   * | Rotation    | Direction    |
   * |-------------|--------------|
   * | -45°/315°↻  | Northeast    |
   * @memberof maths.groupD8
   * @constant {GD8Symmetry}
   */ NE: 7,
    /**
   * Reflection about Y-axis.
   * @memberof maths.groupD8
   * @constant {GD8Symmetry}
   */ MIRROR_VERTICAL: 8,
    /**
   * Reflection about the main diagonal.
   * @memberof maths.groupD8
   * @constant {GD8Symmetry}
   */ MAIN_DIAGONAL: 10,
    /**
   * Reflection about X-axis.
   * @memberof maths.groupD8
   * @constant {GD8Symmetry}
   */ MIRROR_HORIZONTAL: 12,
    /**
   * Reflection about reverse diagonal.
   * @memberof maths.groupD8
   * @constant {GD8Symmetry}
   */ REVERSE_DIAGONAL: 14,
    /**
   * @memberof maths.groupD8
   * @param {GD8Symmetry} ind - sprite rotation angle.
   * @returns {GD8Symmetry} The X-component of the U-axis
   *    after rotating the axes.
   */ uX: (ind)=>$99d48e5a2f9844ff$var$ux[ind],
    /**
   * @memberof maths.groupD8
   * @param {GD8Symmetry} ind - sprite rotation angle.
   * @returns {GD8Symmetry} The Y-component of the U-axis
   *    after rotating the axes.
   */ uY: (ind)=>$99d48e5a2f9844ff$var$uy[ind],
    /**
   * @memberof maths.groupD8
   * @param {GD8Symmetry} ind - sprite rotation angle.
   * @returns {GD8Symmetry} The X-component of the V-axis
   *    after rotating the axes.
   */ vX: (ind)=>$99d48e5a2f9844ff$var$vx[ind],
    /**
   * @memberof maths.groupD8
   * @param {GD8Symmetry} ind - sprite rotation angle.
   * @returns {GD8Symmetry} The Y-component of the V-axis
   *    after rotating the axes.
   */ vY: (ind)=>$99d48e5a2f9844ff$var$vy[ind],
    /**
   * @memberof maths.groupD8
   * @param {GD8Symmetry} rotation - symmetry whose opposite
   *   is needed. Only rotations have opposite symmetries while
   *   reflections don't.
   * @returns {GD8Symmetry} The opposite symmetry of `rotation`
   */ inv: (rotation)=>{
        if (rotation & 8) return rotation & 15;
        return -rotation & 7;
    },
    /**
   * Composes the two D8 operations.
   *
   * Taking `^` as reflection:
   *
   * |       | E=0 | S=2 | W=4 | N=6 | E^=8 | S^=10 | W^=12 | N^=14 |
   * |-------|-----|-----|-----|-----|------|-------|-------|-------|
   * | E=0   | E   | S   | W   | N   | E^   | S^    | W^    | N^    |
   * | S=2   | S   | W   | N   | E   | S^   | W^    | N^    | E^    |
   * | W=4   | W   | N   | E   | S   | W^   | N^    | E^    | S^    |
   * | N=6   | N   | E   | S   | W   | N^   | E^    | S^    | W^    |
   * | E^=8  | E^  | N^  | W^  | S^  | E    | N     | W     | S     |
   * | S^=10 | S^  | E^  | N^  | W^  | S    | E     | N     | W     |
   * | W^=12 | W^  | S^  | E^  | N^  | W    | S     | E     | N     |
   * | N^=14 | N^  | W^  | S^  | E^  | N    | W     | S     | E     |
   *
   * [This is a Cayley table]{@link https://en.wikipedia.org/wiki/Cayley_table}
   * @memberof maths.groupD8
   * @param {GD8Symmetry} rotationSecond - Second operation, which
   *   is the row in the above cayley table.
   * @param {GD8Symmetry} rotationFirst - First operation, which
   *   is the column in the above cayley table.
   * @returns {GD8Symmetry} Composed operation
   */ add: (rotationSecond, rotationFirst)=>$99d48e5a2f9844ff$var$rotationCayley[rotationSecond][rotationFirst],
    /**
   * Reverse of `add`.
   * @memberof maths.groupD8
   * @param {GD8Symmetry} rotationSecond - Second operation
   * @param {GD8Symmetry} rotationFirst - First operation
   * @returns {GD8Symmetry} Result
   */ sub: (rotationSecond, rotationFirst)=>$99d48e5a2f9844ff$var$rotationCayley[rotationSecond][$99d48e5a2f9844ff$export$b7bb6a2a8d203102.inv(rotationFirst)],
    /**
   * Adds 180 degrees to rotation, which is a commutative
   * operation.
   * @memberof maths.groupD8
   * @param {number} rotation - The number to rotate.
   * @returns {number} Rotated number
   */ rotate180: (rotation)=>rotation ^ 4,
    /**
   * Checks if the rotation angle is vertical, i.e. south
   * or north. It doesn't work for reflections.
   * @memberof maths.groupD8
   * @param {GD8Symmetry} rotation - The number to check.
   * @returns {boolean} Whether or not the direction is vertical
   */ isVertical: (rotation)=>(rotation & 3) === 2,
    // rotation % 4 === 2
    /**
   * Approximates the vector `V(dx,dy)` into one of the
   * eight directions provided by `groupD8`.
   * @memberof maths.groupD8
   * @param {number} dx - X-component of the vector
   * @param {number} dy - Y-component of the vector
   * @returns {GD8Symmetry} Approximation of the vector into
   *  one of the eight symmetries.
   */ byDirection: (dx, dy)=>{
        if (Math.abs(dx) * 2 <= Math.abs(dy)) {
            if (dy >= 0) return $99d48e5a2f9844ff$export$b7bb6a2a8d203102.S;
            return $99d48e5a2f9844ff$export$b7bb6a2a8d203102.N;
        } else if (Math.abs(dy) * 2 <= Math.abs(dx)) {
            if (dx > 0) return $99d48e5a2f9844ff$export$b7bb6a2a8d203102.E;
            return $99d48e5a2f9844ff$export$b7bb6a2a8d203102.W;
        } else if (dy > 0) {
            if (dx > 0) return $99d48e5a2f9844ff$export$b7bb6a2a8d203102.SE;
            return $99d48e5a2f9844ff$export$b7bb6a2a8d203102.SW;
        } else if (dx > 0) return $99d48e5a2f9844ff$export$b7bb6a2a8d203102.NE;
        return $99d48e5a2f9844ff$export$b7bb6a2a8d203102.NW;
    },
    /**
   * Helps sprite to compensate texture packer rotation.
   * @memberof maths.groupD8
   * @param {Matrix} matrix - sprite world matrix
   * @param {GD8Symmetry} rotation - The rotation factor to use.
   * @param {number} tx - sprite anchoring
   * @param {number} ty - sprite anchoring
   */ matrixAppendRotationInv: (matrix, rotation, tx = 0, ty = 0)=>{
        const mat = $99d48e5a2f9844ff$var$rotationMatrices[$99d48e5a2f9844ff$export$b7bb6a2a8d203102.inv(rotation)];
        mat.tx = tx;
        mat.ty = ty;
        matrix.append(mat);
    }
};

});
parcelRegister("eY4rt", function(module, exports) {

$parcel$export(module.exports, "Matrix", () => $fd3f7bfaf4af3d85$export$5b12bf1653c0dd85);

var $aWW4e = parcelRequire("aWW4e");

var $1HooC = parcelRequire("1HooC");
"use strict";
class $fd3f7bfaf4af3d85$export$5b12bf1653c0dd85 {
    /**
   * @param a - x scale
   * @param b - y skew
   * @param c - x skew
   * @param d - y scale
   * @param tx - x translation
   * @param ty - y translation
   */ constructor(a = 1, b = 0, c = 0, d = 1, tx = 0, ty = 0){
        /** An array of the current matrix. Only populated when `toArray` is called */ this.array = null;
        this.a = a;
        this.b = b;
        this.c = c;
        this.d = d;
        this.tx = tx;
        this.ty = ty;
    }
    /**
   * Creates a Matrix object based on the given array. The Element to Matrix mapping order is as follows:
   *
   * a = array[0]
   * b = array[1]
   * c = array[3]
   * d = array[4]
   * tx = array[2]
   * ty = array[5]
   * @param array - The array that the matrix will be populated from.
   */ fromArray(array) {
        this.a = array[0];
        this.b = array[1];
        this.c = array[3];
        this.d = array[4];
        this.tx = array[2];
        this.ty = array[5];
    }
    /**
   * Sets the matrix properties.
   * @param a - Matrix component
   * @param b - Matrix component
   * @param c - Matrix component
   * @param d - Matrix component
   * @param tx - Matrix component
   * @param ty - Matrix component
   * @returns This matrix. Good for chaining method calls.
   */ set(a, b, c, d, tx, ty) {
        this.a = a;
        this.b = b;
        this.c = c;
        this.d = d;
        this.tx = tx;
        this.ty = ty;
        return this;
    }
    /**
   * Creates an array from the current Matrix object.
   * @param transpose - Whether we need to transpose the matrix or not
   * @param [out=new Float32Array(9)] - If provided the array will be assigned to out
   * @returns The newly created array which contains the matrix
   */ toArray(transpose, out) {
        if (!this.array) this.array = new Float32Array(9);
        const array = out || this.array;
        if (transpose) {
            array[0] = this.a;
            array[1] = this.b;
            array[2] = 0;
            array[3] = this.c;
            array[4] = this.d;
            array[5] = 0;
            array[6] = this.tx;
            array[7] = this.ty;
            array[8] = 1;
        } else {
            array[0] = this.a;
            array[1] = this.c;
            array[2] = this.tx;
            array[3] = this.b;
            array[4] = this.d;
            array[5] = this.ty;
            array[6] = 0;
            array[7] = 0;
            array[8] = 1;
        }
        return array;
    }
    /**
   * Get a new position with the current transformation applied.
   * Can be used to go from a child's coordinate space to the world coordinate space. (e.g. rendering)
   * @param pos - The origin
   * @param {Point} [newPos] - The point that the new position is assigned to (allowed to be same as input)
   * @returns {Point} The new point, transformed through this matrix
   */ apply(pos, newPos) {
        newPos = newPos || new (0, $1HooC.Point)();
        const x = pos.x;
        const y = pos.y;
        newPos.x = this.a * x + this.c * y + this.tx;
        newPos.y = this.b * x + this.d * y + this.ty;
        return newPos;
    }
    /**
   * Get a new position with the inverse of the current transformation applied.
   * Can be used to go from the world coordinate space to a child's coordinate space. (e.g. input)
   * @param pos - The origin
   * @param {Point} [newPos] - The point that the new position is assigned to (allowed to be same as input)
   * @returns {Point} The new point, inverse-transformed through this matrix
   */ applyInverse(pos, newPos) {
        newPos = newPos || new (0, $1HooC.Point)();
        const a = this.a;
        const b = this.b;
        const c = this.c;
        const d = this.d;
        const tx = this.tx;
        const ty = this.ty;
        const id = 1 / (a * d + c * -b);
        const x = pos.x;
        const y = pos.y;
        newPos.x = d * id * x + -c * id * y + (ty * c - tx * d) * id;
        newPos.y = a * id * y + -b * id * x + (-ty * a + tx * b) * id;
        return newPos;
    }
    /**
   * Translates the matrix on the x and y.
   * @param x - How much to translate x by
   * @param y - How much to translate y by
   * @returns This matrix. Good for chaining method calls.
   */ translate(x, y) {
        this.tx += x;
        this.ty += y;
        return this;
    }
    /**
   * Applies a scale transformation to the matrix.
   * @param x - The amount to scale horizontally
   * @param y - The amount to scale vertically
   * @returns This matrix. Good for chaining method calls.
   */ scale(x, y) {
        this.a *= x;
        this.d *= y;
        this.c *= x;
        this.b *= y;
        this.tx *= x;
        this.ty *= y;
        return this;
    }
    /**
   * Applies a rotation transformation to the matrix.
   * @param angle - The angle in radians.
   * @returns This matrix. Good for chaining method calls.
   */ rotate(angle) {
        const cos = Math.cos(angle);
        const sin = Math.sin(angle);
        const a1 = this.a;
        const c1 = this.c;
        const tx1 = this.tx;
        this.a = a1 * cos - this.b * sin;
        this.b = a1 * sin + this.b * cos;
        this.c = c1 * cos - this.d * sin;
        this.d = c1 * sin + this.d * cos;
        this.tx = tx1 * cos - this.ty * sin;
        this.ty = tx1 * sin + this.ty * cos;
        return this;
    }
    /**
   * Appends the given Matrix to this Matrix.
   * @param matrix - The matrix to append.
   * @returns This matrix. Good for chaining method calls.
   */ append(matrix) {
        const a1 = this.a;
        const b1 = this.b;
        const c1 = this.c;
        const d1 = this.d;
        this.a = matrix.a * a1 + matrix.b * c1;
        this.b = matrix.a * b1 + matrix.b * d1;
        this.c = matrix.c * a1 + matrix.d * c1;
        this.d = matrix.c * b1 + matrix.d * d1;
        this.tx = matrix.tx * a1 + matrix.ty * c1 + this.tx;
        this.ty = matrix.tx * b1 + matrix.ty * d1 + this.ty;
        return this;
    }
    /**
   * Appends two matrix's and sets the result to this matrix. AB = A * B
   * @param a - The matrix to append.
   * @param b - The matrix to append.
   * @returns This matrix. Good for chaining method calls.
   */ appendFrom(a, b) {
        const a1 = a.a;
        const b1 = a.b;
        const c1 = a.c;
        const d1 = a.d;
        const tx = a.tx;
        const ty = a.ty;
        const a2 = b.a;
        const b2 = b.b;
        const c2 = b.c;
        const d2 = b.d;
        this.a = a1 * a2 + b1 * c2;
        this.b = a1 * b2 + b1 * d2;
        this.c = c1 * a2 + d1 * c2;
        this.d = c1 * b2 + d1 * d2;
        this.tx = tx * a2 + ty * c2 + b.tx;
        this.ty = tx * b2 + ty * d2 + b.ty;
        return this;
    }
    /**
   * Sets the matrix based on all the available properties
   * @param x - Position on the x axis
   * @param y - Position on the y axis
   * @param pivotX - Pivot on the x axis
   * @param pivotY - Pivot on the y axis
   * @param scaleX - Scale on the x axis
   * @param scaleY - Scale on the y axis
   * @param rotation - Rotation in radians
   * @param skewX - Skew on the x axis
   * @param skewY - Skew on the y axis
   * @returns This matrix. Good for chaining method calls.
   */ setTransform(x, y, pivotX, pivotY, scaleX, scaleY, rotation, skewX, skewY) {
        this.a = Math.cos(rotation + skewY) * scaleX;
        this.b = Math.sin(rotation + skewY) * scaleX;
        this.c = -Math.sin(rotation - skewX) * scaleY;
        this.d = Math.cos(rotation - skewX) * scaleY;
        this.tx = x - (pivotX * this.a + pivotY * this.c);
        this.ty = y - (pivotX * this.b + pivotY * this.d);
        return this;
    }
    /**
   * Prepends the given Matrix to this Matrix.
   * @param matrix - The matrix to prepend
   * @returns This matrix. Good for chaining method calls.
   */ prepend(matrix) {
        const tx1 = this.tx;
        if (matrix.a !== 1 || matrix.b !== 0 || matrix.c !== 0 || matrix.d !== 1) {
            const a1 = this.a;
            const c1 = this.c;
            this.a = a1 * matrix.a + this.b * matrix.c;
            this.b = a1 * matrix.b + this.b * matrix.d;
            this.c = c1 * matrix.a + this.d * matrix.c;
            this.d = c1 * matrix.b + this.d * matrix.d;
        }
        this.tx = tx1 * matrix.a + this.ty * matrix.c + matrix.tx;
        this.ty = tx1 * matrix.b + this.ty * matrix.d + matrix.ty;
        return this;
    }
    /**
   * Decomposes the matrix (x, y, scaleX, scaleY, and rotation) and sets the properties on to a transform.
   * @param transform - The transform to apply the properties to.
   * @returns The transform with the newly applied properties
   */ decompose(transform) {
        const a = this.a;
        const b = this.b;
        const c = this.c;
        const d = this.d;
        const pivot = transform.pivot;
        const skewX = -Math.atan2(-c, d);
        const skewY = Math.atan2(b, a);
        const delta = Math.abs(skewX + skewY);
        if (delta < 1e-5 || Math.abs((0, $aWW4e.PI_2) - delta) < 1e-5) {
            transform.rotation = skewY;
            transform.skew.x = transform.skew.y = 0;
        } else {
            transform.rotation = 0;
            transform.skew.x = skewX;
            transform.skew.y = skewY;
        }
        transform.scale.x = Math.sqrt(a * a + b * b);
        transform.scale.y = Math.sqrt(c * c + d * d);
        transform.position.x = this.tx + (pivot.x * a + pivot.y * c);
        transform.position.y = this.ty + (pivot.x * b + pivot.y * d);
        return transform;
    }
    /**
   * Inverts this matrix
   * @returns This matrix. Good for chaining method calls.
   */ invert() {
        const a1 = this.a;
        const b1 = this.b;
        const c1 = this.c;
        const d1 = this.d;
        const tx1 = this.tx;
        const n = a1 * d1 - b1 * c1;
        this.a = d1 / n;
        this.b = -b1 / n;
        this.c = -c1 / n;
        this.d = a1 / n;
        this.tx = (c1 * this.ty - d1 * tx1) / n;
        this.ty = -(a1 * this.ty - b1 * tx1) / n;
        return this;
    }
    /** Checks if this matrix is an identity matrix */ isIdentity() {
        return this.a === 1 && this.b === 0 && this.c === 0 && this.d === 1 && this.tx === 0 && this.ty === 0;
    }
    /**
   * Resets this Matrix to an identity (default) matrix.
   * @returns This matrix. Good for chaining method calls.
   */ identity() {
        this.a = 1;
        this.b = 0;
        this.c = 0;
        this.d = 1;
        this.tx = 0;
        this.ty = 0;
        return this;
    }
    /**
   * Creates a new Matrix object with the same values as this one.
   * @returns A copy of this matrix. Good for chaining method calls.
   */ clone() {
        const matrix = new $fd3f7bfaf4af3d85$export$5b12bf1653c0dd85();
        matrix.a = this.a;
        matrix.b = this.b;
        matrix.c = this.c;
        matrix.d = this.d;
        matrix.tx = this.tx;
        matrix.ty = this.ty;
        return matrix;
    }
    /**
   * Changes the values of the given matrix to be the same as the ones in this matrix
   * @param matrix - The matrix to copy to.
   * @returns The matrix given in parameter with its values updated.
   */ copyTo(matrix) {
        matrix.a = this.a;
        matrix.b = this.b;
        matrix.c = this.c;
        matrix.d = this.d;
        matrix.tx = this.tx;
        matrix.ty = this.ty;
        return matrix;
    }
    /**
   * Changes the values of the matrix to be the same as the ones in given matrix
   * @param matrix - The matrix to copy from.
   * @returns this
   */ copyFrom(matrix) {
        this.a = matrix.a;
        this.b = matrix.b;
        this.c = matrix.c;
        this.d = matrix.d;
        this.tx = matrix.tx;
        this.ty = matrix.ty;
        return this;
    }
    /**
   * check to see if two matrices are the same
   * @param matrix - The matrix to compare to.
   */ equals(matrix) {
        return matrix.a === this.a && matrix.b === this.b && matrix.c === this.c && matrix.d === this.d && matrix.tx === this.tx && matrix.ty === this.ty;
    }
    toString() {
        return `[pixi.js:Matrix a=${this.a} b=${this.b} c=${this.c} d=${this.d} tx=${this.tx} ty=${this.ty}]`;
    }
    /**
   * A default (identity) matrix.
   *
   * This is a shared object, if you want to modify it consider creating a new `Matrix`
   * @readonly
   */ static get IDENTITY() {
        return $fd3f7bfaf4af3d85$var$identityMatrix.identity();
    }
    /**
   * A static Matrix that can be used to avoid creating new objects.
   * Will always ensure the matrix is reset to identity when requested.
   * Use this object for fast but temporary calculations, as it may be mutated later on.
   * This is a different object to the `IDENTITY` object and so can be modified without changing `IDENTITY`.
   * @readonly
   */ static get shared() {
        return $fd3f7bfaf4af3d85$var$tempMatrix.identity();
    }
}
const $fd3f7bfaf4af3d85$var$tempMatrix = new $fd3f7bfaf4af3d85$export$5b12bf1653c0dd85();
const $fd3f7bfaf4af3d85$var$identityMatrix = new $fd3f7bfaf4af3d85$export$5b12bf1653c0dd85();

});
parcelRegister("aWW4e", function(module, exports) {

$parcel$export(module.exports, "PI_2", () => $635707f32e142ac4$export$59ed0a0a5de1084b);
$parcel$export(module.exports, "RAD_TO_DEG", () => $635707f32e142ac4$export$3f91627dc85c5d57);
$parcel$export(module.exports, "DEG_TO_RAD", () => $635707f32e142ac4$export$870617f62e3187f1);
"use strict";
const $635707f32e142ac4$export$59ed0a0a5de1084b = Math.PI * 2;
const $635707f32e142ac4$export$3f91627dc85c5d57 = 180 / Math.PI;
const $635707f32e142ac4$export$870617f62e3187f1 = Math.PI / 180;

});

parcelRegister("1HooC", function(module, exports) {

$parcel$export(module.exports, "Point", () => $fdaff9f788d94485$export$baf26146a414f24a);
"use strict";
class $fdaff9f788d94485$export$baf26146a414f24a {
    /**
   * Creates a new `Point`
   * @param {number} [x=0] - position of the point on the x axis
   * @param {number} [y=0] - position of the point on the y axis
   */ constructor(x = 0, y = 0){
        /** Position of the point on the x axis */ this.x = 0;
        /** Position of the point on the y axis */ this.y = 0;
        this.x = x;
        this.y = y;
    }
    /**
   * Creates a clone of this point
   * @returns A clone of this point
   */ clone() {
        return new $fdaff9f788d94485$export$baf26146a414f24a(this.x, this.y);
    }
    /**
   * Copies `x` and `y` from the given point into this point
   * @param p - The point to copy from
   * @returns The point instance itself
   */ copyFrom(p) {
        this.set(p.x, p.y);
        return this;
    }
    /**
   * Copies this point's x and y into the given point (`p`).
   * @param p - The point to copy to. Can be any of type that is or extends `PointData`
   * @returns The point (`p`) with values updated
   */ copyTo(p) {
        p.set(this.x, this.y);
        return p;
    }
    /**
   * Accepts another point (`p`) and returns `true` if the given point is equal to this point
   * @param p - The point to check
   * @returns Returns `true` if both `x` and `y` are equal
   */ equals(p) {
        return p.x === this.x && p.y === this.y;
    }
    /**
   * Sets the point to a new `x` and `y` position.
   * If `y` is omitted, both `x` and `y` will be set to `x`.
   * @param {number} [x=0] - position of the point on the `x` axis
   * @param {number} [y=x] - position of the point on the `y` axis
   * @returns The point instance itself
   */ set(x = 0, y = x) {
        this.x = x;
        this.y = y;
        return this;
    }
    toString() {
        return `[pixi.js/math:Point x=${this.x} y=${this.y}]`;
    }
    /**
   * A static Point object with `x` and `y` values of `0`. Can be used to avoid creating new objects multiple times.
   * @readonly
   */ static get shared() {
        $fdaff9f788d94485$var$tempPoint.x = 0;
        $fdaff9f788d94485$var$tempPoint.y = 0;
        return $fdaff9f788d94485$var$tempPoint;
    }
}
const $fdaff9f788d94485$var$tempPoint = new $fdaff9f788d94485$export$baf26146a414f24a();

});



parcelRegister("fM4Mk", function(module, exports) {

$parcel$export(module.exports, "Rectangle", () => $55a82579353c67d9$export$4617fb02663045ef);

var $1HooC = parcelRequire("1HooC");
"use strict";
const $55a82579353c67d9$var$tempPoints = [
    new (0, $1HooC.Point)(),
    new (0, $1HooC.Point)(),
    new (0, $1HooC.Point)(),
    new (0, $1HooC.Point)()
];
class $55a82579353c67d9$export$4617fb02663045ef {
    /**
   * @param x - The X coordinate of the upper-left corner of the rectangle
   * @param y - The Y coordinate of the upper-left corner of the rectangle
   * @param width - The overall width of the rectangle
   * @param height - The overall height of the rectangle
   */ constructor(x = 0, y = 0, width = 0, height = 0){
        /**
     * The type of the object, mainly used to avoid `instanceof` checks
     * @default 'rectangle'
     */ this.type = "rectangle";
        this.x = Number(x);
        this.y = Number(y);
        this.width = Number(width);
        this.height = Number(height);
    }
    /** Returns the left edge of the rectangle. */ get left() {
        return this.x;
    }
    /** Returns the right edge of the rectangle. */ get right() {
        return this.x + this.width;
    }
    /** Returns the top edge of the rectangle. */ get top() {
        return this.y;
    }
    /** Returns the bottom edge of the rectangle. */ get bottom() {
        return this.y + this.height;
    }
    /** Determines whether the Rectangle is empty. */ isEmpty() {
        return this.left === this.right || this.top === this.bottom;
    }
    /** A constant empty rectangle. This is a new object every time the property is accessed */ static get EMPTY() {
        return new $55a82579353c67d9$export$4617fb02663045ef(0, 0, 0, 0);
    }
    /**
   * Creates a clone of this Rectangle
   * @returns a copy of the rectangle
   */ clone() {
        return new $55a82579353c67d9$export$4617fb02663045ef(this.x, this.y, this.width, this.height);
    }
    /**
   * Converts a Bounds object to a Rectangle object.
   * @param bounds - The bounds to copy and convert to a rectangle.
   * @returns Returns itself.
   */ copyFromBounds(bounds) {
        this.x = bounds.minX;
        this.y = bounds.minY;
        this.width = bounds.maxX - bounds.minX;
        this.height = bounds.maxY - bounds.minY;
        return this;
    }
    /**
   * Copies another rectangle to this one.
   * @param rectangle - The rectangle to copy from.
   * @returns Returns itself.
   */ copyFrom(rectangle) {
        this.x = rectangle.x;
        this.y = rectangle.y;
        this.width = rectangle.width;
        this.height = rectangle.height;
        return this;
    }
    /**
   * Copies this rectangle to another one.
   * @param rectangle - The rectangle to copy to.
   * @returns Returns given parameter.
   */ copyTo(rectangle) {
        rectangle.copyFrom(this);
        return rectangle;
    }
    /**
   * Checks whether the x and y coordinates given are contained within this Rectangle
   * @param x - The X coordinate of the point to test
   * @param y - The Y coordinate of the point to test
   * @returns Whether the x/y coordinates are within this Rectangle
   */ contains(x, y) {
        if (this.width <= 0 || this.height <= 0) return false;
        if (x >= this.x && x < this.x + this.width) {
            if (y >= this.y && y < this.y + this.height) return true;
        }
        return false;
    }
    /**
   * Checks whether the x and y coordinates given are contained within this rectangle including the stroke.
   * @param x - The X coordinate of the point to test
   * @param y - The Y coordinate of the point to test
   * @param strokeWidth - The width of the line to check
   * @returns Whether the x/y coordinates are within this rectangle
   */ strokeContains(x, y, strokeWidth) {
        const { width: width, height: height } = this;
        if (width <= 0 || height <= 0) return false;
        const _x = this.x;
        const _y = this.y;
        const outerLeft = _x - strokeWidth / 2;
        const outerRight = _x + width + strokeWidth / 2;
        const outerTop = _y - strokeWidth / 2;
        const outerBottom = _y + height + strokeWidth / 2;
        const innerLeft = _x + strokeWidth / 2;
        const innerRight = _x + width - strokeWidth / 2;
        const innerTop = _y + strokeWidth / 2;
        const innerBottom = _y + height - strokeWidth / 2;
        return x >= outerLeft && x <= outerRight && y >= outerTop && y <= outerBottom && !(x > innerLeft && x < innerRight && y > innerTop && y < innerBottom);
    }
    /**
   * Determines whether the `other` Rectangle transformed by `transform` intersects with `this` Rectangle object.
   * Returns true only if the area of the intersection is >0, this means that Rectangles
   * sharing a side are not overlapping. Another side effect is that an arealess rectangle
   * (width or height equal to zero) can't intersect any other rectangle.
   * @param {Rectangle} other - The Rectangle to intersect with `this`.
   * @param {Matrix} transform - The transformation matrix of `other`.
   * @returns {boolean} A value of `true` if the transformed `other` Rectangle intersects with `this`; otherwise `false`.
   */ intersects(other, transform) {
        if (!transform) {
            const x02 = this.x < other.x ? other.x : this.x;
            const x12 = this.right > other.right ? other.right : this.right;
            if (x12 <= x02) return false;
            const y02 = this.y < other.y ? other.y : this.y;
            const y12 = this.bottom > other.bottom ? other.bottom : this.bottom;
            return y12 > y02;
        }
        const x0 = this.left;
        const x1 = this.right;
        const y0 = this.top;
        const y1 = this.bottom;
        if (x1 <= x0 || y1 <= y0) return false;
        const lt = $55a82579353c67d9$var$tempPoints[0].set(other.left, other.top);
        const lb = $55a82579353c67d9$var$tempPoints[1].set(other.left, other.bottom);
        const rt = $55a82579353c67d9$var$tempPoints[2].set(other.right, other.top);
        const rb = $55a82579353c67d9$var$tempPoints[3].set(other.right, other.bottom);
        if (rt.x <= lt.x || lb.y <= lt.y) return false;
        const s = Math.sign(transform.a * transform.d - transform.b * transform.c);
        if (s === 0) return false;
        transform.apply(lt, lt);
        transform.apply(lb, lb);
        transform.apply(rt, rt);
        transform.apply(rb, rb);
        if (Math.max(lt.x, lb.x, rt.x, rb.x) <= x0 || Math.min(lt.x, lb.x, rt.x, rb.x) >= x1 || Math.max(lt.y, lb.y, rt.y, rb.y) <= y0 || Math.min(lt.y, lb.y, rt.y, rb.y) >= y1) return false;
        const nx = s * (lb.y - lt.y);
        const ny = s * (lt.x - lb.x);
        const n00 = nx * x0 + ny * y0;
        const n10 = nx * x1 + ny * y0;
        const n01 = nx * x0 + ny * y1;
        const n11 = nx * x1 + ny * y1;
        if (Math.max(n00, n10, n01, n11) <= nx * lt.x + ny * lt.y || Math.min(n00, n10, n01, n11) >= nx * rb.x + ny * rb.y) return false;
        const mx = s * (lt.y - rt.y);
        const my = s * (rt.x - lt.x);
        const m00 = mx * x0 + my * y0;
        const m10 = mx * x1 + my * y0;
        const m01 = mx * x0 + my * y1;
        const m11 = mx * x1 + my * y1;
        if (Math.max(m00, m10, m01, m11) <= mx * lt.x + my * lt.y || Math.min(m00, m10, m01, m11) >= mx * rb.x + my * rb.y) return false;
        return true;
    }
    /**
   * Pads the rectangle making it grow in all directions.
   * If paddingY is omitted, both paddingX and paddingY will be set to paddingX.
   * @param paddingX - The horizontal padding amount.
   * @param paddingY - The vertical padding amount.
   * @returns Returns itself.
   */ pad(paddingX = 0, paddingY = paddingX) {
        this.x -= paddingX;
        this.y -= paddingY;
        this.width += paddingX * 2;
        this.height += paddingY * 2;
        return this;
    }
    /**
   * Fits this rectangle around the passed one.
   * @param rectangle - The rectangle to fit.
   * @returns Returns itself.
   */ fit(rectangle) {
        const x1 = Math.max(this.x, rectangle.x);
        const x2 = Math.min(this.x + this.width, rectangle.x + rectangle.width);
        const y1 = Math.max(this.y, rectangle.y);
        const y2 = Math.min(this.y + this.height, rectangle.y + rectangle.height);
        this.x = x1;
        this.width = Math.max(x2 - x1, 0);
        this.y = y1;
        this.height = Math.max(y2 - y1, 0);
        return this;
    }
    /**
   * Enlarges rectangle that way its corners lie on grid
   * @param resolution - resolution
   * @param eps - precision
   * @returns Returns itself.
   */ ceil(resolution = 1, eps = 1e-3) {
        const x2 = Math.ceil((this.x + this.width - eps) * resolution) / resolution;
        const y2 = Math.ceil((this.y + this.height - eps) * resolution) / resolution;
        this.x = Math.floor((this.x + eps) * resolution) / resolution;
        this.y = Math.floor((this.y + eps) * resolution) / resolution;
        this.width = x2 - this.x;
        this.height = y2 - this.y;
        return this;
    }
    /**
   * Enlarges this rectangle to include the passed rectangle.
   * @param rectangle - The rectangle to include.
   * @returns Returns itself.
   */ enlarge(rectangle) {
        const x1 = Math.min(this.x, rectangle.x);
        const x2 = Math.max(this.x + this.width, rectangle.x + rectangle.width);
        const y1 = Math.min(this.y, rectangle.y);
        const y2 = Math.max(this.y + this.height, rectangle.y + rectangle.height);
        this.x = x1;
        this.width = x2 - x1;
        this.y = y1;
        this.height = y2 - y1;
        return this;
    }
    /**
   * Returns the framing rectangle of the rectangle as a Rectangle object
   * @param out - optional rectangle to store the result
   * @returns The framing rectangle
   */ getBounds(out) {
        out = out || new $55a82579353c67d9$export$4617fb02663045ef();
        out.copyFrom(this);
        return out;
    }
    toString() {
        return `[pixi.js/math:Rectangle x=${this.x} y=${this.y} width=${this.width} height=${this.height}]`;
    }
}

});

parcelRegister("aGJhg", function(module, exports) {

$parcel$export(module.exports, "uid", () => $aa9685d46d70e8a7$export$e2a22331486dcca0);
"use strict";
const $aa9685d46d70e8a7$var$uidCache = {
    default: -1
};
function $aa9685d46d70e8a7$export$e2a22331486dcca0(name = "default") {
    if ($aa9685d46d70e8a7$var$uidCache[name] === void 0) $aa9685d46d70e8a7$var$uidCache[name] = -1;
    return ++$aa9685d46d70e8a7$var$uidCache[name];
}
function $aa9685d46d70e8a7$export$220409b686c277d0() {
    for(const key in $aa9685d46d70e8a7$var$uidCache)delete $aa9685d46d70e8a7$var$uidCache[key];
}

});

parcelRegister("kXq8E", function(module, exports) {

$parcel$export(module.exports, "v8_0_0", () => $86481ab6f435a4d7$export$dc79da96439604f0);
$parcel$export(module.exports, "v8_3_4", () => $86481ab6f435a4d7$export$e88af00f5d3e8bcc);
$parcel$export(module.exports, "deprecation", () => $86481ab6f435a4d7$export$afd31d834b512e89);
"use strict";
const $86481ab6f435a4d7$var$warnings = {};
const $86481ab6f435a4d7$export$dc79da96439604f0 = "8.0.0";
const $86481ab6f435a4d7$export$e88af00f5d3e8bcc = "8.3.4";
function $86481ab6f435a4d7$export$afd31d834b512e89(version, message, ignoreDepth = 3) {
    if ($86481ab6f435a4d7$var$warnings[message]) return;
    let stack = new Error().stack;
    if (typeof stack === "undefined") console.warn("PixiJS Deprecation Warning: ", `${message}
Deprecated since v${version}`);
    else {
        stack = stack.split("\n").splice(ignoreDepth).join("\n");
        if (console.groupCollapsed) {
            console.groupCollapsed("%cPixiJS Deprecation Warning: %c%s", "color:#614108;background:#fffbe6", "font-weight:normal;color:#614108;background:#fffbe6", `${message}
Deprecated since v${version}`);
            console.warn(stack);
            console.groupEnd();
        } else {
            console.warn("PixiJS Deprecation Warning: ", `${message}
Deprecated since v${version}`);
            console.warn(stack);
        }
    }
    $86481ab6f435a4d7$var$warnings[message] = true;
}

});

parcelRegister("2coCi", function(module, exports) {

$parcel$export(module.exports, "NOOP", () => $342f4d0330a1a110$export$5702a91a6f42969f);
"use strict";
const $342f4d0330a1a110$export$5702a91a6f42969f = ()=>{};

});

parcelRegister("jMNJq", function(module, exports) {

$parcel$export(module.exports, "BufferImageSource", () => $38c8a704e7d4a191$export$1872462350fcb7cd);

var $i9BKe = parcelRequire("i9BKe");

var $iA5fe = parcelRequire("iA5fe");
"use strict";
class $38c8a704e7d4a191$export$1872462350fcb7cd extends (0, $iA5fe.TextureSource) {
    constructor(options){
        const buffer = options.resource || new Float32Array(options.width * options.height * 4);
        let format = options.format;
        if (!format) {
            if (buffer instanceof Float32Array) format = "rgba32float";
            else if (buffer instanceof Int32Array) format = "rgba32uint";
            else if (buffer instanceof Uint32Array) format = "rgba32uint";
            else if (buffer instanceof Int16Array) format = "rgba16uint";
            else if (buffer instanceof Uint16Array) format = "rgba16uint";
            else if (buffer instanceof Int8Array) format = "bgra8unorm";
            else format = "bgra8unorm";
        }
        super({
            ...options,
            resource: buffer,
            format: format
        });
        this.uploadMethodId = "buffer";
    }
    static test(resource) {
        return resource instanceof Int8Array || resource instanceof Uint8Array || resource instanceof Uint8ClampedArray || resource instanceof Int16Array || resource instanceof Uint16Array || resource instanceof Int32Array || resource instanceof Uint32Array || resource instanceof Float32Array;
    }
}
$38c8a704e7d4a191$export$1872462350fcb7cd.extension = (0, $i9BKe.ExtensionType).TextureSource;

});
parcelRegister("iA5fe", function(module, exports) {

$parcel$export(module.exports, "TextureSource", () => $50e6ce3cf0e8b717$export$8498e6a2e655d3d8);

var $3vRz3 = parcelRequire("3vRz3");

var $NbSCN = parcelRequire("NbSCN");

var $dr868 = parcelRequire("dr868");

var $aGJhg = parcelRequire("aGJhg");

var $aFPUT = parcelRequire("aFPUT");
"use strict";
const $50e6ce3cf0e8b717$var$_TextureSource = class _TextureSource extends (0, (/*@__PURE__*/$parcel$interopDefault($3vRz3))) {
    /**
   * @param options - options for creating a new TextureSource
   */ constructor(options = {}){
        super();
        this.options = options;
        /** unique id for this Texture source */ this.uid = (0, $aGJhg.uid)("textureSource");
        /**
     * The resource type used by this TextureSource. This is used by the bind groups to determine
     * how to handle this resource.
     * @ignore
     * @internal
     */ this._resourceType = "textureSource";
        /**
     * i unique resource id, used by the bind group systems.
     * This can change if the texture is resized or its resource changes
     */ this._resourceId = (0, $aGJhg.uid)("resource");
        /**
     * this is how the backends know how to upload this texture to the GPU
     * It changes depending on the resource type. Classes that extend TextureSource
     * should override this property.
     * @ignore
     * @internal
     */ this.uploadMethodId = "unknown";
        // dimensions
        this._resolution = 1;
        /** the pixel width of this texture source. This is the REAL pure number, not accounting resolution */ this.pixelWidth = 1;
        /** the pixel height of this texture source. This is the REAL pure number, not accounting resolution */ this.pixelHeight = 1;
        /**
     * the width of this texture source, accounting for resolution
     * eg pixelWidth 200, resolution 2, then width will be 100
     */ this.width = 1;
        /**
     * the height of this texture source, accounting for resolution
     * eg pixelHeight 200, resolution 2, then height will be 100
     */ this.height = 1;
        /**
     * The number of samples of a multisample texture. This is always 1 for non-multisample textures.
     * To enable multisample for a texture, set antialias to true
     * @internal
     * @ignore
     */ this.sampleCount = 1;
        /** The number of mip levels to generate for this texture. this is  overridden if autoGenerateMipmaps is true */ this.mipLevelCount = 1;
        /**
     * Should we auto generate mipmaps for this texture? This will automatically generate mipmaps
     * for this texture when uploading to the GPU. Mipmapped textures take up more memory, but
     * can look better when scaled down.
     *
     * For performance reasons, it is recommended to NOT use this with RenderTextures, as they are often updated every frame.
     * If you do, make sure to call `updateMipmaps` after you update the texture.
     */ this.autoGenerateMipmaps = false;
        /** the format that the texture data has */ this.format = "rgba8unorm";
        /** how many dimensions does this texture have? currently v8 only supports 2d */ this.dimension = "2d";
        /**
     * Only really affects RenderTextures.
     * Should we use antialiasing for this texture. It will look better, but may impact performance as a
     * Blit operation will be required to resolve the texture.
     */ this.antialias = false;
        /**
     * Used by automatic texture Garbage Collection, stores last GC tick when it was bound
     * @protected
     */ this._touched = 0;
        /**
     * Used by the batcher to build texture batches. faster to have the variable here!
     * @protected
     */ this._batchTick = -1;
        /**
     * A temporary batch location for the texture batching. Here for performance reasons only!
     * @protected
     */ this._textureBindLocation = -1;
        options = {
            ..._TextureSource.defaultOptions,
            ...options
        };
        this.label = options.label ?? "";
        this.resource = options.resource;
        this.autoGarbageCollect = options.autoGarbageCollect;
        this._resolution = options.resolution;
        if (options.width) this.pixelWidth = options.width * this._resolution;
        else this.pixelWidth = this.resource ? this.resourceWidth ?? 1 : 1;
        if (options.height) this.pixelHeight = options.height * this._resolution;
        else this.pixelHeight = this.resource ? this.resourceHeight ?? 1 : 1;
        this.width = this.pixelWidth / this._resolution;
        this.height = this.pixelHeight / this._resolution;
        this.format = options.format;
        this.dimension = options.dimensions;
        this.mipLevelCount = options.mipLevelCount;
        this.autoGenerateMipmaps = options.autoGenerateMipmaps;
        this.sampleCount = options.sampleCount;
        this.antialias = options.antialias;
        this.alphaMode = options.alphaMode;
        this.style = new (0, $aFPUT.TextureStyle)((0, $dr868.definedProps)(options));
        this.destroyed = false;
        this._refreshPOT();
    }
    /** returns itself */ get source() {
        return this;
    }
    /** the style of the texture */ get style() {
        return this._style;
    }
    set style(value) {
        if (this.style === value) return;
        this._style?.off("change", this._onStyleChange, this);
        this._style = value;
        this._style?.on("change", this._onStyleChange, this);
        this._onStyleChange();
    }
    /** setting this will set wrapModeU,wrapModeV and wrapModeW all at once! */ get addressMode() {
        return this._style.addressMode;
    }
    set addressMode(value) {
        this._style.addressMode = value;
    }
    /** setting this will set wrapModeU,wrapModeV and wrapModeW all at once! */ get repeatMode() {
        return this._style.addressMode;
    }
    set repeatMode(value) {
        this._style.addressMode = value;
    }
    /** Specifies the sampling behavior when the sample footprint is smaller than or equal to one texel. */ get magFilter() {
        return this._style.magFilter;
    }
    set magFilter(value) {
        this._style.magFilter = value;
    }
    /** Specifies the sampling behavior when the sample footprint is larger than one texel. */ get minFilter() {
        return this._style.minFilter;
    }
    set minFilter(value) {
        this._style.minFilter = value;
    }
    /** Specifies behavior for sampling between mipmap levels. */ get mipmapFilter() {
        return this._style.mipmapFilter;
    }
    set mipmapFilter(value) {
        this._style.mipmapFilter = value;
    }
    /** Specifies the minimum and maximum levels of detail, respectively, used internally when sampling a texture. */ get lodMinClamp() {
        return this._style.lodMinClamp;
    }
    set lodMinClamp(value) {
        this._style.lodMinClamp = value;
    }
    /** Specifies the minimum and maximum levels of detail, respectively, used internally when sampling a texture. */ get lodMaxClamp() {
        return this._style.lodMaxClamp;
    }
    set lodMaxClamp(value) {
        this._style.lodMaxClamp = value;
    }
    _onStyleChange() {
        this.emit("styleChange", this);
    }
    /** call this if you have modified the texture outside of the constructor */ update() {
        if (this.resource) {
            const resolution = this._resolution;
            const didResize = this.resize(this.resourceWidth / resolution, this.resourceHeight / resolution);
            if (didResize) return;
        }
        this.emit("update", this);
    }
    /** Destroys this texture source */ destroy() {
        this.destroyed = true;
        this.emit("destroy", this);
        this.emit("change", this);
        if (this._style) {
            this._style.destroy();
            this._style = null;
        }
        this.uploadMethodId = null;
        this.resource = null;
        this.removeAllListeners();
    }
    /**
   * This will unload the Texture source from the GPU. This will free up the GPU memory
   * As soon as it is required fore rendering, it will be re-uploaded.
   */ unload() {
        this._resourceId = (0, $aGJhg.uid)("resource");
        this.emit("change", this);
        this.emit("unload", this);
    }
    /** the width of the resource. This is the REAL pure number, not accounting resolution   */ get resourceWidth() {
        const { resource: resource } = this;
        return resource.naturalWidth || resource.videoWidth || resource.displayWidth || resource.width;
    }
    /** the height of the resource. This is the REAL pure number, not accounting resolution */ get resourceHeight() {
        const { resource: resource } = this;
        return resource.naturalHeight || resource.videoHeight || resource.displayHeight || resource.height;
    }
    /**
   * the resolution of the texture. Changing this number, will not change the number of pixels in the actual texture
   * but will the size of the texture when rendered.
   *
   * changing the resolution of this texture to 2 for example will make it appear twice as small when rendered (as pixel
   * density will have increased)
   */ get resolution() {
        return this._resolution;
    }
    set resolution(resolution) {
        if (this._resolution === resolution) return;
        this._resolution = resolution;
        this.width = this.pixelWidth / resolution;
        this.height = this.pixelHeight / resolution;
    }
    /**
   * Resize the texture, this is handy if you want to use the texture as a render texture
   * @param width - the new width of the texture
   * @param height - the new height of the texture
   * @param resolution - the new resolution of the texture
   * @returns - if the texture was resized
   */ resize(width, height, resolution) {
        resolution = resolution || this._resolution;
        width = width || this.width;
        height = height || this.height;
        const newPixelWidth = Math.round(width * resolution);
        const newPixelHeight = Math.round(height * resolution);
        this.width = newPixelWidth / resolution;
        this.height = newPixelHeight / resolution;
        this._resolution = resolution;
        if (this.pixelWidth === newPixelWidth && this.pixelHeight === newPixelHeight) return false;
        this._refreshPOT();
        this.pixelWidth = newPixelWidth;
        this.pixelHeight = newPixelHeight;
        this.emit("resize", this);
        this._resourceId = (0, $aGJhg.uid)("resource");
        this.emit("change", this);
        return true;
    }
    /**
   * Lets the renderer know that this texture has been updated and its mipmaps should be re-generated.
   * This is only important for RenderTexture instances, as standard Texture instances will have their
   * mipmaps generated on upload. You should call this method after you make any change to the texture
   *
   * The reason for this is is can be quite expensive to update mipmaps for a texture. So by default,
   * We want you, the developer to specify when this action should happen.
   *
   * Generally you don't want to have mipmaps generated on Render targets that are changed every frame,
   */ updateMipmaps() {
        if (this.autoGenerateMipmaps && this.mipLevelCount > 1) this.emit("updateMipmaps", this);
    }
    set wrapMode(value) {
        this._style.wrapMode = value;
    }
    get wrapMode() {
        return this._style.wrapMode;
    }
    set scaleMode(value) {
        this._style.scaleMode = value;
    }
    /** setting this will set magFilter,minFilter and mipmapFilter all at once!  */ get scaleMode() {
        return this._style.scaleMode;
    }
    /**
   * Refresh check for isPowerOfTwo texture based on size
   * @private
   */ _refreshPOT() {
        this.isPowerOfTwo = (0, $NbSCN.isPow2)(this.pixelWidth) && (0, $NbSCN.isPow2)(this.pixelHeight);
    }
    static test(_resource) {
        throw new Error("Unimplemented");
    }
};
/** The default options used when creating a new TextureSource. override these to add your own defaults */ $50e6ce3cf0e8b717$var$_TextureSource.defaultOptions = {
    resolution: 1,
    format: "bgra8unorm",
    alphaMode: "premultiply-alpha-on-upload",
    dimensions: "2d",
    mipLevelCount: 1,
    autoGenerateMipmaps: false,
    sampleCount: 1,
    antialias: false,
    autoGarbageCollect: false
};
let $50e6ce3cf0e8b717$export$8498e6a2e655d3d8 = $50e6ce3cf0e8b717$var$_TextureSource;

});
parcelRegister("NbSCN", function(module, exports) {

$parcel$export(module.exports, "nextPow2", () => $445bbf816b14b66c$export$f0d90cf68bd426eb);
$parcel$export(module.exports, "isPow2", () => $445bbf816b14b66c$export$eb50b9c078eb6ae7);
"use strict";
function $445bbf816b14b66c$export$f0d90cf68bd426eb(v) {
    v += v === 0 ? 1 : 0;
    --v;
    v |= v >>> 1;
    v |= v >>> 2;
    v |= v >>> 4;
    v |= v >>> 8;
    v |= v >>> 16;
    return v + 1;
}
function $445bbf816b14b66c$export$eb50b9c078eb6ae7(v) {
    return !(v & v - 1) && !!v;
}
function $445bbf816b14b66c$export$b9fae0bba9d9094d(v) {
    let r = (v > 65535 ? 1 : 0) << 4;
    v >>>= r;
    let shift = (v > 255 ? 1 : 0) << 3;
    v >>>= shift;
    r |= shift;
    shift = (v > 15 ? 1 : 0) << 2;
    v >>>= shift;
    r |= shift;
    shift = (v > 3 ? 1 : 0) << 1;
    v >>>= shift;
    r |= shift;
    return r | v >> 1;
}

});

parcelRegister("dr868", function(module, exports) {

$parcel$export(module.exports, "definedProps", () => $c5dcc841d9b9a11e$export$801feaffb936a09d);
"use strict";
function $c5dcc841d9b9a11e$export$801feaffb936a09d(obj) {
    const result = {};
    for(const key in obj)if (obj[key] !== void 0) result[key] = obj[key];
    return result;
}

});

parcelRegister("aFPUT", function(module, exports) {

$parcel$export(module.exports, "TextureStyle", () => $46d9af7c4b00e80a$export$1ce1d0c10d3de5d5);

var $3vRz3 = parcelRequire("3vRz3");

var $aGJhg = parcelRequire("aGJhg");

var $kXq8E = parcelRequire("kXq8E");
"use strict";
const $46d9af7c4b00e80a$var$idHash = /* @__PURE__ */ Object.create(null);
function $46d9af7c4b00e80a$var$createResourceIdFromString(value) {
    const id = $46d9af7c4b00e80a$var$idHash[value];
    if (id === void 0) $46d9af7c4b00e80a$var$idHash[value] = (0, $aGJhg.uid)("resource");
    return id;
}
const $46d9af7c4b00e80a$var$_TextureStyle = class _TextureStyle extends (0, (/*@__PURE__*/$parcel$interopDefault($3vRz3))) {
    /**
   * @param options - options for the style
   */ constructor(options = {}){
        super();
        this._resourceType = "textureSampler";
        this._touched = 0;
        /**
     * Specifies the maximum anisotropy value clamp used by the sampler.
     * Note: Most implementations support {@link GPUSamplerDescriptor#maxAnisotropy} values in range
     * between 1 and 16, inclusive. The used value of {@link GPUSamplerDescriptor#maxAnisotropy} will
     * be clamped to the maximum value that the platform supports.
     * @internal
     * @ignore
     */ this._maxAnisotropy = 1;
        /**
     * Has the style been destroyed?
     * @readonly
     */ this.destroyed = false;
        options = {
            ..._TextureStyle.defaultOptions,
            ...options
        };
        this.addressMode = options.addressMode;
        this.addressModeU = options.addressModeU ?? this.addressModeU;
        this.addressModeV = options.addressModeV ?? this.addressModeV;
        this.addressModeW = options.addressModeW ?? this.addressModeW;
        this.scaleMode = options.scaleMode;
        this.magFilter = options.magFilter ?? this.magFilter;
        this.minFilter = options.minFilter ?? this.minFilter;
        this.mipmapFilter = options.mipmapFilter ?? this.mipmapFilter;
        this.lodMinClamp = options.lodMinClamp;
        this.lodMaxClamp = options.lodMaxClamp;
        this.compare = options.compare;
        this.maxAnisotropy = options.maxAnisotropy ?? 1;
    }
    set addressMode(value) {
        this.addressModeU = value;
        this.addressModeV = value;
        this.addressModeW = value;
    }
    /** setting this will set wrapModeU,wrapModeV and wrapModeW all at once! */ get addressMode() {
        return this.addressModeU;
    }
    set wrapMode(value) {
        (0, $kXq8E.deprecation)((0, $kXq8E.v8_0_0), "TextureStyle.wrapMode is now TextureStyle.addressMode");
        this.addressMode = value;
    }
    get wrapMode() {
        return this.addressMode;
    }
    set scaleMode(value) {
        this.magFilter = value;
        this.minFilter = value;
        this.mipmapFilter = value;
    }
    /** setting this will set magFilter,minFilter and mipmapFilter all at once!  */ get scaleMode() {
        return this.magFilter;
    }
    /** Specifies the maximum anisotropy value clamp used by the sampler. */ set maxAnisotropy(value) {
        this._maxAnisotropy = Math.min(value, 16);
        if (this._maxAnisotropy > 1) this.scaleMode = "linear";
    }
    get maxAnisotropy() {
        return this._maxAnisotropy;
    }
    // TODO - move this to WebGL?
    get _resourceId() {
        return this._sharedResourceId || this._generateResourceId();
    }
    update() {
        this.emit("change", this);
        this._sharedResourceId = null;
    }
    _generateResourceId() {
        const bigKey = `${this.addressModeU}-${this.addressModeV}-${this.addressModeW}-${this.magFilter}-${this.minFilter}-${this.mipmapFilter}-${this.lodMinClamp}-${this.lodMaxClamp}-${this.compare}-${this._maxAnisotropy}`;
        this._sharedResourceId = $46d9af7c4b00e80a$var$createResourceIdFromString(bigKey);
        return this._resourceId;
    }
    /** Destroys the style */ destroy() {
        this.destroyed = true;
        this.emit("destroy", this);
        this.emit("change", this);
        this.removeAllListeners();
    }
};
/** default options for the style */ $46d9af7c4b00e80a$var$_TextureStyle.defaultOptions = {
    addressMode: "clamp-to-edge",
    scaleMode: "linear"
};
let $46d9af7c4b00e80a$export$1ce1d0c10d3de5d5 = $46d9af7c4b00e80a$var$_TextureStyle;

});



parcelRegister("jNN6Y", function(module, exports) {

$parcel$export(module.exports, "TextureMatrix", () => $707e20d60f27daa2$export$dbea3135e9da48cb);

var $eY4rt = parcelRequire("eY4rt");
"use strict";
const $707e20d60f27daa2$var$tempMat = new (0, $eY4rt.Matrix)();
class $707e20d60f27daa2$export$dbea3135e9da48cb {
    /**
   * @param texture - observed texture
   * @param clampMargin - Changes frame clamping, 0.5 by default. Use -0.5 for extra border.
   */ constructor(texture, clampMargin){
        this.mapCoord = new (0, $eY4rt.Matrix)();
        this.uClampFrame = new Float32Array(4);
        this.uClampOffset = new Float32Array(2);
        this._textureID = -1;
        this._updateID = 0;
        this.clampOffset = 0;
        if (typeof clampMargin === "undefined") this.clampMargin = texture.width < 10 ? 0 : 0.5;
        else this.clampMargin = clampMargin;
        this.isSimple = false;
        this.texture = texture;
    }
    /** Texture property. */ get texture() {
        return this._texture;
    }
    set texture(value) {
        if (this.texture === value) return;
        this._texture?.removeListener("update", this.update, this);
        this._texture = value;
        this._texture.addListener("update", this.update, this);
        this.update();
    }
    /**
   * Multiplies uvs array to transform
   * @param uvs - mesh uvs
   * @param [out=uvs] - output
   * @returns - output
   */ multiplyUvs(uvs, out) {
        if (out === void 0) out = uvs;
        const mat = this.mapCoord;
        for(let i = 0; i < uvs.length; i += 2){
            const x = uvs[i];
            const y = uvs[i + 1];
            out[i] = x * mat.a + y * mat.c + mat.tx;
            out[i + 1] = x * mat.b + y * mat.d + mat.ty;
        }
        return out;
    }
    /**
   * Updates matrices if texture was changed
   * @returns - whether or not it was updated
   */ update() {
        const tex = this._texture;
        this._updateID++;
        const uvs = tex.uvs;
        this.mapCoord.set(uvs.x1 - uvs.x0, uvs.y1 - uvs.y0, uvs.x3 - uvs.x0, uvs.y3 - uvs.y0, uvs.x0, uvs.y0);
        const orig = tex.orig;
        const trim = tex.trim;
        if (trim) {
            $707e20d60f27daa2$var$tempMat.set(orig.width / trim.width, 0, 0, orig.height / trim.height, -trim.x / trim.width, -trim.y / trim.height);
            this.mapCoord.append($707e20d60f27daa2$var$tempMat);
        }
        const texBase = tex.source;
        const frame = this.uClampFrame;
        const margin = this.clampMargin / texBase._resolution;
        const offset = this.clampOffset / texBase._resolution;
        frame[0] = (tex.frame.x + margin + offset) / texBase.width;
        frame[1] = (tex.frame.y + margin + offset) / texBase.height;
        frame[2] = (tex.frame.x + tex.frame.width - margin + offset) / texBase.width;
        frame[3] = (tex.frame.y + tex.frame.height - margin + offset) / texBase.height;
        this.uClampOffset[0] = this.clampOffset / texBase.pixelWidth;
        this.uClampOffset[1] = this.clampOffset / texBase.pixelHeight;
        this.isSimple = tex.frame.width === texBase.width && tex.frame.height === texBase.height && tex.rotate === 0;
        return true;
    }
}

});


parcelRegister("f8J9J", function(module, exports) {

$parcel$export(module.exports, "updateQuadBounds", () => $67aa708353891905$export$558ce66aa5723f1d);
"use strict";
function $67aa708353891905$export$558ce66aa5723f1d(bounds, anchor, texture, padding) {
    const { width: width, height: height } = texture.orig;
    const trim = texture.trim;
    if (trim) {
        const sourceWidth = trim.width;
        const sourceHeight = trim.height;
        bounds.minX = trim.x - anchor._x * width - padding;
        bounds.maxX = bounds.minX + sourceWidth;
        bounds.minY = trim.y - anchor._y * height - padding;
        bounds.maxY = bounds.minY + sourceHeight;
    } else {
        bounds.minX = -anchor._x * width - padding;
        bounds.maxX = bounds.minX + width;
        bounds.minY = -anchor._y * height - padding;
        bounds.maxY = bounds.minY + height;
    }
    return;
}

});

parcelRegister("5BbT9", function(module, exports) {

$parcel$export(module.exports, "ViewContainer", () => $505ab25fa048caf7$export$19fb617b96998849);

var $7wtv9 = parcelRequire("7wtv9");

var $eicwU = parcelRequire("eicwU");
"use strict";
class $505ab25fa048caf7$export$19fb617b96998849 extends (0, $eicwU.Container) {
    constructor(){
        super(...arguments);
        /** @private */ this.canBundle = true;
        /** @private */ this.allowChildren = false;
        /** @private */ this._roundPixels = 0;
        /** @private */ this._lastUsed = 0;
        /** @private */ this._lastInstructionTick = -1;
        this._bounds = new (0, $7wtv9.Bounds)(0, 1, 0, 0);
        this._boundsDirty = true;
    }
    /** @private */ _updateBounds() {}
    /**
   * Whether or not to round the x/y position of the sprite.
   * @type {boolean}
   */ get roundPixels() {
        return !!this._roundPixels;
    }
    set roundPixels(value) {
        this._roundPixels = value ? 1 : 0;
    }
    /**
   * Checks if the object contains the given point.
   * @param point - The point to check
   */ containsPoint(point) {
        const bounds = this.bounds;
        const { x: x, y: y } = point;
        return x >= bounds.minX && x <= bounds.maxX && y >= bounds.minY && y <= bounds.maxY;
    }
    destroy(options) {
        super.destroy(options);
        this._bounds = null;
    }
}

});
parcelRegister("7wtv9", function(module, exports) {

$parcel$export(module.exports, "Bounds", () => $0b15abb3a529f09f$export$c4e9d269599ab4b4);

var $eY4rt = parcelRequire("eY4rt");

var $fM4Mk = parcelRequire("fM4Mk");
"use strict";
const $0b15abb3a529f09f$var$defaultMatrix = new (0, $eY4rt.Matrix)();
class $0b15abb3a529f09f$export$c4e9d269599ab4b4 {
    constructor(minX = Infinity, minY = Infinity, maxX = -Infinity, maxY = -Infinity){
        /** @default Infinity */ this.minX = Infinity;
        /** @default Infinity */ this.minY = Infinity;
        /** @default -Infinity */ this.maxX = -Infinity;
        /** @default -Infinity */ this.maxY = -Infinity;
        this.matrix = $0b15abb3a529f09f$var$defaultMatrix;
        this.minX = minX;
        this.minY = minY;
        this.maxX = maxX;
        this.maxY = maxY;
    }
    /**
   * Checks if bounds are empty.
   * @returns - True if empty.
   */ isEmpty() {
        return this.minX > this.maxX || this.minY > this.maxY;
    }
    /** The bounding rectangle of the bounds. */ get rectangle() {
        if (!this._rectangle) this._rectangle = new (0, $fM4Mk.Rectangle)();
        const rectangle = this._rectangle;
        if (this.minX > this.maxX || this.minY > this.maxY) {
            rectangle.x = 0;
            rectangle.y = 0;
            rectangle.width = 0;
            rectangle.height = 0;
        } else rectangle.copyFromBounds(this);
        return rectangle;
    }
    /** Clears the bounds and resets. */ clear() {
        this.minX = Infinity;
        this.minY = Infinity;
        this.maxX = -Infinity;
        this.maxY = -Infinity;
        this.matrix = $0b15abb3a529f09f$var$defaultMatrix;
        return this;
    }
    /**
   * Sets the bounds.
   * @param x0 - left X of frame
   * @param y0 - top Y of frame
   * @param x1 - right X of frame
   * @param y1 - bottom Y of frame
   */ set(x0, y0, x1, y1) {
        this.minX = x0;
        this.minY = y0;
        this.maxX = x1;
        this.maxY = y1;
    }
    /**
   * Adds sprite frame
   * @param x0 - left X of frame
   * @param y0 - top Y of frame
   * @param x1 - right X of frame
   * @param y1 - bottom Y of frame
   * @param matrix
   */ addFrame(x0, y0, x1, y1, matrix) {
        matrix || (matrix = this.matrix);
        const a = matrix.a;
        const b = matrix.b;
        const c = matrix.c;
        const d = matrix.d;
        const tx = matrix.tx;
        const ty = matrix.ty;
        let minX = this.minX;
        let minY = this.minY;
        let maxX = this.maxX;
        let maxY = this.maxY;
        let x = a * x0 + c * y0 + tx;
        let y = b * x0 + d * y0 + ty;
        if (x < minX) minX = x;
        if (y < minY) minY = y;
        if (x > maxX) maxX = x;
        if (y > maxY) maxY = y;
        x = a * x1 + c * y0 + tx;
        y = b * x1 + d * y0 + ty;
        if (x < minX) minX = x;
        if (y < minY) minY = y;
        if (x > maxX) maxX = x;
        if (y > maxY) maxY = y;
        x = a * x0 + c * y1 + tx;
        y = b * x0 + d * y1 + ty;
        if (x < minX) minX = x;
        if (y < minY) minY = y;
        if (x > maxX) maxX = x;
        if (y > maxY) maxY = y;
        x = a * x1 + c * y1 + tx;
        y = b * x1 + d * y1 + ty;
        if (x < minX) minX = x;
        if (y < minY) minY = y;
        if (x > maxX) maxX = x;
        if (y > maxY) maxY = y;
        this.minX = minX;
        this.minY = minY;
        this.maxX = maxX;
        this.maxY = maxY;
    }
    /**
   * Adds a rectangle to the bounds.
   * @param rect - The rectangle to be added.
   * @param matrix - The matrix to apply to the bounds.
   */ addRect(rect, matrix) {
        this.addFrame(rect.x, rect.y, rect.x + rect.width, rect.y + rect.height, matrix);
    }
    /**
   * Adds other {@link Bounds}.
   * @param bounds - The Bounds to be added
   * @param matrix
   */ addBounds(bounds, matrix) {
        this.addFrame(bounds.minX, bounds.minY, bounds.maxX, bounds.maxY, matrix);
    }
    /**
   * Adds other Bounds, masked with Bounds.
   * @param mask - The Bounds to be added.
   */ addBoundsMask(mask) {
        this.minX = this.minX > mask.minX ? this.minX : mask.minX;
        this.minY = this.minY > mask.minY ? this.minY : mask.minY;
        this.maxX = this.maxX < mask.maxX ? this.maxX : mask.maxX;
        this.maxY = this.maxY < mask.maxY ? this.maxY : mask.maxY;
    }
    /**
   * Adds other Bounds, multiplied with matrix.
   * @param matrix - The matrix to apply to the bounds.
   */ applyMatrix(matrix) {
        const minX = this.minX;
        const minY = this.minY;
        const maxX = this.maxX;
        const maxY = this.maxY;
        const { a: a, b: b, c: c, d: d, tx: tx, ty: ty } = matrix;
        let x = a * minX + c * minY + tx;
        let y = b * minX + d * minY + ty;
        this.minX = x;
        this.minY = y;
        this.maxX = x;
        this.maxY = y;
        x = a * maxX + c * minY + tx;
        y = b * maxX + d * minY + ty;
        this.minX = x < this.minX ? x : this.minX;
        this.minY = y < this.minY ? y : this.minY;
        this.maxX = x > this.maxX ? x : this.maxX;
        this.maxY = y > this.maxY ? y : this.maxY;
        x = a * minX + c * maxY + tx;
        y = b * minX + d * maxY + ty;
        this.minX = x < this.minX ? x : this.minX;
        this.minY = y < this.minY ? y : this.minY;
        this.maxX = x > this.maxX ? x : this.maxX;
        this.maxY = y > this.maxY ? y : this.maxY;
        x = a * maxX + c * maxY + tx;
        y = b * maxX + d * maxY + ty;
        this.minX = x < this.minX ? x : this.minX;
        this.minY = y < this.minY ? y : this.minY;
        this.maxX = x > this.maxX ? x : this.maxX;
        this.maxY = y > this.maxY ? y : this.maxY;
    }
    /**
   * Resizes the bounds object to include the given rectangle.
   * @param rect - The rectangle to be included.
   */ fit(rect) {
        if (this.minX < rect.left) this.minX = rect.left;
        if (this.maxX > rect.right) this.maxX = rect.right;
        if (this.minY < rect.top) this.minY = rect.top;
        if (this.maxY > rect.bottom) this.maxY = rect.bottom;
        return this;
    }
    /**
   * Resizes the bounds object to include the given bounds.
   * @param left - The left value of the bounds.
   * @param right - The right value of the bounds.
   * @param top - The top value of the bounds.
   * @param bottom - The bottom value of the bounds.
   */ fitBounds(left, right, top, bottom) {
        if (this.minX < left) this.minX = left;
        if (this.maxX > right) this.maxX = right;
        if (this.minY < top) this.minY = top;
        if (this.maxY > bottom) this.maxY = bottom;
        return this;
    }
    /**
   * Pads bounds object, making it grow in all directions.
   * If paddingY is omitted, both paddingX and paddingY will be set to paddingX.
   * @param paddingX - The horizontal padding amount.
   * @param paddingY - The vertical padding amount.
   */ pad(paddingX, paddingY = paddingX) {
        this.minX -= paddingX;
        this.maxX += paddingX;
        this.minY -= paddingY;
        this.maxY += paddingY;
        return this;
    }
    /** Ceils the bounds. */ ceil() {
        this.minX = Math.floor(this.minX);
        this.minY = Math.floor(this.minY);
        this.maxX = Math.ceil(this.maxX);
        this.maxY = Math.ceil(this.maxY);
        return this;
    }
    /** Clones the bounds. */ clone() {
        return new $0b15abb3a529f09f$export$c4e9d269599ab4b4(this.minX, this.minY, this.maxX, this.maxY);
    }
    /**
   * Scales the bounds by the given values
   * @param x - The X value to scale by.
   * @param y - The Y value to scale by.
   */ scale(x, y = x) {
        this.minX *= x;
        this.minY *= y;
        this.maxX *= x;
        this.maxY *= y;
        return this;
    }
    /** the x value of the bounds. */ get x() {
        return this.minX;
    }
    set x(value) {
        const width = this.maxX - this.minX;
        this.minX = value;
        this.maxX = value + width;
    }
    /** the y value of the bounds. */ get y() {
        return this.minY;
    }
    set y(value) {
        const height = this.maxY - this.minY;
        this.minY = value;
        this.maxY = value + height;
    }
    /** the width value of the bounds. */ get width() {
        return this.maxX - this.minX;
    }
    set width(value) {
        this.maxX = this.minX + value;
    }
    /** the height value of the bounds. */ get height() {
        return this.maxY - this.minY;
    }
    set height(value) {
        this.maxY = this.minY + value;
    }
    /** the left value of the bounds. */ get left() {
        return this.minX;
    }
    /** the right value of the bounds. */ get right() {
        return this.maxX;
    }
    /** the top value of the bounds. */ get top() {
        return this.minY;
    }
    /** the bottom value of the bounds. */ get bottom() {
        return this.maxY;
    }
    /** Is the bounds positive. */ get isPositive() {
        return this.maxX - this.minX > 0 && this.maxY - this.minY > 0;
    }
    get isValid() {
        return this.minX + this.minY !== Infinity;
    }
    /**
   * Adds screen vertices from array
   * @param vertexData - calculated vertices
   * @param beginOffset - begin offset
   * @param endOffset - end offset, excluded
   * @param matrix
   */ addVertexData(vertexData, beginOffset, endOffset, matrix) {
        let minX = this.minX;
        let minY = this.minY;
        let maxX = this.maxX;
        let maxY = this.maxY;
        matrix || (matrix = this.matrix);
        const a = matrix.a;
        const b = matrix.b;
        const c = matrix.c;
        const d = matrix.d;
        const tx = matrix.tx;
        const ty = matrix.ty;
        for(let i = beginOffset; i < endOffset; i += 2){
            const localX = vertexData[i];
            const localY = vertexData[i + 1];
            const x = a * localX + c * localY + tx;
            const y = b * localX + d * localY + ty;
            minX = x < minX ? x : minX;
            minY = y < minY ? y : minY;
            maxX = x > maxX ? x : maxX;
            maxY = y > maxY ? y : maxY;
        }
        this.minX = minX;
        this.minY = minY;
        this.maxX = maxX;
        this.maxY = maxY;
    }
    /**
   * Checks if the point is contained within the bounds.
   * @param x - x coordinate
   * @param y - y coordinate
   */ containsPoint(x, y) {
        if (this.minX <= x && this.minY <= y && this.maxX >= x && this.maxY >= y) return true;
        return false;
    }
    toString() {
        return `[pixi.js:Bounds minX=${this.minX} minY=${this.minY} maxX=${this.maxX} maxY=${this.maxY} width=${this.width} height=${this.height}]`;
    }
}

});

parcelRegister("eicwU", function(module, exports) {

$parcel$export(module.exports, "UPDATE_COLOR", () => $8a2b4ed6f59ce4dc$export$f8ede8d8bf091ab5);
$parcel$export(module.exports, "UPDATE_BLEND", () => $8a2b4ed6f59ce4dc$export$e4801e7edc7582f);
$parcel$export(module.exports, "UPDATE_VISIBLE", () => $8a2b4ed6f59ce4dc$export$83db162b74637ea);
$parcel$export(module.exports, "Container", () => $8a2b4ed6f59ce4dc$export$42a852a2b6b56249);

var $3vRz3 = parcelRequire("3vRz3");

var $a2eTA = parcelRequire("a2eTA");

var $j1i7q = parcelRequire("j1i7q");

var $eY4rt = parcelRequire("eY4rt");

var $aWW4e = parcelRequire("aWW4e");

var $a32F4 = parcelRequire("a32F4");

var $aGJhg = parcelRequire("aGJhg");

var $kXq8E = parcelRequire("kXq8E");

var $61KiY = parcelRequire("61KiY");

var $236jP = parcelRequire("236jP");

var $apXS2 = parcelRequire("apXS2");

var $kkVML = parcelRequire("kkVML");

var $kEqoj = parcelRequire("kEqoj");

var $ggvKl = parcelRequire("ggvKl");

var $82jXu = parcelRequire("82jXu");

var $g5iYs = parcelRequire("g5iYs");

var $1pFbO = parcelRequire("1pFbO");

var $gIPW8 = parcelRequire("gIPW8");
"use strict";
const $8a2b4ed6f59ce4dc$var$defaultSkew = new (0, $a32F4.ObservablePoint)(null);
const $8a2b4ed6f59ce4dc$var$defaultPivot = new (0, $a32F4.ObservablePoint)(null);
const $8a2b4ed6f59ce4dc$var$defaultScale = new (0, $a32F4.ObservablePoint)(null, 1, 1);
const $8a2b4ed6f59ce4dc$export$f8ede8d8bf091ab5 = 1;
const $8a2b4ed6f59ce4dc$export$e4801e7edc7582f = 2;
const $8a2b4ed6f59ce4dc$export$83db162b74637ea = 4;
const $8a2b4ed6f59ce4dc$export$8363b5079568fbee = 8;
class $8a2b4ed6f59ce4dc$export$42a852a2b6b56249 extends (0, (/*@__PURE__*/$parcel$interopDefault($3vRz3))) {
    constructor(options = {}){
        super();
        /** unique id for this container */ this.uid = (0, $aGJhg.uid)("renderable");
        /** @private */ this._updateFlags = 15;
        // the render group this container owns
        /** @private */ this.renderGroup = null;
        // the render group this container belongs to
        /** @private */ this.parentRenderGroup = null;
        // the index of the container in the render group
        /** @private */ this.parentRenderGroupIndex = 0;
        // set to true if the container has changed. It is reset once the changes have been applied
        // by the transform system
        // its here to stop ensure that when things change, only one update gets registers with the transform system
        /** @private */ this.didChange = false;
        // same as above, but for the renderable
        /** @private */ this.didViewUpdate = false;
        // how deep is the container relative to its render group..
        // unless the element is the root render group - it will be relative to its parent
        /** @private */ this.relativeRenderGroupDepth = 0;
        /**
     * The array of children of this container.
     * @readonly
     */ this.children = [];
        /** The display object container that contains this display object. */ this.parent = null;
        // used internally for changing up the render order.. mainly for masks and filters
        // TODO setting this should cause a rebuild??
        /** @private */ this.includeInBuild = true;
        /** @private */ this.measurable = true;
        /** @private */ this.isSimple = true;
        // / /////////////Transform related props//////////////
        // used by the transform system to check if a container needs to be updated that frame
        // if the tick matches the current transform system tick, it is not updated again
        /**
     * @internal
     * @ignore
     */ this.updateTick = -1;
        /**
     * Current transform of the object based on local factors: position, scale, other stuff.
     * @readonly
     */ this.localTransform = new (0, $eY4rt.Matrix)();
        /**
     * The relative group transform is a transform relative to the render group it belongs too. It will include all parent
     * transforms and up to the render group (think of it as kind of like a stage - but the stage can be nested).
     * If this container is is self a render group matrix will be relative to its parent render group
     * @readonly
     */ this.relativeGroupTransform = new (0, $eY4rt.Matrix)();
        /**
     * The group transform is a transform relative to the render group it belongs too.
     * If this container is render group then this will be an identity matrix. other wise it
     * will be the same as the relativeGroupTransform.
     * Use this value when actually rendering things to the screen
     * @readonly
     */ this.groupTransform = this.relativeGroupTransform;
        /** If the object has been destroyed via destroy(). If true, it should not be used. */ this.destroyed = false;
        // transform data..
        /**
     * The coordinate of the object relative to the local coordinates of the parent.
     * @internal
     * @ignore
     */ this._position = new (0, $a32F4.ObservablePoint)(this, 0, 0);
        /**
     * The scale factor of the object.
     * @internal
     * @ignore
     */ this._scale = $8a2b4ed6f59ce4dc$var$defaultScale;
        /**
     * The pivot point of the container that it rotates around.
     * @internal
     * @ignore
     */ this._pivot = $8a2b4ed6f59ce4dc$var$defaultPivot;
        /**
     * The skew amount, on the x and y axis.
     * @internal
     * @ignore
     */ this._skew = $8a2b4ed6f59ce4dc$var$defaultSkew;
        /**
     * The X-coordinate value of the normalized local X axis,
     * the first column of the local transformation matrix without a scale.
     * @internal
     * @ignore
     */ this._cx = 1;
        /**
     * The Y-coordinate value of the normalized local X axis,
     * the first column of the local transformation matrix without a scale.
     * @internal
     * @ignore
     */ this._sx = 0;
        /**
     * The X-coordinate value of the normalized local Y axis,
     * the second column of the local transformation matrix without a scale.
     * @internal
     * @ignore
     */ this._cy = 0;
        /**
     * The Y-coordinate value of the normalized local Y axis,
     * the second column of the local transformation matrix without a scale.
     * @internal
     * @ignore
     */ this._sy = 1;
        /**
     * The rotation amount.
     * @internal
     * @ignore
     */ this._rotation = 0;
        // / COLOR related props //////////////
        // color stored as ABGR
        this.localColor = 16777215;
        this.localAlpha = 1;
        this.groupAlpha = 1;
        // A
        this.groupColor = 16777215;
        // BGR
        this.groupColorAlpha = 4294967295;
        // ABGR
        // / BLEND related props //////////////
        /**
     * @internal
     * @ignore
     */ this.localBlendMode = "inherit";
        /**
     * @internal
     * @ignore
     */ this.groupBlendMode = "normal";
        // / VISIBILITY related props //////////////
        // visibility
        // 0b11
        // first bit is visible, second bit is renderable
        /**
     * This property holds three bits: culled, visible, renderable
     * the third bit represents culling (0 = culled, 1 = not culled) 0b100
     * the second bit represents visibility (0 = not visible, 1 = visible) 0b010
     * the first bit represents renderable (0 = not renderable, 1 = renderable) 0b001
     * @internal
     * @ignore
     */ this.localDisplayStatus = 7;
        // 0b11 | 0b10 | 0b01 | 0b00
        /**
     * @internal
     * @ignore
     */ this.globalDisplayStatus = 7;
        /**
     * A value that increments each time the containe is modified
     * eg children added, removed etc
     * @ignore
     */ this._didContainerChangeTick = 0;
        /**
     * A value that increments each time the container view is modified
     * eg texture swap, geometry change etc
     * @ignore
     */ this._didViewChangeTick = 0;
        /**
     * property that tracks if the container transform has changed
     * @ignore
     */ this._didLocalTransformChangeId = -1;
        this.effects = [];
        (0, $gIPW8.assignWithIgnore)(this, options, {
            children: true,
            parent: true,
            effects: true
        });
        options.children?.forEach((child)=>this.addChild(child));
        options.parent?.addChild(this);
    }
    /**
   * Mixes all enumerable properties and methods from a source object to Container.
   * @param source - The source of properties and methods to mix in.
   */ static mixin(source) {
        Object.defineProperties($8a2b4ed6f59ce4dc$export$42a852a2b6b56249.prototype, Object.getOwnPropertyDescriptors(source));
    }
    /**
   * We now use the _didContainerChangeTick and _didViewChangeTick to track changes
   * @deprecated since 8.2.6
   * @ignore
   */ set _didChangeId(value) {
        this._didViewChangeTick = value >> 12 & 4095;
        this._didContainerChangeTick = value & 4095;
    }
    get _didChangeId() {
        return this._didContainerChangeTick & 4095 | (this._didViewChangeTick & 4095) << 12;
    }
    /**
   * Adds one or more children to the container.
   *
   * Multiple items can be added like so: `myContainer.addChild(thingOne, thingTwo, thingThree)`
   * @param {...Container} children - The Container(s) to add to the container
   * @returns {Container} - The first child that was added.
   */ addChild(...children) {
        if (!this.allowChildren) (0, $kXq8E.deprecation)((0, $kXq8E.v8_0_0), "addChild: Only Containers will be allowed to add children in v8.0.0");
        if (children.length > 1) {
            for(let i = 0; i < children.length; i++)this.addChild(children[i]);
            return children[0];
        }
        const child = children[0];
        if (child.parent === this) {
            this.children.splice(this.children.indexOf(child), 1);
            this.children.push(child);
            if (this.parentRenderGroup) this.parentRenderGroup.structureDidChange = true;
            return child;
        }
        if (child.parent) child.parent.removeChild(child);
        this.children.push(child);
        if (this.sortableChildren) this.sortDirty = true;
        child.parent = this;
        child.didChange = true;
        child.didViewUpdate = false;
        child._updateFlags = 15;
        const renderGroup = this.renderGroup || this.parentRenderGroup;
        if (renderGroup) renderGroup.addChild(child);
        this.emit("childAdded", child, this, this.children.length - 1);
        child.emit("added", this);
        this._didViewChangeTick++;
        if (child._zIndex !== 0) child.depthOfChildModified();
        return child;
    }
    /**
   * Removes one or more children from the container.
   * @param {...Container} children - The Container(s) to remove
   * @returns {Container} The first child that was removed.
   */ removeChild(...children) {
        if (children.length > 1) {
            for(let i = 0; i < children.length; i++)this.removeChild(children[i]);
            return children[0];
        }
        const child = children[0];
        const index = this.children.indexOf(child);
        if (index > -1) {
            this._didViewChangeTick++;
            this.children.splice(index, 1);
            if (this.renderGroup) this.renderGroup.removeChild(child);
            else if (this.parentRenderGroup) this.parentRenderGroup.removeChild(child);
            child.parent = null;
            this.emit("childRemoved", child, this, index);
            child.emit("removed", this);
        }
        return child;
    }
    /** @ignore */ _onUpdate(point) {
        if (point) {
            if (point === this._skew) this._updateSkew();
        }
        this._didContainerChangeTick++;
        if (this.didChange) return;
        this.didChange = true;
        if (this.parentRenderGroup) this.parentRenderGroup.onChildUpdate(this);
    }
    set isRenderGroup(value) {
        if (!!this.renderGroup === value) return;
        if (value) this.enableRenderGroup();
        else this.disableRenderGroup();
    }
    /**
   * Returns true if this container is a render group.
   * This means that it will be rendered as a separate pass, with its own set of instructions
   */ get isRenderGroup() {
        return !!this.renderGroup;
    }
    /**
   * Calling this enables a render group for this container.
   * This means it will be rendered as a separate set of instructions.
   * The transform of the container will also be handled on the GPU rather than the CPU.
   */ enableRenderGroup() {
        if (this.renderGroup) return;
        const parentRenderGroup = this.parentRenderGroup;
        parentRenderGroup?.removeChild(this);
        this.renderGroup = (0, $61KiY.BigPool).get((0, $1pFbO.RenderGroup), this);
        this.groupTransform = (0, $eY4rt.Matrix).IDENTITY;
        parentRenderGroup?.addChild(this);
        this._updateIsSimple();
    }
    /** This will disable the render group for this container. */ disableRenderGroup() {
        if (!this.renderGroup) return;
        const parentRenderGroup = this.parentRenderGroup;
        parentRenderGroup?.removeChild(this);
        (0, $61KiY.BigPool).return(this.renderGroup);
        this.renderGroup = null;
        this.groupTransform = this.relativeGroupTransform;
        parentRenderGroup?.addChild(this);
        this._updateIsSimple();
    }
    /** @ignore */ _updateIsSimple() {
        this.isSimple = !this.renderGroup && this.effects.length === 0;
    }
    /**
   * Current transform of the object based on world (parent) factors.
   * @readonly
   */ get worldTransform() {
        this._worldTransform || (this._worldTransform = new (0, $eY4rt.Matrix)());
        if (this.renderGroup) this._worldTransform.copyFrom(this.renderGroup.worldTransform);
        else if (this.parentRenderGroup) this._worldTransform.appendFrom(this.relativeGroupTransform, this.parentRenderGroup.worldTransform);
        return this._worldTransform;
    }
    // / ////// transform related stuff
    /**
   * The position of the container on the x axis relative to the local coordinates of the parent.
   * An alias to position.x
   */ get x() {
        return this._position.x;
    }
    set x(value) {
        this._position.x = value;
    }
    /**
   * The position of the container on the y axis relative to the local coordinates of the parent.
   * An alias to position.y
   */ get y() {
        return this._position.y;
    }
    set y(value) {
        this._position.y = value;
    }
    /**
   * The coordinate of the object relative to the local coordinates of the parent.
   * @since 4.0.0
   */ get position() {
        return this._position;
    }
    set position(value) {
        this._position.copyFrom(value);
    }
    /**
   * The rotation of the object in radians.
   * 'rotation' and 'angle' have the same effect on a display object; rotation is in radians, angle is in degrees.
   */ get rotation() {
        return this._rotation;
    }
    set rotation(value) {
        if (this._rotation !== value) {
            this._rotation = value;
            this._onUpdate(this._skew);
        }
    }
    /**
   * The angle of the object in degrees.
   * 'rotation' and 'angle' have the same effect on a display object; rotation is in radians, angle is in degrees.
   */ get angle() {
        return this.rotation * (0, $aWW4e.RAD_TO_DEG);
    }
    set angle(value) {
        this.rotation = value * (0, $aWW4e.DEG_TO_RAD);
    }
    /**
   * The center of rotation, scaling, and skewing for this display object in its local space. The `position`
   * is the projection of `pivot` in the parent's local space.
   *
   * By default, the pivot is the origin (0, 0).
   * @since 4.0.0
   */ get pivot() {
        if (this._pivot === $8a2b4ed6f59ce4dc$var$defaultPivot) this._pivot = new (0, $a32F4.ObservablePoint)(this, 0, 0);
        return this._pivot;
    }
    set pivot(value) {
        if (this._pivot === $8a2b4ed6f59ce4dc$var$defaultPivot) this._pivot = new (0, $a32F4.ObservablePoint)(this, 0, 0);
        typeof value === "number" ? this._pivot.set(value) : this._pivot.copyFrom(value);
    }
    /**
   * The skew factor for the object in radians.
   * @since 4.0.0
   */ get skew() {
        if (this._skew === $8a2b4ed6f59ce4dc$var$defaultSkew) this._skew = new (0, $a32F4.ObservablePoint)(this, 0, 0);
        return this._skew;
    }
    set skew(value) {
        if (this._skew === $8a2b4ed6f59ce4dc$var$defaultSkew) this._skew = new (0, $a32F4.ObservablePoint)(this, 0, 0);
        this._skew.copyFrom(value);
    }
    /**
   * The scale factors of this object along the local coordinate axes.
   *
   * The default scale is (1, 1).
   * @since 4.0.0
   */ get scale() {
        if (this._scale === $8a2b4ed6f59ce4dc$var$defaultScale) this._scale = new (0, $a32F4.ObservablePoint)(this, 1, 1);
        return this._scale;
    }
    set scale(value) {
        if (this._scale === $8a2b4ed6f59ce4dc$var$defaultScale) this._scale = new (0, $a32F4.ObservablePoint)(this, 0, 0);
        typeof value === "number" ? this._scale.set(value) : this._scale.copyFrom(value);
    }
    /**
   * The width of the Container, setting this will actually modify the scale to achieve the value set.
   * @memberof scene.Container#
   */ get width() {
        return Math.abs(this.scale.x * this.getLocalBounds().width);
    }
    set width(value) {
        const localWidth = this.getLocalBounds().width;
        this._setWidth(value, localWidth);
    }
    /**
   * The height of the Container, setting this will actually modify the scale to achieve the value set.
   * @memberof scene.Container#
   */ get height() {
        return Math.abs(this.scale.y * this.getLocalBounds().height);
    }
    set height(value) {
        const localHeight = this.getLocalBounds().height;
        this._setHeight(value, localHeight);
    }
    /**
   * Retrieves the size of the container as a [Size]{@link Size} object.
   * This is faster than get the width and height separately.
   * @param out - Optional object to store the size in.
   * @returns - The size of the container.
   * @memberof scene.Container#
   */ getSize(out) {
        if (!out) out = {};
        const bounds = this.getLocalBounds();
        out.width = Math.abs(this.scale.x * bounds.width);
        out.height = Math.abs(this.scale.y * bounds.height);
        return out;
    }
    /**
   * Sets the size of the container to the specified width and height.
   * This is faster than setting the width and height separately.
   * @param value - This can be either a number or a [Size]{@link Size} object.
   * @param height - The height to set. Defaults to the value of `width` if not provided.
   * @memberof scene.Container#
   */ setSize(value, height) {
        const size = this.getLocalBounds();
        if (typeof value === "object") {
            height = value.height ?? value.width;
            value = value.width;
        } else height ?? (height = value);
        value !== void 0 && this._setWidth(value, size.width);
        height !== void 0 && this._setHeight(height, size.height);
    }
    /** Called when the skew or the rotation changes. */ _updateSkew() {
        const rotation = this._rotation;
        const skew = this._skew;
        this._cx = Math.cos(rotation + skew._y);
        this._sx = Math.sin(rotation + skew._y);
        this._cy = -Math.sin(rotation - skew._x);
        this._sy = Math.cos(rotation - skew._x);
    }
    /**
   * Updates the transform properties of the container (accepts partial values).
   * @param {object} opts - The options for updating the transform.
   * @param {number} opts.x - The x position of the container.
   * @param {number} opts.y - The y position of the container.
   * @param {number} opts.scaleX - The scale factor on the x-axis.
   * @param {number} opts.scaleY - The scale factor on the y-axis.
   * @param {number} opts.rotation - The rotation of the container, in radians.
   * @param {number} opts.skewX - The skew factor on the x-axis.
   * @param {number} opts.skewY - The skew factor on the y-axis.
   * @param {number} opts.pivotX - The x coordinate of the pivot point.
   * @param {number} opts.pivotY - The y coordinate of the pivot point.
   */ updateTransform(opts) {
        this.position.set(typeof opts.x === "number" ? opts.x : this.position.x, typeof opts.y === "number" ? opts.y : this.position.y);
        this.scale.set(typeof opts.scaleX === "number" ? opts.scaleX || 1 : this.scale.x, typeof opts.scaleY === "number" ? opts.scaleY || 1 : this.scale.y);
        this.rotation = typeof opts.rotation === "number" ? opts.rotation : this.rotation;
        this.skew.set(typeof opts.skewX === "number" ? opts.skewX : this.skew.x, typeof opts.skewY === "number" ? opts.skewY : this.skew.y);
        this.pivot.set(typeof opts.pivotX === "number" ? opts.pivotX : this.pivot.x, typeof opts.pivotY === "number" ? opts.pivotY : this.pivot.y);
        return this;
    }
    /**
   * Updates the local transform using the given matrix.
   * @param matrix - The matrix to use for updating the transform.
   */ setFromMatrix(matrix) {
        matrix.decompose(this);
    }
    /** Updates the local transform. */ updateLocalTransform() {
        const localTransformChangeId = this._didContainerChangeTick;
        if (this._didLocalTransformChangeId === localTransformChangeId) return;
        this._didLocalTransformChangeId = localTransformChangeId;
        const lt = this.localTransform;
        const scale = this._scale;
        const pivot = this._pivot;
        const position = this._position;
        const sx = scale._x;
        const sy = scale._y;
        const px = pivot._x;
        const py = pivot._y;
        lt.a = this._cx * sx;
        lt.b = this._sx * sx;
        lt.c = this._cy * sy;
        lt.d = this._sy * sy;
        lt.tx = position._x - (px * lt.a + py * lt.c);
        lt.ty = position._y - (px * lt.b + py * lt.d);
    }
    // / ///// color related stuff
    set alpha(value) {
        if (value === this.localAlpha) return;
        this.localAlpha = value;
        this._updateFlags |= $8a2b4ed6f59ce4dc$export$f8ede8d8bf091ab5;
        this._onUpdate();
    }
    /** The opacity of the object. */ get alpha() {
        return this.localAlpha;
    }
    set tint(value) {
        const tempColor = (0, $a2eTA.Color).shared.setValue(value ?? 16777215);
        const bgr = tempColor.toBgrNumber();
        if (bgr === this.localColor) return;
        this.localColor = bgr;
        this._updateFlags |= $8a2b4ed6f59ce4dc$export$f8ede8d8bf091ab5;
        this._onUpdate();
    }
    /**
   * The tint applied to the sprite. This is a hex value.
   *
   * A value of 0xFFFFFF will remove any tint effect.
   * @default 0xFFFFFF
   */ get tint() {
        const bgr = this.localColor;
        return ((bgr & 255) << 16) + (bgr & 65280) + (bgr >> 16 & 255);
    }
    // / //////////////// blend related stuff
    set blendMode(value) {
        if (this.localBlendMode === value) return;
        if (this.parentRenderGroup) this.parentRenderGroup.structureDidChange = true;
        this._updateFlags |= $8a2b4ed6f59ce4dc$export$e4801e7edc7582f;
        this.localBlendMode = value;
        this._onUpdate();
    }
    /**
   * The blend mode to be applied to the sprite. Apply a value of `'normal'` to reset the blend mode.
   * @default 'normal'
   */ get blendMode() {
        return this.localBlendMode;
    }
    // / ///////// VISIBILITY / RENDERABLE /////////////////
    /** The visibility of the object. If false the object will not be drawn, and the transform will not be updated. */ get visible() {
        return !!(this.localDisplayStatus & 2);
    }
    set visible(value) {
        const valueNumber = value ? 2 : 0;
        if ((this.localDisplayStatus & 2) === valueNumber) return;
        if (this.parentRenderGroup) this.parentRenderGroup.structureDidChange = true;
        this._updateFlags |= $8a2b4ed6f59ce4dc$export$83db162b74637ea;
        this.localDisplayStatus ^= 2;
        this._onUpdate();
    }
    /** @ignore */ get culled() {
        return !(this.localDisplayStatus & 4);
    }
    /** @ignore */ set culled(value) {
        const valueNumber = value ? 0 : 4;
        if ((this.localDisplayStatus & 4) === valueNumber) return;
        if (this.parentRenderGroup) this.parentRenderGroup.structureDidChange = true;
        this._updateFlags |= $8a2b4ed6f59ce4dc$export$83db162b74637ea;
        this.localDisplayStatus ^= 4;
        this._onUpdate();
    }
    /** Can this object be rendered, if false the object will not be drawn but the transform will still be updated. */ get renderable() {
        return !!(this.localDisplayStatus & 1);
    }
    set renderable(value) {
        const valueNumber = value ? 1 : 0;
        if ((this.localDisplayStatus & 1) === valueNumber) return;
        this._updateFlags |= $8a2b4ed6f59ce4dc$export$83db162b74637ea;
        this.localDisplayStatus ^= 1;
        if (this.parentRenderGroup) this.parentRenderGroup.structureDidChange = true;
        this._onUpdate();
    }
    /** Whether or not the object should be rendered. */ get isRenderable() {
        return this.localDisplayStatus === 7 && this.groupAlpha > 0;
    }
    /**
   * Removes all internal references and listeners as well as removes children from the display list.
   * Do not use a Container after calling `destroy`.
   * @param options - Options parameter. A boolean will act as if all options
   *  have been set to that value
   * @param {boolean} [options.children=false] - if set to true, all the children will have their destroy
   *  method called as well. 'options' will be passed on to those calls.
   * @param {boolean} [options.texture=false] - Only used for children with textures e.g. Sprites. If options.children
   * is set to true it should destroy the texture of the child sprite
   * @param {boolean} [options.textureSource=false] - Only used for children with textures e.g. Sprites.
   * If options.children is set to true it should destroy the texture source of the child sprite
   * @param {boolean} [options.context=false] - Only used for children with graphicsContexts e.g. Graphics.
   * If options.children is set to true it should destroy the context of the child graphics
   */ destroy(options = false) {
        if (this.destroyed) return;
        this.destroyed = true;
        const oldChildren = this.removeChildren(0, this.children.length);
        this.removeFromParent();
        this.parent = null;
        this._maskEffect = null;
        this._filterEffect = null;
        this.effects = null;
        this._position = null;
        this._scale = null;
        this._pivot = null;
        this._skew = null;
        this.emit("destroyed", this);
        this.removeAllListeners();
        const destroyChildren = typeof options === "boolean" ? options : options?.children;
        if (destroyChildren) for(let i = 0; i < oldChildren.length; ++i)oldChildren[i].destroy(options);
        this.renderGroup?.destroy();
        this.renderGroup = null;
    }
}
$8a2b4ed6f59ce4dc$export$42a852a2b6b56249.mixin((0, $236jP.childrenHelperMixin));
$8a2b4ed6f59ce4dc$export$42a852a2b6b56249.mixin((0, $g5iYs.toLocalGlobalMixin));
$8a2b4ed6f59ce4dc$export$42a852a2b6b56249.mixin((0, $ggvKl.onRenderMixin));
$8a2b4ed6f59ce4dc$export$42a852a2b6b56249.mixin((0, $kEqoj.measureMixin));
$8a2b4ed6f59ce4dc$export$42a852a2b6b56249.mixin((0, $apXS2.effectsMixin));
$8a2b4ed6f59ce4dc$export$42a852a2b6b56249.mixin((0, $kkVML.findMixin));
$8a2b4ed6f59ce4dc$export$42a852a2b6b56249.mixin((0, $82jXu.sortMixin));
$8a2b4ed6f59ce4dc$export$42a852a2b6b56249.mixin((0, $j1i7q.cullingMixin));

});
parcelRegister("a2eTA", function(module, exports) {

$parcel$export(module.exports, "Color", () => $f6a94f8017837c10$export$892596cec99bc70e);

var $erZA3 = parcelRequire("erZA3");

var $lCM3s = parcelRequire("lCM3s");
"use strict";
(0, $erZA3.extend)([
    (0, $lCM3s.default)
]);
const $f6a94f8017837c10$var$_Color = class _Color {
    /**
   * @param {ColorSource} value - Optional value to use, if not provided, white is used.
   */ constructor(value = 16777215){
        this._value = null;
        this._components = new Float32Array(4);
        this._components.fill(1);
        this._int = 16777215;
        this.value = value;
    }
    /** Get red component (0 - 1) */ get red() {
        return this._components[0];
    }
    /** Get green component (0 - 1) */ get green() {
        return this._components[1];
    }
    /** Get blue component (0 - 1) */ get blue() {
        return this._components[2];
    }
    /** Get alpha component (0 - 1) */ get alpha() {
        return this._components[3];
    }
    /**
   * Set the value, suitable for chaining
   * @param value
   * @see Color.value
   */ setValue(value) {
        this.value = value;
        return this;
    }
    /**
   * The current color source.
   *
   * When setting:
   * - Setting to an instance of `Color` will copy its color source and components.
   * - Otherwise, `Color` will try to normalize the color source and set the components.
   *   If the color source is invalid, an `Error` will be thrown and the `Color` will left unchanged.
   *
   * Note: The `null` in the setter's parameter type is added to match the TypeScript rule: return type of getter
   * must be assignable to its setter's parameter type. Setting `value` to `null` will throw an `Error`.
   *
   * When getting:
   * - A return value of `null` means the previous value was overridden (e.g., {@link Color.multiply multiply},
   *   {@link Color.premultiply premultiply} or {@link Color.round round}).
   * - Otherwise, the color source used when setting is returned.
   */ set value(value) {
        if (value instanceof _Color) {
            this._value = this._cloneSource(value._value);
            this._int = value._int;
            this._components.set(value._components);
        } else if (value === null) throw new Error("Cannot set Color#value to null");
        else if (this._value === null || !this._isSourceEqual(this._value, value)) {
            this._value = this._cloneSource(value);
            this._normalize(this._value);
        }
    }
    get value() {
        return this._value;
    }
    /**
   * Copy a color source internally.
   * @param value - Color source
   */ _cloneSource(value) {
        if (typeof value === "string" || typeof value === "number" || value instanceof Number || value === null) return value;
        else if (Array.isArray(value) || ArrayBuffer.isView(value)) return value.slice(0);
        else if (typeof value === "object" && value !== null) return {
            ...value
        };
        return value;
    }
    /**
   * Equality check for color sources.
   * @param value1 - First color source
   * @param value2 - Second color source
   * @returns `true` if the color sources are equal, `false` otherwise.
   */ _isSourceEqual(value1, value2) {
        const type1 = typeof value1;
        const type2 = typeof value2;
        if (type1 !== type2) return false;
        else if (type1 === "number" || type1 === "string" || value1 instanceof Number) return value1 === value2;
        else if (Array.isArray(value1) && Array.isArray(value2) || ArrayBuffer.isView(value1) && ArrayBuffer.isView(value2)) {
            if (value1.length !== value2.length) return false;
            return value1.every((v, i)=>v === value2[i]);
        } else if (value1 !== null && value2 !== null) {
            const keys1 = Object.keys(value1);
            const keys2 = Object.keys(value2);
            if (keys1.length !== keys2.length) return false;
            return keys1.every((key)=>value1[key] === value2[key]);
        }
        return value1 === value2;
    }
    /**
   * Convert to a RGBA color object.
   * @example
   * import { Color } from 'pixi.js';
   * new Color('white').toRgb(); // returns { r: 1, g: 1, b: 1, a: 1 }
   */ toRgba() {
        const [r, g, b, a] = this._components;
        return {
            r: r,
            g: g,
            b: b,
            a: a
        };
    }
    /**
   * Convert to a RGB color object.
   * @example
   * import { Color } from 'pixi.js';
   * new Color('white').toRgb(); // returns { r: 1, g: 1, b: 1 }
   */ toRgb() {
        const [r, g, b] = this._components;
        return {
            r: r,
            g: g,
            b: b
        };
    }
    /** Convert to a CSS-style rgba string: `rgba(255,255,255,1.0)`. */ toRgbaString() {
        const [r, g, b] = this.toUint8RgbArray();
        return `rgba(${r},${g},${b},${this.alpha})`;
    }
    toUint8RgbArray(out) {
        const [r, g, b] = this._components;
        if (!this._arrayRgb) this._arrayRgb = [];
        out = out || this._arrayRgb;
        out[0] = Math.round(r * 255);
        out[1] = Math.round(g * 255);
        out[2] = Math.round(b * 255);
        return out;
    }
    toArray(out) {
        if (!this._arrayRgba) this._arrayRgba = [];
        out = out || this._arrayRgba;
        const [r, g, b, a] = this._components;
        out[0] = r;
        out[1] = g;
        out[2] = b;
        out[3] = a;
        return out;
    }
    toRgbArray(out) {
        if (!this._arrayRgb) this._arrayRgb = [];
        out = out || this._arrayRgb;
        const [r, g, b] = this._components;
        out[0] = r;
        out[1] = g;
        out[2] = b;
        return out;
    }
    /**
   * Convert to a hexadecimal number.
   * @example
   * import { Color } from 'pixi.js';
   * new Color('white').toNumber(); // returns 16777215
   */ toNumber() {
        return this._int;
    }
    /**
   * Convert to a BGR number
   * @example
   * import { Color } from 'pixi.js';
   * new Color(0xffcc99).toBgrNumber(); // returns 0x99ccff
   */ toBgrNumber() {
        const [r, g, b] = this.toUint8RgbArray();
        return (b << 16) + (g << 8) + r;
    }
    /**
   * Convert to a hexadecimal number in little endian format (e.g., BBGGRR).
   * @example
   * import { Color } from 'pixi.js';
   * new Color(0xffcc99).toLittleEndianNumber(); // returns 0x99ccff
   * @returns {number} - The color as a number in little endian format.
   */ toLittleEndianNumber() {
        const value = this._int;
        return (value >> 16) + (value & 65280) + ((value & 255) << 16);
    }
    /**
   * Multiply with another color. This action is destructive, and will
   * override the previous `value` property to be `null`.
   * @param {ColorSource} value - The color to multiply by.
   */ multiply(value) {
        const [r, g, b, a] = _Color._temp.setValue(value)._components;
        this._components[0] *= r;
        this._components[1] *= g;
        this._components[2] *= b;
        this._components[3] *= a;
        this._refreshInt();
        this._value = null;
        return this;
    }
    /**
   * Converts color to a premultiplied alpha format. This action is destructive, and will
   * override the previous `value` property to be `null`.
   * @param alpha - The alpha to multiply by.
   * @param {boolean} [applyToRGB=true] - Whether to premultiply RGB channels.
   * @returns {Color} - Itself.
   */ premultiply(alpha, applyToRGB = true) {
        if (applyToRGB) {
            this._components[0] *= alpha;
            this._components[1] *= alpha;
            this._components[2] *= alpha;
        }
        this._components[3] = alpha;
        this._refreshInt();
        this._value = null;
        return this;
    }
    /**
   * Premultiplies alpha with current color.
   * @param {number} alpha - The alpha to multiply by.
   * @param {boolean} [applyToRGB=true] - Whether to premultiply RGB channels.
   * @returns {number} tint multiplied by alpha
   */ toPremultiplied(alpha, applyToRGB = true) {
        if (alpha === 1) return -16777216 + this._int;
        if (alpha === 0) return applyToRGB ? 0 : this._int;
        let r = this._int >> 16 & 255;
        let g = this._int >> 8 & 255;
        let b = this._int & 255;
        if (applyToRGB) {
            r = r * alpha + 0.5 | 0;
            g = g * alpha + 0.5 | 0;
            b = b * alpha + 0.5 | 0;
        }
        return (alpha * 255 << 24) + (r << 16) + (g << 8) + b;
    }
    /**
   * Convert to a hexadecimal string.
   * @example
   * import { Color } from 'pixi.js';
   * new Color('white').toHex(); // returns "#ffffff"
   */ toHex() {
        const hexString = this._int.toString(16);
        return `#${"000000".substring(0, 6 - hexString.length) + hexString}`;
    }
    /**
   * Convert to a hexadecimal string with alpha.
   * @example
   * import { Color } from 'pixi.js';
   * new Color('white').toHexa(); // returns "#ffffffff"
   */ toHexa() {
        const alphaValue = Math.round(this._components[3] * 255);
        const alphaString = alphaValue.toString(16);
        return this.toHex() + "00".substring(0, 2 - alphaString.length) + alphaString;
    }
    /**
   * Set alpha, suitable for chaining.
   * @param alpha
   */ setAlpha(alpha) {
        this._components[3] = this._clamp(alpha);
        return this;
    }
    /**
   * Normalize the input value into rgba
   * @param value - Input value
   */ _normalize(value) {
        let r;
        let g;
        let b;
        let a;
        if ((typeof value === "number" || value instanceof Number) && value >= 0 && value <= 16777215) {
            const int = value;
            r = (int >> 16 & 255) / 255;
            g = (int >> 8 & 255) / 255;
            b = (int & 255) / 255;
            a = 1;
        } else if ((Array.isArray(value) || value instanceof Float32Array) && value.length >= 3 && value.length <= 4) {
            value = this._clamp(value);
            [r, g, b, a = 1] = value;
        } else if ((value instanceof Uint8Array || value instanceof Uint8ClampedArray) && value.length >= 3 && value.length <= 4) {
            value = this._clamp(value, 0, 255);
            [r, g, b, a = 255] = value;
            r /= 255;
            g /= 255;
            b /= 255;
            a /= 255;
        } else if (typeof value === "string" || typeof value === "object") {
            if (typeof value === "string") {
                const match = _Color.HEX_PATTERN.exec(value);
                if (match) value = `#${match[2]}`;
            }
            const color = (0, $erZA3.colord)(value);
            if (color.isValid()) {
                ({ r: r, g: g, b: b, a: a } = color.rgba);
                r /= 255;
                g /= 255;
                b /= 255;
            }
        }
        if (r !== void 0) {
            this._components[0] = r;
            this._components[1] = g;
            this._components[2] = b;
            this._components[3] = a;
            this._refreshInt();
        } else throw new Error(`Unable to convert color ${value}`);
    }
    /** Refresh the internal color rgb number */ _refreshInt() {
        this._clamp(this._components);
        const [r, g, b] = this._components;
        this._int = (r * 255 << 16) + (g * 255 << 8) + (b * 255 | 0);
    }
    /**
   * Clamps values to a range. Will override original values
   * @param value - Value(s) to clamp
   * @param min - Minimum value
   * @param max - Maximum value
   */ _clamp(value, min = 0, max = 1) {
        if (typeof value === "number") return Math.min(Math.max(value, min), max);
        value.forEach((v, i)=>{
            value[i] = Math.min(Math.max(v, min), max);
        });
        return value;
    }
    /**
   * Check if the value is a color-like object
   * @param value - Value to check
   * @returns True if the value is a color-like object
   * @static
   * @example
   * import { Color } from 'pixi.js';
   * Color.isColorLike('white'); // returns true
   * Color.isColorLike(0xffffff); // returns true
   * Color.isColorLike([1, 1, 1]); // returns true
   */ static isColorLike(value) {
        return typeof value === "number" || typeof value === "string" || value instanceof Number || value instanceof _Color || Array.isArray(value) || value instanceof Uint8Array || value instanceof Uint8ClampedArray || value instanceof Float32Array || value.r !== void 0 && value.g !== void 0 && value.b !== void 0 || value.r !== void 0 && value.g !== void 0 && value.b !== void 0 && value.a !== void 0 || value.h !== void 0 && value.s !== void 0 && value.l !== void 0 || value.h !== void 0 && value.s !== void 0 && value.l !== void 0 && value.a !== void 0 || value.h !== void 0 && value.s !== void 0 && value.v !== void 0 || value.h !== void 0 && value.s !== void 0 && value.v !== void 0 && value.a !== void 0;
    }
};
/**
 * Default Color object for static uses
 * @example
 * import { Color } from 'pixi.js';
 * Color.shared.setValue(0xffffff).toHex(); // '#ffffff'
 */ $f6a94f8017837c10$var$_Color.shared = new $f6a94f8017837c10$var$_Color();
/**
 * Temporary Color object for static uses internally.
 * As to not conflict with Color.shared.
 * @ignore
 */ $f6a94f8017837c10$var$_Color._temp = new $f6a94f8017837c10$var$_Color();
/** Pattern for hex strings */ // eslint-disable-next-line @typescript-eslint/naming-convention
$f6a94f8017837c10$var$_Color.HEX_PATTERN = /^(#|0x)?(([a-f0-9]{3}){1,2}([a-f0-9]{2})?)$/i;
let $f6a94f8017837c10$export$892596cec99bc70e = $f6a94f8017837c10$var$_Color;

});
parcelRegister("erZA3", function(module, exports) {

$parcel$export(module.exports, "colord", () => $482ad42e73ee00b6$export$c8efe09109f9cb9e);
$parcel$export(module.exports, "extend", () => $482ad42e73ee00b6$export$8b58be045bf06082);
var $482ad42e73ee00b6$var$r = {
    grad: .9,
    turn: 360,
    rad: 360 / (2 * Math.PI)
}, $482ad42e73ee00b6$var$t = function(r) {
    return "string" == typeof r ? r.length > 0 : "number" == typeof r;
}, $482ad42e73ee00b6$var$n = function(r, t, n) {
    return void 0 === t && (t = 0), void 0 === n && (n = Math.pow(10, t)), Math.round(n * r) / n + 0;
}, $482ad42e73ee00b6$var$e = function(r, t, n) {
    return void 0 === t && (t = 0), void 0 === n && (n = 1), r > n ? n : r > t ? r : t;
}, $482ad42e73ee00b6$var$u = function(r) {
    return (r = isFinite(r) ? r % 360 : 0) > 0 ? r : r + 360;
}, $482ad42e73ee00b6$var$a = function(r) {
    return {
        r: $482ad42e73ee00b6$var$e(r.r, 0, 255),
        g: $482ad42e73ee00b6$var$e(r.g, 0, 255),
        b: $482ad42e73ee00b6$var$e(r.b, 0, 255),
        a: $482ad42e73ee00b6$var$e(r.a)
    };
}, $482ad42e73ee00b6$var$o = function(r) {
    return {
        r: $482ad42e73ee00b6$var$n(r.r),
        g: $482ad42e73ee00b6$var$n(r.g),
        b: $482ad42e73ee00b6$var$n(r.b),
        a: $482ad42e73ee00b6$var$n(r.a, 3)
    };
}, $482ad42e73ee00b6$var$i = /^#([0-9a-f]{3,8})$/i, $482ad42e73ee00b6$var$s = function(r) {
    var t = r.toString(16);
    return t.length < 2 ? "0" + t : t;
}, $482ad42e73ee00b6$var$h = function(r) {
    var t = r.r, n = r.g, e = r.b, u = r.a, a = Math.max(t, n, e), o = a - Math.min(t, n, e), i = o ? a === t ? (n - e) / o : a === n ? 2 + (e - t) / o : 4 + (t - n) / o : 0;
    return {
        h: 60 * (i < 0 ? i + 6 : i),
        s: a ? o / a * 100 : 0,
        v: a / 255 * 100,
        a: u
    };
}, $482ad42e73ee00b6$var$b = function(r) {
    var t = r.h, n = r.s, e = r.v, u = r.a;
    t = t / 360 * 6, n /= 100, e /= 100;
    var a = Math.floor(t), o = e * (1 - n), i = e * (1 - (t - a) * n), s = e * (1 - (1 - t + a) * n), h = a % 6;
    return {
        r: 255 * [
            e,
            i,
            o,
            o,
            s,
            e
        ][h],
        g: 255 * [
            s,
            e,
            e,
            i,
            o,
            o
        ][h],
        b: 255 * [
            o,
            o,
            s,
            e,
            e,
            i
        ][h],
        a: u
    };
}, $482ad42e73ee00b6$var$g = function(r) {
    return {
        h: $482ad42e73ee00b6$var$u(r.h),
        s: $482ad42e73ee00b6$var$e(r.s, 0, 100),
        l: $482ad42e73ee00b6$var$e(r.l, 0, 100),
        a: $482ad42e73ee00b6$var$e(r.a)
    };
}, $482ad42e73ee00b6$var$d = function(r) {
    return {
        h: $482ad42e73ee00b6$var$n(r.h),
        s: $482ad42e73ee00b6$var$n(r.s),
        l: $482ad42e73ee00b6$var$n(r.l),
        a: $482ad42e73ee00b6$var$n(r.a, 3)
    };
}, $482ad42e73ee00b6$var$f = function(r) {
    var t, n, e;
    return $482ad42e73ee00b6$var$b((n = (t = r).s, {
        h: t.h,
        s: (n *= ((e = t.l) < 50 ? e : 100 - e) / 100) > 0 ? 2 * n / (e + n) * 100 : 0,
        v: e + n,
        a: t.a
    }));
}, $482ad42e73ee00b6$var$c = function(r) {
    var t, n, e, u;
    return {
        h: (t = $482ad42e73ee00b6$var$h(r)).h,
        s: (u = (200 - (n = t.s)) * (e = t.v) / 100) > 0 && u < 200 ? n * e / 100 / (u <= 100 ? u : 200 - u) * 100 : 0,
        l: u / 2,
        a: t.a
    };
}, $482ad42e73ee00b6$var$l = /^hsla?\(\s*([+-]?\d*\.?\d+)(deg|rad|grad|turn)?\s*,\s*([+-]?\d*\.?\d+)%\s*,\s*([+-]?\d*\.?\d+)%\s*(?:,\s*([+-]?\d*\.?\d+)(%)?\s*)?\)$/i, $482ad42e73ee00b6$var$p = /^hsla?\(\s*([+-]?\d*\.?\d+)(deg|rad|grad|turn)?\s+([+-]?\d*\.?\d+)%\s+([+-]?\d*\.?\d+)%\s*(?:\/\s*([+-]?\d*\.?\d+)(%)?\s*)?\)$/i, $482ad42e73ee00b6$var$v = /^rgba?\(\s*([+-]?\d*\.?\d+)(%)?\s*,\s*([+-]?\d*\.?\d+)(%)?\s*,\s*([+-]?\d*\.?\d+)(%)?\s*(?:,\s*([+-]?\d*\.?\d+)(%)?\s*)?\)$/i, $482ad42e73ee00b6$var$m = /^rgba?\(\s*([+-]?\d*\.?\d+)(%)?\s+([+-]?\d*\.?\d+)(%)?\s+([+-]?\d*\.?\d+)(%)?\s*(?:\/\s*([+-]?\d*\.?\d+)(%)?\s*)?\)$/i, $482ad42e73ee00b6$var$y = {
    string: [
        [
            function(r) {
                var t = $482ad42e73ee00b6$var$i.exec(r);
                return t ? (r = t[1]).length <= 4 ? {
                    r: parseInt(r[0] + r[0], 16),
                    g: parseInt(r[1] + r[1], 16),
                    b: parseInt(r[2] + r[2], 16),
                    a: 4 === r.length ? $482ad42e73ee00b6$var$n(parseInt(r[3] + r[3], 16) / 255, 2) : 1
                } : 6 === r.length || 8 === r.length ? {
                    r: parseInt(r.substr(0, 2), 16),
                    g: parseInt(r.substr(2, 2), 16),
                    b: parseInt(r.substr(4, 2), 16),
                    a: 8 === r.length ? $482ad42e73ee00b6$var$n(parseInt(r.substr(6, 2), 16) / 255, 2) : 1
                } : null : null;
            },
            "hex"
        ],
        [
            function(r) {
                var t = $482ad42e73ee00b6$var$v.exec(r) || $482ad42e73ee00b6$var$m.exec(r);
                return t ? t[2] !== t[4] || t[4] !== t[6] ? null : $482ad42e73ee00b6$var$a({
                    r: Number(t[1]) / (t[2] ? 100 / 255 : 1),
                    g: Number(t[3]) / (t[4] ? 100 / 255 : 1),
                    b: Number(t[5]) / (t[6] ? 100 / 255 : 1),
                    a: void 0 === t[7] ? 1 : Number(t[7]) / (t[8] ? 100 : 1)
                }) : null;
            },
            "rgb"
        ],
        [
            function(t) {
                var n = $482ad42e73ee00b6$var$l.exec(t) || $482ad42e73ee00b6$var$p.exec(t);
                if (!n) return null;
                var e, u, a = $482ad42e73ee00b6$var$g({
                    h: (e = n[1], u = n[2], void 0 === u && (u = "deg"), Number(e) * ($482ad42e73ee00b6$var$r[u] || 1)),
                    s: Number(n[3]),
                    l: Number(n[4]),
                    a: void 0 === n[5] ? 1 : Number(n[5]) / (n[6] ? 100 : 1)
                });
                return $482ad42e73ee00b6$var$f(a);
            },
            "hsl"
        ]
    ],
    object: [
        [
            function(r) {
                var n = r.r, e = r.g, u = r.b, o = r.a, i = void 0 === o ? 1 : o;
                return $482ad42e73ee00b6$var$t(n) && $482ad42e73ee00b6$var$t(e) && $482ad42e73ee00b6$var$t(u) ? $482ad42e73ee00b6$var$a({
                    r: Number(n),
                    g: Number(e),
                    b: Number(u),
                    a: Number(i)
                }) : null;
            },
            "rgb"
        ],
        [
            function(r) {
                var n = r.h, e = r.s, u = r.l, a = r.a, o = void 0 === a ? 1 : a;
                if (!$482ad42e73ee00b6$var$t(n) || !$482ad42e73ee00b6$var$t(e) || !$482ad42e73ee00b6$var$t(u)) return null;
                var i = $482ad42e73ee00b6$var$g({
                    h: Number(n),
                    s: Number(e),
                    l: Number(u),
                    a: Number(o)
                });
                return $482ad42e73ee00b6$var$f(i);
            },
            "hsl"
        ],
        [
            function(r) {
                var n = r.h, a = r.s, o = r.v, i = r.a, s = void 0 === i ? 1 : i;
                if (!$482ad42e73ee00b6$var$t(n) || !$482ad42e73ee00b6$var$t(a) || !$482ad42e73ee00b6$var$t(o)) return null;
                var h = function(r) {
                    return {
                        h: $482ad42e73ee00b6$var$u(r.h),
                        s: $482ad42e73ee00b6$var$e(r.s, 0, 100),
                        v: $482ad42e73ee00b6$var$e(r.v, 0, 100),
                        a: $482ad42e73ee00b6$var$e(r.a)
                    };
                }({
                    h: Number(n),
                    s: Number(a),
                    v: Number(o),
                    a: Number(s)
                });
                return $482ad42e73ee00b6$var$b(h);
            },
            "hsv"
        ]
    ]
}, $482ad42e73ee00b6$var$N = function(r, t) {
    for(var n = 0; n < t.length; n++){
        var e = t[n][0](r);
        if (e) return [
            e,
            t[n][1]
        ];
    }
    return [
        null,
        void 0
    ];
}, $482ad42e73ee00b6$var$x = function(r) {
    return "string" == typeof r ? $482ad42e73ee00b6$var$N(r.trim(), $482ad42e73ee00b6$var$y.string) : "object" == typeof r && null !== r ? $482ad42e73ee00b6$var$N(r, $482ad42e73ee00b6$var$y.object) : [
        null,
        void 0
    ];
}, $482ad42e73ee00b6$export$f61ac8b6f1f46202 = function(r) {
    return $482ad42e73ee00b6$var$x(r)[1];
}, $482ad42e73ee00b6$var$M = function(r, t) {
    var n = $482ad42e73ee00b6$var$c(r);
    return {
        h: n.h,
        s: $482ad42e73ee00b6$var$e(n.s + 100 * t, 0, 100),
        l: n.l,
        a: n.a
    };
}, $482ad42e73ee00b6$var$H = function(r) {
    return (299 * r.r + 587 * r.g + 114 * r.b) / 1e3 / 255;
}, $482ad42e73ee00b6$var$$ = function(r, t) {
    var n = $482ad42e73ee00b6$var$c(r);
    return {
        h: n.h,
        s: n.s,
        l: $482ad42e73ee00b6$var$e(n.l + 100 * t, 0, 100),
        a: n.a
    };
}, $482ad42e73ee00b6$export$4d30ed660ff08d0 = function() {
    function r(r) {
        this.parsed = $482ad42e73ee00b6$var$x(r)[0], this.rgba = this.parsed || {
            r: 0,
            g: 0,
            b: 0,
            a: 1
        };
    }
    return r.prototype.isValid = function() {
        return null !== this.parsed;
    }, r.prototype.brightness = function() {
        return $482ad42e73ee00b6$var$n($482ad42e73ee00b6$var$H(this.rgba), 2);
    }, r.prototype.isDark = function() {
        return $482ad42e73ee00b6$var$H(this.rgba) < .5;
    }, r.prototype.isLight = function() {
        return $482ad42e73ee00b6$var$H(this.rgba) >= .5;
    }, r.prototype.toHex = function() {
        var r, t, e, u, a, i;
        return r = $482ad42e73ee00b6$var$o(this.rgba), t = r.r, e = r.g, u = r.b, i = (a = r.a) < 1 ? $482ad42e73ee00b6$var$s($482ad42e73ee00b6$var$n(255 * a)) : "", "#" + $482ad42e73ee00b6$var$s(t) + $482ad42e73ee00b6$var$s(e) + $482ad42e73ee00b6$var$s(u) + i;
    }, r.prototype.toRgb = function() {
        return $482ad42e73ee00b6$var$o(this.rgba);
    }, r.prototype.toRgbString = function() {
        var r, t, n, e, u;
        return r = $482ad42e73ee00b6$var$o(this.rgba), t = r.r, n = r.g, e = r.b, (u = r.a) < 1 ? "rgba(" + t + ", " + n + ", " + e + ", " + u + ")" : "rgb(" + t + ", " + n + ", " + e + ")";
    }, r.prototype.toHsl = function() {
        return $482ad42e73ee00b6$var$d($482ad42e73ee00b6$var$c(this.rgba));
    }, r.prototype.toHslString = function() {
        var r, t, n, e, u;
        return r = $482ad42e73ee00b6$var$d($482ad42e73ee00b6$var$c(this.rgba)), t = r.h, n = r.s, e = r.l, (u = r.a) < 1 ? "hsla(" + t + ", " + n + "%, " + e + "%, " + u + ")" : "hsl(" + t + ", " + n + "%, " + e + "%)";
    }, r.prototype.toHsv = function() {
        var r;
        return r = $482ad42e73ee00b6$var$h(this.rgba), {
            h: $482ad42e73ee00b6$var$n(r.h),
            s: $482ad42e73ee00b6$var$n(r.s),
            v: $482ad42e73ee00b6$var$n(r.v),
            a: $482ad42e73ee00b6$var$n(r.a, 3)
        };
    }, r.prototype.invert = function() {
        var r;
        return $482ad42e73ee00b6$export$c8efe09109f9cb9e({
            r: 255 - (r = this.rgba).r,
            g: 255 - r.g,
            b: 255 - r.b,
            a: r.a
        });
    }, r.prototype.saturate = function(r) {
        return void 0 === r && (r = .1), $482ad42e73ee00b6$export$c8efe09109f9cb9e($482ad42e73ee00b6$var$M(this.rgba, r));
    }, r.prototype.desaturate = function(r) {
        return void 0 === r && (r = .1), $482ad42e73ee00b6$export$c8efe09109f9cb9e($482ad42e73ee00b6$var$M(this.rgba, -r));
    }, r.prototype.grayscale = function() {
        return $482ad42e73ee00b6$export$c8efe09109f9cb9e($482ad42e73ee00b6$var$M(this.rgba, -1));
    }, r.prototype.lighten = function(r) {
        return void 0 === r && (r = .1), $482ad42e73ee00b6$export$c8efe09109f9cb9e($482ad42e73ee00b6$var$$(this.rgba, r));
    }, r.prototype.darken = function(r) {
        return void 0 === r && (r = .1), $482ad42e73ee00b6$export$c8efe09109f9cb9e($482ad42e73ee00b6$var$$(this.rgba, -r));
    }, r.prototype.rotate = function(r) {
        return void 0 === r && (r = 15), this.hue(this.hue() + r);
    }, r.prototype.alpha = function(r) {
        var t;
        return "number" == typeof r ? $482ad42e73ee00b6$export$c8efe09109f9cb9e({
            r: (t = this.rgba).r,
            g: t.g,
            b: t.b,
            a: r
        }) : $482ad42e73ee00b6$var$n(this.rgba.a, 3);
    }, r.prototype.hue = function(r) {
        var t = $482ad42e73ee00b6$var$c(this.rgba);
        return "number" == typeof r ? $482ad42e73ee00b6$export$c8efe09109f9cb9e({
            h: r,
            s: t.s,
            l: t.l,
            a: t.a
        }) : $482ad42e73ee00b6$var$n(t.h);
    }, r.prototype.isEqual = function(r) {
        return this.toHex() === $482ad42e73ee00b6$export$c8efe09109f9cb9e(r).toHex();
    }, r;
}(), $482ad42e73ee00b6$export$c8efe09109f9cb9e = function(r) {
    return r instanceof $482ad42e73ee00b6$export$4d30ed660ff08d0 ? r : new $482ad42e73ee00b6$export$4d30ed660ff08d0(r);
}, $482ad42e73ee00b6$var$S = [], $482ad42e73ee00b6$export$8b58be045bf06082 = function(r) {
    r.forEach(function(r) {
        $482ad42e73ee00b6$var$S.indexOf(r) < 0 && (r($482ad42e73ee00b6$export$4d30ed660ff08d0, $482ad42e73ee00b6$var$y), $482ad42e73ee00b6$var$S.push(r));
    });
}, $482ad42e73ee00b6$export$4385e60b38654f68 = function() {
    return new $482ad42e73ee00b6$export$4d30ed660ff08d0({
        r: 255 * Math.random(),
        g: 255 * Math.random(),
        b: 255 * Math.random()
    });
};

});

parcelRegister("lCM3s", function(module, exports) {

$parcel$export(module.exports, "default", () => $4bf1f6e6e10c0717$export$2e2bcd8739ae039);
function $4bf1f6e6e10c0717$export$2e2bcd8739ae039(e, f) {
    var a = {
        white: "#ffffff",
        bisque: "#ffe4c4",
        blue: "#0000ff",
        cadetblue: "#5f9ea0",
        chartreuse: "#7fff00",
        chocolate: "#d2691e",
        coral: "#ff7f50",
        antiquewhite: "#faebd7",
        aqua: "#00ffff",
        azure: "#f0ffff",
        whitesmoke: "#f5f5f5",
        papayawhip: "#ffefd5",
        plum: "#dda0dd",
        blanchedalmond: "#ffebcd",
        black: "#000000",
        gold: "#ffd700",
        goldenrod: "#daa520",
        gainsboro: "#dcdcdc",
        cornsilk: "#fff8dc",
        cornflowerblue: "#6495ed",
        burlywood: "#deb887",
        aquamarine: "#7fffd4",
        beige: "#f5f5dc",
        crimson: "#dc143c",
        cyan: "#00ffff",
        darkblue: "#00008b",
        darkcyan: "#008b8b",
        darkgoldenrod: "#b8860b",
        darkkhaki: "#bdb76b",
        darkgray: "#a9a9a9",
        darkgreen: "#006400",
        darkgrey: "#a9a9a9",
        peachpuff: "#ffdab9",
        darkmagenta: "#8b008b",
        darkred: "#8b0000",
        darkorchid: "#9932cc",
        darkorange: "#ff8c00",
        darkslateblue: "#483d8b",
        gray: "#808080",
        darkslategray: "#2f4f4f",
        darkslategrey: "#2f4f4f",
        deeppink: "#ff1493",
        deepskyblue: "#00bfff",
        wheat: "#f5deb3",
        firebrick: "#b22222",
        floralwhite: "#fffaf0",
        ghostwhite: "#f8f8ff",
        darkviolet: "#9400d3",
        magenta: "#ff00ff",
        green: "#008000",
        dodgerblue: "#1e90ff",
        grey: "#808080",
        honeydew: "#f0fff0",
        hotpink: "#ff69b4",
        blueviolet: "#8a2be2",
        forestgreen: "#228b22",
        lawngreen: "#7cfc00",
        indianred: "#cd5c5c",
        indigo: "#4b0082",
        fuchsia: "#ff00ff",
        brown: "#a52a2a",
        maroon: "#800000",
        mediumblue: "#0000cd",
        lightcoral: "#f08080",
        darkturquoise: "#00ced1",
        lightcyan: "#e0ffff",
        ivory: "#fffff0",
        lightyellow: "#ffffe0",
        lightsalmon: "#ffa07a",
        lightseagreen: "#20b2aa",
        linen: "#faf0e6",
        mediumaquamarine: "#66cdaa",
        lemonchiffon: "#fffacd",
        lime: "#00ff00",
        khaki: "#f0e68c",
        mediumseagreen: "#3cb371",
        limegreen: "#32cd32",
        mediumspringgreen: "#00fa9a",
        lightskyblue: "#87cefa",
        lightblue: "#add8e6",
        midnightblue: "#191970",
        lightpink: "#ffb6c1",
        mistyrose: "#ffe4e1",
        moccasin: "#ffe4b5",
        mintcream: "#f5fffa",
        lightslategray: "#778899",
        lightslategrey: "#778899",
        navajowhite: "#ffdead",
        navy: "#000080",
        mediumvioletred: "#c71585",
        powderblue: "#b0e0e6",
        palegoldenrod: "#eee8aa",
        oldlace: "#fdf5e6",
        paleturquoise: "#afeeee",
        mediumturquoise: "#48d1cc",
        mediumorchid: "#ba55d3",
        rebeccapurple: "#663399",
        lightsteelblue: "#b0c4de",
        mediumslateblue: "#7b68ee",
        thistle: "#d8bfd8",
        tan: "#d2b48c",
        orchid: "#da70d6",
        mediumpurple: "#9370db",
        purple: "#800080",
        pink: "#ffc0cb",
        skyblue: "#87ceeb",
        springgreen: "#00ff7f",
        palegreen: "#98fb98",
        red: "#ff0000",
        yellow: "#ffff00",
        slateblue: "#6a5acd",
        lavenderblush: "#fff0f5",
        peru: "#cd853f",
        palevioletred: "#db7093",
        violet: "#ee82ee",
        teal: "#008080",
        slategray: "#708090",
        slategrey: "#708090",
        aliceblue: "#f0f8ff",
        darkseagreen: "#8fbc8f",
        darkolivegreen: "#556b2f",
        greenyellow: "#adff2f",
        seagreen: "#2e8b57",
        seashell: "#fff5ee",
        tomato: "#ff6347",
        silver: "#c0c0c0",
        sienna: "#a0522d",
        lavender: "#e6e6fa",
        lightgreen: "#90ee90",
        orange: "#ffa500",
        orangered: "#ff4500",
        steelblue: "#4682b4",
        royalblue: "#4169e1",
        turquoise: "#40e0d0",
        yellowgreen: "#9acd32",
        salmon: "#fa8072",
        saddlebrown: "#8b4513",
        sandybrown: "#f4a460",
        rosybrown: "#bc8f8f",
        darksalmon: "#e9967a",
        lightgoldenrodyellow: "#fafad2",
        snow: "#fffafa",
        lightgrey: "#d3d3d3",
        lightgray: "#d3d3d3",
        dimgray: "#696969",
        dimgrey: "#696969",
        olivedrab: "#6b8e23",
        olive: "#808000"
    }, r = {};
    for(var d in a)r[a[d]] = d;
    var l = {};
    e.prototype.toName = function(f) {
        if (!(this.rgba.a || this.rgba.r || this.rgba.g || this.rgba.b)) return "transparent";
        var d, i, n = r[this.toHex()];
        if (n) return n;
        if (null == f ? void 0 : f.closest) {
            var o = this.toRgb(), t = 1 / 0, b = "black";
            if (!l.length) for(var c in a)l[c] = new e(a[c]).toRgb();
            for(var g in a){
                var u = (d = o, i = l[g], Math.pow(d.r - i.r, 2) + Math.pow(d.g - i.g, 2) + Math.pow(d.b - i.b, 2));
                u < t && (t = u, b = g);
            }
            return b;
        }
    };
    f.string.push([
        function(f) {
            var r = f.toLowerCase(), d = "transparent" === r ? "#0000" : a[r];
            return d ? new e(d).toRgb() : null;
        },
        "name"
    ]);
}

});


parcelRegister("j1i7q", function(module, exports) {

$parcel$export(module.exports, "cullingMixin", () => $b5b40e006e048a91$export$dce76d4f0fd249ed);
"use strict";
const $b5b40e006e048a91$export$dce76d4f0fd249ed = {
    cullArea: null,
    cullable: false,
    cullableChildren: true
};

});

parcelRegister("61KiY", function(module, exports) {

$parcel$export(module.exports, "BigPool", () => $9483424e2013bba4$export$8249372279066210);

var $5Xsoh = parcelRequire("5Xsoh");
"use strict";
class $9483424e2013bba4$export$866836a21808b71c {
    constructor(){
        /**
     * A map to store the pools by their class type.
     * @private
     */ this._poolsByClass = /* @__PURE__ */ new Map();
    }
    /**
   * Prepopulates a specific pool with a given number of items.
   * @template T The type of items in the pool. Must extend PoolItem.
   * @param {PoolItemConstructor<T>} Class - The constructor of the items in the pool.
   * @param {number} total - The number of items to add to the pool.
   */ prepopulate(Class, total) {
        const classPool = this.getPool(Class);
        classPool.prepopulate(total);
    }
    /**
   * Gets an item from a specific pool.
   * @template T The type of items in the pool. Must extend PoolItem.
   * @param {PoolItemConstructor<T>} Class - The constructor of the items in the pool.
   * @param {unknown} [data] - Optional data to pass to the item's constructor.
   * @returns {T} The item from the pool.
   */ get(Class, data) {
        const pool = this.getPool(Class);
        return pool.get(data);
    }
    /**
   * Returns an item to its respective pool.
   * @param {PoolItem} item - The item to return to the pool.
   */ return(item) {
        const pool = this.getPool(item.constructor);
        pool.return(item);
    }
    /**
   * Gets a specific pool based on the class type.
   * @template T The type of items in the pool. Must extend PoolItem.
   * @param {PoolItemConstructor<T>} ClassType - The constructor of the items in the pool.
   * @returns {Pool<T>} The pool of the given class type.
   */ getPool(ClassType) {
        if (!this._poolsByClass.has(ClassType)) this._poolsByClass.set(ClassType, new (0, $5Xsoh.Pool)(ClassType));
        return this._poolsByClass.get(ClassType);
    }
    /** gets the usage stats of each pool in the system */ stats() {
        const stats = {};
        this._poolsByClass.forEach((pool)=>{
            const name = stats[pool._classType.name] ? pool._classType.name + pool._classType.ID : pool._classType.name;
            stats[name] = {
                free: pool.totalFree,
                used: pool.totalUsed,
                size: pool.totalSize
            };
        });
        return stats;
    }
}
const $9483424e2013bba4$export$8249372279066210 = new $9483424e2013bba4$export$866836a21808b71c();

});
parcelRegister("5Xsoh", function(module, exports) {

$parcel$export(module.exports, "Pool", () => $ce33839780b5f2f3$export$14963ee5c8637e11);
"use strict";
class $ce33839780b5f2f3$export$14963ee5c8637e11 {
    /**
   * Constructs a new Pool.
   * @param ClassType - The constructor of the items in the pool.
   * @param {number} [initialSize] - The initial size of the pool.
   */ constructor(ClassType, initialSize){
        this._pool = [];
        this._count = 0;
        this._index = 0;
        this._classType = ClassType;
        if (initialSize) this.prepopulate(initialSize);
    }
    /**
   * Prepopulates the pool with a given number of items.
   * @param total - The number of items to add to the pool.
   */ prepopulate(total) {
        for(let i = 0; i < total; i++)this._pool[this._index++] = new this._classType();
        this._count += total;
    }
    /**
   * Gets an item from the pool. Calls the item's `init` method if it exists.
   * If there are no items left in the pool, a new one will be created.
   * @param {unknown} [data] - Optional data to pass to the item's constructor.
   * @returns {T} The item from the pool.
   */ get(data) {
        let item;
        if (this._index > 0) item = this._pool[--this._index];
        else item = new this._classType();
        item.init?.(data);
        return item;
    }
    /**
   * Returns an item to the pool. Calls the item's `reset` method if it exists.
   * @param {T} item - The item to return to the pool.
   */ return(item) {
        item.reset?.();
        this._pool[this._index++] = item;
    }
    /**
   * Gets the number of items in the pool.
   * @readonly
   * @member {number}
   */ get totalSize() {
        return this._count;
    }
    /**
   * Gets the number of items in the pool that are free to use without needing to create more.
   * @readonly
   * @member {number}
   */ get totalFree() {
        return this._index;
    }
    /**
   * Gets the number of items in the pool that are currently in use.
   * @readonly
   * @member {number}
   */ get totalUsed() {
        return this._count - this._index;
    }
    /** clears the pool - mainly used for debugging! */ clear() {
        this._pool.length = 0;
        this._index = 0;
    }
}

});


parcelRegister("236jP", function(module, exports) {

$parcel$export(module.exports, "childrenHelperMixin", () => $0d8e0eeab3189cd3$export$64cca9f0c2df174a);

var $33PVi = parcelRequire("33PVi");

var $kXq8E = parcelRequire("kXq8E");
"use strict";
const $0d8e0eeab3189cd3$export$64cca9f0c2df174a = {
    allowChildren: true,
    /**
   * Removes all children from this container that are within the begin and end indexes.
   * @param beginIndex - The beginning position.
   * @param endIndex - The ending position. Default value is size of the container.
   * @returns - List of removed children
   * @memberof scene.Container#
   */ removeChildren (beginIndex = 0, endIndex) {
        const end = endIndex ?? this.children.length;
        const range = end - beginIndex;
        const removed = [];
        if (range > 0 && range <= end) {
            for(let i = end - 1; i >= beginIndex; i--){
                const child = this.children[i];
                if (!child) continue;
                removed.push(child);
                child.parent = null;
            }
            (0, $33PVi.removeItems)(this.children, beginIndex, end);
            const renderGroup = this.renderGroup || this.parentRenderGroup;
            if (renderGroup) renderGroup.removeChildren(removed);
            for(let i = 0; i < removed.length; ++i){
                this.emit("childRemoved", removed[i], this, i);
                removed[i].emit("removed", this);
            }
            return removed;
        } else if (range === 0 && this.children.length === 0) return removed;
        throw new RangeError("removeChildren: numeric values are outside the acceptable range.");
    },
    /**
   * Removes a child from the specified index position.
   * @param index - The index to get the child from
   * @returns The child that was removed.
   * @memberof scene.Container#
   */ removeChildAt (index) {
        const child = this.getChildAt(index);
        return this.removeChild(child);
    },
    /**
   * Returns the child at the specified index
   * @param index - The index to get the child at
   * @returns - The child at the given index, if any.
   * @memberof scene.Container#
   */ getChildAt (index) {
        if (index < 0 || index >= this.children.length) throw new Error(`getChildAt: Index (${index}) does not exist.`);
        return this.children[index];
    },
    /**
   * Changes the position of an existing child in the container container
   * @param child - The child Container instance for which you want to change the index number
   * @param index - The resulting index number for the child container
   * @memberof scene.Container#
   */ setChildIndex (child, index) {
        if (index < 0 || index >= this.children.length) throw new Error(`The index ${index} supplied is out of bounds ${this.children.length}`);
        this.getChildIndex(child);
        this.addChildAt(child, index);
    },
    /**
   * Returns the index position of a child Container instance
   * @param child - The Container instance to identify
   * @returns - The index position of the child container to identify
   * @memberof scene.Container#
   */ getChildIndex (child) {
        const index = this.children.indexOf(child);
        if (index === -1) throw new Error("The supplied Container must be a child of the caller");
        return index;
    },
    /**
   * Adds a child to the container at a specified index. If the index is out of bounds an error will be thrown.
   * If the child is already in this container, it will be moved to the specified index.
   * @param {Container} child - The child to add.
   * @param {number} index - The absolute index where the child will be positioned at the end of the operation.
   * @returns {Container} The child that was added.
   * @memberof scene.Container#
   */ addChildAt (child, index) {
        if (!this.allowChildren) (0, $kXq8E.deprecation)((0, $kXq8E.v8_0_0), "addChildAt: Only Containers will be allowed to add children in v8.0.0");
        const { children: children } = this;
        if (index < 0 || index > children.length) throw new Error(`${child}addChildAt: The index ${index} supplied is out of bounds ${children.length}`);
        if (child.parent) {
            const currentIndex = child.parent.children.indexOf(child);
            if (child.parent === this && currentIndex === index) return child;
            if (currentIndex !== -1) child.parent.children.splice(currentIndex, 1);
        }
        if (index === children.length) children.push(child);
        else children.splice(index, 0, child);
        child.parent = this;
        child.didChange = true;
        child.didViewUpdate = false;
        child._updateFlags = 15;
        const renderGroup = this.renderGroup || this.parentRenderGroup;
        if (renderGroup) renderGroup.addChild(child);
        if (this.sortableChildren) this.sortDirty = true;
        this.emit("childAdded", child, this, index);
        child.emit("added", this);
        return child;
    },
    /**
   * Swaps the position of 2 Containers within this container.
   * @param child - First container to swap
   * @param child2 - Second container to swap
   */ swapChildren (child, child2) {
        if (child === child2) return;
        const index1 = this.getChildIndex(child);
        const index2 = this.getChildIndex(child2);
        this.children[index1] = child2;
        this.children[index2] = child;
        const renderGroup = this.renderGroup || this.parentRenderGroup;
        if (renderGroup) renderGroup.structureDidChange = true;
        this._didContainerChangeTick++;
    },
    /**
   * Remove the Container from its parent Container. If the Container has no parent, do nothing.
   * @memberof scene.Container#
   */ removeFromParent () {
        this.parent?.removeChild(this);
    },
    /**
   * Reparent the child to this container, keeping the same worldTransform.
   * @param child - The child to reparent
   * @returns The first child that was reparented.
   * @memberof scene.Container#
   */ reparentChild (...child) {
        if (child.length === 1) return this.reparentChildAt(child[0], this.children.length);
        child.forEach((c)=>this.reparentChildAt(c, this.children.length));
        return child[0];
    },
    /**
   * Reparent the child to this container at the specified index, keeping the same worldTransform.
   * @param child - The child to reparent
   * @param index - The index to reparent the child to
   * @memberof scene.Container#
   */ reparentChildAt (child, index) {
        if (child.parent === this) {
            this.setChildIndex(child, index);
            return child;
        }
        const childMat = child.worldTransform.clone();
        child.removeFromParent();
        this.addChildAt(child, index);
        const newMatrix = this.worldTransform.clone();
        newMatrix.invert();
        childMat.prepend(newMatrix);
        child.setFromMatrix(childMat);
        return child;
    }
};

});
parcelRegister("33PVi", function(module, exports) {

$parcel$export(module.exports, "removeItems", () => $cefc366e7023560b$export$8d47c0e1ce445404);
"use strict";
function $cefc366e7023560b$export$8d47c0e1ce445404(arr, startIdx, removeCount) {
    const length = arr.length;
    let i;
    if (startIdx >= length || removeCount === 0) return;
    removeCount = startIdx + removeCount > length ? length - startIdx : removeCount;
    const len = length - removeCount;
    for(i = startIdx; i < len; ++i)arr[i] = arr[i + removeCount];
    arr.length = len;
}

});


parcelRegister("apXS2", function(module, exports) {

$parcel$export(module.exports, "effectsMixin", () => $1d59e812d2000ae8$export$eec5e288a9d02a7c);

var $aWIPo = parcelRequire("aWIPo");

var $dZmDL = parcelRequire("dZmDL");
"use strict";
const $1d59e812d2000ae8$export$eec5e288a9d02a7c = {
    _maskEffect: null,
    _filterEffect: null,
    /**
   * @todo Needs docs.
   * @memberof scene.Container#
   * @type {Array<Effect>}
   */ effects: [],
    /**
   * @todo Needs docs.
   * @param effect - The effect to add.
   * @memberof scene.Container#
   * @ignore
   */ addEffect (effect) {
        const index = this.effects.indexOf(effect);
        if (index !== -1) return;
        this.effects.push(effect);
        this.effects.sort((a, b)=>a.priority - b.priority);
        const renderGroup = this.renderGroup || this.parentRenderGroup;
        if (renderGroup) renderGroup.structureDidChange = true;
        this._updateIsSimple();
    },
    /**
   * @todo Needs docs.
   * @param effect - The effect to remove.
   * @memberof scene.Container#
   * @ignore
   */ removeEffect (effect) {
        const index = this.effects.indexOf(effect);
        if (index === -1) return;
        this.effects.splice(index, 1);
        if (this.parentRenderGroup) this.parentRenderGroup.structureDidChange = true;
        this._updateIsSimple();
    },
    set mask (value){
        const effect = this._maskEffect;
        if (effect?.mask === value) return;
        if (effect) {
            this.removeEffect(effect);
            (0, $dZmDL.MaskEffectManager).returnMaskEffect(effect);
            this._maskEffect = null;
        }
        if (value === null || value === void 0) return;
        this._maskEffect = (0, $dZmDL.MaskEffectManager).getMaskEffect(value);
        this.addEffect(this._maskEffect);
    },
    /**
   * Sets a mask for the displayObject. A mask is an object that limits the visibility of an
   * object to the shape of the mask applied to it. In PixiJS a regular mask must be a
   * {@link Graphics} or a {@link Sprite} object. This allows for much faster masking in canvas as it
   * utilities shape clipping. Furthermore, a mask of an object must be in the subtree of its parent.
   * Otherwise, `getLocalBounds` may calculate incorrect bounds, which makes the container's width and height wrong.
   * To remove a mask, set this property to `null`.
   *
   * For sprite mask both alpha and red channel are used. Black mask is the same as transparent mask.
   * @example
   * import { Graphics, Sprite } from 'pixi.js';
   *
   * const graphics = new Graphics();
   * graphics.beginFill(0xFF3300);
   * graphics.drawRect(50, 250, 100, 100);
   * graphics.endFill();
   *
   * const sprite = new Sprite(texture);
   * sprite.mask = graphics;
   * @memberof scene.Container#
   */ get mask () {
        return this._maskEffect?.mask;
    },
    set filters (value){
        if (!Array.isArray(value) && value) value = [
            value
        ];
        const effect = this._filterEffect || (this._filterEffect = new (0, $aWIPo.FilterEffect)());
        value;
        const hasFilters = value?.length > 0;
        const hadFilters = effect.filters?.length > 0;
        const didChange = hasFilters !== hadFilters;
        value = Array.isArray(value) ? value.slice(0) : value;
        effect.filters = Object.freeze(value);
        if (didChange) {
            if (hasFilters) this.addEffect(effect);
            else {
                this.removeEffect(effect);
                effect.filters = value ?? null;
            }
        }
    },
    /**
   * Sets the filters for the displayObject.
   * IMPORTANT: This is a WebGL only feature and will be ignored by the canvas renderer.
   * To remove filters simply set this property to `'null'`.
   * @memberof scene.Container#
   */ get filters () {
        return this._filterEffect?.filters;
    },
    set filterArea (value){
        this._filterEffect || (this._filterEffect = new (0, $aWIPo.FilterEffect)());
        this._filterEffect.filterArea = value;
    },
    /**
   * The area the filter is applied to. This is used as more of an optimization
   * rather than figuring out the dimensions of the displayObject each frame you can set this rectangle.
   *
   * Also works as an interaction mask.
   * @memberof scene.Container#
   */ get filterArea () {
        return this._filterEffect?.filterArea;
    }
};

});
parcelRegister("aWIPo", function(module, exports) {

$parcel$export(module.exports, "FilterEffect", () => $573d66e12a5f4185$export$d66c06ffe23037ab);
"use strict";
class $573d66e12a5f4185$export$d66c06ffe23037ab {
    constructor(){
        /** the pipe that knows how to handle this effect */ this.pipe = "filter";
        /** the priority of this effect */ this.priority = 1;
    }
    destroy() {
        for(let i = 0; i < this.filters.length; i++)this.filters[i].destroy();
        this.filters = null;
        this.filterArea = null;
    }
}

});

parcelRegister("dZmDL", function(module, exports) {

$parcel$export(module.exports, "MaskEffectManager", () => $f40a37c299623cb8$export$1eb319167fe02d04);

var $i9BKe = parcelRequire("i9BKe");

var $61KiY = parcelRequire("61KiY");
"use strict";
class $f40a37c299623cb8$export$3b0749bf144d4b29 {
    constructor(){
        /**
     * @private
     */ this._effectClasses = [];
        this._tests = [];
        this._initialized = false;
    }
    init() {
        if (this._initialized) return;
        this._initialized = true;
        this._effectClasses.forEach((test)=>{
            this.add({
                test: test.test,
                maskClass: test
            });
        });
    }
    add(test) {
        this._tests.push(test);
    }
    getMaskEffect(item) {
        if (!this._initialized) this.init();
        for(let i = 0; i < this._tests.length; i++){
            const test = this._tests[i];
            if (test.test(item)) return (0, $61KiY.BigPool).get(test.maskClass, item);
        }
        return item;
    }
    returnMaskEffect(effect) {
        (0, $61KiY.BigPool).return(effect);
    }
}
const $f40a37c299623cb8$export$1eb319167fe02d04 = new $f40a37c299623cb8$export$3b0749bf144d4b29();
(0, $i9BKe.extensions).handleByList((0, $i9BKe.ExtensionType).MaskEffect, $f40a37c299623cb8$export$1eb319167fe02d04._effectClasses);

});


parcelRegister("kkVML", function(module, exports) {

$parcel$export(module.exports, "findMixin", () => $1ce16328dd0c7b09$export$468b0762e1bfbd64);

var $kXq8E = parcelRequire("kXq8E");
"use strict";
const $1ce16328dd0c7b09$export$468b0762e1bfbd64 = {
    /**
   * The instance label of the object.
   * @memberof scene.Container#
   * @member {string} label
   */ label: null,
    /**
   * The instance name of the object.
   * @deprecated since 8.0.0
   * @see scene.Container#label
   * @member {string} name
   * @memberof scene.Container#
   */ get name () {
        (0, $kXq8E.deprecation)((0, $kXq8E.v8_0_0), "Container.name property has been removed, use Container.label instead");
        return this.label;
    },
    set name (value){
        (0, $kXq8E.deprecation)((0, $kXq8E.v8_0_0), "Container.name property has been removed, use Container.label instead");
        this.label = value;
    },
    /**
   * @method getChildByName
   * @deprecated since 8.0.0
   * @param {string} name - Instance name.
   * @param {boolean}[deep=false] - Whether to search recursively
   * @returns {Container} The child with the specified name.
   * @see scene.Container#getChildByLabel
   * @memberof scene.Container#
   */ getChildByName (name, deep = false) {
        return this.getChildByLabel(name, deep);
    },
    /**
   * Returns the first child in the container with the specified label.
   *
   * Recursive searches are done in a pre-order traversal.
   * @memberof scene.Container#
   * @param {string|RegExp} label - Instance label.
   * @param {boolean}[deep=false] - Whether to search recursively
   * @returns {Container} The child with the specified label.
   */ getChildByLabel (label, deep = false) {
        const children = this.children;
        for(let i = 0; i < children.length; i++){
            const child = children[i];
            if (child.label === label || label instanceof RegExp && label.test(child.label)) return child;
        }
        if (deep) for(let i = 0; i < children.length; i++){
            const child = children[i];
            const found = child.getChildByLabel(label, true);
            if (found) return found;
        }
        return null;
    },
    /**
   * Returns all children in the container with the specified label.
   * @memberof scene.Container#
   * @param {string|RegExp} label - Instance label.
   * @param {boolean}[deep=false] - Whether to search recursively
   * @param {Container[]} [out=[]] - The array to store matching children in.
   * @returns {Container[]} An array of children with the specified label.
   */ getChildrenByLabel (label, deep = false, out = []) {
        const children = this.children;
        for(let i = 0; i < children.length; i++){
            const child = children[i];
            if (child.label === label || label instanceof RegExp && label.test(child.label)) out.push(child);
        }
        if (deep) for(let i = 0; i < children.length; i++)children[i].getChildrenByLabel(label, true, out);
        return out;
    }
};

});

parcelRegister("kEqoj", function(module, exports) {

$parcel$export(module.exports, "measureMixin", () => $4a6a8e8422db6a2e$export$285e6e72e8e62f0);

var $eY4rt = parcelRequire("eY4rt");

var $7wtv9 = parcelRequire("7wtv9");

var $iskjc = parcelRequire("iskjc");

var $j68wk = parcelRequire("j68wk");

var $lK289 = parcelRequire("lK289");
"use strict";
const $4a6a8e8422db6a2e$var$tempMatrix = new (0, $eY4rt.Matrix)();
const $4a6a8e8422db6a2e$export$285e6e72e8e62f0 = {
    _localBoundsCacheId: -1,
    _localBoundsCacheData: null,
    _setWidth (value, localWidth) {
        const sign = Math.sign(this.scale.x) || 1;
        if (localWidth !== 0) this.scale.x = value / localWidth * sign;
        else this.scale.x = sign;
    },
    _setHeight (value, localHeight) {
        const sign = Math.sign(this.scale.y) || 1;
        if (localHeight !== 0) this.scale.y = value / localHeight * sign;
        else this.scale.y = sign;
    },
    /**
   * Retrieves the local bounds of the container as a Bounds object.
   * @returns - The bounding area.
   * @memberof scene.Container#
   */ getLocalBounds () {
        if (!this._localBoundsCacheData) this._localBoundsCacheData = {
            data: [],
            index: 1,
            didChange: false,
            localBounds: new (0, $7wtv9.Bounds)()
        };
        const localBoundsCacheData = this._localBoundsCacheData;
        localBoundsCacheData.index = 1;
        localBoundsCacheData.didChange = false;
        if (localBoundsCacheData.data[0] !== this._didViewChangeTick) {
            localBoundsCacheData.didChange = true;
            localBoundsCacheData.data[0] = this._didViewChangeTick;
        }
        (0, $lK289.checkChildrenDidChange)(this, localBoundsCacheData);
        if (localBoundsCacheData.didChange) (0, $j68wk.getLocalBounds)(this, localBoundsCacheData.localBounds, $4a6a8e8422db6a2e$var$tempMatrix);
        return localBoundsCacheData.localBounds;
    },
    /**
   * Calculates and returns the (world) bounds of the display object as a [Rectangle]{@link Rectangle}.
   * @param skipUpdate - Setting to `true` will stop the transforms of the scene graph from
   *  being updated. This means the calculation returned MAY be out of date BUT will give you a
   *  nice performance boost.
   * @param bounds - Optional bounds to store the result of the bounds calculation.
   * @returns - The minimum axis-aligned rectangle in world space that fits around this object.
   * @memberof scene.Container#
   */ getBounds (skipUpdate, bounds) {
        return (0, $iskjc.getGlobalBounds)(this, skipUpdate, bounds || new (0, $7wtv9.Bounds)());
    }
};

});
parcelRegister("iskjc", function(module, exports) {

$parcel$export(module.exports, "getGlobalBounds", () => $b2563854990e287d$export$f4412a6981d97baa);
$parcel$export(module.exports, "updateTransformBackwards", () => $b2563854990e287d$export$2022bc48a49dd6d2);

var $eY4rt = parcelRequire("eY4rt");

var $5tmC8 = parcelRequire("5tmC8");
"use strict";
function $b2563854990e287d$export$f4412a6981d97baa(target, skipUpdateTransform, bounds) {
    bounds.clear();
    let parentTransform;
    let pooledMatrix;
    if (target.parent) {
        if (!skipUpdateTransform) {
            pooledMatrix = (0, $5tmC8.matrixPool).get().identity();
            parentTransform = $b2563854990e287d$export$2022bc48a49dd6d2(target, pooledMatrix);
        } else parentTransform = target.parent.worldTransform;
    } else parentTransform = (0, $eY4rt.Matrix).IDENTITY;
    $b2563854990e287d$export$ca70956e64971628(target, bounds, parentTransform, skipUpdateTransform);
    if (pooledMatrix) (0, $5tmC8.matrixPool).return(pooledMatrix);
    if (!bounds.isValid) bounds.set(0, 0, 0, 0);
    return bounds;
}
function $b2563854990e287d$export$ca70956e64971628(target, bounds, parentTransform, skipUpdateTransform) {
    if (!target.visible || !target.measurable) return;
    let worldTransform;
    if (!skipUpdateTransform) {
        target.updateLocalTransform();
        worldTransform = (0, $5tmC8.matrixPool).get();
        worldTransform.appendFrom(target.localTransform, parentTransform);
    } else worldTransform = target.worldTransform;
    const parentBounds = bounds;
    const preserveBounds = !!target.effects.length;
    if (preserveBounds) bounds = (0, $5tmC8.boundsPool).get().clear();
    if (target.boundsArea) bounds.addRect(target.boundsArea, worldTransform);
    else {
        if (target.addBounds) {
            bounds.matrix = worldTransform;
            target.addBounds(bounds);
        }
        for(let i = 0; i < target.children.length; i++)$b2563854990e287d$export$ca70956e64971628(target.children[i], bounds, worldTransform, skipUpdateTransform);
    }
    if (preserveBounds) {
        for(let i = 0; i < target.effects.length; i++)target.effects[i].addBounds?.(bounds);
        parentBounds.addBounds(bounds, (0, $eY4rt.Matrix).IDENTITY);
        (0, $5tmC8.boundsPool).return(bounds);
    }
    if (!skipUpdateTransform) (0, $5tmC8.matrixPool).return(worldTransform);
}
function $b2563854990e287d$export$2022bc48a49dd6d2(target, parentTransform) {
    const parent = target.parent;
    if (parent) {
        $b2563854990e287d$export$2022bc48a49dd6d2(parent, parentTransform);
        parent.updateLocalTransform();
        parentTransform.append(parent.localTransform);
    }
    return parentTransform;
}

});
parcelRegister("5tmC8", function(module, exports) {

$parcel$export(module.exports, "matrixPool", () => $aaa7ee585a7b6ebc$export$3849005ba4dacf72);
$parcel$export(module.exports, "boundsPool", () => $aaa7ee585a7b6ebc$export$9194656040c1dc42);

var $eY4rt = parcelRequire("eY4rt");

var $5Xsoh = parcelRequire("5Xsoh");

var $7wtv9 = parcelRequire("7wtv9");
"use strict";
const $aaa7ee585a7b6ebc$export$3849005ba4dacf72 = new (0, $5Xsoh.Pool)((0, $eY4rt.Matrix));
const $aaa7ee585a7b6ebc$export$9194656040c1dc42 = new (0, $5Xsoh.Pool)((0, $7wtv9.Bounds));

});


parcelRegister("j68wk", function(module, exports) {

$parcel$export(module.exports, "getLocalBounds", () => $653ce529dcaa332d$export$ffaf4f504c4c5c9c);

var $eY4rt = parcelRequire("eY4rt");

var $hUCK4 = parcelRequire("hUCK4");

var $5tmC8 = parcelRequire("5tmC8");
"use strict";
function $653ce529dcaa332d$export$ffaf4f504c4c5c9c(target, bounds, relativeMatrix) {
    bounds.clear();
    relativeMatrix || (relativeMatrix = (0, $eY4rt.Matrix).IDENTITY);
    $653ce529dcaa332d$var$_getLocalBounds(target, bounds, relativeMatrix, target, true);
    if (!bounds.isValid) bounds.set(0, 0, 0, 0);
    return bounds;
}
function $653ce529dcaa332d$var$_getLocalBounds(target, bounds, parentTransform, rootContainer, isRoot) {
    let relativeTransform;
    if (!isRoot) {
        if (!target.visible || !target.measurable) return;
        target.updateLocalTransform();
        const localTransform = target.localTransform;
        relativeTransform = (0, $5tmC8.matrixPool).get();
        relativeTransform.appendFrom(localTransform, parentTransform);
    } else {
        relativeTransform = (0, $5tmC8.matrixPool).get();
        relativeTransform = parentTransform.copyTo(relativeTransform);
    }
    const parentBounds = bounds;
    const preserveBounds = !!target.effects.length;
    if (preserveBounds) bounds = (0, $5tmC8.boundsPool).get().clear();
    if (target.boundsArea) bounds.addRect(target.boundsArea, relativeTransform);
    else {
        if (target.renderPipeId) {
            bounds.matrix = relativeTransform;
            target.addBounds(bounds);
        }
        const children = target.children;
        for(let i = 0; i < children.length; i++)$653ce529dcaa332d$var$_getLocalBounds(children[i], bounds, relativeTransform, rootContainer, false);
    }
    if (preserveBounds) {
        for(let i = 0; i < target.effects.length; i++)target.effects[i].addLocalBounds?.(bounds, rootContainer);
        parentBounds.addBounds(bounds, (0, $eY4rt.Matrix).IDENTITY);
        (0, $5tmC8.boundsPool).return(bounds);
    }
    (0, $5tmC8.matrixPool).return(relativeTransform);
}
function $653ce529dcaa332d$export$58081aedf094d85b(target, root, matrix) {
    const parent = target.parent;
    if (!parent) {
        (0, $hUCK4.warn)("Item is not inside the root container");
        return;
    }
    if (parent !== root) {
        $653ce529dcaa332d$export$58081aedf094d85b(parent, root, matrix);
        parent.updateLocalTransform();
        matrix.append(parent.localTransform);
    }
}

});
parcelRegister("hUCK4", function(module, exports) {

$parcel$export(module.exports, "warn", () => $ffdcd240d931c2ea$export$c106dd0671a0fc2d);
"use strict";
let $ffdcd240d931c2ea$var$warnCount = 0;
const $ffdcd240d931c2ea$var$maxWarnings = 500;
function $ffdcd240d931c2ea$export$c106dd0671a0fc2d(...args) {
    if ($ffdcd240d931c2ea$var$warnCount === $ffdcd240d931c2ea$var$maxWarnings) return;
    $ffdcd240d931c2ea$var$warnCount++;
    if ($ffdcd240d931c2ea$var$warnCount === $ffdcd240d931c2ea$var$maxWarnings) console.warn("PixiJS Warning: too many warnings, no more warnings will be reported to the console by PixiJS.");
    else console.warn("PixiJS Warning: ", ...args);
}

});


parcelRegister("lK289", function(module, exports) {

$parcel$export(module.exports, "checkChildrenDidChange", () => $6ac8d139665df8ac$export$fd5aadbd3827bcf1);
"use strict";
function $6ac8d139665df8ac$export$fd5aadbd3827bcf1(container, previousData) {
    const children = container.children;
    for(let i = 0; i < children.length; i++){
        const child = children[i];
        const uid = child.uid;
        const didChange = (child._didViewChangeTick & 65535) << 16 | child._didContainerChangeTick & 65535;
        const index = previousData.index;
        if (previousData.data[index] !== uid || previousData.data[index + 1] !== didChange) {
            previousData.data[previousData.index] = uid;
            previousData.data[previousData.index + 1] = didChange;
            previousData.didChange = true;
        }
        previousData.index = index + 2;
        if (child.children.length) $6ac8d139665df8ac$export$fd5aadbd3827bcf1(child, previousData);
    }
    return previousData.didChange;
}

});


parcelRegister("ggvKl", function(module, exports) {

$parcel$export(module.exports, "onRenderMixin", () => $63981d12ee78567e$export$2a5246d1114cb81d);
"use strict";
const $63981d12ee78567e$export$2a5246d1114cb81d = {
    _onRender: null,
    set onRender (func){
        const renderGroup = this.renderGroup || this.parentRenderGroup;
        if (!func) {
            if (this._onRender) renderGroup?.removeOnRender(this);
            this._onRender = null;
            return;
        }
        if (!this._onRender) renderGroup?.addOnRender(this);
        this._onRender = func;
    },
    /**
   * This callback is used when the container is rendered. This is where you should add your custom
   * logic that is needed to be run every frame.
   *
   * In v7 many users used `updateTransform` for this, however the way v8 renders objects is different
   * and "updateTransform" is no longer called every frame
   * @example
   * const container = new Container();
   * container.onRender = () => {
   *    container.rotation += 0.01;
   * };
   * @memberof scene.Container#
   */ get onRender () {
        return this._onRender;
    }
};

});

parcelRegister("82jXu", function(module, exports) {

$parcel$export(module.exports, "sortMixin", () => $8864252dd84a6b69$export$eb4acdd9f4781aed);
"use strict";
const $8864252dd84a6b69$export$eb4acdd9f4781aed = {
    _zIndex: 0,
    /**
   * Should children be sorted by zIndex at the next render call.
   *
   * Will get automatically set to true if a new child is added, or if a child's zIndex changes.
   * @type {boolean}
   * @memberof scene.Container#
   */ sortDirty: false,
    /**
   * If set to true, the container will sort its children by `zIndex` value
   * when the next render is called, or manually if `sortChildren()` is called.
   *
   * This actually changes the order of elements in the array, so should be treated
   * as a basic solution that is not performant compared to other solutions,
   * such as {@link https://github.com/pixijs/layers PixiJS Layers}
   *
   * Also be aware of that this may not work nicely with the `addChildAt()` function,
   * as the `zIndex` sorting may cause the child to automatically sorted to another position.
   * @type {boolean}
   * @memberof scene.Container#
   */ sortableChildren: false,
    /**
   * The zIndex of the container.
   *
   * Setting this value, will automatically set the parent to be sortable. Children will be automatically
   * sorted by zIndex value; a higher value will mean it will be moved towards the end of the array,
   * and thus rendered on top of other display objects within the same container.
   * @see scene.Container#sortableChildren
   * @memberof scene.Container#
   */ get zIndex () {
        return this._zIndex;
    },
    set zIndex (value){
        if (this._zIndex === value) return;
        this._zIndex = value;
        this.depthOfChildModified();
    },
    depthOfChildModified () {
        if (this.parent) {
            this.parent.sortableChildren = true;
            this.parent.sortDirty = true;
        }
        if (this.parentRenderGroup) this.parentRenderGroup.structureDidChange = true;
    },
    /**
   * Sorts children by zIndex.
   * @memberof scene.Container#
   */ sortChildren () {
        if (!this.sortDirty) return;
        this.sortDirty = false;
        this.children.sort($8864252dd84a6b69$var$sortChildren);
    }
};
function $8864252dd84a6b69$var$sortChildren(a, b) {
    return a._zIndex - b._zIndex;
}

});

parcelRegister("g5iYs", function(module, exports) {

$parcel$export(module.exports, "toLocalGlobalMixin", () => $6a95391942e887de$export$38fa7a987602e8dd);

var $eY4rt = parcelRequire("eY4rt");

var $1HooC = parcelRequire("1HooC");

var $iskjc = parcelRequire("iskjc");
"use strict";
const $6a95391942e887de$export$38fa7a987602e8dd = {
    /**
   * Returns the global position of the container.
   * @param point - The optional point to write the global value to.
   * @param skipUpdate - Should we skip the update transform.
   * @returns - The updated point.
   * @memberof scene.Container#
   */ getGlobalPosition (point = new (0, $1HooC.Point)(), skipUpdate = false) {
        if (this.parent) this.parent.toGlobal(this._position, point, skipUpdate);
        else {
            point.x = this._position.x;
            point.y = this._position.y;
        }
        return point;
    },
    /**
   * Calculates the global position of the container.
   * @param position - The world origin to calculate from.
   * @param point - A Point object in which to store the value, optional
   *  (otherwise will create a new Point).
   * @param skipUpdate - Should we skip the update transform.
   * @returns - A point object representing the position of this object.
   * @memberof scene.Container#
   */ toGlobal (position, point, skipUpdate = false) {
        if (!skipUpdate) {
            this.updateLocalTransform();
            const globalMatrix = (0, $iskjc.updateTransformBackwards)(this, new (0, $eY4rt.Matrix)());
            globalMatrix.append(this.localTransform);
            return globalMatrix.apply(position, point);
        }
        return this.worldTransform.apply(position, point);
    },
    /**
   * Calculates the local position of the container relative to another point.
   * @param position - The world origin to calculate from.
   * @param from - The Container to calculate the global position from.
   * @param point - A Point object in which to store the value, optional
   *  (otherwise will create a new Point).
   * @param skipUpdate - Should we skip the update transform
   * @returns - A point object representing the position of this object
   * @memberof scene.Container#
   */ toLocal (position, from, point, skipUpdate) {
        if (from) position = from.toGlobal(position, point, skipUpdate);
        if (!skipUpdate) {
            this.updateLocalTransform();
            const globalMatrix = (0, $iskjc.updateTransformBackwards)(this, new (0, $eY4rt.Matrix)());
            globalMatrix.append(this.localTransform);
            return globalMatrix.applyInverse(position, point);
        }
        return this.worldTransform.applyInverse(position, point);
    }
};

});

parcelRegister("1pFbO", function(module, exports) {

$parcel$export(module.exports, "RenderGroup", () => $5a621eb8e375b2c4$export$94d273f8d74f2a5);

var $eY4rt = parcelRequire("eY4rt");

var $dK5Jn = parcelRequire("dK5Jn");
"use strict";
class $5a621eb8e375b2c4$export$94d273f8d74f2a5 {
    constructor(){
        this.renderPipeId = "renderGroup";
        this.root = null;
        this.canBundle = false;
        this.renderGroupParent = null;
        this.renderGroupChildren = [];
        this.worldTransform = new (0, $eY4rt.Matrix)();
        this.worldColorAlpha = 4294967295;
        this.worldColor = 16777215;
        this.worldAlpha = 1;
        // these updates are transform changes..
        this.childrenToUpdate = /* @__PURE__ */ Object.create(null);
        this.updateTick = 0;
        // these update are renderable changes..
        this.childrenRenderablesToUpdate = {
            list: [],
            index: 0
        };
        // other
        this.structureDidChange = true;
        this.instructionSet = new (0, $dK5Jn.InstructionSet)();
        this._onRenderContainers = [];
    }
    init(root) {
        this.root = root;
        if (root._onRender) this.addOnRender(root);
        root.didChange = true;
        const children = root.children;
        for(let i = 0; i < children.length; i++)this.addChild(children[i]);
    }
    reset() {
        this.renderGroupChildren.length = 0;
        for(const i in this.childrenToUpdate){
            const childrenAtDepth = this.childrenToUpdate[i];
            childrenAtDepth.list.fill(null);
            childrenAtDepth.index = 0;
        }
        this.childrenRenderablesToUpdate.index = 0;
        this.childrenRenderablesToUpdate.list.fill(null);
        this.root = null;
        this.updateTick = 0;
        this.structureDidChange = true;
        this._onRenderContainers.length = 0;
        this.renderGroupParent = null;
    }
    get localTransform() {
        return this.root.localTransform;
    }
    addRenderGroupChild(renderGroupChild) {
        if (renderGroupChild.renderGroupParent) renderGroupChild.renderGroupParent._removeRenderGroupChild(renderGroupChild);
        renderGroupChild.renderGroupParent = this;
        this.renderGroupChildren.push(renderGroupChild);
    }
    _removeRenderGroupChild(renderGroupChild) {
        const index = this.renderGroupChildren.indexOf(renderGroupChild);
        if (index > -1) this.renderGroupChildren.splice(index, 1);
        renderGroupChild.renderGroupParent = null;
    }
    addChild(child) {
        this.structureDidChange = true;
        child.parentRenderGroup = this;
        child.updateTick = -1;
        if (child.parent === this.root) child.relativeRenderGroupDepth = 1;
        else child.relativeRenderGroupDepth = child.parent.relativeRenderGroupDepth + 1;
        child.didChange = true;
        this.onChildUpdate(child);
        if (child.renderGroup) {
            this.addRenderGroupChild(child.renderGroup);
            return;
        }
        if (child._onRender) this.addOnRender(child);
        const children = child.children;
        for(let i = 0; i < children.length; i++)this.addChild(children[i]);
    }
    removeChild(child) {
        this.structureDidChange = true;
        if (child._onRender) {
            if (!child.renderGroup) this.removeOnRender(child);
        }
        child.parentRenderGroup = null;
        if (child.renderGroup) {
            this._removeRenderGroupChild(child.renderGroup);
            return;
        }
        const children = child.children;
        for(let i = 0; i < children.length; i++)this.removeChild(children[i]);
    }
    removeChildren(children) {
        for(let i = 0; i < children.length; i++)this.removeChild(children[i]);
    }
    onChildUpdate(child) {
        let childrenToUpdate = this.childrenToUpdate[child.relativeRenderGroupDepth];
        if (!childrenToUpdate) childrenToUpdate = this.childrenToUpdate[child.relativeRenderGroupDepth] = {
            index: 0,
            list: []
        };
        childrenToUpdate.list[childrenToUpdate.index++] = child;
    }
    // SHOULD THIS BE HERE?
    updateRenderable(container) {
        if (container.globalDisplayStatus < 7) return;
        container.didViewUpdate = false;
        this.instructionSet.renderPipes[container.renderPipeId].updateRenderable(container);
    }
    onChildViewUpdate(child) {
        this.childrenRenderablesToUpdate.list[this.childrenRenderablesToUpdate.index++] = child;
    }
    get isRenderable() {
        return this.root.localDisplayStatus === 7 && this.worldAlpha > 0;
    }
    /**
   * adding a container to the onRender list will make sure the user function
   * passed in to the user defined 'onRender` callBack
   * @param container - the container to add to the onRender list
   */ addOnRender(container) {
        this._onRenderContainers.push(container);
    }
    removeOnRender(container) {
        this._onRenderContainers.splice(this._onRenderContainers.indexOf(container), 1);
    }
    runOnRender() {
        for(let i = 0; i < this._onRenderContainers.length; i++)this._onRenderContainers[i]._onRender();
    }
    destroy() {
        this.renderGroupParent = null;
        this.root = null;
        this.childrenRenderablesToUpdate = null;
        this.childrenToUpdate = null;
        this.renderGroupChildren = null;
        this._onRenderContainers = null;
        this.instructionSet = null;
    }
    getChildren(out = []) {
        const children = this.root.children;
        for(let i = 0; i < children.length; i++)this._getChildren(children[i], out);
        return out;
    }
    _getChildren(container, out = []) {
        out.push(container);
        if (container.renderGroup) return out;
        const children = container.children;
        for(let i = 0; i < children.length; i++)this._getChildren(children[i], out);
        return out;
    }
}

});
parcelRegister("dK5Jn", function(module, exports) {

$parcel$export(module.exports, "InstructionSet", () => $a69ff318b1fa7c86$export$2946bd01f10dd922);

var $aGJhg = parcelRequire("aGJhg");
"use strict";
let $a69ff318b1fa7c86$var$_tick = 0;
class $a69ff318b1fa7c86$export$2946bd01f10dd922 {
    constructor(){
        /** a unique id for this instruction set used through the renderer */ this.uid = (0, $aGJhg.uid)("instructionSet");
        /** the array of instructions */ this.instructions = [];
        /** the actual size of the array (any instructions passed this should be ignored) */ this.instructionSize = 0;
        this.renderables = [];
        this.tick = 0;
    }
    /** reset the instruction set so it can be reused set size back to 0 */ reset() {
        this.instructionSize = 0;
        this.tick = $a69ff318b1fa7c86$var$_tick++;
    }
    /**
   * Add an instruction to the set
   * @param instruction - add an instruction to the set
   */ add(instruction) {
        this.instructions[this.instructionSize++] = instruction;
    }
    /**
   * Log the instructions to the console (for debugging)
   * @internal
   * @ignore
   */ log() {
        this.instructions.length = this.instructionSize;
        console.table(this.instructions, [
            "type",
            "action"
        ]);
    }
}

});


parcelRegister("gIPW8", function(module, exports) {

$parcel$export(module.exports, "assignWithIgnore", () => $83c57e61d47d996f$export$59d0441a278e5935);
"use strict";
function $83c57e61d47d996f$export$59d0441a278e5935(target, options, ignore = {}) {
    for(const key in options)if (!ignore[key] && options[key] !== void 0) target[key] = options[key];
}

});




parcelRegister("jzlb7", function(module, exports) {

$parcel$export(module.exports, "addMaskBounds", () => $cd1eadd0f2fb679c$export$12af48852c6ac574);

var $7wtv9 = parcelRequire("7wtv9");

var $iskjc = parcelRequire("iskjc");
"use strict";
const $cd1eadd0f2fb679c$var$tempBounds = new (0, $7wtv9.Bounds)();
function $cd1eadd0f2fb679c$export$12af48852c6ac574(mask, bounds, skipUpdateTransform) {
    const boundsToMask = $cd1eadd0f2fb679c$var$tempBounds;
    mask.measurable = true;
    (0, $iskjc.getGlobalBounds)(mask, skipUpdateTransform, boundsToMask);
    bounds.addBoundsMask(boundsToMask);
    mask.measurable = false;
}

});

parcelRegister("4vXk0", function(module, exports) {

$parcel$export(module.exports, "addMaskLocalBounds", () => $6df4144b7f405909$export$7416ac774b1f1a33);

var $j68wk = parcelRequire("j68wk");

var $5tmC8 = parcelRequire("5tmC8");

var $hUCK4 = parcelRequire("hUCK4");
"use strict";
function $6df4144b7f405909$export$7416ac774b1f1a33(mask, bounds, localRoot) {
    const boundsToMask = (0, $5tmC8.boundsPool).get();
    mask.measurable = true;
    const tempMatrix = (0, $5tmC8.matrixPool).get().identity();
    const relativeMask = $6df4144b7f405909$export$1536bde1a0bf3cb9(mask, localRoot, tempMatrix);
    (0, $j68wk.getLocalBounds)(mask, boundsToMask, relativeMask);
    mask.measurable = false;
    bounds.addBoundsMask(boundsToMask);
    (0, $5tmC8.matrixPool).return(tempMatrix);
    (0, $5tmC8.boundsPool).return(boundsToMask);
}
function $6df4144b7f405909$export$1536bde1a0bf3cb9(target, root, matrix) {
    if (!target) {
        (0, $hUCK4.warn)("Mask bounds, renderable is not inside the root container");
        return matrix;
    }
    if (target !== root) {
        $6df4144b7f405909$export$1536bde1a0bf3cb9(target.parent, root, matrix);
        target.updateLocalTransform();
        matrix.append(target.localTransform);
    }
    return matrix;
}

});


parcelRegister("lLQso", function(module, exports) {

$parcel$export(module.exports, "ColorMask", () => $2625cf12b5a3b5e5$export$1e2a2c76374c2542);

var $i9BKe = parcelRequire("i9BKe");
"use strict";
class $2625cf12b5a3b5e5$export$1e2a2c76374c2542 {
    constructor(options){
        this.priority = 0;
        this.pipe = "colorMask";
        if (options?.mask) this.init(options.mask);
    }
    init(mask) {
        this.mask = mask;
    }
    destroy() {}
    static test(mask) {
        return typeof mask === "number";
    }
}
$2625cf12b5a3b5e5$export$1e2a2c76374c2542.extension = (0, $i9BKe.ExtensionType).MaskEffect;

});

parcelRegister("jXXId", function(module, exports) {

$parcel$export(module.exports, "StencilMask", () => $e8890ea82735e7dd$export$abd85894695764cb);

var $i9BKe = parcelRequire("i9BKe");

var $eicwU = parcelRequire("eicwU");

var $jzlb7 = parcelRequire("jzlb7");

var $4vXk0 = parcelRequire("4vXk0");
"use strict";
class $e8890ea82735e7dd$export$abd85894695764cb {
    constructor(options){
        this.priority = 0;
        this.pipe = "stencilMask";
        if (options?.mask) this.init(options.mask);
    }
    init(mask) {
        this.mask = mask;
        this.mask.includeInBuild = false;
        this.mask.measurable = false;
    }
    reset() {
        this.mask.measurable = true;
        this.mask.includeInBuild = true;
        this.mask = null;
    }
    addBounds(bounds, skipUpdateTransform) {
        (0, $jzlb7.addMaskBounds)(this.mask, bounds, skipUpdateTransform);
    }
    addLocalBounds(bounds, localRoot) {
        (0, $4vXk0.addMaskLocalBounds)(this.mask, bounds, localRoot);
    }
    containsPoint(point, hitTestFn) {
        const mask = this.mask;
        return hitTestFn(mask, point);
    }
    destroy() {
        this.reset();
    }
    static test(mask) {
        return mask instanceof (0, $eicwU.Container);
    }
}
$e8890ea82735e7dd$export$abd85894695764cb.extension = (0, $i9BKe.ExtensionType).MaskEffect;

});

parcelRegister("8xl7d", function(module, exports) {

$parcel$export(module.exports, "CanvasSource", () => $adfc96265c7ca69d$export$ca65ccf5708c6a0c);

var $iCGeI = parcelRequire("iCGeI");

var $i9BKe = parcelRequire("i9BKe");

var $iA5fe = parcelRequire("iA5fe");
"use strict";
class $adfc96265c7ca69d$export$ca65ccf5708c6a0c extends (0, $iA5fe.TextureSource) {
    constructor(options){
        if (!options.resource) options.resource = (0, $iCGeI.DOMAdapter).get().createCanvas();
        if (!options.width) {
            options.width = options.resource.width;
            if (!options.autoDensity) options.width /= options.resolution;
        }
        if (!options.height) {
            options.height = options.resource.height;
            if (!options.autoDensity) options.height /= options.resolution;
        }
        super(options);
        this.uploadMethodId = "image";
        this.autoDensity = options.autoDensity;
        const canvas = options.resource;
        if (this.pixelWidth !== canvas.width || this.pixelWidth !== canvas.height) this.resizeCanvas();
        this.transparent = !!options.transparent;
    }
    resizeCanvas() {
        if (this.autoDensity) {
            this.resource.style.width = `${this.width}px`;
            this.resource.style.height = `${this.height}px`;
        }
        if (this.resource.width !== this.pixelWidth || this.resource.height !== this.pixelHeight) {
            this.resource.width = this.pixelWidth;
            this.resource.height = this.pixelHeight;
        }
    }
    resize(width = this.width, height = this.height, resolution = this._resolution) {
        const didResize = super.resize(width, height, resolution);
        if (didResize) this.resizeCanvas();
        return didResize;
    }
    static test(resource) {
        return globalThis.HTMLCanvasElement && resource instanceof HTMLCanvasElement || globalThis.OffscreenCanvas && resource instanceof OffscreenCanvas;
    }
    /**
   * Returns the 2D rendering context for the canvas.
   * Caches the context after creating it.
   * @returns The 2D rendering context of the canvas.
   */ get context2D() {
        return this._context2D || (this._context2D = this.resource.getContext("2d"));
    }
}
$adfc96265c7ca69d$export$ca65ccf5708c6a0c.extension = (0, $i9BKe.ExtensionType).TextureSource;

});
parcelRegister("iCGeI", function(module, exports) {

$parcel$export(module.exports, "DOMAdapter", () => $bfbe44ab70ab7a53$export$d988306fa84f7b44);

var $9OKiP = parcelRequire("9OKiP");
"use strict";
let $bfbe44ab70ab7a53$var$currentAdapter = (0, $9OKiP.BrowserAdapter);
const $bfbe44ab70ab7a53$export$d988306fa84f7b44 = {
    /**
   * Returns the current adapter.
   * @returns {environment.Adapter} The current adapter.
   */ get () {
        return $bfbe44ab70ab7a53$var$currentAdapter;
    },
    /**
   * Sets the current adapter.
   * @param adapter - The new adapter.
   */ set (adapter) {
        $bfbe44ab70ab7a53$var$currentAdapter = adapter;
    }
};

});
parcelRegister("9OKiP", function(module, exports) {

$parcel$export(module.exports, "BrowserAdapter", () => $ed1c5172c2eee607$export$e467cc3399500025);
"use strict";
const $ed1c5172c2eee607$export$e467cc3399500025 = {
    createCanvas: (width, height)=>{
        const canvas = document.createElement("canvas");
        canvas.width = width;
        canvas.height = height;
        return canvas;
    },
    getCanvasRenderingContext2D: ()=>CanvasRenderingContext2D,
    getWebGLRenderingContext: ()=>WebGLRenderingContext,
    getNavigator: ()=>navigator,
    getBaseUrl: ()=>document.baseURI ?? window.location.href,
    getFontFaceSet: ()=>document.fonts,
    fetch: (url, options)=>fetch(url, options),
    parseXML: (xml)=>{
        const parser = new DOMParser();
        return parser.parseFromString(xml, "text/xml");
    }
};

});



parcelRegister("aQPld", function(module, exports) {

$parcel$export(module.exports, "ImageSource", () => $ac4c5539d7b1f960$export$280e9a68c3ffd919);

var $iCGeI = parcelRequire("iCGeI");

var $i9BKe = parcelRequire("i9BKe");

var $hUCK4 = parcelRequire("hUCK4");

var $iA5fe = parcelRequire("iA5fe");
"use strict";
class $ac4c5539d7b1f960$export$280e9a68c3ffd919 extends (0, $iA5fe.TextureSource) {
    constructor(options){
        if (options.resource && globalThis.HTMLImageElement && options.resource instanceof HTMLImageElement) {
            const canvas = (0, $iCGeI.DOMAdapter).get().createCanvas(options.resource.width, options.resource.height);
            const context = canvas.getContext("2d");
            context.drawImage(options.resource, 0, 0, options.resource.width, options.resource.height);
            options.resource = canvas;
            (0, $hUCK4.warn)("ImageSource: Image element passed, converting to canvas. Use CanvasSource instead.");
        }
        super(options);
        this.uploadMethodId = "image";
        this.autoGarbageCollect = true;
    }
    static test(resource) {
        return globalThis.HTMLImageElement && resource instanceof HTMLImageElement || typeof ImageBitmap !== "undefined" && resource instanceof ImageBitmap || globalThis.VideoFrame && resource instanceof VideoFrame;
    }
}
$ac4c5539d7b1f960$export$280e9a68c3ffd919.extension = (0, $i9BKe.ExtensionType).TextureSource;

});

parcelRegister("hNatJ", function(module, exports) {

$parcel$export(module.exports, "VideoSource", () => $4dc351acd421ceef$export$f3a17123d80000c5);

var $i9BKe = parcelRequire("i9BKe");

var $4J7WL = parcelRequire("4J7WL");

var $7blVu = parcelRequire("7blVu");

var $iA5fe = parcelRequire("iA5fe");
"use strict";
const $4dc351acd421ceef$var$_VideoSource = class _VideoSource extends (0, $iA5fe.TextureSource) {
    constructor(options){
        super(options);
        // Public
        /** Whether or not the video is ready to play. */ this.isReady = false;
        /** The upload method for this texture. */ this.uploadMethodId = "video";
        options = {
            ..._VideoSource.defaultOptions,
            ...options
        };
        this._autoUpdate = true;
        this._isConnectedToTicker = false;
        this._updateFPS = options.updateFPS || 0;
        this._msToNextUpdate = 0;
        this.autoPlay = options.autoPlay !== false;
        this.alphaMode = options.alphaMode ?? "premultiply-alpha-on-upload";
        this._videoFrameRequestCallback = this._videoFrameRequestCallback.bind(this);
        this._videoFrameRequestCallbackHandle = null;
        this._load = null;
        this._resolve = null;
        this._reject = null;
        this._onCanPlay = this._onCanPlay.bind(this);
        this._onCanPlayThrough = this._onCanPlayThrough.bind(this);
        this._onError = this._onError.bind(this);
        this._onPlayStart = this._onPlayStart.bind(this);
        this._onPlayStop = this._onPlayStop.bind(this);
        this._onSeeked = this._onSeeked.bind(this);
        if (options.autoLoad !== false) this.load();
    }
    /** Update the video frame if the source is not destroyed and meets certain conditions. */ updateFrame() {
        if (this.destroyed) return;
        if (this._updateFPS) {
            const elapsedMS = (0, $4J7WL.Ticker).shared.elapsedMS * this.resource.playbackRate;
            this._msToNextUpdate = Math.floor(this._msToNextUpdate - elapsedMS);
        }
        if (!this._updateFPS || this._msToNextUpdate <= 0) this._msToNextUpdate = this._updateFPS ? Math.floor(1e3 / this._updateFPS) : 0;
        if (this.isValid) this.update();
    }
    /** Callback to update the video frame and potentially request the next frame update. */ _videoFrameRequestCallback() {
        this.updateFrame();
        if (this.destroyed) this._videoFrameRequestCallbackHandle = null;
        else this._videoFrameRequestCallbackHandle = this.resource.requestVideoFrameCallback(this._videoFrameRequestCallback);
    }
    /**
   * Checks if the resource has valid dimensions.
   * @returns {boolean} True if width and height are set, otherwise false.
   */ get isValid() {
        return !!this.resource.videoWidth && !!this.resource.videoHeight;
    }
    /**
   * Start preloading the video resource.
   * @returns {Promise<this>} Handle the validate event
   */ async load() {
        if (this._load) return this._load;
        const source = this.resource;
        const options = this.options;
        if ((source.readyState === source.HAVE_ENOUGH_DATA || source.readyState === source.HAVE_FUTURE_DATA) && source.width && source.height) source.complete = true;
        source.addEventListener("play", this._onPlayStart);
        source.addEventListener("pause", this._onPlayStop);
        source.addEventListener("seeked", this._onSeeked);
        if (!this._isSourceReady()) {
            if (!options.preload) source.addEventListener("canplay", this._onCanPlay);
            source.addEventListener("canplaythrough", this._onCanPlayThrough);
            source.addEventListener("error", this._onError, true);
        } else this._mediaReady();
        this.alphaMode = await (0, $7blVu.detectVideoAlphaMode)();
        this._load = new Promise((resolve, reject)=>{
            if (this.isValid) resolve(this);
            else {
                this._resolve = resolve;
                this._reject = reject;
                if (options.preloadTimeoutMs !== void 0) this._preloadTimeout = setTimeout(()=>{
                    this._onError(new ErrorEvent(`Preload exceeded timeout of ${options.preloadTimeoutMs}ms`));
                });
                source.load();
            }
        });
        return this._load;
    }
    /**
   * Handle video error events.
   * @param event - The error event
   */ _onError(event) {
        this.resource.removeEventListener("error", this._onError, true);
        this.emit("error", event);
        if (this._reject) {
            this._reject(event);
            this._reject = null;
            this._resolve = null;
        }
    }
    /**
   * Checks if the underlying source is playing.
   * @returns True if playing.
   */ _isSourcePlaying() {
        const source = this.resource;
        return !source.paused && !source.ended;
    }
    /**
   * Checks if the underlying source is ready for playing.
   * @returns True if ready.
   */ _isSourceReady() {
        const source = this.resource;
        return source.readyState > 2;
    }
    /** Runs the update loop when the video is ready to play. */ _onPlayStart() {
        if (!this.isValid) this._mediaReady();
        this._configureAutoUpdate();
    }
    /** Stops the update loop when a pause event is triggered. */ _onPlayStop() {
        this._configureAutoUpdate();
    }
    /** Handles behavior when the video completes seeking to the current playback position. */ _onSeeked() {
        if (this._autoUpdate && !this._isSourcePlaying()) {
            this._msToNextUpdate = 0;
            this.updateFrame();
            this._msToNextUpdate = 0;
        }
    }
    _onCanPlay() {
        const source = this.resource;
        source.removeEventListener("canplay", this._onCanPlay);
        this._mediaReady();
    }
    _onCanPlayThrough() {
        const source = this.resource;
        source.removeEventListener("canplaythrough", this._onCanPlay);
        if (this._preloadTimeout) {
            clearTimeout(this._preloadTimeout);
            this._preloadTimeout = void 0;
        }
        this._mediaReady();
    }
    /** Fired when the video is loaded and ready to play. */ _mediaReady() {
        const source = this.resource;
        if (this.isValid) {
            this.isReady = true;
            this.resize(source.videoWidth, source.videoHeight);
        }
        this._msToNextUpdate = 0;
        this.updateFrame();
        this._msToNextUpdate = 0;
        if (this._resolve) {
            this._resolve(this);
            this._resolve = null;
            this._reject = null;
        }
        if (this._isSourcePlaying()) this._onPlayStart();
        else if (this.autoPlay) this.resource.play();
    }
    /** Cleans up resources and event listeners associated with this texture. */ destroy() {
        this._configureAutoUpdate();
        const source = this.resource;
        if (source) {
            source.removeEventListener("play", this._onPlayStart);
            source.removeEventListener("pause", this._onPlayStop);
            source.removeEventListener("seeked", this._onSeeked);
            source.removeEventListener("canplay", this._onCanPlay);
            source.removeEventListener("canplaythrough", this._onCanPlayThrough);
            source.removeEventListener("error", this._onError, true);
            source.pause();
            source.src = "";
            source.load();
        }
        super.destroy();
    }
    /** Should the base texture automatically update itself, set to true by default. */ get autoUpdate() {
        return this._autoUpdate;
    }
    set autoUpdate(value) {
        if (value !== this._autoUpdate) {
            this._autoUpdate = value;
            this._configureAutoUpdate();
        }
    }
    /**
   * How many times a second to update the texture from the video.
   * Leave at 0 to update at every render.
   * A lower fps can help performance, as updating the texture at 60fps on a 30ps video may not be efficient.
   */ get updateFPS() {
        return this._updateFPS;
    }
    set updateFPS(value) {
        if (value !== this._updateFPS) {
            this._updateFPS = value;
            this._configureAutoUpdate();
        }
    }
    /**
   * Configures the updating mechanism based on the current state and settings.
   *
   * This method decides between using the browser's native video frame callback or a custom ticker
   * for updating the video frame. It ensures optimal performance and responsiveness
   * based on the video's state, playback status, and the desired frames-per-second setting.
   *
   * - If `_autoUpdate` is enabled and the video source is playing:
   *   - It will prefer the native video frame callback if available and no specific FPS is set.
   *   - Otherwise, it will use a custom ticker for manual updates.
   * - If `_autoUpdate` is disabled or the video isn't playing, any active update mechanisms are halted.
   */ _configureAutoUpdate() {
        if (this._autoUpdate && this._isSourcePlaying()) {
            if (!this._updateFPS && this.resource.requestVideoFrameCallback) {
                if (this._isConnectedToTicker) {
                    (0, $4J7WL.Ticker).shared.remove(this.updateFrame, this);
                    this._isConnectedToTicker = false;
                    this._msToNextUpdate = 0;
                }
                if (this._videoFrameRequestCallbackHandle === null) this._videoFrameRequestCallbackHandle = this.resource.requestVideoFrameCallback(this._videoFrameRequestCallback);
            } else {
                if (this._videoFrameRequestCallbackHandle !== null) {
                    this.resource.cancelVideoFrameCallback(this._videoFrameRequestCallbackHandle);
                    this._videoFrameRequestCallbackHandle = null;
                }
                if (!this._isConnectedToTicker) {
                    (0, $4J7WL.Ticker).shared.add(this.updateFrame, this);
                    this._isConnectedToTicker = true;
                    this._msToNextUpdate = 0;
                }
            }
        } else {
            if (this._videoFrameRequestCallbackHandle !== null) {
                this.resource.cancelVideoFrameCallback(this._videoFrameRequestCallbackHandle);
                this._videoFrameRequestCallbackHandle = null;
            }
            if (this._isConnectedToTicker) {
                (0, $4J7WL.Ticker).shared.remove(this.updateFrame, this);
                this._isConnectedToTicker = false;
                this._msToNextUpdate = 0;
            }
        }
    }
    static test(resource) {
        return globalThis.HTMLVideoElement && resource instanceof HTMLVideoElement;
    }
};
$4dc351acd421ceef$var$_VideoSource.extension = (0, $i9BKe.ExtensionType).TextureSource;
/** The default options for video sources. */ $4dc351acd421ceef$var$_VideoSource.defaultOptions = {
    ...(0, $iA5fe.TextureSource).defaultOptions,
    /** If true, the video will start loading immediately. */ autoLoad: true,
    /** If true, the video will start playing as soon as it is loaded. */ autoPlay: true,
    /** The number of times a second to update the texture from the video. Leave at 0 to update at every render. */ updateFPS: 0,
    /** If true, the video will be loaded with the `crossorigin` attribute. */ crossorigin: true,
    /** If true, the video will loop when it ends. */ loop: false,
    /** If true, the video will be muted. */ muted: true,
    /** If true, the video will play inline. */ playsinline: true,
    /** If true, the video will be preloaded. */ preload: false
};
/**
 * Map of video MIME types that can't be directly derived from file extensions.
 * @readonly
 */ $4dc351acd421ceef$var$_VideoSource.MIME_TYPES = {
    ogv: "video/ogg",
    mov: "video/quicktime",
    m4v: "video/mp4"
};
let $4dc351acd421ceef$export$f3a17123d80000c5 = $4dc351acd421ceef$var$_VideoSource;

});
parcelRegister("4J7WL", function(module, exports) {

$parcel$export(module.exports, "Ticker", () => $2bf8d15685054100$export$39c54bcc89dcee11);

var $cQMLP = parcelRequire("cQMLP");

var $bJH8Y = parcelRequire("bJH8Y");
"use strict";
const $2bf8d15685054100$var$_Ticker = class _Ticker {
    constructor(){
        /**
     * Whether or not this ticker should invoke the method
     * {@link ticker.Ticker#start|start} automatically when a listener is added.
     */ this.autoStart = false;
        /**
     * Scalar time value from last frame to this frame.
     * This value is capped by setting {@link ticker.Ticker#minFPS|minFPS}
     * and is scaled with {@link ticker.Ticker#speed|speed}.
     * **Note:** The cap may be exceeded by scaling.
     */ this.deltaTime = 1;
        /**
     * The last time {@link ticker.Ticker#update|update} was invoked.
     * This value is also reset internally outside of invoking
     * update, but only when a new animation frame is requested.
     * If the platform supports DOMHighResTimeStamp,
     * this value will have a precision of 1 µs.
     */ this.lastTime = -1;
        /**
     * Factor of current {@link ticker.Ticker#deltaTime|deltaTime}.
     * @example
     * // Scales ticker.deltaTime to what would be
     * // the equivalent of approximately 120 FPS
     * ticker.speed = 2;
     */ this.speed = 1;
        /**
     * Whether or not this ticker has been started.
     * `true` if {@link ticker.Ticker#start|start} has been called.
     * `false` if {@link ticker.Ticker#stop|Stop} has been called.
     * While `false`, this value may change to `true` in the
     * event of {@link ticker.Ticker#autoStart|autoStart} being `true`
     * and a listener is added.
     */ this.started = false;
        /** Internal current frame request ID */ this._requestId = null;
        /**
     * Internal value managed by minFPS property setter and getter.
     * This is the maximum allowed milliseconds between updates.
     */ this._maxElapsedMS = 100;
        /**
     * Internal value managed by minFPS property setter and getter.
     * This is the minimum allowed milliseconds between updates.
     */ this._minElapsedMS = 0;
        /** If enabled, deleting is disabled.*/ this._protected = false;
        /** The last time keyframe was executed. Maintains a relatively fixed interval with the previous value. */ this._lastFrame = -1;
        this._head = new (0, $bJH8Y.TickerListener)(null, null, Infinity);
        this.deltaMS = 1 / _Ticker.targetFPMS;
        this.elapsedMS = 1 / _Ticker.targetFPMS;
        this._tick = (time)=>{
            this._requestId = null;
            if (this.started) {
                this.update(time);
                if (this.started && this._requestId === null && this._head.next) this._requestId = requestAnimationFrame(this._tick);
            }
        };
    }
    /**
   * Conditionally requests a new animation frame.
   * If a frame has not already been requested, and if the internal
   * emitter has listeners, a new frame is requested.
   * @private
   */ _requestIfNeeded() {
        if (this._requestId === null && this._head.next) {
            this.lastTime = performance.now();
            this._lastFrame = this.lastTime;
            this._requestId = requestAnimationFrame(this._tick);
        }
    }
    /**
   * Conditionally cancels a pending animation frame.
   * @private
   */ _cancelIfNeeded() {
        if (this._requestId !== null) {
            cancelAnimationFrame(this._requestId);
            this._requestId = null;
        }
    }
    /**
   * Conditionally requests a new animation frame.
   * If the ticker has been started it checks if a frame has not already
   * been requested, and if the internal emitter has listeners. If these
   * conditions are met, a new frame is requested. If the ticker has not
   * been started, but autoStart is `true`, then the ticker starts now,
   * and continues with the previous conditions to request a new frame.
   * @private
   */ _startIfPossible() {
        if (this.started) this._requestIfNeeded();
        else if (this.autoStart) this.start();
    }
    /**
   * Register a handler for tick events. Calls continuously unless
   * it is removed or the ticker is stopped.
   * @param fn - The listener function to be added for updates
   * @param context - The listener context
   * @param {number} [priority=UPDATE_PRIORITY.NORMAL] - The priority for emitting
   * @returns This instance of a ticker
   */ add(fn, context, priority = (0, $cQMLP.UPDATE_PRIORITY).NORMAL) {
        return this._addListener(new (0, $bJH8Y.TickerListener)(fn, context, priority));
    }
    /**
   * Add a handler for the tick event which is only execute once.
   * @param fn - The listener function to be added for one update
   * @param context - The listener context
   * @param {number} [priority=UPDATE_PRIORITY.NORMAL] - The priority for emitting
   * @returns This instance of a ticker
   */ addOnce(fn, context, priority = (0, $cQMLP.UPDATE_PRIORITY).NORMAL) {
        return this._addListener(new (0, $bJH8Y.TickerListener)(fn, context, priority, true));
    }
    /**
   * Internally adds the event handler so that it can be sorted by priority.
   * Priority allows certain handler (user, AnimatedSprite, Interaction) to be run
   * before the rendering.
   * @private
   * @param listener - Current listener being added.
   * @returns This instance of a ticker
   */ _addListener(listener) {
        let current = this._head.next;
        let previous = this._head;
        if (!current) listener.connect(previous);
        else {
            while(current){
                if (listener.priority > current.priority) {
                    listener.connect(previous);
                    break;
                }
                previous = current;
                current = current.next;
            }
            if (!listener.previous) listener.connect(previous);
        }
        this._startIfPossible();
        return this;
    }
    /**
   * Removes any handlers matching the function and context parameters.
   * If no handlers are left after removing, then it cancels the animation frame.
   * @param fn - The listener function to be removed
   * @param context - The listener context to be removed
   * @returns This instance of a ticker
   */ remove(fn, context) {
        let listener = this._head.next;
        while(listener)if (listener.match(fn, context)) listener = listener.destroy();
        else listener = listener.next;
        if (!this._head.next) this._cancelIfNeeded();
        return this;
    }
    /**
   * The number of listeners on this ticker, calculated by walking through linked list
   * @readonly
   * @member {number}
   */ get count() {
        if (!this._head) return 0;
        let count = 0;
        let current = this._head;
        while(current = current.next)count++;
        return count;
    }
    /** Starts the ticker. If the ticker has listeners a new animation frame is requested at this point. */ start() {
        if (!this.started) {
            this.started = true;
            this._requestIfNeeded();
        }
    }
    /** Stops the ticker. If the ticker has requested an animation frame it is canceled at this point. */ stop() {
        if (this.started) {
            this.started = false;
            this._cancelIfNeeded();
        }
    }
    /** Destroy the ticker and don't use after this. Calling this method removes all references to internal events. */ destroy() {
        if (!this._protected) {
            this.stop();
            let listener = this._head.next;
            while(listener)listener = listener.destroy(true);
            this._head.destroy();
            this._head = null;
        }
    }
    /**
   * Triggers an update. An update entails setting the
   * current {@link ticker.Ticker#elapsedMS|elapsedMS},
   * the current {@link ticker.Ticker#deltaTime|deltaTime},
   * invoking all listeners with current deltaTime,
   * and then finally setting {@link ticker.Ticker#lastTime|lastTime}
   * with the value of currentTime that was provided.
   * This method will be called automatically by animation
   * frame callbacks if the ticker instance has been started
   * and listeners are added.
   * @param {number} [currentTime=performance.now()] - the current time of execution
   */ update(currentTime = performance.now()) {
        let elapsedMS;
        if (currentTime > this.lastTime) {
            elapsedMS = this.elapsedMS = currentTime - this.lastTime;
            if (elapsedMS > this._maxElapsedMS) elapsedMS = this._maxElapsedMS;
            elapsedMS *= this.speed;
            if (this._minElapsedMS) {
                const delta = currentTime - this._lastFrame | 0;
                if (delta < this._minElapsedMS) return;
                this._lastFrame = currentTime - delta % this._minElapsedMS;
            }
            this.deltaMS = elapsedMS;
            this.deltaTime = this.deltaMS * _Ticker.targetFPMS;
            const head = this._head;
            let listener = head.next;
            while(listener)listener = listener.emit(this);
            if (!head.next) this._cancelIfNeeded();
        } else this.deltaTime = this.deltaMS = this.elapsedMS = 0;
        this.lastTime = currentTime;
    }
    /**
   * The frames per second at which this ticker is running.
   * The default is approximately 60 in most modern browsers.
   * **Note:** This does not factor in the value of
   * {@link ticker.Ticker#speed|speed}, which is specific
   * to scaling {@link ticker.Ticker#deltaTime|deltaTime}.
   * @member {number}
   * @readonly
   */ get FPS() {
        return 1e3 / this.elapsedMS;
    }
    /**
   * Manages the maximum amount of milliseconds allowed to
   * elapse between invoking {@link ticker.Ticker#update|update}.
   * This value is used to cap {@link ticker.Ticker#deltaTime|deltaTime},
   * but does not effect the measured value of {@link ticker.Ticker#FPS|FPS}.
   * When setting this property it is clamped to a value between
   * `0` and `Ticker.targetFPMS * 1000`.
   * @member {number}
   * @default 10
   */ get minFPS() {
        return 1e3 / this._maxElapsedMS;
    }
    set minFPS(fps) {
        const minFPS = Math.min(this.maxFPS, fps);
        const minFPMS = Math.min(Math.max(0, minFPS) / 1e3, _Ticker.targetFPMS);
        this._maxElapsedMS = 1 / minFPMS;
    }
    /**
   * Manages the minimum amount of milliseconds required to
   * elapse between invoking {@link ticker.Ticker#update|update}.
   * This will effect the measured value of {@link ticker.Ticker#FPS|FPS}.
   * If it is set to `0`, then there is no limit; PixiJS will render as many frames as it can.
   * Otherwise it will be at least `minFPS`
   * @member {number}
   * @default 0
   */ get maxFPS() {
        if (this._minElapsedMS) return Math.round(1e3 / this._minElapsedMS);
        return 0;
    }
    set maxFPS(fps) {
        if (fps === 0) this._minElapsedMS = 0;
        else {
            const maxFPS = Math.max(this.minFPS, fps);
            this._minElapsedMS = 1 / (maxFPS / 1e3);
        }
    }
    /**
   * The shared ticker instance used by {@link AnimatedSprite} and by
   * {@link VideoResource} to update animation frames / video textures.
   *
   * It may also be used by {@link Application} if created with the `sharedTicker` option property set to true.
   *
   * The property {@link ticker.Ticker#autoStart|autoStart} is set to `true` for this instance.
   * Please follow the examples for usage, including how to opt-out of auto-starting the shared ticker.
   * @example
   * import { Ticker } from 'pixi.js';
   *
   * const ticker = Ticker.shared;
   * // Set this to prevent starting this ticker when listeners are added.
   * // By default this is true only for the Ticker.shared instance.
   * ticker.autoStart = false;
   *
   * // FYI, call this to ensure the ticker is stopped. It should be stopped
   * // if you have not attempted to render anything yet.
   * ticker.stop();
   *
   * // Call this when you are ready for a running shared ticker.
   * ticker.start();
   * @example
   * import { autoDetectRenderer, Container } from 'pixi.js';
   *
   * // You may use the shared ticker to render...
   * const renderer = autoDetectRenderer();
   * const stage = new Container();
   * document.body.appendChild(renderer.view);
   * ticker.add((time) => renderer.render(stage));
   *
   * // Or you can just update it manually.
   * ticker.autoStart = false;
   * ticker.stop();
   * const animate = (time) => {
   *     ticker.update(time);
   *     renderer.render(stage);
   *     requestAnimationFrame(animate);
   * };
   * animate(performance.now());
   * @member {ticker.Ticker}
   * @readonly
   * @static
   */ static get shared() {
        if (!_Ticker._shared) {
            const shared = _Ticker._shared = new _Ticker();
            shared.autoStart = true;
            shared._protected = true;
        }
        return _Ticker._shared;
    }
    /**
   * The system ticker instance used by {@link BasePrepare} for core timing
   * functionality that shouldn't usually need to be paused, unlike the `shared`
   * ticker which drives visual animations and rendering which may want to be paused.
   *
   * The property {@link ticker.Ticker#autoStart|autoStart} is set to `true` for this instance.
   * @member {ticker.Ticker}
   * @readonly
   * @static
   */ static get system() {
        if (!_Ticker._system) {
            const system = _Ticker._system = new _Ticker();
            system.autoStart = true;
            system._protected = true;
        }
        return _Ticker._system;
    }
};
/**
 * Target frames per millisecond.
 * @static
 */ $2bf8d15685054100$var$_Ticker.targetFPMS = 0.06;
let $2bf8d15685054100$export$39c54bcc89dcee11 = $2bf8d15685054100$var$_Ticker;

});
parcelRegister("cQMLP", function(module, exports) {

$parcel$export(module.exports, "UPDATE_PRIORITY", () => $d091949369ecd400$export$688aaf132ba9b379);
"use strict";
var $d091949369ecd400$export$688aaf132ba9b379 = /* @__PURE__ */ ((UPDATE_PRIORITY2)=>{
    UPDATE_PRIORITY2[UPDATE_PRIORITY2["INTERACTION"] = 50] = "INTERACTION";
    UPDATE_PRIORITY2[UPDATE_PRIORITY2["HIGH"] = 25] = "HIGH";
    UPDATE_PRIORITY2[UPDATE_PRIORITY2["NORMAL"] = 0] = "NORMAL";
    UPDATE_PRIORITY2[UPDATE_PRIORITY2["LOW"] = -25] = "LOW";
    UPDATE_PRIORITY2[UPDATE_PRIORITY2["UTILITY"] = -50] = "UTILITY";
    return UPDATE_PRIORITY2;
})($d091949369ecd400$export$688aaf132ba9b379 || {});

});

parcelRegister("bJH8Y", function(module, exports) {

$parcel$export(module.exports, "TickerListener", () => $44ffb68c45a667a2$export$579021a5759a260f);
"use strict";
class $44ffb68c45a667a2$export$579021a5759a260f {
    /**
   * Constructor
   * @private
   * @param fn - The listener function to be added for one update
   * @param context - The listener context
   * @param priority - The priority for emitting
   * @param once - If the handler should fire once
   */ constructor(fn, context = null, priority = 0, once = false){
        /** The next item in chain. */ this.next = null;
        /** The previous item in chain. */ this.previous = null;
        /** `true` if this listener has been destroyed already. */ this._destroyed = false;
        this._fn = fn;
        this._context = context;
        this.priority = priority;
        this._once = once;
    }
    /**
   * Simple compare function to figure out if a function and context match.
   * @param fn - The listener function to be added for one update
   * @param context - The listener context
   * @returns `true` if the listener match the arguments
   */ match(fn, context = null) {
        return this._fn === fn && this._context === context;
    }
    /**
   * Emit by calling the current function.
   * @param ticker - The ticker emitting.
   * @returns Next ticker
   */ emit(ticker) {
        if (this._fn) {
            if (this._context) this._fn.call(this._context, ticker);
            else this._fn(ticker);
        }
        const redirect = this.next;
        if (this._once) this.destroy(true);
        if (this._destroyed) this.next = null;
        return redirect;
    }
    /**
   * Connect to the list.
   * @param previous - Input node, previous listener
   */ connect(previous) {
        this.previous = previous;
        if (previous.next) previous.next.previous = this;
        this.next = previous.next;
        previous.next = this;
    }
    /**
   * Destroy and don't use after this.
   * @param hard - `true` to remove the `next` reference, this
   *        is considered a hard destroy. Soft destroy maintains the next reference.
   * @returns The listener to redirect while emitting or removing.
   */ destroy(hard = false) {
        this._destroyed = true;
        this._fn = null;
        this._context = null;
        if (this.previous) this.previous.next = this.next;
        if (this.next) this.next.previous = this.previous;
        const redirect = this.next;
        this.next = hard ? null : redirect;
        this.previous = null;
        return redirect;
    }
}

});


parcelRegister("7blVu", function(module, exports) {

$parcel$export(module.exports, "detectVideoAlphaMode", () => $1603b82fc2121ba0$export$8df68d58aae31877);
"use strict";
let $1603b82fc2121ba0$var$promise;
async function $1603b82fc2121ba0$export$8df68d58aae31877() {
    $1603b82fc2121ba0$var$promise ?? ($1603b82fc2121ba0$var$promise = (async ()=>{
        const canvas = document.createElement("canvas");
        const gl = canvas.getContext("webgl");
        if (!gl) return "premultiply-alpha-on-upload";
        const video = await new Promise((resolve)=>{
            const video2 = document.createElement("video");
            video2.onloadeddata = ()=>resolve(video2);
            video2.onerror = ()=>resolve(null);
            video2.autoplay = false;
            video2.crossOrigin = "anonymous";
            video2.preload = "auto";
            video2.src = "data:video/webm;base64,GkXfo59ChoEBQveBAULygQRC84EIQoKEd2VibUKHgQJChYECGFOAZwEAAAAAAAHTEU2bdLpNu4tTq4QVSalmU6yBoU27i1OrhBZUrmtTrIHGTbuMU6uEElTDZ1OsggEXTbuMU6uEHFO7a1OsggG97AEAAAAAAABZAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVSalmoCrXsYMPQkBNgIRMYXZmV0GETGF2ZkSJiEBEAAAAAAAAFlSua8yuAQAAAAAAAEPXgQFzxYgAAAAAAAAAAZyBACK1nIN1bmSIgQCGhVZfVlA5g4EBI+ODhAJiWgDglLCBArqBApqBAlPAgQFVsIRVuYEBElTDZ9Vzc9JjwItjxYgAAAAAAAAAAWfInEWjh0VOQ09ERVJEh49MYXZjIGxpYnZweC12cDlnyKJFo4hEVVJBVElPTkSHlDAwOjAwOjAwLjA0MDAwMDAwMAAAH0O2dcfngQCgwqGggQAAAIJJg0IAABAAFgA4JBwYSgAAICAAEb///4r+AAB1oZ2mm+6BAaWWgkmDQgAAEAAWADgkHBhKAAAgIABIQBxTu2uRu4+zgQC3iveBAfGCAXHwgQM=";
            video2.load();
        });
        if (!video) return "premultiply-alpha-on-upload";
        const texture = gl.createTexture();
        gl.bindTexture(gl.TEXTURE_2D, texture);
        const framebuffer = gl.createFramebuffer();
        gl.bindFramebuffer(gl.FRAMEBUFFER, framebuffer);
        gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_2D, texture, 0);
        gl.pixelStorei(gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, false);
        gl.pixelStorei(gl.UNPACK_COLORSPACE_CONVERSION_WEBGL, gl.NONE);
        gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, video);
        const pixel = new Uint8Array(4);
        gl.readPixels(0, 0, 1, 1, gl.RGBA, gl.UNSIGNED_BYTE, pixel);
        gl.deleteFramebuffer(framebuffer);
        gl.deleteTexture(texture);
        gl.getExtension("WEBGL_lose_context")?.loseContext();
        return pixel[0] <= pixel[3] ? "premultiplied-alpha" : "premultiply-alpha-on-upload";
    })());
    return $1603b82fc2121ba0$var$promise;
}

});


parcelRegister("8QN7n", function(module, exports) {

var $2IhKp = parcelRequire("2IhKp");

var $i9BKe = parcelRequire("i9BKe");

var $iA5fe = parcelRequire("iA5fe");

var $bLlTJ = parcelRequire("bLlTJ");
"use strict";
const $da9f248d33f9f2f1$var$sources = [];
(0, $i9BKe.extensions).handleByList((0, $i9BKe.ExtensionType).TextureSource, $da9f248d33f9f2f1$var$sources);
function $da9f248d33f9f2f1$export$688bcf31fbf7eb15(options = {}) {
    return $da9f248d33f9f2f1$var$textureSourceFrom(options);
}
function $da9f248d33f9f2f1$var$textureSourceFrom(options = {}) {
    const hasResource = options && options.resource;
    const res = hasResource ? options.resource : options;
    const opts = hasResource ? options : {
        resource: options
    };
    for(let i = 0; i < $da9f248d33f9f2f1$var$sources.length; i++){
        const Source = $da9f248d33f9f2f1$var$sources[i];
        if (Source.test(res)) return new Source(opts);
    }
    throw new Error(`Could not find a source type for resource: ${opts.resource}`);
}
function $da9f248d33f9f2f1$export$3b748ed6327ec85b(options = {}, skipCache = false) {
    const hasResource = options && options.resource;
    const resource = hasResource ? options.resource : options;
    const opts = hasResource ? options : {
        resource: options
    };
    if (!skipCache && (0, $2IhKp.Cache).has(resource)) return (0, $2IhKp.Cache).get(resource);
    const texture = new (0, $bLlTJ.Texture)({
        source: $da9f248d33f9f2f1$var$textureSourceFrom(opts)
    });
    texture.on("destroy", ()=>{
        if ((0, $2IhKp.Cache).has(resource)) (0, $2IhKp.Cache).remove(resource);
    });
    if (!skipCache) (0, $2IhKp.Cache).set(resource, texture);
    return texture;
}
function $da9f248d33f9f2f1$export$4266177d9730bb1(id, skipCache = false) {
    if (typeof id === "string") return (0, $2IhKp.Cache).get(id);
    else if (id instanceof (0, $iA5fe.TextureSource)) return new (0, $bLlTJ.Texture)({
        source: id
    });
    return $da9f248d33f9f2f1$export$3b748ed6327ec85b(id, skipCache);
}
(0, $bLlTJ.Texture).from = $da9f248d33f9f2f1$export$4266177d9730bb1;
(0, $iA5fe.TextureSource).from = $da9f248d33f9f2f1$var$textureSourceFrom;

});
parcelRegister("2IhKp", function(module, exports) {

$parcel$export(module.exports, "Cache", () => $3d19110becfaeec3$export$94affb487e701bf2);

var $hUCK4 = parcelRequire("hUCK4");

var $3CHiv = parcelRequire("3CHiv");
"use strict";
class $3d19110becfaeec3$var$CacheClass {
    constructor(){
        this._parsers = [];
        this._cache = /* @__PURE__ */ new Map();
        this._cacheMap = /* @__PURE__ */ new Map();
    }
    /** Clear all entries. */ reset() {
        this._cacheMap.clear();
        this._cache.clear();
    }
    /**
   * Check if the key exists
   * @param key - The key to check
   */ has(key) {
        return this._cache.has(key);
    }
    /**
   * Fetch entry by key
   * @param key - The key of the entry to get
   */ get(key) {
        const result = this._cache.get(key);
        if (!result) (0, $hUCK4.warn)(`[Assets] Asset id ${key} was not found in the Cache`);
        return result;
    }
    /**
   * Set a value by key or keys name
   * @param key - The key or keys to set
   * @param value - The value to store in the cache or from which cacheable assets will be derived.
   */ set(key, value) {
        const keys = (0, $3CHiv.convertToList)(key);
        let cacheableAssets;
        for(let i = 0; i < this.parsers.length; i++){
            const parser = this.parsers[i];
            if (parser.test(value)) {
                cacheableAssets = parser.getCacheableAssets(keys, value);
                break;
            }
        }
        const cacheableMap = new Map(Object.entries(cacheableAssets || {}));
        if (!cacheableAssets) keys.forEach((key2)=>{
            cacheableMap.set(key2, value);
        });
        const cacheKeys = [
            ...cacheableMap.keys()
        ];
        const cachedAssets = {
            cacheKeys: cacheKeys,
            keys: keys
        };
        keys.forEach((key2)=>{
            this._cacheMap.set(key2, cachedAssets);
        });
        cacheKeys.forEach((key2)=>{
            const val = cacheableAssets ? cacheableAssets[key2] : value;
            if (this._cache.has(key2) && this._cache.get(key2) !== val) (0, $hUCK4.warn)("[Cache] already has key:", key2);
            this._cache.set(key2, cacheableMap.get(key2));
        });
    }
    /**
   * Remove entry by key
   *
   * This function will also remove any associated alias from the cache also.
   * @param key - The key of the entry to remove
   */ remove(key) {
        if (!this._cacheMap.has(key)) {
            (0, $hUCK4.warn)(`[Assets] Asset id ${key} was not found in the Cache`);
            return;
        }
        const cacheMap = this._cacheMap.get(key);
        const cacheKeys = cacheMap.cacheKeys;
        cacheKeys.forEach((key2)=>{
            this._cache.delete(key2);
        });
        cacheMap.keys.forEach((key2)=>{
            this._cacheMap.delete(key2);
        });
    }
    /** All loader parsers registered */ get parsers() {
        return this._parsers;
    }
}
const $3d19110becfaeec3$export$94affb487e701bf2 = new $3d19110becfaeec3$var$CacheClass();

});
parcelRegister("3CHiv", function(module, exports) {

$parcel$export(module.exports, "convertToList", () => $93954259b3f62d4e$export$b01be8e180bf3d9b);
"use strict";
const $93954259b3f62d4e$export$b01be8e180bf3d9b = (input, transform, forceTransform = false)=>{
    if (!Array.isArray(input)) input = [
        input
    ];
    if (!transform) return input;
    return input.map((item)=>{
        if (typeof item === "string" || forceTransform) return transform(item);
        return item;
    });
};

});




parcelRegister("4RJM2", function(module, exports) {

var $i9BKe = parcelRequire("i9BKe");

var $8PDkK = parcelRequire("8PDkK");
"use strict";
(0, $i9BKe.extensions).add((0, $8PDkK.spritesheetAsset));

});
parcelRegister("8PDkK", function(module, exports) {

$parcel$export(module.exports, "spritesheetAsset", () => $a322641177c54ad8$export$46dcda4f1cdd80fe);

var $iEtN5 = parcelRequire("iEtN5");

var $8kCsw = parcelRequire("8kCsw");

var $5Oad7 = parcelRequire("5Oad7");

var $i9BKe = parcelRequire("i9BKe");

var $bLlTJ = parcelRequire("bLlTJ");

var $lzfZe = parcelRequire("lzfZe");

var $58WFl = parcelRequire("58WFl");
"use strict";
const $a322641177c54ad8$var$validImages = [
    "jpg",
    "png",
    "jpeg",
    "avif",
    "webp",
    "basis",
    "etc2",
    "bc7",
    "bc6h",
    "bc5",
    "bc4",
    "bc3",
    "bc2",
    "bc1",
    "eac",
    "astc"
];
function $a322641177c54ad8$var$getCacheableAssets(keys, asset, ignoreMultiPack) {
    const out = {};
    keys.forEach((key)=>{
        out[key] = asset;
    });
    Object.keys(asset.textures).forEach((key)=>{
        out[key] = asset.textures[key];
    });
    if (!ignoreMultiPack) {
        const basePath = (0, $lzfZe.path).dirname(keys[0]);
        asset.linkedSheets.forEach((item, i)=>{
            const out2 = $a322641177c54ad8$var$getCacheableAssets([
                `${basePath}/${asset.data.meta.related_multi_packs[i]}`
            ], item, true);
            Object.assign(out, out2);
        });
    }
    return out;
}
const $a322641177c54ad8$export$46dcda4f1cdd80fe = {
    extension: (0, $i9BKe.ExtensionType).Asset,
    /** Handle the caching of the related Spritesheet Textures */ cache: {
        test: (asset)=>asset instanceof (0, $58WFl.Spritesheet),
        getCacheableAssets: (keys, asset)=>$a322641177c54ad8$var$getCacheableAssets(keys, asset, false)
    },
    /** Resolve the resolution of the asset. */ resolver: {
        extension: {
            type: (0, $i9BKe.ExtensionType).ResolveParser,
            name: "resolveSpritesheet"
        },
        test: (value)=>{
            const tempURL = value.split("?")[0];
            const split = tempURL.split(".");
            const extension = split.pop();
            const format = split.pop();
            return extension === "json" && $a322641177c54ad8$var$validImages.includes(format);
        },
        parse: (value)=>{
            const split = value.split(".");
            return {
                resolution: parseFloat((0, $8kCsw.Resolver).RETINA_PREFIX.exec(value)?.[1] ?? "1"),
                format: split[split.length - 2],
                src: value
            };
        }
    },
    /**
   * Loader plugin that parses sprite sheets!
   * once the JSON has been loaded this checks to see if the JSON is spritesheet data.
   * If it is, we load the spritesheets image and parse the data into Spritesheet
   * All textures in the sprite sheet are then added to the cache
   */ loader: {
        name: "spritesheetLoader",
        extension: {
            type: (0, $i9BKe.ExtensionType).LoadParser,
            priority: (0, $iEtN5.LoaderParserPriority).Normal,
            name: "spritesheetLoader"
        },
        async testParse (asset, options) {
            return (0, $lzfZe.path).extname(options.src).toLowerCase() === ".json" && !!asset.frames;
        },
        async parse (asset, options, loader) {
            const { texture: imageTexture, imageFilename: // if user need to use preloaded texture
            imageFilename } = options?.data ?? {};
            let basePath = (0, $lzfZe.path).dirname(options.src);
            if (basePath && basePath.lastIndexOf("/") !== basePath.length - 1) basePath += "/";
            let texture;
            if (imageTexture instanceof (0, $bLlTJ.Texture)) texture = imageTexture;
            else {
                const imagePath = (0, $5Oad7.copySearchParams)(basePath + (imageFilename ?? asset.meta.image), options.src);
                const assets = await loader.load([
                    imagePath
                ]);
                texture = assets[imagePath];
            }
            const spritesheet = new (0, $58WFl.Spritesheet)(texture.source, asset);
            await spritesheet.parse();
            const multiPacks = asset?.meta?.related_multi_packs;
            if (Array.isArray(multiPacks)) {
                const promises = [];
                for (const item of multiPacks){
                    if (typeof item !== "string") continue;
                    let itemUrl = basePath + item;
                    if (options.data?.ignoreMultiPack) continue;
                    itemUrl = (0, $5Oad7.copySearchParams)(itemUrl, options.src);
                    promises.push(loader.load({
                        src: itemUrl,
                        data: {
                            ignoreMultiPack: true
                        }
                    }));
                }
                const res = await Promise.all(promises);
                spritesheet.linkedSheets = res;
                res.forEach((item)=>{
                    item.linkedSheets = [
                        spritesheet
                    ].concat(spritesheet.linkedSheets.filter((sp)=>sp !== item));
                });
            }
            return spritesheet;
        },
        async unload (spritesheet, _resolvedAsset, loader) {
            await loader.unload(spritesheet.textureSource._sourceOrigin);
            spritesheet.destroy(false);
        }
    }
};

});
parcelRegister("iEtN5", function(module, exports) {

$parcel$export(module.exports, "LoaderParserPriority", () => $29ed14ceb032dea6$export$820ed6348c4f2750);
"use strict";
var $29ed14ceb032dea6$export$820ed6348c4f2750 = /* @__PURE__ */ ((LoaderParserPriority2)=>{
    LoaderParserPriority2[LoaderParserPriority2["Low"] = 0] = "Low";
    LoaderParserPriority2[LoaderParserPriority2["Normal"] = 1] = "Normal";
    LoaderParserPriority2[LoaderParserPriority2["High"] = 2] = "High";
    return LoaderParserPriority2;
})($29ed14ceb032dea6$export$820ed6348c4f2750 || {});

});

parcelRegister("8kCsw", function(module, exports) {

$parcel$export(module.exports, "Resolver", () => $23cc1cafdfe05125$export$8b4c839865b08288);

var $hUCK4 = parcelRequire("hUCK4");

var $lzfZe = parcelRequire("lzfZe");

var $3CHiv = parcelRequire("3CHiv");

var $8F3vm = parcelRequire("8F3vm");

var $4DmkB = parcelRequire("4DmkB");
"use strict";
class $23cc1cafdfe05125$export$8b4c839865b08288 {
    constructor(){
        this._defaultBundleIdentifierOptions = {
            connector: "-",
            createBundleAssetId: (bundleId, assetId)=>`${bundleId}${this._bundleIdConnector}${assetId}`,
            extractAssetIdFromBundle: (bundleId, assetBundleId)=>assetBundleId.replace(`${bundleId}${this._bundleIdConnector}`, "")
        };
        /** The character that is used to connect the bundleId and the assetId when generating a bundle asset id key */ this._bundleIdConnector = this._defaultBundleIdentifierOptions.connector;
        /**
     * A function that generates a bundle asset id key from a bundleId and an assetId
     * @param bundleId - the bundleId
     * @param assetId  - the assetId
     * @returns the bundle asset id key
     */ this._createBundleAssetId = this._defaultBundleIdentifierOptions.createBundleAssetId;
        /**
     * A function that generates an assetId from a bundle asset id key. This is the reverse of generateBundleAssetId
     * @param bundleId - the bundleId
     * @param assetBundleId - the bundle asset id key
     * @returns the assetId
     */ this._extractAssetIdFromBundle = this._defaultBundleIdentifierOptions.extractAssetIdFromBundle;
        this._assetMap = {};
        this._preferredOrder = [];
        this._parsers = [];
        this._resolverHash = {};
        this._bundles = {};
    }
    /**
   * Override how the resolver deals with generating bundle ids.
   * must be called before any bundles are added
   * @param bundleIdentifier - the bundle identifier options
   */ setBundleIdentifier(bundleIdentifier) {
        this._bundleIdConnector = bundleIdentifier.connector ?? this._bundleIdConnector;
        this._createBundleAssetId = bundleIdentifier.createBundleAssetId ?? this._createBundleAssetId;
        this._extractAssetIdFromBundle = bundleIdentifier.extractAssetIdFromBundle ?? this._extractAssetIdFromBundle;
        if (this._extractAssetIdFromBundle("foo", this._createBundleAssetId("foo", "bar")) !== "bar") throw new Error("[Resolver] GenerateBundleAssetId are not working correctly");
    }
    /**
   * Let the resolver know which assets you prefer to use when resolving assets.
   * Multiple prefer user defined rules can be added.
   * @example
   * resolver.prefer({
   *     // first look for something with the correct format, and then then correct resolution
   *     priority: ['format', 'resolution'],
   *     params:{
   *         format:'webp', // prefer webp images
   *         resolution: 2, // prefer a resolution of 2
   *     }
   * })
   * resolver.add('foo', ['bar@2x.webp', 'bar@2x.png', 'bar.webp', 'bar.png']);
   * resolver.resolveUrl('foo') // => 'bar@2x.webp'
   * @param preferOrders - the prefer options
   */ prefer(...preferOrders) {
        preferOrders.forEach((prefer)=>{
            this._preferredOrder.push(prefer);
            if (!prefer.priority) prefer.priority = Object.keys(prefer.params);
        });
        this._resolverHash = {};
    }
    /**
   * Set the base path to prepend to all urls when resolving
   * @example
   * resolver.basePath = 'https://home.com/';
   * resolver.add('foo', 'bar.ong');
   * resolver.resolveUrl('foo', 'bar.png'); // => 'https://home.com/bar.png'
   * @param basePath - the base path to use
   */ set basePath(basePath) {
        this._basePath = basePath;
    }
    get basePath() {
        return this._basePath;
    }
    /**
   * Set the root path for root-relative URLs. By default the `basePath`'s root is used. If no `basePath` is set, then the
   * default value for browsers is `window.location.origin`
   * @example
   * // Application hosted on https://home.com/some-path/index.html
   * resolver.basePath = 'https://home.com/some-path/';
   * resolver.rootPath = 'https://home.com/';
   * resolver.add('foo', '/bar.png');
   * resolver.resolveUrl('foo', '/bar.png'); // => 'https://home.com/bar.png'
   * @param rootPath - the root path to use
   */ set rootPath(rootPath) {
        this._rootPath = rootPath;
    }
    get rootPath() {
        return this._rootPath;
    }
    /**
   * All the active URL parsers that help the parser to extract information and create
   * an asset object-based on parsing the URL itself.
   *
   * Can be added using the extensions API
   * @example
   * resolver.add('foo', [
   *     {
   *         resolution: 2,
   *         format: 'png',
   *         src: 'image@2x.png',
   *     },
   *     {
   *         resolution:1,
   *         format:'png',
   *         src: 'image.png',
   *     },
   * ]);
   *
   * // With a url parser the information such as resolution and file format could extracted from the url itself:
   * extensions.add({
   *     extension: ExtensionType.ResolveParser,
   *     test: loadTextures.test, // test if url ends in an image
   *     parse: (value: string) =>
   *     ({
   *         resolution: parseFloat(Resolver.RETINA_PREFIX.exec(value)?.[1] ?? '1'),
   *         format: value.split('.').pop(),
   *         src: value,
   *     }),
   * });
   *
   * // Now resolution and format can be extracted from the url
   * resolver.add('foo', [
   *     'image@2x.png',
   *     'image.png',
   * ]);
   */ get parsers() {
        return this._parsers;
    }
    /** Used for testing, this resets the resolver to its initial state */ reset() {
        this.setBundleIdentifier(this._defaultBundleIdentifierOptions);
        this._assetMap = {};
        this._preferredOrder = [];
        this._resolverHash = {};
        this._rootPath = null;
        this._basePath = null;
        this._manifest = null;
        this._bundles = {};
        this._defaultSearchParams = null;
    }
    /**
   * Sets the default URL search parameters for the URL resolver. The urls can be specified as a string or an object.
   * @param searchParams - the default url parameters to append when resolving urls
   */ setDefaultSearchParams(searchParams) {
        if (typeof searchParams === "string") this._defaultSearchParams = searchParams;
        else {
            const queryValues = searchParams;
            this._defaultSearchParams = Object.keys(queryValues).map((key)=>`${encodeURIComponent(key)}=${encodeURIComponent(queryValues[key])}`).join("&");
        }
    }
    /**
   * Returns the aliases for a given asset
   * @param asset - the asset to get the aliases for
   */ getAlias(asset) {
        const { alias: alias, src: src } = asset;
        const aliasesToUse = (0, $3CHiv.convertToList)(alias || src, (value)=>{
            if (typeof value === "string") return value;
            if (Array.isArray(value)) return value.map((v)=>v?.src ?? v);
            if (value?.src) return value.src;
            return value;
        }, true);
        return aliasesToUse;
    }
    /**
   * Add a manifest to the asset resolver. This is a nice way to add all the asset information in one go.
   * generally a manifest would be built using a tool.
   * @param manifest - the manifest to add to the resolver
   */ addManifest(manifest) {
        if (this._manifest) (0, $hUCK4.warn)("[Resolver] Manifest already exists, this will be overwritten");
        this._manifest = manifest;
        manifest.bundles.forEach((bundle)=>{
            this.addBundle(bundle.name, bundle.assets);
        });
    }
    /**
   * This adds a bundle of assets in one go so that you can resolve them as a group.
   * For example you could add a bundle for each screen in you pixi app
   * @example
   * resolver.addBundle('animals', [
   *  { alias: 'bunny', src: 'bunny.png' },
   *  { alias: 'chicken', src: 'chicken.png' },
   *  { alias: 'thumper', src: 'thumper.png' },
   * ]);
   * // or
   * resolver.addBundle('animals', {
   *     bunny: 'bunny.png',
   *     chicken: 'chicken.png',
   *     thumper: 'thumper.png',
   * });
   *
   * const resolvedAssets = await resolver.resolveBundle('animals');
   * @param bundleId - The id of the bundle to add
   * @param assets - A record of the asset or assets that will be chosen from when loading via the specified key
   */ addBundle(bundleId, assets) {
        const assetNames = [];
        let convertedAssets = assets;
        if (!Array.isArray(assets)) convertedAssets = Object.entries(assets).map(([alias, src])=>{
            if (typeof src === "string" || Array.isArray(src)) return {
                alias: alias,
                src: src
            };
            return {
                alias: alias,
                ...src
            };
        });
        convertedAssets.forEach((asset)=>{
            const srcs = asset.src;
            const aliases = asset.alias;
            let ids;
            if (typeof aliases === "string") {
                const bundleAssetId = this._createBundleAssetId(bundleId, aliases);
                assetNames.push(bundleAssetId);
                ids = [
                    aliases,
                    bundleAssetId
                ];
            } else {
                const bundleIds = aliases.map((name)=>this._createBundleAssetId(bundleId, name));
                assetNames.push(...bundleIds);
                ids = [
                    ...aliases,
                    ...bundleIds
                ];
            }
            this.add({
                ...asset,
                alias: ids,
                src: srcs
            });
        });
        this._bundles[bundleId] = assetNames;
    }
    /**
   * Tells the resolver what keys are associated with witch asset.
   * The most important thing the resolver does
   * @example
   * // Single key, single asset:
   * resolver.add({alias: 'foo', src: 'bar.png');
   * resolver.resolveUrl('foo') // => 'bar.png'
   *
   * // Multiple keys, single asset:
   * resolver.add({alias: ['foo', 'boo'], src: 'bar.png'});
   * resolver.resolveUrl('foo') // => 'bar.png'
   * resolver.resolveUrl('boo') // => 'bar.png'
   *
   * // Multiple keys, multiple assets:
   * resolver.add({alias: ['foo', 'boo'], src: ['bar.png', 'bar.webp']});
   * resolver.resolveUrl('foo') // => 'bar.png'
   *
   * // Add custom data attached to the resolver
   * Resolver.add({
   *     alias: 'bunnyBooBooSmooth',
   *     src: 'bunny{png,webp}',
   *     data: { scaleMode:SCALE_MODES.NEAREST }, // Base texture options
   * });
   *
   * resolver.resolve('bunnyBooBooSmooth') // => { src: 'bunny.png', data: { scaleMode: SCALE_MODES.NEAREST } }
   * @param aliases - the UnresolvedAsset or array of UnresolvedAssets to add to the resolver
   */ add(aliases) {
        const assets = [];
        if (Array.isArray(aliases)) assets.push(...aliases);
        else assets.push(aliases);
        let keyCheck;
        keyCheck = (key)=>{
            if (this.hasKey(key)) (0, $hUCK4.warn)(`[Resolver] already has key: ${key} overwriting`);
        };
        const assetArray = (0, $3CHiv.convertToList)(assets);
        assetArray.forEach((asset)=>{
            const { src: src } = asset;
            let { data: data, format: format, loadParser: loadParser } = asset;
            const srcsToUse = (0, $3CHiv.convertToList)(src).map((src2)=>{
                if (typeof src2 === "string") return (0, $8F3vm.createStringVariations)(src2);
                return Array.isArray(src2) ? src2 : [
                    src2
                ];
            });
            const aliasesToUse = this.getAlias(asset);
            Array.isArray(aliasesToUse) ? aliasesToUse.forEach(keyCheck) : keyCheck(aliasesToUse);
            const resolvedAssets = [];
            srcsToUse.forEach((srcs)=>{
                srcs.forEach((src2)=>{
                    let formattedAsset = {};
                    if (typeof src2 !== "object") {
                        formattedAsset.src = src2;
                        for(let i = 0; i < this._parsers.length; i++){
                            const parser = this._parsers[i];
                            if (parser.test(src2)) {
                                formattedAsset = parser.parse(src2);
                                break;
                            }
                        }
                    } else {
                        data = src2.data ?? data;
                        format = src2.format ?? format;
                        loadParser = src2.loadParser ?? loadParser;
                        formattedAsset = {
                            ...formattedAsset,
                            ...src2
                        };
                    }
                    if (!aliasesToUse) throw new Error(`[Resolver] alias is undefined for this asset: ${formattedAsset.src}`);
                    formattedAsset = this._buildResolvedAsset(formattedAsset, {
                        aliases: aliasesToUse,
                        data: data,
                        format: format,
                        loadParser: loadParser
                    });
                    resolvedAssets.push(formattedAsset);
                });
            });
            aliasesToUse.forEach((alias)=>{
                this._assetMap[alias] = resolvedAssets;
            });
        });
    }
    // TODO: this needs an overload like load did in Assets
    /**
   * If the resolver has had a manifest set via setManifest, this will return the assets urls for
   * a given bundleId or bundleIds.
   * @example
   * // Manifest Example
   * const manifest = {
   *     bundles: [
   *         {
   *             name: 'load-screen',
   *             assets: [
   *                 {
   *                     alias: 'background',
   *                     src: 'sunset.png',
   *                 },
   *                 {
   *                     alias: 'bar',
   *                     src: 'load-bar.{png,webp}',
   *                 },
   *             ],
   *         },
   *         {
   *             name: 'game-screen',
   *             assets: [
   *                 {
   *                     alias: 'character',
   *                     src: 'robot.png',
   *                 },
   *                 {
   *                     alias: 'enemy',
   *                     src: 'bad-guy.png',
   *                 },
   *             ],
   *         },
   *     ]
   * };
   *
   * resolver.setManifest(manifest);
   * const resolved = resolver.resolveBundle('load-screen');
   * @param bundleIds - The bundle ids to resolve
   * @returns All the bundles assets or a hash of assets for each bundle specified
   */ resolveBundle(bundleIds) {
        const singleAsset = (0, $4DmkB.isSingleItem)(bundleIds);
        bundleIds = (0, $3CHiv.convertToList)(bundleIds);
        const out = {};
        bundleIds.forEach((bundleId)=>{
            const assetNames = this._bundles[bundleId];
            if (assetNames) {
                const results = this.resolve(assetNames);
                const assets = {};
                for(const key in results){
                    const asset = results[key];
                    assets[this._extractAssetIdFromBundle(bundleId, key)] = asset;
                }
                out[bundleId] = assets;
            }
        });
        return singleAsset ? out[bundleIds[0]] : out;
    }
    /**
   * Does exactly what resolve does, but returns just the URL rather than the whole asset object
   * @param key - The key or keys to resolve
   * @returns - The URLs associated with the key(s)
   */ resolveUrl(key) {
        const result = this.resolve(key);
        if (typeof key !== "string") {
            const out = {};
            for(const i in result)out[i] = result[i].src;
            return out;
        }
        return result.src;
    }
    resolve(keys) {
        const singleAsset = (0, $4DmkB.isSingleItem)(keys);
        keys = (0, $3CHiv.convertToList)(keys);
        const result = {};
        keys.forEach((key)=>{
            if (!this._resolverHash[key]) {
                if (this._assetMap[key]) {
                    let assets = this._assetMap[key];
                    const preferredOrder = this._getPreferredOrder(assets);
                    preferredOrder?.priority.forEach((priorityKey)=>{
                        preferredOrder.params[priorityKey].forEach((value)=>{
                            const filteredAssets = assets.filter((asset)=>{
                                if (asset[priorityKey]) return asset[priorityKey] === value;
                                return false;
                            });
                            if (filteredAssets.length) assets = filteredAssets;
                        });
                    });
                    this._resolverHash[key] = assets[0];
                } else this._resolverHash[key] = this._buildResolvedAsset({
                    alias: [
                        key
                    ],
                    src: key
                }, {});
            }
            result[key] = this._resolverHash[key];
        });
        return singleAsset ? result[keys[0]] : result;
    }
    /**
   * Checks if an asset with a given key exists in the resolver
   * @param key - The key of the asset
   */ hasKey(key) {
        return !!this._assetMap[key];
    }
    /**
   * Checks if a bundle with the given key exists in the resolver
   * @param key - The key of the bundle
   */ hasBundle(key) {
        return !!this._bundles[key];
    }
    /**
   * Internal function for figuring out what prefer criteria an asset should use.
   * @param assets
   */ _getPreferredOrder(assets) {
        for(let i = 0; i < assets.length; i++){
            const asset = assets[0];
            const preferred = this._preferredOrder.find((preference)=>preference.params.format.includes(asset.format));
            if (preferred) return preferred;
        }
        return this._preferredOrder[0];
    }
    /**
   * Appends the default url parameters to the url
   * @param url - The url to append the default parameters to
   * @returns - The url with the default parameters appended
   */ _appendDefaultSearchParams(url) {
        if (!this._defaultSearchParams) return url;
        const paramConnector = /\?/.test(url) ? "&" : "?";
        return `${url}${paramConnector}${this._defaultSearchParams}`;
    }
    _buildResolvedAsset(formattedAsset, data) {
        const { aliases: aliases, data: assetData, loadParser: loadParser, format: format } = data;
        if (this._basePath || this._rootPath) formattedAsset.src = (0, $lzfZe.path).toAbsolute(formattedAsset.src, this._basePath, this._rootPath);
        formattedAsset.alias = aliases ?? formattedAsset.alias ?? [
            formattedAsset.src
        ];
        formattedAsset.src = this._appendDefaultSearchParams(formattedAsset.src);
        formattedAsset.data = {
            ...assetData || {},
            ...formattedAsset.data
        };
        formattedAsset.loadParser = loadParser ?? formattedAsset.loadParser;
        formattedAsset.format = format ?? formattedAsset.format ?? $23cc1cafdfe05125$export$4bb0ea38086a2ed5(formattedAsset.src);
        return formattedAsset;
    }
}
/**
 * The prefix that denotes a URL is for a retina asset.
 * @static
 * @name RETINA_PREFIX
 * @type {RegExp}
 * @default /@([0-9\.]+)x/
 * @example `@2x`
 */ $23cc1cafdfe05125$export$8b4c839865b08288.RETINA_PREFIX = /@([0-9\.]+)x/;
function $23cc1cafdfe05125$export$4bb0ea38086a2ed5(url) {
    return url.split(".").pop().split("?").shift().split("#").shift();
}

});
parcelRegister("lzfZe", function(module, exports) {

$parcel$export(module.exports, "path", () => $3c67d20d89e3898c$export$bb654e07daaf8c3a);

var $iCGeI = parcelRequire("iCGeI");
"use strict";
function $3c67d20d89e3898c$var$assertPath(path2) {
    if (typeof path2 !== "string") throw new TypeError(`Path must be a string. Received ${JSON.stringify(path2)}`);
}
function $3c67d20d89e3898c$var$removeUrlParams(url) {
    const re = url.split("?")[0];
    return re.split("#")[0];
}
function $3c67d20d89e3898c$var$escapeRegExp(string) {
    return string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
function $3c67d20d89e3898c$var$replaceAll(str, find, replace) {
    return str.replace(new RegExp($3c67d20d89e3898c$var$escapeRegExp(find), "g"), replace);
}
function $3c67d20d89e3898c$var$normalizeStringPosix(path2, allowAboveRoot) {
    let res = "";
    let lastSegmentLength = 0;
    let lastSlash = -1;
    let dots = 0;
    let code = -1;
    for(let i = 0; i <= path2.length; ++i){
        if (i < path2.length) code = path2.charCodeAt(i);
        else if (code === 47) break;
        else code = 47;
        if (code === 47) {
            if (lastSlash === i - 1 || dots === 1) ;
            else if (lastSlash !== i - 1 && dots === 2) {
                if (res.length < 2 || lastSegmentLength !== 2 || res.charCodeAt(res.length - 1) !== 46 || res.charCodeAt(res.length - 2) !== 46) {
                    if (res.length > 2) {
                        const lastSlashIndex = res.lastIndexOf("/");
                        if (lastSlashIndex !== res.length - 1) {
                            if (lastSlashIndex === -1) {
                                res = "";
                                lastSegmentLength = 0;
                            } else {
                                res = res.slice(0, lastSlashIndex);
                                lastSegmentLength = res.length - 1 - res.lastIndexOf("/");
                            }
                            lastSlash = i;
                            dots = 0;
                            continue;
                        }
                    } else if (res.length === 2 || res.length === 1) {
                        res = "";
                        lastSegmentLength = 0;
                        lastSlash = i;
                        dots = 0;
                        continue;
                    }
                }
                if (allowAboveRoot) {
                    if (res.length > 0) res += "/..";
                    else res = "..";
                    lastSegmentLength = 2;
                }
            } else {
                if (res.length > 0) res += `/${path2.slice(lastSlash + 1, i)}`;
                else res = path2.slice(lastSlash + 1, i);
                lastSegmentLength = i - lastSlash - 1;
            }
            lastSlash = i;
            dots = 0;
        } else if (code === 46 && dots !== -1) ++dots;
        else dots = -1;
    }
    return res;
}
const $3c67d20d89e3898c$export$bb654e07daaf8c3a = {
    /**
   * Converts a path to posix format.
   * @param path - The path to convert to posix
   */ toPosix (path2) {
        return $3c67d20d89e3898c$var$replaceAll(path2, "\\", "/");
    },
    /**
   * Checks if the path is a URL e.g. http://, https://
   * @param path - The path to check
   */ isUrl (path2) {
        return /^https?:/.test(this.toPosix(path2));
    },
    /**
   * Checks if the path is a data URL
   * @param path - The path to check
   */ isDataUrl (path2) {
        return /^data:([a-z]+\/[a-z0-9-+.]+(;[a-z0-9-.!#$%*+.{}|~`]+=[a-z0-9-.!#$%*+.{}()_|~`]+)*)?(;base64)?,([a-z0-9!$&',()*+;=\-._~:@\/?%\s<>]*?)$/i.test(path2);
    },
    /**
   * Checks if the path is a blob URL
   * @param path - The path to check
   */ isBlobUrl (path2) {
        return path2.startsWith("blob:");
    },
    /**
   * Checks if the path has a protocol e.g. http://, https://, file:///, data:, blob:, C:/
   * This will return true for windows file paths
   * @param path - The path to check
   */ hasProtocol (path2) {
        return /^[^/:]+:/.test(this.toPosix(path2));
    },
    /**
   * Returns the protocol of the path e.g. http://, https://, file:///, data:, blob:, C:/
   * @param path - The path to get the protocol from
   */ getProtocol (path2) {
        $3c67d20d89e3898c$var$assertPath(path2);
        path2 = this.toPosix(path2);
        const matchFile = /^file:\/\/\//.exec(path2);
        if (matchFile) return matchFile[0];
        const matchProtocol = /^[^/:]+:\/{0,2}/.exec(path2);
        if (matchProtocol) return matchProtocol[0];
        return "";
    },
    /**
   * Converts URL to an absolute path.
   * When loading from a Web Worker, we must use absolute paths.
   * If the URL is already absolute we return it as is
   * If it's not, we convert it
   * @param url - The URL to test
   * @param customBaseUrl - The base URL to use
   * @param customRootUrl - The root URL to use
   */ toAbsolute (url, customBaseUrl, customRootUrl) {
        $3c67d20d89e3898c$var$assertPath(url);
        if (this.isDataUrl(url) || this.isBlobUrl(url)) return url;
        const baseUrl = $3c67d20d89e3898c$var$removeUrlParams(this.toPosix(customBaseUrl ?? (0, $iCGeI.DOMAdapter).get().getBaseUrl()));
        const rootUrl = $3c67d20d89e3898c$var$removeUrlParams(this.toPosix(customRootUrl ?? this.rootname(baseUrl)));
        url = this.toPosix(url);
        if (url.startsWith("/")) return $3c67d20d89e3898c$export$bb654e07daaf8c3a.join(rootUrl, url.slice(1));
        const absolutePath = this.isAbsolute(url) ? url : this.join(baseUrl, url);
        return absolutePath;
    },
    /**
   * Normalizes the given path, resolving '..' and '.' segments
   * @param path - The path to normalize
   */ normalize (path2) {
        $3c67d20d89e3898c$var$assertPath(path2);
        if (path2.length === 0) return ".";
        if (this.isDataUrl(path2) || this.isBlobUrl(path2)) return path2;
        path2 = this.toPosix(path2);
        let protocol = "";
        const isAbsolute = path2.startsWith("/");
        if (this.hasProtocol(path2)) {
            protocol = this.rootname(path2);
            path2 = path2.slice(protocol.length);
        }
        const trailingSeparator = path2.endsWith("/");
        path2 = $3c67d20d89e3898c$var$normalizeStringPosix(path2, false);
        if (path2.length > 0 && trailingSeparator) path2 += "/";
        if (isAbsolute) return `/${path2}`;
        return protocol + path2;
    },
    /**
   * Determines if path is an absolute path.
   * Absolute paths can be urls, data urls, or paths on disk
   * @param path - The path to test
   */ isAbsolute (path2) {
        $3c67d20d89e3898c$var$assertPath(path2);
        path2 = this.toPosix(path2);
        if (this.hasProtocol(path2)) return true;
        return path2.startsWith("/");
    },
    /**
   * Joins all given path segments together using the platform-specific separator as a delimiter,
   * then normalizes the resulting path
   * @param segments - The segments of the path to join
   */ join (...segments) {
        if (segments.length === 0) return ".";
        let joined;
        for(let i = 0; i < segments.length; ++i){
            const arg = segments[i];
            $3c67d20d89e3898c$var$assertPath(arg);
            if (arg.length > 0) {
                if (joined === void 0) joined = arg;
                else {
                    const prevArg = segments[i - 1] ?? "";
                    if (this.joinExtensions.includes(this.extname(prevArg).toLowerCase())) joined += `/../${arg}`;
                    else joined += `/${arg}`;
                }
            }
        }
        if (joined === void 0) return ".";
        return this.normalize(joined);
    },
    /**
   * Returns the directory name of a path
   * @param path - The path to parse
   */ dirname (path2) {
        $3c67d20d89e3898c$var$assertPath(path2);
        if (path2.length === 0) return ".";
        path2 = this.toPosix(path2);
        let code = path2.charCodeAt(0);
        const hasRoot = code === 47;
        let end = -1;
        let matchedSlash = true;
        const proto = this.getProtocol(path2);
        const origpath = path2;
        path2 = path2.slice(proto.length);
        for(let i = path2.length - 1; i >= 1; --i){
            code = path2.charCodeAt(i);
            if (code === 47) {
                if (!matchedSlash) {
                    end = i;
                    break;
                }
            } else matchedSlash = false;
        }
        if (end === -1) return hasRoot ? "/" : this.isUrl(origpath) ? proto + path2 : proto;
        if (hasRoot && end === 1) return "//";
        return proto + path2.slice(0, end);
    },
    /**
   * Returns the root of the path e.g. /, C:/, file:///, http://domain.com/
   * @param path - The path to parse
   */ rootname (path2) {
        $3c67d20d89e3898c$var$assertPath(path2);
        path2 = this.toPosix(path2);
        let root = "";
        if (path2.startsWith("/")) root = "/";
        else root = this.getProtocol(path2);
        if (this.isUrl(path2)) {
            const index = path2.indexOf("/", root.length);
            if (index !== -1) root = path2.slice(0, index);
            else root = path2;
            if (!root.endsWith("/")) root += "/";
        }
        return root;
    },
    /**
   * Returns the last portion of a path
   * @param path - The path to test
   * @param ext - Optional extension to remove
   */ basename (path2, ext) {
        $3c67d20d89e3898c$var$assertPath(path2);
        if (ext) $3c67d20d89e3898c$var$assertPath(ext);
        path2 = $3c67d20d89e3898c$var$removeUrlParams(this.toPosix(path2));
        let start = 0;
        let end = -1;
        let matchedSlash = true;
        let i;
        if (ext !== void 0 && ext.length > 0 && ext.length <= path2.length) {
            if (ext.length === path2.length && ext === path2) return "";
            let extIdx = ext.length - 1;
            let firstNonSlashEnd = -1;
            for(i = path2.length - 1; i >= 0; --i){
                const code = path2.charCodeAt(i);
                if (code === 47) {
                    if (!matchedSlash) {
                        start = i + 1;
                        break;
                    }
                } else {
                    if (firstNonSlashEnd === -1) {
                        matchedSlash = false;
                        firstNonSlashEnd = i + 1;
                    }
                    if (extIdx >= 0) {
                        if (code === ext.charCodeAt(extIdx)) {
                            if (--extIdx === -1) end = i;
                        } else {
                            extIdx = -1;
                            end = firstNonSlashEnd;
                        }
                    }
                }
            }
            if (start === end) end = firstNonSlashEnd;
            else if (end === -1) end = path2.length;
            return path2.slice(start, end);
        }
        for(i = path2.length - 1; i >= 0; --i){
            if (path2.charCodeAt(i) === 47) {
                if (!matchedSlash) {
                    start = i + 1;
                    break;
                }
            } else if (end === -1) {
                matchedSlash = false;
                end = i + 1;
            }
        }
        if (end === -1) return "";
        return path2.slice(start, end);
    },
    /**
   * Returns the extension of the path, from the last occurrence of the . (period) character to end of string in the last
   * portion of the path. If there is no . in the last portion of the path, or if there are no . characters other than
   * the first character of the basename of path, an empty string is returned.
   * @param path - The path to parse
   */ extname (path2) {
        $3c67d20d89e3898c$var$assertPath(path2);
        path2 = $3c67d20d89e3898c$var$removeUrlParams(this.toPosix(path2));
        let startDot = -1;
        let startPart = 0;
        let end = -1;
        let matchedSlash = true;
        let preDotState = 0;
        for(let i = path2.length - 1; i >= 0; --i){
            const code = path2.charCodeAt(i);
            if (code === 47) {
                if (!matchedSlash) {
                    startPart = i + 1;
                    break;
                }
                continue;
            }
            if (end === -1) {
                matchedSlash = false;
                end = i + 1;
            }
            if (code === 46) {
                if (startDot === -1) startDot = i;
                else if (preDotState !== 1) preDotState = 1;
            } else if (startDot !== -1) preDotState = -1;
        }
        if (startDot === -1 || end === -1 || preDotState === 0 || preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) return "";
        return path2.slice(startDot, end);
    },
    /**
   * Parses a path into an object containing the 'root', `dir`, `base`, `ext`, and `name` properties.
   * @param path - The path to parse
   */ parse (path2) {
        $3c67d20d89e3898c$var$assertPath(path2);
        const ret = {
            root: "",
            dir: "",
            base: "",
            ext: "",
            name: ""
        };
        if (path2.length === 0) return ret;
        path2 = $3c67d20d89e3898c$var$removeUrlParams(this.toPosix(path2));
        let code = path2.charCodeAt(0);
        const isAbsolute = this.isAbsolute(path2);
        let start;
        const protocol = "";
        ret.root = this.rootname(path2);
        if (isAbsolute || this.hasProtocol(path2)) start = 1;
        else start = 0;
        let startDot = -1;
        let startPart = 0;
        let end = -1;
        let matchedSlash = true;
        let i = path2.length - 1;
        let preDotState = 0;
        for(; i >= start; --i){
            code = path2.charCodeAt(i);
            if (code === 47) {
                if (!matchedSlash) {
                    startPart = i + 1;
                    break;
                }
                continue;
            }
            if (end === -1) {
                matchedSlash = false;
                end = i + 1;
            }
            if (code === 46) {
                if (startDot === -1) startDot = i;
                else if (preDotState !== 1) preDotState = 1;
            } else if (startDot !== -1) preDotState = -1;
        }
        if (startDot === -1 || end === -1 || preDotState === 0 || preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) {
            if (end !== -1) {
                if (startPart === 0 && isAbsolute) ret.base = ret.name = path2.slice(1, end);
                else ret.base = ret.name = path2.slice(startPart, end);
            }
        } else {
            if (startPart === 0 && isAbsolute) {
                ret.name = path2.slice(1, startDot);
                ret.base = path2.slice(1, end);
            } else {
                ret.name = path2.slice(startPart, startDot);
                ret.base = path2.slice(startPart, end);
            }
            ret.ext = path2.slice(startDot, end);
        }
        ret.dir = this.dirname(path2);
        if (protocol) ret.dir = protocol + ret.dir;
        return ret;
    },
    sep: "/",
    delimiter: ":",
    joinExtensions: [
        ".html"
    ]
};

});

parcelRegister("8F3vm", function(module, exports) {

$parcel$export(module.exports, "createStringVariations", () => $fde1bf5bcf60c2d9$export$738117acc6638004);
"use strict";
function $fde1bf5bcf60c2d9$var$processX(base, ids, depth, result, tags) {
    const id = ids[depth];
    for(let i = 0; i < id.length; i++){
        const value = id[i];
        if (depth < ids.length - 1) $fde1bf5bcf60c2d9$var$processX(base.replace(result[depth], value), ids, depth + 1, result, tags);
        else tags.push(base.replace(result[depth], value));
    }
}
function $fde1bf5bcf60c2d9$export$738117acc6638004(string) {
    const regex = /\{(.*?)\}/g;
    const result = string.match(regex);
    const tags = [];
    if (result) {
        const ids = [];
        result.forEach((vars)=>{
            const split = vars.substring(1, vars.length - 1).split(",");
            ids.push(split);
        });
        $fde1bf5bcf60c2d9$var$processX(string, ids, 0, result, tags);
    } else tags.push(string);
    return tags;
}

});

parcelRegister("4DmkB", function(module, exports) {

$parcel$export(module.exports, "isSingleItem", () => $f373b2ad881b3255$export$16a80d27953452d4);
"use strict";
const $f373b2ad881b3255$export$16a80d27953452d4 = (item)=>!Array.isArray(item);

});


parcelRegister("5Oad7", function(module, exports) {

$parcel$export(module.exports, "copySearchParams", () => $273b4a26d8a43536$export$f57b97ef8be10dda);
"use strict";
const $273b4a26d8a43536$export$f57b97ef8be10dda = (targetUrl, sourceUrl)=>{
    const searchParams = sourceUrl.split("?")[1];
    if (searchParams) targetUrl += `?${searchParams}`;
    return targetUrl;
};

});

parcelRegister("58WFl", function(module, exports) {

$parcel$export(module.exports, "Spritesheet", () => $9c38ec259f91df14$export$674d2eb4debbef0c);

var $fM4Mk = parcelRequire("fM4Mk");

var $bLlTJ = parcelRequire("bLlTJ");
"use strict";
const $9c38ec259f91df14$var$_Spritesheet = class _Spritesheet {
    /**
   * @param texture - Reference to the source BaseTexture object.
   * @param {object} data - Spritesheet image data.
   */ constructor(texture, data){
        /** For multi-packed spritesheets, this contains a reference to all the other spritesheets it depends on. */ this.linkedSheets = [];
        this._texture = texture instanceof (0, $bLlTJ.Texture) ? texture : null;
        this.textureSource = texture.source;
        this.textures = {};
        this.animations = {};
        this.data = data;
        const metaResolution = parseFloat(data.meta.scale);
        if (metaResolution) {
            this.resolution = metaResolution;
            texture.source.resolution = this.resolution;
        } else this.resolution = texture.source._resolution;
        this._frames = this.data.frames;
        this._frameKeys = Object.keys(this._frames);
        this._batchIndex = 0;
        this._callback = null;
    }
    /**
   * Parser spritesheet from loaded data. This is done asynchronously
   * to prevent creating too many Texture within a single process.
   */ parse() {
        return new Promise((resolve)=>{
            this._callback = resolve;
            this._batchIndex = 0;
            if (this._frameKeys.length <= _Spritesheet.BATCH_SIZE) {
                this._processFrames(0);
                this._processAnimations();
                this._parseComplete();
            } else this._nextBatch();
        });
    }
    /**
   * Process a batch of frames
   * @param initialFrameIndex - The index of frame to start.
   */ _processFrames(initialFrameIndex) {
        let frameIndex = initialFrameIndex;
        const maxFrames = _Spritesheet.BATCH_SIZE;
        while(frameIndex - initialFrameIndex < maxFrames && frameIndex < this._frameKeys.length){
            const i = this._frameKeys[frameIndex];
            const data = this._frames[i];
            const rect = data.frame;
            if (rect) {
                let frame = null;
                let trim = null;
                const sourceSize = data.trimmed !== false && data.sourceSize ? data.sourceSize : data.frame;
                const orig = new (0, $fM4Mk.Rectangle)(0, 0, Math.floor(sourceSize.w) / this.resolution, Math.floor(sourceSize.h) / this.resolution);
                if (data.rotated) frame = new (0, $fM4Mk.Rectangle)(Math.floor(rect.x) / this.resolution, Math.floor(rect.y) / this.resolution, Math.floor(rect.h) / this.resolution, Math.floor(rect.w) / this.resolution);
                else frame = new (0, $fM4Mk.Rectangle)(Math.floor(rect.x) / this.resolution, Math.floor(rect.y) / this.resolution, Math.floor(rect.w) / this.resolution, Math.floor(rect.h) / this.resolution);
                if (data.trimmed !== false && data.spriteSourceSize) trim = new (0, $fM4Mk.Rectangle)(Math.floor(data.spriteSourceSize.x) / this.resolution, Math.floor(data.spriteSourceSize.y) / this.resolution, Math.floor(rect.w) / this.resolution, Math.floor(rect.h) / this.resolution);
                this.textures[i] = new (0, $bLlTJ.Texture)({
                    source: this.textureSource,
                    frame: frame,
                    orig: orig,
                    trim: trim,
                    rotate: data.rotated ? 2 : 0,
                    defaultAnchor: data.anchor,
                    defaultBorders: data.borders,
                    label: i.toString()
                });
            }
            frameIndex++;
        }
    }
    /** Parse animations config. */ _processAnimations() {
        const animations = this.data.animations || {};
        for(const animName in animations){
            this.animations[animName] = [];
            for(let i = 0; i < animations[animName].length; i++){
                const frameName = animations[animName][i];
                this.animations[animName].push(this.textures[frameName]);
            }
        }
    }
    /** The parse has completed. */ _parseComplete() {
        const callback = this._callback;
        this._callback = null;
        this._batchIndex = 0;
        callback.call(this, this.textures);
    }
    /** Begin the next batch of textures. */ _nextBatch() {
        this._processFrames(this._batchIndex * _Spritesheet.BATCH_SIZE);
        this._batchIndex++;
        setTimeout(()=>{
            if (this._batchIndex * _Spritesheet.BATCH_SIZE < this._frameKeys.length) this._nextBatch();
            else {
                this._processAnimations();
                this._parseComplete();
            }
        }, 0);
    }
    /**
   * Destroy Spritesheet and don't use after this.
   * @param {boolean} [destroyBase=false] - Whether to destroy the base texture as well
   */ destroy(destroyBase = false) {
        for(const i in this.textures)this.textures[i].destroy();
        this._frames = null;
        this._frameKeys = null;
        this.data = null;
        this.textures = null;
        if (destroyBase) {
            this._texture?.destroy();
            this.textureSource.destroy();
        }
        this._texture = null;
        this.textureSource = null;
        this.linkedSheets = [];
    }
};
/** The maximum number of Textures to build per process. */ $9c38ec259f91df14$var$_Spritesheet.BATCH_SIZE = 1e3;
let $9c38ec259f91df14$export$674d2eb4debbef0c = $9c38ec259f91df14$var$_Spritesheet;

});



parcelRegister("3UUq4", function(module, exports) {

$parcel$export(module.exports, "AbstractRenderer", () => $453fded98f054a94$export$58ab3ed211eed562);

var $a2eTA = parcelRequire("a2eTA");

var $aEImn = parcelRequire("aEImn");

var $eicwU = parcelRequire("eicwU");

var $cJHPn = parcelRequire("cJHPn");

var $kXq8E = parcelRequire("kXq8E");


var $hFYOq = parcelRequire("hFYOq");

var $gtbjr = parcelRequire("gtbjr");

var $3vRz3 = parcelRequire("3vRz3");
"use strict";
const $453fded98f054a94$var$defaultRunners = [
    "init",
    "destroy",
    "contextChange",
    "resolutionChange",
    "reset",
    "renderEnd",
    "renderStart",
    "render",
    "update",
    "postrender",
    "prerender"
];
const $453fded98f054a94$var$_AbstractRenderer = class _AbstractRenderer extends (0, (/*@__PURE__*/$parcel$interopDefault($3vRz3))) {
    /**
   * Set up a system with a collection of SystemClasses and runners.
   * Systems are attached dynamically to this class when added.
   * @param config - the config for the system manager
   */ constructor(config){
        super();
        this.runners = /* @__PURE__ */ Object.create(null);
        this.renderPipes = /* @__PURE__ */ Object.create(null);
        this._initOptions = {};
        this._systemsHash = /* @__PURE__ */ Object.create(null);
        this.type = config.type;
        this.name = config.name;
        this.config = config;
        const combinedRunners = [
            ...$453fded98f054a94$var$defaultRunners,
            ...this.config.runners ?? []
        ];
        this._addRunners(...combinedRunners);
        this._unsafeEvalCheck();
    }
    /**
   * Initialize the renderer.
   * @param options - The options to use to create the renderer.
   */ async init(options = {}) {
        const skip = options.skipExtensionImports === true ? true : options.manageImports === false;
        await (0, $aEImn.loadEnvironmentExtensions)(skip);
        this._addSystems(this.config.systems);
        this._addPipes(this.config.renderPipes, this.config.renderPipeAdaptors);
        for(const systemName in this._systemsHash){
            const system = this._systemsHash[systemName];
            const defaultSystemOptions = system.constructor.defaultOptions;
            options = {
                ...defaultSystemOptions,
                ...options
            };
        }
        options = {
            ..._AbstractRenderer.defaultOptions,
            ...options
        };
        this._roundPixels = options.roundPixels ? 1 : 0;
        for(let i = 0; i < this.runners.init.items.length; i++)await this.runners.init.items[i].init(options);
        this._initOptions = options;
    }
    render(args, deprecated) {
        let options = args;
        if (options instanceof (0, $eicwU.Container)) {
            options = {
                container: options
            };
            if (deprecated) {
                (0, $kXq8E.deprecation)((0, $kXq8E.v8_0_0), "passing a second argument is deprecated, please use render options instead");
                options.target = deprecated.renderTexture;
            }
        }
        options.target || (options.target = this.view.renderTarget);
        if (options.target === this.view.renderTarget) {
            this._lastObjectRendered = options.container;
            options.clearColor = this.background.colorRgba;
        }
        if (options.clearColor) {
            const isRGBAArray = Array.isArray(options.clearColor) && options.clearColor.length === 4;
            options.clearColor = isRGBAArray ? options.clearColor : (0, $a2eTA.Color).shared.setValue(options.clearColor).toArray();
        }
        if (!options.transform) {
            options.container.updateLocalTransform();
            options.transform = options.container.localTransform;
        }
        this.runners.prerender.emit(options);
        this.runners.renderStart.emit(options);
        this.runners.render.emit(options);
        this.runners.renderEnd.emit(options);
        this.runners.postrender.emit(options);
    }
    /**
   * Resizes the WebGL view to the specified width and height.
   * @param desiredScreenWidth - The desired width of the screen.
   * @param desiredScreenHeight - The desired height of the screen.
   * @param resolution - The resolution / device pixel ratio of the renderer.
   */ resize(desiredScreenWidth, desiredScreenHeight, resolution) {
        const previousResolution = this.view.resolution;
        this.view.resize(desiredScreenWidth, desiredScreenHeight, resolution);
        this.emit("resize", this.view.screen.width, this.view.screen.height, this.view.resolution);
        if (resolution !== void 0 && resolution !== previousResolution) this.runners.resolutionChange.emit(resolution);
    }
    clear(options = {}) {
        const renderer = this;
        options.target || (options.target = renderer.renderTarget.renderTarget);
        options.clearColor || (options.clearColor = this.background.colorRgba);
        options.clear ?? (options.clear = (0, $hFYOq.CLEAR).ALL);
        const { clear: clear, clearColor: clearColor, target: target } = options;
        (0, $a2eTA.Color).shared.setValue(clearColor ?? this.background.colorRgba);
        renderer.renderTarget.clear(target, clear, (0, $a2eTA.Color).shared.toArray());
    }
    /** The resolution / device pixel ratio of the renderer. */ get resolution() {
        return this.view.resolution;
    }
    set resolution(value) {
        this.view.resolution = value;
        this.runners.resolutionChange.emit(value);
    }
    /**
   * Same as view.width, actual number of pixels in the canvas by horizontal.
   * @member {number}
   * @readonly
   * @default 800
   */ get width() {
        return this.view.texture.frame.width;
    }
    /**
   * Same as view.height, actual number of pixels in the canvas by vertical.
   * @default 600
   */ get height() {
        return this.view.texture.frame.height;
    }
    // NOTE: this was `view` in v7
    /**
   * The canvas element that everything is drawn to.
   * @type {environment.ICanvas}
   */ get canvas() {
        return this.view.canvas;
    }
    /**
   * the last object rendered by the renderer. Useful for other plugins like interaction managers
   * @readonly
   */ get lastObjectRendered() {
        return this._lastObjectRendered;
    }
    /**
   * Flag if we are rendering to the screen vs renderTexture
   * @readonly
   * @default true
   */ get renderingToScreen() {
        const renderer = this;
        return renderer.renderTarget.renderingToScreen;
    }
    /**
   * Measurements of the screen. (0, 0, screenWidth, screenHeight).
   *
   * Its safe to use as filterArea or hitArea for the whole stage.
   */ get screen() {
        return this.view.screen;
    }
    /**
   * Create a bunch of runners based of a collection of ids
   * @param runnerIds - the runner ids to add
   */ _addRunners(...runnerIds) {
        runnerIds.forEach((runnerId)=>{
            this.runners[runnerId] = new (0, $gtbjr.SystemRunner)(runnerId);
        });
    }
    _addSystems(systems) {
        let i;
        for(i in systems){
            const val = systems[i];
            this._addSystem(val.value, val.name);
        }
    }
    /**
   * Add a new system to the renderer.
   * @param ClassRef - Class reference
   * @param name - Property name for system, if not specified
   *        will use a static `name` property on the class itself. This
   *        name will be assigned as s property on the Renderer so make
   *        sure it doesn't collide with properties on Renderer.
   * @returns Return instance of renderer
   */ _addSystem(ClassRef, name) {
        const system = new ClassRef(this);
        if (this[name]) throw new Error(`Whoops! The name "${name}" is already in use`);
        this[name] = system;
        this._systemsHash[name] = system;
        for(const i in this.runners)this.runners[i].add(system);
        return this;
    }
    _addPipes(pipes, pipeAdaptors) {
        const adaptors = pipeAdaptors.reduce((acc, adaptor)=>{
            acc[adaptor.name] = adaptor.value;
            return acc;
        }, {});
        pipes.forEach((pipe)=>{
            const PipeClass = pipe.value;
            const name = pipe.name;
            const Adaptor = adaptors[name];
            this.renderPipes[name] = new PipeClass(this, Adaptor ? new Adaptor() : null);
        });
    }
    destroy(options = false) {
        this.runners.destroy.items.reverse();
        this.runners.destroy.emit(options);
        Object.values(this.runners).forEach((runner)=>{
            runner.destroy();
        });
        this._systemsHash = null;
        this.renderPipes = null;
    }
    /**
   * Generate a texture from a container.
   * @param options - options or container target to use when generating the texture
   * @returns a texture
   */ generateTexture(options) {
        return this.textureGenerator.generateTexture(options);
    }
    /**
   * Whether the renderer will round coordinates to whole pixels when rendering.
   * Can be overridden on a per scene item basis.
   */ get roundPixels() {
        return !!this._roundPixels;
    }
    /**
   * Overridable function by `pixi.js/unsafe-eval` to silence
   * throwing an error if platform doesn't support unsafe-evals.
   * @private
   * @ignore
   */ _unsafeEvalCheck() {
        if (!(0, $cJHPn.unsafeEvalSupported)()) throw new Error("Current environment does not allow unsafe-eval, please use pixi.js/unsafe-eval module to enable support.");
    }
};
/** The default options for the renderer. */ $453fded98f054a94$var$_AbstractRenderer.defaultOptions = {
    /**
   * Default resolution / device pixel ratio of the renderer.
   * @default 1
   */ resolution: 1,
    /**
   * Should the `failIfMajorPerformanceCaveat` flag be enabled as a context option used in the `isWebGLSupported`
   * function. If set to true, a WebGL renderer can fail to be created if the browser thinks there could be
   * performance issues when using WebGL.
   *
   * In PixiJS v6 this has changed from true to false by default, to allow WebGL to work in as many
   * scenarios as possible. However, some users may have a poor experience, for example, if a user has a gpu or
   * driver version blacklisted by the
   * browser.
   *
   * If your application requires high performance rendering, you may wish to set this to false.
   * We recommend one of two options if you decide to set this flag to false:
   *
   * 1: Use the Canvas renderer as a fallback in case high performance WebGL is
   *    not supported.
   *
   * 2: Call `isWebGLSupported` (which if found in the utils package) in your code before attempting to create a
   *    PixiJS renderer, and show an error message to the user if the function returns false, explaining that their
   *    device & browser combination does not support high performance WebGL.
   *    This is a much better strategy than trying to create a PixiJS renderer and finding it then fails.
   * @default false
   */ failIfMajorPerformanceCaveat: false,
    /**
   * Should round pixels be forced when rendering?
   * @default false
   */ roundPixels: false
};
let $453fded98f054a94$export$58ab3ed211eed562 = $453fded98f054a94$var$_AbstractRenderer;

});
parcelRegister("aEImn", function(module, exports) {

$parcel$export(module.exports, "loadEnvironmentExtensions", () => $326e7279631cea1a$export$3b30260a318c769f);

var $i9BKe = parcelRequire("i9BKe");
"use strict";
const $326e7279631cea1a$var$environments = [];
(0, $i9BKe.extensions).handleByNamedList((0, $i9BKe.ExtensionType).Environment, $326e7279631cea1a$var$environments);
async function $326e7279631cea1a$export$3b30260a318c769f(skip) {
    if (skip) return;
    for(let i = 0; i < $326e7279631cea1a$var$environments.length; i++){
        const env = $326e7279631cea1a$var$environments[i];
        if (env.value.test()) {
            await env.value.load();
            return;
        }
    }
}
async function $326e7279631cea1a$export$72225172dd907279(add) {
    return $326e7279631cea1a$export$3b30260a318c769f(!add);
}

});

parcelRegister("cJHPn", function(module, exports) {

$parcel$export(module.exports, "unsafeEvalSupported", () => $d88536e9c61409d6$export$70c0711f29adc5cf);
"use strict";
let $d88536e9c61409d6$var$unsafeEval;
function $d88536e9c61409d6$export$70c0711f29adc5cf() {
    if (typeof $d88536e9c61409d6$var$unsafeEval === "boolean") return $d88536e9c61409d6$var$unsafeEval;
    try {
        const func = new Function("param1", "param2", "param3", "return param1[param2] === param3;");
        $d88536e9c61409d6$var$unsafeEval = func({
            a: "b"
        }, "a", "b") === true;
    } catch (e) {
        $d88536e9c61409d6$var$unsafeEval = false;
    }
    return $d88536e9c61409d6$var$unsafeEval;
}

});

parcelRegister("hFYOq", function(module, exports) {

$parcel$export(module.exports, "CLEAR", () => $bdcaad22b468ed1b$export$6c4d37c7f376a1de);
"use strict";
var $bdcaad22b468ed1b$export$6c4d37c7f376a1de = /* @__PURE__ */ ((CLEAR2)=>{
    CLEAR2[CLEAR2["NONE"] = 0] = "NONE";
    CLEAR2[CLEAR2["COLOR"] = 16384] = "COLOR";
    CLEAR2[CLEAR2["STENCIL"] = 1024] = "STENCIL";
    CLEAR2[CLEAR2["DEPTH"] = 256] = "DEPTH";
    CLEAR2[CLEAR2["COLOR_DEPTH"] = 16640] = "COLOR_DEPTH";
    CLEAR2[CLEAR2["COLOR_STENCIL"] = 17408] = "COLOR_STENCIL";
    CLEAR2[CLEAR2["DEPTH_STENCIL"] = 1280] = "DEPTH_STENCIL";
    CLEAR2[CLEAR2["ALL"] = 17664] = "ALL";
    return CLEAR2;
})($bdcaad22b468ed1b$export$6c4d37c7f376a1de || {});

});

parcelRegister("gtbjr", function(module, exports) {

$parcel$export(module.exports, "SystemRunner", () => $299af1a7d2dd4105$export$ff5f2fe687fe3979);
"use strict";
class $299af1a7d2dd4105$export$ff5f2fe687fe3979 {
    /**
   * @param name - The function name that will be executed on the listeners added to this Runner.
   */ constructor(name){
        this.items = [];
        this._name = name;
    }
    /* eslint-disable jsdoc/require-param, jsdoc/check-param-names */ /**
   * Dispatch/Broadcast Runner to all listeners added to the queue.
   * @param {...any} params - (optional) parameters to pass to each listener
   */ /*  eslint-enable jsdoc/require-param, jsdoc/check-param-names */ emit(a0, a1, a2, a3, a4, a5, a6, a7) {
        const { name: name, items: items } = this;
        for(let i = 0, len = items.length; i < len; i++)items[i][name](a0, a1, a2, a3, a4, a5, a6, a7);
        return this;
    }
    /**
   * Add a listener to the Runner
   *
   * Runners do not need to have scope or functions passed to them.
   * All that is required is to pass the listening object and ensure that it has contains a function that has the same name
   * as the name provided to the Runner when it was created.
   *
   * Eg A listener passed to this Runner will require a 'complete' function.
   *
   * ```
   * import { Runner } from 'pixi.js';
   *
   * const complete = new Runner('complete');
   * ```
   *
   * The scope used will be the object itself.
   * @param {any} item - The object that will be listening.
   */ add(item) {
        if (item[this._name]) {
            this.remove(item);
            this.items.push(item);
        }
        return this;
    }
    /**
   * Remove a single listener from the dispatch queue.
   * @param {any} item - The listener that you would like to remove.
   */ remove(item) {
        const index = this.items.indexOf(item);
        if (index !== -1) this.items.splice(index, 1);
        return this;
    }
    /**
   * Check to see if the listener is already in the Runner
   * @param {any} item - The listener that you would like to check.
   */ contains(item) {
        return this.items.indexOf(item) !== -1;
    }
    /** Remove all listeners from the Runner */ removeAll() {
        this.items.length = 0;
        return this;
    }
    /** Remove all references, don't use after this. */ destroy() {
        this.removeAll();
        this.items = null;
        this._name = null;
    }
    /**
   * `true` if there are no this Runner contains no listeners
   * @readonly
   */ get empty() {
        return this.items.length === 0;
    }
    /**
   * The name of the runner.
   * @readonly
   */ get name() {
        return this._name;
    }
}

});


parcelRegister("eOMWf", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = Promise.all([
    $Gr8vk("g8iML"),
    $Gr8vk("aNM0B")
]).then(()=>parcelRequire("aIpib"));

});

parcelRegister("opv27", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = Promise.all([
    $Gr8vk("g8iML"),
    $Gr8vk("7EYKF")
]).then(()=>parcelRequire("kpxDv"));

});

parcelRegister("gVtOu", function(module, exports) {

$parcel$export(module.exports, "ApplicationInitHook", () => $eaa9a2f5d114568e$export$918f3e4d2b801859);
$parcel$export(module.exports, "RendererInitHook", () => $eaa9a2f5d114568e$export$5fba6e443d2fb64);

var $i9BKe = parcelRequire("i9BKe");

var $7hfrt = parcelRequire("7hfrt");
"use strict";
class $eaa9a2f5d114568e$export$918f3e4d2b801859 {
    static init() {
        globalThis.__PIXI_APP_INIT__?.(this, (0, $7hfrt.VERSION));
    }
    static destroy() {}
}
/** @ignore */ $eaa9a2f5d114568e$export$918f3e4d2b801859.extension = (0, $i9BKe.ExtensionType).Application;
class $eaa9a2f5d114568e$export$5fba6e443d2fb64 {
    constructor(renderer){
        this._renderer = renderer;
    }
    init() {
        globalThis.__PIXI_RENDERER_INIT__?.(this._renderer, (0, $7hfrt.VERSION));
    }
    destroy() {
        this._renderer = null;
    }
}
/** @ignore */ $eaa9a2f5d114568e$export$5fba6e443d2fb64.extension = {
    type: [
        (0, $i9BKe.ExtensionType).WebGLSystem,
        (0, $i9BKe.ExtensionType).WebGPUSystem
    ],
    name: "initHook",
    priority: -10
};

});
parcelRegister("7hfrt", function(module, exports) {

$parcel$export(module.exports, "VERSION", () => $6c3dc1ec0fb181c1$export$a4ad2735b021c132);

var $3vRz3 = parcelRequire("3vRz3");
"use strict";
const $6c3dc1ec0fb181c1$export$dbafa72958753fce = /^\s*data:(?:([\w-]+)\/([\w+.-]+))?(?:;charset=([\w-]+))?(?:;(base64))?,(.*)/i;
const $6c3dc1ec0fb181c1$export$a4ad2735b021c132 = "8.4.0";

});


parcelRegister("axl5b", function(module, exports) {

$parcel$export(module.exports, "BitmapFontManager", () => $906f35d9788bb217$export$d2ee57cdc0e1ed7f);

var $2IhKp = parcelRequire("2IhKp");

var $kXq8E = parcelRequire("kXq8E");

var $hUCK4 = parcelRequire("hUCK4");

var $eKNW7 = parcelRequire("eKNW7");

var $5Jnul = parcelRequire("5Jnul");

var $hzhPt = parcelRequire("hzhPt");

var $6ch13 = parcelRequire("6ch13");
"use strict";
let $906f35d9788bb217$var$fontCount = 0;
class $906f35d9788bb217$var$BitmapFontManagerClass {
    constructor(){
        /**
     * This character set includes all the letters in the alphabet (both lower- and upper- case).
     * @type {string[][]}
     * @example
     * BitmapFont.from('ExampleFont', style, { chars: BitmapFont.ALPHA })
     */ this.ALPHA = [
            [
                "a",
                "z"
            ],
            [
                "A",
                "Z"
            ],
            " "
        ];
        /**
     * This character set includes all decimal digits (from 0 to 9).
     * @type {string[][]}
     * @example
     * BitmapFont.from('ExampleFont', style, { chars: BitmapFont.NUMERIC })
     */ this.NUMERIC = [
            [
                "0",
                "9"
            ]
        ];
        /**
     * This character set is the union of `BitmapFont.ALPHA` and `BitmapFont.NUMERIC`.
     * @type {string[][]}
     */ this.ALPHANUMERIC = [
            [
                "a",
                "z"
            ],
            [
                "A",
                "Z"
            ],
            [
                "0",
                "9"
            ],
            " "
        ];
        /**
     * This character set consists of all the ASCII table.
     * @member {string[][]}
     * @see http://www.asciitable.com/
     */ this.ASCII = [
            [
                " ",
                "~"
            ]
        ];
        /** Default options for installing a new BitmapFont. */ this.defaultOptions = {
            chars: this.ALPHANUMERIC,
            resolution: 1,
            padding: 4,
            skipKerning: false
        };
    }
    /**
   * Get a font for the specified text and style.
   * @param text - The text to get the font for
   * @param style - The style to use
   */ getFont(text, style) {
        let fontFamilyKey = `${style.fontFamily}-bitmap`;
        let overrideFill = true;
        if (style._fill.fill && !style._stroke) {
            fontFamilyKey += style._fill.fill.styleKey;
            overrideFill = false;
        } else if (style._stroke || style.dropShadow) {
            let key = style.styleKey;
            key = key.substring(0, key.lastIndexOf("-"));
            fontFamilyKey = `${key}-bitmap`;
            overrideFill = false;
        }
        if (!(0, $2IhKp.Cache).has(fontFamilyKey)) {
            const fnt = new (0, $5Jnul.DynamicBitmapFont)({
                style: style,
                overrideFill: overrideFill,
                overrideSize: true,
                ...this.defaultOptions
            });
            $906f35d9788bb217$var$fontCount++;
            if ($906f35d9788bb217$var$fontCount > 50) (0, $hUCK4.warn)("BitmapText", `You have dynamically created ${$906f35d9788bb217$var$fontCount} bitmap fonts, this can be inefficient. Try pre installing your font styles using \`BitmapFont.install({name:"style1", style})\``);
            fnt.once("destroy", ()=>{
                $906f35d9788bb217$var$fontCount--;
                (0, $2IhKp.Cache).remove(fontFamilyKey);
            });
            (0, $2IhKp.Cache).set(fontFamilyKey, fnt);
        }
        const dynamicFont = (0, $2IhKp.Cache).get(fontFamilyKey);
        dynamicFont.ensureCharacters?.(text);
        return dynamicFont;
    }
    /**
   * Get the layout of a text for the specified style.
   * @param text - The text to get the layout for
   * @param style - The style to use
   * @param trimEnd - Whether to ignore whitespaces at the end of each line
   */ getLayout(text, style, trimEnd = true) {
        const bitmapFont = this.getFont(text, style);
        return (0, $hzhPt.getBitmapTextLayout)([
            ...text
        ], style, bitmapFont, trimEnd);
    }
    /**
   * Measure the text using the specified style.
   * @param text - The text to measure
   * @param style - The style to use
   * @param trimEnd - Whether to ignore whitespaces at the end of each line
   */ measureText(text, style, trimEnd = true) {
        return this.getLayout(text, style, trimEnd);
    }
    // eslint-disable-next-line max-len
    install(...args) {
        let options = args[0];
        if (typeof options === "string") {
            options = {
                name: options,
                style: args[1],
                chars: args[2]?.chars,
                resolution: args[2]?.resolution,
                padding: args[2]?.padding,
                skipKerning: args[2]?.skipKerning
            };
            (0, $kXq8E.deprecation)((0, $kXq8E.v8_0_0), "BitmapFontManager.install(name, style, options) is deprecated, use BitmapFontManager.install({name, style, ...options})");
        }
        const name = options?.name;
        if (!name) throw new Error("[BitmapFontManager] Property `name` is required.");
        options = {
            ...this.defaultOptions,
            ...options
        };
        const textStyle = options.style;
        const style = textStyle instanceof (0, $eKNW7.TextStyle) ? textStyle : new (0, $eKNW7.TextStyle)(textStyle);
        const overrideFill = style._fill.fill !== null && style._fill.fill !== void 0;
        const font = new (0, $5Jnul.DynamicBitmapFont)({
            style: style,
            overrideFill: overrideFill,
            skipKerning: options.skipKerning,
            padding: options.padding,
            resolution: options.resolution,
            overrideSize: false
        });
        const flatChars = (0, $6ch13.resolveCharacters)(options.chars);
        font.ensureCharacters(flatChars.join(""));
        (0, $2IhKp.Cache).set(`${name}-bitmap`, font);
        font.once("destroy", ()=>(0, $2IhKp.Cache).remove(`${name}-bitmap`));
        return font;
    }
    /**
   * Uninstalls a bitmap font from the cache.
   * @param {string} name - The name of the bitmap font to uninstall.
   */ uninstall(name) {
        const cacheKey = `${name}-bitmap`;
        const font = (0, $2IhKp.Cache).get(cacheKey);
        if (font) {
            (0, $2IhKp.Cache).remove(cacheKey);
            font.destroy();
        }
    }
}
const $906f35d9788bb217$export$d2ee57cdc0e1ed7f = new $906f35d9788bb217$var$BitmapFontManagerClass();

});
parcelRegister("eKNW7", function(module, exports) {

$parcel$export(module.exports, "TextStyle", () => $d76c68b7f9f9bbea$export$1df879243bf2e42d);

var $3vRz3 = parcelRequire("3vRz3");

var $a2eTA = parcelRequire("a2eTA");

var $kXq8E = parcelRequire("kXq8E");

var $gwwtL = parcelRequire("gwwtL");

var $ktCpi = parcelRequire("ktCpi");

var $8aC7P = parcelRequire("8aC7P");

var $6mQKv = parcelRequire("6mQKv");

var $6XitK = parcelRequire("6XitK");
"use strict";
const $d76c68b7f9f9bbea$var$_TextStyle = class _TextStyle extends (0, (/*@__PURE__*/$parcel$interopDefault($3vRz3))) {
    constructor(style = {}){
        super();
        $d76c68b7f9f9bbea$var$convertV7Tov8Style(style);
        const fullStyle = {
            ..._TextStyle.defaultTextStyle,
            ...style
        };
        for(const key in fullStyle){
            const thisKey = key;
            this[thisKey] = fullStyle[key];
        }
        this.update();
    }
    /**
   * Alignment for multiline text, does not affect single line text.
   * @member {'left'|'center'|'right'|'justify'}
   */ get align() {
        return this._align;
    }
    set align(value) {
        this._align = value;
        this.update();
    }
    /** Indicates if lines can be wrapped within words, it needs wordWrap to be set to true. */ get breakWords() {
        return this._breakWords;
    }
    set breakWords(value) {
        this._breakWords = value;
        this.update();
    }
    /** Set a drop shadow for the text. */ get dropShadow() {
        return this._dropShadow;
    }
    set dropShadow(value) {
        if (value !== null && typeof value === "object") this._dropShadow = this._createProxy({
            ..._TextStyle.defaultDropShadow,
            ...value
        });
        else this._dropShadow = value ? this._createProxy({
            ..._TextStyle.defaultDropShadow
        }) : null;
        this.update();
    }
    /** The font family, can be a single font name, or a list of names where the first is the preferred font. */ get fontFamily() {
        return this._fontFamily;
    }
    set fontFamily(value) {
        this._fontFamily = value;
        this.update();
    }
    /** The font size (as a number it converts to px, but as a string, equivalents are '26px','20pt','160%' or '1.6em') */ get fontSize() {
        return this._fontSize;
    }
    set fontSize(value) {
        if (typeof value === "string") this._fontSize = parseInt(value, 10);
        else this._fontSize = value;
        this.update();
    }
    /**
   * The font style.
   * @member {'normal'|'italic'|'oblique'}
   */ get fontStyle() {
        return this._fontStyle;
    }
    set fontStyle(value) {
        this._fontStyle = value;
        this.update();
    }
    /**
   * The font variant.
   * @member {'normal'|'small-caps'}
   */ get fontVariant() {
        return this._fontVariant;
    }
    set fontVariant(value) {
        this._fontVariant = value;
        this.update();
    }
    /**
   * The font weight.
   * @member {'normal'|'bold'|'bolder'|'lighter'|'100'|'200'|'300'|'400'|'500'|'600'|'700'|'800'|'900'}
   */ get fontWeight() {
        return this._fontWeight;
    }
    set fontWeight(value) {
        this._fontWeight = value;
        this.update();
    }
    /** The space between lines. */ get leading() {
        return this._leading;
    }
    set leading(value) {
        this._leading = value;
        this.update();
    }
    /** The amount of spacing between letters, default is 0. */ get letterSpacing() {
        return this._letterSpacing;
    }
    set letterSpacing(value) {
        this._letterSpacing = value;
        this.update();
    }
    /** The line height, a number that represents the vertical space that a letter uses. */ get lineHeight() {
        return this._lineHeight;
    }
    set lineHeight(value) {
        this._lineHeight = value;
        this.update();
    }
    /**
   * Occasionally some fonts are cropped. Adding some padding will prevent this from happening
   * by adding padding to all sides of the text.
   */ get padding() {
        return this._padding;
    }
    set padding(value) {
        this._padding = value;
        this.update();
    }
    /** Trim transparent borders. This is an expensive operation so only use this if you have to! */ get trim() {
        return this._trim;
    }
    set trim(value) {
        this._trim = value;
        this.update();
    }
    /**
   * The baseline of the text that is rendered.
   * @member {'alphabetic'|'top'|'hanging'|'middle'|'ideographic'|'bottom'}
   */ get textBaseline() {
        return this._textBaseline;
    }
    set textBaseline(value) {
        this._textBaseline = value;
        this.update();
    }
    /**
   * How newlines and spaces should be handled.
   * Default is 'pre' (preserve, preserve).
   *
   *  value       | New lines     |   Spaces
   *  ---         | ---           |   ---
   * 'normal'     | Collapse      |   Collapse
   * 'pre'        | Preserve      |   Preserve
   * 'pre-line'   | Preserve      |   Collapse
   * @member {'normal'|'pre'|'pre-line'}
   */ get whiteSpace() {
        return this._whiteSpace;
    }
    set whiteSpace(value) {
        this._whiteSpace = value;
        this.update();
    }
    /** Indicates if word wrap should be used. */ get wordWrap() {
        return this._wordWrap;
    }
    set wordWrap(value) {
        this._wordWrap = value;
        this.update();
    }
    /** The width at which text will wrap, it needs wordWrap to be set to true. */ get wordWrapWidth() {
        return this._wordWrapWidth;
    }
    set wordWrapWidth(value) {
        this._wordWrapWidth = value;
        this.update();
    }
    /** A fillstyle that will be used on the text e.g., 'red', '#00FF00'. */ get fill() {
        return this._originalFill;
    }
    set fill(value) {
        if (value === this._originalFill) return;
        this._originalFill = value;
        if (this._isFillStyle(value)) this._originalFill = this._createProxy({
            ...(0, $8aC7P.GraphicsContext).defaultFillStyle,
            ...value
        }, ()=>{
            this._fill = (0, $6mQKv.toFillStyle)({
                ...this._originalFill
            }, (0, $8aC7P.GraphicsContext).defaultFillStyle);
        });
        this._fill = (0, $6mQKv.toFillStyle)(value === 0 ? "black" : value, (0, $8aC7P.GraphicsContext).defaultFillStyle);
        this.update();
    }
    /** A fillstyle that will be used on the text stroke, e.g., 'blue', '#FCFF00'. */ get stroke() {
        return this._originalStroke;
    }
    set stroke(value) {
        if (value === this._originalStroke) return;
        this._originalStroke = value;
        if (this._isFillStyle(value)) this._originalStroke = this._createProxy({
            ...(0, $8aC7P.GraphicsContext).defaultStrokeStyle,
            ...value
        }, ()=>{
            this._stroke = (0, $6mQKv.toStrokeStyle)({
                ...this._originalStroke
            }, (0, $8aC7P.GraphicsContext).defaultStrokeStyle);
        });
        this._stroke = (0, $6mQKv.toStrokeStyle)(value, (0, $8aC7P.GraphicsContext).defaultStrokeStyle);
        this.update();
    }
    _generateKey() {
        this._styleKey = (0, $6XitK.generateTextStyleKey)(this);
        return this._styleKey;
    }
    update() {
        this._styleKey = null;
        this.emit("update", this);
    }
    /** Resets all properties to the default values */ reset() {
        const defaultStyle = _TextStyle.defaultTextStyle;
        for(const key in defaultStyle)this[key] = defaultStyle[key];
    }
    get styleKey() {
        return this._styleKey || this._generateKey();
    }
    /**
   * Creates a new TextStyle object with the same values as this one.
   * @returns New cloned TextStyle object
   */ clone() {
        return new _TextStyle({
            align: this.align,
            breakWords: this.breakWords,
            dropShadow: this._dropShadow ? {
                ...this._dropShadow
            } : null,
            fill: this._fill,
            fontFamily: this.fontFamily,
            fontSize: this.fontSize,
            fontStyle: this.fontStyle,
            fontVariant: this.fontVariant,
            fontWeight: this.fontWeight,
            leading: this.leading,
            letterSpacing: this.letterSpacing,
            lineHeight: this.lineHeight,
            padding: this.padding,
            stroke: this._stroke,
            textBaseline: this.textBaseline,
            whiteSpace: this.whiteSpace,
            wordWrap: this.wordWrap,
            wordWrapWidth: this.wordWrapWidth
        });
    }
    /**
   * Destroys this text style.
   * @param options - Options parameter. A boolean will act as if all options
   *  have been set to that value
   * @param {boolean} [options.texture=false] - Should it destroy the texture of the this style
   * @param {boolean} [options.textureSource=false] - Should it destroy the textureSource of the this style
   */ destroy(options = false) {
        this.removeAllListeners();
        const destroyTexture = typeof options === "boolean" ? options : options?.texture;
        if (destroyTexture) {
            const destroyTextureSource = typeof options === "boolean" ? options : options?.textureSource;
            if (this._fill?.texture) this._fill.texture.destroy(destroyTextureSource);
            if (this._originalFill?.texture) this._originalFill.texture.destroy(destroyTextureSource);
            if (this._stroke?.texture) this._stroke.texture.destroy(destroyTextureSource);
            if (this._originalStroke?.texture) this._originalStroke.texture.destroy(destroyTextureSource);
        }
        this._fill = null;
        this._stroke = null;
        this.dropShadow = null;
        this._originalStroke = null;
        this._originalFill = null;
    }
    _createProxy(value, cb) {
        return new Proxy(value, {
            set: (target, property, newValue)=>{
                target[property] = newValue;
                cb?.(property, newValue);
                this.update();
                return true;
            }
        });
    }
    _isFillStyle(value) {
        return (value ?? null) !== null && !((0, $a2eTA.Color).isColorLike(value) || value instanceof (0, $gwwtL.FillGradient) || value instanceof (0, $ktCpi.FillPattern));
    }
};
/** The default drop shadow settings */ $d76c68b7f9f9bbea$var$_TextStyle.defaultDropShadow = {
    /** Set alpha for the drop shadow */ alpha: 1,
    /** Set a angle of the drop shadow */ angle: Math.PI / 6,
    /** Set a shadow blur radius */ blur: 0,
    /** A fill style to be used on the  e.g., 'red', '#00FF00' */ color: "black",
    /** Set a distance of the drop shadow */ distance: 5
};
/** The default text style settings */ $d76c68b7f9f9bbea$var$_TextStyle.defaultTextStyle = {
    /**
   * See {@link TextStyle.align}
   * @type {'left'|'center'|'right'|'justify'}
   */ align: "left",
    /** See {@link TextStyle.breakWords} */ breakWords: false,
    /** See {@link TextStyle.dropShadow} */ dropShadow: null,
    /**
   * See {@link TextStyle.fill}
   * @type {string|string[]|number|number[]|CanvasGradient|CanvasPattern}
   */ fill: "black",
    /**
   * See {@link TextStyle.fontFamily}
   * @type {string|string[]}
   */ fontFamily: "Arial",
    /**
   * See {@link TextStyle.fontSize}
   * @type {number|string}
   */ fontSize: 26,
    /**
   * See {@link TextStyle.fontStyle}
   * @type {'normal'|'italic'|'oblique'}
   */ fontStyle: "normal",
    /**
   * See {@link TextStyle.fontVariant}
   * @type {'normal'|'small-caps'}
   */ fontVariant: "normal",
    /**
   * See {@link TextStyle.fontWeight}
   * @type {'normal'|'bold'|'bolder'|'lighter'|'100'|'200'|'300'|'400'|'500'|'600'|'700'|'800'|'900'}
   */ fontWeight: "normal",
    /** See {@link TextStyle.leading} */ leading: 0,
    /** See {@link TextStyle.letterSpacing} */ letterSpacing: 0,
    /** See {@link TextStyle.lineHeight} */ lineHeight: 0,
    /** See {@link TextStyle.padding} */ padding: 0,
    /**
   * See {@link TextStyle.stroke}
   * @type {string|number}
   */ stroke: null,
    /**
   * See {@link TextStyle.textBaseline}
   * @type {'alphabetic'|'top'|'hanging'|'middle'|'ideographic'|'bottom'}
   */ textBaseline: "alphabetic",
    /** See {@link TextStyle.trim} */ trim: false,
    /**
   * See {@link TextStyle.whiteSpace}
   * @type {'normal'|'pre'|'pre-line'}
   */ whiteSpace: "pre",
    /** See {@link TextStyle.wordWrap} */ wordWrap: false,
    /** See {@link TextStyle.wordWrapWidth} */ wordWrapWidth: 100
};
let $d76c68b7f9f9bbea$export$1df879243bf2e42d = $d76c68b7f9f9bbea$var$_TextStyle;
function $d76c68b7f9f9bbea$var$convertV7Tov8Style(style) {
    const oldStyle = style;
    if (typeof oldStyle.dropShadow === "boolean" && oldStyle.dropShadow) {
        const defaults = $d76c68b7f9f9bbea$export$1df879243bf2e42d.defaultDropShadow;
        style.dropShadow = {
            alpha: oldStyle.dropShadowAlpha ?? defaults.alpha,
            angle: oldStyle.dropShadowAngle ?? defaults.angle,
            blur: oldStyle.dropShadowBlur ?? defaults.blur,
            color: oldStyle.dropShadowColor ?? defaults.color,
            distance: oldStyle.dropShadowDistance ?? defaults.distance
        };
    }
    if (oldStyle.strokeThickness !== void 0) {
        (0, $kXq8E.deprecation)((0, $kXq8E.v8_0_0), "strokeThickness is now a part of stroke");
        const color = oldStyle.stroke;
        let obj = {};
        if ((0, $a2eTA.Color).isColorLike(color)) obj.color = color;
        else if (color instanceof (0, $gwwtL.FillGradient) || color instanceof (0, $ktCpi.FillPattern)) obj.fill = color;
        else if (Object.hasOwnProperty.call(color, "color") || Object.hasOwnProperty.call(color, "fill")) obj = color;
        else throw new Error("Invalid stroke value.");
        style.stroke = {
            ...obj,
            width: oldStyle.strokeThickness
        };
    }
    if (Array.isArray(oldStyle.fillGradientStops)) {
        (0, $kXq8E.deprecation)((0, $kXq8E.v8_0_0), "gradient fill is now a fill pattern: `new FillGradient(...)`");
        let fontSize;
        if (style.fontSize == null) style.fontSize = $d76c68b7f9f9bbea$export$1df879243bf2e42d.defaultTextStyle.fontSize;
        else if (typeof style.fontSize === "string") fontSize = parseInt(style.fontSize, 10);
        else fontSize = style.fontSize;
        const gradientFill = new (0, $gwwtL.FillGradient)(0, 0, 0, fontSize * 1.7);
        const fills = oldStyle.fillGradientStops.map((color)=>(0, $a2eTA.Color).shared.setValue(color).toNumber());
        fills.forEach((number, index)=>{
            const ratio = index / (fills.length - 1);
            gradientFill.addColorStop(ratio, number);
        });
        style.fill = {
            fill: gradientFill
        };
    }
}

});
parcelRegister("gwwtL", function(module, exports) {

$parcel$export(module.exports, "FillGradient", () => $339e160815705dba$export$722a6ea8c60ca86);

var $a2eTA = parcelRequire("a2eTA");

var $iCGeI = parcelRequire("iCGeI");

var $eY4rt = parcelRequire("eY4rt");

var $aQPld = parcelRequire("aQPld");

var $bLlTJ = parcelRequire("bLlTJ");

var $aGJhg = parcelRequire("aGJhg");
"use strict";
const $339e160815705dba$var$_FillGradient = class _FillGradient {
    constructor(x0, y0, x1, y1){
        /** unique id for this fill gradient */ this.uid = (0, $aGJhg.uid)("fillGradient");
        this.type = "linear";
        this.gradientStops = [];
        this._styleKey = null;
        this.x0 = x0;
        this.y0 = y0;
        this.x1 = x1;
        this.y1 = y1;
    }
    addColorStop(offset, color) {
        this.gradientStops.push({
            offset: offset,
            color: (0, $a2eTA.Color).shared.setValue(color).toHexa()
        });
        this._styleKey = null;
        return this;
    }
    // TODO move to the system!
    buildLinearGradient() {
        const defaultSize = _FillGradient.defaultTextureSize;
        const { gradientStops: gradientStops } = this;
        const canvas = (0, $iCGeI.DOMAdapter).get().createCanvas();
        canvas.width = defaultSize;
        canvas.height = defaultSize;
        const ctx = canvas.getContext("2d");
        const gradient = ctx.createLinearGradient(0, 0, _FillGradient.defaultTextureSize, 1);
        for(let i = 0; i < gradientStops.length; i++){
            const stop = gradientStops[i];
            gradient.addColorStop(stop.offset, stop.color);
        }
        ctx.fillStyle = gradient;
        ctx.fillRect(0, 0, defaultSize, defaultSize);
        this.texture = new (0, $bLlTJ.Texture)({
            source: new (0, $aQPld.ImageSource)({
                resource: canvas,
                addressModeU: "clamp-to-edge",
                addressModeV: "repeat"
            })
        });
        const { x0: x0, y0: y0, x1: x1, y1: y1 } = this;
        const m = new (0, $eY4rt.Matrix)();
        const dx = x1 - x0;
        const dy = y1 - y0;
        const dist = Math.sqrt(dx * dx + dy * dy);
        const angle = Math.atan2(dy, dx);
        m.translate(-x0, -y0);
        m.scale(1 / defaultSize, 1 / defaultSize);
        m.rotate(-angle);
        m.scale(256 / dist, 1);
        this.transform = m;
        this._styleKey = null;
    }
    get styleKey() {
        if (this._styleKey) return this._styleKey;
        const stops = this.gradientStops.map((stop)=>`${stop.offset}-${stop.color}`).join("-");
        const texture = this.texture.uid;
        const transform = this.transform.toArray().join("-");
        return `fill-gradient-${this.uid}-${stops}-${texture}-${transform}-${this.x0}-${this.y0}-${this.x1}-${this.y1}`;
    }
};
$339e160815705dba$var$_FillGradient.defaultTextureSize = 256;
let $339e160815705dba$export$722a6ea8c60ca86 = $339e160815705dba$var$_FillGradient;

});

parcelRegister("ktCpi", function(module, exports) {

$parcel$export(module.exports, "FillPattern", () => $e9923e9fec04a606$export$3d1378c7410cd8e);

var $eY4rt = parcelRequire("eY4rt");

var $aGJhg = parcelRequire("aGJhg");
"use strict";
const $e9923e9fec04a606$var$repetitionMap = {
    repeat: {
        addressModeU: "repeat",
        addressModeV: "repeat"
    },
    "repeat-x": {
        addressModeU: "repeat",
        addressModeV: "clamp-to-edge"
    },
    "repeat-y": {
        addressModeU: "clamp-to-edge",
        addressModeV: "repeat"
    },
    "no-repeat": {
        addressModeU: "clamp-to-edge",
        addressModeV: "clamp-to-edge"
    }
};
class $e9923e9fec04a606$export$3d1378c7410cd8e {
    constructor(texture, repetition){
        /** unique id for this fill pattern */ this.uid = (0, $aGJhg.uid)("fillPattern");
        this.transform = new (0, $eY4rt.Matrix)();
        this._styleKey = null;
        this.texture = texture;
        this.transform.scale(1 / texture.frame.width, 1 / texture.frame.height);
        if (repetition) {
            texture.source.style.addressModeU = $e9923e9fec04a606$var$repetitionMap[repetition].addressModeU;
            texture.source.style.addressModeV = $e9923e9fec04a606$var$repetitionMap[repetition].addressModeV;
        }
    }
    setTransform(transform) {
        const texture = this.texture;
        this.transform.copyFrom(transform);
        this.transform.invert();
        this.transform.scale(1 / texture.frame.width, 1 / texture.frame.height);
        this._styleKey = null;
    }
    get styleKey() {
        if (this._styleKey) return this._styleKey;
        this._styleKey = `fill-pattern-${this.uid}-${this.texture.uid}-${this.transform.toArray().join("-")}`;
        return this._styleKey;
    }
}

});

parcelRegister("8aC7P", function(module, exports) {

$parcel$export(module.exports, "GraphicsContext", () => $5d1287b36eb70f7f$export$cde35afe8b5f985);

var $3vRz3 = parcelRequire("3vRz3");

var $a2eTA = parcelRequire("a2eTA");

var $eY4rt = parcelRequire("eY4rt");

var $1HooC = parcelRequire("1HooC");

var $bLlTJ = parcelRequire("bLlTJ");

var $aGJhg = parcelRequire("aGJhg");

var $kXq8E = parcelRequire("kXq8E");

var $7wtv9 = parcelRequire("7wtv9");

var $c9xxq = parcelRequire("c9xxq");

var $6ph3G = parcelRequire("6ph3G");

var $6mQKv = parcelRequire("6mQKv");
"use strict";
const $5d1287b36eb70f7f$var$tmpPoint = new (0, $1HooC.Point)();
const $5d1287b36eb70f7f$var$tempMatrix = new (0, $eY4rt.Matrix)();
const $5d1287b36eb70f7f$var$_GraphicsContext = class _GraphicsContext extends (0, (/*@__PURE__*/$parcel$interopDefault($3vRz3))) {
    constructor(){
        super(...arguments);
        /** unique id for this graphics context */ this.uid = (0, $aGJhg.uid)("graphicsContext");
        this.dirty = true;
        this.batchMode = "auto";
        this.instructions = [];
        this._activePath = new (0, $c9xxq.GraphicsPath)();
        this._transform = new (0, $eY4rt.Matrix)();
        this._fillStyle = {
            ..._GraphicsContext.defaultFillStyle
        };
        this._strokeStyle = {
            ..._GraphicsContext.defaultStrokeStyle
        };
        this._stateStack = [];
        this._tick = 0;
        this._bounds = new (0, $7wtv9.Bounds)();
        this._boundsDirty = true;
    }
    /**
   * Creates a new GraphicsContext object that is a clone of this instance, copying all properties,
   * including the current drawing state, transformations, styles, and instructions.
   * @returns A new GraphicsContext instance with the same properties and state as this one.
   */ clone() {
        const clone = new _GraphicsContext();
        clone.batchMode = this.batchMode;
        clone.instructions = this.instructions.slice();
        clone._activePath = this._activePath.clone();
        clone._transform = this._transform.clone();
        clone._fillStyle = {
            ...this._fillStyle
        };
        clone._strokeStyle = {
            ...this._strokeStyle
        };
        clone._stateStack = this._stateStack.slice();
        clone._bounds = this._bounds.clone();
        clone._boundsDirty = true;
        return clone;
    }
    /**
   * The current fill style of the graphics context. This can be a color, gradient, pattern, or a more complex style defined by a FillStyle object.
   */ get fillStyle() {
        return this._fillStyle;
    }
    set fillStyle(value) {
        this._fillStyle = (0, $6mQKv.toFillStyle)(value, _GraphicsContext.defaultFillStyle);
    }
    /**
   * The current stroke style of the graphics context. Similar to fill styles, stroke styles can encompass colors, gradients, patterns, or more detailed configurations via a StrokeStyle object.
   */ get strokeStyle() {
        return this._strokeStyle;
    }
    set strokeStyle(value) {
        this._strokeStyle = (0, $6mQKv.toStrokeStyle)(value, _GraphicsContext.defaultStrokeStyle);
    }
    /**
   * Sets the current fill style of the graphics context. The fill style can be a color, gradient,
   * pattern, or a more complex style defined by a FillStyle object.
   * @param style - The fill style to apply. This can be a simple color, a gradient or pattern object,
   *                or a FillStyle or ConvertedFillStyle object.
   * @returns The instance of the current GraphicsContext for method chaining.
   */ setFillStyle(style) {
        this._fillStyle = (0, $6mQKv.toFillStyle)(style, _GraphicsContext.defaultFillStyle);
        return this;
    }
    /**
   * Sets the current stroke style of the graphics context. Similar to fill styles, stroke styles can
   * encompass colors, gradients, patterns, or more detailed configurations via a StrokeStyle object.
   * @param style - The stroke style to apply. Can be defined as a color, a gradient or pattern,
   *                or a StrokeStyle or ConvertedStrokeStyle object.
   * @returns The instance of the current GraphicsContext for method chaining.
   */ setStrokeStyle(style) {
        this._strokeStyle = (0, $6mQKv.toFillStyle)(style, _GraphicsContext.defaultStrokeStyle);
        return this;
    }
    texture(texture, tint, dx, dy, dw, dh) {
        this.instructions.push({
            action: "texture",
            data: {
                image: texture,
                dx: dx || 0,
                dy: dy || 0,
                dw: dw || texture.frame.width,
                dh: dh || texture.frame.height,
                transform: this._transform.clone(),
                alpha: this._fillStyle.alpha,
                style: tint ? (0, $a2eTA.Color).shared.setValue(tint).toNumber() : 16777215
            }
        });
        this.onUpdate();
        return this;
    }
    /**
   * Resets the current path. Any previous path and its commands are discarded and a new path is
   * started. This is typically called before beginning a new shape or series of drawing commands.
   * @returns The instance of the current GraphicsContext for method chaining.
   */ beginPath() {
        this._activePath = new (0, $c9xxq.GraphicsPath)();
        return this;
    }
    fill(style, alpha) {
        let path;
        const lastInstruction = this.instructions[this.instructions.length - 1];
        if (this._tick === 0 && lastInstruction && lastInstruction.action === "stroke") path = lastInstruction.data.path;
        else path = this._activePath.clone();
        if (!path) return this;
        if (style != null) {
            if (alpha !== void 0 && typeof style === "number") {
                (0, $kXq8E.deprecation)((0, $kXq8E.v8_0_0), "GraphicsContext.fill(color, alpha) is deprecated, use GraphicsContext.fill({ color, alpha }) instead");
                style = {
                    color: style,
                    alpha: alpha
                };
            }
            this._fillStyle = (0, $6mQKv.toFillStyle)(style, _GraphicsContext.defaultFillStyle);
        }
        this.instructions.push({
            action: "fill",
            // TODO copy fill style!
            data: {
                style: this.fillStyle,
                path: path
            }
        });
        this.onUpdate();
        this._initNextPathLocation();
        this._tick = 0;
        return this;
    }
    _initNextPathLocation() {
        const { x: x, y: y } = this._activePath.getLastPoint((0, $1HooC.Point).shared);
        this._activePath.clear();
        this._activePath.moveTo(x, y);
    }
    /**
   * Strokes the current path with the current stroke style. This method can take an optional
   * FillInput parameter to define the stroke's appearance, including its color, width, and other properties.
   * @param style - (Optional) The stroke style to apply. Can be defined as a simple color or a more complex style object. If omitted, uses the current stroke style.
   * @returns The instance of the current GraphicsContext for method chaining.
   */ stroke(style) {
        let path;
        const lastInstruction = this.instructions[this.instructions.length - 1];
        if (this._tick === 0 && lastInstruction && lastInstruction.action === "fill") path = lastInstruction.data.path;
        else path = this._activePath.clone();
        if (!path) return this;
        if (style != null) this._strokeStyle = (0, $6mQKv.toStrokeStyle)(style, _GraphicsContext.defaultStrokeStyle);
        this.instructions.push({
            action: "stroke",
            // TODO copy fill style!
            data: {
                style: this.strokeStyle,
                path: path
            }
        });
        this.onUpdate();
        this._initNextPathLocation();
        this._tick = 0;
        return this;
    }
    /**
   * Applies a cutout to the last drawn shape. This is used to create holes or complex shapes by
   * subtracting a path from the previously drawn path. If a hole is not completely in a shape, it will
   * fail to cut correctly!
   * @returns The instance of the current GraphicsContext for method chaining.
   */ cut() {
        for(let i = 0; i < 2; i++){
            const lastInstruction = this.instructions[this.instructions.length - 1 - i];
            const holePath = this._activePath.clone();
            if (lastInstruction) {
                if (lastInstruction.action === "stroke" || lastInstruction.action === "fill") {
                    if (lastInstruction.data.hole) lastInstruction.data.hole.addPath(holePath);
                    else {
                        lastInstruction.data.hole = holePath;
                        break;
                    }
                }
            }
        }
        this._initNextPathLocation();
        return this;
    }
    /**
   * Adds an arc to the current path, which is centered at (x, y) with the specified radius,
   * starting and ending angles, and direction.
   * @param x - The x-coordinate of the arc's center.
   * @param y - The y-coordinate of the arc's center.
   * @param radius - The arc's radius.
   * @param startAngle - The starting angle, in radians.
   * @param endAngle - The ending angle, in radians.
   * @param counterclockwise - (Optional) Specifies whether the arc is drawn counterclockwise (true) or clockwise (false). Defaults to false.
   * @returns The instance of the current GraphicsContext for method chaining.
   */ arc(x, y, radius, startAngle, endAngle, counterclockwise) {
        this._tick++;
        const t = this._transform;
        this._activePath.arc(t.a * x + t.c * y + t.tx, t.b * x + t.d * y + t.ty, radius, startAngle, endAngle, counterclockwise);
        return this;
    }
    /**
   * Adds an arc to the current path with the given control points and radius, connected to the previous point
   * by a straight line if necessary.
   * @param x1 - The x-coordinate of the first control point.
   * @param y1 - The y-coordinate of the first control point.
   * @param x2 - The x-coordinate of the second control point.
   * @param y2 - The y-coordinate of the second control point.
   * @param radius - The arc's radius.
   * @returns The instance of the current GraphicsContext for method chaining.
   */ arcTo(x1, y1, x2, y2, radius) {
        this._tick++;
        const t = this._transform;
        this._activePath.arcTo(t.a * x1 + t.c * y1 + t.tx, t.b * x1 + t.d * y1 + t.ty, t.a * x2 + t.c * y2 + t.tx, t.b * x2 + t.d * y2 + t.ty, radius);
        return this;
    }
    /**
   * Adds an SVG-style arc to the path, allowing for elliptical arcs based on the SVG spec.
   * @param rx - The x-radius of the ellipse.
   * @param ry - The y-radius of the ellipse.
   * @param xAxisRotation - The rotation of the ellipse's x-axis relative
   * to the x-axis of the coordinate system, in degrees.
   * @param largeArcFlag - Determines if the arc should be greater than or less than 180 degrees.
   * @param sweepFlag - Determines if the arc should be swept in a positive angle direction.
   * @param x - The x-coordinate of the arc's end point.
   * @param y - The y-coordinate of the arc's end point.
   * @returns The instance of the current object for chaining.
   */ arcToSvg(rx, ry, xAxisRotation, largeArcFlag, sweepFlag, x, y) {
        this._tick++;
        const t = this._transform;
        this._activePath.arcToSvg(rx, ry, xAxisRotation, // should we rotate this with transform??
        largeArcFlag, sweepFlag, t.a * x + t.c * y + t.tx, t.b * x + t.d * y + t.ty);
        return this;
    }
    /**
   * Adds a cubic Bezier curve to the path.
   * It requires three points: the first two are control points and the third one is the end point.
   * The starting point is the last point in the current path.
   * @param cp1x - The x-coordinate of the first control point.
   * @param cp1y - The y-coordinate of the first control point.
   * @param cp2x - The x-coordinate of the second control point.
   * @param cp2y - The y-coordinate of the second control point.
   * @param x - The x-coordinate of the end point.
   * @param y - The y-coordinate of the end point.
   * @param smoothness - Optional parameter to adjust the smoothness of the curve.
   * @returns The instance of the current object for chaining.
   */ bezierCurveTo(cp1x, cp1y, cp2x, cp2y, x, y, smoothness) {
        this._tick++;
        const t = this._transform;
        this._activePath.bezierCurveTo(t.a * cp1x + t.c * cp1y + t.tx, t.b * cp1x + t.d * cp1y + t.ty, t.a * cp2x + t.c * cp2y + t.tx, t.b * cp2x + t.d * cp2y + t.ty, t.a * x + t.c * y + t.tx, t.b * x + t.d * y + t.ty, smoothness);
        return this;
    }
    /**
   * Closes the current path by drawing a straight line back to the start.
   * If the shape is already closed or there are no points in the path, this method does nothing.
   * @returns The instance of the current object for chaining.
   */ closePath() {
        this._tick++;
        this._activePath?.closePath();
        return this;
    }
    /**
   * Draws an ellipse at the specified location and with the given x and y radii.
   * An optional transformation can be applied, allowing for rotation, scaling, and translation.
   * @param x - The x-coordinate of the center of the ellipse.
   * @param y - The y-coordinate of the center of the ellipse.
   * @param radiusX - The horizontal radius of the ellipse.
   * @param radiusY - The vertical radius of the ellipse.
   * @returns The instance of the current object for chaining.
   */ ellipse(x, y, radiusX, radiusY) {
        this._tick++;
        this._activePath.ellipse(x, y, radiusX, radiusY, this._transform.clone());
        return this;
    }
    /**
   * Draws a circle shape. This method adds a new circle path to the current drawing.
   * @param x - The x-coordinate of the center of the circle.
   * @param y - The y-coordinate of the center of the circle.
   * @param radius - The radius of the circle.
   * @returns The instance of the current object for chaining.
   */ circle(x, y, radius) {
        this._tick++;
        this._activePath.circle(x, y, radius, this._transform.clone());
        return this;
    }
    /**
   * Adds another `GraphicsPath` to this path, optionally applying a transformation.
   * @param path - The `GraphicsPath` to add.
   * @returns The instance of the current object for chaining.
   */ path(path) {
        this._tick++;
        this._activePath.addPath(path, this._transform.clone());
        return this;
    }
    /**
   * Connects the current point to a new point with a straight line. This method updates the current path.
   * @param x - The x-coordinate of the new point to connect to.
   * @param y - The y-coordinate of the new point to connect to.
   * @returns The instance of the current object for chaining.
   */ lineTo(x, y) {
        this._tick++;
        const t = this._transform;
        this._activePath.lineTo(t.a * x + t.c * y + t.tx, t.b * x + t.d * y + t.ty);
        return this;
    }
    /**
   * Sets the starting point for a new sub-path. Any subsequent drawing commands are considered part of this path.
   * @param x - The x-coordinate for the starting point.
   * @param y - The y-coordinate for the starting point.
   * @returns The instance of the current object for chaining.
   */ moveTo(x, y) {
        this._tick++;
        const t = this._transform;
        const instructions = this._activePath.instructions;
        const transformedX = t.a * x + t.c * y + t.tx;
        const transformedY = t.b * x + t.d * y + t.ty;
        if (instructions.length === 1 && instructions[0].action === "moveTo") {
            instructions[0].data[0] = transformedX;
            instructions[0].data[1] = transformedY;
            return this;
        }
        this._activePath.moveTo(transformedX, transformedY);
        return this;
    }
    /**
   * Adds a quadratic curve to the path. It requires two points: the control point and the end point.
   * The starting point is the last point in the current path.
   * @param cpx - The x-coordinate of the control point.
   * @param cpy - The y-coordinate of the control point.
   * @param x - The x-coordinate of the end point.
   * @param y - The y-coordinate of the end point.
   * @param smoothness - Optional parameter to adjust the smoothness of the curve.
   * @returns The instance of the current object for chaining.
   */ quadraticCurveTo(cpx, cpy, x, y, smoothness) {
        this._tick++;
        const t = this._transform;
        this._activePath.quadraticCurveTo(t.a * cpx + t.c * cpy + t.tx, t.b * cpx + t.d * cpy + t.ty, t.a * x + t.c * y + t.tx, t.b * x + t.d * y + t.ty, smoothness);
        return this;
    }
    /**
   * Draws a rectangle shape. This method adds a new rectangle path to the current drawing.
   * @param x - The x-coordinate of the top-left corner of the rectangle.
   * @param y - The y-coordinate of the top-left corner of the rectangle.
   * @param w - The width of the rectangle.
   * @param h - The height of the rectangle.
   * @returns The instance of the current object for chaining.
   */ rect(x, y, w, h) {
        this._tick++;
        this._activePath.rect(x, y, w, h, this._transform.clone());
        return this;
    }
    /**
   * Draws a rectangle with rounded corners.
   * The corner radius can be specified to determine how rounded the corners should be.
   * An optional transformation can be applied, which allows for rotation, scaling, and translation of the rectangle.
   * @param x - The x-coordinate of the top-left corner of the rectangle.
   * @param y - The y-coordinate of the top-left corner of the rectangle.
   * @param w - The width of the rectangle.
   * @param h - The height of the rectangle.
   * @param radius - The radius of the rectangle's corners. If not specified, corners will be sharp.
   * @returns The instance of the current object for chaining.
   */ roundRect(x, y, w, h, radius) {
        this._tick++;
        this._activePath.roundRect(x, y, w, h, radius, this._transform.clone());
        return this;
    }
    /**
   * Draws a polygon shape by specifying a sequence of points. This method allows for the creation of complex polygons,
   * which can be both open and closed. An optional transformation can be applied, enabling the polygon to be scaled,
   * rotated, or translated as needed.
   * @param points - An array of numbers, or an array of PointData objects eg [{x,y}, {x,y}, {x,y}]
   * representing the x and y coordinates, of the polygon's vertices, in sequence.
   * @param close - A boolean indicating whether to close the polygon path. True by default.
   */ poly(points, close) {
        this._tick++;
        this._activePath.poly(points, close, this._transform.clone());
        return this;
    }
    /**
   * Draws a regular polygon with a specified number of sides. All sides and angles are equal.
   * @param x - The x-coordinate of the center of the polygon.
   * @param y - The y-coordinate of the center of the polygon.
   * @param radius - The radius of the circumscribed circle of the polygon.
   * @param sides - The number of sides of the polygon. Must be 3 or more.
   * @param rotation - The rotation angle of the polygon, in radians. Zero by default.
   * @param transform - An optional `Matrix` object to apply a transformation to the polygon.
   * @returns The instance of the current object for chaining.
   */ regularPoly(x, y, radius, sides, rotation = 0, transform) {
        this._tick++;
        this._activePath.regularPoly(x, y, radius, sides, rotation, transform);
        return this;
    }
    /**
   * Draws a polygon with rounded corners.
   * Similar to `regularPoly` but with the ability to round the corners of the polygon.
   * @param x - The x-coordinate of the center of the polygon.
   * @param y - The y-coordinate of the center of the polygon.
   * @param radius - The radius of the circumscribed circle of the polygon.
   * @param sides - The number of sides of the polygon. Must be 3 or more.
   * @param corner - The radius of the rounding of the corners.
   * @param rotation - The rotation angle of the polygon, in radians. Zero by default.
   * @returns The instance of the current object for chaining.
   */ roundPoly(x, y, radius, sides, corner, rotation) {
        this._tick++;
        this._activePath.roundPoly(x, y, radius, sides, corner, rotation);
        return this;
    }
    /**
   * Draws a shape with rounded corners. This function supports custom radius for each corner of the shape.
   * Optionally, corners can be rounded using a quadratic curve instead of an arc, providing a different aesthetic.
   * @param points - An array of `RoundedPoint` representing the corners of the shape to draw.
   * A minimum of 3 points is required.
   * @param radius - The default radius for the corners.
   * This radius is applied to all corners unless overridden in `points`.
   * @param useQuadratic - If set to true, rounded corners are drawn using a quadraticCurve
   *  method instead of an arc method. Defaults to false.
   * @param smoothness - Specifies the smoothness of the curve when `useQuadratic` is true.
   * Higher values make the curve smoother.
   * @returns The instance of the current object for chaining.
   */ roundShape(points, radius, useQuadratic, smoothness) {
        this._tick++;
        this._activePath.roundShape(points, radius, useQuadratic, smoothness);
        return this;
    }
    /**
   * Draw Rectangle with fillet corners. This is much like rounded rectangle
   * however it support negative numbers as well for the corner radius.
   * @param x - Upper left corner of rect
   * @param y - Upper right corner of rect
   * @param width - Width of rect
   * @param height - Height of rect
   * @param fillet - accept negative or positive values
   */ filletRect(x, y, width, height, fillet) {
        this._tick++;
        this._activePath.filletRect(x, y, width, height, fillet);
        return this;
    }
    /**
   * Draw Rectangle with chamfer corners. These are angled corners.
   * @param x - Upper left corner of rect
   * @param y - Upper right corner of rect
   * @param width - Width of rect
   * @param height - Height of rect
   * @param chamfer - non-zero real number, size of corner cutout
   * @param transform
   */ chamferRect(x, y, width, height, chamfer, transform) {
        this._tick++;
        this._activePath.chamferRect(x, y, width, height, chamfer, transform);
        return this;
    }
    /**
   * Draws a star shape centered at a specified location. This method allows for the creation
   *  of stars with a variable number of points, outer radius, optional inner radius, and rotation.
   * The star is drawn as a closed polygon with alternating outer and inner vertices to create the star's points.
   * An optional transformation can be applied to scale, rotate, or translate the star as needed.
   * @param x - The x-coordinate of the center of the star.
   * @param y - The y-coordinate of the center of the star.
   * @param points - The number of points of the star.
   * @param radius - The outer radius of the star (distance from the center to the outer points).
   * @param innerRadius - Optional. The inner radius of the star
   * (distance from the center to the inner points between the outer points).
   * If not provided, defaults to half of the `radius`.
   * @param rotation - Optional. The rotation of the star in radians, where 0 is aligned with the y-axis.
   * Defaults to 0, meaning one point is directly upward.
   * @returns The instance of the current object for chaining further drawing commands.
   */ star(x, y, points, radius, innerRadius = 0, rotation = 0) {
        this._tick++;
        this._activePath.star(x, y, points, radius, innerRadius, rotation, this._transform.clone());
        return this;
    }
    /**
   * Parses and renders an SVG string into the graphics context. This allows for complex shapes and paths
   * defined in SVG format to be drawn within the graphics context.
   * @param svg - The SVG string to be parsed and rendered.
   */ svg(svg) {
        this._tick++;
        (0, $6ph3G.SVGParser)(svg, this);
        return this;
    }
    /**
   * Restores the most recently saved graphics state by popping the top of the graphics state stack.
   * This includes transformations, fill styles, and stroke styles.
   */ restore() {
        const state = this._stateStack.pop();
        if (state) {
            this._transform = state.transform;
            this._fillStyle = state.fillStyle;
            this._strokeStyle = state.strokeStyle;
        }
        return this;
    }
    /** Saves the current graphics state, including transformations, fill styles, and stroke styles, onto a stack. */ save() {
        this._stateStack.push({
            transform: this._transform.clone(),
            fillStyle: {
                ...this._fillStyle
            },
            strokeStyle: {
                ...this._strokeStyle
            }
        });
        return this;
    }
    /**
   * Returns the current transformation matrix of the graphics context.
   * @returns The current transformation matrix.
   */ getTransform() {
        return this._transform;
    }
    /**
   * Resets the current transformation matrix to the identity matrix, effectively removing any transformations (rotation, scaling, translation) previously applied.
   * @returns The instance of the current GraphicsContext for method chaining.
   */ resetTransform() {
        this._transform.identity();
        return this;
    }
    /**
   * Applies a rotation transformation to the graphics context around the current origin.
   * @param angle - The angle of rotation in radians.
   * @returns The instance of the current GraphicsContext for method chaining.
   */ rotate(angle) {
        this._transform.rotate(angle);
        return this;
    }
    /**
   * Applies a scaling transformation to the graphics context, scaling drawings by x horizontally and by y vertically.
   * @param x - The scale factor in the horizontal direction.
   * @param y - (Optional) The scale factor in the vertical direction. If not specified, the x value is used for both directions.
   * @returns The instance of the current GraphicsContext for method chaining.
   */ scale(x, y = x) {
        this._transform.scale(x, y);
        return this;
    }
    setTransform(a, b, c, d, dx, dy) {
        if (a instanceof (0, $eY4rt.Matrix)) {
            this._transform.set(a.a, a.b, a.c, a.d, a.tx, a.ty);
            return this;
        }
        this._transform.set(a, b, c, d, dx, dy);
        return this;
    }
    transform(a, b, c, d, dx, dy) {
        if (a instanceof (0, $eY4rt.Matrix)) {
            this._transform.append(a);
            return this;
        }
        $5d1287b36eb70f7f$var$tempMatrix.set(a, b, c, d, dx, dy);
        this._transform.append($5d1287b36eb70f7f$var$tempMatrix);
        return this;
    }
    /**
   * Applies a translation transformation to the graphics context, moving the origin by the specified amounts.
   * @param x - The amount to translate in the horizontal direction.
   * @param y - (Optional) The amount to translate in the vertical direction. If not specified, the x value is used for both directions.
   * @returns The instance of the current GraphicsContext for method chaining.
   */ translate(x, y = x) {
        this._transform.translate(x, y);
        return this;
    }
    /**
   * Clears all drawing commands from the graphics context, effectively resetting it. This includes clearing the path,
   * and optionally resetting transformations to the identity matrix.
   * @returns The instance of the current GraphicsContext for method chaining.
   */ clear() {
        this._activePath.clear();
        this.instructions.length = 0;
        this.resetTransform();
        this.onUpdate();
        return this;
    }
    onUpdate() {
        if (this.dirty) return;
        this.emit("update", this, 16);
        this.dirty = true;
        this._boundsDirty = true;
    }
    /** The bounds of the graphic shape. */ get bounds() {
        if (!this._boundsDirty) return this._bounds;
        const bounds = this._bounds;
        bounds.clear();
        for(let i = 0; i < this.instructions.length; i++){
            const instruction = this.instructions[i];
            const action = instruction.action;
            if (action === "fill") {
                const data = instruction.data;
                bounds.addBounds(data.path.bounds);
            } else if (action === "texture") {
                const data = instruction.data;
                bounds.addFrame(data.dx, data.dy, data.dx + data.dw, data.dy + data.dh, data.transform);
            }
            if (action === "stroke") {
                const data = instruction.data;
                const padding = data.style.width / 2;
                const _bounds = data.path.bounds;
                bounds.addFrame(_bounds.minX - padding, _bounds.minY - padding, _bounds.maxX + padding, _bounds.maxY + padding);
            }
        }
        return bounds;
    }
    /**
   * Check to see if a point is contained within this geometry.
   * @param point - Point to check if it's contained.
   * @returns {boolean} `true` if the point is contained within geometry.
   */ containsPoint(point) {
        if (!this.bounds.containsPoint(point.x, point.y)) return false;
        const instructions = this.instructions;
        let hasHit = false;
        for(let k = 0; k < instructions.length; k++){
            const instruction = instructions[k];
            const data = instruction.data;
            const path = data.path;
            if (!instruction.action || !path) continue;
            const style = data.style;
            const shapes = path.shapePath.shapePrimitives;
            for(let i = 0; i < shapes.length; i++){
                const shape = shapes[i].shape;
                if (!style || !shape) continue;
                const transform = shapes[i].transform;
                const transformedPoint = transform ? transform.applyInverse(point, $5d1287b36eb70f7f$var$tmpPoint) : point;
                if (instruction.action === "fill") hasHit = shape.contains(transformedPoint.x, transformedPoint.y);
                else hasHit = shape.strokeContains(transformedPoint.x, transformedPoint.y, style.width);
                const holes = data.hole;
                if (holes) {
                    const holeShapes = holes.shapePath?.shapePrimitives;
                    if (holeShapes) {
                        for(let j = 0; j < holeShapes.length; j++)if (holeShapes[j].shape.contains(transformedPoint.x, transformedPoint.y)) hasHit = false;
                    }
                }
                if (hasHit) return true;
            }
        }
        return hasHit;
    }
    /**
   * Destroys the GraphicsData object.
   * @param options - Options parameter. A boolean will act as if all options
   *  have been set to that value
   * @param {boolean} [options.texture=false] - Should it destroy the current texture of the fill/stroke style?
   * @param {boolean} [options.textureSource=false] - Should it destroy the texture source of the fill/stroke style?
   */ destroy(options = false) {
        this._stateStack.length = 0;
        this._transform = null;
        this.emit("destroy", this);
        this.removeAllListeners();
        const destroyTexture = typeof options === "boolean" ? options : options?.texture;
        if (destroyTexture) {
            const destroyTextureSource = typeof options === "boolean" ? options : options?.textureSource;
            if (this._fillStyle.texture) this._fillStyle.texture.destroy(destroyTextureSource);
            if (this._strokeStyle.texture) this._strokeStyle.texture.destroy(destroyTextureSource);
        }
        this._fillStyle = null;
        this._strokeStyle = null;
        this.instructions = null;
        this._activePath = null;
        this._bounds = null;
        this._stateStack = null;
        this.customShader = null;
        this._transform = null;
    }
};
/** The default fill style to use when none is provided. */ $5d1287b36eb70f7f$var$_GraphicsContext.defaultFillStyle = {
    /** The color to use for the fill. */ color: 16777215,
    /** The alpha value to use for the fill. */ alpha: 1,
    /** The texture to use for the fill. */ texture: (0, $bLlTJ.Texture).WHITE,
    /** The matrix to apply. */ matrix: null,
    /** The fill pattern to use. */ fill: null
};
/** The default stroke style to use when none is provided. */ $5d1287b36eb70f7f$var$_GraphicsContext.defaultStrokeStyle = {
    /** The width of the stroke. */ width: 1,
    /** The color to use for the stroke. */ color: 16777215,
    /** The alpha value to use for the stroke. */ alpha: 1,
    /** The alignment of the stroke. */ alignment: 0.5,
    /** The miter limit to use. */ miterLimit: 10,
    /** The line cap style to use. */ cap: "butt",
    /** The line join style to use. */ join: "miter",
    /** The texture to use for the fill. */ texture: (0, $bLlTJ.Texture).WHITE,
    /** The matrix to apply. */ matrix: null,
    /** The fill pattern to use. */ fill: null
};
let $5d1287b36eb70f7f$export$cde35afe8b5f985 = $5d1287b36eb70f7f$var$_GraphicsContext;

});
parcelRegister("c9xxq", function(module, exports) {

$parcel$export(module.exports, "GraphicsPath", () => $0663b1de1906f348$export$7e54506375634c19);

var $1HooC = parcelRequire("1HooC");

var $aGJhg = parcelRequire("aGJhg");

var $hUCK4 = parcelRequire("hUCK4");

var $Zb4t5 = parcelRequire("Zb4t5");

var $ein11 = parcelRequire("ein11");
"use strict";
class $0663b1de1906f348$export$7e54506375634c19 {
    /**
   * Creates a `GraphicsPath` instance optionally from an SVG path string or an array of `PathInstruction`.
   * @param instructions - An SVG path string or an array of `PathInstruction` objects.
   */ constructor(instructions){
        this.instructions = [];
        /** unique id for this graphics path */ this.uid = (0, $aGJhg.uid)("graphicsPath");
        this._dirty = true;
        if (typeof instructions === "string") (0, $Zb4t5.SVGToGraphicsPath)(instructions, this);
        else this.instructions = instructions?.slice() ?? [];
    }
    /**
   * Provides access to the internal shape path, ensuring it is up-to-date with the current instructions.
   * @returns The `ShapePath` instance associated with this `GraphicsPath`.
   */ get shapePath() {
        if (!this._shapePath) this._shapePath = new (0, $ein11.ShapePath)(this);
        if (this._dirty) {
            this._dirty = false;
            this._shapePath.buildPath();
        }
        return this._shapePath;
    }
    /**
   * Adds another `GraphicsPath` to this path, optionally applying a transformation.
   * @param path - The `GraphicsPath` to add.
   * @param transform - An optional transformation to apply to the added path.
   * @returns The instance of the current object for chaining.
   */ addPath(path, transform) {
        path = path.clone();
        this.instructions.push({
            action: "addPath",
            data: [
                path,
                transform
            ]
        });
        this._dirty = true;
        return this;
    }
    arc(...args) {
        this.instructions.push({
            action: "arc",
            data: args
        });
        this._dirty = true;
        return this;
    }
    arcTo(...args) {
        this.instructions.push({
            action: "arcTo",
            data: args
        });
        this._dirty = true;
        return this;
    }
    arcToSvg(...args) {
        this.instructions.push({
            action: "arcToSvg",
            data: args
        });
        this._dirty = true;
        return this;
    }
    bezierCurveTo(...args) {
        this.instructions.push({
            action: "bezierCurveTo",
            data: args
        });
        this._dirty = true;
        return this;
    }
    /**
   * Adds a cubic Bezier curve to the path.
   * It requires two points: the second control point and the end point. The first control point is assumed to be
   * The starting point is the last point in the current path.
   * @param cp2x - The x-coordinate of the second control point.
   * @param cp2y - The y-coordinate of the second control point.
   * @param x - The x-coordinate of the end point.
   * @param y - The y-coordinate of the end point.
   * @param smoothness - Optional parameter to adjust the smoothness of the curve.
   * @returns The instance of the current object for chaining.
   */ bezierCurveToShort(cp2x, cp2y, x, y, smoothness) {
        const last = this.instructions[this.instructions.length - 1];
        const lastPoint = this.getLastPoint((0, $1HooC.Point).shared);
        let cp1x = 0;
        let cp1y = 0;
        if (!last || last.action !== "bezierCurveTo") {
            cp1x = lastPoint.x;
            cp1y = lastPoint.y;
        } else {
            cp1x = last.data[2];
            cp1y = last.data[3];
            const currentX = lastPoint.x;
            const currentY = lastPoint.y;
            cp1x = currentX + (currentX - cp1x);
            cp1y = currentY + (currentY - cp1y);
        }
        this.instructions.push({
            action: "bezierCurveTo",
            data: [
                cp1x,
                cp1y,
                cp2x,
                cp2y,
                x,
                y,
                smoothness
            ]
        });
        this._dirty = true;
        return this;
    }
    /**
   * Closes the current path by drawing a straight line back to the start.
   * If the shape is already closed or there are no points in the path, this method does nothing.
   * @returns The instance of the current object for chaining.
   */ closePath() {
        this.instructions.push({
            action: "closePath",
            data: []
        });
        this._dirty = true;
        return this;
    }
    ellipse(...args) {
        this.instructions.push({
            action: "ellipse",
            data: args
        });
        this._dirty = true;
        return this;
    }
    lineTo(...args) {
        this.instructions.push({
            action: "lineTo",
            data: args
        });
        this._dirty = true;
        return this;
    }
    moveTo(...args) {
        this.instructions.push({
            action: "moveTo",
            data: args
        });
        return this;
    }
    quadraticCurveTo(...args) {
        this.instructions.push({
            action: "quadraticCurveTo",
            data: args
        });
        this._dirty = true;
        return this;
    }
    /**
   * Adds a quadratic curve to the path. It uses the previous point as the control point.
   * @param x - The x-coordinate of the end point.
   * @param y - The y-coordinate of the end point.
   * @param smoothness - Optional parameter to adjust the smoothness of the curve.
   * @returns The instance of the current object for chaining.
   */ quadraticCurveToShort(x, y, smoothness) {
        const last = this.instructions[this.instructions.length - 1];
        const lastPoint = this.getLastPoint((0, $1HooC.Point).shared);
        let cpx1 = 0;
        let cpy1 = 0;
        if (!last || last.action !== "quadraticCurveTo") {
            cpx1 = lastPoint.x;
            cpy1 = lastPoint.y;
        } else {
            cpx1 = last.data[0];
            cpy1 = last.data[1];
            const currentX = lastPoint.x;
            const currentY = lastPoint.y;
            cpx1 = currentX + (currentX - cpx1);
            cpy1 = currentY + (currentY - cpy1);
        }
        this.instructions.push({
            action: "quadraticCurveTo",
            data: [
                cpx1,
                cpy1,
                x,
                y,
                smoothness
            ]
        });
        this._dirty = true;
        return this;
    }
    /**
   * Draws a rectangle shape. This method adds a new rectangle path to the current drawing.
   * @param x - The x-coordinate of the top-left corner of the rectangle.
   * @param y - The y-coordinate of the top-left corner of the rectangle.
   * @param w - The width of the rectangle.
   * @param h - The height of the rectangle.
   * @param transform - An optional `Matrix` object to apply a transformation to the rectangle.
   * @returns The instance of the current object for chaining.
   */ rect(x, y, w, h, transform) {
        this.instructions.push({
            action: "rect",
            data: [
                x,
                y,
                w,
                h,
                transform
            ]
        });
        this._dirty = true;
        return this;
    }
    /**
   * Draws a circle shape. This method adds a new circle path to the current drawing.
   * @param x - The x-coordinate of the center of the circle.
   * @param y - The y-coordinate of the center of the circle.
   * @param radius - The radius of the circle.
   * @param transform - An optional `Matrix` object to apply a transformation to the circle.
   * @returns The instance of the current object for chaining.
   */ circle(x, y, radius, transform) {
        this.instructions.push({
            action: "circle",
            data: [
                x,
                y,
                radius,
                transform
            ]
        });
        this._dirty = true;
        return this;
    }
    roundRect(...args) {
        this.instructions.push({
            action: "roundRect",
            data: args
        });
        this._dirty = true;
        return this;
    }
    poly(...args) {
        this.instructions.push({
            action: "poly",
            data: args
        });
        this._dirty = true;
        return this;
    }
    regularPoly(...args) {
        this.instructions.push({
            action: "regularPoly",
            data: args
        });
        this._dirty = true;
        return this;
    }
    roundPoly(...args) {
        this.instructions.push({
            action: "roundPoly",
            data: args
        });
        this._dirty = true;
        return this;
    }
    roundShape(...args) {
        this.instructions.push({
            action: "roundShape",
            data: args
        });
        this._dirty = true;
        return this;
    }
    filletRect(...args) {
        this.instructions.push({
            action: "filletRect",
            data: args
        });
        this._dirty = true;
        return this;
    }
    chamferRect(...args) {
        this.instructions.push({
            action: "chamferRect",
            data: args
        });
        this._dirty = true;
        return this;
    }
    /**
   * Draws a star shape centered at a specified location. This method allows for the creation
   *  of stars with a variable number of points, outer radius, optional inner radius, and rotation.
   * The star is drawn as a closed polygon with alternating outer and inner vertices to create the star's points.
   * An optional transformation can be applied to scale, rotate, or translate the star as needed.
   * @param x - The x-coordinate of the center of the star.
   * @param y - The y-coordinate of the center of the star.
   * @param points - The number of points of the star.
   * @param radius - The outer radius of the star (distance from the center to the outer points).
   * @param innerRadius - Optional. The inner radius of the star
   * (distance from the center to the inner points between the outer points).
   * If not provided, defaults to half of the `radius`.
   * @param rotation - Optional. The rotation of the star in radians, where 0 is aligned with the y-axis.
   * Defaults to 0, meaning one point is directly upward.
   * @param transform - An optional `Matrix` object to apply a transformation to the star.
   * This can include rotations, scaling, and translations.
   * @returns The instance of the current object for chaining further drawing commands.
   */ // eslint-disable-next-line max-len
    star(x, y, points, radius, innerRadius, rotation, transform) {
        innerRadius = innerRadius || radius / 2;
        const startAngle = -1 * Math.PI / 2 + rotation;
        const len = points * 2;
        const delta = Math.PI * 2 / len;
        const polygon = [];
        for(let i = 0; i < len; i++){
            const r = i % 2 ? innerRadius : radius;
            const angle = i * delta + startAngle;
            polygon.push(x + r * Math.cos(angle), y + r * Math.sin(angle));
        }
        this.poly(polygon, true, transform);
        return this;
    }
    /**
   * Creates a copy of the current `GraphicsPath` instance. This method supports both shallow and deep cloning.
   * A shallow clone copies the reference of the instructions array, while a deep clone creates a new array and
   * copies each instruction individually, ensuring that modifications to the instructions of the cloned `GraphicsPath`
   * do not affect the original `GraphicsPath` and vice versa.
   * @param deep - A boolean flag indicating whether the clone should be deep.
   * @returns A new `GraphicsPath` instance that is a clone of the current instance.
   */ clone(deep = false) {
        const newGraphicsPath2D = new $0663b1de1906f348$export$7e54506375634c19();
        if (!deep) newGraphicsPath2D.instructions = this.instructions.slice();
        else for(let i = 0; i < this.instructions.length; i++){
            const instruction = this.instructions[i];
            newGraphicsPath2D.instructions.push({
                action: instruction.action,
                data: instruction.data.slice()
            });
        }
        return newGraphicsPath2D;
    }
    clear() {
        this.instructions.length = 0;
        this._dirty = true;
        return this;
    }
    /**
   * Applies a transformation matrix to all drawing instructions within the `GraphicsPath`.
   * This method enables the modification of the path's geometry according to the provided
   * transformation matrix, which can include translations, rotations, scaling, and skewing.
   *
   * Each drawing instruction in the path is updated to reflect the transformation,
   * ensuring the visual representation of the path is consistent with the applied matrix.
   *
   * Note: The transformation is applied directly to the coordinates and control points of the drawing instructions,
   * not to the path as a whole. This means the transformation's effects are baked into the individual instructions,
   * allowing for fine-grained control over the path's appearance.
   * @param matrix - A `Matrix` object representing the transformation to apply.
   * @returns The instance of the current object for chaining further operations.
   */ transform(matrix) {
        if (matrix.isIdentity()) return this;
        const a = matrix.a;
        const b = matrix.b;
        const c = matrix.c;
        const d = matrix.d;
        const tx = matrix.tx;
        const ty = matrix.ty;
        let x = 0;
        let y = 0;
        let cpx1 = 0;
        let cpy1 = 0;
        let cpx2 = 0;
        let cpy2 = 0;
        let rx = 0;
        let ry = 0;
        for(let i = 0; i < this.instructions.length; i++){
            const instruction = this.instructions[i];
            const data = instruction.data;
            switch(instruction.action){
                case "moveTo":
                case "lineTo":
                    x = data[0];
                    y = data[1];
                    data[0] = a * x + c * y + tx;
                    data[1] = b * x + d * y + ty;
                    break;
                case "bezierCurveTo":
                    cpx1 = data[0];
                    cpy1 = data[1];
                    cpx2 = data[2];
                    cpy2 = data[3];
                    x = data[4];
                    y = data[5];
                    data[0] = a * cpx1 + c * cpy1 + tx;
                    data[1] = b * cpx1 + d * cpy1 + ty;
                    data[2] = a * cpx2 + c * cpy2 + tx;
                    data[3] = b * cpx2 + d * cpy2 + ty;
                    data[4] = a * x + c * y + tx;
                    data[5] = b * x + d * y + ty;
                    break;
                case "quadraticCurveTo":
                    cpx1 = data[0];
                    cpy1 = data[1];
                    x = data[2];
                    y = data[3];
                    data[0] = a * cpx1 + c * cpy1 + tx;
                    data[1] = b * cpx1 + d * cpy1 + ty;
                    data[2] = a * x + c * y + tx;
                    data[3] = b * x + d * y + ty;
                    break;
                case "arcToSvg":
                    x = data[5];
                    y = data[6];
                    rx = data[0];
                    ry = data[1];
                    data[0] = a * rx + c * ry;
                    data[1] = b * rx + d * ry;
                    data[5] = a * x + c * y + tx;
                    data[6] = b * x + d * y + ty;
                    break;
                case "circle":
                    data[4] = $0663b1de1906f348$var$adjustTransform(data[3], matrix);
                    break;
                case "rect":
                    data[4] = $0663b1de1906f348$var$adjustTransform(data[4], matrix);
                    break;
                case "ellipse":
                    data[8] = $0663b1de1906f348$var$adjustTransform(data[8], matrix);
                    break;
                case "roundRect":
                    data[5] = $0663b1de1906f348$var$adjustTransform(data[5], matrix);
                    break;
                case "addPath":
                    data[0].transform(matrix);
                    break;
                case "poly":
                    data[2] = $0663b1de1906f348$var$adjustTransform(data[2], matrix);
                    break;
                default:
                    (0, $hUCK4.warn)("unknown transform action", instruction.action);
                    break;
            }
        }
        this._dirty = true;
        return this;
    }
    get bounds() {
        return this.shapePath.bounds;
    }
    /**
   * Retrieves the last point from the current drawing instructions in the `GraphicsPath`.
   * This method is useful for operations that depend on the path's current endpoint,
   * such as connecting subsequent shapes or paths. It supports various drawing instructions,
   * ensuring the last point's position is accurately determined regardless of the path's complexity.
   *
   * If the last instruction is a `closePath`, the method iterates backward through the instructions
   *  until it finds an actionable instruction that defines a point (e.g., `moveTo`, `lineTo`,
   * `quadraticCurveTo`, etc.). For compound paths added via `addPath`, it recursively retrieves
   * the last point from the nested path.
   * @param out - A `Point` object where the last point's coordinates will be stored.
   * This object is modified directly to contain the result.
   * @returns The `Point` object containing the last point's coordinates.
   */ getLastPoint(out) {
        let index = this.instructions.length - 1;
        let lastInstruction = this.instructions[index];
        if (!lastInstruction) {
            out.x = 0;
            out.y = 0;
            return out;
        }
        while(lastInstruction.action === "closePath"){
            index--;
            if (index < 0) {
                out.x = 0;
                out.y = 0;
                return out;
            }
            lastInstruction = this.instructions[index];
        }
        switch(lastInstruction.action){
            case "moveTo":
            case "lineTo":
                out.x = lastInstruction.data[0];
                out.y = lastInstruction.data[1];
                break;
            case "quadraticCurveTo":
                out.x = lastInstruction.data[2];
                out.y = lastInstruction.data[3];
                break;
            case "bezierCurveTo":
                out.x = lastInstruction.data[4];
                out.y = lastInstruction.data[5];
                break;
            case "arc":
            case "arcToSvg":
                out.x = lastInstruction.data[5];
                out.y = lastInstruction.data[6];
                break;
            case "addPath":
                lastInstruction.data[0].getLastPoint(out);
                break;
        }
        return out;
    }
}
function $0663b1de1906f348$var$adjustTransform(currentMatrix, transform) {
    if (currentMatrix) return currentMatrix.prepend(transform);
    return transform.clone();
}

});
parcelRegister("Zb4t5", function(module, exports) {

$parcel$export(module.exports, "SVGToGraphicsPath", () => $af4e82628a1183ef$export$14a4a8042d02aa8d);

var $8DJYa = parcelRequire("8DJYa");

var $hUCK4 = parcelRequire("hUCK4");
"use strict";
function $af4e82628a1183ef$export$14a4a8042d02aa8d(svgPath, path) {
    const commands = (0, (/*@__PURE__*/$parcel$interopDefault($8DJYa)))(svgPath);
    const subpaths = [];
    let currentSubPath = null;
    let lastX = 0;
    let lastY = 0;
    for(let i = 0; i < commands.length; i++){
        const command = commands[i];
        const type = command[0];
        const data = command;
        switch(type){
            case "M":
                lastX = data[1];
                lastY = data[2];
                path.moveTo(lastX, lastY);
                break;
            case "m":
                lastX += data[1];
                lastY += data[2];
                path.moveTo(lastX, lastY);
                break;
            case "H":
                lastX = data[1];
                path.lineTo(lastX, lastY);
                break;
            case "h":
                lastX += data[1];
                path.lineTo(lastX, lastY);
                break;
            case "V":
                lastY = data[1];
                path.lineTo(lastX, lastY);
                break;
            case "v":
                lastY += data[1];
                path.lineTo(lastX, lastY);
                break;
            case "L":
                lastX = data[1];
                lastY = data[2];
                path.lineTo(lastX, lastY);
                break;
            case "l":
                lastX += data[1];
                lastY += data[2];
                path.lineTo(lastX, lastY);
                break;
            case "C":
                lastX = data[5];
                lastY = data[6];
                path.bezierCurveTo(data[1], data[2], data[3], data[4], lastX, lastY);
                break;
            case "c":
                path.bezierCurveTo(lastX + data[1], lastY + data[2], lastX + data[3], lastY + data[4], lastX + data[5], lastY + data[6]);
                lastX += data[5];
                lastY += data[6];
                break;
            case "S":
                lastX = data[3];
                lastY = data[4];
                path.bezierCurveToShort(data[1], data[2], lastX, lastY);
                break;
            case "s":
                path.bezierCurveToShort(lastX + data[1], lastY + data[2], lastX + data[3], lastY + data[4]);
                lastX += data[3];
                lastY += data[4];
                break;
            case "Q":
                lastX = data[3];
                lastY = data[4];
                path.quadraticCurveTo(data[1], data[2], lastX, lastY);
                break;
            case "q":
                path.quadraticCurveTo(lastX + data[1], lastY + data[2], lastX + data[3], lastY + data[4]);
                lastX += data[3];
                lastY += data[4];
                break;
            case "T":
                lastX = data[1];
                lastY = data[2];
                path.quadraticCurveToShort(lastX, lastY);
                break;
            case "t":
                lastX += data[1];
                lastY += data[2];
                path.quadraticCurveToShort(lastX, lastY);
                break;
            case "A":
                lastX = data[6];
                lastY = data[7];
                path.arcToSvg(data[1], data[2], data[3], data[4], data[5], lastX, lastY);
                break;
            case "a":
                lastX += data[6];
                lastY += data[7];
                path.arcToSvg(data[1], data[2], data[3], data[4], data[5], lastX, lastY);
                break;
            case "Z":
            case "z":
                path.closePath();
                if (subpaths.length > 0) {
                    currentSubPath = subpaths.pop();
                    if (currentSubPath) {
                        lastX = currentSubPath.startX;
                        lastY = currentSubPath.startY;
                    } else {
                        lastX = 0;
                        lastY = 0;
                    }
                }
                currentSubPath = null;
                break;
            default:
                (0, $hUCK4.warn)(`Unknown SVG path command: ${type}`);
        }
        if (type !== "Z" && type !== "z") {
            if (currentSubPath === null) {
                currentSubPath = {
                    startX: lastX,
                    startY: lastY
                };
                subpaths.push(currentSubPath);
            }
        }
    }
    return path;
}

});
parcelRegister("8DJYa", function(module, exports) {
module.exports = $64a59fcc91535eb3$var$parse;
/**
 * expected argument lengths
 * @type {Object}
 */ var $64a59fcc91535eb3$var$length = {
    a: 7,
    c: 6,
    h: 1,
    l: 2,
    m: 2,
    q: 4,
    s: 4,
    t: 2,
    v: 1,
    z: 0
};
/**
 * segment pattern
 * @type {RegExp}
 */ var $64a59fcc91535eb3$var$segment = /([astvzqmhlc])([^astvzqmhlc]*)/ig;
/**
 * parse an svg path data string. Generates an Array
 * of commands where each command is an Array of the
 * form `[command, arg1, arg2, ...]`
 *
 * @param {String} path
 * @return {Array}
 */ function $64a59fcc91535eb3$var$parse(path) {
    var data = [];
    path.replace($64a59fcc91535eb3$var$segment, function(_, command, args) {
        var type = command.toLowerCase();
        args = $64a59fcc91535eb3$var$parseValues(args);
        // overloaded moveTo
        if (type == "m" && args.length > 2) {
            data.push([
                command
            ].concat(args.splice(0, 2)));
            type = "l";
            command = command == "m" ? "l" : "L";
        }
        while(true){
            if (args.length == $64a59fcc91535eb3$var$length[type]) {
                args.unshift(command);
                return data.push(args);
            }
            if (args.length < $64a59fcc91535eb3$var$length[type]) throw new Error("malformed path data");
            data.push([
                command
            ].concat(args.splice(0, $64a59fcc91535eb3$var$length[type])));
        }
    });
    return data;
}
var $64a59fcc91535eb3$var$number = /-?[0-9]*\.?[0-9]+(?:e[-+]?\d+)?/ig;
function $64a59fcc91535eb3$var$parseValues(args) {
    var numbers = args.match($64a59fcc91535eb3$var$number);
    return numbers ? numbers.map(Number) : [];
}

});


parcelRegister("ein11", function(module, exports) {

$parcel$export(module.exports, "ShapePath", () => $664ff60a6792361f$export$148534a3c727230b);

var $h7nJT = parcelRequire("h7nJT");

var $9hswb = parcelRequire("9hswb");

var $hbpIN = parcelRequire("hbpIN");

var $fM4Mk = parcelRequire("fM4Mk");

var $7u40a = parcelRequire("7u40a");

var $7wtv9 = parcelRequire("7wtv9");

var $lI2iN = parcelRequire("lI2iN");

var $eRV6E = parcelRequire("eRV6E");

var $aiLPr = parcelRequire("aiLPr");

var $boMdH = parcelRequire("boMdH");

var $jjbCG = parcelRequire("jjbCG");

var $9ad7k = parcelRequire("9ad7k");
"use strict";
const $664ff60a6792361f$var$tempRectangle = new (0, $fM4Mk.Rectangle)();
class $664ff60a6792361f$export$148534a3c727230b {
    constructor(graphicsPath2D){
        /** The list of shape primitives that make up the path. */ this.shapePrimitives = [];
        this._currentPoly = null;
        this._bounds = new (0, $7wtv9.Bounds)();
        this._graphicsPath2D = graphicsPath2D;
    }
    /**
   * Sets the starting point for a new sub-path. Any subsequent drawing commands are considered part of this path.
   * @param x - The x-coordinate for the starting point.
   * @param y - The y-coordinate for the starting point.
   * @returns The instance of the current object for chaining.
   */ moveTo(x, y) {
        this.startPoly(x, y);
        return this;
    }
    /**
   * Connects the current point to a new point with a straight line. This method updates the current path.
   * @param x - The x-coordinate of the new point to connect to.
   * @param y - The y-coordinate of the new point to connect to.
   * @returns The instance of the current object for chaining.
   */ lineTo(x, y) {
        this._ensurePoly();
        const points = this._currentPoly.points;
        const fromX = points[points.length - 2];
        const fromY = points[points.length - 1];
        if (fromX !== x || fromY !== y) points.push(x, y);
        return this;
    }
    /**
   * Adds an arc to the path. The arc is centered at (x, y)
   *  position with radius `radius` starting at `startAngle` and ending at `endAngle`.
   * @param x - The x-coordinate of the arc's center.
   * @param y - The y-coordinate of the arc's center.
   * @param radius - The radius of the arc.
   * @param startAngle - The starting angle of the arc, in radians.
   * @param endAngle - The ending angle of the arc, in radians.
   * @param counterclockwise - Specifies whether the arc should be drawn in the anticlockwise direction. False by default.
   * @returns The instance of the current object for chaining.
   */ arc(x, y, radius, startAngle, endAngle, counterclockwise) {
        this._ensurePoly(false);
        const points = this._currentPoly.points;
        (0, $aiLPr.buildArc)(points, x, y, radius, startAngle, endAngle, counterclockwise);
        return this;
    }
    /**
   * Adds an arc to the path with the arc tangent to the line joining two specified points.
   * The arc radius is specified by `radius`.
   * @param x1 - The x-coordinate of the first point.
   * @param y1 - The y-coordinate of the first point.
   * @param x2 - The x-coordinate of the second point.
   * @param y2 - The y-coordinate of the second point.
   * @param radius - The radius of the arc.
   * @returns The instance of the current object for chaining.
   */ arcTo(x1, y1, x2, y2, radius) {
        this._ensurePoly();
        const points = this._currentPoly.points;
        (0, $boMdH.buildArcTo)(points, x1, y1, x2, y2, radius);
        return this;
    }
    /**
   * Adds an SVG-style arc to the path, allowing for elliptical arcs based on the SVG spec.
   * @param rx - The x-radius of the ellipse.
   * @param ry - The y-radius of the ellipse.
   * @param xAxisRotation - The rotation of the ellipse's x-axis relative
   * to the x-axis of the coordinate system, in degrees.
   * @param largeArcFlag - Determines if the arc should be greater than or less than 180 degrees.
   * @param sweepFlag - Determines if the arc should be swept in a positive angle direction.
   * @param x - The x-coordinate of the arc's end point.
   * @param y - The y-coordinate of the arc's end point.
   * @returns The instance of the current object for chaining.
   */ arcToSvg(rx, ry, xAxisRotation, largeArcFlag, sweepFlag, x, y) {
        const points = this._currentPoly.points;
        (0, $jjbCG.buildArcToSvg)(points, this._currentPoly.lastX, this._currentPoly.lastY, x, y, rx, ry, xAxisRotation, largeArcFlag, sweepFlag);
        return this;
    }
    /**
   * Adds a cubic Bezier curve to the path.
   * It requires three points: the first two are control points and the third one is the end point.
   * The starting point is the last point in the current path.
   * @param cp1x - The x-coordinate of the first control point.
   * @param cp1y - The y-coordinate of the first control point.
   * @param cp2x - The x-coordinate of the second control point.
   * @param cp2y - The y-coordinate of the second control point.
   * @param x - The x-coordinate of the end point.
   * @param y - The y-coordinate of the end point.
   * @param smoothness - Optional parameter to adjust the smoothness of the curve.
   * @returns The instance of the current object for chaining.
   */ bezierCurveTo(cp1x, cp1y, cp2x, cp2y, x, y, smoothness) {
        this._ensurePoly();
        const currentPoly = this._currentPoly;
        (0, $lI2iN.buildAdaptiveBezier)(this._currentPoly.points, currentPoly.lastX, currentPoly.lastY, cp1x, cp1y, cp2x, cp2y, x, y, smoothness);
        return this;
    }
    /**
   * Adds a quadratic curve to the path. It requires two points: the control point and the end point.
   * The starting point is the last point in the current path.
   * @param cp1x - The x-coordinate of the control point.
   * @param cp1y - The y-coordinate of the control point.
   * @param x - The x-coordinate of the end point.
   * @param y - The y-coordinate of the end point.
   * @param smoothing - Optional parameter to adjust the smoothness of the curve.
   * @returns The instance of the current object for chaining.
   */ quadraticCurveTo(cp1x, cp1y, x, y, smoothing) {
        this._ensurePoly();
        const currentPoly = this._currentPoly;
        (0, $eRV6E.buildAdaptiveQuadratic)(this._currentPoly.points, currentPoly.lastX, currentPoly.lastY, cp1x, cp1y, x, y, smoothing);
        return this;
    }
    /**
   * Closes the current path by drawing a straight line back to the start.
   * If the shape is already closed or there are no points in the path, this method does nothing.
   * @returns The instance of the current object for chaining.
   */ closePath() {
        this.endPoly(true);
        return this;
    }
    /**
   * Adds another path to the current path. This method allows for the combination of multiple paths into one.
   * @param path - The `GraphicsPath` object representing the path to add.
   * @param transform - An optional `Matrix` object to apply a transformation to the path before adding it.
   * @returns The instance of the current object for chaining.
   */ addPath(path, transform) {
        this.endPoly();
        if (transform && !transform.isIdentity()) {
            path = path.clone(true);
            path.transform(transform);
        }
        for(let i = 0; i < path.instructions.length; i++){
            const instruction = path.instructions[i];
            this[instruction.action](...instruction.data);
        }
        return this;
    }
    /**
   * Finalizes the drawing of the current path. Optionally, it can close the path.
   * @param closePath - A boolean indicating whether to close the path after finishing. False by default.
   */ finish(closePath = false) {
        this.endPoly(closePath);
    }
    /**
   * Draws a rectangle shape. This method adds a new rectangle path to the current drawing.
   * @param x - The x-coordinate of the top-left corner of the rectangle.
   * @param y - The y-coordinate of the top-left corner of the rectangle.
   * @param w - The width of the rectangle.
   * @param h - The height of the rectangle.
   * @param transform - An optional `Matrix` object to apply a transformation to the rectangle.
   * @returns The instance of the current object for chaining.
   */ rect(x, y, w, h, transform) {
        this.drawShape(new (0, $fM4Mk.Rectangle)(x, y, w, h), transform);
        return this;
    }
    /**
   * Draws a circle shape. This method adds a new circle path to the current drawing.
   * @param x - The x-coordinate of the center of the circle.
   * @param y - The y-coordinate of the center of the circle.
   * @param radius - The radius of the circle.
   * @param transform - An optional `Matrix` object to apply a transformation to the circle.
   * @returns The instance of the current object for chaining.
   */ circle(x, y, radius, transform) {
        this.drawShape(new (0, $h7nJT.Circle)(x, y, radius), transform);
        return this;
    }
    /**
   * Draws a polygon shape. This method allows for the creation of complex polygons by specifying a sequence of points.
   * @param points - An array of numbers, or or an array of PointData objects eg [{x,y}, {x,y}, {x,y}]
   * representing the x and y coordinates of the polygon's vertices, in sequence.
   * @param close - A boolean indicating whether to close the polygon path. True by default.
   * @param transform - An optional `Matrix` object to apply a transformation to the polygon.
   * @returns The instance of the current object for chaining.
   */ poly(points, close, transform) {
        const polygon = new (0, $hbpIN.Polygon)(points);
        polygon.closePath = close;
        this.drawShape(polygon, transform);
        return this;
    }
    /**
   * Draws a regular polygon with a specified number of sides. All sides and angles are equal.
   * @param x - The x-coordinate of the center of the polygon.
   * @param y - The y-coordinate of the center of the polygon.
   * @param radius - The radius of the circumscribed circle of the polygon.
   * @param sides - The number of sides of the polygon. Must be 3 or more.
   * @param rotation - The rotation angle of the polygon, in radians. Zero by default.
   * @param transform - An optional `Matrix` object to apply a transformation to the polygon.
   * @returns The instance of the current object for chaining.
   */ regularPoly(x, y, radius, sides, rotation = 0, transform) {
        sides = Math.max(sides | 0, 3);
        const startAngle = -1 * Math.PI / 2 + rotation;
        const delta = Math.PI * 2 / sides;
        const polygon = [];
        for(let i = 0; i < sides; i++){
            const angle = i * delta + startAngle;
            polygon.push(x + radius * Math.cos(angle), y + radius * Math.sin(angle));
        }
        this.poly(polygon, true, transform);
        return this;
    }
    /**
   * Draws a polygon with rounded corners.
   * Similar to `regularPoly` but with the ability to round the corners of the polygon.
   * @param x - The x-coordinate of the center of the polygon.
   * @param y - The y-coordinate of the center of the polygon.
   * @param radius - The radius of the circumscribed circle of the polygon.
   * @param sides - The number of sides of the polygon. Must be 3 or more.
   * @param corner - The radius of the rounding of the corners.
   * @param rotation - The rotation angle of the polygon, in radians. Zero by default.
   * @param smoothness - Optional parameter to adjust the smoothness of the rounding.
   * @returns The instance of the current object for chaining.
   */ roundPoly(x, y, radius, sides, corner, rotation = 0, smoothness) {
        sides = Math.max(sides | 0, 3);
        if (corner <= 0) return this.regularPoly(x, y, radius, sides, rotation);
        const sideLength = radius * Math.sin(Math.PI / sides) - 1e-3;
        corner = Math.min(corner, sideLength);
        const startAngle = -1 * Math.PI / 2 + rotation;
        const delta = Math.PI * 2 / sides;
        const internalAngle = (sides - 2) * Math.PI / sides / 2;
        for(let i = 0; i < sides; i++){
            const angle = i * delta + startAngle;
            const x0 = x + radius * Math.cos(angle);
            const y0 = y + radius * Math.sin(angle);
            const a1 = angle + Math.PI + internalAngle;
            const a2 = angle - Math.PI - internalAngle;
            const x1 = x0 + corner * Math.cos(a1);
            const y1 = y0 + corner * Math.sin(a1);
            const x3 = x0 + corner * Math.cos(a2);
            const y3 = y0 + corner * Math.sin(a2);
            if (i === 0) this.moveTo(x1, y1);
            else this.lineTo(x1, y1);
            this.quadraticCurveTo(x0, y0, x3, y3, smoothness);
        }
        return this.closePath();
    }
    /**
   * Draws a shape with rounded corners. This function supports custom radius for each corner of the shape.
   * Optionally, corners can be rounded using a quadratic curve instead of an arc, providing a different aesthetic.
   * @param points - An array of `RoundedPoint` representing the corners of the shape to draw.
   * A minimum of 3 points is required.
   * @param radius - The default radius for the corners.
   * This radius is applied to all corners unless overridden in `points`.
   * @param useQuadratic - If set to true, rounded corners are drawn using a quadraticCurve
   *  method instead of an arc method. Defaults to false.
   * @param smoothness - Specifies the smoothness of the curve when `useQuadratic` is true.
   * Higher values make the curve smoother.
   * @returns The instance of the current object for chaining.
   */ roundShape(points, radius, useQuadratic = false, smoothness) {
        if (points.length < 3) return this;
        if (useQuadratic) (0, $9ad7k.roundedShapeQuadraticCurve)(this, points, radius, smoothness);
        else (0, $9ad7k.roundedShapeArc)(this, points, radius);
        return this.closePath();
    }
    /**
   * Draw Rectangle with fillet corners. This is much like rounded rectangle
   * however it support negative numbers as well for the corner radius.
   * @param x - Upper left corner of rect
   * @param y - Upper right corner of rect
   * @param width - Width of rect
   * @param height - Height of rect
   * @param fillet - accept negative or positive values
   */ filletRect(x, y, width, height, fillet) {
        if (fillet === 0) return this.rect(x, y, width, height);
        const maxFillet = Math.min(width, height) / 2;
        const inset = Math.min(maxFillet, Math.max(-maxFillet, fillet));
        const right = x + width;
        const bottom = y + height;
        const dir = inset < 0 ? -inset : 0;
        const size = Math.abs(inset);
        return this.moveTo(x, y + size).arcTo(x + dir, y + dir, x + size, y, size).lineTo(right - size, y).arcTo(right - dir, y + dir, right, y + size, size).lineTo(right, bottom - size).arcTo(right - dir, bottom - dir, x + width - size, bottom, size).lineTo(x + size, bottom).arcTo(x + dir, bottom - dir, x, bottom - size, size).closePath();
    }
    /**
   * Draw Rectangle with chamfer corners. These are angled corners.
   * @param x - Upper left corner of rect
   * @param y - Upper right corner of rect
   * @param width - Width of rect
   * @param height - Height of rect
   * @param chamfer - non-zero real number, size of corner cutout
   * @param transform
   */ chamferRect(x, y, width, height, chamfer, transform) {
        if (chamfer <= 0) return this.rect(x, y, width, height);
        const inset = Math.min(chamfer, Math.min(width, height) / 2);
        const right = x + width;
        const bottom = y + height;
        const points = [
            x + inset,
            y,
            right - inset,
            y,
            right,
            y + inset,
            right,
            bottom - inset,
            right - inset,
            bottom,
            x + inset,
            bottom,
            x,
            bottom - inset,
            x,
            y + inset
        ];
        for(let i = points.length - 1; i >= 2; i -= 2)if (points[i] === points[i - 2] && points[i - 1] === points[i - 3]) points.splice(i - 1, 2);
        return this.poly(points, true, transform);
    }
    /**
   * Draws an ellipse at the specified location and with the given x and y radii.
   * An optional transformation can be applied, allowing for rotation, scaling, and translation.
   * @param x - The x-coordinate of the center of the ellipse.
   * @param y - The y-coordinate of the center of the ellipse.
   * @param radiusX - The horizontal radius of the ellipse.
   * @param radiusY - The vertical radius of the ellipse.
   * @param transform - An optional `Matrix` object to apply a transformation to the ellipse. This can include rotations.
   * @returns The instance of the current object for chaining.
   */ ellipse(x, y, radiusX, radiusY, transform) {
        this.drawShape(new (0, $9hswb.Ellipse)(x, y, radiusX, radiusY), transform);
        return this;
    }
    /**
   * Draws a rectangle with rounded corners.
   * The corner radius can be specified to determine how rounded the corners should be.
   * An optional transformation can be applied, which allows for rotation, scaling, and translation of the rectangle.
   * @param x - The x-coordinate of the top-left corner of the rectangle.
   * @param y - The y-coordinate of the top-left corner of the rectangle.
   * @param w - The width of the rectangle.
   * @param h - The height of the rectangle.
   * @param radius - The radius of the rectangle's corners. If not specified, corners will be sharp.
   * @param transform - An optional `Matrix` object to apply a transformation to the rectangle.
   * @returns The instance of the current object for chaining.
   */ roundRect(x, y, w, h, radius, transform) {
        this.drawShape(new (0, $7u40a.RoundedRectangle)(x, y, w, h, radius), transform);
        return this;
    }
    /**
   * Draws a given shape on the canvas.
   * This is a generic method that can draw any type of shape specified by the `ShapePrimitive` parameter.
   * An optional transformation matrix can be applied to the shape, allowing for complex transformations.
   * @param shape - The shape to draw, defined as a `ShapePrimitive` object.
   * @param matrix - An optional `Matrix` for transforming the shape. This can include rotations,
   * scaling, and translations.
   * @returns The instance of the current object for chaining.
   */ drawShape(shape, matrix) {
        this.endPoly();
        this.shapePrimitives.push({
            shape: shape,
            transform: matrix
        });
        return this;
    }
    /**
   * Starts a new polygon path from the specified starting point.
   * This method initializes a new polygon or ends the current one if it exists.
   * @param x - The x-coordinate of the starting point of the new polygon.
   * @param y - The y-coordinate of the starting point of the new polygon.
   * @returns The instance of the current object for chaining.
   */ startPoly(x, y) {
        let currentPoly = this._currentPoly;
        if (currentPoly) this.endPoly();
        currentPoly = new (0, $hbpIN.Polygon)();
        currentPoly.points.push(x, y);
        this._currentPoly = currentPoly;
        return this;
    }
    /**
   * Ends the current polygon path. If `closePath` is set to true,
   * the path is closed by connecting the last point to the first one.
   * This method finalizes the current polygon and prepares it for drawing or adding to the shape primitives.
   * @param closePath - A boolean indicating whether to close the polygon by connecting the last point
   *  back to the starting point. False by default.
   * @returns The instance of the current object for chaining.
   */ endPoly(closePath = false) {
        const shape = this._currentPoly;
        if (shape && shape.points.length > 2) {
            shape.closePath = closePath;
            this.shapePrimitives.push({
                shape: shape
            });
        }
        this._currentPoly = null;
        return this;
    }
    _ensurePoly(start = true) {
        if (this._currentPoly) return;
        this._currentPoly = new (0, $hbpIN.Polygon)();
        if (start) {
            const lastShape = this.shapePrimitives[this.shapePrimitives.length - 1];
            if (lastShape) {
                let lx = lastShape.shape.x;
                let ly = lastShape.shape.y;
                if (lastShape.transform && !lastShape.transform.isIdentity()) {
                    const t = lastShape.transform;
                    const tempX = lx;
                    lx = t.a * lx + t.c * ly + t.tx;
                    ly = t.b * tempX + t.d * ly + t.ty;
                }
                this._currentPoly.points.push(lx, ly);
            } else this._currentPoly.points.push(0, 0);
        }
    }
    /** Builds the path. */ buildPath() {
        const path = this._graphicsPath2D;
        this.shapePrimitives.length = 0;
        this._currentPoly = null;
        for(let i = 0; i < path.instructions.length; i++){
            const instruction = path.instructions[i];
            this[instruction.action](...instruction.data);
        }
        this.finish();
    }
    /** Gets the bounds of the path. */ get bounds() {
        const bounds = this._bounds;
        bounds.clear();
        const shapePrimitives = this.shapePrimitives;
        for(let i = 0; i < shapePrimitives.length; i++){
            const shapePrimitive = shapePrimitives[i];
            const boundsRect = shapePrimitive.shape.getBounds($664ff60a6792361f$var$tempRectangle);
            if (shapePrimitive.transform) bounds.addRect(boundsRect, shapePrimitive.transform);
            else bounds.addRect(boundsRect);
        }
        return bounds;
    }
}

});
parcelRegister("h7nJT", function(module, exports) {

$parcel$export(module.exports, "Circle", () => $f9e7c5f8c3846477$export$c89a927ffc67e6fa);

var $fM4Mk = parcelRequire("fM4Mk");
"use strict";
class $f9e7c5f8c3846477$export$c89a927ffc67e6fa {
    /**
   * @param x - The X coordinate of the center of this circle
   * @param y - The Y coordinate of the center of this circle
   * @param radius - The radius of the circle
   */ constructor(x = 0, y = 0, radius = 0){
        /**
     * The type of the object, mainly used to avoid `instanceof` checks
     * @default 'circle'
     */ this.type = "circle";
        this.x = x;
        this.y = y;
        this.radius = radius;
    }
    /**
   * Creates a clone of this Circle instance
   * @returns A copy of the Circle
   */ clone() {
        return new $f9e7c5f8c3846477$export$c89a927ffc67e6fa(this.x, this.y, this.radius);
    }
    /**
   * Checks whether the x and y coordinates given are contained within this circle
   * @param x - The X coordinate of the point to test
   * @param y - The Y coordinate of the point to test
   * @returns Whether the x/y coordinates are within this Circle
   */ contains(x, y) {
        if (this.radius <= 0) return false;
        const r2 = this.radius * this.radius;
        let dx = this.x - x;
        let dy = this.y - y;
        dx *= dx;
        dy *= dy;
        return dx + dy <= r2;
    }
    /**
   * Checks whether the x and y coordinates given are contained within this circle including the stroke.
   * @param x - The X coordinate of the point to test
   * @param y - The Y coordinate of the point to test
   * @param width - The width of the line to check
   * @returns Whether the x/y coordinates are within this Circle
   */ strokeContains(x, y, width) {
        if (this.radius === 0) return false;
        const dx = this.x - x;
        const dy = this.y - y;
        const r = this.radius;
        const w2 = width / 2;
        const distance = Math.sqrt(dx * dx + dy * dy);
        return distance < r + w2 && distance > r - w2;
    }
    /**
   * Returns the framing rectangle of the circle as a Rectangle object
   * @param out
   * @returns The framing rectangle
   */ getBounds(out) {
        out = out || new (0, $fM4Mk.Rectangle)();
        out.x = this.x - this.radius;
        out.y = this.y - this.radius;
        out.width = this.radius * 2;
        out.height = this.radius * 2;
        return out;
    }
    /**
   * Copies another circle to this one.
   * @param circle - The circle to copy from.
   * @returns Returns itself.
   */ copyFrom(circle) {
        this.x = circle.x;
        this.y = circle.y;
        this.radius = circle.radius;
        return this;
    }
    /**
   * Copies this circle to another one.
   * @param circle - The circle to copy to.
   * @returns Returns given parameter.
   */ copyTo(circle) {
        circle.copyFrom(this);
        return circle;
    }
    toString() {
        return `[pixi.js/math:Circle x=${this.x} y=${this.y} radius=${this.radius}]`;
    }
}

});

parcelRegister("9hswb", function(module, exports) {

$parcel$export(module.exports, "Ellipse", () => $985c1ca392a56bd1$export$80b0269ab108fa11);

var $fM4Mk = parcelRequire("fM4Mk");
"use strict";
class $985c1ca392a56bd1$export$80b0269ab108fa11 {
    /**
   * @param x - The X coordinate of the center of this ellipse
   * @param y - The Y coordinate of the center of this ellipse
   * @param halfWidth - The half width of this ellipse
   * @param halfHeight - The half height of this ellipse
   */ constructor(x = 0, y = 0, halfWidth = 0, halfHeight = 0){
        /**
     * The type of the object, mainly used to avoid `instanceof` checks
     * @default 'ellipse'
     */ this.type = "ellipse";
        this.x = x;
        this.y = y;
        this.halfWidth = halfWidth;
        this.halfHeight = halfHeight;
    }
    /**
   * Creates a clone of this Ellipse instance
   * @returns {Ellipse} A copy of the ellipse
   */ clone() {
        return new $985c1ca392a56bd1$export$80b0269ab108fa11(this.x, this.y, this.halfWidth, this.halfHeight);
    }
    /**
   * Checks whether the x and y coordinates given are contained within this ellipse
   * @param x - The X coordinate of the point to test
   * @param y - The Y coordinate of the point to test
   * @returns Whether the x/y coords are within this ellipse
   */ contains(x, y) {
        if (this.halfWidth <= 0 || this.halfHeight <= 0) return false;
        let normx = (x - this.x) / this.halfWidth;
        let normy = (y - this.y) / this.halfHeight;
        normx *= normx;
        normy *= normy;
        return normx + normy <= 1;
    }
    /**
   * Checks whether the x and y coordinates given are contained within this ellipse including stroke
   * @param x - The X coordinate of the point to test
   * @param y - The Y coordinate of the point to test
   * @param width
   * @returns Whether the x/y coords are within this ellipse
   */ strokeContains(x, y, width) {
        const { halfWidth: halfWidth, halfHeight: halfHeight } = this;
        if (halfWidth <= 0 || halfHeight <= 0) return false;
        const halfStrokeWidth = width / 2;
        const innerA = halfWidth - halfStrokeWidth;
        const innerB = halfHeight - halfStrokeWidth;
        const outerA = halfWidth + halfStrokeWidth;
        const outerB = halfHeight + halfStrokeWidth;
        const normalizedX = x - this.x;
        const normalizedY = y - this.y;
        const innerEllipse = normalizedX * normalizedX / (innerA * innerA) + normalizedY * normalizedY / (innerB * innerB);
        const outerEllipse = normalizedX * normalizedX / (outerA * outerA) + normalizedY * normalizedY / (outerB * outerB);
        return innerEllipse > 1 && outerEllipse <= 1;
    }
    /**
   * Returns the framing rectangle of the ellipse as a Rectangle object
   * @param out
   * @returns The framing rectangle
   */ getBounds(out) {
        out = out || new (0, $fM4Mk.Rectangle)();
        out.x = this.x - this.halfWidth;
        out.y = this.y - this.halfHeight;
        out.width = this.halfWidth * 2;
        out.height = this.halfHeight * 2;
        return out;
    }
    /**
   * Copies another ellipse to this one.
   * @param ellipse - The ellipse to copy from.
   * @returns Returns itself.
   */ copyFrom(ellipse) {
        this.x = ellipse.x;
        this.y = ellipse.y;
        this.halfWidth = ellipse.halfWidth;
        this.halfHeight = ellipse.halfHeight;
        return this;
    }
    /**
   * Copies this ellipse to another one.
   * @param ellipse - The ellipse to copy to.
   * @returns Returns given parameter.
   */ copyTo(ellipse) {
        ellipse.copyFrom(this);
        return ellipse;
    }
    toString() {
        return `[pixi.js/math:Ellipse x=${this.x} y=${this.y} halfWidth=${this.halfWidth} halfHeight=${this.halfHeight}]`;
    }
}

});

parcelRegister("hbpIN", function(module, exports) {

$parcel$export(module.exports, "Polygon", () => $11dc5aebdc9b56ee$export$7d31b617c820d435);

var $4sAiw = parcelRequire("4sAiw");

var $fM4Mk = parcelRequire("fM4Mk");
"use strict";
class $11dc5aebdc9b56ee$export$7d31b617c820d435 {
    /**
   * @param points - This can be an array of Points
   *  that form the polygon, a flat array of numbers that will be interpreted as [x,y, x,y, ...], or
   *  the arguments passed can be all the points of the polygon e.g.
   *  `new Polygon(new Point(), new Point(), ...)`, or the arguments passed can be flat
   *  x,y values e.g. `new Polygon(x,y, x,y, x,y, ...)` where `x` and `y` are Numbers.
   */ constructor(...points){
        /**
     * The type of the object, mainly used to avoid `instanceof` checks
     * @default 'polygon'
     */ this.type = "polygon";
        let flat = Array.isArray(points[0]) ? points[0] : points;
        if (typeof flat[0] !== "number") {
            const p = [];
            for(let i = 0, il = flat.length; i < il; i++)p.push(flat[i].x, flat[i].y);
            flat = p;
        }
        this.points = flat;
        this.closePath = true;
    }
    /**
   * Creates a clone of this polygon.
   * @returns - A copy of the polygon.
   */ clone() {
        const points = this.points.slice();
        const polygon = new $11dc5aebdc9b56ee$export$7d31b617c820d435(points);
        polygon.closePath = this.closePath;
        return polygon;
    }
    /**
   * Checks whether the x and y coordinates passed to this function are contained within this polygon.
   * @param x - The X coordinate of the point to test.
   * @param y - The Y coordinate of the point to test.
   * @returns - Whether the x/y coordinates are within this polygon.
   */ contains(x, y) {
        let inside = false;
        const length = this.points.length / 2;
        for(let i = 0, j = length - 1; i < length; j = i++){
            const xi = this.points[i * 2];
            const yi = this.points[i * 2 + 1];
            const xj = this.points[j * 2];
            const yj = this.points[j * 2 + 1];
            const intersect = yi > y !== yj > y && x < (xj - xi) * ((y - yi) / (yj - yi)) + xi;
            if (intersect) inside = !inside;
        }
        return inside;
    }
    /**
   * Checks whether the x and y coordinates given are contained within this polygon including the stroke.
   * @param x - The X coordinate of the point to test
   * @param y - The Y coordinate of the point to test
   * @param strokeWidth - The width of the line to check
   * @returns Whether the x/y coordinates are within this polygon
   */ strokeContains(x, y, strokeWidth) {
        const halfStrokeWidth = strokeWidth / 2;
        const halfStrokeWidthSqrd = halfStrokeWidth * halfStrokeWidth;
        const { points: points } = this;
        const iterationLength = points.length - (this.closePath ? 0 : 2);
        for(let i = 0; i < iterationLength; i += 2){
            const x1 = points[i];
            const y1 = points[i + 1];
            const x2 = points[(i + 2) % points.length];
            const y2 = points[(i + 3) % points.length];
            const distanceSqrd = (0, $4sAiw.squaredDistanceToLineSegment)(x, y, x1, y1, x2, y2);
            if (distanceSqrd <= halfStrokeWidthSqrd) return true;
        }
        return false;
    }
    /**
   * Returns the framing rectangle of the polygon as a Rectangle object
   * @param out - optional rectangle to store the result
   * @returns The framing rectangle
   */ getBounds(out) {
        out = out || new (0, $fM4Mk.Rectangle)();
        const points = this.points;
        let minX = Infinity;
        let maxX = -Infinity;
        let minY = Infinity;
        let maxY = -Infinity;
        for(let i = 0, n = points.length; i < n; i += 2){
            const x = points[i];
            const y = points[i + 1];
            minX = x < minX ? x : minX;
            maxX = x > maxX ? x : maxX;
            minY = y < minY ? y : minY;
            maxY = y > maxY ? y : maxY;
        }
        out.x = minX;
        out.width = maxX - minX;
        out.y = minY;
        out.height = maxY - minY;
        return out;
    }
    /**
   * Copies another polygon to this one.
   * @param polygon - The polygon to copy from.
   * @returns Returns itself.
   */ copyFrom(polygon) {
        this.points = polygon.points.slice();
        this.closePath = polygon.closePath;
        return this;
    }
    /**
   * Copies this polygon to another one.
   * @param polygon - The polygon to copy to.
   * @returns Returns given parameter.
   */ copyTo(polygon) {
        polygon.copyFrom(this);
        return polygon;
    }
    toString() {
        return `[pixi.js/math:PolygoncloseStroke=${this.closePath}points=${this.points.reduce((pointsDesc, currentPoint)=>`${pointsDesc}, ${currentPoint}`, "")}]`;
    }
    /**
   * Get the last X coordinate of the polygon
   * @readonly
   */ get lastX() {
        return this.points[this.points.length - 2];
    }
    /**
   * Get the last Y coordinate of the polygon
   * @readonly
   */ get lastY() {
        return this.points[this.points.length - 1];
    }
    /**
   * Get the first X coordinate of the polygon
   * @readonly
   */ get x() {
        return this.points[this.points.length - 2];
    }
    /**
   * Get the first Y coordinate of the polygon
   * @readonly
   */ get y() {
        return this.points[this.points.length - 1];
    }
}

});
parcelRegister("4sAiw", function(module, exports) {

$parcel$export(module.exports, "squaredDistanceToLineSegment", () => $95fee67952e97042$export$db32ff20ff695a);
"use strict";
function $95fee67952e97042$export$db32ff20ff695a(x, y, x1, y1, x2, y2) {
    const a = x - x1;
    const b = y - y1;
    const c = x2 - x1;
    const d = y2 - y1;
    const dot = a * c + b * d;
    const lenSq = c * c + d * d;
    let param = -1;
    if (lenSq !== 0) param = dot / lenSq;
    let xx;
    let yy;
    if (param < 0) {
        xx = x1;
        yy = y1;
    } else if (param > 1) {
        xx = x2;
        yy = y2;
    } else {
        xx = x1 + param * c;
        yy = y1 + param * d;
    }
    const dx = x - xx;
    const dy = y - yy;
    return dx * dx + dy * dy;
}

});


parcelRegister("7u40a", function(module, exports) {

$parcel$export(module.exports, "RoundedRectangle", () => $019041c7bdb3bf3e$export$d55ab2e3dc5a4263);

var $fM4Mk = parcelRequire("fM4Mk");
"use strict";
const $019041c7bdb3bf3e$var$isCornerWithinStroke = (pX, pY, cornerX, cornerY, radius, halfStrokeWidth)=>{
    const dx = pX - cornerX;
    const dy = pY - cornerY;
    const distance = Math.sqrt(dx * dx + dy * dy);
    return distance >= radius - halfStrokeWidth && distance <= radius + halfStrokeWidth;
};
class $019041c7bdb3bf3e$export$d55ab2e3dc5a4263 {
    /**
   * @param x - The X coordinate of the upper-left corner of the rounded rectangle
   * @param y - The Y coordinate of the upper-left corner of the rounded rectangle
   * @param width - The overall width of this rounded rectangle
   * @param height - The overall height of this rounded rectangle
   * @param radius - Controls the radius of the rounded corners
   */ constructor(x = 0, y = 0, width = 0, height = 0, radius = 20){
        /**
     * The type of the object, mainly used to avoid `instanceof` checks
     * @default 'roundedRectangle'
     */ this.type = "roundedRectangle";
        this.x = x;
        this.y = y;
        this.width = width;
        this.height = height;
        this.radius = radius;
    }
    /**
   * Returns the framing rectangle of the rounded rectangle as a Rectangle object
   * @param out - optional rectangle to store the result
   * @returns The framing rectangle
   */ getBounds(out) {
        out = out || new (0, $fM4Mk.Rectangle)();
        out.x = this.x;
        out.y = this.y;
        out.width = this.width;
        out.height = this.height;
        return out;
    }
    /**
   * Creates a clone of this Rounded Rectangle.
   * @returns - A copy of the rounded rectangle.
   */ clone() {
        return new $019041c7bdb3bf3e$export$d55ab2e3dc5a4263(this.x, this.y, this.width, this.height, this.radius);
    }
    /**
   * Copies another rectangle to this one.
   * @param rectangle - The rectangle to copy from.
   * @returns Returns itself.
   */ copyFrom(rectangle) {
        this.x = rectangle.x;
        this.y = rectangle.y;
        this.width = rectangle.width;
        this.height = rectangle.height;
        return this;
    }
    /**
   * Copies this rectangle to another one.
   * @param rectangle - The rectangle to copy to.
   * @returns Returns given parameter.
   */ copyTo(rectangle) {
        rectangle.copyFrom(this);
        return rectangle;
    }
    /**
   * Checks whether the x and y coordinates given are contained within this Rounded Rectangle
   * @param x - The X coordinate of the point to test.
   * @param y - The Y coordinate of the point to test.
   * @returns - Whether the x/y coordinates are within this Rounded Rectangle.
   */ contains(x, y) {
        if (this.width <= 0 || this.height <= 0) return false;
        if (x >= this.x && x <= this.x + this.width) {
            if (y >= this.y && y <= this.y + this.height) {
                const radius = Math.max(0, Math.min(this.radius, Math.min(this.width, this.height) / 2));
                if (y >= this.y + radius && y <= this.y + this.height - radius || x >= this.x + radius && x <= this.x + this.width - radius) return true;
                let dx = x - (this.x + radius);
                let dy = y - (this.y + radius);
                const radius2 = radius * radius;
                if (dx * dx + dy * dy <= radius2) return true;
                dx = x - (this.x + this.width - radius);
                if (dx * dx + dy * dy <= radius2) return true;
                dy = y - (this.y + this.height - radius);
                if (dx * dx + dy * dy <= radius2) return true;
                dx = x - (this.x + radius);
                if (dx * dx + dy * dy <= radius2) return true;
            }
        }
        return false;
    }
    /**
   * Checks whether the x and y coordinates given are contained within this rectangle including the stroke.
   * @param pX - The X coordinate of the point to test
   * @param pY - The Y coordinate of the point to test
   * @param strokeWidth - The width of the line to check
   * @returns Whether the x/y coordinates are within this rectangle
   */ strokeContains(pX, pY, strokeWidth) {
        const { x: x, y: y, width: width, height: height, radius: radius } = this;
        const halfStrokeWidth = strokeWidth / 2;
        const innerX = x + radius;
        const innerY = y + radius;
        const innerWidth = width - radius * 2;
        const innerHeight = height - radius * 2;
        const rightBound = x + width;
        const bottomBound = y + height;
        if ((pX >= x - halfStrokeWidth && pX <= x + halfStrokeWidth || pX >= rightBound - halfStrokeWidth && pX <= rightBound + halfStrokeWidth) && pY >= innerY && pY <= innerY + innerHeight) return true;
        if ((pY >= y - halfStrokeWidth && pY <= y + halfStrokeWidth || pY >= bottomBound - halfStrokeWidth && pY <= bottomBound + halfStrokeWidth) && pX >= innerX && pX <= innerX + innerWidth) return true;
        return(// Top-left
        pX < innerX && pY < innerY && $019041c7bdb3bf3e$var$isCornerWithinStroke(pX, pY, innerX, innerY, radius, halfStrokeWidth) || pX > rightBound - radius && pY < innerY && $019041c7bdb3bf3e$var$isCornerWithinStroke(pX, pY, rightBound - radius, innerY, radius, halfStrokeWidth) || pX > rightBound - radius && pY > bottomBound - radius && $019041c7bdb3bf3e$var$isCornerWithinStroke(pX, pY, rightBound - radius, bottomBound - radius, radius, halfStrokeWidth) || pX < innerX && pY > bottomBound - radius && $019041c7bdb3bf3e$var$isCornerWithinStroke(pX, pY, innerX, bottomBound - radius, radius, halfStrokeWidth));
    }
    toString() {
        return `[pixi.js/math:RoundedRectangle x=${this.x} y=${this.y}width=${this.width} height=${this.height} radius=${this.radius}]`;
    }
}

});

parcelRegister("lI2iN", function(module, exports) {

$parcel$export(module.exports, "buildAdaptiveBezier", () => $4a51fd8da05fe222$export$7dab5eac414ecba2);

var $hFzkv = parcelRequire("hFzkv");
"use strict";
const $4a51fd8da05fe222$var$RECURSION_LIMIT = 8;
const $4a51fd8da05fe222$var$FLT_EPSILON = 11920929e-14;
const $4a51fd8da05fe222$var$PATH_DISTANCE_EPSILON = 1;
const $4a51fd8da05fe222$var$curveAngleToleranceEpsilon = 0.01;
const $4a51fd8da05fe222$var$mAngleTolerance = 0;
const $4a51fd8da05fe222$var$mCuspLimit = 0;
function $4a51fd8da05fe222$export$7dab5eac414ecba2(points, sX, sY, cp1x, cp1y, cp2x, cp2y, eX, eY, smoothness) {
    const scale = 1;
    const smoothing = Math.min(0.99, // a value of 1.0 actually inverts smoothing, so we cap it at 0.99
    Math.max(0, smoothness ?? (0, $hFzkv.GraphicsContextSystem).defaultOptions.bezierSmoothness));
    let distanceTolerance = ($4a51fd8da05fe222$var$PATH_DISTANCE_EPSILON - smoothing) / scale;
    distanceTolerance *= distanceTolerance;
    $4a51fd8da05fe222$var$begin(sX, sY, cp1x, cp1y, cp2x, cp2y, eX, eY, points, distanceTolerance);
    return points;
}
function $4a51fd8da05fe222$var$begin(sX, sY, cp1x, cp1y, cp2x, cp2y, eX, eY, points, distanceTolerance) {
    $4a51fd8da05fe222$var$recursive(sX, sY, cp1x, cp1y, cp2x, cp2y, eX, eY, points, distanceTolerance, 0);
    points.push(eX, eY);
}
function $4a51fd8da05fe222$var$recursive(x1, y1, x2, y2, x3, y3, x4, y4, points, distanceTolerance, level) {
    if (level > $4a51fd8da05fe222$var$RECURSION_LIMIT) return;
    const pi = Math.PI;
    const x12 = (x1 + x2) / 2;
    const y12 = (y1 + y2) / 2;
    const x23 = (x2 + x3) / 2;
    const y23 = (y2 + y3) / 2;
    const x34 = (x3 + x4) / 2;
    const y34 = (y3 + y4) / 2;
    const x123 = (x12 + x23) / 2;
    const y123 = (y12 + y23) / 2;
    const x234 = (x23 + x34) / 2;
    const y234 = (y23 + y34) / 2;
    const x1234 = (x123 + x234) / 2;
    const y1234 = (y123 + y234) / 2;
    if (level > 0) {
        let dx = x4 - x1;
        let dy = y4 - y1;
        const d2 = Math.abs((x2 - x4) * dy - (y2 - y4) * dx);
        const d3 = Math.abs((x3 - x4) * dy - (y3 - y4) * dx);
        let da1;
        let da2;
        if (d2 > $4a51fd8da05fe222$var$FLT_EPSILON && d3 > $4a51fd8da05fe222$var$FLT_EPSILON) {
            if ((d2 + d3) * (d2 + d3) <= distanceTolerance * (dx * dx + dy * dy)) {
                if ($4a51fd8da05fe222$var$mAngleTolerance < $4a51fd8da05fe222$var$curveAngleToleranceEpsilon) {
                    points.push(x1234, y1234);
                    return;
                }
                const a23 = Math.atan2(y3 - y2, x3 - x2);
                da1 = Math.abs(a23 - Math.atan2(y2 - y1, x2 - x1));
                da2 = Math.abs(Math.atan2(y4 - y3, x4 - x3) - a23);
                if (da1 >= pi) da1 = 2 * pi - da1;
                if (da2 >= pi) da2 = 2 * pi - da2;
                if (da1 + da2 < $4a51fd8da05fe222$var$mAngleTolerance) {
                    points.push(x1234, y1234);
                    return;
                }
                if ($4a51fd8da05fe222$var$mCuspLimit !== 0) {
                    if (da1 > $4a51fd8da05fe222$var$mCuspLimit) {
                        points.push(x2, y2);
                        return;
                    }
                    if (da2 > $4a51fd8da05fe222$var$mCuspLimit) {
                        points.push(x3, y3);
                        return;
                    }
                }
            }
        } else if (d2 > $4a51fd8da05fe222$var$FLT_EPSILON) {
            if (d2 * d2 <= distanceTolerance * (dx * dx + dy * dy)) {
                if ($4a51fd8da05fe222$var$mAngleTolerance < $4a51fd8da05fe222$var$curveAngleToleranceEpsilon) {
                    points.push(x1234, y1234);
                    return;
                }
                da1 = Math.abs(Math.atan2(y3 - y2, x3 - x2) - Math.atan2(y2 - y1, x2 - x1));
                if (da1 >= pi) da1 = 2 * pi - da1;
                if (da1 < $4a51fd8da05fe222$var$mAngleTolerance) {
                    points.push(x2, y2);
                    points.push(x3, y3);
                    return;
                }
                if ($4a51fd8da05fe222$var$mCuspLimit !== 0) {
                    if (da1 > $4a51fd8da05fe222$var$mCuspLimit) {
                        points.push(x2, y2);
                        return;
                    }
                }
            }
        } else if (d3 > $4a51fd8da05fe222$var$FLT_EPSILON) {
            if (d3 * d3 <= distanceTolerance * (dx * dx + dy * dy)) {
                if ($4a51fd8da05fe222$var$mAngleTolerance < $4a51fd8da05fe222$var$curveAngleToleranceEpsilon) {
                    points.push(x1234, y1234);
                    return;
                }
                da1 = Math.abs(Math.atan2(y4 - y3, x4 - x3) - Math.atan2(y3 - y2, x3 - x2));
                if (da1 >= pi) da1 = 2 * pi - da1;
                if (da1 < $4a51fd8da05fe222$var$mAngleTolerance) {
                    points.push(x2, y2);
                    points.push(x3, y3);
                    return;
                }
                if ($4a51fd8da05fe222$var$mCuspLimit !== 0) {
                    if (da1 > $4a51fd8da05fe222$var$mCuspLimit) {
                        points.push(x3, y3);
                        return;
                    }
                }
            }
        } else {
            dx = x1234 - (x1 + x4) / 2;
            dy = y1234 - (y1 + y4) / 2;
            if (dx * dx + dy * dy <= distanceTolerance) {
                points.push(x1234, y1234);
                return;
            }
        }
    }
    $4a51fd8da05fe222$var$recursive(x1, y1, x12, y12, x123, y123, x1234, y1234, points, distanceTolerance, level + 1);
    $4a51fd8da05fe222$var$recursive(x1234, y1234, x234, y234, x34, y34, x4, y4, points, distanceTolerance, level + 1);
}

});
parcelRegister("hFzkv", function(module, exports) {

$parcel$export(module.exports, "GraphicsContextSystem", () => $119fb8487ef4f791$export$f2f3ca33e4c65172);

var $i9BKe = parcelRequire("i9BKe");

var $beJMG = parcelRequire("beJMG");

var $5RxDh = parcelRequire("5RxDh");

var $dK5Jn = parcelRequire("dK5Jn");

var $kXq8E = parcelRequire("kXq8E");

var $61KiY = parcelRequire("61KiY");

var $1mKkK = parcelRequire("1mKkK");
"use strict";
class $119fb8487ef4f791$export$e3e348c254036d55 {
    constructor(){
        this.batches = [];
        this.geometryData = {
            vertices: [],
            uvs: [],
            indices: []
        };
    }
}
class $119fb8487ef4f791$export$9b6a6c5b37fc8f49 {
    constructor(){
        this.batcher = new (0, $5RxDh.DefaultBatcher)();
        this.instructions = new (0, $dK5Jn.InstructionSet)();
    }
    init() {
        this.instructions.reset();
    }
    /**
   * @deprecated since version 8.0.0
   * Use `batcher.geometry` instead.
   * @see {Batcher#geometry}
   */ get geometry() {
        (0, $kXq8E.deprecation)((0, $kXq8E.v8_3_4), "GraphicsContextRenderData#geometry is deprecated, please use batcher.geometry instead.");
        return this.batcher.geometry;
    }
}
const $119fb8487ef4f791$var$_GraphicsContextSystem = class _GraphicsContextSystem {
    constructor(){
        // the root context batches, used to either make a batch or geometry
        // all graphics use this as a base
        this._gpuContextHash = {};
        // used for non-batchable graphics
        this._graphicsDataContextHash = /* @__PURE__ */ Object.create(null);
    }
    /**
   * Runner init called, update the default options
   * @ignore
   */ init(options) {
        _GraphicsContextSystem.defaultOptions.bezierSmoothness = options?.bezierSmoothness ?? _GraphicsContextSystem.defaultOptions.bezierSmoothness;
    }
    getContextRenderData(context) {
        return this._graphicsDataContextHash[context.uid] || this._initContextRenderData(context);
    }
    // Context management functions
    updateGpuContext(context) {
        let gpuContext = this._gpuContextHash[context.uid] || this._initContext(context);
        if (context.dirty) {
            if (gpuContext) this._cleanGraphicsContextData(context);
            else gpuContext = this._initContext(context);
            (0, $1mKkK.buildContextBatches)(context, gpuContext);
            const batchMode = context.batchMode;
            if (context.customShader || batchMode === "no-batch") gpuContext.isBatchable = false;
            else if (batchMode === "auto") gpuContext.isBatchable = gpuContext.geometryData.vertices.length < 400;
            context.dirty = false;
        }
        return gpuContext;
    }
    getGpuContext(context) {
        return this._gpuContextHash[context.uid] || this._initContext(context);
    }
    _initContextRenderData(context) {
        const graphicsData = (0, $61KiY.BigPool).get($119fb8487ef4f791$export$9b6a6c5b37fc8f49);
        const { batches: batches, geometryData: geometryData } = this._gpuContextHash[context.uid];
        const vertexSize = geometryData.vertices.length;
        const indexSize = geometryData.indices.length;
        for(let i = 0; i < batches.length; i++)batches[i].applyTransform = false;
        const batcher = graphicsData.batcher;
        batcher.ensureAttributeBuffer(vertexSize);
        batcher.ensureIndexBuffer(indexSize);
        batcher.begin();
        for(let i = 0; i < batches.length; i++){
            const batch = batches[i];
            batcher.add(batch);
        }
        batcher.finish(graphicsData.instructions);
        const geometry = batcher.geometry;
        geometry.indexBuffer.setDataWithSize(batcher.indexBuffer, batcher.indexSize, true);
        geometry.buffers[0].setDataWithSize(batcher.attributeBuffer.float32View, batcher.attributeSize, true);
        const drawBatches = batcher.batches;
        for(let i = 0; i < drawBatches.length; i++){
            const batch = drawBatches[i];
            batch.bindGroup = (0, $beJMG.getTextureBatchBindGroup)(batch.textures.textures, batch.textures.count);
        }
        this._graphicsDataContextHash[context.uid] = graphicsData;
        return graphicsData;
    }
    _initContext(context) {
        const gpuContext = new $119fb8487ef4f791$export$e3e348c254036d55();
        gpuContext.context = context;
        this._gpuContextHash[context.uid] = gpuContext;
        context.on("destroy", this.onGraphicsContextDestroy, this);
        return this._gpuContextHash[context.uid];
    }
    onGraphicsContextDestroy(context) {
        this._cleanGraphicsContextData(context);
        context.off("destroy", this.onGraphicsContextDestroy, this);
        this._gpuContextHash[context.uid] = null;
    }
    _cleanGraphicsContextData(context) {
        const gpuContext = this._gpuContextHash[context.uid];
        if (!gpuContext.isBatchable) {
            if (this._graphicsDataContextHash[context.uid]) {
                (0, $61KiY.BigPool).return(this.getContextRenderData(context));
                this._graphicsDataContextHash[context.uid] = null;
            }
        }
        if (gpuContext.batches) gpuContext.batches.forEach((batch)=>{
            (0, $61KiY.BigPool).return(batch);
        });
    }
    destroy() {
        for(const i in this._gpuContextHash)if (this._gpuContextHash[i]) this.onGraphicsContextDestroy(this._gpuContextHash[i].context);
    }
};
/** @ignore */ $119fb8487ef4f791$var$_GraphicsContextSystem.extension = {
    type: [
        (0, $i9BKe.ExtensionType).WebGLSystem,
        (0, $i9BKe.ExtensionType).WebGPUSystem,
        (0, $i9BKe.ExtensionType).CanvasSystem
    ],
    name: "graphicsContext"
};
/** The default options for the GraphicsContextSystem. */ $119fb8487ef4f791$var$_GraphicsContextSystem.defaultOptions = {
    /**
   * A value from 0 to 1 that controls the smoothness of bezier curves (the higher the smoother)
   * @default 0.5
   */ bezierSmoothness: 0.5
};
let $119fb8487ef4f791$export$f2f3ca33e4c65172 = $119fb8487ef4f791$var$_GraphicsContextSystem;

});
parcelRegister("beJMG", function(module, exports) {

$parcel$export(module.exports, "getTextureBatchBindGroup", () => $24797d7b1c25d5bc$export$84c26df82650dc9b);

var $awcfo = parcelRequire("awcfo");

var $bLlTJ = parcelRequire("bLlTJ");

var $1EHMq = parcelRequire("1EHMq");
"use strict";
const $24797d7b1c25d5bc$var$cachedGroups = {};
function $24797d7b1c25d5bc$export$84c26df82650dc9b(textures, size) {
    let uid = 2166136261;
    for(let i = 0; i < size; i++){
        uid ^= textures[i].uid;
        uid = Math.imul(uid, 16777619);
        uid >>>= 0;
    }
    return $24797d7b1c25d5bc$var$cachedGroups[uid] || $24797d7b1c25d5bc$var$generateTextureBatchBindGroup(textures, size, uid);
}
let $24797d7b1c25d5bc$var$maxTextures = 0;
function $24797d7b1c25d5bc$var$generateTextureBatchBindGroup(textures, size, key) {
    const bindGroupResources = {};
    let bindIndex = 0;
    if (!$24797d7b1c25d5bc$var$maxTextures) $24797d7b1c25d5bc$var$maxTextures = (0, $1EHMq.getMaxTexturesPerBatch)();
    for(let i = 0; i < $24797d7b1c25d5bc$var$maxTextures; i++){
        const texture = i < size ? textures[i] : (0, $bLlTJ.Texture).EMPTY.source;
        bindGroupResources[bindIndex++] = texture.source;
        bindGroupResources[bindIndex++] = texture.style;
    }
    const bindGroup = new (0, $awcfo.BindGroup)(bindGroupResources);
    $24797d7b1c25d5bc$var$cachedGroups[key] = bindGroup;
    return bindGroup;
}

});
parcelRegister("awcfo", function(module, exports) {

$parcel$export(module.exports, "BindGroup", () => $6cadf620a92ebba7$export$6f452ee382def63c);
"use strict";
class $6cadf620a92ebba7$export$6f452ee382def63c {
    /**
   * Create a new instance eof the Bind Group.
   * @param resources - The resources that are bound together for use by a shader.
   */ constructor(resources){
        /** The resources that are bound together for use by a shader. */ this.resources = /* @__PURE__ */ Object.create(null);
        this._dirty = true;
        let index = 0;
        for(const i in resources){
            const resource = resources[i];
            this.setResource(resource, index++);
        }
        this._updateKey();
    }
    /**
   * Updates the key if its flagged as dirty. This is used internally to
   * match this bind group to a WebGPU BindGroup.
   * @internal
   * @ignore
   */ _updateKey() {
        if (!this._dirty) return;
        this._dirty = false;
        const keyParts = [];
        let index = 0;
        for(const i in this.resources)keyParts[index++] = this.resources[i]._resourceId;
        this._key = keyParts.join("|");
    }
    /**
   * Set a resource at a given index. this function will
   * ensure that listeners will be removed from the current resource
   * and added to the new resource.
   * @param resource - The resource to set.
   * @param index - The index to set the resource at.
   */ setResource(resource, index) {
        const currentResource = this.resources[index];
        if (resource === currentResource) return;
        if (currentResource) resource.off?.("change", this.onResourceChange, this);
        resource.on?.("change", this.onResourceChange, this);
        this.resources[index] = resource;
        this._dirty = true;
    }
    /**
   * Returns the resource at the current specified index.
   * @param index - The index of the resource to get.
   * @returns - The resource at the specified index.
   */ getResource(index) {
        return this.resources[index];
    }
    /**
   * Used internally to 'touch' each resource, to ensure that the GC
   * knows that all resources in this bind group are still being used.
   * @param tick - The current tick.
   * @internal
   * @ignore
   */ _touch(tick) {
        const resources = this.resources;
        for(const i in resources)resources[i]._touched = tick;
    }
    /** Destroys this bind group and removes all listeners. */ destroy() {
        const resources = this.resources;
        for(const i in resources){
            const resource = resources[i];
            resource.off?.("change", this.onResourceChange, this);
        }
        this.resources = null;
    }
    onResourceChange(resource) {
        this._dirty = true;
        if (resource.destroyed) {
            const resources = this.resources;
            for(const i in resources)if (resources[i] === resource) resources[i] = null;
        } else this._updateKey();
    }
}

});

parcelRegister("1EHMq", function(module, exports) {

$parcel$export(module.exports, "getMaxTexturesPerBatch", () => $b5d07f8bc89d7387$export$313b92466c30ee73);

var $ckKKH = parcelRequire("ckKKH");

var $awsWF = parcelRequire("awsWF");
"use strict";
let $b5d07f8bc89d7387$var$maxTexturesPerBatchCache = null;
function $b5d07f8bc89d7387$export$313b92466c30ee73() {
    if ($b5d07f8bc89d7387$var$maxTexturesPerBatchCache) return $b5d07f8bc89d7387$var$maxTexturesPerBatchCache;
    const gl = (0, $ckKKH.getTestContext)();
    $b5d07f8bc89d7387$var$maxTexturesPerBatchCache = gl.getParameter(gl.MAX_TEXTURE_IMAGE_UNITS);
    $b5d07f8bc89d7387$var$maxTexturesPerBatchCache = (0, $awsWF.checkMaxIfStatementsInShader)($b5d07f8bc89d7387$var$maxTexturesPerBatchCache, gl);
    gl.getExtension("WEBGL_lose_context")?.loseContext();
    return $b5d07f8bc89d7387$var$maxTexturesPerBatchCache;
}

});
parcelRegister("ckKKH", function(module, exports) {

$parcel$export(module.exports, "getTestContext", () => $a517f2c0dcfb1c3f$export$f034b2d55f8df08b);

var $iCGeI = parcelRequire("iCGeI");
"use strict";
let $a517f2c0dcfb1c3f$var$context;
function $a517f2c0dcfb1c3f$export$f034b2d55f8df08b() {
    if (!$a517f2c0dcfb1c3f$var$context || $a517f2c0dcfb1c3f$var$context?.isContextLost()) {
        const canvas = (0, $iCGeI.DOMAdapter).get().createCanvas();
        $a517f2c0dcfb1c3f$var$context = canvas.getContext("webgl", {});
    }
    return $a517f2c0dcfb1c3f$var$context;
}

});

parcelRegister("awsWF", function(module, exports) {

$parcel$export(module.exports, "checkMaxIfStatementsInShader", () => $717b67827b6a1bc1$export$fb6ad4e758d74cc0);
"use strict";
const $717b67827b6a1bc1$var$fragTemplate = [
    "precision mediump float;",
    "void main(void){",
    "float test = 0.1;",
    "%forloop%",
    "gl_FragColor = vec4(0.0);",
    "}"
].join("\n");
function $717b67827b6a1bc1$var$generateIfTestSrc(maxIfs) {
    let src = "";
    for(let i = 0; i < maxIfs; ++i){
        if (i > 0) src += "\nelse ";
        if (i < maxIfs - 1) src += `if(test == ${i}.0){}`;
    }
    return src;
}
function $717b67827b6a1bc1$export$fb6ad4e758d74cc0(maxIfs, gl) {
    if (maxIfs === 0) throw new Error("Invalid value of `0` passed to `checkMaxIfStatementsInShader`");
    const shader = gl.createShader(gl.FRAGMENT_SHADER);
    try {
        while(true){
            const fragmentSrc = $717b67827b6a1bc1$var$fragTemplate.replace(/%forloop%/gi, $717b67827b6a1bc1$var$generateIfTestSrc(maxIfs));
            gl.shaderSource(shader, fragmentSrc);
            gl.compileShader(shader);
            if (!gl.getShaderParameter(shader, gl.COMPILE_STATUS)) maxIfs = maxIfs / 2 | 0;
            else break;
        }
    } finally{
        gl.deleteShader(shader);
    }
    return maxIfs;
}

});



parcelRegister("5RxDh", function(module, exports) {

$parcel$export(module.exports, "DefaultBatcher", () => $122ab179875de631$export$34bf80542893bcb);

var $i9BKe = parcelRequire("i9BKe");

var $4rmMq = parcelRequire("4rmMq");

var $6Ogkc = parcelRequire("6Ogkc");

var $bBMVz = parcelRequire("bBMVz");
"use strict";
let $122ab179875de631$var$defaultShader = null;
const $122ab179875de631$var$_DefaultBatcher = class _DefaultBatcher extends (0, $4rmMq.Batcher) {
    constructor(){
        super(...arguments);
        this.geometry = new (0, $6Ogkc.BatchGeometry)();
        this.shader = $122ab179875de631$var$defaultShader || ($122ab179875de631$var$defaultShader = new (0, $bBMVz.DefaultShader)(this.maxTextures));
        this.name = _DefaultBatcher.extension.name;
        /** The size of one attribute. 1 = 32 bit. x, y, u, v, color, textureIdAndRound -> total = 6 */ this.vertexSize = 6;
    }
    /**
   * Packs the attributes of a DefaultBatchableMeshElement into the provided views.
   * @param element - The DefaultBatchableMeshElement to pack.
   * @param float32View - The Float32Array view to pack into.
   * @param uint32View - The Uint32Array view to pack into.
   * @param index - The starting index in the views.
   * @param textureId - The texture ID to use.
   */ packAttributes(element, float32View, uint32View, index, textureId) {
        const textureIdAndRound = textureId << 16 | element.roundPixels & 65535;
        const wt = element.transform;
        const a = wt.a;
        const b = wt.b;
        const c = wt.c;
        const d = wt.d;
        const tx = wt.tx;
        const ty = wt.ty;
        const { positions: positions, uvs: uvs } = element;
        const argb = element.color;
        const offset = element.attributeOffset;
        const end = offset + element.attributeSize;
        for(let i = offset; i < end; i++){
            const i2 = i * 2;
            const x = positions[i2];
            const y = positions[i2 + 1];
            float32View[index++] = a * x + c * y + tx;
            float32View[index++] = d * y + b * x + ty;
            float32View[index++] = uvs[i2];
            float32View[index++] = uvs[i2 + 1];
            uint32View[index++] = argb;
            uint32View[index++] = textureIdAndRound;
        }
    }
    /**
   * Packs the attributes of a DefaultBatchableQuadElement into the provided views.
   * @param element - The DefaultBatchableQuadElement to pack.
   * @param float32View - The Float32Array view to pack into.
   * @param uint32View - The Uint32Array view to pack into.
   * @param index - The starting index in the views.
   * @param textureId - The texture ID to use.
   */ packQuadAttributes(element, float32View, uint32View, index, textureId) {
        const texture = element.texture;
        const wt = element.transform;
        const a = wt.a;
        const b = wt.b;
        const c = wt.c;
        const d = wt.d;
        const tx = wt.tx;
        const ty = wt.ty;
        const bounds = element.bounds;
        const w0 = bounds.maxX;
        const w1 = bounds.minX;
        const h0 = bounds.maxY;
        const h1 = bounds.minY;
        const uvs = texture.uvs;
        const argb = element.color;
        const textureIdAndRound = textureId << 16 | element.roundPixels & 65535;
        float32View[index + 0] = a * w1 + c * h1 + tx;
        float32View[index + 1] = d * h1 + b * w1 + ty;
        float32View[index + 2] = uvs.x0;
        float32View[index + 3] = uvs.y0;
        uint32View[index + 4] = argb;
        uint32View[index + 5] = textureIdAndRound;
        float32View[index + 6] = a * w0 + c * h1 + tx;
        float32View[index + 7] = d * h1 + b * w0 + ty;
        float32View[index + 8] = uvs.x1;
        float32View[index + 9] = uvs.y1;
        uint32View[index + 10] = argb;
        uint32View[index + 11] = textureIdAndRound;
        float32View[index + 12] = a * w0 + c * h0 + tx;
        float32View[index + 13] = d * h0 + b * w0 + ty;
        float32View[index + 14] = uvs.x2;
        float32View[index + 15] = uvs.y2;
        uint32View[index + 16] = argb;
        uint32View[index + 17] = textureIdAndRound;
        float32View[index + 18] = a * w1 + c * h0 + tx;
        float32View[index + 19] = d * h0 + b * w1 + ty;
        float32View[index + 20] = uvs.x3;
        float32View[index + 21] = uvs.y3;
        uint32View[index + 22] = argb;
        uint32View[index + 23] = textureIdAndRound;
    }
};
/** @ignore */ $122ab179875de631$var$_DefaultBatcher.extension = {
    type: [
        (0, $i9BKe.ExtensionType).Batcher
    ],
    name: "default"
};
let $122ab179875de631$export$34bf80542893bcb = $122ab179875de631$var$_DefaultBatcher;

});
parcelRegister("4rmMq", function(module, exports) {

$parcel$export(module.exports, "Batcher", () => $71f140885a3d3890$export$704b12ddc1dacdd2);

var $aGJhg = parcelRequire("aGJhg");

var $aaUE3 = parcelRequire("aaUE3");

var $1tfR4 = parcelRequire("1tfR4");

var $eN26f = parcelRequire("eN26f");

var $1EHMq = parcelRequire("1EHMq");

var $bRzRK = parcelRequire("bRzRK");
"use strict";
class $71f140885a3d3890$export$33b107562567fc47 {
    constructor(){
        this.renderPipeId = "batch";
        this.action = "startBatch";
        // TODO - eventually this could be useful for flagging batches as dirty and then only rebuilding those ones
        // public elementStart = 0;
        // public elementSize = 0;
        // for drawing..
        this.start = 0;
        this.size = 0;
        this.textures = new (0, $bRzRK.BatchTextureArray)();
        this.blendMode = "normal";
        this.canBundle = true;
    }
    destroy() {
        this.textures = null;
        this.gpuBindGroup = null;
        this.bindGroup = null;
        this.batcher = null;
    }
}
const $71f140885a3d3890$var$batchPool = [];
let $71f140885a3d3890$var$batchPoolIndex = 0;
function $71f140885a3d3890$var$getBatchFromPool() {
    return $71f140885a3d3890$var$batchPoolIndex > 0 ? $71f140885a3d3890$var$batchPool[--$71f140885a3d3890$var$batchPoolIndex] : new $71f140885a3d3890$export$33b107562567fc47();
}
function $71f140885a3d3890$var$returnBatchToPool(batch) {
    $71f140885a3d3890$var$batchPool[$71f140885a3d3890$var$batchPoolIndex++] = batch;
}
let $71f140885a3d3890$var$BATCH_TICK = 0;
const $71f140885a3d3890$var$_Batcher = class _Batcher {
    constructor(options = {}){
        /** unique id for this batcher */ this.uid = (0, $aGJhg.uid)("batcher");
        /** Indicates whether the batch data has been modified and needs updating. */ this.dirty = true;
        /** The current index of the batch being processed. */ this.batchIndex = 0;
        /** An array of all batches created during the current rendering process. */ this.batches = [];
        this._elements = [];
        _Batcher.defaultOptions.maxTextures = _Batcher.defaultOptions.maxTextures ?? (0, $1EHMq.getMaxTexturesPerBatch)();
        options = {
            ..._Batcher.defaultOptions,
            ...options
        };
        const { maxTextures: maxTextures, attributesInitialSize: attributesInitialSize, indicesInitialSize: indicesInitialSize } = options;
        this.attributeBuffer = new (0, $aaUE3.ViewableBuffer)(attributesInitialSize * 4);
        this.indexBuffer = new Uint16Array(indicesInitialSize);
        this.maxTextures = maxTextures;
    }
    begin() {
        this.elementSize = 0;
        this.elementStart = 0;
        this.indexSize = 0;
        this.attributeSize = 0;
        for(let i = 0; i < this.batchIndex; i++)$71f140885a3d3890$var$returnBatchToPool(this.batches[i]);
        this.batchIndex = 0;
        this._batchIndexStart = 0;
        this._batchIndexSize = 0;
        this.dirty = true;
    }
    add(batchableObject) {
        this._elements[this.elementSize++] = batchableObject;
        batchableObject._indexStart = this.indexSize;
        batchableObject._attributeStart = this.attributeSize;
        batchableObject._batcher = this;
        this.indexSize += batchableObject.indexSize;
        this.attributeSize += batchableObject.attributeSize * this.vertexSize;
    }
    checkAndUpdateTexture(batchableObject, texture) {
        const textureId = batchableObject._batch.textures.ids[texture._source.uid];
        if (!textureId && textureId !== 0) return false;
        batchableObject._textureId = textureId;
        batchableObject.texture = texture;
        return true;
    }
    updateElement(batchableObject) {
        this.dirty = true;
        const attributeBuffer = this.attributeBuffer;
        if (batchableObject.packAsQuad) this.packQuadAttributes(batchableObject, attributeBuffer.float32View, attributeBuffer.uint32View, batchableObject._attributeStart, batchableObject._textureId);
        else this.packAttributes(batchableObject, attributeBuffer.float32View, attributeBuffer.uint32View, batchableObject._attributeStart, batchableObject._textureId);
    }
    /**
   * breaks the batcher. This happens when a batch gets too big,
   * or we need to switch to a different type of rendering (a filter for example)
   * @param instructionSet
   */ break(instructionSet) {
        const elements = this._elements;
        if (!elements[this.elementStart]) return;
        let batch = $71f140885a3d3890$var$getBatchFromPool();
        let textureBatch = batch.textures;
        textureBatch.clear();
        const firstElement = elements[this.elementStart];
        let blendMode = (0, $eN26f.getAdjustedBlendModeBlend)(firstElement.blendMode, firstElement.texture._source);
        if (this.attributeSize * 4 > this.attributeBuffer.size) this._resizeAttributeBuffer(this.attributeSize * 4);
        if (this.indexSize > this.indexBuffer.length) this._resizeIndexBuffer(this.indexSize);
        const f32 = this.attributeBuffer.float32View;
        const u32 = this.attributeBuffer.uint32View;
        const indexBuffer = this.indexBuffer;
        let size = this._batchIndexSize;
        let start = this._batchIndexStart;
        let action = "startBatch";
        const maxTextures = this.maxTextures;
        for(let i = this.elementStart; i < this.elementSize; ++i){
            const element = elements[i];
            elements[i] = null;
            const texture = element.texture;
            const source = texture._source;
            const adjustedBlendMode = (0, $eN26f.getAdjustedBlendModeBlend)(element.blendMode, source);
            const breakRequired = blendMode !== adjustedBlendMode;
            if (source._batchTick === $71f140885a3d3890$var$BATCH_TICK && !breakRequired) {
                element._textureId = source._textureBindLocation;
                size += element.indexSize;
                if (element.packAsQuad) {
                    this.packQuadAttributes(element, f32, u32, element._attributeStart, element._textureId);
                    this.packQuadIndex(indexBuffer, element._indexStart, element._attributeStart / this.vertexSize);
                } else {
                    this.packAttributes(element, f32, u32, element._attributeStart, element._textureId);
                    this.packIndex(element, indexBuffer, element._indexStart, element._attributeStart / this.vertexSize);
                }
                element._batch = batch;
                continue;
            }
            source._batchTick = $71f140885a3d3890$var$BATCH_TICK;
            if (textureBatch.count >= maxTextures || breakRequired) {
                this._finishBatch(batch, start, size - start, textureBatch, blendMode, instructionSet, action);
                action = "renderBatch";
                start = size;
                blendMode = adjustedBlendMode;
                batch = $71f140885a3d3890$var$getBatchFromPool();
                textureBatch = batch.textures;
                textureBatch.clear();
                ++$71f140885a3d3890$var$BATCH_TICK;
            }
            element._textureId = source._textureBindLocation = textureBatch.count;
            textureBatch.ids[source.uid] = textureBatch.count;
            textureBatch.textures[textureBatch.count++] = source;
            element._batch = batch;
            size += element.indexSize;
            if (element.packAsQuad) {
                this.packQuadAttributes(element, f32, u32, element._attributeStart, element._textureId);
                this.packQuadIndex(indexBuffer, element._indexStart, element._attributeStart / this.vertexSize);
            } else {
                this.packAttributes(element, f32, u32, element._attributeStart, element._textureId);
                this.packIndex(element, indexBuffer, element._indexStart, element._attributeStart / this.vertexSize);
            }
        }
        if (textureBatch.count > 0) {
            this._finishBatch(batch, start, size - start, textureBatch, blendMode, instructionSet, action);
            start = size;
            ++$71f140885a3d3890$var$BATCH_TICK;
        }
        this.elementStart = this.elementSize;
        this._batchIndexStart = start;
        this._batchIndexSize = size;
    }
    _finishBatch(batch, indexStart, indexSize, textureBatch, blendMode, instructionSet, action) {
        batch.gpuBindGroup = null;
        batch.bindGroup = null;
        batch.action = action;
        batch.batcher = this;
        batch.textures = textureBatch;
        batch.blendMode = blendMode;
        batch.start = indexStart;
        batch.size = indexSize;
        ++$71f140885a3d3890$var$BATCH_TICK;
        this.batches[this.batchIndex++] = batch;
        instructionSet.add(batch);
    }
    finish(instructionSet) {
        this.break(instructionSet);
    }
    /**
   * Resizes the attribute buffer to the given size (1 = 1 float32)
   * @param size - the size in vertices to ensure (not bytes!)
   */ ensureAttributeBuffer(size) {
        if (size * 4 <= this.attributeBuffer.size) return;
        this._resizeAttributeBuffer(size * 4);
    }
    /**
   * Resizes the index buffer to the given size (1 = 1 float32)
   * @param size - the size in vertices to ensure (not bytes!)
   */ ensureIndexBuffer(size) {
        if (size <= this.indexBuffer.length) return;
        this._resizeIndexBuffer(size);
    }
    _resizeAttributeBuffer(size) {
        const newSize = Math.max(size, this.attributeBuffer.size * 2);
        const newArrayBuffer = new (0, $aaUE3.ViewableBuffer)(newSize);
        (0, $1tfR4.fastCopy)(this.attributeBuffer.rawBinaryData, newArrayBuffer.rawBinaryData);
        this.attributeBuffer = newArrayBuffer;
    }
    _resizeIndexBuffer(size) {
        const indexBuffer = this.indexBuffer;
        let newSize = Math.max(size, indexBuffer.length * 1.5);
        newSize += newSize % 2;
        const newIndexBuffer = newSize > 65535 ? new Uint32Array(newSize) : new Uint16Array(newSize);
        if (newIndexBuffer.BYTES_PER_ELEMENT !== indexBuffer.BYTES_PER_ELEMENT) for(let i = 0; i < indexBuffer.length; i++)newIndexBuffer[i] = indexBuffer[i];
        else (0, $1tfR4.fastCopy)(indexBuffer.buffer, newIndexBuffer.buffer);
        this.indexBuffer = newIndexBuffer;
    }
    packQuadIndex(indexBuffer, index, indicesOffset) {
        indexBuffer[index] = indicesOffset + 0;
        indexBuffer[index + 1] = indicesOffset + 1;
        indexBuffer[index + 2] = indicesOffset + 2;
        indexBuffer[index + 3] = indicesOffset + 0;
        indexBuffer[index + 4] = indicesOffset + 2;
        indexBuffer[index + 5] = indicesOffset + 3;
    }
    packIndex(element, indexBuffer, index, indicesOffset) {
        const indices = element.indices;
        const size = element.indexSize;
        const indexOffset = element.indexOffset;
        const attributeOffset = element.attributeOffset;
        for(let i = 0; i < size; i++)indexBuffer[index++] = indicesOffset + indices[i + indexOffset] - attributeOffset;
    }
    destroy() {
        for(let i = 0; i < this.batches.length; i++)$71f140885a3d3890$var$returnBatchToPool(this.batches[i]);
        this.batches = null;
        for(let i = 0; i < this._elements.length; i++)this._elements[i]._batch = null;
        this._elements = null;
        this.indexBuffer = null;
        this.attributeBuffer.destroy();
        this.attributeBuffer = null;
    }
};
$71f140885a3d3890$var$_Batcher.defaultOptions = {
    maxTextures: null,
    attributesInitialSize: 4,
    indicesInitialSize: 6
};
let $71f140885a3d3890$export$704b12ddc1dacdd2 = $71f140885a3d3890$var$_Batcher;

});
parcelRegister("aaUE3", function(module, exports) {

$parcel$export(module.exports, "ViewableBuffer", () => $d6aafa25b0389ff9$export$4fdbf0662aa3047a);
"use strict";
class $d6aafa25b0389ff9$export$4fdbf0662aa3047a {
    constructor(sizeOrBuffer){
        if (typeof sizeOrBuffer === "number") this.rawBinaryData = new ArrayBuffer(sizeOrBuffer);
        else if (sizeOrBuffer instanceof Uint8Array) this.rawBinaryData = sizeOrBuffer.buffer;
        else this.rawBinaryData = sizeOrBuffer;
        this.uint32View = new Uint32Array(this.rawBinaryData);
        this.float32View = new Float32Array(this.rawBinaryData);
        this.size = this.rawBinaryData.byteLength;
    }
    /** View on the raw binary data as a `Int8Array`. */ get int8View() {
        if (!this._int8View) this._int8View = new Int8Array(this.rawBinaryData);
        return this._int8View;
    }
    /** View on the raw binary data as a `Uint8Array`. */ get uint8View() {
        if (!this._uint8View) this._uint8View = new Uint8Array(this.rawBinaryData);
        return this._uint8View;
    }
    /**  View on the raw binary data as a `Int16Array`. */ get int16View() {
        if (!this._int16View) this._int16View = new Int16Array(this.rawBinaryData);
        return this._int16View;
    }
    /** View on the raw binary data as a `Int32Array`. */ get int32View() {
        if (!this._int32View) this._int32View = new Int32Array(this.rawBinaryData);
        return this._int32View;
    }
    /** View on the raw binary data as a `Float64Array`. */ get float64View() {
        if (!this._float64Array) this._float64Array = new Float64Array(this.rawBinaryData);
        return this._float64Array;
    }
    /** View on the raw binary data as a `BigUint64Array`. */ get bigUint64View() {
        if (!this._bigUint64Array) this._bigUint64Array = new BigUint64Array(this.rawBinaryData);
        return this._bigUint64Array;
    }
    /**
   * Returns the view of the given type.
   * @param type - One of `int8`, `uint8`, `int16`,
   *    `uint16`, `int32`, `uint32`, and `float32`.
   * @returns - typed array of given type
   */ view(type) {
        return this[`${type}View`];
    }
    /** Destroys all buffer references. Do not use after calling this. */ destroy() {
        this.rawBinaryData = null;
        this._int8View = null;
        this._uint8View = null;
        this._int16View = null;
        this.uint16View = null;
        this._int32View = null;
        this.uint32View = null;
        this.float32View = null;
    }
    /**
   * Returns the size of the given type in bytes.
   * @param type - One of `int8`, `uint8`, `int16`,
   *   `uint16`, `int32`, `uint32`, and `float32`.
   * @returns - size of the type in bytes
   */ static sizeOf(type) {
        switch(type){
            case "int8":
            case "uint8":
                return 1;
            case "int16":
            case "uint16":
                return 2;
            case "int32":
            case "uint32":
            case "float32":
                return 4;
            default:
                throw new Error(`${type} isn't a valid view type`);
        }
    }
}

});

parcelRegister("1tfR4", function(module, exports) {

$parcel$export(module.exports, "fastCopy", () => $3976cf47510ef1a5$export$c691b0c42debe682);
"use strict";
function $3976cf47510ef1a5$export$c691b0c42debe682(sourceBuffer, destinationBuffer) {
    const lengthDouble = sourceBuffer.byteLength / 8 | 0;
    const sourceFloat64View = new Float64Array(sourceBuffer, 0, lengthDouble);
    const destinationFloat64View = new Float64Array(destinationBuffer, 0, lengthDouble);
    destinationFloat64View.set(sourceFloat64View);
    const remainingBytes = sourceBuffer.byteLength - lengthDouble * 8;
    if (remainingBytes > 0) {
        const sourceUint8View = new Uint8Array(sourceBuffer, lengthDouble * 8, remainingBytes);
        const destinationUint8View = new Uint8Array(destinationBuffer, lengthDouble * 8, remainingBytes);
        destinationUint8View.set(sourceUint8View);
    }
}

});

parcelRegister("eN26f", function(module, exports) {

$parcel$export(module.exports, "getAdjustedBlendModeBlend", () => $3b017cb7131d92fc$export$ab2fc5cf3fe899fe);

var $eE5Ke = parcelRequire("eE5Ke");
"use strict";
function $3b017cb7131d92fc$export$ab2fc5cf3fe899fe(blendMode, textureSource) {
    if (textureSource.alphaMode === "no-premultiply-alpha") return (0, $eE5Ke.BLEND_TO_NPM)[blendMode] || blendMode;
    return blendMode;
}

});
parcelRegister("eE5Ke", function(module, exports) {

$parcel$export(module.exports, "BLEND_TO_NPM", () => $16526f00f7b0e2b9$export$8c0bd2ccaa4a8d5e);
$parcel$export(module.exports, "STENCIL_MODES", () => $16526f00f7b0e2b9$export$c250b85d73a91bdf);
"use strict";
const $16526f00f7b0e2b9$export$8c0bd2ccaa4a8d5e = {
    normal: "normal-npm",
    add: "add-npm",
    screen: "screen-npm"
};
var $16526f00f7b0e2b9$export$c250b85d73a91bdf = /* @__PURE__ */ ((STENCIL_MODES2)=>{
    STENCIL_MODES2[STENCIL_MODES2["DISABLED"] = 0] = "DISABLED";
    STENCIL_MODES2[STENCIL_MODES2["RENDERING_MASK_ADD"] = 1] = "RENDERING_MASK_ADD";
    STENCIL_MODES2[STENCIL_MODES2["MASK_ACTIVE"] = 2] = "MASK_ACTIVE";
    STENCIL_MODES2[STENCIL_MODES2["RENDERING_MASK_REMOVE"] = 3] = "RENDERING_MASK_REMOVE";
    STENCIL_MODES2[STENCIL_MODES2["NONE"] = 4] = "NONE";
    return STENCIL_MODES2;
})($16526f00f7b0e2b9$export$c250b85d73a91bdf || {});

});


parcelRegister("bRzRK", function(module, exports) {

$parcel$export(module.exports, "BatchTextureArray", () => $a96c3003620e8697$export$aa760e0febf1a758);
"use strict";
class $a96c3003620e8697$export$aa760e0febf1a758 {
    constructor(){
        /** Respective locations for textures. */ this.ids = /* @__PURE__ */ Object.create(null);
        this.textures = [];
        this.count = 0;
    }
    /** Clear the textures and their locations. */ clear() {
        for(let i = 0; i < this.count; i++){
            const t = this.textures[i];
            this.textures[i] = null;
            this.ids[t.uid] = null;
        }
        this.count = 0;
    }
}

});


parcelRegister("6Ogkc", function(module, exports) {

$parcel$export(module.exports, "BatchGeometry", () => $ec424808c68c925d$export$449e8d355fd68e43);

var $lvEAL = parcelRequire("lvEAL");

var $1UZ6r = parcelRequire("1UZ6r");

var $cOnev = parcelRequire("cOnev");
"use strict";
const $ec424808c68c925d$var$placeHolderBufferData = new Float32Array(1);
const $ec424808c68c925d$var$placeHolderIndexData = new Uint32Array(1);
class $ec424808c68c925d$export$449e8d355fd68e43 extends (0, $cOnev.Geometry) {
    constructor(){
        const vertexSize = 6;
        const attributeBuffer = new (0, $lvEAL.Buffer)({
            data: $ec424808c68c925d$var$placeHolderBufferData,
            label: "attribute-batch-buffer",
            usage: (0, $1UZ6r.BufferUsage).VERTEX | (0, $1UZ6r.BufferUsage).COPY_DST,
            shrinkToFit: false
        });
        const indexBuffer = new (0, $lvEAL.Buffer)({
            data: $ec424808c68c925d$var$placeHolderIndexData,
            label: "index-batch-buffer",
            usage: (0, $1UZ6r.BufferUsage).INDEX | (0, $1UZ6r.BufferUsage).COPY_DST,
            // | BufferUsage.STATIC,
            shrinkToFit: false
        });
        const stride = vertexSize * 4;
        super({
            attributes: {
                aPosition: {
                    buffer: attributeBuffer,
                    format: "float32x2",
                    stride: stride,
                    offset: 0
                },
                aUV: {
                    buffer: attributeBuffer,
                    format: "float32x2",
                    stride: stride,
                    offset: 8
                },
                aColor: {
                    buffer: attributeBuffer,
                    format: "unorm8x4",
                    stride: stride,
                    offset: 16
                },
                aTextureIdAndRound: {
                    buffer: attributeBuffer,
                    format: "uint16x2",
                    stride: stride,
                    offset: 20
                }
            },
            indexBuffer: indexBuffer
        });
    }
}

});
parcelRegister("lvEAL", function(module, exports) {

$parcel$export(module.exports, "Buffer", () => $9841377a483d1ce7$export$a143d493d941bafc);

var $3vRz3 = parcelRequire("3vRz3");

var $aGJhg = parcelRequire("aGJhg");

var $1UZ6r = parcelRequire("1UZ6r");
"use strict";
class $9841377a483d1ce7$export$a143d493d941bafc extends (0, (/*@__PURE__*/$parcel$interopDefault($3vRz3))) {
    /**
   * Creates a new Buffer with the given options
   * @param options - the options for the buffer
   */ constructor(options){
        let { data: data, size: size } = options;
        const { usage: usage, label: label, shrinkToFit: shrinkToFit } = options;
        super();
        /**
     * emits when the underlying buffer has changed shape (i.e. resized)
     * letting the renderer know that it needs to discard the old buffer on the GPU and create a new one
     * @event change
     */ /**
     * emits when the underlying buffer data has been updated. letting the renderer know
     * that it needs to update the buffer on the GPU
     * @event update
     */ /**
     * emits when the buffer is destroyed. letting the renderer know that it needs to destroy the buffer on the GPU
     * @event destroy
     */ /** a unique id for this uniform group used through the renderer */ this.uid = (0, $aGJhg.uid)("buffer");
        /**
     * a resource type, used to identify how to handle it when its in a bind group / shader resource
     * @internal
     * @ignore
     */ this._resourceType = "buffer";
        /**
     * the resource id used internally by the renderer to build bind group keys
     * @internal
     * @ignore
     */ this._resourceId = (0, $aGJhg.uid)("resource");
        /**
     * used internally to know if a uniform group was used in the last render pass
     * @internal
     * @ignore
     */ this._touched = 0;
        /**
     * @internal
     * @ignore
     */ this._updateID = 1;
        /**
     * should the GPU buffer be shrunk when the data becomes smaller?
     * changing this will cause the buffer to be destroyed and a new one created on the GPU
     * this can be expensive, especially if the buffer is already big enough!
     * setting this to false will prevent the buffer from being shrunk. This will yield better performance
     * if you are constantly setting data that is changing size often.
     * @default true
     */ this.shrinkToFit = true;
        /**
     * Has the buffer been destroyed?
     * @readonly
     */ this.destroyed = false;
        if (data instanceof Array) data = new Float32Array(data);
        this._data = data;
        size = size ?? data?.byteLength;
        const mappedAtCreation = !!data;
        this.descriptor = {
            size: size,
            usage: usage,
            mappedAtCreation: mappedAtCreation,
            label: label
        };
        this.shrinkToFit = shrinkToFit ?? true;
    }
    /** the data in the buffer */ get data() {
        return this._data;
    }
    set data(value) {
        this.setDataWithSize(value, value.length, true);
    }
    /** whether the buffer is static or not */ get static() {
        return !!(this.descriptor.usage & (0, $1UZ6r.BufferUsage).STATIC);
    }
    set static(value) {
        if (value) this.descriptor.usage |= (0, $1UZ6r.BufferUsage).STATIC;
        else this.descriptor.usage &= ~(0, $1UZ6r.BufferUsage).STATIC;
    }
    /**
   * Sets the data in the buffer to the given value. This will immediately update the buffer on the GPU.
   * If you only want to update a subset of the buffer, you can pass in the size of the data.
   * @param value - the data to set
   * @param size - the size of the data in bytes
   * @param syncGPU - should the buffer be updated on the GPU immediately?
   */ setDataWithSize(value, size, syncGPU) {
        this._updateID++;
        this._updateSize = size * value.BYTES_PER_ELEMENT;
        if (this._data === value) {
            if (syncGPU) this.emit("update", this);
            return;
        }
        const oldData = this._data;
        this._data = value;
        if (oldData.length !== value.length) {
            if (!this.shrinkToFit && value.byteLength < oldData.byteLength) {
                if (syncGPU) this.emit("update", this);
            } else {
                this.descriptor.size = value.byteLength;
                this._resourceId = (0, $aGJhg.uid)("resource");
                this.emit("change", this);
            }
            return;
        }
        if (syncGPU) this.emit("update", this);
    }
    /**
   * updates the buffer on the GPU to reflect the data in the buffer.
   * By default it will update the entire buffer. If you only want to update a subset of the buffer,
   * you can pass in the size of the buffer to update.
   * @param sizeInBytes - the new size of the buffer in bytes
   */ update(sizeInBytes) {
        this._updateSize = sizeInBytes ?? this._updateSize;
        this._updateID++;
        this.emit("update", this);
    }
    /** Destroys the buffer */ destroy() {
        this.destroyed = true;
        this.emit("destroy", this);
        this.emit("change", this);
        this._data = null;
        this.descriptor = null;
        this.removeAllListeners();
    }
}

});
parcelRegister("1UZ6r", function(module, exports) {

$parcel$export(module.exports, "BufferUsage", () => $f4c8f2641f61e66f$export$f8deb2be8632fd10);
"use strict";
var $f4c8f2641f61e66f$export$f8deb2be8632fd10 = /* @__PURE__ */ ((BufferUsage2)=>{
    BufferUsage2[BufferUsage2["MAP_READ"] = 1] = "MAP_READ";
    BufferUsage2[BufferUsage2["MAP_WRITE"] = 2] = "MAP_WRITE";
    BufferUsage2[BufferUsage2["COPY_SRC"] = 4] = "COPY_SRC";
    BufferUsage2[BufferUsage2["COPY_DST"] = 8] = "COPY_DST";
    BufferUsage2[BufferUsage2["INDEX"] = 16] = "INDEX";
    BufferUsage2[BufferUsage2["VERTEX"] = 32] = "VERTEX";
    BufferUsage2[BufferUsage2["UNIFORM"] = 64] = "UNIFORM";
    BufferUsage2[BufferUsage2["STORAGE"] = 128] = "STORAGE";
    BufferUsage2[BufferUsage2["INDIRECT"] = 256] = "INDIRECT";
    BufferUsage2[BufferUsage2["QUERY_RESOLVE"] = 512] = "QUERY_RESOLVE";
    BufferUsage2[BufferUsage2["STATIC"] = 1024] = "STATIC";
    return BufferUsage2;
})($f4c8f2641f61e66f$export$f8deb2be8632fd10 || {});

});


parcelRegister("cOnev", function(module, exports) {

$parcel$export(module.exports, "Geometry", () => $f72e7cebaee4d192$export$2db6c17465f94a2);

var $3vRz3 = parcelRequire("3vRz3");

var $7wtv9 = parcelRequire("7wtv9");

var $aGJhg = parcelRequire("aGJhg");

var $lvEAL = parcelRequire("lvEAL");

var $zwuDY = parcelRequire("zwuDY");

var $dYcXX = parcelRequire("dYcXX");
"use strict";
function $f72e7cebaee4d192$var$ensureIsAttribute(attribute) {
    if (attribute instanceof (0, $lvEAL.Buffer) || Array.isArray(attribute) || attribute.BYTES_PER_ELEMENT) attribute = {
        buffer: attribute
    };
    attribute.buffer = (0, $zwuDY.ensureIsBuffer)(attribute.buffer, false);
    return attribute;
}
class $f72e7cebaee4d192$export$2db6c17465f94a2 extends (0, (/*@__PURE__*/$parcel$interopDefault($3vRz3))) {
    /**
   * Create a new instance of a geometry
   * @param options - The options for the geometry.
   */ constructor(options){
        const { attributes: attributes, indexBuffer: indexBuffer, topology: topology } = options;
        super();
        /** The unique id of the geometry. */ this.uid = (0, $aGJhg.uid)("geometry");
        /**
     * the layout key will be generated by WebGPU all geometries that have the same structure
     * will have the same layout key. This is used to cache the pipeline layout
     * @internal
     * @ignore
     */ this._layoutKey = 0;
        /** the instance count of the geometry to draw */ this.instanceCount = 1;
        this._bounds = new (0, $7wtv9.Bounds)();
        this._boundsDirty = true;
        this.attributes = attributes;
        this.buffers = [];
        this.instanceCount = options.instanceCount || 1;
        for(const i in attributes){
            const attribute = attributes[i] = $f72e7cebaee4d192$var$ensureIsAttribute(attributes[i]);
            const bufferIndex = this.buffers.indexOf(attribute.buffer);
            if (bufferIndex === -1) {
                this.buffers.push(attribute.buffer);
                attribute.buffer.on("update", this.onBufferUpdate, this);
                attribute.buffer.on("change", this.onBufferUpdate, this);
            }
        }
        if (indexBuffer) {
            this.indexBuffer = (0, $zwuDY.ensureIsBuffer)(indexBuffer, true);
            this.buffers.push(this.indexBuffer);
        }
        this.topology = topology || "triangle-list";
    }
    onBufferUpdate() {
        this._boundsDirty = true;
        this.emit("update", this);
    }
    /**
   * Returns the requested attribute.
   * @param id - The name of the attribute required
   * @returns - The attribute requested.
   */ getAttribute(id) {
        return this.attributes[id];
    }
    /**
   * Returns the index buffer
   * @returns - The index buffer.
   */ getIndex() {
        return this.indexBuffer;
    }
    /**
   * Returns the requested buffer.
   * @param id - The name of the buffer required.
   * @returns - The buffer requested.
   */ getBuffer(id) {
        return this.getAttribute(id).buffer;
    }
    /**
   * Used to figure out how many vertices there are in this geometry
   * @returns the number of vertices in the geometry
   */ getSize() {
        for(const i in this.attributes){
            const attribute = this.attributes[i];
            const buffer = attribute.buffer;
            return buffer.data.length / (attribute.stride / 4 || attribute.size);
        }
        return 0;
    }
    /** Returns the bounds of the geometry. */ get bounds() {
        if (!this._boundsDirty) return this._bounds;
        this._boundsDirty = false;
        return (0, $dYcXX.getGeometryBounds)(this, "aPosition", this._bounds);
    }
    /**
   * destroys the geometry.
   * @param destroyBuffers - destroy the buffers associated with this geometry
   */ destroy(destroyBuffers = false) {
        this.emit("destroy", this);
        this.removeAllListeners();
        if (destroyBuffers) this.buffers.forEach((buffer)=>buffer.destroy());
        this.attributes = null;
        this.buffers = null;
        this.indexBuffer = null;
        this._bounds = null;
    }
}

});
parcelRegister("zwuDY", function(module, exports) {

$parcel$export(module.exports, "ensureIsBuffer", () => $c27f8a68b3d31b3f$export$e02adcb3cf335e03);

var $lvEAL = parcelRequire("lvEAL");

var $1UZ6r = parcelRequire("1UZ6r");
"use strict";
function $c27f8a68b3d31b3f$export$e02adcb3cf335e03(buffer, index) {
    if (!(buffer instanceof (0, $lvEAL.Buffer))) {
        let usage = index ? (0, $1UZ6r.BufferUsage).INDEX : (0, $1UZ6r.BufferUsage).VERTEX;
        if (buffer instanceof Array) {
            if (index) {
                buffer = new Uint32Array(buffer);
                usage = (0, $1UZ6r.BufferUsage).INDEX | (0, $1UZ6r.BufferUsage).COPY_DST;
            } else {
                buffer = new Float32Array(buffer);
                usage = (0, $1UZ6r.BufferUsage).VERTEX | (0, $1UZ6r.BufferUsage).COPY_DST;
            }
        }
        buffer = new (0, $lvEAL.Buffer)({
            data: buffer,
            label: index ? "index-mesh-buffer" : "vertex-mesh-buffer",
            usage: usage
        });
    }
    return buffer;
}

});

parcelRegister("dYcXX", function(module, exports) {

$parcel$export(module.exports, "getGeometryBounds", () => $547d4a1f0305efcb$export$ca8be28ec6402f29);
"use strict";
function $547d4a1f0305efcb$export$ca8be28ec6402f29(geometry, attributeId, bounds) {
    const attribute = geometry.getAttribute(attributeId);
    if (!attribute) {
        bounds.minX = 0;
        bounds.minY = 0;
        bounds.maxX = 0;
        bounds.maxY = 0;
        return bounds;
    }
    const data = attribute.buffer.data;
    let minX = Infinity;
    let minY = Infinity;
    let maxX = -Infinity;
    let maxY = -Infinity;
    const byteSize = data.BYTES_PER_ELEMENT;
    const offset = (attribute.offset || 0) / byteSize;
    const stride = (attribute.stride || 8) / byteSize;
    for(let i = offset; i < data.length; i += stride){
        const x = data[i];
        const y = data[i + 1];
        if (x > maxX) maxX = x;
        if (y > maxY) maxY = y;
        if (x < minX) minX = x;
        if (y < minY) minY = y;
    }
    bounds.minX = minX;
    bounds.minY = minY;
    bounds.maxX = maxX;
    bounds.maxY = maxY;
    return bounds;
}

});



parcelRegister("bBMVz", function(module, exports) {

$parcel$export(module.exports, "DefaultShader", () => $5546e8c9dd716d36$export$5ee16216350ebcbc);

var $3JBHn = parcelRequire("3JBHn");

var $cNnNT = parcelRequire("cNnNT");

var $ikSZA = parcelRequire("ikSZA");

var $kSpdC = parcelRequire("kSpdC");

var $10zIa = parcelRequire("10zIa");

var $5iDyo = parcelRequire("5iDyo");
"use strict";
class $5546e8c9dd716d36$export$5ee16216350ebcbc extends (0, $5iDyo.Shader) {
    constructor(maxTextures){
        const glProgram = (0, $3JBHn.compileHighShaderGlProgram)({
            name: "batch",
            bits: [
                (0, $cNnNT.colorBitGl),
                (0, $ikSZA.generateTextureBatchBitGl)(maxTextures),
                (0, $kSpdC.roundPixelsBitGl)
            ]
        });
        const gpuProgram = (0, $3JBHn.compileHighShaderGpuProgram)({
            name: "batch",
            bits: [
                (0, $cNnNT.colorBit),
                (0, $ikSZA.generateTextureBatchBit)(maxTextures),
                (0, $kSpdC.roundPixelsBit)
            ]
        });
        super({
            glProgram: glProgram,
            gpuProgram: gpuProgram,
            resources: {
                batchSamplers: (0, $10zIa.getBatchSamplersUniformGroup)(maxTextures)
            }
        });
    }
}

});
parcelRegister("3JBHn", function(module, exports) {

$parcel$export(module.exports, "compileHighShaderGpuProgram", () => $52144493f15d3fff$export$af9d352c01aa9018);
$parcel$export(module.exports, "compileHighShaderGlProgram", () => $52144493f15d3fff$export$477b8252c7ecdf2);

var $fK92B = parcelRequire("fK92B");

var $6j7wq = parcelRequire("6j7wq");

var $i8pLT = parcelRequire("i8pLT");

var $jOJh1 = parcelRequire("jOJh1");

var $8hMvn = parcelRequire("8hMvn");
"use strict";
function $52144493f15d3fff$export$af9d352c01aa9018({ bits: bits, name: name }) {
    const source = (0, $i8pLT.compileHighShader)({
        template: {
            fragment: (0, $jOJh1.fragmentGPUTemplate),
            vertex: (0, $jOJh1.vertexGPUTemplate)
        },
        bits: [
            (0, $8hMvn.globalUniformsBit),
            ...bits
        ]
    });
    return (0, $6j7wq.GpuProgram).from({
        name: name,
        vertex: {
            source: source.vertex,
            entryPoint: "main"
        },
        fragment: {
            source: source.fragment,
            entryPoint: "main"
        }
    });
}
function $52144493f15d3fff$export$477b8252c7ecdf2({ bits: bits, name: name }) {
    return new (0, $fK92B.GlProgram)({
        name: name,
        ...(0, $i8pLT.compileHighShaderGl)({
            template: {
                vertex: (0, $jOJh1.vertexGlTemplate),
                fragment: (0, $jOJh1.fragmentGlTemplate)
            },
            bits: [
                (0, $8hMvn.globalUniformsBitGl),
                ...bits
            ]
        })
    });
}

});
parcelRegister("fK92B", function(module, exports) {

$parcel$export(module.exports, "GlProgram", () => $5a1cd4acf4c2252d$export$64881d9ea0a969d7);

var $9kWs1 = parcelRequire("9kWs1");

var $c1vp1 = parcelRequire("c1vp1");

var $iCp49 = parcelRequire("iCp49");

var $67Nsh = parcelRequire("67Nsh");

var $3Hbxe = parcelRequire("3Hbxe");

var $aUAMu = parcelRequire("aUAMu");

var $500fb = parcelRequire("500fb");
"use strict";
const $5a1cd4acf4c2252d$var$processes = {
    stripVersion: // strips any version headers..
    $500fb.stripVersion,
    ensurePrecision: // adds precision string if not already present
    $67Nsh.ensurePrecision,
    addProgramDefines: // add some defines if WebGL1 to make it more compatible with WebGL2 shaders
    $iCp49.addProgramDefines,
    setProgramName: // add the program name to the shader
    $aUAMu.setProgramName,
    insertVersion: // add the version string to the shader header
    $3Hbxe.insertVersion
};
const $5a1cd4acf4c2252d$var$programCache = /* @__PURE__ */ Object.create(null);
const $5a1cd4acf4c2252d$var$_GlProgram = class _GlProgram {
    /**
   * Creates a shiny new GlProgram. Used by WebGL renderer.
   * @param options - The options for the program.
   */ constructor(options){
        options = {
            ..._GlProgram.defaultOptions,
            ...options
        };
        const isES300 = options.fragment.indexOf("#version 300 es") !== -1;
        const preprocessorOptions = {
            stripVersion: isES300,
            ensurePrecision: {
                requestedFragmentPrecision: options.preferredFragmentPrecision,
                requestedVertexPrecision: options.preferredVertexPrecision,
                maxSupportedVertexPrecision: "highp",
                maxSupportedFragmentPrecision: (0, $c1vp1.getMaxFragmentPrecision)()
            },
            setProgramName: {
                name: options.name
            },
            addProgramDefines: isES300,
            insertVersion: isES300
        };
        let fragment = options.fragment;
        let vertex = options.vertex;
        Object.keys($5a1cd4acf4c2252d$var$processes).forEach((processKey)=>{
            const processOptions = preprocessorOptions[processKey];
            fragment = $5a1cd4acf4c2252d$var$processes[processKey](fragment, processOptions, true);
            vertex = $5a1cd4acf4c2252d$var$processes[processKey](vertex, processOptions, false);
        });
        this.fragment = fragment;
        this.vertex = vertex;
        this._key = (0, $9kWs1.createIdFromString)(`${this.vertex}:${this.fragment}`, "gl-program");
    }
    /** destroys the program */ destroy() {
        this.fragment = null;
        this.vertex = null;
        this._attributeData = null;
        this._uniformData = null;
        this._uniformBlockData = null;
        this.transformFeedbackVaryings = null;
    }
    /**
   * Helper function that creates a program for a given source.
   * It will check the program cache if the program has already been created.
   * If it has that one will be returned, if not a new one will be created and cached.
   * @param options - The options for the program.
   * @returns A program using the same source
   */ static from(options) {
        const key = `${options.vertex}:${options.fragment}`;
        if (!$5a1cd4acf4c2252d$var$programCache[key]) $5a1cd4acf4c2252d$var$programCache[key] = new _GlProgram(options);
        return $5a1cd4acf4c2252d$var$programCache[key];
    }
};
/** The default options used by the program. */ $5a1cd4acf4c2252d$var$_GlProgram.defaultOptions = {
    preferredVertexPrecision: "highp",
    preferredFragmentPrecision: "mediump"
};
let $5a1cd4acf4c2252d$export$64881d9ea0a969d7 = $5a1cd4acf4c2252d$var$_GlProgram;

});
parcelRegister("9kWs1", function(module, exports) {

$parcel$export(module.exports, "createIdFromString", () => $0601e88d616c38d4$export$1e452c36dfe36a93);
"use strict";
const $0601e88d616c38d4$var$idCounts = /* @__PURE__ */ Object.create(null);
const $0601e88d616c38d4$var$idHash = /* @__PURE__ */ Object.create(null);
function $0601e88d616c38d4$export$1e452c36dfe36a93(value, groupId) {
    let id = $0601e88d616c38d4$var$idHash[value];
    if (id === void 0) {
        if ($0601e88d616c38d4$var$idCounts[groupId] === void 0) $0601e88d616c38d4$var$idCounts[groupId] = 1;
        $0601e88d616c38d4$var$idHash[value] = id = $0601e88d616c38d4$var$idCounts[groupId]++;
    }
    return id;
}

});

parcelRegister("c1vp1", function(module, exports) {

$parcel$export(module.exports, "getMaxFragmentPrecision", () => $e905b7e6e5b75a20$export$428c38e64838140);

var $ckKKH = parcelRequire("ckKKH");
"use strict";
let $e905b7e6e5b75a20$var$maxFragmentPrecision;
function $e905b7e6e5b75a20$export$428c38e64838140() {
    if (!$e905b7e6e5b75a20$var$maxFragmentPrecision) {
        $e905b7e6e5b75a20$var$maxFragmentPrecision = "mediump";
        const gl = (0, $ckKKH.getTestContext)();
        if (gl) {
            if (gl.getShaderPrecisionFormat) {
                const shaderFragment = gl.getShaderPrecisionFormat(gl.FRAGMENT_SHADER, gl.HIGH_FLOAT);
                $e905b7e6e5b75a20$var$maxFragmentPrecision = shaderFragment.precision ? "highp" : "mediump";
            }
        }
    }
    return $e905b7e6e5b75a20$var$maxFragmentPrecision;
}

});

parcelRegister("iCp49", function(module, exports) {

$parcel$export(module.exports, "addProgramDefines", () => $ab141df14b998d07$export$fba00ea8bc676dd1);
"use strict";
function $ab141df14b998d07$export$fba00ea8bc676dd1(src, isES300, isFragment) {
    if (isES300) return src;
    if (isFragment) {
        src = src.replace("out vec4 finalColor;", "");
        return `
        
        #ifdef GL_ES // This checks if it is WebGL1
        #define in varying
        #define finalColor gl_FragColor
        #define texture texture2D
        #endif
        ${src}
        `;
    }
    return `
        
        #ifdef GL_ES // This checks if it is WebGL1
        #define in attribute
        #define out varying
        #endif
        ${src}
        `;
}

});

parcelRegister("67Nsh", function(module, exports) {

$parcel$export(module.exports, "ensurePrecision", () => $bda6ccefc0c5ab42$export$899bdffb1b617f8b);
"use strict";
function $bda6ccefc0c5ab42$export$899bdffb1b617f8b(src, options, isFragment) {
    const maxSupportedPrecision = isFragment ? options.maxSupportedFragmentPrecision : options.maxSupportedVertexPrecision;
    if (src.substring(0, 9) !== "precision") {
        let precision = isFragment ? options.requestedFragmentPrecision : options.requestedVertexPrecision;
        if (precision === "highp" && maxSupportedPrecision !== "highp") precision = "mediump";
        return `precision ${precision} float;
${src}`;
    } else if (maxSupportedPrecision !== "highp" && src.substring(0, 15) === "precision highp") return src.replace("precision highp", "precision mediump");
    return src;
}

});

parcelRegister("3Hbxe", function(module, exports) {

$parcel$export(module.exports, "insertVersion", () => $82be6e3df1c54b73$export$df5409633d2e06a0);
"use strict";
function $82be6e3df1c54b73$export$df5409633d2e06a0(src, isES300) {
    if (!isES300) return src;
    return `#version 300 es
${src}`;
}

});

parcelRegister("aUAMu", function(module, exports) {

$parcel$export(module.exports, "setProgramName", () => $de2ea14e21161fdc$export$fcd35f5a80d5e29b);
"use strict";
const $de2ea14e21161fdc$var$fragmentNameCache = {};
const $de2ea14e21161fdc$var$VertexNameCache = {};
function $de2ea14e21161fdc$export$fcd35f5a80d5e29b(src, { name: name = `pixi-program` }, isFragment = true) {
    name = name.replace(/\s+/g, "-");
    name += isFragment ? "-fragment" : "-vertex";
    const nameCache = isFragment ? $de2ea14e21161fdc$var$fragmentNameCache : $de2ea14e21161fdc$var$VertexNameCache;
    if (nameCache[name]) {
        nameCache[name]++;
        name += `-${nameCache[name]}`;
    } else nameCache[name] = 1;
    if (src.indexOf("#define SHADER_NAME") !== -1) return src;
    const shaderName = `#define SHADER_NAME ${name}`;
    return `${shaderName}
${src}`;
}

});

parcelRegister("500fb", function(module, exports) {

$parcel$export(module.exports, "stripVersion", () => $d98e8e318b45168f$export$f71406e7a553e9e5);
"use strict";
function $d98e8e318b45168f$export$f71406e7a553e9e5(src, isES300) {
    if (!isES300) return src;
    return src.replace("#version 300 es", "");
}

});


parcelRegister("6j7wq", function(module, exports) {

$parcel$export(module.exports, "GpuProgram", () => $8e9bc14aafd75f61$export$b7a31a3cdd61870);

var $9kWs1 = parcelRequire("9kWs1");

var $7j3L3 = parcelRequire("7j3L3");

var $ceyhm = parcelRequire("ceyhm");

var $eebg6 = parcelRequire("eebg6");

var $gwiyt = parcelRequire("gwiyt");

var $ftyd4 = parcelRequire("ftyd4");
"use strict";
const $8e9bc14aafd75f61$var$programCache = /* @__PURE__ */ Object.create(null);
class $8e9bc14aafd75f61$export$b7a31a3cdd61870 {
    /**
   * Create a new GpuProgram
   * @param options - The options for the gpu program
   */ constructor(options){
        /**
     * @internal
     * @ignore
     */ this._layoutKey = 0;
        /**
     * @internal
     * @ignore
     */ this._attributeLocationsKey = 0;
        const { fragment: fragment, vertex: vertex, layout: layout, gpuLayout: gpuLayout, name: name } = options;
        this.name = name;
        this.fragment = fragment;
        this.vertex = vertex;
        if (fragment.source === vertex.source) {
            const structsAndGroups = (0, $ceyhm.extractStructAndGroups)(fragment.source);
            this.structsAndGroups = structsAndGroups;
        } else {
            const vertexStructsAndGroups = (0, $ceyhm.extractStructAndGroups)(vertex.source);
            const fragmentStructsAndGroups = (0, $ceyhm.extractStructAndGroups)(fragment.source);
            this.structsAndGroups = (0, $ftyd4.removeStructAndGroupDuplicates)(vertexStructsAndGroups, fragmentStructsAndGroups);
        }
        this.layout = layout ?? (0, $gwiyt.generateLayoutHash)(this.structsAndGroups);
        this.gpuLayout = gpuLayout ?? (0, $eebg6.generateGpuLayoutGroups)(this.structsAndGroups);
        this.autoAssignGlobalUniforms = !!(this.layout[0]?.globalUniforms !== void 0);
        this.autoAssignLocalUniforms = !!(this.layout[1]?.localUniforms !== void 0);
        this._generateProgramKey();
    }
    // TODO maker this pure
    _generateProgramKey() {
        const { vertex: vertex, fragment: fragment } = this;
        const bigKey = vertex.source + fragment.source + vertex.entryPoint + fragment.entryPoint;
        this._layoutKey = (0, $9kWs1.createIdFromString)(bigKey, "program");
    }
    get attributeData() {
        this._attributeData ?? (this._attributeData = (0, $7j3L3.extractAttributesFromGpuProgram)(this.vertex));
        return this._attributeData;
    }
    /** destroys the program */ destroy() {
        this.gpuLayout = null;
        this.layout = null;
        this.structsAndGroups = null;
        this.fragment = null;
        this.vertex = null;
    }
    /**
   * Helper function that creates a program for a given source.
   * It will check the program cache if the program has already been created.
   * If it has that one will be returned, if not a new one will be created and cached.
   * @param options - The options for the program.
   * @returns A program using the same source
   */ static from(options) {
        const key = `${options.vertex.source}:${options.fragment.source}:${options.fragment.entryPoint}:${options.vertex.entryPoint}`;
        if (!$8e9bc14aafd75f61$var$programCache[key]) $8e9bc14aafd75f61$var$programCache[key] = new $8e9bc14aafd75f61$export$b7a31a3cdd61870(options);
        return $8e9bc14aafd75f61$var$programCache[key];
    }
}

});
parcelRegister("7j3L3", function(module, exports) {

$parcel$export(module.exports, "extractAttributesFromGpuProgram", () => $a83de38b8d80c92b$export$b0efe5f01c53f69f);

var $kavUV = parcelRequire("kavUV");
"use strict";
const $a83de38b8d80c92b$var$WGSL_TO_VERTEX_TYPES = {
    f32: "float32",
    "vec2<f32>": "float32x2",
    "vec3<f32>": "float32x3",
    "vec4<f32>": "float32x4",
    vec2f: "float32x2",
    vec3f: "float32x3",
    vec4f: "float32x4",
    i32: "sint32",
    "vec2<i32>": "sint32x2",
    "vec3<i32>": "sint32x3",
    "vec4<i32>": "sint32x4",
    u32: "uint32",
    "vec2<u32>": "uint32x2",
    "vec3<u32>": "uint32x3",
    "vec4<u32>": "uint32x4",
    bool: "uint32",
    "vec2<bool>": "uint32x2",
    "vec3<bool>": "uint32x3",
    "vec4<bool>": "uint32x4"
};
function $a83de38b8d80c92b$export$b0efe5f01c53f69f({ source: source, entryPoint: entryPoint }) {
    const results = {};
    const mainVertStart = source.indexOf(`fn ${entryPoint}`);
    if (mainVertStart !== -1) {
        const arrowFunctionStart = source.indexOf("->", mainVertStart);
        if (arrowFunctionStart !== -1) {
            const functionArgsSubstring = source.substring(mainVertStart, arrowFunctionStart);
            const inputsRegex = /@location\((\d+)\)\s+([a-zA-Z0-9_]+)\s*:\s*([a-zA-Z0-9_<>]+)(?:,|\s|$)/g;
            let match;
            while((match = inputsRegex.exec(functionArgsSubstring)) !== null){
                const format = $a83de38b8d80c92b$var$WGSL_TO_VERTEX_TYPES[match[3]] ?? "float32";
                results[match[2]] = {
                    location: parseInt(match[1], 10),
                    format: format,
                    stride: (0, $kavUV.getAttributeInfoFromFormat)(format).stride,
                    offset: 0,
                    instance: false,
                    start: 0
                };
            }
        }
    }
    return results;
}

});
parcelRegister("kavUV", function(module, exports) {

$parcel$export(module.exports, "getAttributeInfoFromFormat", () => $b94249370f97e371$export$4da509c30cc6be33);
"use strict";
const $b94249370f97e371$var$attributeFormatData = {
    uint8x2: {
        size: 2,
        stride: 2,
        normalised: false
    },
    uint8x4: {
        size: 4,
        stride: 4,
        normalised: false
    },
    sint8x2: {
        size: 2,
        stride: 2,
        normalised: false
    },
    sint8x4: {
        size: 4,
        stride: 4,
        normalised: false
    },
    unorm8x2: {
        size: 2,
        stride: 2,
        normalised: true
    },
    unorm8x4: {
        size: 4,
        stride: 4,
        normalised: true
    },
    snorm8x2: {
        size: 2,
        stride: 2,
        normalised: true
    },
    snorm8x4: {
        size: 4,
        stride: 4,
        normalised: true
    },
    uint16x2: {
        size: 2,
        stride: 4,
        normalised: false
    },
    uint16x4: {
        size: 4,
        stride: 8,
        normalised: false
    },
    sint16x2: {
        size: 2,
        stride: 4,
        normalised: false
    },
    sint16x4: {
        size: 4,
        stride: 8,
        normalised: false
    },
    unorm16x2: {
        size: 2,
        stride: 4,
        normalised: true
    },
    unorm16x4: {
        size: 4,
        stride: 8,
        normalised: true
    },
    snorm16x2: {
        size: 2,
        stride: 4,
        normalised: true
    },
    snorm16x4: {
        size: 4,
        stride: 8,
        normalised: true
    },
    float16x2: {
        size: 2,
        stride: 4,
        normalised: false
    },
    float16x4: {
        size: 4,
        stride: 8,
        normalised: false
    },
    float32: {
        size: 1,
        stride: 4,
        normalised: false
    },
    float32x2: {
        size: 2,
        stride: 8,
        normalised: false
    },
    float32x3: {
        size: 3,
        stride: 12,
        normalised: false
    },
    float32x4: {
        size: 4,
        stride: 16,
        normalised: false
    },
    uint32: {
        size: 1,
        stride: 4,
        normalised: false
    },
    uint32x2: {
        size: 2,
        stride: 8,
        normalised: false
    },
    uint32x3: {
        size: 3,
        stride: 12,
        normalised: false
    },
    uint32x4: {
        size: 4,
        stride: 16,
        normalised: false
    },
    sint32: {
        size: 1,
        stride: 4,
        normalised: false
    },
    sint32x2: {
        size: 2,
        stride: 8,
        normalised: false
    },
    sint32x3: {
        size: 3,
        stride: 12,
        normalised: false
    },
    sint32x4: {
        size: 4,
        stride: 16,
        normalised: false
    }
};
function $b94249370f97e371$export$4da509c30cc6be33(format) {
    return $b94249370f97e371$var$attributeFormatData[format] ?? $b94249370f97e371$var$attributeFormatData.float32;
}

});


parcelRegister("ceyhm", function(module, exports) {

$parcel$export(module.exports, "extractStructAndGroups", () => $ea3e5b1ac2f96ec2$export$368e99a200562975);
"use strict";
function $ea3e5b1ac2f96ec2$export$368e99a200562975(wgsl) {
    const linePattern = /(^|[^/])@(group|binding)\(\d+\)[^;]+;/g;
    const groupPattern = /@group\((\d+)\)/;
    const bindingPattern = /@binding\((\d+)\)/;
    const namePattern = /var(<[^>]+>)? (\w+)/;
    const typePattern = /:\s*(\w+)/;
    const structPattern = /struct\s+(\w+)\s*{([^}]+)}/g;
    const structMemberPattern = /(\w+)\s*:\s*([\w\<\>]+)/g;
    const structName = /struct\s+(\w+)/;
    const groups = wgsl.match(linePattern)?.map((item)=>({
            group: parseInt(item.match(groupPattern)[1], 10),
            binding: parseInt(item.match(bindingPattern)[1], 10),
            name: item.match(namePattern)[2],
            isUniform: item.match(namePattern)[1] === "<uniform>",
            type: item.match(typePattern)[1]
        }));
    if (!groups) return {
        groups: [],
        structs: []
    };
    const structs = wgsl.match(structPattern)?.map((struct)=>{
        const name = struct.match(structName)[1];
        const members = struct.match(structMemberPattern).reduce((acc, member)=>{
            const [name2, type] = member.split(":");
            acc[name2.trim()] = type.trim();
            return acc;
        }, {});
        if (!members) return null;
        return {
            name: name,
            members: members
        };
    }).filter(({ name: name })=>groups.some((group)=>group.type === name)) ?? [];
    return {
        groups: groups,
        structs: structs
    };
}

});

parcelRegister("eebg6", function(module, exports) {

$parcel$export(module.exports, "generateGpuLayoutGroups", () => $6d1e03a3e3cda982$export$950011c0dc347495);

var $aR3rf = parcelRequire("aR3rf");
"use strict";
function $6d1e03a3e3cda982$export$950011c0dc347495({ groups: groups }) {
    const layout = [];
    for(let i = 0; i < groups.length; i++){
        const group = groups[i];
        if (!layout[group.group]) layout[group.group] = [];
        if (group.isUniform) layout[group.group].push({
            binding: group.binding,
            visibility: (0, $aR3rf.ShaderStage).VERTEX | (0, $aR3rf.ShaderStage).FRAGMENT,
            buffer: {
                type: "uniform"
            }
        });
        else if (group.type === "sampler") layout[group.group].push({
            binding: group.binding,
            visibility: (0, $aR3rf.ShaderStage).FRAGMENT,
            sampler: {
                type: "filtering"
            }
        });
        else if (group.type === "texture_2d") layout[group.group].push({
            binding: group.binding,
            visibility: (0, $aR3rf.ShaderStage).FRAGMENT,
            texture: {
                sampleType: "float",
                viewDimension: "2d",
                multisampled: false
            }
        });
    }
    return layout;
}

});
parcelRegister("aR3rf", function(module, exports) {

$parcel$export(module.exports, "ShaderStage", () => $06e6106f9171a2e8$export$34a0cafc5a97ef31);
"use strict";
var $06e6106f9171a2e8$export$34a0cafc5a97ef31 = /* @__PURE__ */ ((ShaderStage2)=>{
    ShaderStage2[ShaderStage2["VERTEX"] = 1] = "VERTEX";
    ShaderStage2[ShaderStage2["FRAGMENT"] = 2] = "FRAGMENT";
    ShaderStage2[ShaderStage2["COMPUTE"] = 4] = "COMPUTE";
    return ShaderStage2;
})($06e6106f9171a2e8$export$34a0cafc5a97ef31 || {});

});


parcelRegister("gwiyt", function(module, exports) {

$parcel$export(module.exports, "generateLayoutHash", () => $292f21f6c3cd9e17$export$6a0f9650f9d4f875);
"use strict";
function $292f21f6c3cd9e17$export$6a0f9650f9d4f875({ groups: groups }) {
    const layout = [];
    for(let i = 0; i < groups.length; i++){
        const group = groups[i];
        if (!layout[group.group]) layout[group.group] = {};
        layout[group.group][group.name] = group.binding;
    }
    return layout;
}

});

parcelRegister("ftyd4", function(module, exports) {

$parcel$export(module.exports, "removeStructAndGroupDuplicates", () => $f605447e20cc6f1a$export$5f344e20ddfaa2d6);
"use strict";
function $f605447e20cc6f1a$export$5f344e20ddfaa2d6(vertexStructsAndGroups, fragmentStructsAndGroups) {
    const structNameSet = /* @__PURE__ */ new Set();
    const dupeGroupKeySet = /* @__PURE__ */ new Set();
    const structs = [
        ...vertexStructsAndGroups.structs,
        ...fragmentStructsAndGroups.structs
    ].filter((struct)=>{
        if (structNameSet.has(struct.name)) return false;
        structNameSet.add(struct.name);
        return true;
    });
    const groups = [
        ...vertexStructsAndGroups.groups,
        ...fragmentStructsAndGroups.groups
    ].filter((group)=>{
        const key = `${group.name}-${group.binding}`;
        if (dupeGroupKeySet.has(key)) return false;
        dupeGroupKeySet.add(key);
        return true;
    });
    return {
        structs: structs,
        groups: groups
    };
}

});


parcelRegister("i8pLT", function(module, exports) {

$parcel$export(module.exports, "compileHighShader", () => $9ef573d9dfae5a48$export$86219fd7a1c584d2);
$parcel$export(module.exports, "compileHighShaderGl", () => $9ef573d9dfae5a48$export$ff7039b165d48f97);

var $9zLXd = parcelRequire("9zLXd");

var $jJet4 = parcelRequire("jJet4");

var $ak3Em = parcelRequire("ak3Em");

var $9hCqF = parcelRequire("9hCqF");

var $9Zsfg = parcelRequire("9Zsfg");
"use strict";
const $9ef573d9dfae5a48$var$cacheMap = /* @__PURE__ */ Object.create(null);
const $9ef573d9dfae5a48$var$bitCacheMap = /* @__PURE__ */ new Map();
let $9ef573d9dfae5a48$var$CACHE_UID = 0;
function $9ef573d9dfae5a48$export$86219fd7a1c584d2({ template: template, bits: bits }) {
    const cacheId = $9ef573d9dfae5a48$var$generateCacheId(template, bits);
    if ($9ef573d9dfae5a48$var$cacheMap[cacheId]) return $9ef573d9dfae5a48$var$cacheMap[cacheId];
    const { vertex: vertex, fragment: fragment } = $9ef573d9dfae5a48$var$compileInputsAndOutputs(template, bits);
    $9ef573d9dfae5a48$var$cacheMap[cacheId] = $9ef573d9dfae5a48$var$compileBits(vertex, fragment, bits);
    return $9ef573d9dfae5a48$var$cacheMap[cacheId];
}
function $9ef573d9dfae5a48$export$ff7039b165d48f97({ template: template, bits: bits }) {
    const cacheId = $9ef573d9dfae5a48$var$generateCacheId(template, bits);
    if ($9ef573d9dfae5a48$var$cacheMap[cacheId]) return $9ef573d9dfae5a48$var$cacheMap[cacheId];
    $9ef573d9dfae5a48$var$cacheMap[cacheId] = $9ef573d9dfae5a48$var$compileBits(template.vertex, template.fragment, bits);
    return $9ef573d9dfae5a48$var$cacheMap[cacheId];
}
function $9ef573d9dfae5a48$var$compileInputsAndOutputs(template, bits) {
    const vertexFragments = bits.map((shaderBit)=>shaderBit.vertex).filter((v)=>!!v);
    const fragmentFragments = bits.map((shaderBit)=>shaderBit.fragment).filter((v)=>!!v);
    let compiledVertex = (0, $ak3Em.compileInputs)(vertexFragments, template.vertex, true);
    compiledVertex = (0, $9hCqF.compileOutputs)(vertexFragments, compiledVertex);
    const compiledFragment = (0, $ak3Em.compileInputs)(fragmentFragments, template.fragment, true);
    return {
        vertex: compiledVertex,
        fragment: compiledFragment
    };
}
function $9ef573d9dfae5a48$var$generateCacheId(template, bits) {
    return bits.map((highFragment)=>{
        if (!$9ef573d9dfae5a48$var$bitCacheMap.has(highFragment)) $9ef573d9dfae5a48$var$bitCacheMap.set(highFragment, $9ef573d9dfae5a48$var$CACHE_UID++);
        return $9ef573d9dfae5a48$var$bitCacheMap.get(highFragment);
    }).sort((a, b)=>a - b).join("-") + template.vertex + template.fragment;
}
function $9ef573d9dfae5a48$var$compileBits(vertex, fragment, bits) {
    const vertexParts = (0, $jJet4.compileHooks)(vertex);
    const fragmentParts = (0, $jJet4.compileHooks)(fragment);
    bits.forEach((shaderBit)=>{
        (0, $9zLXd.addBits)(shaderBit.vertex, vertexParts, shaderBit.name);
        (0, $9zLXd.addBits)(shaderBit.fragment, fragmentParts, shaderBit.name);
    });
    return {
        vertex: (0, $9Zsfg.injectBits)(vertex, vertexParts),
        fragment: (0, $9Zsfg.injectBits)(fragment, fragmentParts)
    };
}

});
parcelRegister("9zLXd", function(module, exports) {

$parcel$export(module.exports, "addBits", () => $c36d60e017699465$export$38c21fb192fe3d9);

var $hUCK4 = parcelRequire("hUCK4");
"use strict";
function $c36d60e017699465$export$38c21fb192fe3d9(srcParts, parts, name) {
    if (srcParts) for(const i in srcParts){
        const id = i.toLocaleLowerCase();
        const part = parts[id];
        if (part) {
            let sanitisedPart = srcParts[i];
            if (i === "header") sanitisedPart = sanitisedPart.replace(/@in\s+[^;]+;\s*/g, "").replace(/@out\s+[^;]+;\s*/g, "");
            if (name) part.push(`//----${name}----//`);
            part.push(sanitisedPart);
        } else (0, $hUCK4.warn)(`${i} placement hook does not exist in shader`);
    }
}

});

parcelRegister("jJet4", function(module, exports) {

$parcel$export(module.exports, "compileHooks", () => $e10d3f89fc808d5a$export$17705ba43ca63936);
"use strict";
const $e10d3f89fc808d5a$export$a564a4c9984eee7d = /\{\{(.*?)\}\}/g;
function $e10d3f89fc808d5a$export$17705ba43ca63936(programSrc) {
    const parts = {};
    const partMatches = programSrc.match($e10d3f89fc808d5a$export$a564a4c9984eee7d)?.map((hook)=>hook.replace(/[{()}]/g, "")) ?? [];
    partMatches.forEach((hook)=>{
        parts[hook] = [];
    });
    return parts;
}

});

parcelRegister("ak3Em", function(module, exports) {

$parcel$export(module.exports, "compileInputs", () => $76be63c34b98a2b0$export$aa47df9391ef0455);
"use strict";
function $76be63c34b98a2b0$var$extractInputs(fragmentSource, out) {
    let match;
    const regex = /@in\s+([^;]+);/g;
    while((match = regex.exec(fragmentSource)) !== null)out.push(match[1]);
}
function $76be63c34b98a2b0$export$aa47df9391ef0455(fragments, template, sort = false) {
    const results = [];
    $76be63c34b98a2b0$var$extractInputs(template, results);
    fragments.forEach((fragment)=>{
        if (fragment.header) $76be63c34b98a2b0$var$extractInputs(fragment.header, results);
    });
    const mainInput = results;
    if (sort) mainInput.sort();
    const finalString = mainInput.map((inValue, i)=>`       @location(${i}) ${inValue},`).join("\n");
    let cleanedString = template.replace(/@in\s+[^;]+;\s*/g, "");
    cleanedString = cleanedString.replace("{{in}}", `
${finalString}
`);
    return cleanedString;
}

});

parcelRegister("9hCqF", function(module, exports) {

$parcel$export(module.exports, "compileOutputs", () => $eeb3f3dfbb29bd14$export$ae19cc473c7ab18);
"use strict";
function $eeb3f3dfbb29bd14$var$extractOutputs(fragmentSource, out) {
    let match;
    const regex = /@out\s+([^;]+);/g;
    while((match = regex.exec(fragmentSource)) !== null)out.push(match[1]);
}
function $eeb3f3dfbb29bd14$var$extractVariableName(value) {
    const regex = /\b(\w+)\s*:/g;
    const match = regex.exec(value);
    return match ? match[1] : "";
}
function $eeb3f3dfbb29bd14$var$stripVariable(value) {
    const regex = /@.*?\s+/g;
    return value.replace(regex, "");
}
function $eeb3f3dfbb29bd14$export$ae19cc473c7ab18(fragments, template) {
    const results = [];
    $eeb3f3dfbb29bd14$var$extractOutputs(template, results);
    fragments.forEach((fragment)=>{
        if (fragment.header) $eeb3f3dfbb29bd14$var$extractOutputs(fragment.header, results);
    });
    let index = 0;
    const mainStruct = results.sort().map((inValue)=>{
        if (inValue.indexOf("builtin") > -1) return inValue;
        return `@location(${index++}) ${inValue}`;
    }).join(",\n");
    const mainStart = results.sort().map((inValue)=>`       var ${$eeb3f3dfbb29bd14$var$stripVariable(inValue)};`).join("\n");
    const mainEnd = `return VSOutput(
                ${results.sort().map((inValue)=>` ${$eeb3f3dfbb29bd14$var$extractVariableName(inValue)}`).join(",\n")});`;
    let compiledCode = template.replace(/@out\s+[^;]+;\s*/g, "");
    compiledCode = compiledCode.replace("{{struct}}", `
${mainStruct}
`);
    compiledCode = compiledCode.replace("{{start}}", `
${mainStart}
`);
    compiledCode = compiledCode.replace("{{return}}", `
${mainEnd}
`);
    return compiledCode;
}

});

parcelRegister("9Zsfg", function(module, exports) {

$parcel$export(module.exports, "injectBits", () => $650fee7fffdacf4b$export$83c47c7340456c75);
"use strict";
function $650fee7fffdacf4b$export$83c47c7340456c75(templateSrc, fragmentParts) {
    let out = templateSrc;
    for(const i in fragmentParts){
        const parts = fragmentParts[i];
        const toInject = parts.join("\n");
        if (toInject.length) out = out.replace(`{{${i}}}`, `//-----${i} START-----//
${parts.join("\n")}
//----${i} FINISH----//`);
        else out = out.replace(`{{${i}}}`, "");
    }
    return out;
}

});


parcelRegister("jOJh1", function(module, exports) {

$parcel$export(module.exports, "vertexGPUTemplate", () => $f723d8c01fbb4e07$export$61ecfa8d2718163a);
$parcel$export(module.exports, "fragmentGPUTemplate", () => $f723d8c01fbb4e07$export$922d1073ee2ef930);
$parcel$export(module.exports, "vertexGlTemplate", () => $f723d8c01fbb4e07$export$99b0f79e15be8ede);
$parcel$export(module.exports, "fragmentGlTemplate", () => $f723d8c01fbb4e07$export$3f7784dd6a13ff5a);
"use strict";
const $f723d8c01fbb4e07$export$61ecfa8d2718163a = /* wgsl */ `
    @in aPosition: vec2<f32>;
    @in aUV: vec2<f32>;

    @out @builtin(position) vPosition: vec4<f32>;
    @out vUV : vec2<f32>;
    @out vColor : vec4<f32>;

    {{header}}

    struct VSOutput {
        {{struct}}
    };

    @vertex
    fn main( {{in}} ) -> VSOutput {

        var worldTransformMatrix = globalUniforms.uWorldTransformMatrix;
        var modelMatrix = mat3x3<f32>(
            1.0, 0.0, 0.0,
            0.0, 1.0, 0.0,
            0.0, 0.0, 1.0
          );
        var position = aPosition;
        var uv = aUV;

        {{start}}
        
        vColor = vec4<f32>(1., 1., 1., 1.);

        {{main}}

        vUV = uv;

        var modelViewProjectionMatrix = globalUniforms.uProjectionMatrix * worldTransformMatrix * modelMatrix;

        vPosition =  vec4<f32>((modelViewProjectionMatrix *  vec3<f32>(position, 1.0)).xy, 0.0, 1.0);
       
        vColor *= globalUniforms.uWorldColorAlpha;

        {{end}}

        {{return}}
    };
`;
const $f723d8c01fbb4e07$export$922d1073ee2ef930 = /* wgsl */ `
    @in vUV : vec2<f32>;
    @in vColor : vec4<f32>;
   
    {{header}}

    @fragment
    fn main(
        {{in}}
      ) -> @location(0) vec4<f32> {
        
        {{start}}

        var outColor:vec4<f32>;
      
        {{main}}
        
        var finalColor:vec4<f32> = outColor * vColor;

        {{end}}

        return finalColor;
      };
`;
const $f723d8c01fbb4e07$export$99b0f79e15be8ede = /* glsl */ `
    in vec2 aPosition;
    in vec2 aUV;

    out vec4 vColor;
    out vec2 vUV;

    {{header}}

    void main(void){

        mat3 worldTransformMatrix = uWorldTransformMatrix;
        mat3 modelMatrix = mat3(
            1.0, 0.0, 0.0,
            0.0, 1.0, 0.0,
            0.0, 0.0, 1.0
          );
        vec2 position = aPosition;
        vec2 uv = aUV;
        
        {{start}}
        
        vColor = vec4(1.);
        
        {{main}}
        
        vUV = uv;
        
        mat3 modelViewProjectionMatrix = uProjectionMatrix * worldTransformMatrix * modelMatrix;

        gl_Position = vec4((modelViewProjectionMatrix * vec3(position, 1.0)).xy, 0.0, 1.0);

        vColor *= uWorldColorAlpha;

        {{end}}
    }
`;
const $f723d8c01fbb4e07$export$3f7784dd6a13ff5a = /* glsl */ `
   
    in vec4 vColor;
    in vec2 vUV;

    out vec4 finalColor;

    {{header}}

    void main(void) {
        
        {{start}}

        vec4 outColor;
      
        {{main}}
        
        finalColor = outColor * vColor;
        
        {{end}}
    }
`;

});

parcelRegister("8hMvn", function(module, exports) {

$parcel$export(module.exports, "globalUniformsBit", () => $d20cb1ce683ff173$export$435d64b3a14c5a51);
$parcel$export(module.exports, "globalUniformsBitGl", () => $d20cb1ce683ff173$export$38608853d4735d51);
"use strict";
const $d20cb1ce683ff173$export$435d64b3a14c5a51 = {
    name: "global-uniforms-bit",
    vertex: {
        header: /* wgsl */ `
        struct GlobalUniforms {
            uProjectionMatrix:mat3x3<f32>,
            uWorldTransformMatrix:mat3x3<f32>,
            uWorldColorAlpha: vec4<f32>,
            uResolution: vec2<f32>,
        }

        @group(0) @binding(0) var<uniform> globalUniforms : GlobalUniforms;
        `
    }
};
const $d20cb1ce683ff173$export$320b7a2ae65b2f3a = {
    name: "global-uniforms-ubo-bit",
    vertex: {
        header: /* glsl */ `
          uniform globalUniforms {
            mat3 uProjectionMatrix;
            mat3 uWorldTransformMatrix;
            vec4 uWorldColorAlpha;
            vec2 uResolution;
          };
        `
    }
};
const $d20cb1ce683ff173$export$38608853d4735d51 = {
    name: "global-uniforms-bit",
    vertex: {
        header: /* glsl */ `
          uniform mat3 uProjectionMatrix;
          uniform mat3 uWorldTransformMatrix;
          uniform vec4 uWorldColorAlpha;
          uniform vec2 uResolution;
        `
    }
};

});


parcelRegister("cNnNT", function(module, exports) {

$parcel$export(module.exports, "colorBit", () => $39898bd73b5669c2$export$a62becfe5fe4ad2);
$parcel$export(module.exports, "colorBitGl", () => $39898bd73b5669c2$export$93189e9821cf4459);
"use strict";
const $39898bd73b5669c2$export$a62becfe5fe4ad2 = {
    name: "color-bit",
    vertex: {
        header: /* wgsl */ `
            @in aColor: vec4<f32>;
        `,
        main: /* wgsl */ `
            vColor *= vec4<f32>(aColor.rgb * aColor.a, aColor.a);
        `
    }
};
const $39898bd73b5669c2$export$93189e9821cf4459 = {
    name: "color-bit",
    vertex: {
        header: /* glsl */ `
            in vec4 aColor;
        `,
        main: /* glsl */ `
            vColor *= vec4(aColor.rgb * aColor.a, aColor.a);
        `
    }
};

});

parcelRegister("ikSZA", function(module, exports) {

$parcel$export(module.exports, "generateTextureBatchBit", () => $da5fa72bb41a0724$export$aff2d36945cda647);
$parcel$export(module.exports, "generateTextureBatchBitGl", () => $da5fa72bb41a0724$export$204e46d9a7a4f835);
"use strict";
const $da5fa72bb41a0724$var$textureBatchBitGpuCache = {};
function $da5fa72bb41a0724$var$generateBindingSrc(maxTextures) {
    const src = [];
    if (maxTextures === 1) {
        src.push("@group(1) @binding(0) var textureSource1: texture_2d<f32>;");
        src.push("@group(1) @binding(1) var textureSampler1: sampler;");
    } else {
        let bindingIndex = 0;
        for(let i = 0; i < maxTextures; i++){
            src.push(`@group(1) @binding(${bindingIndex++}) var textureSource${i + 1}: texture_2d<f32>;`);
            src.push(`@group(1) @binding(${bindingIndex++}) var textureSampler${i + 1}: sampler;`);
        }
    }
    return src.join("\n");
}
function $da5fa72bb41a0724$var$generateSampleSrc(maxTextures) {
    const src = [];
    if (maxTextures === 1) src.push("outColor = textureSampleGrad(textureSource1, textureSampler1, vUV, uvDx, uvDy);");
    else {
        src.push("switch vTextureId {");
        for(let i = 0; i < maxTextures; i++){
            if (i === maxTextures - 1) src.push(`  default:{`);
            else src.push(`  case ${i}:{`);
            src.push(`      outColor = textureSampleGrad(textureSource${i + 1}, textureSampler${i + 1}, vUV, uvDx, uvDy);`);
            src.push(`      break;}`);
        }
        src.push(`}`);
    }
    return src.join("\n");
}
function $da5fa72bb41a0724$export$aff2d36945cda647(maxTextures) {
    if (!$da5fa72bb41a0724$var$textureBatchBitGpuCache[maxTextures]) $da5fa72bb41a0724$var$textureBatchBitGpuCache[maxTextures] = {
        name: "texture-batch-bit",
        vertex: {
            header: `
                @in aTextureIdAndRound: vec2<u32>;
                @out @interpolate(flat) vTextureId : u32;
            `,
            main: `
                vTextureId = aTextureIdAndRound.y;
            `,
            end: `
                if(aTextureIdAndRound.x == 1)
                {
                    vPosition = vec4<f32>(roundPixels(vPosition.xy, globalUniforms.uResolution), vPosition.zw);
                }
            `
        },
        fragment: {
            header: `
                @in @interpolate(flat) vTextureId: u32;

                ${$da5fa72bb41a0724$var$generateBindingSrc(maxTextures)}
            `,
            main: `
                var uvDx = dpdx(vUV);
                var uvDy = dpdy(vUV);

                ${$da5fa72bb41a0724$var$generateSampleSrc(maxTextures)}
            `
        }
    };
    return $da5fa72bb41a0724$var$textureBatchBitGpuCache[maxTextures];
}
const $da5fa72bb41a0724$var$textureBatchBitGlCache = {};
function $da5fa72bb41a0724$var$generateSampleGlSrc(maxTextures) {
    const src = [];
    for(let i = 0; i < maxTextures; i++){
        if (i > 0) src.push("else");
        if (i < maxTextures - 1) src.push(`if(vTextureId < ${i}.5)`);
        src.push("{");
        src.push(`	outColor = texture(uTextures[${i}], vUV);`);
        src.push("}");
    }
    return src.join("\n");
}
function $da5fa72bb41a0724$export$204e46d9a7a4f835(maxTextures) {
    if (!$da5fa72bb41a0724$var$textureBatchBitGlCache[maxTextures]) $da5fa72bb41a0724$var$textureBatchBitGlCache[maxTextures] = {
        name: "texture-batch-bit",
        vertex: {
            header: `
                in vec2 aTextureIdAndRound;
                out float vTextureId;

            `,
            main: `
                vTextureId = aTextureIdAndRound.y;
            `,
            end: `
                if(aTextureIdAndRound.x == 1.)
                {
                    gl_Position.xy = roundPixels(gl_Position.xy, uResolution);
                }
            `
        },
        fragment: {
            header: `
                in float vTextureId;

                uniform sampler2D uTextures[${maxTextures}];

            `,
            main: `

                ${$da5fa72bb41a0724$var$generateSampleGlSrc(maxTextures)}
            `
        }
    };
    return $da5fa72bb41a0724$var$textureBatchBitGlCache[maxTextures];
}

});

parcelRegister("kSpdC", function(module, exports) {

$parcel$export(module.exports, "roundPixelsBit", () => $2b55e281ef9e6651$export$22150169726f7b1);
$parcel$export(module.exports, "roundPixelsBitGl", () => $2b55e281ef9e6651$export$222909710f39cc5);
"use strict";
const $2b55e281ef9e6651$export$22150169726f7b1 = {
    name: "round-pixels-bit",
    vertex: {
        header: /* wgsl */ `
            fn roundPixels(position: vec2<f32>, targetSize: vec2<f32>) -> vec2<f32> 
            {
                return (floor(((position * 0.5 + 0.5) * targetSize) + 0.5) / targetSize) * 2.0 - 1.0;
            }
        `
    }
};
const $2b55e281ef9e6651$export$222909710f39cc5 = {
    name: "round-pixels-bit",
    vertex: {
        header: /* glsl */ `   
            vec2 roundPixels(vec2 position, vec2 targetSize)
            {       
                return (floor(((position * 0.5 + 0.5) * targetSize) + 0.5) / targetSize) * 2.0 - 1.0;
            }
        `
    }
};

});

parcelRegister("10zIa", function(module, exports) {

$parcel$export(module.exports, "getBatchSamplersUniformGroup", () => $8d646a0ea6e06bfb$export$5fc8295c6cba6ffe);

var $cryyq = parcelRequire("cryyq");
"use strict";
const $8d646a0ea6e06bfb$var$batchSamplersUniformGroupHash = {};
function $8d646a0ea6e06bfb$export$5fc8295c6cba6ffe(maxTextures) {
    let batchSamplersUniformGroup = $8d646a0ea6e06bfb$var$batchSamplersUniformGroupHash[maxTextures];
    if (batchSamplersUniformGroup) return batchSamplersUniformGroup;
    const sampleValues = new Int32Array(maxTextures);
    for(let i = 0; i < maxTextures; i++)sampleValues[i] = i;
    batchSamplersUniformGroup = $8d646a0ea6e06bfb$var$batchSamplersUniformGroupHash[maxTextures] = new (0, $cryyq.UniformGroup)({
        uTextures: {
            value: sampleValues,
            type: `i32`,
            size: maxTextures
        }
    }, {
        isStatic: true
    });
    return batchSamplersUniformGroup;
}

});
parcelRegister("cryyq", function(module, exports) {

$parcel$export(module.exports, "UniformGroup", () => $9136c1ea7e89e2b5$export$6601a7a2dcf79bf5);

var $aGJhg = parcelRequire("aGJhg");

var $9kWs1 = parcelRequire("9kWs1");

var $jhfqN = parcelRequire("jhfqN");

var $ezKtQ = parcelRequire("ezKtQ");
"use strict";
const $9136c1ea7e89e2b5$var$_UniformGroup = class _UniformGroup {
    /**
   * Create a new Uniform group
   * @param uniformStructures - The structures of the uniform group
   * @param options - The optional parameters of this uniform group
   */ constructor(uniformStructures, options){
        /** used internally to know if a uniform group was used in the last render pass */ this._touched = 0;
        /** a unique id for this uniform group used through the renderer */ this.uid = (0, $aGJhg.uid)("uniform");
        /** a resource type, used to identify how to handle it when its in a bind group / shader resource */ this._resourceType = "uniformGroup";
        /** the resource id used internally by the renderer to build bind group keys */ this._resourceId = (0, $aGJhg.uid)("resource");
        /** used ito identify if this is a uniform group */ this.isUniformGroup = true;
        /**
     * used to flag if this Uniform groups data is different from what it has stored in its buffer / on the GPU
     * @internal
     * @ignore
     */ this._dirtyId = 0;
        // implementing the interface - UniformGroup are not destroyed
        this.destroyed = false;
        options = {
            ..._UniformGroup.defaultOptions,
            ...options
        };
        this.uniformStructures = uniformStructures;
        const uniforms = {};
        for(const i in uniformStructures){
            const uniformData = uniformStructures[i];
            uniformData.name = i;
            uniformData.size = uniformData.size ?? 1;
            if (!(0, $jhfqN.UNIFORM_TYPES_MAP)[uniformData.type]) throw new Error(`Uniform type ${uniformData.type} is not supported. Supported uniform types are: ${(0, $jhfqN.UNIFORM_TYPES_VALUES).join(", ")}`);
            uniformData.value ?? (uniformData.value = (0, $ezKtQ.getDefaultUniformValue)(uniformData.type, uniformData.size));
            uniforms[i] = uniformData.value;
        }
        this.uniforms = uniforms;
        this._dirtyId = 1;
        this.ubo = options.ubo;
        this.isStatic = options.isStatic;
        this._signature = (0, $9kWs1.createIdFromString)(Object.keys(uniforms).map((i)=>`${i}-${uniformStructures[i].type}`).join("-"), "uniform-group");
    }
    /** Call this if you want the uniform groups data to be uploaded to the GPU only useful if `isStatic` is true. */ update() {
        this._dirtyId++;
    }
};
/** The default options used by the uniform group. */ $9136c1ea7e89e2b5$var$_UniformGroup.defaultOptions = {
    /** if true the UniformGroup is handled as an Uniform buffer object. */ ubo: false,
    /** if true, then you are responsible for when the data is uploaded to the GPU by calling `update()` */ isStatic: false
};
let $9136c1ea7e89e2b5$export$6601a7a2dcf79bf5 = $9136c1ea7e89e2b5$var$_UniformGroup;

});
parcelRegister("jhfqN", function(module, exports) {

$parcel$export(module.exports, "UNIFORM_TYPES_VALUES", () => $d4900ea566bb062d$export$94ae83f3c0da5990);
$parcel$export(module.exports, "UNIFORM_TYPES_MAP", () => $d4900ea566bb062d$export$97ddd6675231876e);
"use strict";
const $d4900ea566bb062d$export$94ae83f3c0da5990 = [
    "f32",
    "i32",
    "vec2<f32>",
    "vec3<f32>",
    "vec4<f32>",
    "mat2x2<f32>",
    "mat3x3<f32>",
    "mat4x4<f32>",
    "mat3x2<f32>",
    "mat4x2<f32>",
    "mat2x3<f32>",
    "mat4x3<f32>",
    "mat2x4<f32>",
    "mat3x4<f32>"
];
const $d4900ea566bb062d$export$97ddd6675231876e = $d4900ea566bb062d$export$94ae83f3c0da5990.reduce((acc, type)=>{
    acc[type] = true;
    return acc;
}, {});

});

parcelRegister("ezKtQ", function(module, exports) {

$parcel$export(module.exports, "getDefaultUniformValue", () => $aa11a20cb06f2781$export$7febdb6905805c3d);
"use strict";
function $aa11a20cb06f2781$export$7febdb6905805c3d(type, size) {
    switch(type){
        case "f32":
            return 0;
        case "vec2<f32>":
            return new Float32Array(2 * size);
        case "vec3<f32>":
            return new Float32Array(3 * size);
        case "vec4<f32>":
            return new Float32Array(4 * size);
        case "mat2x2<f32>":
            return new Float32Array([
                1,
                0,
                0,
                1
            ]);
        case "mat3x3<f32>":
            return new Float32Array([
                1,
                0,
                0,
                0,
                1,
                0,
                0,
                0,
                1
            ]);
        case "mat4x4<f32>":
            return new Float32Array([
                1,
                0,
                0,
                0,
                0,
                1,
                0,
                0,
                0,
                0,
                1,
                0,
                0,
                0,
                0,
                1
            ]);
    }
    return null;
}

});



parcelRegister("5iDyo", function(module, exports) {

$parcel$export(module.exports, "Shader", () => $26072a826565afe8$export$462bb059fed9d9e5);

var $3vRz3 = parcelRequire("3vRz3");

var $fK92B = parcelRequire("fK92B");

var $awcfo = parcelRequire("awcfo");

var $6j7wq = parcelRequire("6j7wq");

var $2bK9z = parcelRequire("2bK9z");

var $cryyq = parcelRequire("cryyq");
"use strict";
class $26072a826565afe8$export$462bb059fed9d9e5 extends (0, (/*@__PURE__*/$parcel$interopDefault($3vRz3))) {
    constructor(options){
        super();
        /**
     * A record of the uniform groups and resources used by the shader.
     * This is used by WebGL renderer to sync uniform data.
     * @internal
     * @ignore
     */ this._uniformBindMap = /* @__PURE__ */ Object.create(null);
        this._ownedBindGroups = [];
        let { gpuProgram: gpuProgram, glProgram: glProgram, groups: groups, resources: resources, compatibleRenderers: compatibleRenderers, groupMap: groupMap } = options;
        this.gpuProgram = gpuProgram;
        this.glProgram = glProgram;
        if (compatibleRenderers === void 0) {
            compatibleRenderers = 0;
            if (gpuProgram) compatibleRenderers |= (0, $2bK9z.RendererType).WEBGPU;
            if (glProgram) compatibleRenderers |= (0, $2bK9z.RendererType).WEBGL;
        }
        this.compatibleRenderers = compatibleRenderers;
        const nameHash = {};
        if (!resources && !groups) resources = {};
        if (resources && groups) throw new Error("[Shader] Cannot have both resources and groups");
        else if (!gpuProgram && groups && !groupMap) throw new Error("[Shader] No group map or WebGPU shader provided - consider using resources instead.");
        else if (!gpuProgram && groups && groupMap) {
            for(const i in groupMap)for(const j in groupMap[i]){
                const uniformName = groupMap[i][j];
                nameHash[uniformName] = {
                    group: i,
                    binding: j,
                    name: uniformName
                };
            }
        } else if (gpuProgram && groups && !groupMap) {
            const groupData = gpuProgram.structsAndGroups.groups;
            groupMap = {};
            groupData.forEach((data)=>{
                groupMap[data.group] = groupMap[data.group] || {};
                groupMap[data.group][data.binding] = data.name;
                nameHash[data.name] = data;
            });
        } else if (resources) {
            groups = {};
            groupMap = {};
            if (gpuProgram) {
                const groupData = gpuProgram.structsAndGroups.groups;
                groupData.forEach((data)=>{
                    groupMap[data.group] = groupMap[data.group] || {};
                    groupMap[data.group][data.binding] = data.name;
                    nameHash[data.name] = data;
                });
            }
            let bindTick = 0;
            for(const i in resources){
                if (nameHash[i]) continue;
                if (!groups[99]) {
                    groups[99] = new (0, $awcfo.BindGroup)();
                    this._ownedBindGroups.push(groups[99]);
                }
                nameHash[i] = {
                    group: 99,
                    binding: bindTick,
                    name: i
                };
                groupMap[99] = groupMap[99] || {};
                groupMap[99][bindTick] = i;
                bindTick++;
            }
            for(const i in resources){
                const name = i;
                let value = resources[i];
                if (!value.source && !value._resourceType) value = new (0, $cryyq.UniformGroup)(value);
                const data = nameHash[name];
                if (data) {
                    if (!groups[data.group]) {
                        groups[data.group] = new (0, $awcfo.BindGroup)();
                        this._ownedBindGroups.push(groups[data.group]);
                    }
                    groups[data.group].setResource(value, data.binding);
                }
            }
        }
        this.groups = groups;
        this._uniformBindMap = groupMap;
        this.resources = this._buildResourceAccessor(groups, nameHash);
    }
    /**
   * Sometimes a resource group will be provided later (for example global uniforms)
   * In such cases, this method can be used to let the shader know about the group.
   * @param name - the name of the resource group
   * @param groupIndex - the index of the group (should match the webGPU shader group location)
   * @param bindIndex - the index of the bind point (should match the webGPU shader bind point)
   */ addResource(name, groupIndex, bindIndex) {
        var _a, _b;
        (_a = this._uniformBindMap)[groupIndex] || (_a[groupIndex] = {});
        (_b = this._uniformBindMap[groupIndex])[bindIndex] || (_b[bindIndex] = name);
        if (!this.groups[groupIndex]) {
            this.groups[groupIndex] = new (0, $awcfo.BindGroup)();
            this._ownedBindGroups.push(this.groups[groupIndex]);
        }
    }
    _buildResourceAccessor(groups, nameHash) {
        const uniformsOut = {};
        for(const i in nameHash){
            const data = nameHash[i];
            Object.defineProperty(uniformsOut, data.name, {
                get () {
                    return groups[data.group].getResource(data.binding);
                },
                set (value) {
                    groups[data.group].setResource(value, data.binding);
                }
            });
        }
        return uniformsOut;
    }
    /**
   * Use to destroy the shader when its not longer needed.
   * It will destroy the resources and remove listeners.
   * @param destroyPrograms - if the programs should be destroyed as well.
   * Make sure its not being used by other shaders!
   */ destroy(destroyPrograms = false) {
        this.emit("destroy", this);
        if (destroyPrograms) {
            this.gpuProgram?.destroy();
            this.glProgram?.destroy();
        }
        this.gpuProgram = null;
        this.glProgram = null;
        this.removeAllListeners();
        this._uniformBindMap = null;
        this._ownedBindGroups.forEach((bindGroup)=>{
            bindGroup.destroy();
        });
        this._ownedBindGroups = null;
        this.resources = null;
        this.groups = null;
    }
    static from(options) {
        const { gpu: gpu, gl: gl, ...rest } = options;
        let gpuProgram;
        let glProgram;
        if (gpu) gpuProgram = (0, $6j7wq.GpuProgram).from(gpu);
        if (gl) glProgram = (0, $fK92B.GlProgram).from(gl);
        return new $26072a826565afe8$export$462bb059fed9d9e5({
            gpuProgram: gpuProgram,
            glProgram: glProgram,
            ...rest
        });
    }
}

});
parcelRegister("2bK9z", function(module, exports) {

$parcel$export(module.exports, "RendererType", () => $d9ac1633e306ebfe$export$2ca8315eebe81c3d);
"use strict";
var $d9ac1633e306ebfe$export$2ca8315eebe81c3d = /* @__PURE__ */ ((RendererType2)=>{
    RendererType2[RendererType2["WEBGL"] = 1] = "WEBGL";
    RendererType2[RendererType2["WEBGPU"] = 2] = "WEBGPU";
    RendererType2[RendererType2["BOTH"] = 3] = "BOTH";
    return RendererType2;
})($d9ac1633e306ebfe$export$2ca8315eebe81c3d || {});

});




parcelRegister("1mKkK", function(module, exports) {

$parcel$export(module.exports, "buildContextBatches", () => $2ba674c6e42be2fb$export$e3c00f31a053d231);

var $i9BKe = parcelRequire("i9BKe");

var $fM4Mk = parcelRequire("fM4Mk");

var $kVCUp = parcelRequire("kVCUp");

var $9Co9Q = parcelRequire("9Co9Q");

var $bLlTJ = parcelRequire("bLlTJ");

var $61KiY = parcelRequire("61KiY");

var $xZ5a3 = parcelRequire("xZ5a3");

var $dY2iR = parcelRequire("dY2iR");

var $46SPq = parcelRequire("46SPq");

var $ei7YJ = parcelRequire("ei7YJ");

var $7DIxn = parcelRequire("7DIxn");

var $iAUCq = parcelRequire("iAUCq");

var $2E1jb = parcelRequire("2E1jb");
"use strict";
const $2ba674c6e42be2fb$export$ab760b0d495e92a1 = {};
(0, $i9BKe.extensions).handleByMap((0, $i9BKe.ExtensionType).ShapeBuilder, $2ba674c6e42be2fb$export$ab760b0d495e92a1);
(0, $i9BKe.extensions).add((0, $7DIxn.buildRectangle), (0, $ei7YJ.buildPolygon), (0, $iAUCq.buildTriangle), (0, $dY2iR.buildCircle), (0, $dY2iR.buildEllipse), (0, $dY2iR.buildRoundedRectangle));
const $2ba674c6e42be2fb$var$tempRect = new (0, $fM4Mk.Rectangle)();
function $2ba674c6e42be2fb$export$e3c00f31a053d231(context, gpuContext) {
    const { geometryData: geometryData, batches: batches } = gpuContext;
    batches.length = 0;
    geometryData.indices.length = 0;
    geometryData.vertices.length = 0;
    geometryData.uvs.length = 0;
    for(let i = 0; i < context.instructions.length; i++){
        const instruction = context.instructions[i];
        if (instruction.action === "texture") $2ba674c6e42be2fb$var$addTextureToGeometryData(instruction.data, batches, geometryData);
        else if (instruction.action === "fill" || instruction.action === "stroke") {
            const isStroke = instruction.action === "stroke";
            const shapePath = instruction.data.path.shapePath;
            const style = instruction.data.style;
            const hole = instruction.data.hole;
            if (isStroke && hole) $2ba674c6e42be2fb$var$addShapePathToGeometryData(hole.shapePath, style, null, true, batches, geometryData);
            $2ba674c6e42be2fb$var$addShapePathToGeometryData(shapePath, style, hole, isStroke, batches, geometryData);
        }
    }
}
function $2ba674c6e42be2fb$var$addTextureToGeometryData(data, batches, geometryData) {
    const { vertices: vertices, uvs: uvs, indices: indices } = geometryData;
    const indexOffset = indices.length;
    const vertOffset = vertices.length / 2;
    const points = [];
    const build = $2ba674c6e42be2fb$export$ab760b0d495e92a1.rectangle;
    const rect = $2ba674c6e42be2fb$var$tempRect;
    const texture = data.image;
    rect.x = data.dx;
    rect.y = data.dy;
    rect.width = data.dw;
    rect.height = data.dh;
    const matrix = data.transform;
    build.build(rect, points);
    if (matrix) (0, $9Co9Q.transformVertices)(points, matrix);
    build.triangulate(points, vertices, 2, vertOffset, indices, indexOffset);
    const textureUvs = texture.uvs;
    uvs.push(textureUvs.x0, textureUvs.y0, textureUvs.x1, textureUvs.y1, textureUvs.x3, textureUvs.y3, textureUvs.x2, textureUvs.y2);
    const graphicsBatch = (0, $61KiY.BigPool).get((0, $xZ5a3.BatchableGraphics));
    graphicsBatch.indexOffset = indexOffset;
    graphicsBatch.indexSize = indices.length - indexOffset;
    graphicsBatch.attributeOffset = vertOffset;
    graphicsBatch.attributeSize = vertices.length / 2 - vertOffset;
    graphicsBatch.baseColor = data.style;
    graphicsBatch.alpha = data.alpha;
    graphicsBatch.texture = texture;
    graphicsBatch.geometryData = geometryData;
    batches.push(graphicsBatch);
}
function $2ba674c6e42be2fb$var$addShapePathToGeometryData(shapePath, style, hole, isStroke, batches, geometryData) {
    const { vertices: vertices, uvs: uvs, indices: indices } = geometryData;
    const lastIndex = shapePath.shapePrimitives.length - 1;
    shapePath.shapePrimitives.forEach(({ shape: shape, transform: matrix }, i)=>{
        const indexOffset = indices.length;
        const vertOffset = vertices.length / 2;
        const points = [];
        const build = $2ba674c6e42be2fb$export$ab760b0d495e92a1[shape.type];
        build.build(shape, points);
        if (matrix) (0, $9Co9Q.transformVertices)(points, matrix);
        if (!isStroke) {
            if (hole && lastIndex === i) {
                if (lastIndex !== 0) console.warn("[Pixi Graphics] only the last shape have be cut out");
                const holeIndices = [];
                const otherPoints = points.slice();
                const holeArrays = $2ba674c6e42be2fb$var$getHoleArrays(hole.shapePath);
                holeArrays.forEach((holePoints)=>{
                    holeIndices.push(otherPoints.length / 2);
                    otherPoints.push(...holePoints);
                });
                (0, $2E1jb.triangulateWithHoles)(otherPoints, holeIndices, vertices, 2, vertOffset, indices, indexOffset);
            } else build.triangulate(points, vertices, 2, vertOffset, indices, indexOffset);
        } else {
            const close = shape.closePath ?? true;
            const lineStyle = style;
            (0, $46SPq.buildLine)(points, lineStyle, false, close, vertices, 2, vertOffset, indices, indexOffset);
        }
        const uvsOffset = uvs.length / 2;
        const texture = style.texture;
        if (texture !== (0, $bLlTJ.Texture).WHITE) {
            const textureMatrix = style.matrix;
            if (textureMatrix) {
                if (matrix) textureMatrix.append(matrix.clone().invert());
                (0, $kVCUp.buildUvs)(vertices, 2, vertOffset, uvs, uvsOffset, 2, vertices.length / 2 - vertOffset, textureMatrix);
            }
        } else (0, $kVCUp.buildSimpleUvs)(uvs, uvsOffset, 2, vertices.length / 2 - vertOffset);
        const graphicsBatch = (0, $61KiY.BigPool).get((0, $xZ5a3.BatchableGraphics));
        graphicsBatch.indexOffset = indexOffset;
        graphicsBatch.indexSize = indices.length - indexOffset;
        graphicsBatch.attributeOffset = vertOffset;
        graphicsBatch.attributeSize = vertices.length / 2 - vertOffset;
        graphicsBatch.baseColor = style.color;
        graphicsBatch.alpha = style.alpha;
        graphicsBatch.texture = texture;
        graphicsBatch.geometryData = geometryData;
        batches.push(graphicsBatch);
    });
}
function $2ba674c6e42be2fb$var$getHoleArrays(shape) {
    if (!shape) return [];
    const holePrimitives = shape.shapePrimitives;
    const holeArrays = [];
    for(let k = 0; k < holePrimitives.length; k++){
        const holePrimitive = holePrimitives[k].shape;
        const holePoints = [];
        const holeBuilder = $2ba674c6e42be2fb$export$ab760b0d495e92a1[holePrimitive.type];
        holeBuilder.build(holePrimitive, holePoints);
        holeArrays.push(holePoints);
    }
    return holeArrays;
}

});
parcelRegister("kVCUp", function(module, exports) {

$parcel$export(module.exports, "buildUvs", () => $1606ccc0770732ec$export$2027711a0ff70dc2);
$parcel$export(module.exports, "buildSimpleUvs", () => $1606ccc0770732ec$export$580e3d8462b9fe52);
"use strict";
function $1606ccc0770732ec$export$2027711a0ff70dc2(vertices, verticesStride, verticesOffset, uvs, uvsOffset, uvsStride, size, matrix = null) {
    let index = 0;
    verticesOffset *= verticesStride;
    uvsOffset *= uvsStride;
    const a = matrix.a;
    const b = matrix.b;
    const c = matrix.c;
    const d = matrix.d;
    const tx = matrix.tx;
    const ty = matrix.ty;
    while(index < size){
        const x = vertices[verticesOffset];
        const y = vertices[verticesOffset + 1];
        uvs[uvsOffset] = a * x + c * y + tx;
        uvs[uvsOffset + 1] = b * x + d * y + ty;
        uvsOffset += uvsStride;
        verticesOffset += verticesStride;
        index++;
    }
}
function $1606ccc0770732ec$export$580e3d8462b9fe52(uvs, uvsOffset, uvsStride, size) {
    let index = 0;
    uvsOffset *= uvsStride;
    while(index < size){
        uvs[uvsOffset] = 0;
        uvs[uvsOffset + 1] = 0;
        uvsOffset += uvsStride;
        index++;
    }
}

});

parcelRegister("9Co9Q", function(module, exports) {

$parcel$export(module.exports, "transformVertices", () => $74e682a1604b3625$export$cbe36b8a8d6e3d3);
"use strict";
function $74e682a1604b3625$export$cbe36b8a8d6e3d3(vertices, m, offset, stride, size) {
    const a = m.a;
    const b = m.b;
    const c = m.c;
    const d = m.d;
    const tx = m.tx;
    const ty = m.ty;
    offset = offset || 0;
    stride = stride || 2;
    size = size || vertices.length / stride - offset;
    let index = offset * stride;
    for(let i = 0; i < size; i++){
        const x = vertices[index];
        const y = vertices[index + 1];
        vertices[index] = a * x + c * y + tx;
        vertices[index + 1] = b * x + d * y + ty;
        index += stride;
    }
}

});

parcelRegister("xZ5a3", function(module, exports) {

$parcel$export(module.exports, "BatchableGraphics", () => $3f80d08e0b9378c5$export$91d2a08bbf21546b);

var $eY4rt = parcelRequire("eY4rt");

var $3N6bV = parcelRequire("3N6bV");
"use strict";
const $3f80d08e0b9378c5$var$identityMatrix = new (0, $eY4rt.Matrix)();
class $3f80d08e0b9378c5$export$91d2a08bbf21546b {
    constructor(){
        this.packAsQuad = false;
        this.batcherName = "default";
        this.applyTransform = true;
        this.roundPixels = 0;
        this._batcher = null;
        this._batch = null;
    }
    get uvs() {
        return this.geometryData.uvs;
    }
    get positions() {
        return this.geometryData.vertices;
    }
    get indices() {
        return this.geometryData.indices;
    }
    get blendMode() {
        if (this.applyTransform) return this.renderable.groupBlendMode;
        return "normal";
    }
    get color() {
        const rgb = this.baseColor;
        const bgr = rgb >> 16 | rgb & 65280 | (rgb & 255) << 16;
        const renderable = this.renderable;
        if (renderable) return (0, $3N6bV.multiplyHexColors)(bgr, renderable.groupColor) + (this.alpha * renderable.groupAlpha * 255 << 24);
        return bgr + (this.alpha * 255 << 24);
    }
    get transform() {
        return this.renderable?.groupTransform || $3f80d08e0b9378c5$var$identityMatrix;
    }
    copyTo(gpuBuffer) {
        gpuBuffer.indexOffset = this.indexOffset;
        gpuBuffer.indexSize = this.indexSize;
        gpuBuffer.attributeOffset = this.attributeOffset;
        gpuBuffer.attributeSize = this.attributeSize;
        gpuBuffer.baseColor = this.baseColor;
        gpuBuffer.alpha = this.alpha;
        gpuBuffer.texture = this.texture;
        gpuBuffer.geometryData = this.geometryData;
    }
    reset() {
        this.applyTransform = true;
    }
}

});
parcelRegister("3N6bV", function(module, exports) {

$parcel$export(module.exports, "multiplyHexColors", () => $038267701630e9a0$export$815d7ea0395de72c);
"use strict";
function $038267701630e9a0$export$815d7ea0395de72c(color1, color2) {
    if (color1 === 16777215 || !color2) return color2;
    if (color2 === 16777215 || !color1) return color1;
    const r1 = color1 >> 16 & 255;
    const g1 = color1 >> 8 & 255;
    const b1 = color1 & 255;
    const r2 = color2 >> 16 & 255;
    const g2 = color2 >> 8 & 255;
    const b2 = color2 & 255;
    const r = r1 * r2 / 255;
    const g = g1 * g2 / 255;
    const b = b1 * b2 / 255;
    return (r << 16) + (g << 8) + b;
}

});


parcelRegister("dY2iR", function(module, exports) {

$parcel$export(module.exports, "buildCircle", () => $791ed7b81fe09d67$export$a3541b2d8ecbfcf2);
$parcel$export(module.exports, "buildEllipse", () => $791ed7b81fe09d67$export$d35b00c6ec9534ca);
$parcel$export(module.exports, "buildRoundedRectangle", () => $791ed7b81fe09d67$export$4b54fce47d2ae7f4);

var $i9BKe = parcelRequire("i9BKe");
"use strict";
const $791ed7b81fe09d67$export$a3541b2d8ecbfcf2 = {
    extension: {
        type: (0, $i9BKe.ExtensionType).ShapeBuilder,
        name: "circle"
    },
    build (shape, points) {
        let x;
        let y;
        let dx;
        let dy;
        let rx;
        let ry;
        if (shape.type === "circle") {
            const circle = shape;
            x = circle.x;
            y = circle.y;
            rx = ry = circle.radius;
            dx = dy = 0;
        } else if (shape.type === "ellipse") {
            const ellipse = shape;
            x = ellipse.x;
            y = ellipse.y;
            rx = ellipse.halfWidth;
            ry = ellipse.halfHeight;
            dx = dy = 0;
        } else {
            const roundedRect = shape;
            const halfWidth = roundedRect.width / 2;
            const halfHeight = roundedRect.height / 2;
            x = roundedRect.x + halfWidth;
            y = roundedRect.y + halfHeight;
            rx = ry = Math.max(0, Math.min(roundedRect.radius, Math.min(halfWidth, halfHeight)));
            dx = halfWidth - rx;
            dy = halfHeight - ry;
        }
        if (!(rx >= 0 && ry >= 0 && dx >= 0 && dy >= 0)) return points;
        const n = Math.ceil(2.3 * Math.sqrt(rx + ry));
        const m = n * 8 + (dx ? 4 : 0) + (dy ? 4 : 0);
        if (m === 0) return points;
        if (n === 0) {
            points[0] = points[6] = x + dx;
            points[1] = points[3] = y + dy;
            points[2] = points[4] = x - dx;
            points[5] = points[7] = y - dy;
            return points;
        }
        let j1 = 0;
        let j2 = n * 4 + (dx ? 2 : 0) + 2;
        let j3 = j2;
        let j4 = m;
        let x0 = dx + rx;
        let y0 = dy;
        let x1 = x + x0;
        let x2 = x - x0;
        let y1 = y + y0;
        points[j1++] = x1;
        points[j1++] = y1;
        points[--j2] = y1;
        points[--j2] = x2;
        if (dy) {
            const y22 = y - y0;
            points[j3++] = x2;
            points[j3++] = y22;
            points[--j4] = y22;
            points[--j4] = x1;
        }
        for(let i = 1; i < n; i++){
            const a = Math.PI / 2 * (i / n);
            const x02 = dx + Math.cos(a) * rx;
            const y02 = dy + Math.sin(a) * ry;
            const x12 = x + x02;
            const x22 = x - x02;
            const y12 = y + y02;
            const y22 = y - y02;
            points[j1++] = x12;
            points[j1++] = y12;
            points[--j2] = y12;
            points[--j2] = x22;
            points[j3++] = x22;
            points[j3++] = y22;
            points[--j4] = y22;
            points[--j4] = x12;
        }
        x0 = dx;
        y0 = dy + ry;
        x1 = x + x0;
        x2 = x - x0;
        y1 = y + y0;
        const y2 = y - y0;
        points[j1++] = x1;
        points[j1++] = y1;
        points[--j4] = y2;
        points[--j4] = x1;
        if (dx) {
            points[j1++] = x2;
            points[j1++] = y1;
            points[--j4] = y2;
            points[--j4] = x2;
        }
        return points;
    },
    triangulate (points, vertices, verticesStride, verticesOffset, indices, indicesOffset) {
        if (points.length === 0) return;
        let centerX = 0;
        let centerY = 0;
        for(let i = 0; i < points.length; i += 2){
            centerX += points[i];
            centerY += points[i + 1];
        }
        centerX /= points.length / 2;
        centerY /= points.length / 2;
        let count = verticesOffset;
        vertices[count * verticesStride] = centerX;
        vertices[count * verticesStride + 1] = centerY;
        const centerIndex = count++;
        for(let i = 0; i < points.length; i += 2){
            vertices[count * verticesStride] = points[i];
            vertices[count * verticesStride + 1] = points[i + 1];
            if (i > 0) {
                indices[indicesOffset++] = count;
                indices[indicesOffset++] = centerIndex;
                indices[indicesOffset++] = count - 1;
            }
            count++;
        }
        indices[indicesOffset++] = centerIndex + 1;
        indices[indicesOffset++] = centerIndex;
        indices[indicesOffset++] = count - 1;
    }
};
const $791ed7b81fe09d67$export$d35b00c6ec9534ca = {
    ...$791ed7b81fe09d67$export$a3541b2d8ecbfcf2,
    extension: {
        ...$791ed7b81fe09d67$export$a3541b2d8ecbfcf2.extension,
        name: "ellipse"
    }
};
const $791ed7b81fe09d67$export$4b54fce47d2ae7f4 = {
    ...$791ed7b81fe09d67$export$a3541b2d8ecbfcf2,
    extension: {
        ...$791ed7b81fe09d67$export$a3541b2d8ecbfcf2.extension,
        name: "roundedRectangle"
    }
};

});

parcelRegister("46SPq", function(module, exports) {

$parcel$export(module.exports, "buildLine", () => $9fc8551677af3cf1$export$45986ccf08e93b0b);

var $1HooC = parcelRequire("1HooC");

var $d1s7O = parcelRequire("d1s7O");

var $168p3 = parcelRequire("168p3");
"use strict";
function $9fc8551677af3cf1$var$square(x, y, nx, ny, innerWeight, outerWeight, clockwise, verts) {
    const ix = x - nx * innerWeight;
    const iy = y - ny * innerWeight;
    const ox = x + nx * outerWeight;
    const oy = y + ny * outerWeight;
    let exx;
    let eyy;
    if (clockwise) {
        exx = ny;
        eyy = -nx;
    } else {
        exx = -ny;
        eyy = nx;
    }
    const eix = ix + exx;
    const eiy = iy + eyy;
    const eox = ox + exx;
    const eoy = oy + eyy;
    verts.push(eix, eiy);
    verts.push(eox, eoy);
    return 2;
}
function $9fc8551677af3cf1$var$round(cx, cy, sx, sy, ex, ey, verts, clockwise) {
    const cx2p0x = sx - cx;
    const cy2p0y = sy - cy;
    let angle0 = Math.atan2(cx2p0x, cy2p0y);
    let angle1 = Math.atan2(ex - cx, ey - cy);
    if (clockwise && angle0 < angle1) angle0 += Math.PI * 2;
    else if (!clockwise && angle0 > angle1) angle1 += Math.PI * 2;
    let startAngle = angle0;
    const angleDiff = angle1 - angle0;
    const absAngleDiff = Math.abs(angleDiff);
    const radius = Math.sqrt(cx2p0x * cx2p0x + cy2p0y * cy2p0y);
    const segCount = (15 * absAngleDiff * Math.sqrt(radius) / Math.PI >> 0) + 1;
    const angleInc = angleDiff / segCount;
    startAngle += angleInc;
    if (clockwise) {
        verts.push(cx, cy);
        verts.push(sx, sy);
        for(let i = 1, angle = startAngle; i < segCount; i++, angle += angleInc){
            verts.push(cx, cy);
            verts.push(cx + Math.sin(angle) * radius, cy + Math.cos(angle) * radius);
        }
        verts.push(cx, cy);
        verts.push(ex, ey);
    } else {
        verts.push(sx, sy);
        verts.push(cx, cy);
        for(let i = 1, angle = startAngle; i < segCount; i++, angle += angleInc){
            verts.push(cx + Math.sin(angle) * radius, cy + Math.cos(angle) * radius);
            verts.push(cx, cy);
        }
        verts.push(ex, ey);
        verts.push(cx, cy);
    }
    return segCount * 2;
}
function $9fc8551677af3cf1$export$45986ccf08e93b0b(points, lineStyle, flipAlignment, closed, vertices, _verticesStride, _verticesOffset, indices, _indicesOffset) {
    const eps = (0, $d1s7O.closePointEps);
    if (points.length === 0) return;
    const style = lineStyle;
    let alignment = style.alignment;
    if (lineStyle.alignment !== 0.5) {
        let orientation = (0, $168p3.getOrientationOfPoints)(points);
        if (flipAlignment) orientation *= -1;
        alignment = (alignment - 0.5) * orientation + 0.5;
    }
    const firstPoint = new (0, $1HooC.Point)(points[0], points[1]);
    const lastPoint = new (0, $1HooC.Point)(points[points.length - 2], points[points.length - 1]);
    const closedShape = closed;
    const closedPath = Math.abs(firstPoint.x - lastPoint.x) < eps && Math.abs(firstPoint.y - lastPoint.y) < eps;
    if (closedShape) {
        points = points.slice();
        if (closedPath) {
            points.pop();
            points.pop();
            lastPoint.set(points[points.length - 2], points[points.length - 1]);
        }
        const midPointX = (firstPoint.x + lastPoint.x) * 0.5;
        const midPointY = (lastPoint.y + firstPoint.y) * 0.5;
        points.unshift(midPointX, midPointY);
        points.push(midPointX, midPointY);
    }
    const verts = vertices;
    const length = points.length / 2;
    let indexCount = points.length;
    const indexStart = verts.length / 2;
    const width = style.width / 2;
    const widthSquared = width * width;
    const miterLimitSquared = style.miterLimit * style.miterLimit;
    let x0 = points[0];
    let y0 = points[1];
    let x1 = points[2];
    let y1 = points[3];
    let x2 = 0;
    let y2 = 0;
    let perpX = -(y0 - y1);
    let perpY = x0 - x1;
    let perp1x = 0;
    let perp1y = 0;
    let dist = Math.sqrt(perpX * perpX + perpY * perpY);
    perpX /= dist;
    perpY /= dist;
    perpX *= width;
    perpY *= width;
    const ratio = alignment;
    const innerWeight = (1 - ratio) * 2;
    const outerWeight = ratio * 2;
    if (!closedShape) {
        if (style.cap === "round") indexCount += $9fc8551677af3cf1$var$round(x0 - perpX * (innerWeight - outerWeight) * 0.5, y0 - perpY * (innerWeight - outerWeight) * 0.5, x0 - perpX * innerWeight, y0 - perpY * innerWeight, x0 + perpX * outerWeight, y0 + perpY * outerWeight, verts, true) + 2;
        else if (style.cap === "square") indexCount += $9fc8551677af3cf1$var$square(x0, y0, perpX, perpY, innerWeight, outerWeight, true, verts);
    }
    verts.push(x0 - perpX * innerWeight, y0 - perpY * innerWeight);
    verts.push(x0 + perpX * outerWeight, y0 + perpY * outerWeight);
    for(let i = 1; i < length - 1; ++i){
        x0 = points[(i - 1) * 2];
        y0 = points[(i - 1) * 2 + 1];
        x1 = points[i * 2];
        y1 = points[i * 2 + 1];
        x2 = points[(i + 1) * 2];
        y2 = points[(i + 1) * 2 + 1];
        perpX = -(y0 - y1);
        perpY = x0 - x1;
        dist = Math.sqrt(perpX * perpX + perpY * perpY);
        perpX /= dist;
        perpY /= dist;
        perpX *= width;
        perpY *= width;
        perp1x = -(y1 - y2);
        perp1y = x1 - x2;
        dist = Math.sqrt(perp1x * perp1x + perp1y * perp1y);
        perp1x /= dist;
        perp1y /= dist;
        perp1x *= width;
        perp1y *= width;
        const dx0 = x1 - x0;
        const dy0 = y0 - y1;
        const dx1 = x1 - x2;
        const dy1 = y2 - y1;
        const dot = dx0 * dx1 + dy0 * dy1;
        const cross = dy0 * dx1 - dy1 * dx0;
        const clockwise = cross < 0;
        if (Math.abs(cross) < 1e-3 * Math.abs(dot)) {
            verts.push(x1 - perpX * innerWeight, y1 - perpY * innerWeight);
            verts.push(x1 + perpX * outerWeight, y1 + perpY * outerWeight);
            if (dot >= 0) {
                if (style.join === "round") indexCount += $9fc8551677af3cf1$var$round(x1, y1, x1 - perpX * innerWeight, y1 - perpY * innerWeight, x1 - perp1x * innerWeight, y1 - perp1y * innerWeight, verts, false) + 4;
                else indexCount += 2;
                verts.push(x1 - perp1x * outerWeight, y1 - perp1y * outerWeight);
                verts.push(x1 + perp1x * innerWeight, y1 + perp1y * innerWeight);
            }
            continue;
        }
        const c1 = (-perpX + x0) * (-perpY + y1) - (-perpX + x1) * (-perpY + y0);
        const c2 = (-perp1x + x2) * (-perp1y + y1) - (-perp1x + x1) * (-perp1y + y2);
        const px = (dx0 * c2 - dx1 * c1) / cross;
        const py = (dy1 * c1 - dy0 * c2) / cross;
        const pDist = (px - x1) * (px - x1) + (py - y1) * (py - y1);
        const imx = x1 + (px - x1) * innerWeight;
        const imy = y1 + (py - y1) * innerWeight;
        const omx = x1 - (px - x1) * outerWeight;
        const omy = y1 - (py - y1) * outerWeight;
        const smallerInsideSegmentSq = Math.min(dx0 * dx0 + dy0 * dy0, dx1 * dx1 + dy1 * dy1);
        const insideWeight = clockwise ? innerWeight : outerWeight;
        const smallerInsideDiagonalSq = smallerInsideSegmentSq + insideWeight * insideWeight * widthSquared;
        const insideMiterOk = pDist <= smallerInsideDiagonalSq;
        if (insideMiterOk) {
            if (style.join === "bevel" || pDist / widthSquared > miterLimitSquared) {
                if (clockwise) {
                    verts.push(imx, imy);
                    verts.push(x1 + perpX * outerWeight, y1 + perpY * outerWeight);
                    verts.push(imx, imy);
                    verts.push(x1 + perp1x * outerWeight, y1 + perp1y * outerWeight);
                } else {
                    verts.push(x1 - perpX * innerWeight, y1 - perpY * innerWeight);
                    verts.push(omx, omy);
                    verts.push(x1 - perp1x * innerWeight, y1 - perp1y * innerWeight);
                    verts.push(omx, omy);
                }
                indexCount += 2;
            } else if (style.join === "round") {
                if (clockwise) {
                    verts.push(imx, imy);
                    verts.push(x1 + perpX * outerWeight, y1 + perpY * outerWeight);
                    indexCount += $9fc8551677af3cf1$var$round(x1, y1, x1 + perpX * outerWeight, y1 + perpY * outerWeight, x1 + perp1x * outerWeight, y1 + perp1y * outerWeight, verts, true) + 4;
                    verts.push(imx, imy);
                    verts.push(x1 + perp1x * outerWeight, y1 + perp1y * outerWeight);
                } else {
                    verts.push(x1 - perpX * innerWeight, y1 - perpY * innerWeight);
                    verts.push(omx, omy);
                    indexCount += $9fc8551677af3cf1$var$round(x1, y1, x1 - perpX * innerWeight, y1 - perpY * innerWeight, x1 - perp1x * innerWeight, y1 - perp1y * innerWeight, verts, false) + 4;
                    verts.push(x1 - perp1x * innerWeight, y1 - perp1y * innerWeight);
                    verts.push(omx, omy);
                }
            } else {
                verts.push(imx, imy);
                verts.push(omx, omy);
            }
        } else {
            verts.push(x1 - perpX * innerWeight, y1 - perpY * innerWeight);
            verts.push(x1 + perpX * outerWeight, y1 + perpY * outerWeight);
            if (style.join === "round") {
                if (clockwise) indexCount += $9fc8551677af3cf1$var$round(x1, y1, x1 + perpX * outerWeight, y1 + perpY * outerWeight, x1 + perp1x * outerWeight, y1 + perp1y * outerWeight, verts, true) + 2;
                else indexCount += $9fc8551677af3cf1$var$round(x1, y1, x1 - perpX * innerWeight, y1 - perpY * innerWeight, x1 - perp1x * innerWeight, y1 - perp1y * innerWeight, verts, false) + 2;
            } else if (style.join === "miter" && pDist / widthSquared <= miterLimitSquared) {
                if (clockwise) {
                    verts.push(omx, omy);
                    verts.push(omx, omy);
                } else {
                    verts.push(imx, imy);
                    verts.push(imx, imy);
                }
                indexCount += 2;
            }
            verts.push(x1 - perp1x * innerWeight, y1 - perp1y * innerWeight);
            verts.push(x1 + perp1x * outerWeight, y1 + perp1y * outerWeight);
            indexCount += 2;
        }
    }
    x0 = points[(length - 2) * 2];
    y0 = points[(length - 2) * 2 + 1];
    x1 = points[(length - 1) * 2];
    y1 = points[(length - 1) * 2 + 1];
    perpX = -(y0 - y1);
    perpY = x0 - x1;
    dist = Math.sqrt(perpX * perpX + perpY * perpY);
    perpX /= dist;
    perpY /= dist;
    perpX *= width;
    perpY *= width;
    verts.push(x1 - perpX * innerWeight, y1 - perpY * innerWeight);
    verts.push(x1 + perpX * outerWeight, y1 + perpY * outerWeight);
    if (!closedShape) {
        if (style.cap === "round") indexCount += $9fc8551677af3cf1$var$round(x1 - perpX * (innerWeight - outerWeight) * 0.5, y1 - perpY * (innerWeight - outerWeight) * 0.5, x1 - perpX * innerWeight, y1 - perpY * innerWeight, x1 + perpX * outerWeight, y1 + perpY * outerWeight, verts, false) + 2;
        else if (style.cap === "square") indexCount += $9fc8551677af3cf1$var$square(x1, y1, perpX, perpY, innerWeight, outerWeight, false, verts);
    }
    const eps2 = (0, $d1s7O.curveEps) * (0, $d1s7O.curveEps);
    for(let i = indexStart; i < indexCount + indexStart - 2; ++i){
        x0 = verts[i * 2];
        y0 = verts[i * 2 + 1];
        x1 = verts[(i + 1) * 2];
        y1 = verts[(i + 1) * 2 + 1];
        x2 = verts[(i + 2) * 2];
        y2 = verts[(i + 2) * 2 + 1];
        if (Math.abs(x0 * (y1 - y2) + x1 * (y2 - y0) + x2 * (y0 - y1)) < eps2) continue;
        indices.push(i, i + 1, i + 2);
    }
}

});
parcelRegister("d1s7O", function(module, exports) {

$parcel$export(module.exports, "closePointEps", () => $5f88c52b3933a72f$export$7159a7c43f12984);
$parcel$export(module.exports, "curveEps", () => $5f88c52b3933a72f$export$51a946149243709);
"use strict";
const $5f88c52b3933a72f$export$7159a7c43f12984 = 1e-4;
const $5f88c52b3933a72f$export$51a946149243709 = 1e-4;

});

parcelRegister("168p3", function(module, exports) {

$parcel$export(module.exports, "getOrientationOfPoints", () => $19281094736c08bb$export$38856eae80d480e1);
"use strict";
function $19281094736c08bb$export$38856eae80d480e1(points) {
    const m = points.length;
    if (m < 6) return 1;
    let area = 0;
    for(let i = 0, x1 = points[m - 2], y1 = points[m - 1]; i < m; i += 2){
        const x2 = points[i];
        const y2 = points[i + 1];
        area += (x2 - x1) * (y2 + y1);
        x1 = x2;
        y1 = y2;
    }
    if (area < 0) return -1;
    return 1;
}

});


parcelRegister("ei7YJ", function(module, exports) {

$parcel$export(module.exports, "buildPolygon", () => $7f823fd9a95a0bf4$export$4c2d12f7b210f357);

var $i9BKe = parcelRequire("i9BKe");

var $2E1jb = parcelRequire("2E1jb");
"use strict";
const $7f823fd9a95a0bf4$var$emptyArray = [];
const $7f823fd9a95a0bf4$export$4c2d12f7b210f357 = {
    extension: {
        type: (0, $i9BKe.ExtensionType).ShapeBuilder,
        name: "polygon"
    },
    build (shape, points) {
        for(let i = 0; i < shape.points.length; i++)points[i] = shape.points[i];
        return points;
    },
    triangulate (points, vertices, verticesStride, verticesOffset, indices, indicesOffset) {
        (0, $2E1jb.triangulateWithHoles)(points, $7f823fd9a95a0bf4$var$emptyArray, vertices, verticesStride, verticesOffset, indices, indicesOffset);
    }
};

});
parcelRegister("2E1jb", function(module, exports) {

$parcel$export(module.exports, "triangulateWithHoles", () => $0c79f6b53084d415$export$5a241bf9c2c3d94b);

var $2jYVZ = parcelRequire("2jYVZ");
"use strict";
function $0c79f6b53084d415$export$5a241bf9c2c3d94b(points, holes, vertices, verticesStride, verticesOffset, indices, indicesOffset) {
    const triangles = (0, (/*@__PURE__*/$parcel$interopDefault($2jYVZ)))(points, holes, 2);
    if (!triangles) return;
    for(let i = 0; i < triangles.length; i += 3){
        indices[indicesOffset++] = triangles[i] + verticesOffset;
        indices[indicesOffset++] = triangles[i + 1] + verticesOffset;
        indices[indicesOffset++] = triangles[i + 2] + verticesOffset;
    }
    let index = verticesOffset * verticesStride;
    for(let i = 0; i < points.length; i += 2){
        vertices[index] = points[i];
        vertices[index + 1] = points[i + 1];
        index += verticesStride;
    }
}

});
parcelRegister("2jYVZ", function(module, exports) {
"use strict";
module.exports = $1b0c9f6ca9bef72e$var$earcut;
module.exports.default = $1b0c9f6ca9bef72e$var$earcut;
function $1b0c9f6ca9bef72e$var$earcut(data, holeIndices, dim) {
    dim = dim || 2;
    var hasHoles = holeIndices && holeIndices.length, outerLen = hasHoles ? holeIndices[0] * dim : data.length, outerNode = $1b0c9f6ca9bef72e$var$linkedList(data, 0, outerLen, dim, true), triangles = [];
    if (!outerNode || outerNode.next === outerNode.prev) return triangles;
    var minX, minY, maxX, maxY, x, y, invSize;
    if (hasHoles) outerNode = $1b0c9f6ca9bef72e$var$eliminateHoles(data, holeIndices, outerNode, dim);
    // if the shape is not too simple, we'll use z-order curve hash later; calculate polygon bbox
    if (data.length > 80 * dim) {
        minX = maxX = data[0];
        minY = maxY = data[1];
        for(var i = dim; i < outerLen; i += dim){
            x = data[i];
            y = data[i + 1];
            if (x < minX) minX = x;
            if (y < minY) minY = y;
            if (x > maxX) maxX = x;
            if (y > maxY) maxY = y;
        }
        // minX, minY and invSize are later used to transform coords into integers for z-order calculation
        invSize = Math.max(maxX - minX, maxY - minY);
        invSize = invSize !== 0 ? 32767 / invSize : 0;
    }
    $1b0c9f6ca9bef72e$var$earcutLinked(outerNode, triangles, dim, minX, minY, invSize, 0);
    return triangles;
}
// create a circular doubly linked list from polygon points in the specified winding order
function $1b0c9f6ca9bef72e$var$linkedList(data, start, end, dim, clockwise) {
    var i, last;
    if (clockwise === $1b0c9f6ca9bef72e$var$signedArea(data, start, end, dim) > 0) for(i = start; i < end; i += dim)last = $1b0c9f6ca9bef72e$var$insertNode(i, data[i], data[i + 1], last);
    else for(i = end - dim; i >= start; i -= dim)last = $1b0c9f6ca9bef72e$var$insertNode(i, data[i], data[i + 1], last);
    if (last && $1b0c9f6ca9bef72e$var$equals(last, last.next)) {
        $1b0c9f6ca9bef72e$var$removeNode(last);
        last = last.next;
    }
    return last;
}
// eliminate colinear or duplicate points
function $1b0c9f6ca9bef72e$var$filterPoints(start, end) {
    if (!start) return start;
    if (!end) end = start;
    var p = start, again;
    do {
        again = false;
        if (!p.steiner && ($1b0c9f6ca9bef72e$var$equals(p, p.next) || $1b0c9f6ca9bef72e$var$area(p.prev, p, p.next) === 0)) {
            $1b0c9f6ca9bef72e$var$removeNode(p);
            p = end = p.prev;
            if (p === p.next) break;
            again = true;
        } else p = p.next;
    }while (again || p !== end);
    return end;
}
// main ear slicing loop which triangulates a polygon (given as a linked list)
function $1b0c9f6ca9bef72e$var$earcutLinked(ear, triangles, dim, minX, minY, invSize, pass) {
    if (!ear) return;
    // interlink polygon nodes in z-order
    if (!pass && invSize) $1b0c9f6ca9bef72e$var$indexCurve(ear, minX, minY, invSize);
    var stop = ear, prev, next;
    // iterate through ears, slicing them one by one
    while(ear.prev !== ear.next){
        prev = ear.prev;
        next = ear.next;
        if (invSize ? $1b0c9f6ca9bef72e$var$isEarHashed(ear, minX, minY, invSize) : $1b0c9f6ca9bef72e$var$isEar(ear)) {
            // cut off the triangle
            triangles.push(prev.i / dim | 0);
            triangles.push(ear.i / dim | 0);
            triangles.push(next.i / dim | 0);
            $1b0c9f6ca9bef72e$var$removeNode(ear);
            // skipping the next vertex leads to less sliver triangles
            ear = next.next;
            stop = next.next;
            continue;
        }
        ear = next;
        // if we looped through the whole remaining polygon and can't find any more ears
        if (ear === stop) {
            // try filtering points and slicing again
            if (!pass) $1b0c9f6ca9bef72e$var$earcutLinked($1b0c9f6ca9bef72e$var$filterPoints(ear), triangles, dim, minX, minY, invSize, 1);
            else if (pass === 1) {
                ear = $1b0c9f6ca9bef72e$var$cureLocalIntersections($1b0c9f6ca9bef72e$var$filterPoints(ear), triangles, dim);
                $1b0c9f6ca9bef72e$var$earcutLinked(ear, triangles, dim, minX, minY, invSize, 2);
            // as a last resort, try splitting the remaining polygon into two
            } else if (pass === 2) $1b0c9f6ca9bef72e$var$splitEarcut(ear, triangles, dim, minX, minY, invSize);
            break;
        }
    }
}
// check whether a polygon node forms a valid ear with adjacent nodes
function $1b0c9f6ca9bef72e$var$isEar(ear) {
    var a = ear.prev, b = ear, c = ear.next;
    if ($1b0c9f6ca9bef72e$var$area(a, b, c) >= 0) return false; // reflex, can't be an ear
    // now make sure we don't have other points inside the potential ear
    var ax = a.x, bx = b.x, cx = c.x, ay = a.y, by = b.y, cy = c.y;
    // triangle bbox; min & max are calculated like this for speed
    var x0 = ax < bx ? ax < cx ? ax : cx : bx < cx ? bx : cx, y0 = ay < by ? ay < cy ? ay : cy : by < cy ? by : cy, x1 = ax > bx ? ax > cx ? ax : cx : bx > cx ? bx : cx, y1 = ay > by ? ay > cy ? ay : cy : by > cy ? by : cy;
    var p = c.next;
    while(p !== a){
        if (p.x >= x0 && p.x <= x1 && p.y >= y0 && p.y <= y1 && $1b0c9f6ca9bef72e$var$pointInTriangle(ax, ay, bx, by, cx, cy, p.x, p.y) && $1b0c9f6ca9bef72e$var$area(p.prev, p, p.next) >= 0) return false;
        p = p.next;
    }
    return true;
}
function $1b0c9f6ca9bef72e$var$isEarHashed(ear, minX, minY, invSize) {
    var a = ear.prev, b = ear, c = ear.next;
    if ($1b0c9f6ca9bef72e$var$area(a, b, c) >= 0) return false; // reflex, can't be an ear
    var ax = a.x, bx = b.x, cx = c.x, ay = a.y, by = b.y, cy = c.y;
    // triangle bbox; min & max are calculated like this for speed
    var x0 = ax < bx ? ax < cx ? ax : cx : bx < cx ? bx : cx, y0 = ay < by ? ay < cy ? ay : cy : by < cy ? by : cy, x1 = ax > bx ? ax > cx ? ax : cx : bx > cx ? bx : cx, y1 = ay > by ? ay > cy ? ay : cy : by > cy ? by : cy;
    // z-order range for the current triangle bbox;
    var minZ = $1b0c9f6ca9bef72e$var$zOrder(x0, y0, minX, minY, invSize), maxZ = $1b0c9f6ca9bef72e$var$zOrder(x1, y1, minX, minY, invSize);
    var p = ear.prevZ, n = ear.nextZ;
    // look for points inside the triangle in both directions
    while(p && p.z >= minZ && n && n.z <= maxZ){
        if (p.x >= x0 && p.x <= x1 && p.y >= y0 && p.y <= y1 && p !== a && p !== c && $1b0c9f6ca9bef72e$var$pointInTriangle(ax, ay, bx, by, cx, cy, p.x, p.y) && $1b0c9f6ca9bef72e$var$area(p.prev, p, p.next) >= 0) return false;
        p = p.prevZ;
        if (n.x >= x0 && n.x <= x1 && n.y >= y0 && n.y <= y1 && n !== a && n !== c && $1b0c9f6ca9bef72e$var$pointInTriangle(ax, ay, bx, by, cx, cy, n.x, n.y) && $1b0c9f6ca9bef72e$var$area(n.prev, n, n.next) >= 0) return false;
        n = n.nextZ;
    }
    // look for remaining points in decreasing z-order
    while(p && p.z >= minZ){
        if (p.x >= x0 && p.x <= x1 && p.y >= y0 && p.y <= y1 && p !== a && p !== c && $1b0c9f6ca9bef72e$var$pointInTriangle(ax, ay, bx, by, cx, cy, p.x, p.y) && $1b0c9f6ca9bef72e$var$area(p.prev, p, p.next) >= 0) return false;
        p = p.prevZ;
    }
    // look for remaining points in increasing z-order
    while(n && n.z <= maxZ){
        if (n.x >= x0 && n.x <= x1 && n.y >= y0 && n.y <= y1 && n !== a && n !== c && $1b0c9f6ca9bef72e$var$pointInTriangle(ax, ay, bx, by, cx, cy, n.x, n.y) && $1b0c9f6ca9bef72e$var$area(n.prev, n, n.next) >= 0) return false;
        n = n.nextZ;
    }
    return true;
}
// go through all polygon nodes and cure small local self-intersections
function $1b0c9f6ca9bef72e$var$cureLocalIntersections(start, triangles, dim) {
    var p = start;
    do {
        var a = p.prev, b = p.next.next;
        if (!$1b0c9f6ca9bef72e$var$equals(a, b) && $1b0c9f6ca9bef72e$var$intersects(a, p, p.next, b) && $1b0c9f6ca9bef72e$var$locallyInside(a, b) && $1b0c9f6ca9bef72e$var$locallyInside(b, a)) {
            triangles.push(a.i / dim | 0);
            triangles.push(p.i / dim | 0);
            triangles.push(b.i / dim | 0);
            // remove two nodes involved
            $1b0c9f6ca9bef72e$var$removeNode(p);
            $1b0c9f6ca9bef72e$var$removeNode(p.next);
            p = start = b;
        }
        p = p.next;
    }while (p !== start);
    return $1b0c9f6ca9bef72e$var$filterPoints(p);
}
// try splitting polygon into two and triangulate them independently
function $1b0c9f6ca9bef72e$var$splitEarcut(start, triangles, dim, minX, minY, invSize) {
    // look for a valid diagonal that divides the polygon into two
    var a = start;
    do {
        var b = a.next.next;
        while(b !== a.prev){
            if (a.i !== b.i && $1b0c9f6ca9bef72e$var$isValidDiagonal(a, b)) {
                // split the polygon in two by the diagonal
                var c = $1b0c9f6ca9bef72e$var$splitPolygon(a, b);
                // filter colinear points around the cuts
                a = $1b0c9f6ca9bef72e$var$filterPoints(a, a.next);
                c = $1b0c9f6ca9bef72e$var$filterPoints(c, c.next);
                // run earcut on each half
                $1b0c9f6ca9bef72e$var$earcutLinked(a, triangles, dim, minX, minY, invSize, 0);
                $1b0c9f6ca9bef72e$var$earcutLinked(c, triangles, dim, minX, minY, invSize, 0);
                return;
            }
            b = b.next;
        }
        a = a.next;
    }while (a !== start);
}
// link every hole into the outer loop, producing a single-ring polygon without holes
function $1b0c9f6ca9bef72e$var$eliminateHoles(data, holeIndices, outerNode, dim) {
    var queue = [], i, len, start, end, list;
    for(i = 0, len = holeIndices.length; i < len; i++){
        start = holeIndices[i] * dim;
        end = i < len - 1 ? holeIndices[i + 1] * dim : data.length;
        list = $1b0c9f6ca9bef72e$var$linkedList(data, start, end, dim, false);
        if (list === list.next) list.steiner = true;
        queue.push($1b0c9f6ca9bef72e$var$getLeftmost(list));
    }
    queue.sort($1b0c9f6ca9bef72e$var$compareX);
    // process holes from left to right
    for(i = 0; i < queue.length; i++)outerNode = $1b0c9f6ca9bef72e$var$eliminateHole(queue[i], outerNode);
    return outerNode;
}
function $1b0c9f6ca9bef72e$var$compareX(a, b) {
    return a.x - b.x;
}
// find a bridge between vertices that connects hole with an outer ring and and link it
function $1b0c9f6ca9bef72e$var$eliminateHole(hole, outerNode) {
    var bridge = $1b0c9f6ca9bef72e$var$findHoleBridge(hole, outerNode);
    if (!bridge) return outerNode;
    var bridgeReverse = $1b0c9f6ca9bef72e$var$splitPolygon(bridge, hole);
    // filter collinear points around the cuts
    $1b0c9f6ca9bef72e$var$filterPoints(bridgeReverse, bridgeReverse.next);
    return $1b0c9f6ca9bef72e$var$filterPoints(bridge, bridge.next);
}
// David Eberly's algorithm for finding a bridge between hole and outer polygon
function $1b0c9f6ca9bef72e$var$findHoleBridge(hole, outerNode) {
    var p = outerNode, hx = hole.x, hy = hole.y, qx = -Infinity, m;
    // find a segment intersected by a ray from the hole's leftmost point to the left;
    // segment's endpoint with lesser x will be potential connection point
    do {
        if (hy <= p.y && hy >= p.next.y && p.next.y !== p.y) {
            var x = p.x + (hy - p.y) * (p.next.x - p.x) / (p.next.y - p.y);
            if (x <= hx && x > qx) {
                qx = x;
                m = p.x < p.next.x ? p : p.next;
                if (x === hx) return m; // hole touches outer segment; pick leftmost endpoint
            }
        }
        p = p.next;
    }while (p !== outerNode);
    if (!m) return null;
    // look for points inside the triangle of hole point, segment intersection and endpoint;
    // if there are no points found, we have a valid connection;
    // otherwise choose the point of the minimum angle with the ray as connection point
    var stop = m, mx = m.x, my = m.y, tanMin = Infinity, tan;
    p = m;
    do {
        if (hx >= p.x && p.x >= mx && hx !== p.x && $1b0c9f6ca9bef72e$var$pointInTriangle(hy < my ? hx : qx, hy, mx, my, hy < my ? qx : hx, hy, p.x, p.y)) {
            tan = Math.abs(hy - p.y) / (hx - p.x); // tangential
            if ($1b0c9f6ca9bef72e$var$locallyInside(p, hole) && (tan < tanMin || tan === tanMin && (p.x > m.x || p.x === m.x && $1b0c9f6ca9bef72e$var$sectorContainsSector(m, p)))) {
                m = p;
                tanMin = tan;
            }
        }
        p = p.next;
    }while (p !== stop);
    return m;
}
// whether sector in vertex m contains sector in vertex p in the same coordinates
function $1b0c9f6ca9bef72e$var$sectorContainsSector(m, p) {
    return $1b0c9f6ca9bef72e$var$area(m.prev, m, p.prev) < 0 && $1b0c9f6ca9bef72e$var$area(p.next, m, m.next) < 0;
}
// interlink polygon nodes in z-order
function $1b0c9f6ca9bef72e$var$indexCurve(start, minX, minY, invSize) {
    var p = start;
    do {
        if (p.z === 0) p.z = $1b0c9f6ca9bef72e$var$zOrder(p.x, p.y, minX, minY, invSize);
        p.prevZ = p.prev;
        p.nextZ = p.next;
        p = p.next;
    }while (p !== start);
    p.prevZ.nextZ = null;
    p.prevZ = null;
    $1b0c9f6ca9bef72e$var$sortLinked(p);
}
// Simon Tatham's linked list merge sort algorithm
// http://www.chiark.greenend.org.uk/~sgtatham/algorithms/listsort.html
function $1b0c9f6ca9bef72e$var$sortLinked(list) {
    var i, p, q, e, tail, numMerges, pSize, qSize, inSize = 1;
    do {
        p = list;
        list = null;
        tail = null;
        numMerges = 0;
        while(p){
            numMerges++;
            q = p;
            pSize = 0;
            for(i = 0; i < inSize; i++){
                pSize++;
                q = q.nextZ;
                if (!q) break;
            }
            qSize = inSize;
            while(pSize > 0 || qSize > 0 && q){
                if (pSize !== 0 && (qSize === 0 || !q || p.z <= q.z)) {
                    e = p;
                    p = p.nextZ;
                    pSize--;
                } else {
                    e = q;
                    q = q.nextZ;
                    qSize--;
                }
                if (tail) tail.nextZ = e;
                else list = e;
                e.prevZ = tail;
                tail = e;
            }
            p = q;
        }
        tail.nextZ = null;
        inSize *= 2;
    }while (numMerges > 1);
    return list;
}
// z-order of a point given coords and inverse of the longer side of data bbox
function $1b0c9f6ca9bef72e$var$zOrder(x, y, minX, minY, invSize) {
    // coords are transformed into non-negative 15-bit integer range
    x = (x - minX) * invSize | 0;
    y = (y - minY) * invSize | 0;
    x = (x | x << 8) & 0x00FF00FF;
    x = (x | x << 4) & 0x0F0F0F0F;
    x = (x | x << 2) & 0x33333333;
    x = (x | x << 1) & 0x55555555;
    y = (y | y << 8) & 0x00FF00FF;
    y = (y | y << 4) & 0x0F0F0F0F;
    y = (y | y << 2) & 0x33333333;
    y = (y | y << 1) & 0x55555555;
    return x | y << 1;
}
// find the leftmost node of a polygon ring
function $1b0c9f6ca9bef72e$var$getLeftmost(start) {
    var p = start, leftmost = start;
    do {
        if (p.x < leftmost.x || p.x === leftmost.x && p.y < leftmost.y) leftmost = p;
        p = p.next;
    }while (p !== start);
    return leftmost;
}
// check if a point lies within a convex triangle
function $1b0c9f6ca9bef72e$var$pointInTriangle(ax, ay, bx, by, cx, cy, px, py) {
    return (cx - px) * (ay - py) >= (ax - px) * (cy - py) && (ax - px) * (by - py) >= (bx - px) * (ay - py) && (bx - px) * (cy - py) >= (cx - px) * (by - py);
}
// check if a diagonal between two polygon nodes is valid (lies in polygon interior)
function $1b0c9f6ca9bef72e$var$isValidDiagonal(a, b) {
    return a.next.i !== b.i && a.prev.i !== b.i && !$1b0c9f6ca9bef72e$var$intersectsPolygon(a, b) && // dones't intersect other edges
    ($1b0c9f6ca9bef72e$var$locallyInside(a, b) && $1b0c9f6ca9bef72e$var$locallyInside(b, a) && $1b0c9f6ca9bef72e$var$middleInside(a, b) && // locally visible
    ($1b0c9f6ca9bef72e$var$area(a.prev, a, b.prev) || $1b0c9f6ca9bef72e$var$area(a, b.prev, b)) || // does not create opposite-facing sectors
    $1b0c9f6ca9bef72e$var$equals(a, b) && $1b0c9f6ca9bef72e$var$area(a.prev, a, a.next) > 0 && $1b0c9f6ca9bef72e$var$area(b.prev, b, b.next) > 0); // special zero-length case
}
// signed area of a triangle
function $1b0c9f6ca9bef72e$var$area(p, q, r) {
    return (q.y - p.y) * (r.x - q.x) - (q.x - p.x) * (r.y - q.y);
}
// check if two points are equal
function $1b0c9f6ca9bef72e$var$equals(p1, p2) {
    return p1.x === p2.x && p1.y === p2.y;
}
// check if two segments intersect
function $1b0c9f6ca9bef72e$var$intersects(p1, q1, p2, q2) {
    var o1 = $1b0c9f6ca9bef72e$var$sign($1b0c9f6ca9bef72e$var$area(p1, q1, p2));
    var o2 = $1b0c9f6ca9bef72e$var$sign($1b0c9f6ca9bef72e$var$area(p1, q1, q2));
    var o3 = $1b0c9f6ca9bef72e$var$sign($1b0c9f6ca9bef72e$var$area(p2, q2, p1));
    var o4 = $1b0c9f6ca9bef72e$var$sign($1b0c9f6ca9bef72e$var$area(p2, q2, q1));
    if (o1 !== o2 && o3 !== o4) return true; // general case
    if (o1 === 0 && $1b0c9f6ca9bef72e$var$onSegment(p1, p2, q1)) return true; // p1, q1 and p2 are collinear and p2 lies on p1q1
    if (o2 === 0 && $1b0c9f6ca9bef72e$var$onSegment(p1, q2, q1)) return true; // p1, q1 and q2 are collinear and q2 lies on p1q1
    if (o3 === 0 && $1b0c9f6ca9bef72e$var$onSegment(p2, p1, q2)) return true; // p2, q2 and p1 are collinear and p1 lies on p2q2
    if (o4 === 0 && $1b0c9f6ca9bef72e$var$onSegment(p2, q1, q2)) return true; // p2, q2 and q1 are collinear and q1 lies on p2q2
    return false;
}
// for collinear points p, q, r, check if point q lies on segment pr
function $1b0c9f6ca9bef72e$var$onSegment(p, q, r) {
    return q.x <= Math.max(p.x, r.x) && q.x >= Math.min(p.x, r.x) && q.y <= Math.max(p.y, r.y) && q.y >= Math.min(p.y, r.y);
}
function $1b0c9f6ca9bef72e$var$sign(num) {
    return num > 0 ? 1 : num < 0 ? -1 : 0;
}
// check if a polygon diagonal intersects any polygon segments
function $1b0c9f6ca9bef72e$var$intersectsPolygon(a, b) {
    var p = a;
    do {
        if (p.i !== a.i && p.next.i !== a.i && p.i !== b.i && p.next.i !== b.i && $1b0c9f6ca9bef72e$var$intersects(p, p.next, a, b)) return true;
        p = p.next;
    }while (p !== a);
    return false;
}
// check if a polygon diagonal is locally inside the polygon
function $1b0c9f6ca9bef72e$var$locallyInside(a, b) {
    return $1b0c9f6ca9bef72e$var$area(a.prev, a, a.next) < 0 ? $1b0c9f6ca9bef72e$var$area(a, b, a.next) >= 0 && $1b0c9f6ca9bef72e$var$area(a, a.prev, b) >= 0 : $1b0c9f6ca9bef72e$var$area(a, b, a.prev) < 0 || $1b0c9f6ca9bef72e$var$area(a, a.next, b) < 0;
}
// check if the middle point of a polygon diagonal is inside the polygon
function $1b0c9f6ca9bef72e$var$middleInside(a, b) {
    var p = a, inside = false, px = (a.x + b.x) / 2, py = (a.y + b.y) / 2;
    do {
        if (p.y > py !== p.next.y > py && p.next.y !== p.y && px < (p.next.x - p.x) * (py - p.y) / (p.next.y - p.y) + p.x) inside = !inside;
        p = p.next;
    }while (p !== a);
    return inside;
}
// link two polygon vertices with a bridge; if the vertices belong to the same ring, it splits polygon into two;
// if one belongs to the outer ring and another to a hole, it merges it into a single ring
function $1b0c9f6ca9bef72e$var$splitPolygon(a, b) {
    var a2 = new $1b0c9f6ca9bef72e$var$Node(a.i, a.x, a.y), b2 = new $1b0c9f6ca9bef72e$var$Node(b.i, b.x, b.y), an = a.next, bp = b.prev;
    a.next = b;
    b.prev = a;
    a2.next = an;
    an.prev = a2;
    b2.next = a2;
    a2.prev = b2;
    bp.next = b2;
    b2.prev = bp;
    return b2;
}
// create a node and optionally link it with previous one (in a circular doubly linked list)
function $1b0c9f6ca9bef72e$var$insertNode(i, x, y, last) {
    var p = new $1b0c9f6ca9bef72e$var$Node(i, x, y);
    if (!last) {
        p.prev = p;
        p.next = p;
    } else {
        p.next = last.next;
        p.prev = last;
        last.next.prev = p;
        last.next = p;
    }
    return p;
}
function $1b0c9f6ca9bef72e$var$removeNode(p) {
    p.next.prev = p.prev;
    p.prev.next = p.next;
    if (p.prevZ) p.prevZ.nextZ = p.nextZ;
    if (p.nextZ) p.nextZ.prevZ = p.prevZ;
}
function $1b0c9f6ca9bef72e$var$Node(i, x, y) {
    // vertex index in coordinates array
    this.i = i;
    // vertex coordinates
    this.x = x;
    this.y = y;
    // previous and next vertex nodes in a polygon ring
    this.prev = null;
    this.next = null;
    // z-order curve value
    this.z = 0;
    // previous and next nodes in z-order
    this.prevZ = null;
    this.nextZ = null;
    // indicates whether this is a steiner point
    this.steiner = false;
}
// return a percentage difference between the polygon area and its triangulation area;
// used to verify correctness of triangulation
$1b0c9f6ca9bef72e$var$earcut.deviation = function(data, holeIndices, dim, triangles) {
    var hasHoles = holeIndices && holeIndices.length;
    var outerLen = hasHoles ? holeIndices[0] * dim : data.length;
    var polygonArea = Math.abs($1b0c9f6ca9bef72e$var$signedArea(data, 0, outerLen, dim));
    if (hasHoles) for(var i = 0, len = holeIndices.length; i < len; i++){
        var start = holeIndices[i] * dim;
        var end = i < len - 1 ? holeIndices[i + 1] * dim : data.length;
        polygonArea -= Math.abs($1b0c9f6ca9bef72e$var$signedArea(data, start, end, dim));
    }
    var trianglesArea = 0;
    for(i = 0; i < triangles.length; i += 3){
        var a = triangles[i] * dim;
        var b = triangles[i + 1] * dim;
        var c = triangles[i + 2] * dim;
        trianglesArea += Math.abs((data[a] - data[c]) * (data[b + 1] - data[a + 1]) - (data[a] - data[b]) * (data[c + 1] - data[a + 1]));
    }
    return polygonArea === 0 && trianglesArea === 0 ? 0 : Math.abs((trianglesArea - polygonArea) / polygonArea);
};
function $1b0c9f6ca9bef72e$var$signedArea(data, start, end, dim) {
    var sum = 0;
    for(var i = start, j = end - dim; i < end; i += dim){
        sum += (data[j] - data[i]) * (data[i + 1] + data[j + 1]);
        j = i;
    }
    return sum;
}
// turn a polygon in a multi-dimensional array form (e.g. as in GeoJSON) into a form Earcut accepts
$1b0c9f6ca9bef72e$var$earcut.flatten = function(data) {
    var dim = data[0][0].length, result = {
        vertices: [],
        holes: [],
        dimensions: dim
    }, holeIndex = 0;
    for(var i = 0; i < data.length; i++){
        for(var j = 0; j < data[i].length; j++)for(var d = 0; d < dim; d++)result.vertices.push(data[i][j][d]);
        if (i > 0) {
            holeIndex += data[i - 1].length;
            result.holes.push(holeIndex);
        }
    }
    return result;
};

});



parcelRegister("7DIxn", function(module, exports) {

$parcel$export(module.exports, "buildRectangle", () => $1d4b4832ec6feb5d$export$cbe813d11f2192b2);

var $i9BKe = parcelRequire("i9BKe");
"use strict";
const $1d4b4832ec6feb5d$export$cbe813d11f2192b2 = {
    extension: {
        type: (0, $i9BKe.ExtensionType).ShapeBuilder,
        name: "rectangle"
    },
    build (shape, points) {
        const rectData = shape;
        const x = rectData.x;
        const y = rectData.y;
        const width = rectData.width;
        const height = rectData.height;
        if (!(width >= 0 && height >= 0)) return points;
        points[0] = x;
        points[1] = y;
        points[2] = x + width;
        points[3] = y;
        points[4] = x + width;
        points[5] = y + height;
        points[6] = x;
        points[7] = y + height;
        return points;
    },
    triangulate (points, vertices, verticesStride, verticesOffset, indices, indicesOffset) {
        let count = 0;
        verticesOffset *= verticesStride;
        vertices[verticesOffset + count] = points[0];
        vertices[verticesOffset + count + 1] = points[1];
        count += verticesStride;
        vertices[verticesOffset + count] = points[2];
        vertices[verticesOffset + count + 1] = points[3];
        count += verticesStride;
        vertices[verticesOffset + count] = points[6];
        vertices[verticesOffset + count + 1] = points[7];
        count += verticesStride;
        vertices[verticesOffset + count] = points[4];
        vertices[verticesOffset + count + 1] = points[5];
        count += verticesStride;
        const verticesIndex = verticesOffset / verticesStride;
        indices[indicesOffset++] = verticesIndex;
        indices[indicesOffset++] = verticesIndex + 1;
        indices[indicesOffset++] = verticesIndex + 2;
        indices[indicesOffset++] = verticesIndex + 1;
        indices[indicesOffset++] = verticesIndex + 3;
        indices[indicesOffset++] = verticesIndex + 2;
    }
};

});

parcelRegister("iAUCq", function(module, exports) {

$parcel$export(module.exports, "buildTriangle", () => $14f13b7de979604e$export$8eb75cb9f614d270);

var $i9BKe = parcelRequire("i9BKe");
"use strict";
const $14f13b7de979604e$export$8eb75cb9f614d270 = {
    extension: {
        type: (0, $i9BKe.ExtensionType).ShapeBuilder,
        name: "triangle"
    },
    build (shape, points) {
        points[0] = shape.x;
        points[1] = shape.y;
        points[2] = shape.x2;
        points[3] = shape.y2;
        points[4] = shape.x3;
        points[5] = shape.y3;
        return points;
    },
    triangulate (points, vertices, verticesStride, verticesOffset, indices, indicesOffset) {
        let count = 0;
        verticesOffset *= verticesStride;
        vertices[verticesOffset + count] = points[0];
        vertices[verticesOffset + count + 1] = points[1];
        count += verticesStride;
        vertices[verticesOffset + count] = points[2];
        vertices[verticesOffset + count + 1] = points[3];
        count += verticesStride;
        vertices[verticesOffset + count] = points[4];
        vertices[verticesOffset + count + 1] = points[5];
        const verticesIndex = verticesOffset / verticesStride;
        indices[indicesOffset++] = verticesIndex;
        indices[indicesOffset++] = verticesIndex + 1;
        indices[indicesOffset++] = verticesIndex + 2;
    }
};

});




parcelRegister("eRV6E", function(module, exports) {

$parcel$export(module.exports, "buildAdaptiveQuadratic", () => $39a9db3afcc2f789$export$d53ce9debfe7a6c2);

var $hFzkv = parcelRequire("hFzkv");
"use strict";
const $39a9db3afcc2f789$var$RECURSION_LIMIT = 8;
const $39a9db3afcc2f789$var$FLT_EPSILON = 11920929e-14;
const $39a9db3afcc2f789$var$PATH_DISTANCE_EPSILON = 1;
const $39a9db3afcc2f789$var$curveAngleToleranceEpsilon = 0.01;
const $39a9db3afcc2f789$var$mAngleTolerance = 0;
function $39a9db3afcc2f789$export$d53ce9debfe7a6c2(points, sX, sY, cp1x, cp1y, eX, eY, smoothness) {
    const scale = 1;
    const smoothing = Math.min(0.99, // a value of 1.0 actually inverts smoothing, so we cap it at 0.99
    Math.max(0, smoothness ?? (0, $hFzkv.GraphicsContextSystem).defaultOptions.bezierSmoothness));
    let distanceTolerance = ($39a9db3afcc2f789$var$PATH_DISTANCE_EPSILON - smoothing) / scale;
    distanceTolerance *= distanceTolerance;
    $39a9db3afcc2f789$var$begin(sX, sY, cp1x, cp1y, eX, eY, points, distanceTolerance);
    return points;
}
function $39a9db3afcc2f789$var$begin(sX, sY, cp1x, cp1y, eX, eY, points, distanceTolerance) {
    $39a9db3afcc2f789$var$recursive(points, sX, sY, cp1x, cp1y, eX, eY, distanceTolerance, 0);
    points.push(eX, eY);
}
function $39a9db3afcc2f789$var$recursive(points, x1, y1, x2, y2, x3, y3, distanceTolerance, level) {
    if (level > $39a9db3afcc2f789$var$RECURSION_LIMIT) return;
    const pi = Math.PI;
    const x12 = (x1 + x2) / 2;
    const y12 = (y1 + y2) / 2;
    const x23 = (x2 + x3) / 2;
    const y23 = (y2 + y3) / 2;
    const x123 = (x12 + x23) / 2;
    const y123 = (y12 + y23) / 2;
    let dx = x3 - x1;
    let dy = y3 - y1;
    const d = Math.abs((x2 - x3) * dy - (y2 - y3) * dx);
    if (d > $39a9db3afcc2f789$var$FLT_EPSILON) {
        if (d * d <= distanceTolerance * (dx * dx + dy * dy)) {
            if ($39a9db3afcc2f789$var$mAngleTolerance < $39a9db3afcc2f789$var$curveAngleToleranceEpsilon) {
                points.push(x123, y123);
                return;
            }
            let da = Math.abs(Math.atan2(y3 - y2, x3 - x2) - Math.atan2(y2 - y1, x2 - x1));
            if (da >= pi) da = 2 * pi - da;
            if (da < $39a9db3afcc2f789$var$mAngleTolerance) {
                points.push(x123, y123);
                return;
            }
        }
    } else {
        dx = x123 - (x1 + x3) / 2;
        dy = y123 - (y1 + y3) / 2;
        if (dx * dx + dy * dy <= distanceTolerance) {
            points.push(x123, y123);
            return;
        }
    }
    $39a9db3afcc2f789$var$recursive(points, x1, y1, x12, y12, x123, y123, distanceTolerance, level + 1);
    $39a9db3afcc2f789$var$recursive(points, x123, y123, x23, y23, x3, y3, distanceTolerance, level + 1);
}

});

parcelRegister("aiLPr", function(module, exports) {

$parcel$export(module.exports, "buildArc", () => $4598c98f5bbae757$export$ed8eebdc6998f0f6);
"use strict";
function $4598c98f5bbae757$export$ed8eebdc6998f0f6(points, x, y, radius, start, end, clockwise, steps) {
    let dist = Math.abs(start - end);
    if (!clockwise && start > end) dist = 2 * Math.PI - dist;
    else if (clockwise && end > start) dist = 2 * Math.PI - dist;
    steps = steps || Math.max(6, Math.floor(6 * Math.pow(radius, 1 / 3) * (dist / Math.PI)));
    steps = Math.max(steps, 3);
    let f = dist / steps;
    let t = start;
    f *= clockwise ? -1 : 1;
    for(let i = 0; i < steps + 1; i++){
        const cs = Math.cos(t);
        const sn = Math.sin(t);
        const nx = x + cs * radius;
        const ny = y + sn * radius;
        points.push(nx, ny);
        t += f;
    }
}

});

parcelRegister("boMdH", function(module, exports) {

$parcel$export(module.exports, "buildArcTo", () => $35a2eb588826e37c$export$d46b7933b415e02f);

var $aiLPr = parcelRequire("aiLPr");
"use strict";
function $35a2eb588826e37c$export$d46b7933b415e02f(points, x1, y1, x2, y2, radius) {
    const fromX = points[points.length - 2];
    const fromY = points[points.length - 1];
    const a1 = fromY - y1;
    const b1 = fromX - x1;
    const a2 = y2 - y1;
    const b2 = x2 - x1;
    const mm = Math.abs(a1 * b2 - b1 * a2);
    if (mm < 1e-8 || radius === 0) {
        if (points[points.length - 2] !== x1 || points[points.length - 1] !== y1) points.push(x1, y1);
        return;
    }
    const dd = a1 * a1 + b1 * b1;
    const cc = a2 * a2 + b2 * b2;
    const tt = a1 * a2 + b1 * b2;
    const k1 = radius * Math.sqrt(dd) / mm;
    const k2 = radius * Math.sqrt(cc) / mm;
    const j1 = k1 * tt / dd;
    const j2 = k2 * tt / cc;
    const cx = k1 * b2 + k2 * b1;
    const cy = k1 * a2 + k2 * a1;
    const px = b1 * (k2 + j1);
    const py = a1 * (k2 + j1);
    const qx = b2 * (k1 + j2);
    const qy = a2 * (k1 + j2);
    const startAngle = Math.atan2(py - cy, px - cx);
    const endAngle = Math.atan2(qy - cy, qx - cx);
    (0, $aiLPr.buildArc)(points, cx + x1, cy + y1, radius, startAngle, endAngle, b1 * a2 > b2 * a1);
}

});

parcelRegister("jjbCG", function(module, exports) {

$parcel$export(module.exports, "buildArcToSvg", () => $d859b1787749b4c9$export$71ccaa6dca53075e);

var $lI2iN = parcelRequire("lI2iN");
"use strict";
const $d859b1787749b4c9$var$TAU = Math.PI * 2;
const $d859b1787749b4c9$var$out = {
    centerX: 0,
    centerY: 0,
    ang1: 0,
    ang2: 0
};
const $d859b1787749b4c9$var$mapToEllipse = ({ x: x, y: y }, rx, ry, cosPhi, sinPhi, centerX, centerY, out2)=>{
    x *= rx;
    y *= ry;
    const xp = cosPhi * x - sinPhi * y;
    const yp = sinPhi * x + cosPhi * y;
    out2.x = xp + centerX;
    out2.y = yp + centerY;
    return out2;
};
function $d859b1787749b4c9$var$approxUnitArc(ang1, ang2) {
    const a1 = ang2 === -1.5707963267948966 ? -0.551915024494 : 4 / 3 * Math.tan(ang2 / 4);
    const a = ang2 === 1.5707963267948966 ? 0.551915024494 : a1;
    const x1 = Math.cos(ang1);
    const y1 = Math.sin(ang1);
    const x2 = Math.cos(ang1 + ang2);
    const y2 = Math.sin(ang1 + ang2);
    return [
        {
            x: x1 - y1 * a,
            y: y1 + x1 * a
        },
        {
            x: x2 + y2 * a,
            y: y2 - x2 * a
        },
        {
            x: x2,
            y: y2
        }
    ];
}
const $d859b1787749b4c9$var$vectorAngle = (ux, uy, vx, vy)=>{
    const sign = ux * vy - uy * vx < 0 ? -1 : 1;
    let dot = ux * vx + uy * vy;
    if (dot > 1) dot = 1;
    if (dot < -1) dot = -1;
    return sign * Math.acos(dot);
};
const $d859b1787749b4c9$var$getArcCenter = (px, py, cx, cy, rx, ry, largeArcFlag, sweepFlag, sinPhi, cosPhi, pxp, pyp, out2)=>{
    const rxSq = Math.pow(rx, 2);
    const rySq = Math.pow(ry, 2);
    const pxpSq = Math.pow(pxp, 2);
    const pypSq = Math.pow(pyp, 2);
    let radicant = rxSq * rySq - rxSq * pypSq - rySq * pxpSq;
    if (radicant < 0) radicant = 0;
    radicant /= rxSq * pypSq + rySq * pxpSq;
    radicant = Math.sqrt(radicant) * (largeArcFlag === sweepFlag ? -1 : 1);
    const centerXp = radicant * rx / ry * pyp;
    const centerYp = radicant * -ry / rx * pxp;
    const centerX = cosPhi * centerXp - sinPhi * centerYp + (px + cx) / 2;
    const centerY = sinPhi * centerXp + cosPhi * centerYp + (py + cy) / 2;
    const vx1 = (pxp - centerXp) / rx;
    const vy1 = (pyp - centerYp) / ry;
    const vx2 = (-pxp - centerXp) / rx;
    const vy2 = (-pyp - centerYp) / ry;
    const ang1 = $d859b1787749b4c9$var$vectorAngle(1, 0, vx1, vy1);
    let ang2 = $d859b1787749b4c9$var$vectorAngle(vx1, vy1, vx2, vy2);
    if (sweepFlag === 0 && ang2 > 0) ang2 -= $d859b1787749b4c9$var$TAU;
    if (sweepFlag === 1 && ang2 < 0) ang2 += $d859b1787749b4c9$var$TAU;
    out2.centerX = centerX;
    out2.centerY = centerY;
    out2.ang1 = ang1;
    out2.ang2 = ang2;
};
function $d859b1787749b4c9$export$71ccaa6dca53075e(points, px, py, cx, cy, rx, ry, xAxisRotation = 0, largeArcFlag = 0, sweepFlag = 0) {
    if (rx === 0 || ry === 0) return;
    const sinPhi = Math.sin(xAxisRotation * $d859b1787749b4c9$var$TAU / 360);
    const cosPhi = Math.cos(xAxisRotation * $d859b1787749b4c9$var$TAU / 360);
    const pxp = cosPhi * (px - cx) / 2 + sinPhi * (py - cy) / 2;
    const pyp = -sinPhi * (px - cx) / 2 + cosPhi * (py - cy) / 2;
    if (pxp === 0 && pyp === 0) return;
    rx = Math.abs(rx);
    ry = Math.abs(ry);
    const lambda = Math.pow(pxp, 2) / Math.pow(rx, 2) + Math.pow(pyp, 2) / Math.pow(ry, 2);
    if (lambda > 1) {
        rx *= Math.sqrt(lambda);
        ry *= Math.sqrt(lambda);
    }
    $d859b1787749b4c9$var$getArcCenter(px, py, cx, cy, rx, ry, largeArcFlag, sweepFlag, sinPhi, cosPhi, pxp, pyp, $d859b1787749b4c9$var$out);
    let { ang1: ang1, ang2: ang2 } = $d859b1787749b4c9$var$out;
    const { centerX: centerX, centerY: centerY } = $d859b1787749b4c9$var$out;
    let ratio = Math.abs(ang2) / ($d859b1787749b4c9$var$TAU / 4);
    if (Math.abs(1 - ratio) < 1e-7) ratio = 1;
    const segments = Math.max(Math.ceil(ratio), 1);
    ang2 /= segments;
    let lastX = points[points.length - 2];
    let lastY = points[points.length - 1];
    const outCurvePoint = {
        x: 0,
        y: 0
    };
    for(let i = 0; i < segments; i++){
        const curve = $d859b1787749b4c9$var$approxUnitArc(ang1, ang2);
        const { x: x1, y: y1 } = $d859b1787749b4c9$var$mapToEllipse(curve[0], rx, ry, cosPhi, sinPhi, centerX, centerY, outCurvePoint);
        const { x: x2, y: y2 } = $d859b1787749b4c9$var$mapToEllipse(curve[1], rx, ry, cosPhi, sinPhi, centerX, centerY, outCurvePoint);
        const { x: x, y: y } = $d859b1787749b4c9$var$mapToEllipse(curve[2], rx, ry, cosPhi, sinPhi, centerX, centerY, outCurvePoint);
        (0, $lI2iN.buildAdaptiveBezier)(points, lastX, lastY, x1, y1, x2, y2, x, y);
        lastX = x;
        lastY = y;
        ang1 += ang2;
    }
}

});

parcelRegister("9ad7k", function(module, exports) {

$parcel$export(module.exports, "roundedShapeArc", () => $9769dc3699a7c802$export$ae1f43bc280f09be);
$parcel$export(module.exports, "roundedShapeQuadraticCurve", () => $9769dc3699a7c802$export$cf503f371c53af9e);
"use strict";
function $9769dc3699a7c802$export$ae1f43bc280f09be(g, points, radius) {
    const vecFrom = (p, pp)=>{
        const x = pp.x - p.x;
        const y = pp.y - p.y;
        const len = Math.sqrt(x * x + y * y);
        const nx = x / len;
        const ny = y / len;
        return {
            len: len,
            nx: nx,
            ny: ny
        };
    };
    const sharpCorner = (i, p)=>{
        if (i === 0) g.moveTo(p.x, p.y);
        else g.lineTo(p.x, p.y);
    };
    let p1 = points[points.length - 1];
    for(let i = 0; i < points.length; i++){
        const p2 = points[i % points.length];
        const pRadius = p2.radius ?? radius;
        if (pRadius <= 0) {
            sharpCorner(i, p2);
            p1 = p2;
            continue;
        }
        const p3 = points[(i + 1) % points.length];
        const v1 = vecFrom(p2, p1);
        const v2 = vecFrom(p2, p3);
        if (v1.len < 1e-4 || v2.len < 1e-4) {
            sharpCorner(i, p2);
            p1 = p2;
            continue;
        }
        let angle = Math.asin(v1.nx * v2.ny - v1.ny * v2.nx);
        let radDirection = 1;
        let drawDirection = false;
        if (v1.nx * v2.nx - v1.ny * -v2.ny < 0) {
            if (angle < 0) angle = Math.PI + angle;
            else {
                angle = Math.PI - angle;
                radDirection = -1;
                drawDirection = true;
            }
        } else if (angle > 0) {
            radDirection = -1;
            drawDirection = true;
        }
        const halfAngle = angle / 2;
        let cRadius;
        let lenOut = Math.abs(Math.cos(halfAngle) * pRadius / Math.sin(halfAngle));
        if (lenOut > Math.min(v1.len / 2, v2.len / 2)) {
            lenOut = Math.min(v1.len / 2, v2.len / 2);
            cRadius = Math.abs(lenOut * Math.sin(halfAngle) / Math.cos(halfAngle));
        } else cRadius = pRadius;
        const cX = p2.x + v2.nx * lenOut + -v2.ny * cRadius * radDirection;
        const cY = p2.y + v2.ny * lenOut + v2.nx * cRadius * radDirection;
        const startAngle = Math.atan2(v1.ny, v1.nx) + Math.PI / 2 * radDirection;
        const endAngle = Math.atan2(v2.ny, v2.nx) - Math.PI / 2 * radDirection;
        if (i === 0) g.moveTo(cX + Math.cos(startAngle) * cRadius, cY + Math.sin(startAngle) * cRadius);
        g.arc(cX, cY, cRadius, startAngle, endAngle, drawDirection);
        p1 = p2;
    }
}
function $9769dc3699a7c802$export$cf503f371c53af9e(g, points, radius, smoothness) {
    const distance = (p1, p2)=>Math.sqrt((p1.x - p2.x) ** 2 + (p1.y - p2.y) ** 2);
    const pointLerp = (p1, p2, t)=>({
            x: p1.x + (p2.x - p1.x) * t,
            y: p1.y + (p2.y - p1.y) * t
        });
    const numPoints = points.length;
    for(let i = 0; i < numPoints; i++){
        const thisPoint = points[(i + 1) % numPoints];
        const pRadius = thisPoint.radius ?? radius;
        if (pRadius <= 0) {
            if (i === 0) g.moveTo(thisPoint.x, thisPoint.y);
            else g.lineTo(thisPoint.x, thisPoint.y);
            continue;
        }
        const lastPoint = points[i];
        const nextPoint = points[(i + 2) % numPoints];
        const lastEdgeLength = distance(lastPoint, thisPoint);
        let start;
        if (lastEdgeLength < 1e-4) start = thisPoint;
        else {
            const lastOffsetDistance = Math.min(lastEdgeLength / 2, pRadius);
            start = pointLerp(thisPoint, lastPoint, lastOffsetDistance / lastEdgeLength);
        }
        const nextEdgeLength = distance(nextPoint, thisPoint);
        let end;
        if (nextEdgeLength < 1e-4) end = thisPoint;
        else {
            const nextOffsetDistance = Math.min(nextEdgeLength / 2, pRadius);
            end = pointLerp(thisPoint, nextPoint, nextOffsetDistance / nextEdgeLength);
        }
        if (i === 0) g.moveTo(start.x, start.y);
        else g.lineTo(start.x, start.y);
        g.quadraticCurveTo(thisPoint.x, thisPoint.y, end.x, end.y, smoothness);
    }
}

});



parcelRegister("6ph3G", function(module, exports) {

$parcel$export(module.exports, "SVGParser", () => $ff733ce48c045e93$export$2cc2aaca18109aab);

var $a2eTA = parcelRequire("a2eTA");

var $c9xxq = parcelRequire("c9xxq");
"use strict";
function $ff733ce48c045e93$export$2cc2aaca18109aab(svg, graphicsContext) {
    if (typeof svg === "string") {
        const div = document.createElement("div");
        div.innerHTML = svg.trim();
        svg = div.querySelector("svg");
    }
    const session = {
        context: graphicsContext,
        path: new (0, $c9xxq.GraphicsPath)()
    };
    $ff733ce48c045e93$var$renderChildren(svg, session, null, null);
    return graphicsContext;
}
function $ff733ce48c045e93$var$renderChildren(svg, session, fillStyle, strokeStyle) {
    const children = svg.children;
    const { fillStyle: f1, strokeStyle: s1 } = $ff733ce48c045e93$var$parseStyle(svg);
    if (f1 && fillStyle) fillStyle = {
        ...fillStyle,
        ...f1
    };
    else if (f1) fillStyle = f1;
    if (s1 && strokeStyle) strokeStyle = {
        ...strokeStyle,
        ...s1
    };
    else if (s1) strokeStyle = s1;
    session.context.fillStyle = fillStyle;
    session.context.strokeStyle = strokeStyle;
    let x;
    let y;
    let x1;
    let y1;
    let x2;
    let y2;
    let cx;
    let cy;
    let r;
    let rx;
    let ry;
    let points;
    let pointsString;
    let d;
    let graphicsPath;
    let width;
    let height;
    switch(svg.nodeName.toLowerCase()){
        case "path":
            d = svg.getAttribute("d");
            graphicsPath = new (0, $c9xxq.GraphicsPath)(d);
            session.context.path(graphicsPath);
            if (fillStyle) session.context.fill();
            if (strokeStyle) session.context.stroke();
            break;
        case "circle":
            cx = $ff733ce48c045e93$var$parseFloatAttribute(svg, "cx", 0);
            cy = $ff733ce48c045e93$var$parseFloatAttribute(svg, "cy", 0);
            r = $ff733ce48c045e93$var$parseFloatAttribute(svg, "r", 0);
            session.context.ellipse(cx, cy, r, r);
            if (fillStyle) session.context.fill();
            if (strokeStyle) session.context.stroke();
            break;
        case "rect":
            x = $ff733ce48c045e93$var$parseFloatAttribute(svg, "x", 0);
            y = $ff733ce48c045e93$var$parseFloatAttribute(svg, "y", 0);
            width = $ff733ce48c045e93$var$parseFloatAttribute(svg, "width", 0);
            height = $ff733ce48c045e93$var$parseFloatAttribute(svg, "height", 0);
            rx = $ff733ce48c045e93$var$parseFloatAttribute(svg, "rx", 0);
            ry = $ff733ce48c045e93$var$parseFloatAttribute(svg, "ry", 0);
            if (rx || ry) session.context.roundRect(x, y, width, height, rx || ry);
            else session.context.rect(x, y, width, height);
            if (fillStyle) session.context.fill();
            if (strokeStyle) session.context.stroke();
            break;
        case "ellipse":
            cx = $ff733ce48c045e93$var$parseFloatAttribute(svg, "cx", 0);
            cy = $ff733ce48c045e93$var$parseFloatAttribute(svg, "cy", 0);
            rx = $ff733ce48c045e93$var$parseFloatAttribute(svg, "rx", 0);
            ry = $ff733ce48c045e93$var$parseFloatAttribute(svg, "ry", 0);
            session.context.beginPath();
            session.context.ellipse(cx, cy, rx, ry);
            if (fillStyle) session.context.fill();
            if (strokeStyle) session.context.stroke();
            break;
        case "line":
            x1 = $ff733ce48c045e93$var$parseFloatAttribute(svg, "x1", 0);
            y1 = $ff733ce48c045e93$var$parseFloatAttribute(svg, "y1", 0);
            x2 = $ff733ce48c045e93$var$parseFloatAttribute(svg, "x2", 0);
            y2 = $ff733ce48c045e93$var$parseFloatAttribute(svg, "y2", 0);
            session.context.beginPath();
            session.context.moveTo(x1, y1);
            session.context.lineTo(x2, y2);
            if (strokeStyle) session.context.stroke();
            break;
        case "polygon":
            pointsString = svg.getAttribute("points");
            points = pointsString.match(/\d+/g).map((n)=>parseInt(n, 10));
            session.context.poly(points, true);
            if (fillStyle) session.context.fill();
            if (strokeStyle) session.context.stroke();
            break;
        case "polyline":
            pointsString = svg.getAttribute("points");
            points = pointsString.match(/\d+/g).map((n)=>parseInt(n, 10));
            session.context.poly(points, false);
            if (strokeStyle) session.context.stroke();
            break;
        case "g":
        case "svg":
            break;
        default:
            console.info(`[SVG parser] <${svg.nodeName}> elements unsupported`);
            break;
    }
    for(let i = 0; i < children.length; i++)$ff733ce48c045e93$var$renderChildren(children[i], session, fillStyle, strokeStyle);
}
function $ff733ce48c045e93$var$parseFloatAttribute(svg, id, defaultValue) {
    const value = svg.getAttribute(id);
    return value ? Number(value) : defaultValue;
}
function $ff733ce48c045e93$var$parseStyle(svg) {
    const style = svg.getAttribute("style");
    const strokeStyle = {};
    const fillStyle = {};
    let useFill = false;
    let useStroke = false;
    if (style) {
        const styleParts = style.split(";");
        for(let i = 0; i < styleParts.length; i++){
            const stylePart = styleParts[i];
            const [key, value] = stylePart.split(":");
            switch(key){
                case "stroke":
                    if (value !== "none") {
                        strokeStyle.color = (0, $a2eTA.Color).shared.setValue(value).toNumber();
                        useStroke = true;
                    }
                    break;
                case "stroke-width":
                    strokeStyle.width = Number(value);
                    break;
                case "fill":
                    if (value !== "none") {
                        useFill = true;
                        fillStyle.color = (0, $a2eTA.Color).shared.setValue(value).toNumber();
                    }
                    break;
                case "fill-opacity":
                    fillStyle.alpha = Number(value);
                    break;
                case "stroke-opacity":
                    strokeStyle.alpha = Number(value);
                    break;
                case "opacity":
                    fillStyle.alpha = Number(value);
                    strokeStyle.alpha = Number(value);
                    break;
            }
        }
    } else {
        const stroke = svg.getAttribute("stroke");
        if (stroke && stroke !== "none") {
            useStroke = true;
            strokeStyle.color = (0, $a2eTA.Color).shared.setValue(stroke).toNumber();
            strokeStyle.width = $ff733ce48c045e93$var$parseFloatAttribute(svg, "stroke-width", 1);
        }
        const fill = svg.getAttribute("fill");
        if (fill && fill !== "none") {
            useFill = true;
            fillStyle.color = (0, $a2eTA.Color).shared.setValue(fill).toNumber();
        }
    }
    return {
        strokeStyle: useStroke ? strokeStyle : null,
        fillStyle: useFill ? fillStyle : null
    };
}

});

parcelRegister("6mQKv", function(module, exports) {

$parcel$export(module.exports, "toFillStyle", () => $ee0f76cca9221b48$export$b254764c5530994a);
$parcel$export(module.exports, "toStrokeStyle", () => $ee0f76cca9221b48$export$64975ed44b74a62b);

var $a2eTA = parcelRequire("a2eTA");

var $eY4rt = parcelRequire("eY4rt");

var $bLlTJ = parcelRequire("bLlTJ");

var $gwwtL = parcelRequire("gwwtL");

var $ktCpi = parcelRequire("ktCpi");
"use strict";
function $ee0f76cca9221b48$var$isColorLike(value) {
    return (0, $a2eTA.Color).isColorLike(value);
}
function $ee0f76cca9221b48$var$isFillPattern(value) {
    return value instanceof (0, $ktCpi.FillPattern);
}
function $ee0f76cca9221b48$var$isFillGradient(value) {
    return value instanceof (0, $gwwtL.FillGradient);
}
function $ee0f76cca9221b48$var$handleColorLike(fill, value, defaultStyle) {
    const temp = (0, $a2eTA.Color).shared.setValue(value ?? 0);
    fill.color = temp.toNumber();
    fill.alpha = temp.alpha === 1 ? defaultStyle.alpha : temp.alpha;
    fill.texture = (0, $bLlTJ.Texture).WHITE;
    return {
        ...defaultStyle,
        ...fill
    };
}
function $ee0f76cca9221b48$var$handleFillPattern(fill, value, defaultStyle) {
    fill.fill = value;
    fill.color = 16777215;
    fill.texture = value.texture;
    fill.matrix = value.transform;
    return {
        ...defaultStyle,
        ...fill
    };
}
function $ee0f76cca9221b48$var$handleFillGradient(fill, value, defaultStyle) {
    value.buildLinearGradient();
    fill.fill = value;
    fill.color = 16777215;
    fill.texture = value.texture;
    fill.matrix = value.transform;
    return {
        ...defaultStyle,
        ...fill
    };
}
function $ee0f76cca9221b48$var$handleFillObject(value, defaultStyle) {
    const style = {
        ...defaultStyle,
        ...value
    };
    if (style.texture) {
        if (style.texture !== (0, $bLlTJ.Texture).WHITE) {
            const m = style.matrix?.invert() || new (0, $eY4rt.Matrix)();
            m.translate(style.texture.frame.x, style.texture.frame.y);
            m.scale(1 / style.texture.source.width, 1 / style.texture.source.height);
            style.matrix = m;
        }
        const sourceStyle = style.texture.source.style;
        if (sourceStyle.addressMode === "clamp-to-edge") {
            sourceStyle.addressMode = "repeat";
            sourceStyle.update();
        }
    }
    const color = (0, $a2eTA.Color).shared.setValue(style.color);
    style.alpha *= color.alpha;
    style.color = color.toNumber();
    style.matrix = style.matrix ? style.matrix.clone() : null;
    return style;
}
function $ee0f76cca9221b48$export$b254764c5530994a(value, defaultStyle) {
    if (value === void 0 || value === null) return null;
    const fill = {};
    const objectStyle = value;
    if ($ee0f76cca9221b48$var$isColorLike(value)) return $ee0f76cca9221b48$var$handleColorLike(fill, value, defaultStyle);
    else if ($ee0f76cca9221b48$var$isFillPattern(value)) return $ee0f76cca9221b48$var$handleFillPattern(fill, value, defaultStyle);
    else if ($ee0f76cca9221b48$var$isFillGradient(value)) return $ee0f76cca9221b48$var$handleFillGradient(fill, value, defaultStyle);
    else if (objectStyle.fill && $ee0f76cca9221b48$var$isFillPattern(objectStyle.fill)) return $ee0f76cca9221b48$var$handleFillPattern(objectStyle, objectStyle.fill, defaultStyle);
    else if (objectStyle.fill && $ee0f76cca9221b48$var$isFillGradient(objectStyle.fill)) return $ee0f76cca9221b48$var$handleFillGradient(objectStyle, objectStyle.fill, defaultStyle);
    return $ee0f76cca9221b48$var$handleFillObject(objectStyle, defaultStyle);
}
function $ee0f76cca9221b48$export$64975ed44b74a62b(value, defaultStyle) {
    const { width: width, alignment: alignment, miterLimit: miterLimit, cap: cap, join: join, ...rest } = defaultStyle;
    const fill = $ee0f76cca9221b48$export$b254764c5530994a(value, rest);
    if (!fill) return null;
    return {
        width: width,
        alignment: alignment,
        miterLimit: miterLimit,
        cap: cap,
        join: join,
        ...fill
    };
}

});


parcelRegister("6XitK", function(module, exports) {

$parcel$export(module.exports, "generateTextStyleKey", () => $9b4def45185a5f6c$export$8a3681e2b47964bb);

var $a2eTA = parcelRequire("a2eTA");
"use strict";
const $9b4def45185a5f6c$var$valuesToIterateForKeys = [
    "align",
    "breakWords",
    "cssOverrides",
    "fontVariant",
    "fontWeight",
    "leading",
    "letterSpacing",
    "lineHeight",
    "padding",
    "textBaseline",
    "trim",
    "whiteSpace",
    "wordWrap",
    "wordWrapWidth",
    "fontFamily",
    "fontStyle",
    "fontSize"
];
function $9b4def45185a5f6c$export$8a3681e2b47964bb(style) {
    const key = [];
    let index = 0;
    for(let i = 0; i < $9b4def45185a5f6c$var$valuesToIterateForKeys.length; i++){
        const prop = `_${$9b4def45185a5f6c$var$valuesToIterateForKeys[i]}`;
        key[index++] = style[prop];
    }
    index = $9b4def45185a5f6c$var$addFillStyleKey(style._fill, key, index);
    index = $9b4def45185a5f6c$var$addStokeStyleKey(style._stroke, key, index);
    index = $9b4def45185a5f6c$var$addDropShadowKey(style.dropShadow, key, index);
    return key.join("-");
}
function $9b4def45185a5f6c$var$addFillStyleKey(fillStyle, key, index) {
    if (!fillStyle) return index;
    key[index++] = fillStyle.color;
    key[index++] = fillStyle.alpha;
    key[index++] = fillStyle.fill?.styleKey;
    return index;
}
function $9b4def45185a5f6c$var$addStokeStyleKey(strokeStyle, key, index) {
    if (!strokeStyle) return index;
    index = $9b4def45185a5f6c$var$addFillStyleKey(strokeStyle, key, index);
    key[index++] = strokeStyle.width;
    key[index++] = strokeStyle.alignment;
    key[index++] = strokeStyle.cap;
    key[index++] = strokeStyle.join;
    key[index++] = strokeStyle.miterLimit;
    return index;
}
function $9b4def45185a5f6c$var$addDropShadowKey(dropShadow, key, index) {
    if (!dropShadow) return index;
    key[index++] = dropShadow.alpha;
    key[index++] = dropShadow.angle;
    key[index++] = dropShadow.blur;
    key[index++] = dropShadow.distance;
    key[index++] = (0, $a2eTA.Color).shared.setValue(dropShadow.color).toNumber();
    return index;
}

});


parcelRegister("5Jnul", function(module, exports) {

$parcel$export(module.exports, "DynamicBitmapFont", () => $8f5ec95844dc935f$export$bce21273d0a2e6c7);

var $a2eTA = parcelRequire("a2eTA");

var $fM4Mk = parcelRequire("fM4Mk");

var $6RGCN = parcelRequire("6RGCN");

var $aQPld = parcelRequire("aQPld");

var $bLlTJ = parcelRequire("bLlTJ");

var $kXq8E = parcelRequire("kXq8E");

var $wLFHs = parcelRequire("wLFHs");

var $fI0NC = parcelRequire("fI0NC");

var $4JkiF = parcelRequire("4JkiF");

var $eKNW7 = parcelRequire("eKNW7");

var $hlNkG = parcelRequire("hlNkG");

var $6ch13 = parcelRequire("6ch13");
"use strict";
const $8f5ec95844dc935f$var$_DynamicBitmapFont = class _DynamicBitmapFont extends (0, $hlNkG.AbstractBitmapFont) {
    /**
   * @param options - The options for the dynamic bitmap font.
   */ constructor(options){
        super();
        /**
     * this is a resolution modifier for the font size..
     * texture resolution will also be used to scale texture according to its font size also
     */ this.resolution = 1;
        /** The pages of the font. */ this.pages = [];
        this._padding = 0;
        this._measureCache = /* @__PURE__ */ Object.create(null);
        this._currentChars = [];
        this._currentX = 0;
        this._currentY = 0;
        this._currentPageIndex = -1;
        this._skipKerning = false;
        const dynamicOptions = {
            ..._DynamicBitmapFont.defaultOptions,
            ...options
        };
        this._textureSize = dynamicOptions.textureSize;
        this._mipmap = dynamicOptions.mipmap;
        const style = dynamicOptions.style.clone();
        if (dynamicOptions.overrideFill) {
            style._fill.color = 16777215;
            style._fill.alpha = 1;
            style._fill.texture = (0, $bLlTJ.Texture).WHITE;
            style._fill.fill = null;
        }
        this.applyFillAsTint = dynamicOptions.overrideFill;
        const requestedFontSize = style.fontSize;
        style.fontSize = this.baseMeasurementFontSize;
        const font = (0, $fI0NC.fontStringFromTextStyle)(style);
        if (dynamicOptions.overrideSize) {
            if (style._stroke) style._stroke.width *= this.baseRenderedFontSize / requestedFontSize;
        } else style.fontSize = this.baseRenderedFontSize = requestedFontSize;
        this._style = style;
        this._skipKerning = dynamicOptions.skipKerning ?? false;
        this.resolution = dynamicOptions.resolution ?? 1;
        this._padding = dynamicOptions.padding ?? 4;
        this.fontMetrics = (0, $wLFHs.CanvasTextMetrics).measureFont(font);
        this.lineHeight = style.lineHeight || this.fontMetrics.fontSize || style.fontSize;
    }
    ensureCharacters(chars) {
        const charList = (0, $6ch13.resolveCharacters)(chars).filter((char)=>!this._currentChars.includes(char)).filter((char, index, self)=>self.indexOf(char) === index);
        if (!charList.length) return;
        this._currentChars = [
            ...this._currentChars,
            ...charList
        ];
        let pageData;
        if (this._currentPageIndex === -1) pageData = this._nextPage();
        else pageData = this.pages[this._currentPageIndex];
        let { canvas: canvas, context: context } = pageData.canvasAndContext;
        let textureSource = pageData.texture.source;
        const style = this._style;
        let currentX = this._currentX;
        let currentY = this._currentY;
        const fontScale = this.baseRenderedFontSize / this.baseMeasurementFontSize;
        const padding = this._padding * fontScale;
        const widthScale = style.fontStyle === "italic" ? 2 : 1;
        let maxCharHeight = 0;
        let skipTexture = false;
        for(let i = 0; i < charList.length; i++){
            const char = charList[i];
            const metrics = (0, $wLFHs.CanvasTextMetrics).measureText(char, style, canvas, false);
            metrics.lineHeight = metrics.height;
            const width = widthScale * metrics.width * fontScale;
            const height = metrics.height * fontScale;
            const paddedWidth = width + padding * 2;
            const paddedHeight = height + padding * 2;
            skipTexture = false;
            if (char !== "\n" && char !== "\r" && char !== "	" && char !== " ") {
                skipTexture = true;
                maxCharHeight = Math.ceil(Math.max(paddedHeight, maxCharHeight));
            }
            if (currentX + paddedWidth > this._textureSize) {
                currentY += maxCharHeight;
                maxCharHeight = paddedHeight;
                currentX = 0;
                if (currentY + maxCharHeight > this._textureSize) {
                    textureSource.update();
                    const pageData2 = this._nextPage();
                    canvas = pageData2.canvasAndContext.canvas;
                    context = pageData2.canvasAndContext.context;
                    textureSource = pageData2.texture.source;
                    currentY = 0;
                }
            }
            const xAdvance = width / fontScale - (style.dropShadow?.distance ?? 0) - (style._stroke?.width ?? 0);
            this.chars[char] = {
                id: char.codePointAt(0),
                xOffset: -this._padding,
                yOffset: -this._padding,
                xAdvance: xAdvance,
                kerning: {}
            };
            if (skipTexture) {
                this._drawGlyph(context, metrics, currentX + padding, currentY + padding, fontScale, style);
                const px = textureSource.width * fontScale;
                const py = textureSource.height * fontScale;
                const frame = new (0, $fM4Mk.Rectangle)(currentX / px * textureSource.width, currentY / py * textureSource.height, paddedWidth / px * textureSource.width, paddedHeight / py * textureSource.height);
                this.chars[char].texture = new (0, $bLlTJ.Texture)({
                    source: textureSource,
                    frame: frame
                });
                currentX += Math.ceil(paddedWidth);
            }
        }
        textureSource.update();
        this._currentX = currentX;
        this._currentY = currentY;
        this._skipKerning && this._applyKerning(charList, context);
    }
    /**
   * @deprecated since 8.0.0
   * The map of base page textures (i.e., sheets of glyphs).
   */ get pageTextures() {
        (0, $kXq8E.deprecation)((0, $kXq8E.v8_0_0), "BitmapFont.pageTextures is deprecated, please use BitmapFont.pages instead.");
        return this.pages;
    }
    _applyKerning(newChars, context) {
        const measureCache = this._measureCache;
        for(let i = 0; i < newChars.length; i++){
            const first = newChars[i];
            for(let j = 0; j < this._currentChars.length; j++){
                const second = this._currentChars[j];
                let c1 = measureCache[first];
                if (!c1) c1 = measureCache[first] = context.measureText(first).width;
                let c2 = measureCache[second];
                if (!c2) c2 = measureCache[second] = context.measureText(second).width;
                let total = context.measureText(first + second).width;
                let amount = total - (c1 + c2);
                if (amount) this.chars[first].kerning[second] = amount;
                total = context.measureText(first + second).width;
                amount = total - (c1 + c2);
                if (amount) this.chars[second].kerning[first] = amount;
            }
        }
    }
    _nextPage() {
        this._currentPageIndex++;
        const textureResolution = this.resolution;
        const canvasAndContext = (0, $6RGCN.CanvasPool).getOptimalCanvasAndContext(this._textureSize, this._textureSize, textureResolution);
        this._setupContext(canvasAndContext.context, this._style, textureResolution);
        const resolution = textureResolution * (this.baseRenderedFontSize / this.baseMeasurementFontSize);
        const texture = new (0, $bLlTJ.Texture)({
            source: new (0, $aQPld.ImageSource)({
                resource: canvasAndContext.canvas,
                resolution: resolution,
                alphaMode: "premultiply-alpha-on-upload",
                autoGenerateMipmaps: this._mipmap
            })
        });
        const pageData = {
            canvasAndContext: canvasAndContext,
            texture: texture
        };
        this.pages[this._currentPageIndex] = pageData;
        return pageData;
    }
    // canvas style!
    _setupContext(context, style, resolution) {
        style.fontSize = this.baseRenderedFontSize;
        context.scale(resolution, resolution);
        context.font = (0, $fI0NC.fontStringFromTextStyle)(style);
        style.fontSize = this.baseMeasurementFontSize;
        context.textBaseline = style.textBaseline;
        const stroke = style._stroke;
        const strokeThickness = stroke?.width ?? 0;
        if (stroke) {
            context.lineWidth = strokeThickness;
            context.lineJoin = stroke.join;
            context.miterLimit = stroke.miterLimit;
            context.strokeStyle = (0, $4JkiF.getCanvasFillStyle)(stroke, context);
        }
        if (style._fill) context.fillStyle = (0, $4JkiF.getCanvasFillStyle)(style._fill, context);
        if (style.dropShadow) {
            const shadowOptions = style.dropShadow;
            const rgb = (0, $a2eTA.Color).shared.setValue(shadowOptions.color).toArray();
            const dropShadowBlur = shadowOptions.blur * resolution;
            const dropShadowDistance = shadowOptions.distance * resolution;
            context.shadowColor = `rgba(${rgb[0] * 255},${rgb[1] * 255},${rgb[2] * 255},${shadowOptions.alpha})`;
            context.shadowBlur = dropShadowBlur;
            context.shadowOffsetX = Math.cos(shadowOptions.angle) * dropShadowDistance;
            context.shadowOffsetY = Math.sin(shadowOptions.angle) * dropShadowDistance;
        } else {
            context.shadowColor = "black";
            context.shadowBlur = 0;
            context.shadowOffsetX = 0;
            context.shadowOffsetY = 0;
        }
    }
    _drawGlyph(context, metrics, x, y, fontScale, style) {
        const char = metrics.text;
        const fontProperties = metrics.fontProperties;
        const stroke = style._stroke;
        const strokeThickness = (stroke?.width ?? 0) * fontScale;
        const tx = x + strokeThickness / 2;
        const ty = y - strokeThickness / 2;
        const descent = fontProperties.descent * fontScale;
        const lineHeight = metrics.lineHeight * fontScale;
        if (style.stroke && strokeThickness) context.strokeText(char, tx, ty + lineHeight - descent);
        if (style._fill) context.fillText(char, tx, ty + lineHeight - descent);
    }
    destroy() {
        super.destroy();
        for(let i = 0; i < this.pages.length; i++){
            const { canvasAndContext: canvasAndContext, texture: texture } = this.pages[i];
            canvasAndContext.canvas.width = canvasAndContext.canvas.width;
            (0, $6RGCN.CanvasPool).returnCanvasAndContext(canvasAndContext);
            texture.destroy(true);
        }
        this.pages = null;
    }
};
$8f5ec95844dc935f$var$_DynamicBitmapFont.defaultOptions = {
    textureSize: 512,
    style: new (0, $eKNW7.TextStyle)(),
    mipmap: true
};
let $8f5ec95844dc935f$export$bce21273d0a2e6c7 = $8f5ec95844dc935f$var$_DynamicBitmapFont;

});
parcelRegister("6RGCN", function(module, exports) {

$parcel$export(module.exports, "CanvasPool", () => $cb3b5b020b2ab749$export$e56d0a06781accc9);

var $iCGeI = parcelRequire("iCGeI");

var $NbSCN = parcelRequire("NbSCN");
"use strict";
class $cb3b5b020b2ab749$export$62d9f0b8aada09d7 {
    constructor(canvasOptions){
        this._canvasPool = /* @__PURE__ */ Object.create(null);
        this.canvasOptions = canvasOptions || {};
        this.enableFullScreen = false;
    }
    /**
   * Creates texture with params that were specified in pool constructor.
   * @param pixelWidth - Width of texture in pixels.
   * @param pixelHeight - Height of texture in pixels.
   */ _createCanvasAndContext(pixelWidth, pixelHeight) {
        const canvas = (0, $iCGeI.DOMAdapter).get().createCanvas();
        canvas.width = pixelWidth;
        canvas.height = pixelHeight;
        const context = canvas.getContext("2d");
        return {
            canvas: canvas,
            context: context
        };
    }
    /**
   * Gets a Power-of-Two render texture or fullScreen texture
   * @param minWidth - The minimum width of the render texture.
   * @param minHeight - The minimum height of the render texture.
   * @param resolution - The resolution of the render texture.
   * @returns The new render texture.
   */ getOptimalCanvasAndContext(minWidth, minHeight, resolution = 1) {
        minWidth = Math.ceil(minWidth * resolution - 1e-6);
        minHeight = Math.ceil(minHeight * resolution - 1e-6);
        minWidth = (0, $NbSCN.nextPow2)(minWidth);
        minHeight = (0, $NbSCN.nextPow2)(minHeight);
        const key = (minWidth << 17) + (minHeight << 1);
        if (!this._canvasPool[key]) this._canvasPool[key] = [];
        let canvasAndContext = this._canvasPool[key].pop();
        if (!canvasAndContext) canvasAndContext = this._createCanvasAndContext(minWidth, minHeight);
        return canvasAndContext;
    }
    /**
   * Place a render texture back into the pool.
   * @param canvasAndContext
   */ returnCanvasAndContext(canvasAndContext) {
        const canvas = canvasAndContext.canvas;
        const { width: width, height: height } = canvas;
        const key = (width << 17) + (height << 1);
        this._canvasPool[key].push(canvasAndContext);
    }
    clear() {
        this._canvasPool = {};
    }
}
const $cb3b5b020b2ab749$export$e56d0a06781accc9 = new $cb3b5b020b2ab749$export$62d9f0b8aada09d7();

});

parcelRegister("wLFHs", function(module, exports) {

$parcel$export(module.exports, "CanvasTextMetrics", () => $3648baf7179c08cc$export$b12f6bdc825d944f);

var $iCGeI = parcelRequire("iCGeI");

var $fI0NC = parcelRequire("fI0NC");
"use strict";
const $3648baf7179c08cc$var$contextSettings = {
    // TextMetrics requires getImageData readback for measuring fonts.
    willReadFrequently: true
};
const $3648baf7179c08cc$var$_CanvasTextMetrics = class _CanvasTextMetrics {
    /**
   * Checking that we can use modern canvas 2D API.
   *
   * Note: This is an unstable API, Chrome < 94 use `textLetterSpacing`, later versions use `letterSpacing`.
   * @see TextMetrics.experimentalLetterSpacing
   * @see https://developer.mozilla.org/en-US/docs/Web/API/ICanvasRenderingContext2D/letterSpacing
   * @see https://developer.chrome.com/origintrials/#/view_trial/3585991203293757441
   */ static get experimentalLetterSpacingSupported() {
        let result = _CanvasTextMetrics._experimentalLetterSpacingSupported;
        if (result !== void 0) {
            const proto = (0, $iCGeI.DOMAdapter).get().getCanvasRenderingContext2D().prototype;
            result = _CanvasTextMetrics._experimentalLetterSpacingSupported = "letterSpacing" in proto || "textLetterSpacing" in proto;
        }
        return result;
    }
    /**
   * @param text - the text that was measured
   * @param style - the style that was measured
   * @param width - the measured width of the text
   * @param height - the measured height of the text
   * @param lines - an array of the lines of text broken by new lines and wrapping if specified in style
   * @param lineWidths - an array of the line widths for each line matched to `lines`
   * @param lineHeight - the measured line height for this style
   * @param maxLineWidth - the maximum line width for all measured lines
   * @param {FontMetrics} fontProperties - the font properties object from TextMetrics.measureFont
   */ constructor(text, style, width, height, lines, lineWidths, lineHeight, maxLineWidth, fontProperties){
        this.text = text;
        this.style = style;
        this.width = width;
        this.height = height;
        this.lines = lines;
        this.lineWidths = lineWidths;
        this.lineHeight = lineHeight;
        this.maxLineWidth = maxLineWidth;
        this.fontProperties = fontProperties;
    }
    /**
   * Measures the supplied string of text and returns a Rectangle.
   * @param text - The text to measure.
   * @param style - The text style to use for measuring
   * @param canvas - optional specification of the canvas to use for measuring.
   * @param wordWrap
   * @returns Measured width and height of the text.
   */ static measureText(text = " ", style, canvas = _CanvasTextMetrics._canvas, wordWrap = style.wordWrap) {
        const textKey = `${text}:${style.styleKey}`;
        if (_CanvasTextMetrics._measurementCache[textKey]) return _CanvasTextMetrics._measurementCache[textKey];
        const font = (0, $fI0NC.fontStringFromTextStyle)(style);
        const fontProperties = _CanvasTextMetrics.measureFont(font);
        if (fontProperties.fontSize === 0) {
            fontProperties.fontSize = style.fontSize;
            fontProperties.ascent = style.fontSize;
        }
        const context = _CanvasTextMetrics.__context;
        context.font = font;
        const outputText = wordWrap ? _CanvasTextMetrics._wordWrap(text, style, canvas) : text;
        const lines = outputText.split(/(?:\r\n|\r|\n)/);
        const lineWidths = new Array(lines.length);
        let maxLineWidth = 0;
        for(let i = 0; i < lines.length; i++){
            const lineWidth = _CanvasTextMetrics._measureText(lines[i], style.letterSpacing, context);
            lineWidths[i] = lineWidth;
            maxLineWidth = Math.max(maxLineWidth, lineWidth);
        }
        const strokeWidth = style._stroke?.width || 0;
        let width = maxLineWidth + strokeWidth;
        if (style.dropShadow) width += style.dropShadow.distance;
        const lineHeight = style.lineHeight || fontProperties.fontSize;
        let height = Math.max(lineHeight, fontProperties.fontSize + strokeWidth) + (lines.length - 1) * (lineHeight + style.leading);
        if (style.dropShadow) height += style.dropShadow.distance;
        const measurements = new _CanvasTextMetrics(text, style, width, height, lines, lineWidths, lineHeight + style.leading, maxLineWidth, fontProperties);
        return measurements;
    }
    static _measureText(text, letterSpacing, context) {
        let useExperimentalLetterSpacing = false;
        if (_CanvasTextMetrics.experimentalLetterSpacingSupported) {
            if (_CanvasTextMetrics.experimentalLetterSpacing) {
                context.letterSpacing = `${letterSpacing}px`;
                context.textLetterSpacing = `${letterSpacing}px`;
                useExperimentalLetterSpacing = true;
            } else {
                context.letterSpacing = "0px";
                context.textLetterSpacing = "0px";
            }
        }
        let width = context.measureText(text).width;
        if (width > 0) {
            if (useExperimentalLetterSpacing) width -= letterSpacing;
            else width += (_CanvasTextMetrics.graphemeSegmenter(text).length - 1) * letterSpacing;
        }
        return width;
    }
    /**
   * Applies newlines to a string to have it optimally fit into the horizontal
   * bounds set by the Text object's wordWrapWidth property.
   * @param text - String to apply word wrapping to
   * @param style - the style to use when wrapping
   * @param canvas - optional specification of the canvas to use for measuring.
   * @returns New string with new lines applied where required
   */ static _wordWrap(text, style, canvas = _CanvasTextMetrics._canvas) {
        const context = canvas.getContext("2d", $3648baf7179c08cc$var$contextSettings);
        let width = 0;
        let line = "";
        let lines = "";
        const cache = /* @__PURE__ */ Object.create(null);
        const { letterSpacing: letterSpacing, whiteSpace: whiteSpace } = style;
        const collapseSpaces = _CanvasTextMetrics._collapseSpaces(whiteSpace);
        const collapseNewlines = _CanvasTextMetrics._collapseNewlines(whiteSpace);
        let canPrependSpaces = !collapseSpaces;
        const wordWrapWidth = style.wordWrapWidth + letterSpacing;
        const tokens = _CanvasTextMetrics._tokenize(text);
        for(let i = 0; i < tokens.length; i++){
            let token = tokens[i];
            if (_CanvasTextMetrics._isNewline(token)) {
                if (!collapseNewlines) {
                    lines += _CanvasTextMetrics._addLine(line);
                    canPrependSpaces = !collapseSpaces;
                    line = "";
                    width = 0;
                    continue;
                }
                token = " ";
            }
            if (collapseSpaces) {
                const currIsBreakingSpace = _CanvasTextMetrics.isBreakingSpace(token);
                const lastIsBreakingSpace = _CanvasTextMetrics.isBreakingSpace(line[line.length - 1]);
                if (currIsBreakingSpace && lastIsBreakingSpace) continue;
            }
            const tokenWidth = _CanvasTextMetrics._getFromCache(token, letterSpacing, cache, context);
            if (tokenWidth > wordWrapWidth) {
                if (line !== "") {
                    lines += _CanvasTextMetrics._addLine(line);
                    line = "";
                    width = 0;
                }
                if (_CanvasTextMetrics.canBreakWords(token, style.breakWords)) {
                    const characters = _CanvasTextMetrics.wordWrapSplit(token);
                    for(let j = 0; j < characters.length; j++){
                        let char = characters[j];
                        let lastChar = char;
                        let k = 1;
                        while(characters[j + k]){
                            const nextChar = characters[j + k];
                            if (!_CanvasTextMetrics.canBreakChars(lastChar, nextChar, token, j, style.breakWords)) char += nextChar;
                            else break;
                            lastChar = nextChar;
                            k++;
                        }
                        j += k - 1;
                        const characterWidth = _CanvasTextMetrics._getFromCache(char, letterSpacing, cache, context);
                        if (characterWidth + width > wordWrapWidth) {
                            lines += _CanvasTextMetrics._addLine(line);
                            canPrependSpaces = false;
                            line = "";
                            width = 0;
                        }
                        line += char;
                        width += characterWidth;
                    }
                } else {
                    if (line.length > 0) {
                        lines += _CanvasTextMetrics._addLine(line);
                        line = "";
                        width = 0;
                    }
                    const isLastToken = i === tokens.length - 1;
                    lines += _CanvasTextMetrics._addLine(token, !isLastToken);
                    canPrependSpaces = false;
                    line = "";
                    width = 0;
                }
            } else {
                if (tokenWidth + width > wordWrapWidth) {
                    canPrependSpaces = false;
                    lines += _CanvasTextMetrics._addLine(line);
                    line = "";
                    width = 0;
                }
                if (line.length > 0 || !_CanvasTextMetrics.isBreakingSpace(token) || canPrependSpaces) {
                    line += token;
                    width += tokenWidth;
                }
            }
        }
        lines += _CanvasTextMetrics._addLine(line, false);
        return lines;
    }
    /**
   * Convenience function for logging each line added during the wordWrap method.
   * @param line    - The line of text to add
   * @param newLine - Add new line character to end
   * @returns A formatted line
   */ static _addLine(line, newLine = true) {
        line = _CanvasTextMetrics._trimRight(line);
        line = newLine ? `${line}
` : line;
        return line;
    }
    /**
   * Gets & sets the widths of calculated characters in a cache object
   * @param key            - The key
   * @param letterSpacing  - The letter spacing
   * @param cache          - The cache
   * @param context        - The canvas context
   * @returns The from cache.
   */ static _getFromCache(key, letterSpacing, cache, context) {
        let width = cache[key];
        if (typeof width !== "number") {
            width = _CanvasTextMetrics._measureText(key, letterSpacing, context) + letterSpacing;
            cache[key] = width;
        }
        return width;
    }
    /**
   * Determines whether we should collapse breaking spaces.
   * @param whiteSpace - The TextStyle property whiteSpace
   * @returns Should collapse
   */ static _collapseSpaces(whiteSpace) {
        return whiteSpace === "normal" || whiteSpace === "pre-line";
    }
    /**
   * Determines whether we should collapse newLine chars.
   * @param whiteSpace - The white space
   * @returns should collapse
   */ static _collapseNewlines(whiteSpace) {
        return whiteSpace === "normal";
    }
    /**
   * Trims breaking whitespaces from string.
   * @param text - The text
   * @returns Trimmed string
   */ static _trimRight(text) {
        if (typeof text !== "string") return "";
        for(let i = text.length - 1; i >= 0; i--){
            const char = text[i];
            if (!_CanvasTextMetrics.isBreakingSpace(char)) break;
            text = text.slice(0, -1);
        }
        return text;
    }
    /**
   * Determines if char is a newline.
   * @param char - The character
   * @returns True if newline, False otherwise.
   */ static _isNewline(char) {
        if (typeof char !== "string") return false;
        return _CanvasTextMetrics._newlines.includes(char.charCodeAt(0));
    }
    /**
   * Determines if char is a breaking whitespace.
   *
   * It allows one to determine whether char should be a breaking whitespace
   * For example certain characters in CJK langs or numbers.
   * It must return a boolean.
   * @param char - The character
   * @param [_nextChar] - The next character
   * @returns True if whitespace, False otherwise.
   */ static isBreakingSpace(char, _nextChar) {
        if (typeof char !== "string") return false;
        return _CanvasTextMetrics._breakingSpaces.includes(char.charCodeAt(0));
    }
    /**
   * Splits a string into words, breaking-spaces and newLine characters
   * @param text - The text
   * @returns A tokenized array
   */ static _tokenize(text) {
        const tokens = [];
        let token = "";
        if (typeof text !== "string") return tokens;
        for(let i = 0; i < text.length; i++){
            const char = text[i];
            const nextChar = text[i + 1];
            if (_CanvasTextMetrics.isBreakingSpace(char, nextChar) || _CanvasTextMetrics._isNewline(char)) {
                if (token !== "") {
                    tokens.push(token);
                    token = "";
                }
                tokens.push(char);
                continue;
            }
            token += char;
        }
        if (token !== "") tokens.push(token);
        return tokens;
    }
    /**
   * Overridable helper method used internally by TextMetrics, exposed to allow customizing the class's behavior.
   *
   * It allows one to customise which words should break
   * Examples are if the token is CJK or numbers.
   * It must return a boolean.
   * @param _token - The token
   * @param breakWords - The style attr break words
   * @returns Whether to break word or not
   */ static canBreakWords(_token, breakWords) {
        return breakWords;
    }
    /**
   * Overridable helper method used internally by TextMetrics, exposed to allow customizing the class's behavior.
   *
   * It allows one to determine whether a pair of characters
   * should be broken by newlines
   * For example certain characters in CJK langs or numbers.
   * It must return a boolean.
   * @param _char - The character
   * @param _nextChar - The next character
   * @param _token - The token/word the characters are from
   * @param _index - The index in the token of the char
   * @param _breakWords - The style attr break words
   * @returns whether to break word or not
   */ static canBreakChars(_char, _nextChar, _token, _index, _breakWords) {
        return true;
    }
    /**
   * Overridable helper method used internally by TextMetrics, exposed to allow customizing the class's behavior.
   *
   * It is called when a token (usually a word) has to be split into separate pieces
   * in order to determine the point to break a word.
   * It must return an array of characters.
   * @param token - The token to split
   * @returns The characters of the token
   * @see CanvasTextMetrics.graphemeSegmenter
   */ static wordWrapSplit(token) {
        return _CanvasTextMetrics.graphemeSegmenter(token);
    }
    /**
   * Calculates the ascent, descent and fontSize of a given font-style
   * @param font - String representing the style of the font
   * @returns Font properties object
   */ static measureFont(font) {
        if (_CanvasTextMetrics._fonts[font]) return _CanvasTextMetrics._fonts[font];
        const context = _CanvasTextMetrics._context;
        context.font = font;
        const metrics = context.measureText(_CanvasTextMetrics.METRICS_STRING + _CanvasTextMetrics.BASELINE_SYMBOL);
        const properties = {
            ascent: metrics.actualBoundingBoxAscent,
            descent: metrics.actualBoundingBoxDescent,
            fontSize: metrics.actualBoundingBoxAscent + metrics.actualBoundingBoxDescent
        };
        _CanvasTextMetrics._fonts[font] = properties;
        return properties;
    }
    /**
   * Clear font metrics in metrics cache.
   * @param {string} [font] - font name. If font name not set then clear cache for all fonts.
   */ static clearMetrics(font = "") {
        if (font) delete _CanvasTextMetrics._fonts[font];
        else _CanvasTextMetrics._fonts = {};
    }
    /**
   * Cached canvas element for measuring text
   * TODO: this should be private, but isn't because of backward compat, will fix later.
   * @ignore
   */ static get _canvas() {
        if (!_CanvasTextMetrics.__canvas) {
            let canvas;
            try {
                const c = new OffscreenCanvas(0, 0);
                const context = c.getContext("2d", $3648baf7179c08cc$var$contextSettings);
                if (context?.measureText) {
                    _CanvasTextMetrics.__canvas = c;
                    return c;
                }
                canvas = (0, $iCGeI.DOMAdapter).get().createCanvas();
            } catch (ex) {
                canvas = (0, $iCGeI.DOMAdapter).get().createCanvas();
            }
            canvas.width = canvas.height = 10;
            _CanvasTextMetrics.__canvas = canvas;
        }
        return _CanvasTextMetrics.__canvas;
    }
    /**
   * TODO: this should be private, but isn't because of backward compat, will fix later.
   * @ignore
   */ static get _context() {
        if (!_CanvasTextMetrics.__context) _CanvasTextMetrics.__context = _CanvasTextMetrics._canvas.getContext("2d", $3648baf7179c08cc$var$contextSettings);
        return _CanvasTextMetrics.__context;
    }
};
/**
 * String used for calculate font metrics.
 * These characters are all tall to help calculate the height required for text.
 */ $3648baf7179c08cc$var$_CanvasTextMetrics.METRICS_STRING = "|\xc9q\xc5";
/** Baseline symbol for calculate font metrics. */ $3648baf7179c08cc$var$_CanvasTextMetrics.BASELINE_SYMBOL = "M";
/** Baseline multiplier for calculate font metrics. */ $3648baf7179c08cc$var$_CanvasTextMetrics.BASELINE_MULTIPLIER = 1.4;
/** Height multiplier for setting height of canvas to calculate font metrics. */ $3648baf7179c08cc$var$_CanvasTextMetrics.HEIGHT_MULTIPLIER = 2;
/**
 * A Unicode "character", or "grapheme cluster", can be composed of multiple Unicode code points,
 * such as letters with diacritical marks (e.g. `'\u0065\u0301'`, letter e with acute)
 * or emojis with modifiers (e.g. `'\uD83E\uDDD1\u200D\uD83D\uDCBB'`, technologist).
 * The new `Intl.Segmenter` API in ES2022 can split the string into grapheme clusters correctly. If it is not available,
 * PixiJS will fallback to use the iterator of String, which can only spilt the string into code points.
 * If you want to get full functionality in environments that don't support `Intl.Segmenter` (such as Firefox),
 * you can use other libraries such as [grapheme-splitter]{@link https://www.npmjs.com/package/grapheme-splitter}
 * or [graphemer]{@link https://www.npmjs.com/package/graphemer} to create a polyfill. Since these libraries can be
 * relatively large in size to handle various Unicode grapheme clusters properly, PixiJS won't use them directly.
 */ $3648baf7179c08cc$var$_CanvasTextMetrics.graphemeSegmenter = (()=>{
    if (typeof Intl?.Segmenter === "function") {
        const segmenter = new Intl.Segmenter();
        return (s)=>[
                ...segmenter.segment(s)
            ].map((x)=>x.segment);
    }
    return (s)=>[
            ...s
        ];
})();
/**
 * New rendering behavior for letter-spacing which uses Chrome's new native API. This will
 * lead to more accurate letter-spacing results because it does not try to manually draw
 * each character. However, this Chrome API is experimental and may not serve all cases yet.
 * @see TextMetrics.experimentalLetterSpacingSupported
 */ $3648baf7179c08cc$var$_CanvasTextMetrics.experimentalLetterSpacing = false;
/** Cache of {@see TextMetrics.FontMetrics} objects. */ $3648baf7179c08cc$var$_CanvasTextMetrics._fonts = {};
/** Cache of new line chars. */ $3648baf7179c08cc$var$_CanvasTextMetrics._newlines = [
    10,
    // line feed
    13
];
/** Cache of breaking spaces. */ $3648baf7179c08cc$var$_CanvasTextMetrics._breakingSpaces = [
    9,
    // character tabulation
    32,
    // space
    8192,
    // en quad
    8193,
    // em quad
    8194,
    // en space
    8195,
    // em space
    8196,
    // three-per-em space
    8197,
    // four-per-em space
    8198,
    // six-per-em space
    8200,
    // punctuation space
    8201,
    // thin space
    8202,
    // hair space
    8287,
    // medium mathematical space
    12288
];
$3648baf7179c08cc$var$_CanvasTextMetrics._measurementCache = {};
let $3648baf7179c08cc$export$b12f6bdc825d944f = $3648baf7179c08cc$var$_CanvasTextMetrics;

});
parcelRegister("fI0NC", function(module, exports) {

$parcel$export(module.exports, "fontStringFromTextStyle", () => $432516f32dcd2061$export$b7b5edb82ac3fc66);
"use strict";
const $432516f32dcd2061$var$genericFontFamilies = [
    "serif",
    "sans-serif",
    "monospace",
    "cursive",
    "fantasy",
    "system-ui"
];
function $432516f32dcd2061$export$b7b5edb82ac3fc66(style) {
    const fontSizeString = typeof style.fontSize === "number" ? `${style.fontSize}px` : style.fontSize;
    let fontFamilies = style.fontFamily;
    if (!Array.isArray(style.fontFamily)) fontFamilies = style.fontFamily.split(",");
    for(let i = fontFamilies.length - 1; i >= 0; i--){
        let fontFamily = fontFamilies[i].trim();
        if (!/([\"\'])[^\'\"]+\1/.test(fontFamily) && !$432516f32dcd2061$var$genericFontFamilies.includes(fontFamily)) fontFamily = `"${fontFamily}"`;
        fontFamilies[i] = fontFamily;
    }
    return `${style.fontStyle} ${style.fontVariant} ${style.fontWeight} ${fontSizeString} ${fontFamilies.join(",")}`;
}

});


parcelRegister("4JkiF", function(module, exports) {

$parcel$export(module.exports, "getCanvasFillStyle", () => $70d03c252755e3f8$export$c31af9427fa8602b);

var $a2eTA = parcelRequire("a2eTA");

var $eY4rt = parcelRequire("eY4rt");

var $bLlTJ = parcelRequire("bLlTJ");

var $hUCK4 = parcelRequire("hUCK4");

var $gwwtL = parcelRequire("gwwtL");

var $ktCpi = parcelRequire("ktCpi");
"use strict";
function $70d03c252755e3f8$export$c31af9427fa8602b(fillStyle, context) {
    if (fillStyle.texture === (0, $bLlTJ.Texture).WHITE && !fillStyle.fill) return (0, $a2eTA.Color).shared.setValue(fillStyle.color).setAlpha(fillStyle.alpha ?? 1).toHexa();
    else if (!fillStyle.fill) {
        const pattern = context.createPattern(fillStyle.texture.source.resource, "repeat");
        const tempMatrix = fillStyle.matrix.copyTo((0, $eY4rt.Matrix).shared);
        tempMatrix.scale(fillStyle.texture.frame.width, fillStyle.texture.frame.height);
        pattern.setTransform(tempMatrix);
        return pattern;
    } else if (fillStyle.fill instanceof (0, $ktCpi.FillPattern)) {
        const fillPattern = fillStyle.fill;
        const pattern = context.createPattern(fillPattern.texture.source.resource, "repeat");
        const tempMatrix = fillPattern.transform.copyTo((0, $eY4rt.Matrix).shared);
        tempMatrix.scale(fillPattern.texture.frame.width, fillPattern.texture.frame.height);
        pattern.setTransform(tempMatrix);
        return pattern;
    } else if (fillStyle.fill instanceof (0, $gwwtL.FillGradient)) {
        const fillGradient = fillStyle.fill;
        if (fillGradient.type === "linear") {
            const gradient = context.createLinearGradient(fillGradient.x0, fillGradient.y0, fillGradient.x1, fillGradient.y1);
            fillGradient.gradientStops.forEach((stop)=>{
                gradient.addColorStop(stop.offset, (0, $a2eTA.Color).shared.setValue(stop.color).toHex());
            });
            return gradient;
        }
    }
    (0, $hUCK4.warn)("FillStyle not recognised", fillStyle);
    return "red";
}

});

parcelRegister("hlNkG", function(module, exports) {

$parcel$export(module.exports, "AbstractBitmapFont", () => $5d74af76d429a42b$export$70779aee6e4c1309);

var $3vRz3 = parcelRequire("3vRz3");

var $kXq8E = parcelRequire("kXq8E");
"use strict";
class $5d74af76d429a42b$export$70779aee6e4c1309 extends (0, (/*@__PURE__*/$parcel$interopDefault($3vRz3))) {
    constructor(){
        super(...arguments);
        /** The map of characters by character code. */ this.chars = /* @__PURE__ */ Object.create(null);
        /**
     * The line-height of the font face in pixels.
     * @type {number}
     */ this.lineHeight = 0;
        /**
     * The name of the font face
     * @type {string}
     */ this.fontFamily = "";
        /** The metrics of the font face. */ this.fontMetrics = {
            fontSize: 0,
            ascent: 0,
            descent: 0
        };
        /**
     * The offset of the font face from the baseline.
     * @type {number}
     */ this.baseLineOffset = 0;
        /** The range and type of the distance field for this font. */ this.distanceField = {
            type: "none",
            range: 0
        };
        /** The map of base page textures (i.e., sheets of glyphs). */ this.pages = [];
        /** should the fill for this font be applied as a tint to the text. */ this.applyFillAsTint = true;
        /** The size of the font face in pixels. */ this.baseMeasurementFontSize = 100;
        this.baseRenderedFontSize = 100;
    }
    /**
   * The name of the font face.
   * @deprecated since 8.0.0 Use `fontFamily` instead.
   */ get font() {
        (0, $kXq8E.deprecation)((0, $kXq8E.v8_0_0), "BitmapFont.font is deprecated, please use BitmapFont.fontFamily instead.");
        return this.fontFamily;
    }
    /**
   * The map of base page textures (i.e., sheets of glyphs).
   * @deprecated since 8.0.0 Use `pages` instead.
   */ get pageTextures() {
        (0, $kXq8E.deprecation)((0, $kXq8E.v8_0_0), "BitmapFont.pageTextures is deprecated, please use BitmapFont.pages instead.");
        return this.pages;
    }
    /**
   * The size of the font face in pixels.
   * @deprecated since 8.0.0 Use `fontMetrics.fontSize` instead.
   */ get size() {
        (0, $kXq8E.deprecation)((0, $kXq8E.v8_0_0), "BitmapFont.size is deprecated, please use BitmapFont.fontMetrics.fontSize instead.");
        return this.fontMetrics.fontSize;
    }
    /**
   * The kind of distance field for this font or "none".
   * @deprecated since 8.0.0 Use `distanceField.type` instead.
   */ get distanceFieldRange() {
        (0, $kXq8E.deprecation)((0, $kXq8E.v8_0_0), "BitmapFont.distanceFieldRange is deprecated, please use BitmapFont.distanceField.range instead.");
        return this.distanceField.range;
    }
    /**
   * The range of the distance field in pixels.
   * @deprecated since 8.0.0 Use `distanceField.range` instead.
   */ get distanceFieldType() {
        (0, $kXq8E.deprecation)((0, $kXq8E.v8_0_0), "BitmapFont.distanceFieldType is deprecated, please use BitmapFont.distanceField.type instead.");
        return this.distanceField.type;
    }
    destroy(destroyTextures = false) {
        this.emit("destroy", this);
        this.removeAllListeners();
        for(const i in this.chars)this.chars[i].texture?.destroy();
        this.chars = null;
        if (destroyTextures) {
            this.pages.forEach((page)=>page.texture.destroy(true));
            this.pages = null;
        }
    }
}

});

parcelRegister("6ch13", function(module, exports) {

$parcel$export(module.exports, "resolveCharacters", () => $6068e3267b929dcc$export$221291e5031b03d8);
"use strict";
function $6068e3267b929dcc$export$221291e5031b03d8(chars) {
    if (chars === "") return [];
    if (typeof chars === "string") chars = [
        chars
    ];
    const result = [];
    for(let i = 0, j = chars.length; i < j; i++){
        const item = chars[i];
        if (Array.isArray(item)) {
            if (item.length !== 2) throw new Error(`[BitmapFont]: Invalid character range length, expecting 2 got ${item.length}.`);
            if (item[0].length === 0 || item[1].length === 0) throw new Error("[BitmapFont]: Invalid character delimiter.");
            const startCode = item[0].charCodeAt(0);
            const endCode = item[1].charCodeAt(0);
            if (endCode < startCode) throw new Error("[BitmapFont]: Invalid character range.");
            for(let i2 = startCode, j2 = endCode; i2 <= j2; i2++)result.push(String.fromCharCode(i2));
        } else result.push(...Array.from(item));
    }
    if (result.length === 0) throw new Error("[BitmapFont]: Empty set when resolving characters.");
    return result;
}

});


parcelRegister("hzhPt", function(module, exports) {

$parcel$export(module.exports, "getBitmapTextLayout", () => $a05acbad40de1576$export$beeb37b3e20d3ee4);
"use strict";
function $a05acbad40de1576$export$beeb37b3e20d3ee4(chars, style, font, trimEnd) {
    const layoutData = {
        width: 0,
        height: 0,
        offsetY: 0,
        scale: style.fontSize / font.baseMeasurementFontSize,
        lines: [
            {
                width: 0,
                charPositions: [],
                spaceWidth: 0,
                spacesIndex: [],
                chars: []
            }
        ]
    };
    layoutData.offsetY = font.baseLineOffset;
    let currentLine = layoutData.lines[0];
    let previousChar = null;
    let firstWord = true;
    const currentWord = {
        spaceWord: false,
        width: 0,
        start: 0,
        index: 0,
        // use index to not modify the array as we use it a lot!
        positions: [],
        chars: []
    };
    const nextWord = (word)=>{
        const start = currentLine.width;
        for(let j = 0; j < currentWord.index; j++){
            const position = word.positions[j];
            currentLine.chars.push(word.chars[j]);
            currentLine.charPositions.push(position + start);
        }
        currentLine.width += word.width;
        firstWord = false;
        currentWord.width = 0;
        currentWord.index = 0;
        currentWord.chars.length = 0;
    };
    const nextLine = ()=>{
        let index = currentLine.chars.length - 1;
        if (trimEnd) {
            let lastChar = currentLine.chars[index];
            while(lastChar === " "){
                currentLine.width -= font.chars[lastChar].xAdvance;
                lastChar = currentLine.chars[--index];
            }
        }
        layoutData.width = Math.max(layoutData.width, currentLine.width);
        currentLine = {
            width: 0,
            charPositions: [],
            chars: [],
            spaceWidth: 0,
            spacesIndex: []
        };
        firstWord = true;
        layoutData.lines.push(currentLine);
        layoutData.height += font.lineHeight;
    };
    const scale = font.baseMeasurementFontSize / style.fontSize;
    const adjustedLetterSpacing = style.letterSpacing * scale;
    const adjustedWordWrapWidth = style.wordWrapWidth * scale;
    for(let i = 0; i < chars.length + 1; i++){
        let char;
        const isEnd = i === chars.length;
        if (!isEnd) char = chars[i];
        const charData = font.chars[char] || font.chars[" "];
        const isSpace = /(?:\s)/.test(char);
        const isWordBreak = isSpace || char === "\r" || char === "\n" || isEnd;
        if (isWordBreak) {
            const addWordToNextLine = !firstWord && style.wordWrap && currentLine.width + currentWord.width - adjustedLetterSpacing > adjustedWordWrapWidth;
            if (addWordToNextLine) {
                nextLine();
                nextWord(currentWord);
                if (!isEnd) currentLine.charPositions.push(0);
            } else {
                currentWord.start = currentLine.width;
                nextWord(currentWord);
                if (!isEnd) currentLine.charPositions.push(0);
            }
            if (char === "\r" || char === "\n") {
                if (currentLine.width !== 0) nextLine();
            } else if (!isEnd) {
                const spaceWidth = charData.xAdvance + (charData.kerning[previousChar] || 0) + adjustedLetterSpacing;
                currentLine.width += spaceWidth;
                currentLine.spaceWidth = spaceWidth;
                currentLine.spacesIndex.push(currentLine.charPositions.length);
                currentLine.chars.push(char);
            }
        } else {
            const kerning = charData.kerning[previousChar] || 0;
            const nextCharWidth = charData.xAdvance + kerning + adjustedLetterSpacing;
            currentWord.positions[currentWord.index++] = currentWord.width + kerning;
            currentWord.chars.push(char);
            currentWord.width += nextCharWidth;
        }
        previousChar = char;
    }
    nextLine();
    if (style.align === "center") $a05acbad40de1576$var$alignCenter(layoutData);
    else if (style.align === "right") $a05acbad40de1576$var$alignRight(layoutData);
    else if (style.align === "justify") $a05acbad40de1576$var$alignJustify(layoutData);
    return layoutData;
}
function $a05acbad40de1576$var$alignCenter(measurementData) {
    for(let i = 0; i < measurementData.lines.length; i++){
        const line = measurementData.lines[i];
        const offset = measurementData.width / 2 - line.width / 2;
        for(let j = 0; j < line.charPositions.length; j++)line.charPositions[j] += offset;
    }
}
function $a05acbad40de1576$var$alignRight(measurementData) {
    for(let i = 0; i < measurementData.lines.length; i++){
        const line = measurementData.lines[i];
        const offset = measurementData.width - line.width;
        for(let j = 0; j < line.charPositions.length; j++)line.charPositions[j] += offset;
    }
}
function $a05acbad40de1576$var$alignJustify(measurementData) {
    const width = measurementData.width;
    for(let i = 0; i < measurementData.lines.length; i++){
        const line = measurementData.lines[i];
        let indy = 0;
        let spaceIndex = line.spacesIndex[indy++];
        let offset = 0;
        const totalSpaces = line.spacesIndex.length;
        const newSpaceWidth = (width - line.width) / totalSpaces;
        const spaceWidth = newSpaceWidth;
        for(let j = 0; j < line.charPositions.length; j++){
            if (j === spaceIndex) {
                spaceIndex = line.spacesIndex[indy++];
                offset += spaceWidth;
            }
            line.charPositions[j] += offset;
        }
    }
}

});


parcelRegister("3cebA", function(module, exports) {

$parcel$export(module.exports, "Graphics", () => $1b5e4ef3a1ed4a4a$export$29d3e417456abdad);

var $kXq8E = parcelRequire("kXq8E");

var $5BbT9 = parcelRequire("5BbT9");

var $8aC7P = parcelRequire("8aC7P");
"use strict";
class $1b5e4ef3a1ed4a4a$export$29d3e417456abdad extends (0, $5BbT9.ViewContainer) {
    /**
   * @param options - Options for the Graphics.
   */ constructor(options){
        if (options instanceof (0, $8aC7P.GraphicsContext)) options = {
            context: options
        };
        const { context: context, roundPixels: roundPixels, ...rest } = options || {};
        super({
            label: "Graphics",
            ...rest
        });
        this.renderPipeId = "graphics";
        if (!context) this._context = this._ownedContext = new (0, $8aC7P.GraphicsContext)();
        else this._context = context;
        this._context.on("update", this.onViewUpdate, this);
        this.allowChildren = false;
        this.roundPixels = roundPixels ?? false;
    }
    set context(context) {
        if (context === this._context) return;
        this._context.off("update", this.onViewUpdate, this);
        this._context = context;
        this._context.on("update", this.onViewUpdate, this);
        this.onViewUpdate();
    }
    get context() {
        return this._context;
    }
    /**
   * The local bounds of the graphic.
   * @type {rendering.Bounds}
   */ get bounds() {
        return this._context.bounds;
    }
    /**
   * Adds the bounds of this object to the bounds object.
   * @param bounds - The output bounds object.
   */ addBounds(bounds) {
        bounds.addBounds(this._context.bounds);
    }
    /**
   * Checks if the object contains the given point.
   * @param point - The point to check
   */ containsPoint(point) {
        return this._context.containsPoint(point);
    }
    onViewUpdate() {
        this._didViewChangeTick++;
        this._didGraphicsUpdate = true;
        if (this.didViewUpdate) return;
        this.didViewUpdate = true;
        const renderGroup = this.renderGroup || this.parentRenderGroup;
        if (renderGroup) renderGroup.onChildViewUpdate(this);
    }
    /**
   * Destroys this graphics renderable and optionally its context.
   * @param options - Options parameter. A boolean will act as if all options
   *
   * If the context was created by this graphics and `destroy(false)` or `destroy()` is called
   * then the context will still be destroyed.
   *
   * If you want to explicitly not destroy this context that this graphics created,
   * then you should pass destroy({ context: false })
   *
   * If the context was passed in as an argument to the constructor then it will not be destroyed
   * @param {boolean} [options.texture=false] - Should destroy the texture of the graphics context
   * @param {boolean} [options.textureSource=false] - Should destroy the texture source of the graphics context
   * @param {boolean} [options.context=false] - Should destroy the context
   */ destroy(options) {
        if (this._ownedContext && !options) this._ownedContext.destroy(options);
        else if (options === true || options?.context === true) this._context.destroy(options);
        this._ownedContext = null;
        this._context = null;
        super.destroy(options);
    }
    _callContextMethod(method, args) {
        this.context[method](...args);
        return this;
    }
    // --------------------------------------- GraphicsContext methods ---------------------------------------
    /**
   * Sets the current fill style of the graphics context. The fill style can be a color, gradient,
   * pattern, or a more complex style defined by a FillStyle object.
   * @param {FillInput} args - The fill style to apply. This can be a simple color, a gradient or
   * pattern object, or a FillStyle or ConvertedFillStyle object.
   * @returns The instance of the current GraphicsContext for method chaining.
   */ setFillStyle(...args) {
        return this._callContextMethod("setFillStyle", args);
    }
    /**
   * Sets the current stroke style of the graphics context. Similar to fill styles, stroke styles can
   * encompass colors, gradients, patterns, or more detailed configurations via a StrokeStyle object.
   * @param {StrokeInput} args - The stroke style to apply. Can be defined as a color, a gradient or pattern,
   * or a StrokeStyle or ConvertedStrokeStyle object.
   * @returns The instance of the current GraphicsContext for method chaining.
   */ setStrokeStyle(...args) {
        return this._callContextMethod("setStrokeStyle", args);
    }
    fill(...args) {
        return this._callContextMethod("fill", args);
    }
    /**
   * Strokes the current path with the current stroke style. This method can take an optional
   * FillStyle parameter to define the stroke's appearance, including its color, width, and other properties.
   * @param {FillStyle} args - (Optional) The stroke style to apply. Can be defined as a simple color or a more
   * complex style object. If omitted, uses the current stroke style.
   * @returns The instance of the current GraphicsContext for method chaining.
   */ stroke(...args) {
        return this._callContextMethod("stroke", args);
    }
    texture(...args) {
        return this._callContextMethod("texture", args);
    }
    /**
   * Resets the current path. Any previous path and its commands are discarded and a new path is
   * started. This is typically called before beginning a new shape or series of drawing commands.
   * @returns The instance of the current GraphicsContext for method chaining.
   */ beginPath() {
        return this._callContextMethod("beginPath", []);
    }
    /**
   * Applies a cutout to the last drawn shape. This is used to create holes or complex shapes by
   * subtracting a path from the previously drawn path. If a hole is not completely in a shape, it will
   * fail to cut correctly!
   */ cut() {
        return this._callContextMethod("cut", []);
    }
    arc(...args) {
        return this._callContextMethod("arc", args);
    }
    arcTo(...args) {
        return this._callContextMethod("arcTo", args);
    }
    arcToSvg(...args) {
        return this._callContextMethod("arcToSvg", args);
    }
    bezierCurveTo(...args) {
        return this._callContextMethod("bezierCurveTo", args);
    }
    /**
   * Closes the current path by drawing a straight line back to the start.
   * If the shape is already closed or there are no points in the path, this method does nothing.
   * @returns The instance of the current object for chaining.
   */ closePath() {
        return this._callContextMethod("closePath", []);
    }
    ellipse(...args) {
        return this._callContextMethod("ellipse", args);
    }
    circle(...args) {
        return this._callContextMethod("circle", args);
    }
    path(...args) {
        return this._callContextMethod("path", args);
    }
    lineTo(...args) {
        return this._callContextMethod("lineTo", args);
    }
    moveTo(...args) {
        return this._callContextMethod("moveTo", args);
    }
    quadraticCurveTo(...args) {
        return this._callContextMethod("quadraticCurveTo", args);
    }
    rect(...args) {
        return this._callContextMethod("rect", args);
    }
    roundRect(...args) {
        return this._callContextMethod("roundRect", args);
    }
    poly(...args) {
        return this._callContextMethod("poly", args);
    }
    regularPoly(...args) {
        return this._callContextMethod("regularPoly", args);
    }
    roundPoly(...args) {
        return this._callContextMethod("roundPoly", args);
    }
    roundShape(...args) {
        return this._callContextMethod("roundShape", args);
    }
    filletRect(...args) {
        return this._callContextMethod("filletRect", args);
    }
    chamferRect(...args) {
        return this._callContextMethod("chamferRect", args);
    }
    star(...args) {
        return this._callContextMethod("star", args);
    }
    svg(...args) {
        return this._callContextMethod("svg", args);
    }
    restore(...args) {
        return this._callContextMethod("restore", args);
    }
    /** Saves the current graphics state, including transformations, fill styles, and stroke styles, onto a stack. */ save() {
        return this._callContextMethod("save", []);
    }
    /**
   * Returns the current transformation matrix of the graphics context.
   * @returns The current transformation matrix.
   */ getTransform() {
        return this.context.getTransform();
    }
    /**
   * Resets the current transformation matrix to the identity matrix, effectively removing
   * any transformations (rotation, scaling, translation) previously applied.
   * @returns The instance of the current GraphicsContext for method chaining.
   */ resetTransform() {
        return this._callContextMethod("resetTransform", []);
    }
    rotateTransform(...args) {
        return this._callContextMethod("rotate", args);
    }
    scaleTransform(...args) {
        return this._callContextMethod("scale", args);
    }
    setTransform(...args) {
        return this._callContextMethod("setTransform", args);
    }
    transform(...args) {
        return this._callContextMethod("transform", args);
    }
    translateTransform(...args) {
        return this._callContextMethod("translate", args);
    }
    /**
   * Clears all drawing commands from the graphics context, effectively resetting it. This includes clearing the path,
   * and optionally resetting transformations to the identity matrix.
   * @returns The instance of the current GraphicsContext for method chaining.
   */ clear() {
        return this._callContextMethod("clear", []);
    }
    /**
   * The fill style to use.
   * @type {ConvertedFillStyle}
   */ get fillStyle() {
        return this._context.fillStyle;
    }
    set fillStyle(value) {
        this._context.fillStyle = value;
    }
    /**
   * The stroke style to use.
   * @type {ConvertedStrokeStyle}
   */ get strokeStyle() {
        return this._context.strokeStyle;
    }
    set strokeStyle(value) {
        this._context.strokeStyle = value;
    }
    /**
   * Creates a new Graphics object.
   * Note that only the context of the object is cloned, not its transform (position,scale,etc)
   * @param deep - Whether to create a deep clone of the graphics object. If false, the context
   * will be shared between the two objects (default false). If true, the context will be
   * cloned (recommended if you need to modify the context in any way).
   * @returns - A clone of the graphics object
   */ clone(deep = false) {
        if (deep) return new $1b5e4ef3a1ed4a4a$export$29d3e417456abdad(this._context.clone());
        this._ownedContext = null;
        const clone = new $1b5e4ef3a1ed4a4a$export$29d3e417456abdad(this._context);
        return clone;
    }
    // -------- v7 deprecations ---------
    /**
   * @param width
   * @param color
   * @param alpha
   * @deprecated since 8.0.0 Use {@link Graphics#setStrokeStyle} instead
   */ lineStyle(width, color, alpha) {
        (0, $kXq8E.deprecation)((0, $kXq8E.v8_0_0), "Graphics#lineStyle is no longer needed. Use Graphics#setStrokeStyle to set the stroke style.");
        const strokeStyle = {};
        width && (strokeStyle.width = width);
        color && (strokeStyle.color = color);
        alpha && (strokeStyle.alpha = alpha);
        this.context.strokeStyle = strokeStyle;
        return this;
    }
    /**
   * @param color
   * @param alpha
   * @deprecated since 8.0.0 Use {@link Graphics#fill} instead
   */ beginFill(color, alpha) {
        (0, $kXq8E.deprecation)((0, $kXq8E.v8_0_0), "Graphics#beginFill is no longer needed. Use Graphics#fill to fill the shape with the desired style.");
        const fillStyle = {};
        color && (fillStyle.color = color);
        alpha && (fillStyle.alpha = alpha);
        this.context.fillStyle = fillStyle;
        return this;
    }
    /**
   * @deprecated since 8.0.0 Use {@link Graphics#fill} instead
   */ endFill() {
        (0, $kXq8E.deprecation)((0, $kXq8E.v8_0_0), "Graphics#endFill is no longer needed. Use Graphics#fill to fill the shape with the desired style.");
        this.context.fill();
        const strokeStyle = this.context.strokeStyle;
        if (strokeStyle.width !== (0, $8aC7P.GraphicsContext).defaultStrokeStyle.width || strokeStyle.color !== (0, $8aC7P.GraphicsContext).defaultStrokeStyle.color || strokeStyle.alpha !== (0, $8aC7P.GraphicsContext).defaultStrokeStyle.alpha) this.context.stroke();
        return this;
    }
    /**
   * @param {...any} args
   * @deprecated since 8.0.0 Use {@link Graphics#circle} instead
   */ drawCircle(...args) {
        (0, $kXq8E.deprecation)((0, $kXq8E.v8_0_0), "Graphics#drawCircle has been renamed to Graphics#circle");
        return this._callContextMethod("circle", args);
    }
    /**
   * @param {...any} args
   * @deprecated since 8.0.0 Use {@link Graphics#ellipse} instead
   */ drawEllipse(...args) {
        (0, $kXq8E.deprecation)((0, $kXq8E.v8_0_0), "Graphics#drawEllipse has been renamed to Graphics#ellipse");
        return this._callContextMethod("ellipse", args);
    }
    /**
   * @param {...any} args
   * @deprecated since 8.0.0 Use {@link Graphics#poly} instead
   */ drawPolygon(...args) {
        (0, $kXq8E.deprecation)((0, $kXq8E.v8_0_0), "Graphics#drawPolygon has been renamed to Graphics#poly");
        return this._callContextMethod("poly", args);
    }
    /**
   * @param {...any} args
   * @deprecated since 8.0.0 Use {@link Graphics#rect} instead
   */ drawRect(...args) {
        (0, $kXq8E.deprecation)((0, $kXq8E.v8_0_0), "Graphics#drawRect has been renamed to Graphics#rect");
        return this._callContextMethod("rect", args);
    }
    /**
   * @param {...any} args
   * @deprecated since 8.0.0 Use {@link Graphics#roundRect} instead
   */ drawRoundedRect(...args) {
        (0, $kXq8E.deprecation)((0, $kXq8E.v8_0_0), "Graphics#drawRoundedRect has been renamed to Graphics#roundRect");
        return this._callContextMethod("roundRect", args);
    }
    /**
   * @param {...any} args
   * @deprecated since 8.0.0 Use {@link Graphics#star} instead
   */ drawStar(...args) {
        (0, $kXq8E.deprecation)((0, $kXq8E.v8_0_0), "Graphics#drawStar has been renamed to Graphics#star");
        return this._callContextMethod("star", args);
    }
}

});

parcelRegister("hkl1e", function(module, exports) {

var $2Ys9z = parcelRequire("2Ys9z");
parcelRequire("dMz05");
module.exports = $c9d49bd36db95cd5$var$AABB;
/**
 * Axis aligned bounding box class.
 * @class AABB
 * @constructor
 * @param {Object}  [options]
 * @param {Array}   [options.upperBound]
 * @param {Array}   [options.lowerBound]
 */ function $c9d49bd36db95cd5$var$AABB(options) {
    /**
     * The lower bound of the bounding box.
     * @property lowerBound
     * @type {Array}
     */ this.lowerBound = $2Ys9z.create();
    if (options && options.lowerBound) $2Ys9z.copy(this.lowerBound, options.lowerBound);
    /**
     * The upper bound of the bounding box.
     * @property upperBound
     * @type {Array}
     */ this.upperBound = $2Ys9z.create();
    if (options && options.upperBound) $2Ys9z.copy(this.upperBound, options.upperBound);
}
var $c9d49bd36db95cd5$var$tmp = $2Ys9z.create();
/**
 * Set the AABB bounds from a set of points, transformed by the given position and angle.
 * @method setFromPoints
 * @param {Array} points An array of vec2's.
 * @param {Array} position
 * @param {number} angle
 * @param {number} skinSize Some margin to be added to the AABB.
 */ $c9d49bd36db95cd5$var$AABB.prototype.setFromPoints = function(points, position, angle, skinSize) {
    var l = this.lowerBound, u = this.upperBound;
    if (typeof angle !== "number") angle = 0;
    // Set to the first point
    if (angle !== 0) $2Ys9z.rotate(l, points[0], angle);
    else $2Ys9z.copy(l, points[0]);
    $2Ys9z.copy(u, l);
    // Compute cosines and sines just once
    var cosAngle = Math.cos(angle), sinAngle = Math.sin(angle);
    for(var i = 1; i < points.length; i++){
        var p = points[i];
        if (angle !== 0) {
            var x = p[0], y = p[1];
            $c9d49bd36db95cd5$var$tmp[0] = cosAngle * x - sinAngle * y;
            $c9d49bd36db95cd5$var$tmp[1] = sinAngle * x + cosAngle * y;
            p = $c9d49bd36db95cd5$var$tmp;
        }
        for(var j = 0; j < 2; j++){
            if (p[j] > u[j]) u[j] = p[j];
            if (p[j] < l[j]) l[j] = p[j];
        }
    }
    // Add offset
    if (position) {
        $2Ys9z.add(this.lowerBound, this.lowerBound, position);
        $2Ys9z.add(this.upperBound, this.upperBound, position);
    }
    if (skinSize) {
        this.lowerBound[0] -= skinSize;
        this.lowerBound[1] -= skinSize;
        this.upperBound[0] += skinSize;
        this.upperBound[1] += skinSize;
    }
};
/**
 * Copy bounds from an AABB to this AABB
 * @method copy
 * @param  {AABB} aabb
 */ $c9d49bd36db95cd5$var$AABB.prototype.copy = function(aabb) {
    $2Ys9z.copy(this.lowerBound, aabb.lowerBound);
    $2Ys9z.copy(this.upperBound, aabb.upperBound);
};
/**
 * Extend this AABB so that it covers the given AABB too.
 * @method extend
 * @param  {AABB} aabb
 */ $c9d49bd36db95cd5$var$AABB.prototype.extend = function(aabb) {
    // Loop over x and y
    var i = 2;
    while(i--){
        // Extend lower bound
        var l = aabb.lowerBound[i];
        if (this.lowerBound[i] > l) this.lowerBound[i] = l;
        // Upper
        var u = aabb.upperBound[i];
        if (this.upperBound[i] < u) this.upperBound[i] = u;
    }
};
/**
 * Returns true if the given AABB overlaps this AABB.
 * @method overlaps
 * @param  {AABB} aabb
 * @return {Boolean}
 */ $c9d49bd36db95cd5$var$AABB.prototype.overlaps = function(aabb) {
    var l1 = this.lowerBound, u1 = this.upperBound, l2 = aabb.lowerBound, u2 = aabb.upperBound;
    //      l2        u2
    //      |---------|
    // |--------|
    // l1       u1
    return (l2[0] <= u1[0] && u1[0] <= u2[0] || l1[0] <= u2[0] && u2[0] <= u1[0]) && (l2[1] <= u1[1] && u1[1] <= u2[1] || l1[1] <= u2[1] && u2[1] <= u1[1]);
};
/**
 * @method containsPoint
 * @param  {Array} point
 * @return {boolean}
 */ $c9d49bd36db95cd5$var$AABB.prototype.containsPoint = function(point) {
    var l = this.lowerBound, u = this.upperBound;
    return l[0] <= point[0] && point[0] <= u[0] && l[1] <= point[1] && point[1] <= u[1];
};
/**
 * Check if the AABB is hit by a ray.
 * @method overlapsRay
 * @param  {Ray} ray
 * @return {number} -1 if no hit, a number between 0 and 1 if hit.
 */ $c9d49bd36db95cd5$var$AABB.prototype.overlapsRay = function(ray) {
    var t = 0;
    // ray.direction is unit direction vector of ray
    var dirFracX = 1 / ray.direction[0];
    var dirFracY = 1 / ray.direction[1];
    // this.lowerBound is the corner of AABB with minimal coordinates - left bottom, rt is maximal corner
    var t1 = (this.lowerBound[0] - ray.from[0]) * dirFracX;
    var t2 = (this.upperBound[0] - ray.from[0]) * dirFracX;
    var t3 = (this.lowerBound[1] - ray.from[1]) * dirFracY;
    var t4 = (this.upperBound[1] - ray.from[1]) * dirFracY;
    var tmin = Math.max(Math.max(Math.min(t1, t2), Math.min(t3, t4)));
    var tmax = Math.min(Math.min(Math.max(t1, t2), Math.max(t3, t4)));
    // if tmax < 0, ray (line) is intersecting AABB, but whole AABB is behing us
    if (tmax < 0) //t = tmax;
    return -1;
    // if tmin > tmax, ray doesn't intersect AABB
    if (tmin > tmax) //t = tmax;
    return -1;
    return tmin;
};

});
parcelRegister("2Ys9z", function(module, exports) {
/* Copyright (c) 2013, Brandon Jones, Colin MacKenzie IV. All rights reserved.

Redistribution and use in source and binary forms, with or without modification,
are permitted provided that the following conditions are met:

  * Redistributions of source code must retain the above copyright notice, this
    list of conditions and the following disclaimer.
  * Redistributions in binary form must reproduce the above copyright notice,
    this list of conditions and the following disclaimer in the documentation
    and/or other materials provided with the distribution.

THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR
ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
(INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON
ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
(INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE. */ /**
 * The vec2 object from glMatrix, with some extensions and some removed methods. See http://glmatrix.net.
 * @class vec2
 */ var $22a7061001f45300$var$vec2 = module.exports = {};

var $dMz05 = parcelRequire("dMz05");
/**
 * Make a cross product and only return the z component
 * @method crossLength
 * @static
 * @param  {Array} a
 * @param  {Array} b
 * @return {Number}
 */ $22a7061001f45300$var$vec2.crossLength = function(a, b) {
    return a[0] * b[1] - a[1] * b[0];
};
/**
 * Cross product between a vector and the Z component of a vector
 * @method crossVZ
 * @static
 * @param  {Array} out
 * @param  {Array} vec
 * @param  {Number} zcomp
 * @return {Number}
 */ $22a7061001f45300$var$vec2.crossVZ = function(out, vec, zcomp) {
    $22a7061001f45300$var$vec2.rotate(out, vec, -Math.PI / 2); // Rotate according to the right hand rule
    $22a7061001f45300$var$vec2.scale(out, out, zcomp); // Scale with z
    return out;
};
/**
 * Cross product between a vector and the Z component of a vector
 * @method crossZV
 * @static
 * @param  {Array} out
 * @param  {Number} zcomp
 * @param  {Array} vec
 * @return {Number}
 */ $22a7061001f45300$var$vec2.crossZV = function(out, zcomp, vec) {
    $22a7061001f45300$var$vec2.rotate(out, vec, Math.PI / 2); // Rotate according to the right hand rule
    $22a7061001f45300$var$vec2.scale(out, out, zcomp); // Scale with z
    return out;
};
/**
 * Rotate a vector by an angle
 * @method rotate
 * @static
 * @param  {Array} out
 * @param  {Array} a
 * @param  {Number} angle
 */ $22a7061001f45300$var$vec2.rotate = function(out, a, angle) {
    if (angle !== 0) {
        var c = Math.cos(angle), s = Math.sin(angle), x = a[0], y = a[1];
        out[0] = c * x - s * y;
        out[1] = s * x + c * y;
    } else {
        out[0] = a[0];
        out[1] = a[1];
    }
};
/**
 * Rotate a vector 90 degrees clockwise
 * @method rotate90cw
 * @static
 * @param  {Array} out
 * @param  {Array} a
 * @param  {Number} angle
 */ $22a7061001f45300$var$vec2.rotate90cw = function(out, a) {
    var x = a[0];
    var y = a[1];
    out[0] = y;
    out[1] = -x;
};
/**
 * Transform a point position to local frame.
 * @method toLocalFrame
 * @param  {Array} out
 * @param  {Array} worldPoint
 * @param  {Array} framePosition
 * @param  {Number} frameAngle
 */ $22a7061001f45300$var$vec2.toLocalFrame = function(out, worldPoint, framePosition, frameAngle) {
    $22a7061001f45300$var$vec2.copy(out, worldPoint);
    $22a7061001f45300$var$vec2.sub(out, out, framePosition);
    $22a7061001f45300$var$vec2.rotate(out, out, -frameAngle);
};
/**
 * Transform a point position to global frame.
 * @method toGlobalFrame
 * @param  {Array} out
 * @param  {Array} localPoint
 * @param  {Array} framePosition
 * @param  {Number} frameAngle
 */ $22a7061001f45300$var$vec2.toGlobalFrame = function(out, localPoint, framePosition, frameAngle) {
    $22a7061001f45300$var$vec2.copy(out, localPoint);
    $22a7061001f45300$var$vec2.rotate(out, out, frameAngle);
    $22a7061001f45300$var$vec2.add(out, out, framePosition);
};
/**
 * Transform a vector to local frame.
 * @method vectorToLocalFrame
 * @param  {Array} out
 * @param  {Array} worldVector
 * @param  {Number} frameAngle
 */ $22a7061001f45300$var$vec2.vectorToLocalFrame = function(out, worldVector, frameAngle) {
    $22a7061001f45300$var$vec2.rotate(out, worldVector, -frameAngle);
};
/**
 * Transform a point position to global frame.
 * @method toGlobalFrame
 * @param  {Array} out
 * @param  {Array} localVector
 * @param  {Number} frameAngle
 */ $22a7061001f45300$var$vec2.vectorToGlobalFrame = function(out, localVector, frameAngle) {
    $22a7061001f45300$var$vec2.rotate(out, localVector, frameAngle);
};
/**
 * Compute centroid of a triangle spanned by vectors a,b,c. See http://easycalculation.com/analytical/learn-centroid.php
 * @method centroid
 * @static
 * @param  {Array} out
 * @param  {Array} a
 * @param  {Array} b
 * @param  {Array} c
 * @return  {Array} The out object
 */ $22a7061001f45300$var$vec2.centroid = function(out, a, b, c) {
    $22a7061001f45300$var$vec2.add(out, a, b);
    $22a7061001f45300$var$vec2.add(out, out, c);
    $22a7061001f45300$var$vec2.scale(out, out, 1 / 3);
    return out;
};
/**
 * Creates a new, empty vec2
 * @static
 * @method create
 * @return {Array} a new 2D vector
 */ $22a7061001f45300$var$vec2.create = function() {
    var out = new $dMz05.ARRAY_TYPE(2);
    out[0] = 0;
    out[1] = 0;
    return out;
};
/**
 * Creates a new vec2 initialized with values from an existing vector
 * @static
 * @method clone
 * @param {Array} a vector to clone
 * @return {Array} a new 2D vector
 */ $22a7061001f45300$var$vec2.clone = function(a) {
    var out = new $dMz05.ARRAY_TYPE(2);
    out[0] = a[0];
    out[1] = a[1];
    return out;
};
/**
 * Creates a new vec2 initialized with the given values
 * @static
 * @method fromValues
 * @param {Number} x X component
 * @param {Number} y Y component
 * @return {Array} a new 2D vector
 */ $22a7061001f45300$var$vec2.fromValues = function(x, y) {
    var out = new $dMz05.ARRAY_TYPE(2);
    out[0] = x;
    out[1] = y;
    return out;
};
/**
 * Copy the values from one vec2 to another
 * @static
 * @method copy
 * @param {Array} out the receiving vector
 * @param {Array} a the source vector
 * @return {Array} out
 */ $22a7061001f45300$var$vec2.copy = function(out, a) {
    out[0] = a[0];
    out[1] = a[1];
    return out;
};
/**
 * Set the components of a vec2 to the given values
 * @static
 * @method set
 * @param {Array} out the receiving vector
 * @param {Number} x X component
 * @param {Number} y Y component
 * @return {Array} out
 */ $22a7061001f45300$var$vec2.set = function(out, x, y) {
    out[0] = x;
    out[1] = y;
    return out;
};
/**
 * Adds two vec2's
 * @static
 * @method add
 * @param {Array} out the receiving vector
 * @param {Array} a the first operand
 * @param {Array} b the second operand
 * @return {Array} out
 */ $22a7061001f45300$var$vec2.add = function(out, a, b) {
    out[0] = a[0] + b[0];
    out[1] = a[1] + b[1];
    return out;
};
/**
 * Subtracts two vec2's
 * @static
 * @method subtract
 * @param {Array} out the receiving vector
 * @param {Array} a the first operand
 * @param {Array} b the second operand
 * @return {Array} out
 */ $22a7061001f45300$var$vec2.subtract = function(out, a, b) {
    out[0] = a[0] - b[0];
    out[1] = a[1] - b[1];
    return out;
};
/**
 * Alias for vec2.subtract
 * @static
 * @method sub
 */ $22a7061001f45300$var$vec2.sub = $22a7061001f45300$var$vec2.subtract;
/**
 * Multiplies two vec2's
 * @static
 * @method multiply
 * @param {Array} out the receiving vector
 * @param {Array} a the first operand
 * @param {Array} b the second operand
 * @return {Array} out
 */ $22a7061001f45300$var$vec2.multiply = function(out, a, b) {
    out[0] = a[0] * b[0];
    out[1] = a[1] * b[1];
    return out;
};
/**
 * Alias for vec2.multiply
 * @static
 * @method mul
 */ $22a7061001f45300$var$vec2.mul = $22a7061001f45300$var$vec2.multiply;
/**
 * Divides two vec2's
 * @static
 * @method divide
 * @param {Array} out the receiving vector
 * @param {Array} a the first operand
 * @param {Array} b the second operand
 * @return {Array} out
 */ $22a7061001f45300$var$vec2.divide = function(out, a, b) {
    out[0] = a[0] / b[0];
    out[1] = a[1] / b[1];
    return out;
};
/**
 * Alias for vec2.divide
 * @static
 * @method div
 */ $22a7061001f45300$var$vec2.div = $22a7061001f45300$var$vec2.divide;
/**
 * Scales a vec2 by a scalar number
 * @static
 * @method scale
 * @param {Array} out the receiving vector
 * @param {Array} a the vector to scale
 * @param {Number} b amount to scale the vector by
 * @return {Array} out
 */ $22a7061001f45300$var$vec2.scale = function(out, a, b) {
    out[0] = a[0] * b;
    out[1] = a[1] * b;
    return out;
};
/**
 * Calculates the euclidian distance between two vec2's
 * @static
 * @method distance
 * @param {Array} a the first operand
 * @param {Array} b the second operand
 * @return {Number} distance between a and b
 */ $22a7061001f45300$var$vec2.distance = function(a, b) {
    var x = b[0] - a[0], y = b[1] - a[1];
    return Math.sqrt(x * x + y * y);
};
/**
 * Alias for vec2.distance
 * @static
 * @method dist
 */ $22a7061001f45300$var$vec2.dist = $22a7061001f45300$var$vec2.distance;
/**
 * Calculates the squared euclidian distance between two vec2's
 * @static
 * @method squaredDistance
 * @param {Array} a the first operand
 * @param {Array} b the second operand
 * @return {Number} squared distance between a and b
 */ $22a7061001f45300$var$vec2.squaredDistance = function(a, b) {
    var x = b[0] - a[0], y = b[1] - a[1];
    return x * x + y * y;
};
/**
 * Alias for vec2.squaredDistance
 * @static
 * @method sqrDist
 */ $22a7061001f45300$var$vec2.sqrDist = $22a7061001f45300$var$vec2.squaredDistance;
/**
 * Calculates the length of a vec2
 * @static
 * @method length
 * @param {Array} a vector to calculate length of
 * @return {Number} length of a
 */ $22a7061001f45300$var$vec2.length = function(a) {
    var x = a[0], y = a[1];
    return Math.sqrt(x * x + y * y);
};
/**
 * Alias for vec2.length
 * @method len
 * @static
 */ $22a7061001f45300$var$vec2.len = $22a7061001f45300$var$vec2.length;
/**
 * Calculates the squared length of a vec2
 * @static
 * @method squaredLength
 * @param {Array} a vector to calculate squared length of
 * @return {Number} squared length of a
 */ $22a7061001f45300$var$vec2.squaredLength = function(a) {
    var x = a[0], y = a[1];
    return x * x + y * y;
};
/**
 * Alias for vec2.squaredLength
 * @static
 * @method sqrLen
 */ $22a7061001f45300$var$vec2.sqrLen = $22a7061001f45300$var$vec2.squaredLength;
/**
 * Negates the components of a vec2
 * @static
 * @method negate
 * @param {Array} out the receiving vector
 * @param {Array} a vector to negate
 * @return {Array} out
 */ $22a7061001f45300$var$vec2.negate = function(out, a) {
    out[0] = -a[0];
    out[1] = -a[1];
    return out;
};
/**
 * Normalize a vec2
 * @static
 * @method normalize
 * @param {Array} out the receiving vector
 * @param {Array} a vector to normalize
 * @return {Array} out
 */ $22a7061001f45300$var$vec2.normalize = function(out, a) {
    var x = a[0], y = a[1];
    var len = x * x + y * y;
    if (len > 0) {
        //TODO: evaluate use of glm_invsqrt here?
        len = 1 / Math.sqrt(len);
        out[0] = a[0] * len;
        out[1] = a[1] * len;
    }
    return out;
};
/**
 * Calculates the dot product of two vec2's
 * @static
 * @method dot
 * @param {Array} a the first operand
 * @param {Array} b the second operand
 * @return {Number} dot product of a and b
 */ $22a7061001f45300$var$vec2.dot = function(a, b) {
    return a[0] * b[0] + a[1] * b[1];
};
/**
 * Returns a string representation of a vector
 * @static
 * @method str
 * @param {Array} vec vector to represent as a string
 * @return {String} string representation of the vector
 */ $22a7061001f45300$var$vec2.str = function(a) {
    return "vec2(" + a[0] + ", " + a[1] + ")";
};
/**
 * Linearly interpolate/mix two vectors.
 * @static
 * @method lerp
 * @param {Array} out
 * @param {Array} a First vector
 * @param {Array} b Second vector
 * @param {number} t Lerp factor
 */ $22a7061001f45300$var$vec2.lerp = function(out, a, b, t) {
    var ax = a[0], ay = a[1];
    out[0] = ax + t * (b[0] - ax);
    out[1] = ay + t * (b[1] - ay);
    return out;
};
/**
 * Reflect a vector along a normal.
 * @static
 * @method reflect
 * @param {Array} out
 * @param {Array} vector
 * @param {Array} normal
 */ $22a7061001f45300$var$vec2.reflect = function(out, vector, normal) {
    var dot = vector[0] * normal[0] + vector[1] * normal[1];
    out[0] = vector[0] - 2 * normal[0] * dot;
    out[1] = vector[1] - 2 * normal[1] * dot;
};
/**
 * Get the intersection point between two line segments.
 * @static
 * @method getLineSegmentsIntersection
 * @param  {Array} out
 * @param  {Array} p0
 * @param  {Array} p1
 * @param  {Array} p2
 * @param  {Array} p3
 * @return {boolean} True if there was an intersection, otherwise false.
 */ $22a7061001f45300$var$vec2.getLineSegmentsIntersection = function(out, p0, p1, p2, p3) {
    var t = $22a7061001f45300$var$vec2.getLineSegmentsIntersectionFraction(p0, p1, p2, p3);
    if (t < 0) return false;
    else {
        out[0] = p0[0] + t * (p1[0] - p0[0]);
        out[1] = p0[1] + t * (p1[1] - p0[1]);
        return true;
    }
};
/**
 * Get the intersection fraction between two line segments. If successful, the intersection is at p0 + t * (p1 - p0)
 * @static
 * @method getLineSegmentsIntersectionFraction
 * @param  {Array} p0
 * @param  {Array} p1
 * @param  {Array} p2
 * @param  {Array} p3
 * @return {number} A number between 0 and 1 if there was an intersection, otherwise -1.
 */ $22a7061001f45300$var$vec2.getLineSegmentsIntersectionFraction = function(p0, p1, p2, p3) {
    var s1_x = p1[0] - p0[0];
    var s1_y = p1[1] - p0[1];
    var s2_x = p3[0] - p2[0];
    var s2_y = p3[1] - p2[1];
    var s, t;
    s = (-s1_y * (p0[0] - p2[0]) + s1_x * (p0[1] - p2[1])) / (-s2_x * s1_y + s1_x * s2_y);
    t = (s2_x * (p0[1] - p2[1]) - s2_y * (p0[0] - p2[0])) / (-s2_x * s1_y + s1_x * s2_y);
    if (s >= 0 && s <= 1 && t >= 0 && t <= 1) return t;
    return -1; // No collision
};

});
parcelRegister("dMz05", function(module, exports) {
/* global P2_ARRAY_TYPE */ module.exports = $a08ae86a856e7e9e$var$Utils;
/**
 * Misc utility functions
 * @class Utils
 * @constructor
 */ function $a08ae86a856e7e9e$var$Utils() {}
/**
 * Append the values in array b to the array a. See <a href="http://stackoverflow.com/questions/1374126/how-to-append-an-array-to-an-existing-javascript-array/1374131#1374131">this</a> for an explanation.
 * @method appendArray
 * @static
 * @param  {Array} a
 * @param  {Array} b
 */ $a08ae86a856e7e9e$var$Utils.appendArray = function(a, b) {
    if (b.length < 150000) a.push.apply(a, b);
    else for(var i = 0, len = b.length; i !== len; ++i)a.push(b[i]);
};
/**
 * Garbage free Array.splice(). Does not allocate a new array.
 * @method splice
 * @static
 * @param  {Array} array
 * @param  {Number} index
 * @param  {Number} howmany
 */ $a08ae86a856e7e9e$var$Utils.splice = function(array, index, howmany) {
    howmany = howmany || 1;
    for(var i = index, len = array.length - howmany; i < len; i++)array[i] = array[i + howmany];
    array.length = len;
};
/**
 * The array type to use for internal numeric computations throughout the library. Float32Array is used if it is available, but falls back on Array. If you want to set array type manually, inject it via the global variable P2_ARRAY_TYPE. See example below.
 * @static
 * @property {function} ARRAY_TYPE
 * @example
 *     <script>
 *         <!-- Inject your preferred array type before loading p2.js -->
 *         P2_ARRAY_TYPE = Array;
 *     </script>
 *     <script src="p2.js"></script>
 */ if (typeof P2_ARRAY_TYPE !== "undefined") $a08ae86a856e7e9e$var$Utils.ARRAY_TYPE = P2_ARRAY_TYPE;
else if (typeof Float32Array !== "undefined") $a08ae86a856e7e9e$var$Utils.ARRAY_TYPE = Float32Array;
else $a08ae86a856e7e9e$var$Utils.ARRAY_TYPE = Array;
/**
 * Extend an object with the properties of another
 * @static
 * @method extend
 * @param  {object} a
 * @param  {object} b
 */ $a08ae86a856e7e9e$var$Utils.extend = function(a, b) {
    for(var key in b)a[key] = b[key];
};
/**
 * Extend an options object with default values.
 * @static
 * @method defaults
 * @param  {object} options The options object. May be falsy: in this case, a new object is created and returned.
 * @param  {object} defaults An object containing default values.
 * @return {object} The modified options object.
 */ $a08ae86a856e7e9e$var$Utils.defaults = function(options, defaults) {
    options = options || {};
    for(var key in defaults)if (!(key in options)) options[key] = defaults[key];
    return options;
};

});



parcelRegister("5PEF1", function(module, exports) {

var $f0tQu = parcelRequire("f0tQu");
parcelRequire("2Ys9z");
module.exports = $43f14183f1aefb3e$var$AngleLockEquation;
/**
 * Locks the relative angle between two bodies. The constraint tries to keep the dot product between two vectors, local in each body, to zero. The local angle in body i is a parameter.
 *
 * @class AngleLockEquation
 * @constructor
 * @extends Equation
 * @param {Body} bodyA
 * @param {Body} bodyB
 * @param {Object} [options]
 * @param {Number} [options.angle] Angle to add to the local vector in body A.
 * @param {Number} [options.ratio] Gear ratio
 */ function $43f14183f1aefb3e$var$AngleLockEquation(bodyA, bodyB, options) {
    options = options || {};
    $f0tQu.call(this, bodyA, bodyB, -Number.MAX_VALUE, Number.MAX_VALUE);
    this.angle = options.angle || 0;
    /**
     * The gear ratio.
     * @property {Number} ratio
     * @private
     * @see setRatio
     */ this.ratio = typeof options.ratio === "number" ? options.ratio : 1;
    this.setRatio(this.ratio);
}
$43f14183f1aefb3e$var$AngleLockEquation.prototype = new $f0tQu();
$43f14183f1aefb3e$var$AngleLockEquation.prototype.constructor = $43f14183f1aefb3e$var$AngleLockEquation;
$43f14183f1aefb3e$var$AngleLockEquation.prototype.computeGq = function() {
    return this.ratio * this.bodyA.angle - this.bodyB.angle + this.angle;
};
/**
 * Set the gear ratio for this equation
 * @method setRatio
 * @param {Number} ratio
 */ $43f14183f1aefb3e$var$AngleLockEquation.prototype.setRatio = function(ratio) {
    var G = this.G;
    G[2] = ratio;
    G[5] = -1;
    this.ratio = ratio;
};
/**
 * Set the max force for the equation.
 * @method setMaxTorque
 * @param {Number} torque
 */ $43f14183f1aefb3e$var$AngleLockEquation.prototype.setMaxTorque = function(torque) {
    this.maxForce = torque;
    this.minForce = -torque;
};

});
parcelRegister("f0tQu", function(module, exports) {
module.exports = $aece01d762aa979a$var$Equation;

var $2Ys9z = parcelRequire("2Ys9z");

var $dMz05 = parcelRequire("dMz05");
parcelRequire("e7hLo");
/**
 * Base class for constraint equations.
 * @class Equation
 * @constructor
 * @param {Body} bodyA First body participating in the equation
 * @param {Body} bodyB Second body participating in the equation
 * @param {number} minForce Minimum force to apply. Default: -Number.MAX_VALUE
 * @param {number} maxForce Maximum force to apply. Default: Number.MAX_VALUE
 */ function $aece01d762aa979a$var$Equation(bodyA, bodyB, minForce, maxForce) {
    /**
     * Minimum force to apply when solving.
     * @property minForce
     * @type {Number}
     */ this.minForce = typeof minForce === "undefined" ? -Number.MAX_VALUE : minForce;
    /**
     * Max force to apply when solving.
     * @property maxForce
     * @type {Number}
     */ this.maxForce = typeof maxForce === "undefined" ? Number.MAX_VALUE : maxForce;
    /**
     * First body participating in the constraint
     * @property bodyA
     * @type {Body}
     */ this.bodyA = bodyA;
    /**
     * Second body participating in the constraint
     * @property bodyB
     * @type {Body}
     */ this.bodyB = bodyB;
    /**
     * The stiffness of this equation. Typically chosen to a large number (~1e7), but can be chosen somewhat freely to get a stable simulation.
     * @property stiffness
     * @type {Number}
     */ this.stiffness = $aece01d762aa979a$var$Equation.DEFAULT_STIFFNESS;
    /**
     * The number of time steps needed to stabilize the constraint equation. Typically between 3 and 5 time steps.
     * @property relaxation
     * @type {Number}
     */ this.relaxation = $aece01d762aa979a$var$Equation.DEFAULT_RELAXATION;
    /**
     * The Jacobian entry of this equation. 6 numbers, 3 per body (x,y,angle).
     * @property G
     * @type {Array}
     */ this.G = new $dMz05.ARRAY_TYPE(6);
    for(var i = 0; i < 6; i++)this.G[i] = 0;
    this.offset = 0;
    this.a = 0;
    this.b = 0;
    this.epsilon = 0;
    this.timeStep = 1 / 60;
    /**
     * Indicates if stiffness or relaxation was changed.
     * @property {Boolean} needsUpdate
     */ this.needsUpdate = true;
    /**
     * The resulting constraint multiplier from the last solve. This is mostly equivalent to the force produced by the constraint.
     * @property multiplier
     * @type {Number}
     */ this.multiplier = 0;
    /**
     * Relative velocity.
     * @property {Number} relativeVelocity
     */ this.relativeVelocity = 0;
    /**
     * Whether this equation is enabled or not. If true, it will be added to the solver.
     * @property {Boolean} enabled
     */ this.enabled = true;
}
$aece01d762aa979a$var$Equation.prototype.constructor = $aece01d762aa979a$var$Equation;
/**
 * The default stiffness when creating a new Equation.
 * @static
 * @property {Number} DEFAULT_STIFFNESS
 * @default 1e6
 */ $aece01d762aa979a$var$Equation.DEFAULT_STIFFNESS = 1e6;
/**
 * The default relaxation when creating a new Equation.
 * @static
 * @property {Number} DEFAULT_RELAXATION
 * @default 4
 */ $aece01d762aa979a$var$Equation.DEFAULT_RELAXATION = 4;
/**
 * Compute SPOOK parameters .a, .b and .epsilon according to the current parameters. See equations 9, 10 and 11 in the <a href="http://www8.cs.umu.se/kurser/5DV058/VT09/lectures/spooknotes.pdf">SPOOK notes</a>.
 * @method update
 */ $aece01d762aa979a$var$Equation.prototype.update = function() {
    var k = this.stiffness, d = this.relaxation, h = this.timeStep;
    this.a = 4.0 / (h * (1 + 4 * d));
    this.b = 4.0 * d / (1 + 4 * d);
    this.epsilon = 4.0 / (h * h * k * (1 + 4 * d));
    this.needsUpdate = false;
};
/**
 * Multiply a jacobian entry with corresponding positions or velocities
 * @method gmult
 * @return {Number}
 */ $aece01d762aa979a$var$Equation.prototype.gmult = function(G, vi, wi, vj, wj) {
    return G[0] * vi[0] + G[1] * vi[1] + G[2] * wi + G[3] * vj[0] + G[4] * vj[1] + G[5] * wj;
};
/**
 * Computes the RHS of the SPOOK equation
 * @method computeB
 * @return {Number}
 */ $aece01d762aa979a$var$Equation.prototype.computeB = function(a, b, h) {
    var GW = this.computeGW();
    var Gq = this.computeGq();
    var GiMf = this.computeGiMf();
    return -Gq * a - GW * b - GiMf * h;
};
/**
 * Computes G\*q, where q are the generalized body coordinates
 * @method computeGq
 * @return {Number}
 */ var $aece01d762aa979a$var$qi = $2Ys9z.create(), $aece01d762aa979a$var$qj = $2Ys9z.create();
$aece01d762aa979a$var$Equation.prototype.computeGq = function() {
    var G = this.G, bi = this.bodyA, bj = this.bodyB, xi = bi.position, xj = bj.position, ai = bi.angle, aj = bj.angle;
    return this.gmult(G, $aece01d762aa979a$var$qi, ai, $aece01d762aa979a$var$qj, aj) + this.offset;
};
/**
 * Computes G\*W, where W are the body velocities
 * @method computeGW
 * @return {Number}
 */ $aece01d762aa979a$var$Equation.prototype.computeGW = function() {
    var G = this.G, bi = this.bodyA, bj = this.bodyB, vi = bi.velocity, vj = bj.velocity, wi = bi.angularVelocity, wj = bj.angularVelocity;
    return this.gmult(G, vi, wi, vj, wj) + this.relativeVelocity;
};
/**
 * Computes G\*Wlambda, where W are the body velocities
 * @method computeGWlambda
 * @return {Number}
 */ $aece01d762aa979a$var$Equation.prototype.computeGWlambda = function() {
    var G = this.G, bi = this.bodyA, bj = this.bodyB, vi = bi.vlambda, vj = bj.vlambda, wi = bi.wlambda, wj = bj.wlambda;
    return this.gmult(G, vi, wi, vj, wj);
};
/**
 * Computes G\*inv(M)\*f, where M is the mass matrix with diagonal blocks for each body, and f are the forces on the bodies.
 * @method computeGiMf
 * @return {Number}
 */ var $aece01d762aa979a$var$iMfi = $2Ys9z.create(), $aece01d762aa979a$var$iMfj = $2Ys9z.create();
$aece01d762aa979a$var$Equation.prototype.computeGiMf = function() {
    var bi = this.bodyA, bj = this.bodyB, fi = bi.force, ti = bi.angularForce, fj = bj.force, tj = bj.angularForce, invMassi = bi.invMassSolve, invMassj = bj.invMassSolve, invIi = bi.invInertiaSolve, invIj = bj.invInertiaSolve, G = this.G;
    $2Ys9z.scale($aece01d762aa979a$var$iMfi, fi, invMassi);
    $2Ys9z.multiply($aece01d762aa979a$var$iMfi, bi.massMultiplier, $aece01d762aa979a$var$iMfi);
    $2Ys9z.scale($aece01d762aa979a$var$iMfj, fj, invMassj);
    $2Ys9z.multiply($aece01d762aa979a$var$iMfj, bj.massMultiplier, $aece01d762aa979a$var$iMfj);
    return this.gmult(G, $aece01d762aa979a$var$iMfi, ti * invIi, $aece01d762aa979a$var$iMfj, tj * invIj);
};
/**
 * Computes G\*inv(M)\*G'
 * @method computeGiMGt
 * @return {Number}
 */ $aece01d762aa979a$var$Equation.prototype.computeGiMGt = function() {
    var bi = this.bodyA, bj = this.bodyB, invMassi = bi.invMassSolve, invMassj = bj.invMassSolve, invIi = bi.invInertiaSolve, invIj = bj.invInertiaSolve, G = this.G;
    return G[0] * G[0] * invMassi * bi.massMultiplier[0] + G[1] * G[1] * invMassi * bi.massMultiplier[1] + G[2] * G[2] * invIi + G[3] * G[3] * invMassj * bj.massMultiplier[0] + G[4] * G[4] * invMassj * bj.massMultiplier[1] + G[5] * G[5] * invIj;
};
var $aece01d762aa979a$var$addToWlambda_temp = $2Ys9z.create(), $aece01d762aa979a$var$addToWlambda_Gi = $2Ys9z.create(), $aece01d762aa979a$var$addToWlambda_Gj = $2Ys9z.create(), $aece01d762aa979a$var$addToWlambda_ri = $2Ys9z.create(), $aece01d762aa979a$var$addToWlambda_rj = $2Ys9z.create(), $aece01d762aa979a$var$addToWlambda_Mdiag = $2Ys9z.create();
/**
 * Add constraint velocity to the bodies.
 * @method addToWlambda
 * @param {Number} deltalambda
 */ $aece01d762aa979a$var$Equation.prototype.addToWlambda = function(deltalambda) {
    var bi = this.bodyA, bj = this.bodyB, temp = $aece01d762aa979a$var$addToWlambda_temp, Gi = $aece01d762aa979a$var$addToWlambda_Gi, Gj = $aece01d762aa979a$var$addToWlambda_Gj, ri = $aece01d762aa979a$var$addToWlambda_ri, rj = $aece01d762aa979a$var$addToWlambda_rj, invMassi = bi.invMassSolve, invMassj = bj.invMassSolve, invIi = bi.invInertiaSolve, invIj = bj.invInertiaSolve, Mdiag = $aece01d762aa979a$var$addToWlambda_Mdiag, G = this.G;
    Gi[0] = G[0];
    Gi[1] = G[1];
    Gj[0] = G[3];
    Gj[1] = G[4];
    // Add to linear velocity
    // v_lambda += inv(M) * delta_lamba * G
    $2Ys9z.scale(temp, Gi, invMassi * deltalambda);
    $2Ys9z.multiply(temp, temp, bi.massMultiplier);
    $2Ys9z.add(bi.vlambda, bi.vlambda, temp);
    // This impulse is in the offset frame
    // Also add contribution to angular
    //bi.wlambda -= vec2.crossLength(temp,ri);
    bi.wlambda += invIi * G[2] * deltalambda;
    $2Ys9z.scale(temp, Gj, invMassj * deltalambda);
    $2Ys9z.multiply(temp, temp, bj.massMultiplier);
    $2Ys9z.add(bj.vlambda, bj.vlambda, temp);
    //bj.wlambda -= vec2.crossLength(temp,rj);
    bj.wlambda += invIj * G[5] * deltalambda;
};
/**
 * Compute the denominator part of the SPOOK equation: C = G\*inv(M)\*G' + eps
 * @method computeInvC
 * @param  {Number} eps
 * @return {Number}
 */ $aece01d762aa979a$var$Equation.prototype.computeInvC = function(eps) {
    return 1.0 / (this.computeGiMGt() + eps);
};

});
parcelRegister("e7hLo", function(module, exports) {

var $2Ys9z = parcelRequire("2Ys9z");

var $32CtG = parcelRequire("32CtG");

var $clDtn = parcelRequire("clDtn");

var $ZlKj0 = parcelRequire("ZlKj0");

var $l9ZUH = parcelRequire("l9ZUH");

var $hkl1e = parcelRequire("hkl1e");

var $5POlg = parcelRequire("5POlg");
module.exports = $a46f7f8fe64db8b3$var$Body;
/**
 * A rigid body. Has got a center of mass, position, velocity and a number of
 * shapes that are used for collisions.
 *
 * @class Body
 * @constructor
 * @extends EventEmitter
 * @param {Object} [options]
 * @param {Array} [options.force]
 * @param {Array} [options.position]
 * @param {Array} [options.velocity]
 * @param {Boolean} [options.allowSleep]
 * @param {Boolean} [options.collisionResponse]
 * @param {Number} [options.angle=0]
 * @param {Number} [options.angularForce=0]
 * @param {Number} [options.angularVelocity=0]
 * @param {Number} [options.ccdIterations=10]
 * @param {Number} [options.ccdSpeedThreshold=-1]
 * @param {Number} [options.fixedRotation=false]
 * @param {Number} [options.gravityScale]
 * @param {Number} [options.id]
 * @param {Number} [options.mass=0] A number >= 0. If zero, the .type will be set to Body.STATIC.
 * @param {Number} [options.sleepSpeedLimit]
 * @param {Number} [options.sleepTimeLimit]
 *
 * @example
 *
 *     // Create a typical dynamic body
 *     var body = new Body({
 *         mass: 1,
 *         position: [0, 0],
 *         angle: 0,
 *         velocity: [0, 0],
 *         angularVelocity: 0
 *     });
 *
 *     // Add a circular shape to the body
 *     body.addShape(new Circle({ radius: 1 }));
 *
 *     // Add the body to the world
 *     world.addBody(body);
 */ function $a46f7f8fe64db8b3$var$Body(options) {
    options = options || {};
    $5POlg.call(this);
    /**
     * The body identifyer
     * @property id
     * @type {Number}
     */ this.id = options.id || ++$a46f7f8fe64db8b3$var$Body._idCounter;
    /**
     * The world that this body is added to. This property is set to NULL if the body is not added to any world.
     * @property world
     * @type {World}
     */ this.world = null;
    /**
     * The shapes of the body.
     *
     * @property shapes
     * @type {Array}
     */ this.shapes = [];
    /**
     * The mass of the body.
     * @property mass
     * @type {number}
     */ this.mass = options.mass || 0;
    /**
     * The inverse mass of the body.
     * @property invMass
     * @type {number}
     */ this.invMass = 0;
    /**
     * The inertia of the body around the Z axis.
     * @property inertia
     * @type {number}
     */ this.inertia = 0;
    /**
     * The inverse inertia of the body.
     * @property invInertia
     * @type {number}
     */ this.invInertia = 0;
    this.invMassSolve = 0;
    this.invInertiaSolve = 0;
    /**
     * Set to true if you want to fix the rotation of the body.
     * @property fixedRotation
     * @type {Boolean}
     */ this.fixedRotation = !!options.fixedRotation;
    /**
     * Set to true if you want to fix the body movement along the X axis. The body will still be able to move along Y.
     * @property {Boolean} fixedX
     */ this.fixedX = !!options.fixedX;
    /**
     * Set to true if you want to fix the body movement along the Y axis. The body will still be able to move along X.
     * @property {Boolean} fixedY
     */ this.fixedY = !!options.fixedY;
    /**
     * @private
     * @property {array} massMultiplier
     */ this.massMultiplier = $2Ys9z.create();
    /**
     * The position of the body
     * @property position
     * @type {Array}
     */ this.position = $2Ys9z.fromValues(0, 0);
    if (options.position) $2Ys9z.copy(this.position, options.position);
    /**
     * The interpolated position of the body. Use this for rendering.
     * @property interpolatedPosition
     * @type {Array}
     */ this.interpolatedPosition = $2Ys9z.fromValues(0, 0);
    /**
     * The interpolated angle of the body. Use this for rendering.
     * @property interpolatedAngle
     * @type {Number}
     */ this.interpolatedAngle = 0;
    /**
     * The previous position of the body.
     * @property previousPosition
     * @type {Array}
     */ this.previousPosition = $2Ys9z.fromValues(0, 0);
    /**
     * The previous angle of the body.
     * @property previousAngle
     * @type {Number}
     */ this.previousAngle = 0;
    /**
     * The current velocity of the body.
     * @property velocity
     * @type {Array}
     */ this.velocity = $2Ys9z.fromValues(0, 0);
    if (options.velocity) $2Ys9z.copy(this.velocity, options.velocity);
    /**
     * Constraint velocity that was added to the body during the last step.
     * @property vlambda
     * @type {Array}
     */ this.vlambda = $2Ys9z.fromValues(0, 0);
    /**
     * Angular constraint velocity that was added to the body during last step.
     * @property wlambda
     * @type {Array}
     */ this.wlambda = 0;
    /**
     * The angle of the body, in radians.
     * @property angle
     * @type {number}
     * @example
     *     // The angle property is not normalized to the interval 0 to 2*pi, it can be any value.
     *     // If you need a value between 0 and 2*pi, use the following function to normalize it.
     *     function normalizeAngle(angle){
     *         angle = angle % (2*Math.PI);
     *         if(angle < 0){
     *             angle += (2*Math.PI);
     *         }
     *         return angle;
     *     }
     */ this.angle = options.angle || 0;
    /**
     * The angular velocity of the body, in radians per second.
     * @property angularVelocity
     * @type {number}
     */ this.angularVelocity = options.angularVelocity || 0;
    /**
     * The force acting on the body. Since the body force (and {{#crossLink "Body/angularForce:property"}}{{/crossLink}}) will be zeroed after each step, so you need to set the force before each step.
     * @property force
     * @type {Array}
     *
     * @example
     *     // This produces a forcefield of 1 Newton in the positive x direction.
     *     for(var i=0; i<numSteps; i++){
     *         body.force[0] = 1;
     *         world.step(1/60);
     *     }
     *
     * @example
     *     // This will apply a rotational force on the body
     *     for(var i=0; i<numSteps; i++){
     *         body.angularForce = -3;
     *         world.step(1/60);
     *     }
     */ this.force = $2Ys9z.create();
    if (options.force) $2Ys9z.copy(this.force, options.force);
    /**
     * The angular force acting on the body. See {{#crossLink "Body/force:property"}}{{/crossLink}}.
     * @property angularForce
     * @type {number}
     */ this.angularForce = options.angularForce || 0;
    /**
     * The linear damping acting on the body in the velocity direction. Should be a value between 0 and 1.
     * @property damping
     * @type {Number}
     * @default 0.1
     */ this.damping = typeof options.damping === "number" ? options.damping : 0.1;
    /**
     * The angular force acting on the body. Should be a value between 0 and 1.
     * @property angularDamping
     * @type {Number}
     * @default 0.1
     */ this.angularDamping = typeof options.angularDamping === "number" ? options.angularDamping : 0.1;
    /**
     * The type of motion this body has. Should be one of: {{#crossLink "Body/STATIC:property"}}Body.STATIC{{/crossLink}}, {{#crossLink "Body/DYNAMIC:property"}}Body.DYNAMIC{{/crossLink}} and {{#crossLink "Body/KINEMATIC:property"}}Body.KINEMATIC{{/crossLink}}.
     *
     * * Static bodies do not move, and they do not respond to forces or collision.
     * * Dynamic bodies body can move and respond to collisions and forces.
     * * Kinematic bodies only moves according to its .velocity, and does not respond to collisions or force.
     *
     * @property type
     * @type {number}
     *
     * @example
     *     // Bodies are static by default. Static bodies will never move.
     *     var body = new Body();
     *     console.log(body.type == Body.STATIC); // true
     *
     * @example
     *     // By setting the mass of a body to a nonzero number, the body
     *     // will become dynamic and will move and interact with other bodies.
     *     var dynamicBody = new Body({
     *         mass : 1
     *     });
     *     console.log(dynamicBody.type == Body.DYNAMIC); // true
     *
     * @example
     *     // Kinematic bodies will only move if you change their velocity.
     *     var kinematicBody = new Body({
     *         type: Body.KINEMATIC // Type can be set via the options object.
     *     });
     */ this.type = $a46f7f8fe64db8b3$var$Body.STATIC;
    if (typeof options.type !== "undefined") this.type = options.type;
    else if (!options.mass) this.type = $a46f7f8fe64db8b3$var$Body.STATIC;
    else this.type = $a46f7f8fe64db8b3$var$Body.DYNAMIC;
    /**
     * Bounding circle radius.
     * @property boundingRadius
     * @type {Number}
     */ this.boundingRadius = 0;
    /**
     * Bounding box of this body.
     * @property aabb
     * @type {AABB}
     */ this.aabb = new $hkl1e();
    /**
     * Indicates if the AABB needs update. Update it with {{#crossLink "Body/updateAABB:method"}}.updateAABB(){{/crossLink}}.
     * @property aabbNeedsUpdate
     * @type {Boolean}
     * @see updateAABB
     *
     * @example
     *     // Force update the AABB
     *     body.aabbNeedsUpdate = true;
     *     body.updateAABB();
     *     console.log(body.aabbNeedsUpdate); // false
     */ this.aabbNeedsUpdate = true;
    /**
     * If true, the body will automatically fall to sleep. Note that you need to enable sleeping in the {{#crossLink "World"}}{{/crossLink}} before anything will happen.
     * @property allowSleep
     * @type {Boolean}
     * @default true
     */ this.allowSleep = options.allowSleep !== undefined ? options.allowSleep : true;
    this.wantsToSleep = false;
    /**
     * One of {{#crossLink "Body/AWAKE:property"}}Body.AWAKE{{/crossLink}}, {{#crossLink "Body/SLEEPY:property"}}Body.SLEEPY{{/crossLink}} and {{#crossLink "Body/SLEEPING:property"}}Body.SLEEPING{{/crossLink}}.
     *
     * The body is initially Body.AWAKE. If its velocity norm is below .sleepSpeedLimit, the sleepState will become Body.SLEEPY. If the body continues to be Body.SLEEPY for .sleepTimeLimit seconds, it will fall asleep (Body.SLEEPY).
     *
     * @property sleepState
     * @type {Number}
     * @default Body.AWAKE
     */ this.sleepState = $a46f7f8fe64db8b3$var$Body.AWAKE;
    /**
     * If the speed (the norm of the velocity) is smaller than this value, the body is considered sleepy.
     * @property sleepSpeedLimit
     * @type {Number}
     * @default 0.2
     */ this.sleepSpeedLimit = options.sleepSpeedLimit !== undefined ? options.sleepSpeedLimit : 0.2;
    /**
     * If the body has been sleepy for this sleepTimeLimit seconds, it is considered sleeping.
     * @property sleepTimeLimit
     * @type {Number}
     * @default 1
     */ this.sleepTimeLimit = options.sleepTimeLimit !== undefined ? options.sleepTimeLimit : 1;
    /**
     * Gravity scaling factor. If you want the body to ignore gravity, set this to zero. If you want to reverse gravity, set it to -1.
     * @property {Number} gravityScale
     * @default 1
     */ this.gravityScale = options.gravityScale !== undefined ? options.gravityScale : 1;
    /**
     * Whether to produce contact forces when in contact with other bodies. Note that contacts will be generated, but they will be disabled. That means that this body will move through other bodies, but it will still trigger contact events, etc.
     * @property {Boolean} collisionResponse
     */ this.collisionResponse = options.collisionResponse !== undefined ? options.collisionResponse : true;
    /**
     * How long the body has been sleeping.
     * @property {Number} idleTime
     */ this.idleTime = 0;
    /**
     * The last time when the body went to SLEEPY state.
     * @property {Number} timeLastSleepy
     * @private
     */ this.timeLastSleepy = 0;
    /**
     * If the body speed exceeds this threshold, CCD (continuous collision detection) will be enabled. Set it to a negative number to disable CCD completely for this body.
     * @property {number} ccdSpeedThreshold
     * @default -1
     */ this.ccdSpeedThreshold = options.ccdSpeedThreshold !== undefined ? options.ccdSpeedThreshold : -1;
    /**
     * The number of iterations that should be used when searching for the time of impact during CCD. A larger number will assure that there's a small penetration on CCD collision, but a small number will give more performance.
     * @property {number} ccdIterations
     * @default 10
     */ this.ccdIterations = options.ccdIterations !== undefined ? options.ccdIterations : 10;
    this.concavePath = null;
    this._wakeUpAfterNarrowphase = false;
    this.updateMassProperties();
}
$a46f7f8fe64db8b3$var$Body.prototype = new $5POlg();
$a46f7f8fe64db8b3$var$Body.prototype.constructor = $a46f7f8fe64db8b3$var$Body;
$a46f7f8fe64db8b3$var$Body._idCounter = 0;
/**
 * @private
 * @method updateSolveMassProperties
 */ $a46f7f8fe64db8b3$var$Body.prototype.updateSolveMassProperties = function() {
    if (this.sleepState === $a46f7f8fe64db8b3$var$Body.SLEEPING || this.type === $a46f7f8fe64db8b3$var$Body.KINEMATIC) {
        this.invMassSolve = 0;
        this.invInertiaSolve = 0;
    } else {
        this.invMassSolve = this.invMass;
        this.invInertiaSolve = this.invInertia;
    }
};
/**
 * Set the total density of the body
 * @method setDensity
 * @param {number} density
 */ $a46f7f8fe64db8b3$var$Body.prototype.setDensity = function(density) {
    var totalArea = this.getArea();
    this.mass = totalArea * density;
    this.updateMassProperties();
};
/**
 * Get the total area of all shapes in the body
 * @method getArea
 * @return {Number}
 */ $a46f7f8fe64db8b3$var$Body.prototype.getArea = function() {
    var totalArea = 0;
    for(var i = 0; i < this.shapes.length; i++)totalArea += this.shapes[i].area;
    return totalArea;
};
/**
 * Get the AABB from the body. The AABB is updated if necessary.
 * @method getAABB
 * @return {AABB} The AABB instance (this.aabb)
 */ $a46f7f8fe64db8b3$var$Body.prototype.getAABB = function() {
    if (this.aabbNeedsUpdate) this.updateAABB();
    return this.aabb;
};
var $a46f7f8fe64db8b3$var$shapeAABB = new $hkl1e(), $a46f7f8fe64db8b3$var$tmp = $2Ys9z.create();
/**
 * Updates the AABB of the Body, and set .aabbNeedsUpdate = false.
 * @method updateAABB
 */ $a46f7f8fe64db8b3$var$Body.prototype.updateAABB = function() {
    var shapes = this.shapes, N = shapes.length, offset = $a46f7f8fe64db8b3$var$tmp, bodyAngle = this.angle;
    for(var i = 0; i !== N; i++){
        var shape = shapes[i], angle = shape.angle + bodyAngle;
        // Get shape world offset
        $2Ys9z.rotate(offset, shape.position, bodyAngle);
        $2Ys9z.add(offset, offset, this.position);
        // Get shape AABB
        shape.computeAABB($a46f7f8fe64db8b3$var$shapeAABB, offset, angle);
        if (i === 0) this.aabb.copy($a46f7f8fe64db8b3$var$shapeAABB);
        else this.aabb.extend($a46f7f8fe64db8b3$var$shapeAABB);
    }
    this.aabbNeedsUpdate = false;
};
/**
 * Update the bounding radius of the body (this.boundingRadius). Should be done if any of the shape dimensions or positions are changed.
 * @method updateBoundingRadius
 */ $a46f7f8fe64db8b3$var$Body.prototype.updateBoundingRadius = function() {
    var shapes = this.shapes, N = shapes.length, radius = 0;
    for(var i = 0; i !== N; i++){
        var shape = shapes[i], offset = $2Ys9z.length(shape.position), r = shape.boundingRadius;
        if (offset + r > radius) radius = offset + r;
    }
    this.boundingRadius = radius;
};
/**
 * Add a shape to the body. You can pass a local transform when adding a shape,
 * so that the shape gets an offset and angle relative to the body center of mass.
 * Will automatically update the mass properties and bounding radius.
 *
 * @method addShape
 * @param  {Shape}              shape
 * @param  {Array} [offset] Local body offset of the shape.
 * @param  {Number}             [angle]  Local body angle.
 *
 * @example
 *     var body = new Body(),
 *         shape = new Circle({ radius: 1 });
 *
 *     // Add the shape to the body, positioned in the center
 *     body.addShape(shape);
 *
 *     // Add another shape to the body, positioned 1 unit length from the body center of mass along the local x-axis.
 *     body.addShape(shape,[1,0]);
 *
 *     // Add another shape to the body, positioned 1 unit length from the body center of mass along the local y-axis, and rotated 90 degrees CCW.
 *     body.addShape(shape,[0,1],Math.PI/2);
 */ $a46f7f8fe64db8b3$var$Body.prototype.addShape = function(shape, offset, angle) {
    if (shape.body) throw new Error("A shape can only be added to one body.");
    shape.body = this;
    // Copy the offset vector
    if (offset) $2Ys9z.copy(shape.position, offset);
    else $2Ys9z.set(shape.position, 0, 0);
    shape.angle = angle || 0;
    this.shapes.push(shape);
    this.updateMassProperties();
    this.updateBoundingRadius();
    this.aabbNeedsUpdate = true;
};
/**
 * Remove a shape
 * @method removeShape
 * @param  {Shape} shape
 * @return {Boolean} True if the shape was found and removed, else false.
 */ $a46f7f8fe64db8b3$var$Body.prototype.removeShape = function(shape) {
    var idx = this.shapes.indexOf(shape);
    if (idx !== -1) {
        this.shapes.splice(idx, 1);
        this.aabbNeedsUpdate = true;
        shape.body = null;
        return true;
    } else return false;
};
/**
 * Updates .inertia, .invMass, .invInertia for this Body. Should be called when
 * changing the structure or mass of the Body.
 *
 * @method updateMassProperties
 *
 * @example
 *     body.mass += 1;
 *     body.updateMassProperties();
 */ $a46f7f8fe64db8b3$var$Body.prototype.updateMassProperties = function() {
    if (this.type === $a46f7f8fe64db8b3$var$Body.STATIC || this.type === $a46f7f8fe64db8b3$var$Body.KINEMATIC) {
        this.mass = Number.MAX_VALUE;
        this.invMass = 0;
        this.inertia = Number.MAX_VALUE;
        this.invInertia = 0;
    } else {
        var shapes = this.shapes, N = shapes.length, m = this.mass / N, I = 0;
        if (!this.fixedRotation) {
            for(var i = 0; i < N; i++){
                var shape = shapes[i], r2 = $2Ys9z.squaredLength(shape.position), Icm = shape.computeMomentOfInertia(m);
                I += Icm + m * r2;
            }
            this.inertia = I;
            this.invInertia = I > 0 ? 1 / I : 0;
        } else {
            this.inertia = Number.MAX_VALUE;
            this.invInertia = 0;
        }
        // Inverse mass properties are easy
        this.invMass = 1 / this.mass;
        $2Ys9z.set(this.massMultiplier, this.fixedX ? 0 : 1, this.fixedY ? 0 : 1);
    }
};
var $a46f7f8fe64db8b3$var$Body_applyForce_r = $2Ys9z.create();
/**
 * Apply force to a point relative to the center of mass of the body. This could for example be a point on the RigidBody surface. Applying force this way will add to Body.force and Body.angularForce. If relativePoint is zero, the force will be applied directly on the center of mass, and the torque produced will be zero.
 * @method applyForce
 * @param {Array} force The force to add.
 * @param {Array} [relativePoint] A world point to apply the force on.
 */ $a46f7f8fe64db8b3$var$Body.prototype.applyForce = function(force, relativePoint) {
    // Add linear force
    $2Ys9z.add(this.force, this.force, force);
    if (relativePoint) {
        // Compute produced rotational force
        var rotForce = $2Ys9z.crossLength(relativePoint, force);
        // Add rotational force
        this.angularForce += rotForce;
    }
};
/**
 * Apply force to a body-local point.
 * @method applyForceLocal
 * @param  {Array} localForce The force vector to add, oriented in local body space.
 * @param  {Array} [localPoint] A point relative to the body in world space. If not given, it is set to zero and all of the impulse will be excerted on the center of mass.
 */ var $a46f7f8fe64db8b3$var$Body_applyForce_forceWorld = $2Ys9z.create();
var $a46f7f8fe64db8b3$var$Body_applyForce_pointWorld = $2Ys9z.create();
var $a46f7f8fe64db8b3$var$Body_applyForce_pointLocal = $2Ys9z.create();
$a46f7f8fe64db8b3$var$Body.prototype.applyForceLocal = function(localForce, localPoint) {
    localPoint = localPoint || $a46f7f8fe64db8b3$var$Body_applyForce_pointLocal;
    var worldForce = $a46f7f8fe64db8b3$var$Body_applyForce_forceWorld;
    var worldPoint = $a46f7f8fe64db8b3$var$Body_applyForce_pointWorld;
    this.vectorToWorldFrame(worldForce, localForce);
    this.vectorToWorldFrame(worldPoint, localPoint);
    this.applyForce(worldForce, worldPoint);
};
/**
 * Apply impulse to a point relative to the body. This could for example be a point on the Body surface. An impulse is a force added to a body during a short period of time (impulse = force * time). Impulses will be added to Body.velocity and Body.angularVelocity.
 * @method applyImpulse
 * @param  {Array} impulse The impulse vector to add, oriented in world space.
 * @param  {Array} [relativePoint] A point relative to the body in world space. If not given, it is set to zero and all of the impulse will be excerted on the center of mass.
 */ var $a46f7f8fe64db8b3$var$Body_applyImpulse_velo = $2Ys9z.create();
$a46f7f8fe64db8b3$var$Body.prototype.applyImpulse = function(impulseVector, relativePoint) {
    if (this.type !== $a46f7f8fe64db8b3$var$Body.DYNAMIC) return;
    // Compute produced central impulse velocity
    var velo = $a46f7f8fe64db8b3$var$Body_applyImpulse_velo;
    $2Ys9z.scale(velo, impulseVector, this.invMass);
    $2Ys9z.multiply(velo, this.massMultiplier, velo);
    // Add linear impulse
    $2Ys9z.add(this.velocity, velo, this.velocity);
    if (relativePoint) {
        // Compute produced rotational impulse velocity
        var rotVelo = $2Ys9z.crossLength(relativePoint, impulseVector);
        rotVelo *= this.invInertia;
        // Add rotational Impulse
        this.angularVelocity += rotVelo;
    }
};
/**
 * Apply impulse to a point relative to the body. This could for example be a point on the Body surface. An impulse is a force added to a body during a short period of time (impulse = force * time). Impulses will be added to Body.velocity and Body.angularVelocity.
 * @method applyImpulseLocal
 * @param  {Array} impulse The impulse vector to add, oriented in world space.
 * @param  {Array} [relativePoint] A point relative to the body in world space. If not given, it is set to zero and all of the impulse will be excerted on the center of mass.
 */ var $a46f7f8fe64db8b3$var$Body_applyImpulse_impulseWorld = $2Ys9z.create();
var $a46f7f8fe64db8b3$var$Body_applyImpulse_pointWorld = $2Ys9z.create();
var $a46f7f8fe64db8b3$var$Body_applyImpulse_pointLocal = $2Ys9z.create();
$a46f7f8fe64db8b3$var$Body.prototype.applyImpulseLocal = function(localImpulse, localPoint) {
    localPoint = localPoint || $a46f7f8fe64db8b3$var$Body_applyImpulse_pointLocal;
    var worldImpulse = $a46f7f8fe64db8b3$var$Body_applyImpulse_impulseWorld;
    var worldPoint = $a46f7f8fe64db8b3$var$Body_applyImpulse_pointWorld;
    this.vectorToWorldFrame(worldImpulse, localImpulse);
    this.vectorToWorldFrame(worldPoint, localPoint);
    this.applyImpulse(worldImpulse, worldPoint);
};
/**
 * Transform a world point to local body frame.
 * @method toLocalFrame
 * @param  {Array} out          The vector to store the result in
 * @param  {Array} worldPoint   The input world point
 */ $a46f7f8fe64db8b3$var$Body.prototype.toLocalFrame = function(out, worldPoint) {
    $2Ys9z.toLocalFrame(out, worldPoint, this.position, this.angle);
};
/**
 * Transform a local point to world frame.
 * @method toWorldFrame
 * @param  {Array} out          The vector to store the result in
 * @param  {Array} localPoint   The input local point
 */ $a46f7f8fe64db8b3$var$Body.prototype.toWorldFrame = function(out, localPoint) {
    $2Ys9z.toGlobalFrame(out, localPoint, this.position, this.angle);
};
/**
 * Transform a world point to local body frame.
 * @method vectorToLocalFrame
 * @param  {Array} out          The vector to store the result in
 * @param  {Array} worldVector  The input world vector
 */ $a46f7f8fe64db8b3$var$Body.prototype.vectorToLocalFrame = function(out, worldVector) {
    $2Ys9z.vectorToLocalFrame(out, worldVector, this.angle);
};
/**
 * Transform a local point to world frame.
 * @method vectorToWorldFrame
 * @param  {Array} out          The vector to store the result in
 * @param  {Array} localVector  The input local vector
 */ $a46f7f8fe64db8b3$var$Body.prototype.vectorToWorldFrame = function(out, localVector) {
    $2Ys9z.vectorToGlobalFrame(out, localVector, this.angle);
};
/**
 * Reads a polygon shape path, and assembles convex shapes from that and puts them at proper offset points.
 * @method fromPolygon
 * @param {Array} path An array of 2d vectors, e.g. [[0,0],[0,1],...] that resembles a concave or convex polygon. The shape must be simple and without holes.
 * @param {Object} [options]
 * @param {Boolean} [options.optimalDecomp=false]   Set to true if you need optimal decomposition. Warning: very slow for polygons with more than 10 vertices.
 * @param {Boolean} [options.skipSimpleCheck=false] Set to true if you already know that the path is not intersecting itself.
 * @param {Boolean|Number} [options.removeCollinearPoints=false] Set to a number (angle threshold value) to remove collinear points, or false to keep all points.
 * @return {Boolean} True on success, else false.
 */ $a46f7f8fe64db8b3$var$Body.prototype.fromPolygon = function(path, options) {
    options = options || {};
    // Remove all shapes
    for(var i = this.shapes.length; i >= 0; --i)this.removeShape(this.shapes[i]);
    var p = new $32CtG.Polygon();
    p.vertices = path;
    // Make it counter-clockwise
    p.makeCCW();
    if (typeof options.removeCollinearPoints === "number") p.removeCollinearPoints(options.removeCollinearPoints);
    // Check if any line segment intersects the path itself
    if (typeof options.skipSimpleCheck === "undefined") {
        if (!p.isSimple()) return false;
    }
    // Save this path for later
    this.concavePath = p.vertices.slice(0);
    for(var i = 0; i < this.concavePath.length; i++){
        var v = [
            0,
            0
        ];
        $2Ys9z.copy(v, this.concavePath[i]);
        this.concavePath[i] = v;
    }
    // Slow or fast decomp?
    var convexes;
    if (options.optimalDecomp) convexes = p.decomp();
    else convexes = p.quickDecomp();
    var cm = $2Ys9z.create();
    // Add convexes
    for(var i = 0; i !== convexes.length; i++){
        // Create convex
        var c = new $clDtn({
            vertices: convexes[i].vertices
        });
        // Move all vertices so its center of mass is in the local center of the convex
        for(var j = 0; j !== c.vertices.length; j++){
            var v = c.vertices[j];
            $2Ys9z.sub(v, v, c.centerOfMass);
        }
        $2Ys9z.scale(cm, c.centerOfMass, 1);
        c.updateTriangles();
        c.updateCenterOfMass();
        c.updateBoundingRadius();
        // Add the shape
        this.addShape(c, cm);
    }
    this.adjustCenterOfMass();
    this.aabbNeedsUpdate = true;
    return true;
};
var $a46f7f8fe64db8b3$var$adjustCenterOfMass_tmp1 = $2Ys9z.fromValues(0, 0), $a46f7f8fe64db8b3$var$adjustCenterOfMass_tmp2 = $2Ys9z.fromValues(0, 0), $a46f7f8fe64db8b3$var$adjustCenterOfMass_tmp3 = $2Ys9z.fromValues(0, 0), $a46f7f8fe64db8b3$var$adjustCenterOfMass_tmp4 = $2Ys9z.fromValues(0, 0);
/**
 * Moves the shape offsets so their center of mass becomes the body center of mass.
 * @method adjustCenterOfMass
 */ $a46f7f8fe64db8b3$var$Body.prototype.adjustCenterOfMass = function() {
    var offset_times_area = $a46f7f8fe64db8b3$var$adjustCenterOfMass_tmp2, sum = $a46f7f8fe64db8b3$var$adjustCenterOfMass_tmp3, cm = $a46f7f8fe64db8b3$var$adjustCenterOfMass_tmp4, totalArea = 0;
    $2Ys9z.set(sum, 0, 0);
    for(var i = 0; i !== this.shapes.length; i++){
        var s = this.shapes[i];
        $2Ys9z.scale(offset_times_area, s.position, s.area);
        $2Ys9z.add(sum, sum, offset_times_area);
        totalArea += s.area;
    }
    $2Ys9z.scale(cm, sum, 1 / totalArea);
    // Now move all shapes
    for(var i = 0; i !== this.shapes.length; i++){
        var s = this.shapes[i];
        $2Ys9z.sub(s.position, s.position, cm);
    }
    // Move the body position too
    $2Ys9z.add(this.position, this.position, cm);
    // And concave path
    for(var i = 0; this.concavePath && i < this.concavePath.length; i++)$2Ys9z.sub(this.concavePath[i], this.concavePath[i], cm);
    this.updateMassProperties();
    this.updateBoundingRadius();
};
/**
 * Sets the force on the body to zero.
 * @method setZeroForce
 */ $a46f7f8fe64db8b3$var$Body.prototype.setZeroForce = function() {
    $2Ys9z.set(this.force, 0.0, 0.0);
    this.angularForce = 0.0;
};
$a46f7f8fe64db8b3$var$Body.prototype.resetConstraintVelocity = function() {
    var b = this, vlambda = b.vlambda;
    $2Ys9z.set(vlambda, 0, 0);
    b.wlambda = 0;
};
$a46f7f8fe64db8b3$var$Body.prototype.addConstraintVelocity = function() {
    var b = this, v = b.velocity;
    $2Ys9z.add(v, v, b.vlambda);
    b.angularVelocity += b.wlambda;
};
/**
 * Apply damping, see <a href="http://code.google.com/p/bullet/issues/detail?id=74">this</a> for details.
 * @method applyDamping
 * @param  {number} dt Current time step
 */ $a46f7f8fe64db8b3$var$Body.prototype.applyDamping = function(dt) {
    if (this.type === $a46f7f8fe64db8b3$var$Body.DYNAMIC) {
        var v = this.velocity;
        $2Ys9z.scale(v, v, Math.pow(1.0 - this.damping, dt));
        this.angularVelocity *= Math.pow(1.0 - this.angularDamping, dt);
    }
};
/**
 * Wake the body up. Normally you should not need this, as the body is automatically awoken at events such as collisions.
 * Sets the sleepState to {{#crossLink "Body/AWAKE:property"}}Body.AWAKE{{/crossLink}} and emits the wakeUp event if the body wasn't awake before.
 * @method wakeUp
 */ $a46f7f8fe64db8b3$var$Body.prototype.wakeUp = function() {
    var s = this.sleepState;
    this.sleepState = $a46f7f8fe64db8b3$var$Body.AWAKE;
    this.idleTime = 0;
    if (s !== $a46f7f8fe64db8b3$var$Body.AWAKE) this.emit($a46f7f8fe64db8b3$var$Body.wakeUpEvent);
};
/**
 * Force body sleep
 * @method sleep
 */ $a46f7f8fe64db8b3$var$Body.prototype.sleep = function() {
    this.sleepState = $a46f7f8fe64db8b3$var$Body.SLEEPING;
    this.angularVelocity = 0;
    this.angularForce = 0;
    $2Ys9z.set(this.velocity, 0, 0);
    $2Ys9z.set(this.force, 0, 0);
    this.emit($a46f7f8fe64db8b3$var$Body.sleepEvent);
};
/**
 * Called every timestep to update internal sleep timer and change sleep state if needed.
 * @method sleepTick
 * @param {number} time The world time in seconds
 * @param {boolean} dontSleep
 * @param {number} dt
 */ $a46f7f8fe64db8b3$var$Body.prototype.sleepTick = function(time, dontSleep, dt) {
    if (!this.allowSleep || this.type === $a46f7f8fe64db8b3$var$Body.SLEEPING) return;
    this.wantsToSleep = false;
    var sleepState = this.sleepState, speedSquared = $2Ys9z.squaredLength(this.velocity) + Math.pow(this.angularVelocity, 2), speedLimitSquared = Math.pow(this.sleepSpeedLimit, 2);
    // Add to idle time
    if (speedSquared >= speedLimitSquared) {
        this.idleTime = 0;
        this.sleepState = $a46f7f8fe64db8b3$var$Body.AWAKE;
    } else {
        this.idleTime += dt;
        this.sleepState = $a46f7f8fe64db8b3$var$Body.SLEEPY;
    }
    if (this.idleTime > this.sleepTimeLimit) {
        if (!dontSleep) this.sleep();
        else this.wantsToSleep = true;
    }
};
/**
 * Check if the body is overlapping another body. Note that this method only works if the body was added to a World and if at least one step was taken.
 * @method overlaps
 * @param  {Body} body
 * @return {boolean}
 */ $a46f7f8fe64db8b3$var$Body.prototype.overlaps = function(body) {
    return this.world.overlapKeeper.bodiesAreOverlapping(this, body);
};
var $a46f7f8fe64db8b3$var$integrate_fhMinv = $2Ys9z.create();
var $a46f7f8fe64db8b3$var$integrate_velodt = $2Ys9z.create();
/**
 * Move the body forward in time given its current velocity.
 * @method integrate
 * @param  {Number} dt
 */ $a46f7f8fe64db8b3$var$Body.prototype.integrate = function(dt) {
    var minv = this.invMass, f = this.force, pos = this.position, velo = this.velocity;
    // Save old position
    $2Ys9z.copy(this.previousPosition, this.position);
    this.previousAngle = this.angle;
    // Velocity update
    if (!this.fixedRotation) this.angularVelocity += this.angularForce * this.invInertia * dt;
    $2Ys9z.scale($a46f7f8fe64db8b3$var$integrate_fhMinv, f, dt * minv);
    $2Ys9z.multiply($a46f7f8fe64db8b3$var$integrate_fhMinv, this.massMultiplier, $a46f7f8fe64db8b3$var$integrate_fhMinv);
    $2Ys9z.add(velo, $a46f7f8fe64db8b3$var$integrate_fhMinv, velo);
    // CCD
    if (!this.integrateToTimeOfImpact(dt)) {
        // Regular position update
        $2Ys9z.scale($a46f7f8fe64db8b3$var$integrate_velodt, velo, dt);
        $2Ys9z.add(pos, pos, $a46f7f8fe64db8b3$var$integrate_velodt);
        if (!this.fixedRotation) this.angle += this.angularVelocity * dt;
    }
    this.aabbNeedsUpdate = true;
};
var $a46f7f8fe64db8b3$var$result = new $ZlKj0();
var $a46f7f8fe64db8b3$var$ray = new $l9ZUH({
    mode: $l9ZUH.ALL
});
var $a46f7f8fe64db8b3$var$direction = $2Ys9z.create();
var $a46f7f8fe64db8b3$var$end = $2Ys9z.create();
var $a46f7f8fe64db8b3$var$startToEnd = $2Ys9z.create();
var $a46f7f8fe64db8b3$var$rememberPosition = $2Ys9z.create();
$a46f7f8fe64db8b3$var$Body.prototype.integrateToTimeOfImpact = function(dt) {
    if (this.ccdSpeedThreshold < 0 || $2Ys9z.squaredLength(this.velocity) < Math.pow(this.ccdSpeedThreshold, 2)) return false;
    $2Ys9z.normalize($a46f7f8fe64db8b3$var$direction, this.velocity);
    $2Ys9z.scale($a46f7f8fe64db8b3$var$end, this.velocity, dt);
    $2Ys9z.add($a46f7f8fe64db8b3$var$end, $a46f7f8fe64db8b3$var$end, this.position);
    $2Ys9z.sub($a46f7f8fe64db8b3$var$startToEnd, $a46f7f8fe64db8b3$var$end, this.position);
    var startToEndAngle = this.angularVelocity * dt;
    var len = $2Ys9z.length($a46f7f8fe64db8b3$var$startToEnd);
    var timeOfImpact = 1;
    var hit;
    var that = this;
    $a46f7f8fe64db8b3$var$result.reset();
    $a46f7f8fe64db8b3$var$ray.callback = function(result) {
        if (result.body === that) return;
        hit = result.body;
        result.getHitPoint($a46f7f8fe64db8b3$var$end, $a46f7f8fe64db8b3$var$ray);
        $2Ys9z.sub($a46f7f8fe64db8b3$var$startToEnd, $a46f7f8fe64db8b3$var$end, that.position);
        timeOfImpact = $2Ys9z.length($a46f7f8fe64db8b3$var$startToEnd) / len;
        result.stop();
    };
    $2Ys9z.copy($a46f7f8fe64db8b3$var$ray.from, this.position);
    $2Ys9z.copy($a46f7f8fe64db8b3$var$ray.to, $a46f7f8fe64db8b3$var$end);
    $a46f7f8fe64db8b3$var$ray.update();
    this.world.raycast($a46f7f8fe64db8b3$var$result, $a46f7f8fe64db8b3$var$ray);
    if (!hit) return false;
    var rememberAngle = this.angle;
    $2Ys9z.copy($a46f7f8fe64db8b3$var$rememberPosition, this.position);
    // Got a start and end point. Approximate time of impact using binary search
    var iter = 0;
    var tmin = 0;
    var tmid = 0;
    var tmax = timeOfImpact;
    while(tmax >= tmin && iter < this.ccdIterations){
        iter++;
        // calculate the midpoint
        tmid = (tmax - tmin) / 2;
        // Move the body to that point
        $2Ys9z.scale($a46f7f8fe64db8b3$var$integrate_velodt, $a46f7f8fe64db8b3$var$startToEnd, timeOfImpact);
        $2Ys9z.add(this.position, $a46f7f8fe64db8b3$var$rememberPosition, $a46f7f8fe64db8b3$var$integrate_velodt);
        this.angle = rememberAngle + startToEndAngle * timeOfImpact;
        this.updateAABB();
        // check overlap
        var overlaps = this.aabb.overlaps(hit.aabb) && this.world.narrowphase.bodiesOverlap(this, hit);
        if (overlaps) // change min to search upper interval
        tmin = tmid;
        else // change max to search lower interval
        tmax = tmid;
    }
    timeOfImpact = tmid;
    $2Ys9z.copy(this.position, $a46f7f8fe64db8b3$var$rememberPosition);
    this.angle = rememberAngle;
    // move to TOI
    $2Ys9z.scale($a46f7f8fe64db8b3$var$integrate_velodt, $a46f7f8fe64db8b3$var$startToEnd, timeOfImpact);
    $2Ys9z.add(this.position, this.position, $a46f7f8fe64db8b3$var$integrate_velodt);
    if (!this.fixedRotation) this.angle += startToEndAngle * timeOfImpact;
    return true;
};
/**
 * Get velocity of a point in the body.
 * @method getVelocityAtPoint
 * @param  {Array} result A vector to store the result in
 * @param  {Array} relativePoint A world oriented vector, indicating the position of the point to get the velocity from
 * @return {Array} The result vector
 */ $a46f7f8fe64db8b3$var$Body.prototype.getVelocityAtPoint = function(result, relativePoint) {
    $2Ys9z.crossVZ(result, relativePoint, this.angularVelocity);
    $2Ys9z.subtract(result, this.velocity, result);
    return result;
};
/**
 * @event sleepy
 */ $a46f7f8fe64db8b3$var$Body.sleepyEvent = {
    type: "sleepy"
};
/**
 * @event sleep
 */ $a46f7f8fe64db8b3$var$Body.sleepEvent = {
    type: "sleep"
};
/**
 * @event wakeup
 */ $a46f7f8fe64db8b3$var$Body.wakeUpEvent = {
    type: "wakeup"
};
/**
 * Dynamic body.
 * @property DYNAMIC
 * @type {Number}
 * @static
 */ $a46f7f8fe64db8b3$var$Body.DYNAMIC = 1;
/**
 * Static body.
 * @property STATIC
 * @type {Number}
 * @static
 */ $a46f7f8fe64db8b3$var$Body.STATIC = 2;
/**
 * Kinematic body.
 * @property KINEMATIC
 * @type {Number}
 * @static
 */ $a46f7f8fe64db8b3$var$Body.KINEMATIC = 4;
/**
 * @property AWAKE
 * @type {Number}
 * @static
 */ $a46f7f8fe64db8b3$var$Body.AWAKE = 0;
/**
 * @property SLEEPY
 * @type {Number}
 * @static
 */ $a46f7f8fe64db8b3$var$Body.SLEEPY = 1;
/**
 * @property SLEEPING
 * @type {Number}
 * @static
 */ $a46f7f8fe64db8b3$var$Body.SLEEPING = 2;

});
parcelRegister("32CtG", function(module, exports) {


module.exports = {
    Polygon: (parcelRequire("78CTm")),
    Point: (parcelRequire("7IHg3"))
};

});
parcelRegister("78CTm", function(module, exports) {

var $f7pMh = parcelRequire("f7pMh");

var $7IHg3 = parcelRequire("7IHg3");

var $apnUg = parcelRequire("apnUg");
module.exports = $532772ddca37032b$var$Polygon;
/**
 * Polygon class.
 * @class Polygon
 * @constructor
 */ function $532772ddca37032b$var$Polygon() {
    /**
     * Vertices that this polygon consists of. An array of array of numbers, example: [[0,0],[1,0],..]
     * @property vertices
     * @type {Array}
     */ this.vertices = [];
}
/**
 * Get a vertex at position i. It does not matter if i is out of bounds, this function will just cycle.
 * @method at
 * @param  {Number} i
 * @return {Array}
 */ $532772ddca37032b$var$Polygon.prototype.at = function(i) {
    var v = this.vertices, s = v.length;
    return v[i < 0 ? i % s + s : i % s];
};
/**
 * Get first vertex
 * @method first
 * @return {Array}
 */ $532772ddca37032b$var$Polygon.prototype.first = function() {
    return this.vertices[0];
};
/**
 * Get last vertex
 * @method last
 * @return {Array}
 */ $532772ddca37032b$var$Polygon.prototype.last = function() {
    return this.vertices[this.vertices.length - 1];
};
/**
 * Clear the polygon data
 * @method clear
 * @return {Array}
 */ $532772ddca37032b$var$Polygon.prototype.clear = function() {
    this.vertices.length = 0;
};
/**
 * Append points "from" to "to"-1 from an other polygon "poly" onto this one.
 * @method append
 * @param {Polygon} poly The polygon to get points from.
 * @param {Number}  from The vertex index in "poly".
 * @param {Number}  to The end vertex index in "poly". Note that this vertex is NOT included when appending.
 * @return {Array}
 */ $532772ddca37032b$var$Polygon.prototype.append = function(poly, from, to) {
    if (typeof from == "undefined") throw new Error("From is not given!");
    if (typeof to == "undefined") throw new Error("To is not given!");
    if (to - 1 < from) throw new Error("lol1");
    if (to > poly.vertices.length) throw new Error("lol2");
    if (from < 0) throw new Error("lol3");
    for(var i = from; i < to; i++)this.vertices.push(poly.vertices[i]);
};
/**
 * Make sure that the polygon vertices are ordered counter-clockwise.
 * @method makeCCW
 */ $532772ddca37032b$var$Polygon.prototype.makeCCW = function() {
    var br = 0, v = this.vertices;
    // find bottom right point
    for(var i = 1; i < this.vertices.length; ++i)if (v[i][1] < v[br][1] || v[i][1] == v[br][1] && v[i][0] > v[br][0]) br = i;
    // reverse poly if clockwise
    if (!$7IHg3.left(this.at(br - 1), this.at(br), this.at(br + 1))) this.reverse();
};
/**
 * Reverse the vertices in the polygon
 * @method reverse
 */ $532772ddca37032b$var$Polygon.prototype.reverse = function() {
    var tmp = [];
    for(var i = 0, N = this.vertices.length; i !== N; i++)tmp.push(this.vertices.pop());
    this.vertices = tmp;
};
/**
 * Check if a point in the polygon is a reflex point
 * @method isReflex
 * @param  {Number}  i
 * @return {Boolean}
 */ $532772ddca37032b$var$Polygon.prototype.isReflex = function(i) {
    return $7IHg3.right(this.at(i - 1), this.at(i), this.at(i + 1));
};
var $532772ddca37032b$var$tmpLine1 = [], $532772ddca37032b$var$tmpLine2 = [];
/**
 * Check if two vertices in the polygon can see each other
 * @method canSee
 * @param  {Number} a Vertex index 1
 * @param  {Number} b Vertex index 2
 * @return {Boolean}
 */ $532772ddca37032b$var$Polygon.prototype.canSee = function(a, b) {
    var p, dist, l1 = $532772ddca37032b$var$tmpLine1, l2 = $532772ddca37032b$var$tmpLine2;
    if ($7IHg3.leftOn(this.at(a + 1), this.at(a), this.at(b)) && $7IHg3.rightOn(this.at(a - 1), this.at(a), this.at(b))) return false;
    dist = $7IHg3.sqdist(this.at(a), this.at(b));
    for(var i = 0; i !== this.vertices.length; ++i){
        if ((i + 1) % this.vertices.length === a || i === a) continue;
        if ($7IHg3.leftOn(this.at(a), this.at(b), this.at(i + 1)) && $7IHg3.rightOn(this.at(a), this.at(b), this.at(i))) {
            l1[0] = this.at(a);
            l1[1] = this.at(b);
            l2[0] = this.at(i);
            l2[1] = this.at(i + 1);
            p = $f7pMh.lineInt(l1, l2);
            if ($7IHg3.sqdist(this.at(a), p) < dist) return false;
        }
    }
    return true;
};
/**
 * Copy the polygon from vertex i to vertex j.
 * @method copy
 * @param  {Number} i
 * @param  {Number} j
 * @param  {Polygon} [targetPoly]   Optional target polygon to save in.
 * @return {Polygon}                The resulting copy.
 */ $532772ddca37032b$var$Polygon.prototype.copy = function(i, j, targetPoly) {
    var p = targetPoly || new $532772ddca37032b$var$Polygon();
    p.clear();
    if (i < j) // Insert all vertices from i to j
    for(var k = i; k <= j; k++)p.vertices.push(this.vertices[k]);
    else {
        // Insert vertices 0 to j
        for(var k = 0; k <= j; k++)p.vertices.push(this.vertices[k]);
        // Insert vertices i to end
        for(var k = i; k < this.vertices.length; k++)p.vertices.push(this.vertices[k]);
    }
    return p;
};
/**
 * Decomposes the polygon into convex pieces. Returns a list of edges [[p1,p2],[p2,p3],...] that cuts the polygon.
 * Note that this algorithm has complexity O(N^4) and will be very slow for polygons with many vertices.
 * @method getCutEdges
 * @return {Array}
 */ $532772ddca37032b$var$Polygon.prototype.getCutEdges = function() {
    var min = [], tmp1 = [], tmp2 = [], tmpPoly = new $532772ddca37032b$var$Polygon();
    var nDiags = Number.MAX_VALUE;
    for(var i = 0; i < this.vertices.length; ++i)if (this.isReflex(i)) {
        for(var j = 0; j < this.vertices.length; ++j)if (this.canSee(i, j)) {
            tmp1 = this.copy(i, j, tmpPoly).getCutEdges();
            tmp2 = this.copy(j, i, tmpPoly).getCutEdges();
            for(var k = 0; k < tmp2.length; k++)tmp1.push(tmp2[k]);
            if (tmp1.length < nDiags) {
                min = tmp1;
                nDiags = tmp1.length;
                min.push([
                    this.at(i),
                    this.at(j)
                ]);
            }
        }
    }
    return min;
};
/**
 * Decomposes the polygon into one or more convex sub-Polygons.
 * @method decomp
 * @return {Array} An array or Polygon objects.
 */ $532772ddca37032b$var$Polygon.prototype.decomp = function() {
    var edges = this.getCutEdges();
    if (edges.length > 0) return this.slice(edges);
    else return [
        this
    ];
};
/**
 * Slices the polygon given one or more cut edges. If given one, this function will return two polygons (false on failure). If many, an array of polygons.
 * @method slice
 * @param {Array} cutEdges A list of edges, as returned by .getCutEdges()
 * @return {Array}
 */ $532772ddca37032b$var$Polygon.prototype.slice = function(cutEdges) {
    if (cutEdges.length == 0) return [
        this
    ];
    if (cutEdges instanceof Array && cutEdges.length && cutEdges[0] instanceof Array && cutEdges[0].length == 2 && cutEdges[0][0] instanceof Array) {
        var polys = [
            this
        ];
        for(var i = 0; i < cutEdges.length; i++){
            var cutEdge = cutEdges[i];
            // Cut all polys
            for(var j = 0; j < polys.length; j++){
                var poly = polys[j];
                var result = poly.slice(cutEdge);
                if (result) {
                    // Found poly! Cut and quit
                    polys.splice(j, 1);
                    polys.push(result[0], result[1]);
                    break;
                }
            }
        }
        return polys;
    } else {
        // Was given one edge
        var cutEdge = cutEdges;
        var i = this.vertices.indexOf(cutEdge[0]);
        var j = this.vertices.indexOf(cutEdge[1]);
        if (i != -1 && j != -1) return [
            this.copy(i, j),
            this.copy(j, i)
        ];
        else return false;
    }
};
/**
 * Checks that the line segments of this polygon do not intersect each other.
 * @method isSimple
 * @param  {Array} path An array of vertices e.g. [[0,0],[0,1],...]
 * @return {Boolean}
 * @todo Should it check all segments with all others?
 */ $532772ddca37032b$var$Polygon.prototype.isSimple = function() {
    var path = this.vertices;
    // Check
    for(var i = 0; i < path.length - 1; i++)for(var j = 0; j < i - 1; j++){
        if ($f7pMh.segmentsIntersect(path[i], path[i + 1], path[j], path[j + 1])) return false;
    }
    // Check the segment between the last and the first point to all others
    for(var i = 1; i < path.length - 2; i++){
        if ($f7pMh.segmentsIntersect(path[0], path[path.length - 1], path[i], path[i + 1])) return false;
    }
    return true;
};
function $532772ddca37032b$var$getIntersectionPoint(p1, p2, q1, q2, delta) {
    delta = delta || 0;
    var a1 = p2[1] - p1[1];
    var b1 = p1[0] - p2[0];
    var c1 = a1 * p1[0] + b1 * p1[1];
    var a2 = q2[1] - q1[1];
    var b2 = q1[0] - q2[0];
    var c2 = a2 * q1[0] + b2 * q1[1];
    var det = a1 * b2 - a2 * b1;
    if (!$apnUg.eq(det, 0, delta)) return [
        (b2 * c1 - b1 * c2) / det,
        (a1 * c2 - a2 * c1) / det
    ];
    else return [
        0,
        0
    ];
}
/**
 * Quickly decompose the Polygon into convex sub-polygons.
 * @method quickDecomp
 * @param  {Array} result
 * @param  {Array} [reflexVertices]
 * @param  {Array} [steinerPoints]
 * @param  {Number} [delta]
 * @param  {Number} [maxlevel]
 * @param  {Number} [level]
 * @return {Array}
 */ $532772ddca37032b$var$Polygon.prototype.quickDecomp = function(result, reflexVertices, steinerPoints, delta, maxlevel, level) {
    maxlevel = maxlevel || 100;
    level = level || 0;
    delta = delta || 25;
    result = typeof result != "undefined" ? result : [];
    reflexVertices = reflexVertices || [];
    steinerPoints = steinerPoints || [];
    var upperInt = [
        0,
        0
    ], lowerInt = [
        0,
        0
    ], p = [
        0,
        0
    ]; // Points
    var upperDist = 0, lowerDist = 0, d = 0, closestDist = 0; // scalars
    var upperIndex = 0, lowerIndex = 0, closestIndex = 0; // Integers
    var lowerPoly = new $532772ddca37032b$var$Polygon(), upperPoly = new $532772ddca37032b$var$Polygon(); // polygons
    var poly = this, v = this.vertices;
    if (v.length < 3) return result;
    level++;
    if (level > maxlevel) {
        console.warn("quickDecomp: max level (" + maxlevel + ") reached.");
        return result;
    }
    for(var i = 0; i < this.vertices.length; ++i)if (poly.isReflex(i)) {
        reflexVertices.push(poly.vertices[i]);
        upperDist = lowerDist = Number.MAX_VALUE;
        for(var j = 0; j < this.vertices.length; ++j){
            if ($7IHg3.left(poly.at(i - 1), poly.at(i), poly.at(j)) && $7IHg3.rightOn(poly.at(i - 1), poly.at(i), poly.at(j - 1))) {
                p = $532772ddca37032b$var$getIntersectionPoint(poly.at(i - 1), poly.at(i), poly.at(j), poly.at(j - 1)); // find the point of intersection
                if ($7IHg3.right(poly.at(i + 1), poly.at(i), p)) {
                    d = $7IHg3.sqdist(poly.vertices[i], p);
                    if (d < lowerDist) {
                        lowerDist = d;
                        lowerInt = p;
                        lowerIndex = j;
                    }
                }
            }
            if ($7IHg3.left(poly.at(i + 1), poly.at(i), poly.at(j + 1)) && $7IHg3.rightOn(poly.at(i + 1), poly.at(i), poly.at(j))) {
                p = $532772ddca37032b$var$getIntersectionPoint(poly.at(i + 1), poly.at(i), poly.at(j), poly.at(j + 1));
                if ($7IHg3.left(poly.at(i - 1), poly.at(i), p)) {
                    d = $7IHg3.sqdist(poly.vertices[i], p);
                    if (d < upperDist) {
                        upperDist = d;
                        upperInt = p;
                        upperIndex = j;
                    }
                }
            }
        }
        // if there are no vertices to connect to, choose a point in the middle
        if (lowerIndex == (upperIndex + 1) % this.vertices.length) {
            //console.log("Case 1: Vertex("+i+"), lowerIndex("+lowerIndex+"), upperIndex("+upperIndex+"), poly.size("+this.vertices.length+")");
            p[0] = (lowerInt[0] + upperInt[0]) / 2;
            p[1] = (lowerInt[1] + upperInt[1]) / 2;
            steinerPoints.push(p);
            if (i < upperIndex) {
                //lowerPoly.insert(lowerPoly.end(), poly.begin() + i, poly.begin() + upperIndex + 1);
                lowerPoly.append(poly, i, upperIndex + 1);
                lowerPoly.vertices.push(p);
                upperPoly.vertices.push(p);
                if (lowerIndex != 0) //upperPoly.insert(upperPoly.end(), poly.begin() + lowerIndex, poly.end());
                upperPoly.append(poly, lowerIndex, poly.vertices.length);
                //upperPoly.insert(upperPoly.end(), poly.begin(), poly.begin() + i + 1);
                upperPoly.append(poly, 0, i + 1);
            } else {
                if (i != 0) //lowerPoly.insert(lowerPoly.end(), poly.begin() + i, poly.end());
                lowerPoly.append(poly, i, poly.vertices.length);
                //lowerPoly.insert(lowerPoly.end(), poly.begin(), poly.begin() + upperIndex + 1);
                lowerPoly.append(poly, 0, upperIndex + 1);
                lowerPoly.vertices.push(p);
                upperPoly.vertices.push(p);
                //upperPoly.insert(upperPoly.end(), poly.begin() + lowerIndex, poly.begin() + i + 1);
                upperPoly.append(poly, lowerIndex, i + 1);
            }
        } else {
            // connect to the closest point within the triangle
            //console.log("Case 2: Vertex("+i+"), closestIndex("+closestIndex+"), poly.size("+this.vertices.length+")\n");
            if (lowerIndex > upperIndex) upperIndex += this.vertices.length;
            closestDist = Number.MAX_VALUE;
            if (upperIndex < lowerIndex) return result;
            for(var j = lowerIndex; j <= upperIndex; ++j)if ($7IHg3.leftOn(poly.at(i - 1), poly.at(i), poly.at(j)) && $7IHg3.rightOn(poly.at(i + 1), poly.at(i), poly.at(j))) {
                d = $7IHg3.sqdist(poly.at(i), poly.at(j));
                if (d < closestDist) {
                    closestDist = d;
                    closestIndex = j % this.vertices.length;
                }
            }
            if (i < closestIndex) {
                lowerPoly.append(poly, i, closestIndex + 1);
                if (closestIndex != 0) upperPoly.append(poly, closestIndex, v.length);
                upperPoly.append(poly, 0, i + 1);
            } else {
                if (i != 0) lowerPoly.append(poly, i, v.length);
                lowerPoly.append(poly, 0, closestIndex + 1);
                upperPoly.append(poly, closestIndex, i + 1);
            }
        }
        // solve smallest poly first
        if (lowerPoly.vertices.length < upperPoly.vertices.length) {
            lowerPoly.quickDecomp(result, reflexVertices, steinerPoints, delta, maxlevel, level);
            upperPoly.quickDecomp(result, reflexVertices, steinerPoints, delta, maxlevel, level);
        } else {
            upperPoly.quickDecomp(result, reflexVertices, steinerPoints, delta, maxlevel, level);
            lowerPoly.quickDecomp(result, reflexVertices, steinerPoints, delta, maxlevel, level);
        }
        return result;
    }
    result.push(this);
    return result;
};
/**
 * Remove collinear points in the polygon.
 * @method removeCollinearPoints
 * @param  {Number} [precision] The threshold angle to use when determining whether two edges are collinear. Use zero for finest precision.
 * @return {Number}           The number of points removed
 */ $532772ddca37032b$var$Polygon.prototype.removeCollinearPoints = function(precision) {
    var num = 0;
    for(var i = this.vertices.length - 1; this.vertices.length > 3 && i >= 0; --i)if ($7IHg3.collinear(this.at(i - 1), this.at(i), this.at(i + 1), precision)) {
        // Remove the middle point
        this.vertices.splice(i % this.vertices.length, 1);
        i--; // Jump one point forward. Otherwise we may get a chain removal
        num++;
    }
    return num;
};

});
parcelRegister("f7pMh", function(module, exports) {

var $apnUg = parcelRequire("apnUg");
module.exports = $b01b816442074f61$var$Line;
/**
 * Container for line-related functions
 * @class Line
 */ function $b01b816442074f61$var$Line() {}
/**
 * Compute the intersection between two lines.
 * @static
 * @method lineInt
 * @param  {Array}  l1          Line vector 1
 * @param  {Array}  l2          Line vector 2
 * @param  {Number} precision   Precision to use when checking if the lines are parallel
 * @return {Array}              The intersection point.
 */ $b01b816442074f61$var$Line.lineInt = function(l1, l2, precision) {
    precision = precision || 0;
    var i = [
        0,
        0
    ]; // point
    var a1, b1, c1, a2, b2, c2, det; // scalars
    a1 = l1[1][1] - l1[0][1];
    b1 = l1[0][0] - l1[1][0];
    c1 = a1 * l1[0][0] + b1 * l1[0][1];
    a2 = l2[1][1] - l2[0][1];
    b2 = l2[0][0] - l2[1][0];
    c2 = a2 * l2[0][0] + b2 * l2[0][1];
    det = a1 * b2 - a2 * b1;
    if (!$apnUg.eq(det, 0, precision)) {
        i[0] = (b2 * c1 - b1 * c2) / det;
        i[1] = (a1 * c2 - a2 * c1) / det;
    }
    return i;
};
/**
 * Checks if two line segments intersects.
 * @method segmentsIntersect
 * @param {Array} p1 The start vertex of the first line segment.
 * @param {Array} p2 The end vertex of the first line segment.
 * @param {Array} q1 The start vertex of the second line segment.
 * @param {Array} q2 The end vertex of the second line segment.
 * @return {Boolean} True if the two line segments intersect
 */ $b01b816442074f61$var$Line.segmentsIntersect = function(p1, p2, q1, q2) {
    var dx = p2[0] - p1[0];
    var dy = p2[1] - p1[1];
    var da = q2[0] - q1[0];
    var db = q2[1] - q1[1];
    // segments are parallel
    if (da * dy - db * dx == 0) return false;
    var s = (dx * (q1[1] - p1[1]) + dy * (p1[0] - q1[0])) / (da * dy - db * dx);
    var t = (da * (p1[1] - q1[1]) + db * (q1[0] - p1[0])) / (db * dx - da * dy);
    return s >= 0 && s <= 1 && t >= 0 && t <= 1;
};

});
parcelRegister("apnUg", function(module, exports) {
module.exports = $793ec888c2787a2f$var$Scalar;
/**
 * Scalar functions
 * @class Scalar
 */ function $793ec888c2787a2f$var$Scalar() {}
/**
 * Check if two scalars are equal
 * @static
 * @method eq
 * @param  {Number} a
 * @param  {Number} b
 * @param  {Number} [precision]
 * @return {Boolean}
 */ $793ec888c2787a2f$var$Scalar.eq = function(a, b, precision) {
    precision = precision || 0;
    return Math.abs(a - b) < precision;
};

});


parcelRegister("7IHg3", function(module, exports) {
module.exports = $59ee32917f9611c0$var$Point;
/**
 * Point related functions
 * @class Point
 */ function $59ee32917f9611c0$var$Point() {}
/**
 * Get the area of a triangle spanned by the three given points. Note that the area will be negative if the points are not given in counter-clockwise order.
 * @static
 * @method area
 * @param  {Array} a
 * @param  {Array} b
 * @param  {Array} c
 * @return {Number}
 */ $59ee32917f9611c0$var$Point.area = function(a, b, c) {
    return (b[0] - a[0]) * (c[1] - a[1]) - (c[0] - a[0]) * (b[1] - a[1]);
};
$59ee32917f9611c0$var$Point.left = function(a, b, c) {
    return $59ee32917f9611c0$var$Point.area(a, b, c) > 0;
};
$59ee32917f9611c0$var$Point.leftOn = function(a, b, c) {
    return $59ee32917f9611c0$var$Point.area(a, b, c) >= 0;
};
$59ee32917f9611c0$var$Point.right = function(a, b, c) {
    return $59ee32917f9611c0$var$Point.area(a, b, c) < 0;
};
$59ee32917f9611c0$var$Point.rightOn = function(a, b, c) {
    return $59ee32917f9611c0$var$Point.area(a, b, c) <= 0;
};
var $59ee32917f9611c0$var$tmpPoint1 = [], $59ee32917f9611c0$var$tmpPoint2 = [];
/**
 * Check if three points are collinear
 * @method collinear
 * @param  {Array} a
 * @param  {Array} b
 * @param  {Array} c
 * @param  {Number} [thresholdAngle=0] Threshold angle to use when comparing the vectors. The function will return true if the angle between the resulting vectors is less than this value. Use zero for max precision.
 * @return {Boolean}
 */ $59ee32917f9611c0$var$Point.collinear = function(a, b, c, thresholdAngle) {
    if (!thresholdAngle) return $59ee32917f9611c0$var$Point.area(a, b, c) == 0;
    else {
        var ab = $59ee32917f9611c0$var$tmpPoint1, bc = $59ee32917f9611c0$var$tmpPoint2;
        ab[0] = b[0] - a[0];
        ab[1] = b[1] - a[1];
        bc[0] = c[0] - b[0];
        bc[1] = c[1] - b[1];
        var dot = ab[0] * bc[0] + ab[1] * bc[1], magA = Math.sqrt(ab[0] * ab[0] + ab[1] * ab[1]), magB = Math.sqrt(bc[0] * bc[0] + bc[1] * bc[1]), angle = Math.acos(dot / (magA * magB));
        return angle < thresholdAngle;
    }
};
$59ee32917f9611c0$var$Point.sqdist = function(a, b) {
    var dx = b[0] - a[0];
    var dy = b[1] - a[1];
    return dx * dx + dy * dy;
};

});



parcelRegister("clDtn", function(module, exports) {

var $k7z01 = parcelRequire("k7z01");

var $2Ys9z = parcelRequire("2Ys9z");

var $cm0Cz = parcelRequire("cm0Cz");
parcelRequire("32CtG");
module.exports = $8fd610a91dec4c33$var$Convex;
/**
 * Convex shape class.
 * @class Convex
 * @constructor
 * @extends Shape
 * @param {object} [options] (Note that this options object will be passed on to the {{#crossLink "Shape"}}{{/crossLink}} constructor.)
 * @param {Array} [options.vertices] An array of vertices that span this shape. Vertices are given in counter-clockwise (CCW) direction.
 * @param {Array} [options.axes] An array of unit length vectors, representing the symmetry axes in the convex.
 * @example
 *     // Create a box
 *     var vertices = [[-1,-1], [1,-1], [1,1], [-1,1]];
 *     var convexShape = new Convex({ vertices: vertices });
 *     body.addShape(convexShape);
 */ function $8fd610a91dec4c33$var$Convex(options) {
    if (Array.isArray(arguments[0])) {
        options = {
            vertices: arguments[0],
            axes: arguments[1]
        };
        console.warn("The Convex constructor signature has changed. Please use the following format: new Convex({ vertices: [...], ... })");
    }
    options = options || {};
    /**
     * Vertices defined in the local frame.
     * @property vertices
     * @type {Array}
     */ this.vertices = [];
    // Copy the verts
    var vertices = options.vertices !== undefined ? options.vertices : [];
    for(var i = 0; i < vertices.length; i++){
        var v = $2Ys9z.create();
        $2Ys9z.copy(v, vertices[i]);
        this.vertices.push(v);
    }
    /**
     * Axes defined in the local frame.
     * @property axes
     * @type {Array}
     */ this.axes = [];
    if (options.axes) // Copy the axes
    for(var i = 0; i < options.axes.length; i++){
        var axis = $2Ys9z.create();
        $2Ys9z.copy(axis, options.axes[i]);
        this.axes.push(axis);
    }
    else // Construct axes from the vertex data
    for(var i = 0; i < this.vertices.length; i++){
        // Get the world edge
        var worldPoint0 = this.vertices[i];
        var worldPoint1 = this.vertices[(i + 1) % this.vertices.length];
        var normal = $2Ys9z.create();
        $2Ys9z.sub(normal, worldPoint1, worldPoint0);
        // Get normal - just rotate 90 degrees since vertices are given in CCW
        $2Ys9z.rotate90cw(normal, normal);
        $2Ys9z.normalize(normal, normal);
        this.axes.push(normal);
    }
    /**
     * The center of mass of the Convex
     * @property centerOfMass
     * @type {Array}
     */ this.centerOfMass = $2Ys9z.fromValues(0, 0);
    /**
     * Triangulated version of this convex. The structure is Array of 3-Arrays, and each subarray contains 3 integers, referencing the vertices.
     * @property triangles
     * @type {Array}
     */ this.triangles = [];
    if (this.vertices.length) {
        this.updateTriangles();
        this.updateCenterOfMass();
    }
    /**
     * The bounding radius of the convex
     * @property boundingRadius
     * @type {Number}
     */ this.boundingRadius = 0;
    options.type = $k7z01.CONVEX;
    $k7z01.call(this, options);
    this.updateBoundingRadius();
    this.updateArea();
    if (this.area < 0) throw new Error("Convex vertices must be given in conter-clockwise winding.");
}
$8fd610a91dec4c33$var$Convex.prototype = new $k7z01();
$8fd610a91dec4c33$var$Convex.prototype.constructor = $8fd610a91dec4c33$var$Convex;
var $8fd610a91dec4c33$var$tmpVec1 = $2Ys9z.create();
var $8fd610a91dec4c33$var$tmpVec2 = $2Ys9z.create();
/**
 * Project a Convex onto a world-oriented axis
 * @method projectOntoAxis
 * @static
 * @param  {Array} offset
 * @param  {Array} localAxis
 * @param  {Array} result
 */ $8fd610a91dec4c33$var$Convex.prototype.projectOntoLocalAxis = function(localAxis, result) {
    var max = null, min = null, v, value, localAxis = $8fd610a91dec4c33$var$tmpVec1;
    // Get projected position of all vertices
    for(var i = 0; i < this.vertices.length; i++){
        v = this.vertices[i];
        value = $2Ys9z.dot(v, localAxis);
        if (max === null || value > max) max = value;
        if (min === null || value < min) min = value;
    }
    if (min > max) {
        var t = min;
        min = max;
        max = t;
    }
    $2Ys9z.set(result, min, max);
};
$8fd610a91dec4c33$var$Convex.prototype.projectOntoWorldAxis = function(localAxis, shapeOffset, shapeAngle, result) {
    var worldAxis = $8fd610a91dec4c33$var$tmpVec2;
    this.projectOntoLocalAxis(localAxis, result);
    // Project the position of the body onto the axis - need to add this to the result
    if (shapeAngle !== 0) $2Ys9z.rotate(worldAxis, localAxis, shapeAngle);
    else worldAxis = localAxis;
    var offset = $2Ys9z.dot(shapeOffset, worldAxis);
    $2Ys9z.set(result, result[0] + offset, result[1] + offset);
};
/**
 * Update the .triangles property
 * @method updateTriangles
 */ $8fd610a91dec4c33$var$Convex.prototype.updateTriangles = function() {
    this.triangles.length = 0;
    // Rewrite on polyk notation, array of numbers
    var polykVerts = [];
    for(var i = 0; i < this.vertices.length; i++){
        var v = this.vertices[i];
        polykVerts.push(v[0], v[1]);
    }
    // Triangulate
    var triangles = $cm0Cz.Triangulate(polykVerts);
    // Loop over all triangles, add their inertia contributions to I
    for(var i = 0; i < triangles.length; i += 3){
        var id1 = triangles[i], id2 = triangles[i + 1], id3 = triangles[i + 2];
        // Add to triangles
        this.triangles.push([
            id1,
            id2,
            id3
        ]);
    }
};
var $8fd610a91dec4c33$var$updateCenterOfMass_centroid = $2Ys9z.create(), $8fd610a91dec4c33$var$updateCenterOfMass_centroid_times_mass = $2Ys9z.create(), $8fd610a91dec4c33$var$updateCenterOfMass_a = $2Ys9z.create(), $8fd610a91dec4c33$var$updateCenterOfMass_b = $2Ys9z.create(), $8fd610a91dec4c33$var$updateCenterOfMass_c = $2Ys9z.create(), $8fd610a91dec4c33$var$updateCenterOfMass_ac = $2Ys9z.create(), $8fd610a91dec4c33$var$updateCenterOfMass_ca = $2Ys9z.create(), $8fd610a91dec4c33$var$updateCenterOfMass_cb = $2Ys9z.create(), $8fd610a91dec4c33$var$updateCenterOfMass_n = $2Ys9z.create();
/**
 * Update the .centerOfMass property.
 * @method updateCenterOfMass
 */ $8fd610a91dec4c33$var$Convex.prototype.updateCenterOfMass = function() {
    var triangles = this.triangles, verts = this.vertices, cm = this.centerOfMass, centroid = $8fd610a91dec4c33$var$updateCenterOfMass_centroid, n = $8fd610a91dec4c33$var$updateCenterOfMass_n, a = $8fd610a91dec4c33$var$updateCenterOfMass_a, b = $8fd610a91dec4c33$var$updateCenterOfMass_b, c = $8fd610a91dec4c33$var$updateCenterOfMass_c, ac = $8fd610a91dec4c33$var$updateCenterOfMass_ac, ca = $8fd610a91dec4c33$var$updateCenterOfMass_ca, cb = $8fd610a91dec4c33$var$updateCenterOfMass_cb, centroid_times_mass = $8fd610a91dec4c33$var$updateCenterOfMass_centroid_times_mass;
    $2Ys9z.set(cm, 0, 0);
    var totalArea = 0;
    for(var i = 0; i !== triangles.length; i++){
        var t = triangles[i], a = verts[t[0]], b = verts[t[1]], c = verts[t[2]];
        $2Ys9z.centroid(centroid, a, b, c);
        // Get mass for the triangle (density=1 in this case)
        // http://math.stackexchange.com/questions/80198/area-of-triangle-via-vectors
        var m = $8fd610a91dec4c33$var$Convex.triangleArea(a, b, c);
        totalArea += m;
        // Add to center of mass
        $2Ys9z.scale(centroid_times_mass, centroid, m);
        $2Ys9z.add(cm, cm, centroid_times_mass);
    }
    $2Ys9z.scale(cm, cm, 1 / totalArea);
};
/**
 * Compute the mass moment of inertia of the Convex.
 * @method computeMomentOfInertia
 * @param  {Number} mass
 * @return {Number}
 * @see http://www.gamedev.net/topic/342822-moment-of-inertia-of-a-polygon-2d/
 */ $8fd610a91dec4c33$var$Convex.prototype.computeMomentOfInertia = function(mass) {
    var denom = 0.0, numer = 0.0, N = this.vertices.length;
    for(var j = N - 1, i = 0; i < N; j = i, i++){
        var p0 = this.vertices[j];
        var p1 = this.vertices[i];
        var a = Math.abs($2Ys9z.crossLength(p0, p1));
        var b = $2Ys9z.dot(p1, p1) + $2Ys9z.dot(p1, p0) + $2Ys9z.dot(p0, p0);
        denom += a * b;
        numer += a;
    }
    return mass / 6.0 * (denom / numer);
};
/**
 * Updates the .boundingRadius property
 * @method updateBoundingRadius
 */ $8fd610a91dec4c33$var$Convex.prototype.updateBoundingRadius = function() {
    var verts = this.vertices, r2 = 0;
    for(var i = 0; i !== verts.length; i++){
        var l2 = $2Ys9z.squaredLength(verts[i]);
        if (l2 > r2) r2 = l2;
    }
    this.boundingRadius = Math.sqrt(r2);
};
/**
 * Get the area of the triangle spanned by the three points a, b, c. The area is positive if the points are given in counter-clockwise order, otherwise negative.
 * @static
 * @method triangleArea
 * @param {Array} a
 * @param {Array} b
 * @param {Array} c
 * @return {Number}
 */ $8fd610a91dec4c33$var$Convex.triangleArea = function(a, b, c) {
    return ((b[0] - a[0]) * (c[1] - a[1]) - (c[0] - a[0]) * (b[1] - a[1])) * 0.5;
};
/**
 * Update the .area
 * @method updateArea
 */ $8fd610a91dec4c33$var$Convex.prototype.updateArea = function() {
    this.updateTriangles();
    this.area = 0;
    var triangles = this.triangles, verts = this.vertices;
    for(var i = 0; i !== triangles.length; i++){
        var t = triangles[i], a = verts[t[0]], b = verts[t[1]], c = verts[t[2]];
        // Get mass for the triangle (density=1 in this case)
        var m = $8fd610a91dec4c33$var$Convex.triangleArea(a, b, c);
        this.area += m;
    }
};
/**
 * @method computeAABB
 * @param  {AABB}   out
 * @param  {Array}  position
 * @param  {Number} angle
 */ $8fd610a91dec4c33$var$Convex.prototype.computeAABB = function(out, position, angle) {
    out.setFromPoints(this.vertices, position, angle, 0);
};
var $8fd610a91dec4c33$var$intersectConvex_rayStart = $2Ys9z.create();
var $8fd610a91dec4c33$var$intersectConvex_rayEnd = $2Ys9z.create();
var $8fd610a91dec4c33$var$intersectConvex_normal = $2Ys9z.create();
/**
 * @method raycast
 * @param  {RaycastResult} result
 * @param  {Ray} ray
 * @param  {array} position
 * @param  {number} angle
 */ $8fd610a91dec4c33$var$Convex.prototype.raycast = function(result, ray, position, angle) {
    var rayStart = $8fd610a91dec4c33$var$intersectConvex_rayStart;
    var rayEnd = $8fd610a91dec4c33$var$intersectConvex_rayEnd;
    var normal = $8fd610a91dec4c33$var$intersectConvex_normal;
    var vertices = this.vertices;
    // Transform to local shape space
    $2Ys9z.toLocalFrame(rayStart, ray.from, position, angle);
    $2Ys9z.toLocalFrame(rayEnd, ray.to, position, angle);
    var n = vertices.length;
    for(var i = 0; i < n && !result.shouldStop(ray); i++){
        var q1 = vertices[i];
        var q2 = vertices[(i + 1) % n];
        var delta = $2Ys9z.getLineSegmentsIntersectionFraction(rayStart, rayEnd, q1, q2);
        if (delta >= 0) {
            $2Ys9z.sub(normal, q2, q1);
            $2Ys9z.rotate(normal, normal, -Math.PI / 2 + angle);
            $2Ys9z.normalize(normal, normal);
            ray.reportIntersection(result, delta, normal, i);
        }
    }
};

});
parcelRegister("k7z01", function(module, exports) {
module.exports = $ea5f9c4151d0164c$var$Shape;

var $2Ys9z = parcelRequire("2Ys9z");
/**
 * Base class for shapes.
 * @class Shape
 * @constructor
 * @param {object} [options]
 * @param {array} [options.position]
 * @param {number} [options.angle=0]
 * @param {number} [options.collisionGroup=1]
 * @param {number} [options.collisionMask=1]
 * @param {boolean} [options.sensor=false]
 * @param {boolean} [options.collisionResponse=true]
 * @param {object} [options.type=0]
 */ function $ea5f9c4151d0164c$var$Shape(options) {
    options = options || {};
    /**
     * The body this shape is attached to. A shape can only be attached to a single body.
     * @property {Body} body
     */ this.body = null;
    /**
     * Body-local position of the shape.
     * @property {Array} position
     */ this.position = $2Ys9z.fromValues(0, 0);
    if (options.position) $2Ys9z.copy(this.position, options.position);
    /**
     * Body-local angle of the shape.
     * @property {number} angle
     */ this.angle = options.angle || 0;
    /**
     * The type of the shape. One of:
     *
     * * {{#crossLink "Shape/CIRCLE:property"}}Shape.CIRCLE{{/crossLink}}
     * * {{#crossLink "Shape/PARTICLE:property"}}Shape.PARTICLE{{/crossLink}}
     * * {{#crossLink "Shape/PLANE:property"}}Shape.PLANE{{/crossLink}}
     * * {{#crossLink "Shape/CONVEX:property"}}Shape.CONVEX{{/crossLink}}
     * * {{#crossLink "Shape/LINE:property"}}Shape.LINE{{/crossLink}}
     * * {{#crossLink "Shape/BOX:property"}}Shape.BOX{{/crossLink}}
     * * {{#crossLink "Shape/CAPSULE:property"}}Shape.CAPSULE{{/crossLink}}
     * * {{#crossLink "Shape/HEIGHTFIELD:property"}}Shape.HEIGHTFIELD{{/crossLink}}
     *
     * @property {number} type
     */ this.type = options.type || 0;
    /**
     * Shape object identifier.
     * @type {Number}
     * @property id
     */ this.id = $ea5f9c4151d0164c$var$Shape.idCounter++;
    /**
     * Bounding circle radius of this shape
     * @property boundingRadius
     * @type {Number}
     */ this.boundingRadius = 0;
    /**
     * Collision group that this shape belongs to (bit mask). See <a href="http://www.aurelienribon.com/blog/2011/07/box2d-tutorial-collision-filtering/">this tutorial</a>.
     * @property collisionGroup
     * @type {Number}
     * @example
     *     // Setup bits for each available group
     *     var PLAYER = Math.pow(2,0),
     *         ENEMY =  Math.pow(2,1),
     *         GROUND = Math.pow(2,2)
     *
     *     // Put shapes into their groups
     *     player1Shape.collisionGroup = PLAYER;
     *     player2Shape.collisionGroup = PLAYER;
     *     enemyShape  .collisionGroup = ENEMY;
     *     groundShape .collisionGroup = GROUND;
     *
     *     // Assign groups that each shape collide with.
     *     // Note that the players can collide with ground and enemies, but not with other players.
     *     player1Shape.collisionMask = ENEMY | GROUND;
     *     player2Shape.collisionMask = ENEMY | GROUND;
     *     enemyShape  .collisionMask = PLAYER | GROUND;
     *     groundShape .collisionMask = PLAYER | ENEMY;
     *
     * @example
     *     // How collision check is done
     *     if(shapeA.collisionGroup & shapeB.collisionMask)!=0 && (shapeB.collisionGroup & shapeA.collisionMask)!=0){
     *         // The shapes will collide
     *     }
     */ this.collisionGroup = options.collisionGroup !== undefined ? options.collisionGroup : 1;
    /**
     * Whether to produce contact forces when in contact with other bodies. Note that contacts will be generated, but they will be disabled. That means that this shape will move through other body shapes, but it will still trigger contact events, etc.
     * @property {Boolean} collisionResponse
     */ this.collisionResponse = options.collisionResponse !== undefined ? options.collisionResponse : true;
    /**
     * Collision mask of this shape. See .collisionGroup.
     * @property collisionMask
     * @type {Number}
     */ this.collisionMask = options.collisionMask !== undefined ? options.collisionMask : 1;
    /**
     * Material to use in collisions for this Shape. If this is set to null, the world will use default material properties instead.
     * @property material
     * @type {Material}
     */ this.material = options.material || null;
    /**
     * Area of this shape.
     * @property area
     * @type {Number}
     */ this.area = 0;
    /**
     * Set to true if you want this shape to be a sensor. A sensor does not generate contacts, but it still reports contact events. This is good if you want to know if a shape is overlapping another shape, without them generating contacts.
     * @property {Boolean} sensor
     */ this.sensor = options.sensor !== undefined ? options.sensor : false;
    if (this.type) this.updateBoundingRadius();
    this.updateArea();
}
$ea5f9c4151d0164c$var$Shape.idCounter = 0;
/**
 * @static
 * @property {Number} CIRCLE
 */ $ea5f9c4151d0164c$var$Shape.CIRCLE = 1;
/**
 * @static
 * @property {Number} PARTICLE
 */ $ea5f9c4151d0164c$var$Shape.PARTICLE = 2;
/**
 * @static
 * @property {Number} PLANE
 */ $ea5f9c4151d0164c$var$Shape.PLANE = 4;
/**
 * @static
 * @property {Number} CONVEX
 */ $ea5f9c4151d0164c$var$Shape.CONVEX = 8;
/**
 * @static
 * @property {Number} LINE
 */ $ea5f9c4151d0164c$var$Shape.LINE = 16;
/**
 * @static
 * @property {Number} BOX
 */ $ea5f9c4151d0164c$var$Shape.BOX = 32;
Object.defineProperty($ea5f9c4151d0164c$var$Shape, "RECTANGLE", {
    get: function() {
        console.warn("Shape.RECTANGLE is deprecated, use Shape.BOX instead.");
        return $ea5f9c4151d0164c$var$Shape.BOX;
    }
});
/**
 * @static
 * @property {Number} CAPSULE
 */ $ea5f9c4151d0164c$var$Shape.CAPSULE = 64;
/**
 * @static
 * @property {Number} HEIGHTFIELD
 */ $ea5f9c4151d0164c$var$Shape.HEIGHTFIELD = 128;
/**
 * Should return the moment of inertia around the Z axis of the body given the total mass. See <a href="http://en.wikipedia.org/wiki/List_of_moments_of_inertia">Wikipedia's list of moments of inertia</a>.
 * @method computeMomentOfInertia
 * @param  {Number} mass
 * @return {Number} If the inertia is infinity or if the object simply isn't possible to rotate, return 0.
 */ $ea5f9c4151d0164c$var$Shape.prototype.computeMomentOfInertia = function(mass) {};
/**
 * Returns the bounding circle radius of this shape.
 * @method updateBoundingRadius
 * @return {Number}
 */ $ea5f9c4151d0164c$var$Shape.prototype.updateBoundingRadius = function() {};
/**
 * Update the .area property of the shape.
 * @method updateArea
 */ $ea5f9c4151d0164c$var$Shape.prototype.updateArea = function() {
// To be implemented in all subclasses
};
/**
 * Compute the world axis-aligned bounding box (AABB) of this shape.
 * @method computeAABB
 * @param  {AABB} out The resulting AABB.
 * @param  {Array} position World position of the shape.
 * @param  {Number} angle World angle of the shape.
 */ $ea5f9c4151d0164c$var$Shape.prototype.computeAABB = function(out, position, angle) {
// To be implemented in each subclass
};
/**
 * Perform raycasting on this shape.
 * @method raycast
 * @param  {RayResult} result Where to store the resulting data.
 * @param  {Ray} ray The Ray that you want to use for raycasting.
 * @param  {array} position World position of the shape (the .position property will be ignored).
 * @param  {number} angle World angle of the shape (the .angle property will be ignored).
 */ $ea5f9c4151d0164c$var$Shape.prototype.raycast = function(result, ray, position, angle) {
// To be implemented in each subclass
};

});

parcelRegister("cm0Cz", function(module, exports) {
/*
        PolyK library
        url: http://polyk.ivank.net
        Released under MIT licence.

        Copyright (c) 2012 Ivan Kuckir

        Permission is hereby granted, free of charge, to any person
        obtaining a copy of this software and associated documentation
        files (the "Software"), to deal in the Software without
        restriction, including without limitation the rights to use,
        copy, modify, merge, publish, distribute, sublicense, and/or sell
        copies of the Software, and to permit persons to whom the
        Software is furnished to do so, subject to the following
        conditions:

        The above copyright notice and this permission notice shall be
        included in all copies or substantial portions of the Software.

        THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
        EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES
        OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
        NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT
        HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
        WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
        FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR
        OTHER DEALINGS IN THE SOFTWARE.
    */ var $8fe80578290374fa$var$PolyK = {};
/*
        Is Polygon self-intersecting?

        O(n^2)
    */ /*
    PolyK.IsSimple = function(p)
    {
        var n = p.length>>1;
        if(n<4) return true;
        var a1 = new PolyK._P(), a2 = new PolyK._P();
        var b1 = new PolyK._P(), b2 = new PolyK._P();
        var c = new PolyK._P();

        for(var i=0; i<n; i++)
        {
            a1.x = p[2*i  ];
            a1.y = p[2*i+1];
            if(i==n-1)  { a2.x = p[0    ];  a2.y = p[1    ]; }
            else        { a2.x = p[2*i+2];  a2.y = p[2*i+3]; }

            for(var j=0; j<n; j++)
            {
                if(Math.abs(i-j) < 2) continue;
                if(j==n-1 && i==0) continue;
                if(i==n-1 && j==0) continue;

                b1.x = p[2*j  ];
                b1.y = p[2*j+1];
                if(j==n-1)  { b2.x = p[0    ];  b2.y = p[1    ]; }
                else        { b2.x = p[2*j+2];  b2.y = p[2*j+3]; }

                if(PolyK._GetLineIntersection(a1,a2,b1,b2,c) != null) return false;
            }
        }
        return true;
    }

    PolyK.IsConvex = function(p)
    {
        if(p.length<6) return true;
        var l = p.length - 4;
        for(var i=0; i<l; i+=2)
            if(!PolyK._convex(p[i], p[i+1], p[i+2], p[i+3], p[i+4], p[i+5])) return false;
        if(!PolyK._convex(p[l  ], p[l+1], p[l+2], p[l+3], p[0], p[1])) return false;
        if(!PolyK._convex(p[l+2], p[l+3], p[0  ], p[1  ], p[2], p[3])) return false;
        return true;
    }
    */ $8fe80578290374fa$var$PolyK.GetArea = function(p) {
    if (p.length < 6) return 0;
    var l = p.length - 2;
    var sum = 0;
    for(var i = 0; i < l; i += 2)sum += (p[i + 2] - p[i]) * (p[i + 1] + p[i + 3]);
    sum += (p[0] - p[l]) * (p[l + 1] + p[1]);
    return -sum * 0.5;
};
/*
    PolyK.GetAABB = function(p)
    {
        var minx = Infinity;
        var miny = Infinity;
        var maxx = -minx;
        var maxy = -miny;
        for(var i=0; i<p.length; i+=2)
        {
            minx = Math.min(minx, p[i  ]);
            maxx = Math.max(maxx, p[i  ]);
            miny = Math.min(miny, p[i+1]);
            maxy = Math.max(maxy, p[i+1]);
        }
        return {x:minx, y:miny, width:maxx-minx, height:maxy-miny};
    }
    */ $8fe80578290374fa$var$PolyK.Triangulate = function(p) {
    var n = p.length >> 1;
    if (n < 3) return [];
    var tgs = [];
    var avl = [];
    for(var i = 0; i < n; i++)avl.push(i);
    var i = 0;
    var al = n;
    while(al > 3){
        var i0 = avl[(i + 0) % al];
        var i1 = avl[(i + 1) % al];
        var i2 = avl[(i + 2) % al];
        var ax = p[2 * i0], ay = p[2 * i0 + 1];
        var bx = p[2 * i1], by = p[2 * i1 + 1];
        var cx = p[2 * i2], cy = p[2 * i2 + 1];
        var earFound = false;
        if ($8fe80578290374fa$var$PolyK._convex(ax, ay, bx, by, cx, cy)) {
            earFound = true;
            for(var j = 0; j < al; j++){
                var vi = avl[j];
                if (vi == i0 || vi == i1 || vi == i2) continue;
                if ($8fe80578290374fa$var$PolyK._PointInTriangle(p[2 * vi], p[2 * vi + 1], ax, ay, bx, by, cx, cy)) {
                    earFound = false;
                    break;
                }
            }
        }
        if (earFound) {
            tgs.push(i0, i1, i2);
            avl.splice((i + 1) % al, 1);
            al--;
            i = 0;
        } else if (i++ > 3 * al) break; // no convex angles :(
    }
    tgs.push(avl[0], avl[1], avl[2]);
    return tgs;
};
/*
    PolyK.ContainsPoint = function(p, px, py)
    {
        var n = p.length>>1;
        var ax, ay, bx = p[2*n-2]-px, by = p[2*n-1]-py;
        var depth = 0;
        for(var i=0; i<n; i++)
        {
            ax = bx;  ay = by;
            bx = p[2*i  ] - px;
            by = p[2*i+1] - py;
            if(ay< 0 && by< 0) continue;    // both "up" or both "donw"
            if(ay>=0 && by>=0) continue;    // both "up" or both "donw"
            if(ax< 0 && bx< 0) continue;

            var lx = ax + (bx-ax)*(-ay)/(by-ay);
            if(lx>0) depth++;
        }
        return (depth & 1) == 1;
    }

    PolyK.Slice = function(p, ax, ay, bx, by)
    {
        if(PolyK.ContainsPoint(p, ax, ay) || PolyK.ContainsPoint(p, bx, by)) return [p.slice(0)];

        var a = new PolyK._P(ax, ay);
        var b = new PolyK._P(bx, by);
        var iscs = [];  // intersections
        var ps = [];    // points
        for(var i=0; i<p.length; i+=2) ps.push(new PolyK._P(p[i], p[i+1]));

        for(var i=0; i<ps.length; i++)
        {
            var isc = new PolyK._P(0,0);
            isc = PolyK._GetLineIntersection(a, b, ps[i], ps[(i+1)%ps.length], isc);

            if(isc)
            {
                isc.flag = true;
                iscs.push(isc);
                ps.splice(i+1,0,isc);
                i++;
            }
        }
        if(iscs.length == 0) return [p.slice(0)];
        var comp = function(u,v) {return PolyK._P.dist(a,u) - PolyK._P.dist(a,v); }
        iscs.sort(comp);

        var pgs = [];
        var dir = 0;
        while(iscs.length > 0)
        {
            var n = ps.length;
            var i0 = iscs[0];
            var i1 = iscs[1];
            var ind0 = ps.indexOf(i0);
            var ind1 = ps.indexOf(i1);
            var solved = false;

            if(PolyK._firstWithFlag(ps, ind0) == ind1) solved = true;
            else
            {
                i0 = iscs[1];
                i1 = iscs[0];
                ind0 = ps.indexOf(i0);
                ind1 = ps.indexOf(i1);
                if(PolyK._firstWithFlag(ps, ind0) == ind1) solved = true;
            }
            if(solved)
            {
                dir--;
                var pgn = PolyK._getPoints(ps, ind0, ind1);
                pgs.push(pgn);
                ps = PolyK._getPoints(ps, ind1, ind0);
                i0.flag = i1.flag = false;
                iscs.splice(0,2);
                if(iscs.length == 0) pgs.push(ps);
            }
            else { dir++; iscs.reverse(); }
            if(dir>1) break;
        }
        var result = [];
        for(var i=0; i<pgs.length; i++)
        {
            var pg = pgs[i];
            var npg = [];
            for(var j=0; j<pg.length; j++) npg.push(pg[j].x, pg[j].y);
            result.push(npg);
        }
        return result;
    }

    PolyK.Raycast = function(p, x, y, dx, dy, isc)
    {
        var l = p.length - 2;
        var tp = PolyK._tp;
        var a1 = tp[0], a2 = tp[1],
        b1 = tp[2], b2 = tp[3], c = tp[4];
        a1.x = x; a1.y = y;
        a2.x = x+dx; a2.y = y+dy;

        if(isc==null) isc = {dist:0, edge:0, norm:{x:0, y:0}, refl:{x:0, y:0}};
        isc.dist = Infinity;

        for(var i=0; i<l; i+=2)
        {
            b1.x = p[i  ];  b1.y = p[i+1];
            b2.x = p[i+2];  b2.y = p[i+3];
            var nisc = PolyK._RayLineIntersection(a1, a2, b1, b2, c);
            if(nisc) PolyK._updateISC(dx, dy, a1, b1, b2, c, i/2, isc);
        }
        b1.x = b2.x;  b1.y = b2.y;
        b2.x = p[0];  b2.y = p[1];
        var nisc = PolyK._RayLineIntersection(a1, a2, b1, b2, c);
        if(nisc) PolyK._updateISC(dx, dy, a1, b1, b2, c, p.length/2, isc);

        return (isc.dist != Infinity) ? isc : null;
    }

    PolyK.ClosestEdge = function(p, x, y, isc)
    {
        var l = p.length - 2;
        var tp = PolyK._tp;
        var a1 = tp[0],
        b1 = tp[2], b2 = tp[3], c = tp[4];
        a1.x = x; a1.y = y;

        if(isc==null) isc = {dist:0, edge:0, point:{x:0, y:0}, norm:{x:0, y:0}};
        isc.dist = Infinity;

        for(var i=0; i<l; i+=2)
        {
            b1.x = p[i  ];  b1.y = p[i+1];
            b2.x = p[i+2];  b2.y = p[i+3];
            PolyK._pointLineDist(a1, b1, b2, i>>1, isc);
        }
        b1.x = b2.x;  b1.y = b2.y;
        b2.x = p[0];  b2.y = p[1];
        PolyK._pointLineDist(a1, b1, b2, l>>1, isc);

        var idst = 1/isc.dist;
        isc.norm.x = (x-isc.point.x)*idst;
        isc.norm.y = (y-isc.point.y)*idst;
        return isc;
    }

    PolyK._pointLineDist = function(p, a, b, edge, isc)
    {
        var x = p.x, y = p.y, x1 = a.x, y1 = a.y, x2 = b.x, y2 = b.y;

        var A = x - x1;
        var B = y - y1;
        var C = x2 - x1;
        var D = y2 - y1;

        var dot = A * C + B * D;
        var len_sq = C * C + D * D;
        var param = dot / len_sq;

        var xx, yy;

        if (param < 0 || (x1 == x2 && y1 == y2)) {
            xx = x1;
            yy = y1;
        }
        else if (param > 1) {
            xx = x2;
            yy = y2;
        }
        else {
            xx = x1 + param * C;
            yy = y1 + param * D;
        }

        var dx = x - xx;
        var dy = y - yy;
        var dst = Math.sqrt(dx * dx + dy * dy);
        if(dst<isc.dist)
        {
            isc.dist = dst;
            isc.edge = edge;
            isc.point.x = xx;
            isc.point.y = yy;
        }
    }

    PolyK._updateISC = function(dx, dy, a1, b1, b2, c, edge, isc)
    {
        var nrl = PolyK._P.dist(a1, c);
        if(nrl<isc.dist)
        {
            var ibl = 1/PolyK._P.dist(b1, b2);
            var nx = -(b2.y-b1.y)*ibl;
            var ny =  (b2.x-b1.x)*ibl;
            var ddot = 2*(dx*nx+dy*ny);
            isc.dist = nrl;
            isc.norm.x = nx;
            isc.norm.y = ny;
            isc.refl.x = -ddot*nx+dx;
            isc.refl.y = -ddot*ny+dy;
            isc.edge = edge;
        }
    }

    PolyK._getPoints = function(ps, ind0, ind1)
    {
        var n = ps.length;
        var nps = [];
        if(ind1<ind0) ind1 += n;
        for(var i=ind0; i<= ind1; i++) nps.push(ps[i%n]);
        return nps;
    }

    PolyK._firstWithFlag = function(ps, ind)
    {
        var n = ps.length;
        while(true)
        {
            ind = (ind+1)%n;
            if(ps[ind].flag) return ind;
        }
    }
    */ $8fe80578290374fa$var$PolyK._PointInTriangle = function(px, py, ax, ay, bx, by, cx, cy) {
    var v0x = cx - ax;
    var v0y = cy - ay;
    var v1x = bx - ax;
    var v1y = by - ay;
    var v2x = px - ax;
    var v2y = py - ay;
    var dot00 = v0x * v0x + v0y * v0y;
    var dot01 = v0x * v1x + v0y * v1y;
    var dot02 = v0x * v2x + v0y * v2y;
    var dot11 = v1x * v1x + v1y * v1y;
    var dot12 = v1x * v2x + v1y * v2y;
    var invDenom = 1 / (dot00 * dot11 - dot01 * dot01);
    var u = (dot11 * dot02 - dot01 * dot12) * invDenom;
    var v = (dot00 * dot12 - dot01 * dot02) * invDenom;
    // Check if point is in triangle
    return u >= 0 && v >= 0 && u + v < 1;
};
/*
    PolyK._RayLineIntersection = function(a1, a2, b1, b2, c)
    {
        var dax = (a1.x-a2.x), dbx = (b1.x-b2.x);
        var day = (a1.y-a2.y), dby = (b1.y-b2.y);

        var Den = dax*dby - day*dbx;
        if (Den == 0) return null;  // parallel

        var A = (a1.x * a2.y - a1.y * a2.x);
        var B = (b1.x * b2.y - b1.y * b2.x);

        var I = c;
        var iDen = 1/Den;
        I.x = ( A*dbx - dax*B ) * iDen;
        I.y = ( A*dby - day*B ) * iDen;

        if(!PolyK._InRect(I, b1, b2)) return null;
        if((day>0 && I.y>a1.y) || (day<0 && I.y<a1.y)) return null;
        if((dax>0 && I.x>a1.x) || (dax<0 && I.x<a1.x)) return null;
        return I;
    }

    PolyK._GetLineIntersection = function(a1, a2, b1, b2, c)
    {
        var dax = (a1.x-a2.x), dbx = (b1.x-b2.x);
        var day = (a1.y-a2.y), dby = (b1.y-b2.y);

        var Den = dax*dby - day*dbx;
        if (Den == 0) return null;  // parallel

        var A = (a1.x * a2.y - a1.y * a2.x);
        var B = (b1.x * b2.y - b1.y * b2.x);

        var I = c;
        I.x = ( A*dbx - dax*B ) / Den;
        I.y = ( A*dby - day*B ) / Den;

        if(PolyK._InRect(I, a1, a2) && PolyK._InRect(I, b1, b2)) return I;
        return null;
    }

    PolyK._InRect = function(a, b, c)
    {
        if  (b.x == c.x) return (a.y>=Math.min(b.y, c.y) && a.y<=Math.max(b.y, c.y));
        if  (b.y == c.y) return (a.x>=Math.min(b.x, c.x) && a.x<=Math.max(b.x, c.x));

        if(a.x >= Math.min(b.x, c.x) && a.x <= Math.max(b.x, c.x)
        && a.y >= Math.min(b.y, c.y) && a.y <= Math.max(b.y, c.y))
        return true;
        return false;
    }
    */ $8fe80578290374fa$var$PolyK._convex = function(ax, ay, bx, by, cx, cy) {
    return (ay - by) * (cx - bx) + (bx - ax) * (cy - by) >= 0;
};
/*
    PolyK._P = function(x,y)
    {
        this.x = x;
        this.y = y;
        this.flag = false;
    }
    PolyK._P.prototype.toString = function()
    {
        return "Point ["+this.x+", "+this.y+"]";
    }
    PolyK._P.dist = function(a,b)
    {
        var dx = b.x-a.x;
        var dy = b.y-a.y;
        return Math.sqrt(dx*dx + dy*dy);
    }

    PolyK._tp = [];
    for(var i=0; i<10; i++) PolyK._tp.push(new PolyK._P(0,0));
        */ module.exports = $8fe80578290374fa$var$PolyK;

});


parcelRegister("ZlKj0", function(module, exports) {

var $2Ys9z = parcelRequire("2Ys9z");

var $l9ZUH = parcelRequire("l9ZUH");
module.exports = $0b8690e51f419871$var$RaycastResult;
/**
 * Storage for Ray casting hit data.
 * @class RaycastResult
 * @constructor
 */ function $0b8690e51f419871$var$RaycastResult() {
    /**
	 * The normal of the hit, oriented in world space.
	 * @property {array} normal
	 */ this.normal = $2Ys9z.create();
    /**
	 * The hit shape, or null.
	 * @property {Shape} shape
	 */ this.shape = null;
    /**
	 * The hit body, or null.
	 * @property {Body} body
	 */ this.body = null;
    /**
	 * The index of the hit triangle, if the hit shape was indexable.
	 * @property {number} faceIndex
	 * @default -1
	 */ this.faceIndex = -1;
    /**
	 * Distance to the hit, as a fraction. 0 is at the "from" point, 1 is at the "to" point. Will be set to -1 if there was no hit yet.
	 * @property {number} fraction
	 * @default -1
	 */ this.fraction = -1;
    /**
	 * If the ray should stop traversing.
	 * @readonly
	 * @property {Boolean} isStopped
	 */ this.isStopped = false;
}
/**
 * Reset all result data. Must be done before re-using the result object.
 * @method reset
 */ $0b8690e51f419871$var$RaycastResult.prototype.reset = function() {
    $2Ys9z.set(this.normal, 0, 0);
    this.shape = null;
    this.body = null;
    this.faceIndex = -1;
    this.fraction = -1;
    this.isStopped = false;
};
/**
 * Get the distance to the hit point.
 * @method getHitDistance
 * @param {Ray} ray
 */ $0b8690e51f419871$var$RaycastResult.prototype.getHitDistance = function(ray) {
    return $2Ys9z.distance(ray.from, ray.to) * this.fraction;
};
/**
 * Returns true if the ray hit something since the last reset().
 * @method hasHit
 */ $0b8690e51f419871$var$RaycastResult.prototype.hasHit = function() {
    return this.fraction !== -1;
};
/**
 * Get world hit point.
 * @method getHitPoint
 * @param {array} out
 * @param {Ray} ray
 */ $0b8690e51f419871$var$RaycastResult.prototype.getHitPoint = function(out, ray) {
    $2Ys9z.lerp(out, ray.from, ray.to, this.fraction);
};
/**
 * Can be called while iterating over hits to stop searching for hit points.
 * @method stop
 */ $0b8690e51f419871$var$RaycastResult.prototype.stop = function() {
    this.isStopped = true;
};
/**
 * @method shouldStop
 * @private
 * @param {Ray} ray
 * @return {boolean}
 */ $0b8690e51f419871$var$RaycastResult.prototype.shouldStop = function(ray) {
    return this.isStopped || this.fraction !== -1 && ray.mode === $l9ZUH.ANY;
};
/**
 * @method set
 * @private
 * @param {array} normal
 * @param {Shape} shape
 * @param {Body} body
 * @param {number} fraction
 */ $0b8690e51f419871$var$RaycastResult.prototype.set = function(normal, shape, body, fraction, faceIndex) {
    $2Ys9z.copy(this.normal, normal);
    this.shape = shape;
    this.body = body;
    this.fraction = fraction;
    this.faceIndex = faceIndex;
};

});
parcelRegister("l9ZUH", function(module, exports) {
module.exports = $f67a76f538e3ba3b$var$Ray;

var $2Ys9z = parcelRequire("2Ys9z");
parcelRequire("ZlKj0");
parcelRequire("k7z01");
parcelRequire("hkl1e");
/**
 * A line with a start and end point that is used to intersect shapes. For an example, see {{#crossLink "World/raycast:method"}}World.raycast{{/crossLink}}
 * @class Ray
 * @constructor
 * @param {object} [options]
 * @param {array} [options.from]
 * @param {array} [options.to]
 * @param {boolean} [options.checkCollisionResponse=true]
 * @param {boolean} [options.skipBackfaces=false]
 * @param {number} [options.collisionMask=-1]
 * @param {number} [options.collisionGroup=-1]
 * @param {number} [options.mode=Ray.ANY]
 * @param {number} [options.callback]
 */ function $f67a76f538e3ba3b$var$Ray(options) {
    options = options || {};
    /**
     * Ray start point.
     * @property {array} from
     */ this.from = options.from ? $2Ys9z.fromValues(options.from[0], options.from[1]) : $2Ys9z.create();
    /**
     * Ray end point
     * @property {array} to
     */ this.to = options.to ? $2Ys9z.fromValues(options.to[0], options.to[1]) : $2Ys9z.create();
    /**
     * Set to true if you want the Ray to take .collisionResponse flags into account on bodies and shapes.
     * @property {Boolean} checkCollisionResponse
     */ this.checkCollisionResponse = options.checkCollisionResponse !== undefined ? options.checkCollisionResponse : true;
    /**
     * If set to true, the ray skips any hits with normal.dot(rayDirection) < 0.
     * @property {Boolean} skipBackfaces
     */ this.skipBackfaces = !!options.skipBackfaces;
    /**
     * @property {number} collisionMask
     * @default -1
     */ this.collisionMask = options.collisionMask !== undefined ? options.collisionMask : -1;
    /**
     * @property {number} collisionGroup
     * @default -1
     */ this.collisionGroup = options.collisionGroup !== undefined ? options.collisionGroup : -1;
    /**
     * The intersection mode. Should be {{#crossLink "Ray/ANY:property"}}Ray.ANY{{/crossLink}}, {{#crossLink "Ray/ALL:property"}}Ray.ALL{{/crossLink}} or {{#crossLink "Ray/CLOSEST:property"}}Ray.CLOSEST{{/crossLink}}.
     * @property {number} mode
     */ this.mode = options.mode !== undefined ? options.mode : $f67a76f538e3ba3b$var$Ray.ANY;
    /**
     * Current, user-provided result callback. Will be used if mode is Ray.ALL.
     * @property {Function} callback
     */ this.callback = options.callback || function(result) {};
    /**
     * @readOnly
     * @property {array} direction
     */ this.direction = $2Ys9z.create();
    /**
     * Length of the ray
     * @readOnly
     * @property {number} length
     */ this.length = 1;
    this.update();
}
$f67a76f538e3ba3b$var$Ray.prototype.constructor = $f67a76f538e3ba3b$var$Ray;
/**
 * This raycasting mode will make the Ray traverse through all intersection points and only return the closest one.
 * @static
 * @property {Number} CLOSEST
 */ $f67a76f538e3ba3b$var$Ray.CLOSEST = 1;
/**
 * This raycasting mode will make the Ray stop when it finds the first intersection point.
 * @static
 * @property {Number} ANY
 */ $f67a76f538e3ba3b$var$Ray.ANY = 2;
/**
 * This raycasting mode will traverse all intersection points and executes a callback for each one.
 * @static
 * @property {Number} ALL
 */ $f67a76f538e3ba3b$var$Ray.ALL = 4;
/**
 * Should be called if you change the from or to point.
 * @method update
 */ $f67a76f538e3ba3b$var$Ray.prototype.update = function() {
    // Update .direction and .length
    var d = this.direction;
    $2Ys9z.sub(d, this.to, this.from);
    this.length = $2Ys9z.length(d);
    $2Ys9z.normalize(d, d);
};
/**
 * @method intersectBodies
 * @param {Array} bodies An array of Body objects.
 */ $f67a76f538e3ba3b$var$Ray.prototype.intersectBodies = function(result, bodies) {
    for(var i = 0, l = bodies.length; !result.shouldStop(this) && i < l; i++){
        var body = bodies[i];
        var aabb = body.getAABB();
        if (aabb.overlapsRay(this) >= 0 || aabb.containsPoint(this.from)) this.intersectBody(result, body);
    }
};
var $f67a76f538e3ba3b$var$intersectBody_worldPosition = $2Ys9z.create();
/**
 * Shoot a ray at a body, get back information about the hit.
 * @method intersectBody
 * @private
 * @param {Body} body
 */ $f67a76f538e3ba3b$var$Ray.prototype.intersectBody = function(result, body) {
    var checkCollisionResponse = this.checkCollisionResponse;
    if (checkCollisionResponse && !body.collisionResponse) return;
    var worldPosition = $f67a76f538e3ba3b$var$intersectBody_worldPosition;
    for(var i = 0, N = body.shapes.length; i < N; i++){
        var shape = body.shapes[i];
        if (checkCollisionResponse && !shape.collisionResponse) continue; // Skip
        if ((this.collisionGroup & shape.collisionMask) === 0 || (shape.collisionGroup & this.collisionMask) === 0) continue;
        // Get world angle and position of the shape
        $2Ys9z.rotate(worldPosition, shape.position, body.angle);
        $2Ys9z.add(worldPosition, worldPosition, body.position);
        var worldAngle = shape.angle + body.angle;
        this.intersectShape(result, shape, worldAngle, worldPosition, body);
        if (result.shouldStop(this)) break;
    }
};
/**
 * @method intersectShape
 * @private
 * @param {Shape} shape
 * @param {number} angle
 * @param {array} position
 * @param {Body} body
 */ $f67a76f538e3ba3b$var$Ray.prototype.intersectShape = function(result, shape, angle, position, body) {
    var from = this.from;
    // Checking radius
    var distance = $f67a76f538e3ba3b$var$distanceFromIntersectionSquared(from, this.direction, position);
    if (distance > shape.boundingRadius * shape.boundingRadius) return;
    this._currentBody = body;
    this._currentShape = shape;
    shape.raycast(result, this, position, angle);
    this._currentBody = this._currentShape = null;
};
/**
 * Get the AABB of the ray.
 * @method getAABB
 * @param  {AABB} aabb
 */ $f67a76f538e3ba3b$var$Ray.prototype.getAABB = function(result) {
    var to = this.to;
    var from = this.from;
    $2Ys9z.set(result.lowerBound, Math.min(to[0], from[0]), Math.min(to[1], from[1]));
    $2Ys9z.set(result.upperBound, Math.max(to[0], from[0]), Math.max(to[1], from[1]));
};
var $f67a76f538e3ba3b$var$hitPointWorld = $2Ys9z.create();
/**
 * @method reportIntersection
 * @private
 * @param  {number} fraction
 * @param  {array} normal
 * @param  {number} [faceIndex=-1]
 * @return {boolean} True if the intersections should continue
 */ $f67a76f538e3ba3b$var$Ray.prototype.reportIntersection = function(result, fraction, normal, faceIndex) {
    var from = this.from;
    var to = this.to;
    var shape = this._currentShape;
    var body = this._currentBody;
    // Skip back faces?
    if (this.skipBackfaces && $2Ys9z.dot(normal, this.direction) > 0) return;
    switch(this.mode){
        case $f67a76f538e3ba3b$var$Ray.ALL:
            result.set(normal, shape, body, fraction, faceIndex);
            this.callback(result);
            break;
        case $f67a76f538e3ba3b$var$Ray.CLOSEST:
            // Store if closer than current closest
            if (fraction < result.fraction || !result.hasHit()) result.set(normal, shape, body, fraction, faceIndex);
            break;
        case $f67a76f538e3ba3b$var$Ray.ANY:
            // Report and stop.
            result.set(normal, shape, body, fraction, faceIndex);
            break;
    }
};
var $f67a76f538e3ba3b$var$v0 = $2Ys9z.create(), $f67a76f538e3ba3b$var$intersect = $2Ys9z.create();
function $f67a76f538e3ba3b$var$distanceFromIntersectionSquared(from, direction, position) {
    // v0 is vector from from to position
    $2Ys9z.sub($f67a76f538e3ba3b$var$v0, position, from);
    var dot = $2Ys9z.dot($f67a76f538e3ba3b$var$v0, direction);
    // intersect = direction * dot + from
    $2Ys9z.scale($f67a76f538e3ba3b$var$intersect, direction, dot);
    $2Ys9z.add($f67a76f538e3ba3b$var$intersect, $f67a76f538e3ba3b$var$intersect, from);
    return $2Ys9z.squaredDistance(position, $f67a76f538e3ba3b$var$intersect);
}

});


parcelRegister("5POlg", function(module, exports) {
/**
 * Base class for objects that dispatches events.
 * @class EventEmitter
 * @constructor
 */ var $43f8c405f3231efd$var$EventEmitter = function() {};
module.exports = $43f8c405f3231efd$var$EventEmitter;
$43f8c405f3231efd$var$EventEmitter.prototype = {
    constructor: $43f8c405f3231efd$var$EventEmitter,
    /**
     * Add an event listener
     * @method on
     * @param  {String} type
     * @param  {Function} listener
     * @return {EventEmitter} The self object, for chainability.
     */ on: function(type, listener, context) {
        listener.context = context || this;
        if (this._listeners === undefined) this._listeners = {};
        var listeners = this._listeners;
        if (listeners[type] === undefined) listeners[type] = [];
        if (listeners[type].indexOf(listener) === -1) listeners[type].push(listener);
        return this;
    },
    /**
     * Check if an event listener is added
     * @method has
     * @param  {String} type
     * @param  {Function} listener
     * @return {Boolean}
     */ has: function(type, listener) {
        if (this._listeners === undefined) return false;
        var listeners = this._listeners;
        if (listener) {
            if (listeners[type] !== undefined && listeners[type].indexOf(listener) !== -1) return true;
        } else {
            if (listeners[type] !== undefined) return true;
        }
        return false;
    },
    /**
     * Remove an event listener
     * @method off
     * @param  {String} type
     * @param  {Function} listener
     * @return {EventEmitter} The self object, for chainability.
     */ off: function(type, listener) {
        if (this._listeners === undefined) return this;
        var listeners = this._listeners;
        var index = listeners[type].indexOf(listener);
        if (index !== -1) listeners[type].splice(index, 1);
        return this;
    },
    /**
     * Emit an event.
     * @method emit
     * @param  {Object} event
     * @param  {String} event.type
     * @return {EventEmitter} The self object, for chainability.
     */ emit: function(event) {
        if (this._listeners === undefined) return this;
        var listeners = this._listeners;
        var listenerArray = listeners[event.type];
        if (listenerArray !== undefined) {
            event.target = this;
            for(var i = 0, l = listenerArray.length; i < l; i++){
                var listener = listenerArray[i];
                listener.call(listener.context, event);
            }
        }
        return this;
    }
};

});




parcelRegister("dQgku", function(module, exports) {

var $2Ys9z = parcelRequire("2Ys9z");

var $e7hLo = parcelRequire("e7hLo");
module.exports = $a13ccc5cdbcd0111$var$Broadphase;
/**
 * Base class for broadphase implementations.
 * @class Broadphase
 * @constructor
 */ function $a13ccc5cdbcd0111$var$Broadphase(type) {
    this.type = type;
    /**
     * The resulting overlapping pairs. Will be filled with results during .getCollisionPairs().
     * @property result
     * @type {Array}
     */ this.result = [];
    /**
     * The world to search for collision pairs in. To change it, use .setWorld()
     * @property world
     * @type {World}
     * @readOnly
     */ this.world = null;
    /**
     * The bounding volume type to use in the broadphase algorithms. Should be set to Broadphase.AABB or Broadphase.BOUNDING_CIRCLE.
     * @property {Number} boundingVolumeType
     */ this.boundingVolumeType = $a13ccc5cdbcd0111$var$Broadphase.AABB;
}
/**
 * Axis aligned bounding box type.
 * @static
 * @property {Number} AABB
 */ $a13ccc5cdbcd0111$var$Broadphase.AABB = 1;
/**
 * Bounding circle type.
 * @static
 * @property {Number} BOUNDING_CIRCLE
 */ $a13ccc5cdbcd0111$var$Broadphase.BOUNDING_CIRCLE = 2;
/**
 * Set the world that we are searching for collision pairs in.
 * @method setWorld
 * @param  {World} world
 */ $a13ccc5cdbcd0111$var$Broadphase.prototype.setWorld = function(world) {
    this.world = world;
};
/**
 * Get all potential intersecting body pairs.
 * @method getCollisionPairs
 * @param  {World} world The world to search in.
 * @return {Array} An array of the bodies, ordered in pairs. Example: A result of [a,b,c,d] means that the potential pairs are: (a,b), (c,d).
 */ $a13ccc5cdbcd0111$var$Broadphase.prototype.getCollisionPairs = function(world) {};
var $a13ccc5cdbcd0111$var$dist = $2Ys9z.create();
/**
 * Check whether the bounding radius of two bodies overlap.
 * @method  boundingRadiusCheck
 * @param  {Body} bodyA
 * @param  {Body} bodyB
 * @return {Boolean}
 */ $a13ccc5cdbcd0111$var$Broadphase.boundingRadiusCheck = function(bodyA, bodyB) {
    $2Ys9z.sub($a13ccc5cdbcd0111$var$dist, bodyA.position, bodyB.position);
    var d2 = $2Ys9z.squaredLength($a13ccc5cdbcd0111$var$dist), r = bodyA.boundingRadius + bodyB.boundingRadius;
    return d2 <= r * r;
};
/**
 * Check whether the bounding radius of two bodies overlap.
 * @method  boundingRadiusCheck
 * @param  {Body} bodyA
 * @param  {Body} bodyB
 * @return {Boolean}
 */ $a13ccc5cdbcd0111$var$Broadphase.aabbCheck = function(bodyA, bodyB) {
    return bodyA.getAABB().overlaps(bodyB.getAABB());
};
/**
 * Check whether the bounding radius of two bodies overlap.
 * @method  boundingRadiusCheck
 * @param  {Body} bodyA
 * @param  {Body} bodyB
 * @return {Boolean}
 */ $a13ccc5cdbcd0111$var$Broadphase.prototype.boundingVolumeCheck = function(bodyA, bodyB) {
    var result;
    switch(this.boundingVolumeType){
        case $a13ccc5cdbcd0111$var$Broadphase.BOUNDING_CIRCLE:
            result = $a13ccc5cdbcd0111$var$Broadphase.boundingRadiusCheck(bodyA, bodyB);
            break;
        case $a13ccc5cdbcd0111$var$Broadphase.AABB:
            result = $a13ccc5cdbcd0111$var$Broadphase.aabbCheck(bodyA, bodyB);
            break;
        default:
            throw new Error("Bounding volume type not recognized: " + this.boundingVolumeType);
    }
    return result;
};
/**
 * Check whether two bodies are allowed to collide at all.
 * @method  canCollide
 * @param  {Body} bodyA
 * @param  {Body} bodyB
 * @return {Boolean}
 */ $a13ccc5cdbcd0111$var$Broadphase.canCollide = function(bodyA, bodyB) {
    var KINEMATIC = $e7hLo.KINEMATIC;
    var STATIC = $e7hLo.STATIC;
    // Cannot collide static bodies
    if (bodyA.type === STATIC && bodyB.type === STATIC) return false;
    // Cannot collide static vs kinematic bodies
    if (bodyA.type === KINEMATIC && bodyB.type === STATIC || bodyA.type === STATIC && bodyB.type === KINEMATIC) return false;
    // Cannot collide kinematic vs kinematic
    if (bodyA.type === KINEMATIC && bodyB.type === KINEMATIC) return false;
    // Cannot collide both sleeping bodies
    if (bodyA.sleepState === $e7hLo.SLEEPING && bodyB.sleepState === $e7hLo.SLEEPING) return false;
    // Cannot collide if one is static and the other is sleeping
    if (bodyA.sleepState === $e7hLo.SLEEPING && bodyB.type === STATIC || bodyB.sleepState === $e7hLo.SLEEPING && bodyA.type === STATIC) return false;
    return true;
};
$a13ccc5cdbcd0111$var$Broadphase.NAIVE = 1;
$a13ccc5cdbcd0111$var$Broadphase.SAP = 2;

});

parcelRegister("4flMw", function(module, exports) {

var $k7z01 = parcelRequire("k7z01");

var $2Ys9z = parcelRequire("2Ys9z");
module.exports = $3179757e477018e0$var$Capsule;
/**
 * Capsule shape class.
 * @class Capsule
 * @constructor
 * @extends Shape
 * @param {object} [options] (Note that this options object will be passed on to the {{#crossLink "Shape"}}{{/crossLink}} constructor.)
 * @param {Number} [options.length=1] The distance between the end points
 * @param {Number} [options.radius=1] Radius of the capsule
 * @example
 *     var capsuleShape = new Capsule({
 *         length: 1,
 *         radius: 2
 *     });
 *     body.addShape(capsuleShape);
 */ function $3179757e477018e0$var$Capsule(options) {
    if (typeof arguments[0] === "number" && typeof arguments[1] === "number") {
        options = {
            length: arguments[0],
            radius: arguments[1]
        };
        console.warn("The Capsule constructor signature has changed. Please use the following format: new Capsule({ radius: 1, length: 1 })");
    }
    options = options || {};
    /**
     * The distance between the end points.
     * @property {Number} length
     */ this.length = options.length || 1;
    /**
     * The radius of the capsule.
     * @property {Number} radius
     */ this.radius = options.radius || 1;
    options.type = $k7z01.CAPSULE;
    $k7z01.call(this, options);
}
$3179757e477018e0$var$Capsule.prototype = new $k7z01();
$3179757e477018e0$var$Capsule.prototype.constructor = $3179757e477018e0$var$Capsule;
/**
 * Compute the mass moment of inertia of the Capsule.
 * @method conputeMomentOfInertia
 * @param  {Number} mass
 * @return {Number}
 * @todo
 */ $3179757e477018e0$var$Capsule.prototype.computeMomentOfInertia = function(mass) {
    // Approximate with rectangle
    var r = this.radius, w = this.length + r, h = r * 2;
    return mass * (h * h + w * w) / 12;
};
/**
 * @method updateBoundingRadius
 */ $3179757e477018e0$var$Capsule.prototype.updateBoundingRadius = function() {
    this.boundingRadius = this.radius + this.length / 2;
};
/**
 * @method updateArea
 */ $3179757e477018e0$var$Capsule.prototype.updateArea = function() {
    this.area = Math.PI * this.radius * this.radius + this.radius * 2 * this.length;
};
var $3179757e477018e0$var$r = $2Ys9z.create();
/**
 * @method computeAABB
 * @param  {AABB}   out      The resulting AABB.
 * @param  {Array}  position
 * @param  {Number} angle
 */ $3179757e477018e0$var$Capsule.prototype.computeAABB = function(out, position, angle) {
    var radius = this.radius;
    // Compute center position of one of the the circles, world oriented, but with local offset
    $2Ys9z.set($3179757e477018e0$var$r, this.length / 2, 0);
    if (angle !== 0) $2Ys9z.rotate($3179757e477018e0$var$r, $3179757e477018e0$var$r, angle);
    // Get bounds
    $2Ys9z.set(out.upperBound, Math.max($3179757e477018e0$var$r[0] + radius, -$3179757e477018e0$var$r[0] + radius), Math.max($3179757e477018e0$var$r[1] + radius, -$3179757e477018e0$var$r[1] + radius));
    $2Ys9z.set(out.lowerBound, Math.min($3179757e477018e0$var$r[0] - radius, -$3179757e477018e0$var$r[0] - radius), Math.min($3179757e477018e0$var$r[1] - radius, -$3179757e477018e0$var$r[1] - radius));
    // Add offset
    $2Ys9z.add(out.lowerBound, out.lowerBound, position);
    $2Ys9z.add(out.upperBound, out.upperBound, position);
};
var $3179757e477018e0$var$intersectCapsule_hitPointWorld = $2Ys9z.create();
var $3179757e477018e0$var$intersectCapsule_normal = $2Ys9z.create();
var $3179757e477018e0$var$intersectCapsule_l0 = $2Ys9z.create();
var $3179757e477018e0$var$intersectCapsule_l1 = $2Ys9z.create();
var $3179757e477018e0$var$intersectCapsule_unit_y = $2Ys9z.fromValues(0, 1);
/**
 * @method raycast
 * @param  {RaycastResult} result
 * @param  {Ray} ray
 * @param  {array} position
 * @param  {number} angle
 */ $3179757e477018e0$var$Capsule.prototype.raycast = function(result, ray, position, angle) {
    var from = ray.from;
    var to = ray.to;
    var direction = ray.direction;
    var hitPointWorld = $3179757e477018e0$var$intersectCapsule_hitPointWorld;
    var normal = $3179757e477018e0$var$intersectCapsule_normal;
    var l0 = $3179757e477018e0$var$intersectCapsule_l0;
    var l1 = $3179757e477018e0$var$intersectCapsule_l1;
    // The sides
    var halfLen = this.length / 2;
    for(var i = 0; i < 2; i++){
        // get start and end of the line
        var y = this.radius * (i * 2 - 1);
        $2Ys9z.set(l0, -halfLen, y);
        $2Ys9z.set(l1, halfLen, y);
        $2Ys9z.toGlobalFrame(l0, l0, position, angle);
        $2Ys9z.toGlobalFrame(l1, l1, position, angle);
        var delta = $2Ys9z.getLineSegmentsIntersectionFraction(from, to, l0, l1);
        if (delta >= 0) {
            $2Ys9z.rotate(normal, $3179757e477018e0$var$intersectCapsule_unit_y, angle);
            $2Ys9z.scale(normal, normal, i * 2 - 1);
            ray.reportIntersection(result, delta, normal, -1);
            if (result.shouldStop(ray)) return;
        }
    }
    // Circles
    var diagonalLengthSquared = Math.pow(this.radius, 2) + Math.pow(halfLen, 2);
    for(var i = 0; i < 2; i++){
        $2Ys9z.set(l0, halfLen * (i * 2 - 1), 0);
        $2Ys9z.toGlobalFrame(l0, l0, position, angle);
        var a = Math.pow(to[0] - from[0], 2) + Math.pow(to[1] - from[1], 2);
        var b = 2 * ((to[0] - from[0]) * (from[0] - l0[0]) + (to[1] - from[1]) * (from[1] - l0[1]));
        var c = Math.pow(from[0] - l0[0], 2) + Math.pow(from[1] - l0[1], 2) - Math.pow(this.radius, 2);
        var delta = Math.pow(b, 2) - 4 * a * c;
        if (delta < 0) continue;
        else if (delta === 0) {
            // single intersection point
            $2Ys9z.lerp(hitPointWorld, from, to, delta);
            if ($2Ys9z.squaredDistance(hitPointWorld, position) > diagonalLengthSquared) {
                $2Ys9z.sub(normal, hitPointWorld, l0);
                $2Ys9z.normalize(normal, normal);
                ray.reportIntersection(result, delta, normal, -1);
                if (result.shouldStop(ray)) return;
            }
        } else {
            var sqrtDelta = Math.sqrt(delta);
            var inv2a = 1 / (2 * a);
            var d1 = (-b - sqrtDelta) * inv2a;
            var d2 = (-b + sqrtDelta) * inv2a;
            if (d1 >= 0 && d1 <= 1) {
                $2Ys9z.lerp(hitPointWorld, from, to, d1);
                if ($2Ys9z.squaredDistance(hitPointWorld, position) > diagonalLengthSquared) {
                    $2Ys9z.sub(normal, hitPointWorld, l0);
                    $2Ys9z.normalize(normal, normal);
                    ray.reportIntersection(result, d1, normal, -1);
                    if (result.shouldStop(ray)) return;
                }
            }
            if (d2 >= 0 && d2 <= 1) {
                $2Ys9z.lerp(hitPointWorld, from, to, d2);
                if ($2Ys9z.squaredDistance(hitPointWorld, position) > diagonalLengthSquared) {
                    $2Ys9z.sub(normal, hitPointWorld, l0);
                    $2Ys9z.normalize(normal, normal);
                    ray.reportIntersection(result, d2, normal, -1);
                    if (result.shouldStop(ray)) return;
                }
            }
        }
    }
};

});

parcelRegister("OJ0UJ", function(module, exports) {

var $k7z01 = parcelRequire("k7z01");

var $2Ys9z = parcelRequire("2Ys9z");
module.exports = $0987966afaa2e433$var$Circle;
/**
 * Circle shape class.
 * @class Circle
 * @extends Shape
 * @constructor
 * @param {options} [options] (Note that this options object will be passed on to the {{#crossLink "Shape"}}{{/crossLink}} constructor.)
 * @param {number} [options.radius=1] The radius of this circle
 *
 * @example
 *     var circleShape = new Circle({ radius: 1 });
 *     body.addShape(circleShape);
 */ function $0987966afaa2e433$var$Circle(options) {
    if (typeof arguments[0] === "number") {
        options = {
            radius: arguments[0]
        };
        console.warn("The Circle constructor signature has changed. Please use the following format: new Circle({ radius: 1 })");
    }
    options = options || {};
    /**
     * The radius of the circle.
     * @property radius
     * @type {number}
     */ this.radius = options.radius || 1;
    options.type = $k7z01.CIRCLE;
    $k7z01.call(this, options);
}
$0987966afaa2e433$var$Circle.prototype = new $k7z01();
$0987966afaa2e433$var$Circle.prototype.constructor = $0987966afaa2e433$var$Circle;
/**
 * @method computeMomentOfInertia
 * @param  {Number} mass
 * @return {Number}
 */ $0987966afaa2e433$var$Circle.prototype.computeMomentOfInertia = function(mass) {
    var r = this.radius;
    return mass * r * r / 2;
};
/**
 * @method updateBoundingRadius
 * @return {Number}
 */ $0987966afaa2e433$var$Circle.prototype.updateBoundingRadius = function() {
    this.boundingRadius = this.radius;
};
/**
 * @method updateArea
 * @return {Number}
 */ $0987966afaa2e433$var$Circle.prototype.updateArea = function() {
    this.area = Math.PI * this.radius * this.radius;
};
/**
 * @method computeAABB
 * @param  {AABB}   out      The resulting AABB.
 * @param  {Array}  position
 * @param  {Number} angle
 */ $0987966afaa2e433$var$Circle.prototype.computeAABB = function(out, position, angle) {
    var r = this.radius;
    $2Ys9z.set(out.upperBound, r, r);
    $2Ys9z.set(out.lowerBound, -r, -r);
    if (position) {
        $2Ys9z.add(out.lowerBound, out.lowerBound, position);
        $2Ys9z.add(out.upperBound, out.upperBound, position);
    }
};
var $0987966afaa2e433$var$Ray_intersectSphere_intersectionPoint = $2Ys9z.create();
var $0987966afaa2e433$var$Ray_intersectSphere_normal = $2Ys9z.create();
/**
 * @method raycast
 * @param  {RaycastResult} result
 * @param  {Ray} ray
 * @param  {array} position
 * @param  {number} angle
 */ $0987966afaa2e433$var$Circle.prototype.raycast = function(result, ray, position, angle) {
    var from = ray.from, to = ray.to, r = this.radius;
    var a = Math.pow(to[0] - from[0], 2) + Math.pow(to[1] - from[1], 2);
    var b = 2 * ((to[0] - from[0]) * (from[0] - position[0]) + (to[1] - from[1]) * (from[1] - position[1]));
    var c = Math.pow(from[0] - position[0], 2) + Math.pow(from[1] - position[1], 2) - Math.pow(r, 2);
    var delta = Math.pow(b, 2) - 4 * a * c;
    var intersectionPoint = $0987966afaa2e433$var$Ray_intersectSphere_intersectionPoint;
    var normal = $0987966afaa2e433$var$Ray_intersectSphere_normal;
    if (delta < 0) // No intersection
    return;
    else if (delta === 0) {
        // single intersection point
        $2Ys9z.lerp(intersectionPoint, from, to, delta);
        $2Ys9z.sub(normal, intersectionPoint, position);
        $2Ys9z.normalize(normal, normal);
        ray.reportIntersection(result, delta, normal, -1);
    } else {
        var sqrtDelta = Math.sqrt(delta);
        var inv2a = 1 / (2 * a);
        var d1 = (-b - sqrtDelta) * inv2a;
        var d2 = (-b + sqrtDelta) * inv2a;
        if (d1 >= 0 && d1 <= 1) {
            $2Ys9z.lerp(intersectionPoint, from, to, d1);
            $2Ys9z.sub(normal, intersectionPoint, position);
            $2Ys9z.normalize(normal, normal);
            ray.reportIntersection(result, d1, normal, -1);
            if (result.shouldStop(ray)) return;
        }
        if (d2 >= 0 && d2 <= 1) {
            $2Ys9z.lerp(intersectionPoint, from, to, d2);
            $2Ys9z.sub(normal, intersectionPoint, position);
            $2Ys9z.normalize(normal, normal);
            ray.reportIntersection(result, d2, normal, -1);
        }
    }
};

});

parcelRegister("3iby4", function(module, exports) {
module.exports = $265c02d6433a735e$var$Constraint;

var $dMz05 = parcelRequire("dMz05");
/**
 * Base constraint class.
 *
 * @class Constraint
 * @constructor
 * @author schteppe
 * @param {Body} bodyA
 * @param {Body} bodyB
 * @param {Number} type
 * @param {Object} [options]
 * @param {Object} [options.collideConnected=true]
 */ function $265c02d6433a735e$var$Constraint(bodyA, bodyB, type, options) {
    /**
     * The type of constraint. May be one of Constraint.DISTANCE, Constraint.GEAR, Constraint.LOCK, Constraint.PRISMATIC or Constraint.REVOLUTE.
     * @property {number} type
     */ this.type = type;
    options = $dMz05.defaults(options, {
        collideConnected: true,
        wakeUpBodies: true
    });
    /**
     * Equations to be solved in this constraint
     *
     * @property equations
     * @type {Array}
     */ this.equations = [];
    /**
     * First body participating in the constraint.
     * @property bodyA
     * @type {Body}
     */ this.bodyA = bodyA;
    /**
     * Second body participating in the constraint.
     * @property bodyB
     * @type {Body}
     */ this.bodyB = bodyB;
    /**
     * Set to true if you want the connected bodies to collide.
     * @property collideConnected
     * @type {Boolean}
     * @default true
     */ this.collideConnected = options.collideConnected;
    // Wake up bodies when connected
    if (options.wakeUpBodies) {
        if (bodyA) bodyA.wakeUp();
        if (bodyB) bodyB.wakeUp();
    }
}
/**
 * Updates the internal constraint parameters before solve.
 * @method update
 */ $265c02d6433a735e$var$Constraint.prototype.update = function() {
    throw new Error("method update() not implmemented in this Constraint subclass!");
};
/**
 * @static
 * @property {number} DISTANCE
 */ $265c02d6433a735e$var$Constraint.DISTANCE = 1;
/**
 * @static
 * @property {number} GEAR
 */ $265c02d6433a735e$var$Constraint.GEAR = 2;
/**
 * @static
 * @property {number} LOCK
 */ $265c02d6433a735e$var$Constraint.LOCK = 3;
/**
 * @static
 * @property {number} PRISMATIC
 */ $265c02d6433a735e$var$Constraint.PRISMATIC = 4;
/**
 * @static
 * @property {number} REVOLUTE
 */ $265c02d6433a735e$var$Constraint.REVOLUTE = 5;
/**
 * Set stiffness for this constraint.
 * @method setStiffness
 * @param {Number} stiffness
 */ $265c02d6433a735e$var$Constraint.prototype.setStiffness = function(stiffness) {
    var eqs = this.equations;
    for(var i = 0; i !== eqs.length; i++){
        var eq = eqs[i];
        eq.stiffness = stiffness;
        eq.needsUpdate = true;
    }
};
/**
 * Set relaxation for this constraint.
 * @method setRelaxation
 * @param {Number} relaxation
 */ $265c02d6433a735e$var$Constraint.prototype.setRelaxation = function(relaxation) {
    var eqs = this.equations;
    for(var i = 0; i !== eqs.length; i++){
        var eq = eqs[i];
        eq.relaxation = relaxation;
        eq.needsUpdate = true;
    }
};

});

parcelRegister("cSwh0", function(module, exports) {

var $f0tQu = parcelRequire("f0tQu");

var $2Ys9z = parcelRequire("2Ys9z");
module.exports = $96038ffecb9a9a01$var$ContactEquation;
/**
 * Non-penetration constraint equation. Tries to make the contactPointA and contactPointB vectors coincide, while keeping the applied force repulsive.
 *
 * @class ContactEquation
 * @constructor
 * @extends Equation
 * @param {Body} bodyA
 * @param {Body} bodyB
 */ function $96038ffecb9a9a01$var$ContactEquation(bodyA, bodyB) {
    $f0tQu.call(this, bodyA, bodyB, 0, Number.MAX_VALUE);
    /**
     * Vector from body i center of mass to the contact point.
     * @property contactPointA
     * @type {Array}
     */ this.contactPointA = $2Ys9z.create();
    this.penetrationVec = $2Ys9z.create();
    /**
     * World-oriented vector from body A center of mass to the contact point.
     * @property contactPointB
     * @type {Array}
     */ this.contactPointB = $2Ys9z.create();
    /**
     * The normal vector, pointing out of body i
     * @property normalA
     * @type {Array}
     */ this.normalA = $2Ys9z.create();
    /**
     * The restitution to use (0=no bounciness, 1=max bounciness).
     * @property restitution
     * @type {Number}
     */ this.restitution = 0;
    /**
     * This property is set to true if this is the first impact between the bodies (not persistant contact).
     * @property firstImpact
     * @type {Boolean}
     * @readOnly
     */ this.firstImpact = false;
    /**
     * The shape in body i that triggered this contact.
     * @property shapeA
     * @type {Shape}
     */ this.shapeA = null;
    /**
     * The shape in body j that triggered this contact.
     * @property shapeB
     * @type {Shape}
     */ this.shapeB = null;
}
$96038ffecb9a9a01$var$ContactEquation.prototype = new $f0tQu();
$96038ffecb9a9a01$var$ContactEquation.prototype.constructor = $96038ffecb9a9a01$var$ContactEquation;
$96038ffecb9a9a01$var$ContactEquation.prototype.computeB = function(a, b, h) {
    var bi = this.bodyA, bj = this.bodyB, ri = this.contactPointA, rj = this.contactPointB, xi = bi.position, xj = bj.position;
    var penetrationVec = this.penetrationVec, n = this.normalA, G = this.G;
    // Caluclate cross products
    var rixn = $2Ys9z.crossLength(ri, n), rjxn = $2Ys9z.crossLength(rj, n);
    // G = [-n -rixn n rjxn]
    G[0] = -n[0];
    G[1] = -n[1];
    G[2] = -rixn;
    G[3] = n[0];
    G[4] = n[1];
    G[5] = rjxn;
    // Calculate q = xj+rj -(xi+ri) i.e. the penetration vector
    $2Ys9z.add(penetrationVec, xj, rj);
    $2Ys9z.sub(penetrationVec, penetrationVec, xi);
    $2Ys9z.sub(penetrationVec, penetrationVec, ri);
    // Compute iteration
    var GW, Gq;
    if (this.firstImpact && this.restitution !== 0) {
        Gq = 0;
        GW = 1 / b * (1 + this.restitution) * this.computeGW();
    } else {
        Gq = $2Ys9z.dot(n, penetrationVec) + this.offset;
        GW = this.computeGW();
    }
    var GiMf = this.computeGiMf();
    var B = -Gq * a - GW * b - h * GiMf;
    return B;
};
var $96038ffecb9a9a01$var$vi = $2Ys9z.create();
var $96038ffecb9a9a01$var$vj = $2Ys9z.create();
var $96038ffecb9a9a01$var$relVel = $2Ys9z.create();
/**
 * Get the relative velocity along the normal vector.
 * @return {number}
 */ $96038ffecb9a9a01$var$ContactEquation.prototype.getVelocityAlongNormal = function() {
    this.bodyA.getVelocityAtPoint($96038ffecb9a9a01$var$vi, this.contactPointA);
    this.bodyB.getVelocityAtPoint($96038ffecb9a9a01$var$vj, this.contactPointB);
    $2Ys9z.subtract($96038ffecb9a9a01$var$relVel, $96038ffecb9a9a01$var$vi, $96038ffecb9a9a01$var$vj);
    return $2Ys9z.dot(this.normalA, $96038ffecb9a9a01$var$relVel);
};

});

parcelRegister("8P1Fq", function(module, exports) {

var $cSwh0 = parcelRequire("cSwh0");

var $kaNFS = parcelRequire("kaNFS");
module.exports = $66c4613b00481d00$var$ContactEquationPool;
/**
 * @class
 */ function $66c4613b00481d00$var$ContactEquationPool() {
    $kaNFS.apply(this, arguments);
}
$66c4613b00481d00$var$ContactEquationPool.prototype = new $kaNFS();
$66c4613b00481d00$var$ContactEquationPool.prototype.constructor = $66c4613b00481d00$var$ContactEquationPool;
/**
 * @method create
 * @return {ContactEquation}
 */ $66c4613b00481d00$var$ContactEquationPool.prototype.create = function() {
    return new $cSwh0();
};
/**
 * @method destroy
 * @param {ContactEquation} equation
 * @return {ContactEquationPool}
 */ $66c4613b00481d00$var$ContactEquationPool.prototype.destroy = function(equation) {
    equation.bodyA = equation.bodyB = null;
    return this;
};

});
parcelRegister("kaNFS", function(module, exports) {
module.exports = $eafb461b641e6378$var$Pool;
/**
 * @class Object pooling utility.
 */ function $eafb461b641e6378$var$Pool(options) {
    options = options || {};
    /**
	 * @property {Array} objects
	 * @type {Array}
	 */ this.objects = [];
    if (options.size !== undefined) this.resize(options.size);
}
/**
 * @method resize
 * @param {number} size
 * @return {Pool} Self, for chaining
 */ $eafb461b641e6378$var$Pool.prototype.resize = function(size) {
    var objects = this.objects;
    while(objects.length > size)objects.pop();
    while(objects.length < size)objects.push(this.create());
    return this;
};
/**
 * Get an object from the pool or create a new instance.
 * @method get
 * @return {Object}
 */ $eafb461b641e6378$var$Pool.prototype.get = function() {
    var objects = this.objects;
    return objects.length ? objects.pop() : this.create();
};
/**
 * Clean up and put the object back into the pool for later use.
 * @method release
 * @param {Object} object
 * @return {Pool} Self for chaining
 */ $eafb461b641e6378$var$Pool.prototype.release = function(object) {
    this.destroy(object);
    this.objects.push(object);
    return this;
};

});


parcelRegister("hzM8V", function(module, exports) {

var $kfn8e = parcelRequire("kfn8e");

var $f0tQu = parcelRequire("f0tQu");
module.exports = $ccbb0cb7a4ce210f$var$ContactMaterial;
/**
 * Defines what happens when two materials meet, such as what friction coefficient to use. You can also set other things such as restitution, surface velocity and constraint parameters.
 * @class ContactMaterial
 * @constructor
 * @param {Material} materialA
 * @param {Material} materialB
 * @param {Object}   [options]
 * @param {Number}   [options.friction=0.3]       Friction coefficient.
 * @param {Number}   [options.restitution=0]      Restitution coefficient aka "bounciness".
 * @param {Number}   [options.stiffness]          ContactEquation stiffness.
 * @param {Number}   [options.relaxation]         ContactEquation relaxation.
 * @param {Number}   [options.frictionStiffness]  FrictionEquation stiffness.
 * @param {Number}   [options.frictionRelaxation] FrictionEquation relaxation.
 * @param {Number}   [options.surfaceVelocity=0]  Surface velocity.
 * @author schteppe
 */ function $ccbb0cb7a4ce210f$var$ContactMaterial(materialA, materialB, options) {
    options = options || {};
    if (!(materialA instanceof $kfn8e) || !(materialB instanceof $kfn8e)) throw new Error("First two arguments must be Material instances.");
    /**
     * The contact material identifier
     * @property id
     * @type {Number}
     */ this.id = $ccbb0cb7a4ce210f$var$ContactMaterial.idCounter++;
    /**
     * First material participating in the contact material
     * @property materialA
     * @type {Material}
     */ this.materialA = materialA;
    /**
     * Second material participating in the contact material
     * @property materialB
     * @type {Material}
     */ this.materialB = materialB;
    /**
     * Friction coefficient to use in the contact of these two materials. Friction = 0 will make the involved objects super slippery, and friction = 1 will make it much less slippery. A friction coefficient larger than 1 will allow for very large friction forces, which can be convenient for preventing car tires not slip on the ground.
     * @property friction
     * @type {Number}
     * @default 0.3
     */ this.friction = typeof options.friction !== "undefined" ? Number(options.friction) : 0.3;
    /**
     * Restitution, or "bounciness" to use in the contact of these two materials. A restitution of 0 will make no bounce, while restitution=1 will approximately bounce back with the same velocity the object came with.
     * @property restitution
     * @type {Number}
     * @default 0
     */ this.restitution = typeof options.restitution !== "undefined" ? Number(options.restitution) : 0;
    /**
     * Hardness of the contact. Less stiffness will make the objects penetrate more, and will make the contact act more like a spring than a contact force. Default value is {{#crossLink "Equation/DEFAULT_STIFFNESS:property"}}Equation.DEFAULT_STIFFNESS{{/crossLink}}.
     * @property stiffness
     * @type {Number}
     */ this.stiffness = typeof options.stiffness !== "undefined" ? Number(options.stiffness) : $f0tQu.DEFAULT_STIFFNESS;
    /**
     * Relaxation of the resulting ContactEquation that this ContactMaterial generate. Default value is {{#crossLink "Equation/DEFAULT_RELAXATION:property"}}Equation.DEFAULT_RELAXATION{{/crossLink}}.
     * @property relaxation
     * @type {Number}
     */ this.relaxation = typeof options.relaxation !== "undefined" ? Number(options.relaxation) : $f0tQu.DEFAULT_RELAXATION;
    /**
     * Stiffness of the resulting friction force. For most cases, the value of this property should be a large number. I cannot think of any case where you would want less frictionStiffness. Default value is {{#crossLink "Equation/DEFAULT_STIFFNESS:property"}}Equation.DEFAULT_STIFFNESS{{/crossLink}}.
     * @property frictionStiffness
     * @type {Number}
     */ this.frictionStiffness = typeof options.frictionStiffness !== "undefined" ? Number(options.frictionStiffness) : $f0tQu.DEFAULT_STIFFNESS;
    /**
     * Relaxation of the resulting friction force. The default value should be good for most simulations. Default value is {{#crossLink "Equation/DEFAULT_RELAXATION:property"}}Equation.DEFAULT_RELAXATION{{/crossLink}}.
     * @property frictionRelaxation
     * @type {Number}
     */ this.frictionRelaxation = typeof options.frictionRelaxation !== "undefined" ? Number(options.frictionRelaxation) : $f0tQu.DEFAULT_RELAXATION;
    /**
     * Will add surface velocity to this material. If bodyA rests on top if bodyB, and the surface velocity is positive, bodyA will slide to the right.
     * @property {Number} surfaceVelocity
     * @default 0
     */ this.surfaceVelocity = typeof options.surfaceVelocity !== "undefined" ? Number(options.surfaceVelocity) : 0;
    /**
     * Offset to be set on ContactEquations. A positive value will make the bodies penetrate more into each other. Can be useful in scenes where contacts need to be more persistent, for example when stacking. Aka "cure for nervous contacts".
     * @property contactSkinSize
     * @type {Number}
     */ this.contactSkinSize = 0.005;
}
$ccbb0cb7a4ce210f$var$ContactMaterial.idCounter = 0;

});
parcelRegister("kfn8e", function(module, exports) {
module.exports = $ebd726d555576f25$var$Material;
/**
 * Defines a physics material.
 * @class Material
 * @constructor
 * @param {number} id Material identifier
 * @author schteppe
 */ function $ebd726d555576f25$var$Material(id) {
    /**
     * The material identifier
     * @property id
     * @type {Number}
     */ this.id = id || $ebd726d555576f25$var$Material.idCounter++;
}
$ebd726d555576f25$var$Material.idCounter = 0;

});


parcelRegister("2pi2h", function(module, exports) {

var $3iby4 = parcelRequire("3iby4");

var $f0tQu = parcelRequire("f0tQu");

var $2Ys9z = parcelRequire("2Ys9z");

var $dMz05 = parcelRequire("dMz05");
module.exports = $1c0be813d760ad79$var$DistanceConstraint;
/**
 * Constraint that tries to keep the distance between two bodies constant.
 *
 * @class DistanceConstraint
 * @constructor
 * @author schteppe
 * @param {Body} bodyA
 * @param {Body} bodyB
 * @param {object} [options]
 * @param {number} [options.distance] The distance to keep between the anchor points. Defaults to the current distance between the bodies.
 * @param {Array} [options.localAnchorA] The anchor point for bodyA, defined locally in bodyA frame. Defaults to [0,0].
 * @param {Array} [options.localAnchorB] The anchor point for bodyB, defined locally in bodyB frame. Defaults to [0,0].
 * @param {object} [options.maxForce=Number.MAX_VALUE] Maximum force to apply.
 * @extends Constraint
 *
 * @example
 *     // If distance is not given as an option, then the current distance between the bodies is used.
 *     // In this example, the bodies will be constrained to have a distance of 2 between their centers.
 *     var bodyA = new Body({ mass: 1, position: [-1, 0] });
 *     var bodyB = new Body({ mass: 1, position: [1, 0] });
 *     var constraint = new DistanceConstraint(bodyA, bodyB);
 *     world.addConstraint(constraint);
 *
 * @example
 *     // Manually set the distance and anchors
 *     var constraint = new DistanceConstraint(bodyA, bodyB, {
 *         distance: 1,          // Distance to keep between the points
 *         localAnchorA: [1, 0], // Point on bodyA
 *         localAnchorB: [-1, 0] // Point on bodyB
 *     });
 *     world.addConstraint(constraint);
 */ function $1c0be813d760ad79$var$DistanceConstraint(bodyA, bodyB, options) {
    options = $dMz05.defaults(options, {
        localAnchorA: [
            0,
            0
        ],
        localAnchorB: [
            0,
            0
        ]
    });
    $3iby4.call(this, bodyA, bodyB, $3iby4.DISTANCE, options);
    /**
     * Local anchor in body A.
     * @property localAnchorA
     * @type {Array}
     */ this.localAnchorA = $2Ys9z.fromValues(options.localAnchorA[0], options.localAnchorA[1]);
    /**
     * Local anchor in body B.
     * @property localAnchorB
     * @type {Array}
     */ this.localAnchorB = $2Ys9z.fromValues(options.localAnchorB[0], options.localAnchorB[1]);
    var localAnchorA = this.localAnchorA;
    var localAnchorB = this.localAnchorB;
    /**
     * The distance to keep.
     * @property distance
     * @type {Number}
     */ this.distance = 0;
    if (typeof options.distance === "number") this.distance = options.distance;
    else {
        // Use the current world distance between the world anchor points.
        var worldAnchorA = $2Ys9z.create(), worldAnchorB = $2Ys9z.create(), r = $2Ys9z.create();
        // Transform local anchors to world
        $2Ys9z.rotate(worldAnchorA, localAnchorA, bodyA.angle);
        $2Ys9z.rotate(worldAnchorB, localAnchorB, bodyB.angle);
        $2Ys9z.add(r, bodyB.position, worldAnchorB);
        $2Ys9z.sub(r, r, worldAnchorA);
        $2Ys9z.sub(r, r, bodyA.position);
        this.distance = $2Ys9z.length(r);
    }
    var maxForce;
    if (typeof options.maxForce === "undefined") maxForce = Number.MAX_VALUE;
    else maxForce = options.maxForce;
    var normal = new $f0tQu(bodyA, bodyB, -maxForce, maxForce); // Just in the normal direction
    this.equations = [
        normal
    ];
    /**
     * Max force to apply.
     * @property {number} maxForce
     */ this.maxForce = maxForce;
    // g = (xi - xj).dot(n)
    // dg/dt = (vi - vj).dot(n) = G*W = [n 0 -n 0] * [vi wi vj wj]'
    // ...and if we were to include offset points:
    // g =
    //      (xj + rj - xi - ri).dot(n) - distance
    //
    // dg/dt =
    //      (vj + wj x rj - vi - wi x ri).dot(n) =
    //      { term 2 is near zero } =
    //      [-n   -ri x n   n   rj x n] * [vi wi vj wj]' =
    //      G * W
    //
    // => G = [-n -rixn n rjxn]
    var r = $2Ys9z.create();
    var ri = $2Ys9z.create(); // worldAnchorA
    var rj = $2Ys9z.create(); // worldAnchorB
    var that = this;
    normal.computeGq = function() {
        var bodyA = this.bodyA, bodyB = this.bodyB, xi = bodyA.position, xj = bodyB.position;
        // Transform local anchors to world
        $2Ys9z.rotate(ri, localAnchorA, bodyA.angle);
        $2Ys9z.rotate(rj, localAnchorB, bodyB.angle);
        $2Ys9z.add(r, xj, rj);
        $2Ys9z.sub(r, r, ri);
        $2Ys9z.sub(r, r, xi);
        //vec2.sub(r, bodyB.position, bodyA.position);
        return $2Ys9z.length(r) - that.distance;
    };
    // Make the contact constraint bilateral
    this.setMaxForce(maxForce);
    /**
     * If the upper limit is enabled or not.
     * @property {Boolean} upperLimitEnabled
     */ this.upperLimitEnabled = false;
    /**
     * The upper constraint limit.
     * @property {number} upperLimit
     */ this.upperLimit = 1;
    /**
     * If the lower limit is enabled or not.
     * @property {Boolean} lowerLimitEnabled
     */ this.lowerLimitEnabled = false;
    /**
     * The lower constraint limit.
     * @property {number} lowerLimit
     */ this.lowerLimit = 0;
    /**
     * Current constraint position. This is equal to the current distance between the world anchor points.
     * @property {number} position
     */ this.position = 0;
}
$1c0be813d760ad79$var$DistanceConstraint.prototype = new $3iby4();
$1c0be813d760ad79$var$DistanceConstraint.prototype.constructor = $1c0be813d760ad79$var$DistanceConstraint;
/**
 * Update the constraint equations. Should be done if any of the bodies changed position, before solving.
 * @method update
 */ var $1c0be813d760ad79$var$n = $2Ys9z.create();
var $1c0be813d760ad79$var$ri = $2Ys9z.create(); // worldAnchorA
var $1c0be813d760ad79$var$rj = $2Ys9z.create(); // worldAnchorB
$1c0be813d760ad79$var$DistanceConstraint.prototype.update = function() {
    var normal = this.equations[0], bodyA = this.bodyA, bodyB = this.bodyB, distance = this.distance, xi = bodyA.position, xj = bodyB.position, normalEquation = this.equations[0], G = normal.G;
    // Transform local anchors to world
    $2Ys9z.rotate($1c0be813d760ad79$var$ri, this.localAnchorA, bodyA.angle);
    $2Ys9z.rotate($1c0be813d760ad79$var$rj, this.localAnchorB, bodyB.angle);
    // Get world anchor points and normal
    $2Ys9z.add($1c0be813d760ad79$var$n, xj, $1c0be813d760ad79$var$rj);
    $2Ys9z.sub($1c0be813d760ad79$var$n, $1c0be813d760ad79$var$n, $1c0be813d760ad79$var$ri);
    $2Ys9z.sub($1c0be813d760ad79$var$n, $1c0be813d760ad79$var$n, xi);
    this.position = $2Ys9z.length($1c0be813d760ad79$var$n);
    var violating = false;
    if (this.upperLimitEnabled) {
        if (this.position > this.upperLimit) {
            normalEquation.maxForce = 0;
            normalEquation.minForce = -this.maxForce;
            this.distance = this.upperLimit;
            violating = true;
        }
    }
    if (this.lowerLimitEnabled) {
        if (this.position < this.lowerLimit) {
            normalEquation.maxForce = this.maxForce;
            normalEquation.minForce = 0;
            this.distance = this.lowerLimit;
            violating = true;
        }
    }
    if ((this.lowerLimitEnabled || this.upperLimitEnabled) && !violating) {
        // No constraint needed.
        normalEquation.enabled = false;
        return;
    }
    normalEquation.enabled = true;
    $2Ys9z.normalize($1c0be813d760ad79$var$n, $1c0be813d760ad79$var$n);
    // Caluclate cross products
    var rixn = $2Ys9z.crossLength($1c0be813d760ad79$var$ri, $1c0be813d760ad79$var$n), rjxn = $2Ys9z.crossLength($1c0be813d760ad79$var$rj, $1c0be813d760ad79$var$n);
    // G = [-n -rixn n rjxn]
    G[0] = -$1c0be813d760ad79$var$n[0];
    G[1] = -$1c0be813d760ad79$var$n[1];
    G[2] = -rixn;
    G[3] = $1c0be813d760ad79$var$n[0];
    G[4] = $1c0be813d760ad79$var$n[1];
    G[5] = rjxn;
};
/**
 * Set the max force to be used
 * @method setMaxForce
 * @param {Number} maxForce
 */ $1c0be813d760ad79$var$DistanceConstraint.prototype.setMaxForce = function(maxForce) {
    var normal = this.equations[0];
    normal.minForce = -maxForce;
    normal.maxForce = maxForce;
};
/**
 * Get the max force
 * @method getMaxForce
 * @return {Number}
 */ $1c0be813d760ad79$var$DistanceConstraint.prototype.getMaxForce = function() {
    var normal = this.equations[0];
    return normal.maxForce;
};

});

parcelRegister("jNxse", function(module, exports) {

var $2Ys9z = parcelRequire("2Ys9z");

var $f0tQu = parcelRequire("f0tQu");
parcelRequire("dMz05");
module.exports = $e69c8b3dfcdeabae$var$FrictionEquation;
/**
 * Constrains the slipping in a contact along a tangent
 *
 * @class FrictionEquation
 * @constructor
 * @param {Body} bodyA
 * @param {Body} bodyB
 * @param {Number} slipForce
 * @extends Equation
 */ function $e69c8b3dfcdeabae$var$FrictionEquation(bodyA, bodyB, slipForce) {
    $f0tQu.call(this, bodyA, bodyB, -slipForce, slipForce);
    /**
     * Relative vector from center of body A to the contact point, world oriented.
     * @property contactPointA
     * @type {Array}
     */ this.contactPointA = $2Ys9z.create();
    /**
     * Relative vector from center of body B to the contact point, world oriented.
     * @property contactPointB
     * @type {Array}
     */ this.contactPointB = $2Ys9z.create();
    /**
     * Tangent vector that the friction force will act along. World oriented.
     * @property t
     * @type {Array}
     */ this.t = $2Ys9z.create();
    /**
     * ContactEquations connected to this friction equation. The contact equations can be used to rescale the max force for the friction. If more than one contact equation is given, then the max force can be set to the average.
     * @property contactEquations
     * @type {ContactEquation}
     */ this.contactEquations = [];
    /**
     * The shape in body i that triggered this friction.
     * @property shapeA
     * @type {Shape}
     * @todo Needed? The shape can be looked up via contactEquation.shapeA...
     */ this.shapeA = null;
    /**
     * The shape in body j that triggered this friction.
     * @property shapeB
     * @type {Shape}
     * @todo Needed? The shape can be looked up via contactEquation.shapeB...
     */ this.shapeB = null;
    /**
     * The friction coefficient to use.
     * @property frictionCoefficient
     * @type {Number}
     */ this.frictionCoefficient = 0.3;
}
$e69c8b3dfcdeabae$var$FrictionEquation.prototype = new $f0tQu();
$e69c8b3dfcdeabae$var$FrictionEquation.prototype.constructor = $e69c8b3dfcdeabae$var$FrictionEquation;
/**
 * Set the slipping condition for the constraint. The friction force cannot be
 * larger than this value.
 * @method setSlipForce
 * @param  {Number} slipForce
 */ $e69c8b3dfcdeabae$var$FrictionEquation.prototype.setSlipForce = function(slipForce) {
    this.maxForce = slipForce;
    this.minForce = -slipForce;
};
/**
 * Get the max force for the constraint.
 * @method getSlipForce
 * @return {Number}
 */ $e69c8b3dfcdeabae$var$FrictionEquation.prototype.getSlipForce = function() {
    return this.maxForce;
};
$e69c8b3dfcdeabae$var$FrictionEquation.prototype.computeB = function(a, b, h) {
    var bi = this.bodyA, bj = this.bodyB, ri = this.contactPointA, rj = this.contactPointB, t = this.t, G = this.G;
    // G = [-t -rixt t rjxt]
    // And remember, this is a pure velocity constraint, g is always zero!
    G[0] = -t[0];
    G[1] = -t[1];
    G[2] = -$2Ys9z.crossLength(ri, t);
    G[3] = t[0];
    G[4] = t[1];
    G[5] = $2Ys9z.crossLength(rj, t);
    var GW = this.computeGW(), GiMf = this.computeGiMf();
    var B = /* - g * a  */ -GW * b - h * GiMf;
    return B;
};

});

parcelRegister("gwWMZ", function(module, exports) {

var $jNxse = parcelRequire("jNxse");

var $kaNFS = parcelRequire("kaNFS");
module.exports = $c08d3cd3ab799811$var$FrictionEquationPool;
/**
 * @class
 */ function $c08d3cd3ab799811$var$FrictionEquationPool() {
    $kaNFS.apply(this, arguments);
}
$c08d3cd3ab799811$var$FrictionEquationPool.prototype = new $kaNFS();
$c08d3cd3ab799811$var$FrictionEquationPool.prototype.constructor = $c08d3cd3ab799811$var$FrictionEquationPool;
/**
 * @method create
 * @return {FrictionEquation}
 */ $c08d3cd3ab799811$var$FrictionEquationPool.prototype.create = function() {
    return new $jNxse();
};
/**
 * @method destroy
 * @param {FrictionEquation} equation
 * @return {FrictionEquationPool}
 */ $c08d3cd3ab799811$var$FrictionEquationPool.prototype.destroy = function(equation) {
    equation.bodyA = equation.bodyB = null;
    return this;
};

});

parcelRegister("bb1X1", function(module, exports) {

var $3iby4 = parcelRequire("3iby4");
parcelRequire("f0tQu");

var $5PEF1 = parcelRequire("5PEF1");
parcelRequire("2Ys9z");
module.exports = $82323c3c86809ad8$var$GearConstraint;
/**
 * Constrains the angle of two bodies to each other to be equal. If a gear ratio is not one, the angle of bodyA must be a multiple of the angle of bodyB.
 * @class GearConstraint
 * @constructor
 * @author schteppe
 * @param {Body}            bodyA
 * @param {Body}            bodyB
 * @param {Object}          [options]
 * @param {Number}          [options.angle=0] Relative angle between the bodies. Will be set to the current angle between the bodies (the gear ratio is accounted for).
 * @param {Number}          [options.ratio=1] Gear ratio.
 * @param {Number}          [options.maxTorque] Maximum torque to apply.
 * @extends Constraint
 *
 * @example
 *     var constraint = new GearConstraint(bodyA, bodyB);
 *     world.addConstraint(constraint);
 *
 * @example
 *     var constraint = new GearConstraint(bodyA, bodyB, {
 *         ratio: 2,
 *         maxTorque: 1000
 *     });
 *     world.addConstraint(constraint);
 */ function $82323c3c86809ad8$var$GearConstraint(bodyA, bodyB, options) {
    options = options || {};
    $3iby4.call(this, bodyA, bodyB, $3iby4.GEAR, options);
    /**
     * The gear ratio.
     * @property ratio
     * @type {Number}
     */ this.ratio = options.ratio !== undefined ? options.ratio : 1;
    /**
     * The relative angle
     * @property angle
     * @type {Number}
     */ this.angle = options.angle !== undefined ? options.angle : bodyB.angle - this.ratio * bodyA.angle;
    // Send same parameters to the equation
    options.angle = this.angle;
    options.ratio = this.ratio;
    this.equations = [
        new $5PEF1(bodyA, bodyB, options)
    ];
    // Set max torque
    if (options.maxTorque !== undefined) this.setMaxTorque(options.maxTorque);
}
$82323c3c86809ad8$var$GearConstraint.prototype = new $3iby4();
$82323c3c86809ad8$var$GearConstraint.prototype.constructor = $82323c3c86809ad8$var$GearConstraint;
$82323c3c86809ad8$var$GearConstraint.prototype.update = function() {
    var eq = this.equations[0];
    if (eq.ratio !== this.ratio) eq.setRatio(this.ratio);
    eq.angle = this.angle;
};
/**
 * Set the max torque for the constraint.
 * @method setMaxTorque
 * @param {Number} torque
 */ $82323c3c86809ad8$var$GearConstraint.prototype.setMaxTorque = function(torque) {
    this.equations[0].setMaxTorque(torque);
};
/**
 * Get the max torque for the constraint.
 * @method getMaxTorque
 * @return {Number}
 */ $82323c3c86809ad8$var$GearConstraint.prototype.getMaxTorque = function(torque) {
    return this.equations[0].maxForce;
};

});

parcelRegister("hejTV", function(module, exports) {

var $2Ys9z = parcelRequire("2Ys9z");

var $aZxNS = parcelRequire("aZxNS");

var $dMz05 = parcelRequire("dMz05");

var $jNxse = parcelRequire("jNxse");
module.exports = $c8b32e6144340a1d$var$GSSolver;
/**
 * Iterative Gauss-Seidel constraint equation solver.
 *
 * @class GSSolver
 * @constructor
 * @extends Solver
 * @param {Object} [options]
 * @param {Number} [options.iterations=10]
 * @param {Number} [options.tolerance=0]
 */ function $c8b32e6144340a1d$var$GSSolver(options) {
    $aZxNS.call(this, options, $aZxNS.GS);
    options = options || {};
    /**
     * The max number of iterations to do when solving. More gives better results, but is more expensive.
     * @property iterations
     * @type {Number}
     */ this.iterations = options.iterations || 10;
    /**
     * The error tolerance, per constraint. If the total error is below this limit, the solver will stop iterating. Set to zero for as good solution as possible, but to something larger than zero to make computations faster.
     * @property tolerance
     * @type {Number}
     * @default 1e-7
     */ this.tolerance = options.tolerance || 1e-7;
    this.arrayStep = 30;
    this.lambda = new $dMz05.ARRAY_TYPE(this.arrayStep);
    this.Bs = new $dMz05.ARRAY_TYPE(this.arrayStep);
    this.invCs = new $dMz05.ARRAY_TYPE(this.arrayStep);
    /**
     * Set to true to set all right hand side terms to zero when solving. Can be handy for a few applications.
     * @property useZeroRHS
     * @type {Boolean}
     * @todo Remove, not used
     */ this.useZeroRHS = false;
    /**
     * Number of solver iterations that are used to approximate normal forces used for friction (F_friction = mu * F_normal). These friction forces will override any other friction forces that are set. If you set frictionIterations = 0, then this feature will be disabled.
     *
     * Use only frictionIterations > 0 if the approximated normal force (F_normal = mass * gravity) is not good enough. Examples of where it can happen is in space games where gravity is zero, or in tall stacks where the normal force is large at bottom but small at top.
     *
     * @property frictionIterations
     * @type {Number}
     * @default 0
     */ this.frictionIterations = options.frictionIterations !== undefined ? 0 : options.frictionIterations;
    /**
     * The number of iterations that were made during the last solve. If .tolerance is zero, this value will always be equal to .iterations, but if .tolerance is larger than zero, and the solver can quit early, then this number will be somewhere between 1 and .iterations.
     * @property {Number} usedIterations
     */ this.usedIterations = 0;
}
$c8b32e6144340a1d$var$GSSolver.prototype = new $aZxNS();
$c8b32e6144340a1d$var$GSSolver.prototype.constructor = $c8b32e6144340a1d$var$GSSolver;
function $c8b32e6144340a1d$var$setArrayZero(array) {
    var l = array.length;
    while(l--)array[l] = 0;
}
/**
 * Solve the system of equations
 * @method solve
 * @param  {Number}  h       Time step
 * @param  {World}   world    World to solve
 */ $c8b32e6144340a1d$var$GSSolver.prototype.solve = function(h, world) {
    this.sortEquations();
    var iter = 0, maxIter = this.iterations, maxFrictionIter = this.frictionIterations, equations = this.equations, Neq = equations.length, tolSquared = Math.pow(this.tolerance * Neq, 2), bodies = world.bodies, Nbodies = world.bodies.length, add = $2Ys9z.add, set = $2Ys9z.set, useZeroRHS = this.useZeroRHS, lambda = this.lambda;
    this.usedIterations = 0;
    if (Neq) for(var i = 0; i !== Nbodies; i++){
        var b = bodies[i];
        // Update solve mass
        b.updateSolveMassProperties();
    }
    // Things that does not change during iteration can be computed once
    if (lambda.length < Neq) {
        lambda = this.lambda = new $dMz05.ARRAY_TYPE(Neq + this.arrayStep);
        this.Bs = new $dMz05.ARRAY_TYPE(Neq + this.arrayStep);
        this.invCs = new $dMz05.ARRAY_TYPE(Neq + this.arrayStep);
    }
    $c8b32e6144340a1d$var$setArrayZero(lambda);
    var invCs = this.invCs, Bs = this.Bs, lambda = this.lambda;
    for(var i = 0; i !== equations.length; i++){
        var c = equations[i];
        if (c.timeStep !== h || c.needsUpdate) {
            c.timeStep = h;
            c.update();
        }
        Bs[i] = c.computeB(c.a, c.b, h);
        invCs[i] = c.computeInvC(c.epsilon);
    }
    var q, B, c, deltalambdaTot, i, j;
    if (Neq !== 0) {
        for(i = 0; i !== Nbodies; i++){
            var b = bodies[i];
            // Reset vlambda
            b.resetConstraintVelocity();
        }
        if (maxFrictionIter) {
            // Iterate over contact equations to get normal forces
            for(iter = 0; iter !== maxFrictionIter; iter++){
                // Accumulate the total error for each iteration.
                deltalambdaTot = 0.0;
                for(j = 0; j !== Neq; j++){
                    c = equations[j];
                    var deltalambda = $c8b32e6144340a1d$var$GSSolver.iterateEquation(j, c, c.epsilon, Bs, invCs, lambda, useZeroRHS, h, iter);
                    deltalambdaTot += Math.abs(deltalambda);
                }
                this.usedIterations++;
                // If the total error is small enough - stop iterate
                if (deltalambdaTot * deltalambdaTot <= tolSquared) break;
            }
            $c8b32e6144340a1d$var$GSSolver.updateMultipliers(equations, lambda, 1 / h);
            // Set computed friction force
            for(j = 0; j !== Neq; j++){
                var eq = equations[j];
                if (eq instanceof $jNxse) {
                    var f = 0.0;
                    for(var k = 0; k !== eq.contactEquations.length; k++)f += eq.contactEquations[k].multiplier;
                    f *= eq.frictionCoefficient / eq.contactEquations.length;
                    eq.maxForce = f;
                    eq.minForce = -f;
                }
            }
        }
        // Iterate over all equations
        for(iter = 0; iter !== maxIter; iter++){
            // Accumulate the total error for each iteration.
            deltalambdaTot = 0.0;
            for(j = 0; j !== Neq; j++){
                c = equations[j];
                var deltalambda = $c8b32e6144340a1d$var$GSSolver.iterateEquation(j, c, c.epsilon, Bs, invCs, lambda, useZeroRHS, h, iter);
                deltalambdaTot += Math.abs(deltalambda);
            }
            this.usedIterations++;
            // If the total error is small enough - stop iterate
            if (deltalambdaTot * deltalambdaTot <= tolSquared) break;
        }
        // Add result to velocity
        for(i = 0; i !== Nbodies; i++)bodies[i].addConstraintVelocity();
        $c8b32e6144340a1d$var$GSSolver.updateMultipliers(equations, lambda, 1 / h);
    }
};
// Sets the .multiplier property of each equation
$c8b32e6144340a1d$var$GSSolver.updateMultipliers = function(equations, lambda, invDt) {
    // Set the .multiplier property of each equation
    var l = equations.length;
    while(l--)equations[l].multiplier = lambda[l] * invDt;
};
$c8b32e6144340a1d$var$GSSolver.iterateEquation = function(j, eq, eps, Bs, invCs, lambda, useZeroRHS, dt, iter) {
    // Compute iteration
    var B = Bs[j], invC = invCs[j], lambdaj = lambda[j], GWlambda = eq.computeGWlambda();
    var maxForce = eq.maxForce, minForce = eq.minForce;
    if (useZeroRHS) B = 0;
    var deltalambda = invC * (B - GWlambda - eps * lambdaj);
    // Clamp if we are not within the min/max interval
    var lambdaj_plus_deltalambda = lambdaj + deltalambda;
    if (lambdaj_plus_deltalambda < minForce * dt) deltalambda = minForce * dt - lambdaj;
    else if (lambdaj_plus_deltalambda > maxForce * dt) deltalambda = maxForce * dt - lambdaj;
    lambda[j] += deltalambda;
    eq.addToWlambda(deltalambda);
    return deltalambda;
};

});
parcelRegister("aZxNS", function(module, exports) {
parcelRequire("dMz05");

var $5POlg = parcelRequire("5POlg");
module.exports = $8009d28ee8bf1079$var$Solver;
/**
 * Base class for constraint solvers.
 * @class Solver
 * @constructor
 * @extends EventEmitter
 */ function $8009d28ee8bf1079$var$Solver(options, type) {
    options = options || {};
    $5POlg.call(this);
    this.type = type;
    /**
     * Current equations in the solver.
     *
     * @property equations
     * @type {Array}
     */ this.equations = [];
    /**
     * Function that is used to sort all equations before each solve.
     * @property equationSortFunction
     * @type {function|boolean}
     */ this.equationSortFunction = options.equationSortFunction || false;
}
$8009d28ee8bf1079$var$Solver.prototype = new $5POlg();
$8009d28ee8bf1079$var$Solver.prototype.constructor = $8009d28ee8bf1079$var$Solver;
/**
 * Method to be implemented in each subclass
 * @method solve
 * @param  {Number} dt
 * @param  {World} world
 */ $8009d28ee8bf1079$var$Solver.prototype.solve = function(dt, world) {
    throw new Error("Solver.solve should be implemented by subclasses!");
};
var $8009d28ee8bf1079$var$mockWorld = {
    bodies: []
};
/**
 * Solves all constraints in an island.
 * @method solveIsland
 * @param  {Number} dt
 * @param  {Island} island
 */ $8009d28ee8bf1079$var$Solver.prototype.solveIsland = function(dt, island) {
    this.removeAllEquations();
    if (island.equations.length) {
        // Add equations to solver
        this.addEquations(island.equations);
        $8009d28ee8bf1079$var$mockWorld.bodies.length = 0;
        island.getBodies($8009d28ee8bf1079$var$mockWorld.bodies);
        // Solve
        if ($8009d28ee8bf1079$var$mockWorld.bodies.length) this.solve(dt, $8009d28ee8bf1079$var$mockWorld);
    }
};
/**
 * Sort all equations using the .equationSortFunction. Should be called by subclasses before solving.
 * @method sortEquations
 */ $8009d28ee8bf1079$var$Solver.prototype.sortEquations = function() {
    if (this.equationSortFunction) this.equations.sort(this.equationSortFunction);
};
/**
 * Add an equation to be solved.
 *
 * @method addEquation
 * @param {Equation} eq
 */ $8009d28ee8bf1079$var$Solver.prototype.addEquation = function(eq) {
    if (eq.enabled) this.equations.push(eq);
};
/**
 * Add equations. Same as .addEquation, but this time the argument is an array of Equations
 *
 * @method addEquations
 * @param {Array} eqs
 */ $8009d28ee8bf1079$var$Solver.prototype.addEquations = function(eqs) {
    //Utils.appendArray(this.equations,eqs);
    for(var i = 0, N = eqs.length; i !== N; i++){
        var eq = eqs[i];
        if (eq.enabled) this.equations.push(eq);
    }
};
/**
 * Remove an equation.
 *
 * @method removeEquation
 * @param {Equation} eq
 */ $8009d28ee8bf1079$var$Solver.prototype.removeEquation = function(eq) {
    var i = this.equations.indexOf(eq);
    if (i !== -1) this.equations.splice(i, 1);
};
/**
 * Remove all currently added equations.
 *
 * @method removeAllEquations
 */ $8009d28ee8bf1079$var$Solver.prototype.removeAllEquations = function() {
    this.equations.length = 0;
};
$8009d28ee8bf1079$var$Solver.GS = 1;
$8009d28ee8bf1079$var$Solver.ISLAND = 2;

});


parcelRegister("6Xtot", function(module, exports) {

var $k7z01 = parcelRequire("k7z01");

var $2Ys9z = parcelRequire("2Ys9z");
parcelRequire("dMz05");
module.exports = $510f0dbbb907ec6c$var$Heightfield;
/**
 * Heightfield shape class. Height data is given as an array. These data points are spread out evenly with a distance "elementWidth".
 * @class Heightfield
 * @extends Shape
 * @constructor
 * @param {object} [options] (Note that this options object will be passed on to the {{#crossLink "Shape"}}{{/crossLink}} constructor.)
 * @param {array} [options.heights] An array of Y values that will be used to construct the terrain.
 * @param {Number} [options.minValue] Minimum value of the data points in the data array. Will be computed automatically if not given.
 * @param {Number} [options.maxValue] Maximum value.
 * @param {Number} [options.elementWidth=0.1] World spacing between the data points in X direction.
 *
 * @example
 *     // Generate some height data (y-values).
 *     var heights = [];
 *     for(var i = 0; i < 1000; i++){
 *         var y = 0.5 * Math.cos(0.2 * i);
 *         heights.push(y);
 *     }
 *
 *     // Create the heightfield shape
 *     var heightfieldShape = new Heightfield({
 *         heights: heights,
 *         elementWidth: 1 // Distance between the data points in X direction
 *     });
 *     var heightfieldBody = new Body();
 *     heightfieldBody.addShape(heightfieldShape);
 *     world.addBody(heightfieldBody);
 *
 * @todo Should use a scale property with X and Y direction instead of just elementWidth
 */ function $510f0dbbb907ec6c$var$Heightfield(options) {
    if (Array.isArray(arguments[0])) {
        options = {
            heights: arguments[0]
        };
        if (typeof arguments[1] === "object") for(var key in arguments[1])options[key] = arguments[1][key];
        console.warn("The Heightfield constructor signature has changed. Please use the following format: new Heightfield({ heights: [...], ... })");
    }
    options = options || {};
    /**
     * An array of numbers, or height values, that are spread out along the x axis.
     * @property {array} heights
     */ this.heights = options.heights ? options.heights.slice(0) : [];
    /**
     * Max value of the heights
     * @property {number} maxValue
     */ this.maxValue = options.maxValue || null;
    /**
     * Max value of the heights
     * @property {number} minValue
     */ this.minValue = options.minValue || null;
    /**
     * The width of each element
     * @property {number} elementWidth
     */ this.elementWidth = options.elementWidth || 0.1;
    if (options.maxValue === undefined || options.minValue === undefined) this.updateMaxMinValues();
    options.type = $k7z01.HEIGHTFIELD;
    $k7z01.call(this, options);
}
$510f0dbbb907ec6c$var$Heightfield.prototype = new $k7z01();
$510f0dbbb907ec6c$var$Heightfield.prototype.constructor = $510f0dbbb907ec6c$var$Heightfield;
/**
 * Update the .minValue and the .maxValue
 * @method updateMaxMinValues
 */ $510f0dbbb907ec6c$var$Heightfield.prototype.updateMaxMinValues = function() {
    var data = this.heights;
    var maxValue = data[0];
    var minValue = data[0];
    for(var i = 0; i !== data.length; i++){
        var v = data[i];
        if (v > maxValue) maxValue = v;
        if (v < minValue) minValue = v;
    }
    this.maxValue = maxValue;
    this.minValue = minValue;
};
/**
 * @method computeMomentOfInertia
 * @param  {Number} mass
 * @return {Number}
 */ $510f0dbbb907ec6c$var$Heightfield.prototype.computeMomentOfInertia = function(mass) {
    return Number.MAX_VALUE;
};
$510f0dbbb907ec6c$var$Heightfield.prototype.updateBoundingRadius = function() {
    this.boundingRadius = Number.MAX_VALUE;
};
$510f0dbbb907ec6c$var$Heightfield.prototype.updateArea = function() {
    var data = this.heights, area = 0;
    for(var i = 0; i < data.length - 1; i++)area += (data[i] + data[i + 1]) / 2 * this.elementWidth;
    this.area = area;
};
var $510f0dbbb907ec6c$var$points = [
    $2Ys9z.create(),
    $2Ys9z.create(),
    $2Ys9z.create(),
    $2Ys9z.create()
];
/**
 * @method computeAABB
 * @param  {AABB}   out      The resulting AABB.
 * @param  {Array}  position
 * @param  {Number} angle
 */ $510f0dbbb907ec6c$var$Heightfield.prototype.computeAABB = function(out, position, angle) {
    $2Ys9z.set($510f0dbbb907ec6c$var$points[0], 0, this.maxValue);
    $2Ys9z.set($510f0dbbb907ec6c$var$points[1], this.elementWidth * this.heights.length, this.maxValue);
    $2Ys9z.set($510f0dbbb907ec6c$var$points[2], this.elementWidth * this.heights.length, this.minValue);
    $2Ys9z.set($510f0dbbb907ec6c$var$points[3], 0, this.minValue);
    out.setFromPoints($510f0dbbb907ec6c$var$points, position, angle);
};
/**
 * Get a line segment in the heightfield
 * @method getLineSegment
 * @param  {array} start Where to store the resulting start point
 * @param  {array} end Where to store the resulting end point
 * @param  {number} i
 */ $510f0dbbb907ec6c$var$Heightfield.prototype.getLineSegment = function(start, end, i) {
    var data = this.heights;
    var width = this.elementWidth;
    $2Ys9z.set(start, i * width, data[i]);
    $2Ys9z.set(end, (i + 1) * width, data[i + 1]);
};
$510f0dbbb907ec6c$var$Heightfield.prototype.getSegmentIndex = function(position) {
    return Math.floor(position[0] / this.elementWidth);
};
$510f0dbbb907ec6c$var$Heightfield.prototype.getClampedSegmentIndex = function(position) {
    var i = this.getSegmentIndex(position);
    i = Math.min(this.heights.length, Math.max(i, 0)); // clamp
    return i;
};
var $510f0dbbb907ec6c$var$intersectHeightfield_hitPointWorld = $2Ys9z.create();
var $510f0dbbb907ec6c$var$intersectHeightfield_worldNormal = $2Ys9z.create();
var $510f0dbbb907ec6c$var$intersectHeightfield_l0 = $2Ys9z.create();
var $510f0dbbb907ec6c$var$intersectHeightfield_l1 = $2Ys9z.create();
var $510f0dbbb907ec6c$var$intersectHeightfield_localFrom = $2Ys9z.create();
var $510f0dbbb907ec6c$var$intersectHeightfield_localTo = $2Ys9z.create();
var $510f0dbbb907ec6c$var$intersectHeightfield_unit_y = $2Ys9z.fromValues(0, 1);
// Returns 1 if the lines intersect, otherwise 0.
function $510f0dbbb907ec6c$var$getLineSegmentsIntersection(out, p0, p1, p2, p3) {
    var s1_x, s1_y, s2_x, s2_y;
    s1_x = p1[0] - p0[0];
    s1_y = p1[1] - p0[1];
    s2_x = p3[0] - p2[0];
    s2_y = p3[1] - p2[1];
    var s, t;
    s = (-s1_y * (p0[0] - p2[0]) + s1_x * (p0[1] - p2[1])) / (-s2_x * s1_y + s1_x * s2_y);
    t = (s2_x * (p0[1] - p2[1]) - s2_y * (p0[0] - p2[0])) / (-s2_x * s1_y + s1_x * s2_y);
    if (s >= 0 && s <= 1 && t >= 0 && t <= 1) {
        var intX = p0[0] + t * s1_x;
        var intY = p0[1] + t * s1_y;
        out[0] = intX;
        out[1] = intY;
        return t;
    }
    return -1; // No collision
}
/**
 * @method raycast
 * @param  {RayResult} result
 * @param  {Ray} ray
 * @param  {array} position
 * @param  {number} angle
 */ $510f0dbbb907ec6c$var$Heightfield.prototype.raycast = function(result, ray, position, angle) {
    var from = ray.from;
    var to = ray.to;
    var direction = ray.direction;
    var hitPointWorld = $510f0dbbb907ec6c$var$intersectHeightfield_hitPointWorld;
    var worldNormal = $510f0dbbb907ec6c$var$intersectHeightfield_worldNormal;
    var l0 = $510f0dbbb907ec6c$var$intersectHeightfield_l0;
    var l1 = $510f0dbbb907ec6c$var$intersectHeightfield_l1;
    var localFrom = $510f0dbbb907ec6c$var$intersectHeightfield_localFrom;
    var localTo = $510f0dbbb907ec6c$var$intersectHeightfield_localTo;
    // get local ray start and end
    $2Ys9z.toLocalFrame(localFrom, from, position, angle);
    $2Ys9z.toLocalFrame(localTo, to, position, angle);
    // Get the segment range
    var i0 = this.getClampedSegmentIndex(localFrom);
    var i1 = this.getClampedSegmentIndex(localTo);
    if (i0 > i1) {
        var tmp = i0;
        i0 = i1;
        i1 = tmp;
    }
    // The segments
    for(var i = 0; i < this.heights.length - 1; i++){
        this.getLineSegment(l0, l1, i);
        var t = $2Ys9z.getLineSegmentsIntersectionFraction(localFrom, localTo, l0, l1);
        if (t >= 0) {
            $2Ys9z.sub(worldNormal, l1, l0);
            $2Ys9z.rotate(worldNormal, worldNormal, angle + Math.PI / 2);
            $2Ys9z.normalize(worldNormal, worldNormal);
            ray.reportIntersection(result, t, worldNormal, -1);
            if (result.shouldStop(ray)) return;
        }
    }
};

});

parcelRegister("d7wN7", function(module, exports) {

var $k7z01 = parcelRequire("k7z01");

var $2Ys9z = parcelRequire("2Ys9z");
module.exports = $98d55d71a3dcbc9d$var$Line;
/**
 * Line shape class. The line shape is along the x direction, and stretches from [-length/2, 0] to [length/2,0].
 * @class Line
 * @param {object} [options] (Note that this options object will be passed on to the {{#crossLink "Shape"}}{{/crossLink}} constructor.)
 * @param {Number} [options.length=1] The total length of the line
 * @extends Shape
 * @constructor
 */ function $98d55d71a3dcbc9d$var$Line(options) {
    if (typeof arguments[0] === "number") {
        options = {
            length: arguments[0]
        };
        console.warn("The Line constructor signature has changed. Please use the following format: new Line({ length: 1, ... })");
    }
    options = options || {};
    /**
     * Length of this line
     * @property {Number} length
     * @default 1
     */ this.length = options.length || 1;
    options.type = $k7z01.LINE;
    $k7z01.call(this, options);
}
$98d55d71a3dcbc9d$var$Line.prototype = new $k7z01();
$98d55d71a3dcbc9d$var$Line.prototype.constructor = $98d55d71a3dcbc9d$var$Line;
$98d55d71a3dcbc9d$var$Line.prototype.computeMomentOfInertia = function(mass) {
    return mass * Math.pow(this.length, 2) / 12;
};
$98d55d71a3dcbc9d$var$Line.prototype.updateBoundingRadius = function() {
    this.boundingRadius = this.length / 2;
};
var $98d55d71a3dcbc9d$var$points = [
    $2Ys9z.create(),
    $2Ys9z.create()
];
/**
 * @method computeAABB
 * @param  {AABB}   out      The resulting AABB.
 * @param  {Array}  position
 * @param  {Number} angle
 */ $98d55d71a3dcbc9d$var$Line.prototype.computeAABB = function(out, position, angle) {
    var l2 = this.length / 2;
    $2Ys9z.set($98d55d71a3dcbc9d$var$points[0], -l2, 0);
    $2Ys9z.set($98d55d71a3dcbc9d$var$points[1], l2, 0);
    out.setFromPoints($98d55d71a3dcbc9d$var$points, position, angle, 0);
};
var $98d55d71a3dcbc9d$var$raycast_hitPoint = $2Ys9z.create();
var $98d55d71a3dcbc9d$var$raycast_normal = $2Ys9z.create();
var $98d55d71a3dcbc9d$var$raycast_l0 = $2Ys9z.create();
var $98d55d71a3dcbc9d$var$raycast_l1 = $2Ys9z.create();
var $98d55d71a3dcbc9d$var$raycast_unit_y = $2Ys9z.fromValues(0, 1);
/**
 * @method raycast
 * @param  {RaycastResult} result
 * @param  {Ray} ray
 * @param  {number} angle
 * @param  {array} position
 */ $98d55d71a3dcbc9d$var$Line.prototype.raycast = function(result, ray, position, angle) {
    var from = ray.from;
    var to = ray.to;
    var l0 = $98d55d71a3dcbc9d$var$raycast_l0;
    var l1 = $98d55d71a3dcbc9d$var$raycast_l1;
    // get start and end of the line
    var halfLen = this.length / 2;
    $2Ys9z.set(l0, -halfLen, 0);
    $2Ys9z.set(l1, halfLen, 0);
    $2Ys9z.toGlobalFrame(l0, l0, position, angle);
    $2Ys9z.toGlobalFrame(l1, l1, position, angle);
    var fraction = $2Ys9z.getLineSegmentsIntersectionFraction(l0, l1, from, to);
    if (fraction >= 0) {
        var normal = $98d55d71a3dcbc9d$var$raycast_normal;
        $2Ys9z.rotate(normal, $98d55d71a3dcbc9d$var$raycast_unit_y, angle); // todo: this should depend on which side the ray comes from
        ray.reportIntersection(result, fraction, normal, -1);
    }
};

});

parcelRegister("48dNO", function(module, exports) {

var $3iby4 = parcelRequire("3iby4");

var $2Ys9z = parcelRequire("2Ys9z");

var $f0tQu = parcelRequire("f0tQu");
module.exports = $30229da6f24f1f47$var$LockConstraint;
/**
 * Locks the relative position and rotation between two bodies.
 *
 * @class LockConstraint
 * @constructor
 * @author schteppe
 * @param {Body} bodyA
 * @param {Body} bodyB
 * @param {Object} [options]
 * @param {Array}  [options.localOffsetB] The offset of bodyB in bodyA's frame. If not given the offset is computed from current positions.
 * @param {number} [options.localAngleB] The angle of bodyB in bodyA's frame. If not given, the angle is computed from current angles.
 * @param {number} [options.maxForce]
 * @extends Constraint
 *
 * @example
 *     // Locks the relative position and rotation between bodyA and bodyB
 *     var constraint = new LockConstraint(bodyA, bodyB);
 *     world.addConstraint(constraint);
 */ function $30229da6f24f1f47$var$LockConstraint(bodyA, bodyB, options) {
    options = options || {};
    $3iby4.call(this, bodyA, bodyB, $3iby4.LOCK, options);
    var maxForce = typeof options.maxForce === "undefined" ? Number.MAX_VALUE : options.maxForce;
    var localAngleB = options.localAngleB || 0;
    // Use 3 equations:
    // gx =   (xj - xi - l) * xhat = 0
    // gy =   (xj - xi - l) * yhat = 0
    // gr =   (xi - xj + r) * that = 0
    //
    // ...where:
    //   l is the localOffsetB vector rotated to world in bodyA frame
    //   r is the same vector but reversed and rotated from bodyB frame
    //   xhat, yhat are world axis vectors
    //   that is the tangent of r
    //
    // For the first two constraints, we get
    // G*W = (vj - vi - ldot  ) * xhat
    //     = (vj - vi - wi x l) * xhat
    //
    // Since (wi x l) * xhat = (l x xhat) * wi, we get
    // G*W = [ -1   0   (-l x xhat)  1   0   0] * [vi wi vj wj]
    //
    // The last constraint gives
    // GW = (vi - vj + wj x r) * that
    //    = [  that   0  -that  (r x t) ]
    var x = new $f0tQu(bodyA, bodyB, -maxForce, maxForce), y = new $f0tQu(bodyA, bodyB, -maxForce, maxForce), rot = new $f0tQu(bodyA, bodyB, -maxForce, maxForce);
    var l = $2Ys9z.create(), g = $2Ys9z.create(), that = this;
    x.computeGq = function() {
        $2Ys9z.rotate(l, that.localOffsetB, bodyA.angle);
        $2Ys9z.sub(g, bodyB.position, bodyA.position);
        $2Ys9z.sub(g, g, l);
        return g[0];
    };
    y.computeGq = function() {
        $2Ys9z.rotate(l, that.localOffsetB, bodyA.angle);
        $2Ys9z.sub(g, bodyB.position, bodyA.position);
        $2Ys9z.sub(g, g, l);
        return g[1];
    };
    var r = $2Ys9z.create(), t = $2Ys9z.create();
    rot.computeGq = function() {
        $2Ys9z.rotate(r, that.localOffsetB, bodyB.angle - that.localAngleB);
        $2Ys9z.scale(r, r, -1);
        $2Ys9z.sub(g, bodyA.position, bodyB.position);
        $2Ys9z.add(g, g, r);
        $2Ys9z.rotate(t, r, -Math.PI / 2);
        $2Ys9z.normalize(t, t);
        return $2Ys9z.dot(g, t);
    };
    /**
     * The offset of bodyB in bodyA's frame.
     * @property {Array} localOffsetB
     */ this.localOffsetB = $2Ys9z.create();
    if (options.localOffsetB) $2Ys9z.copy(this.localOffsetB, options.localOffsetB);
    else {
        // Construct from current positions
        $2Ys9z.sub(this.localOffsetB, bodyB.position, bodyA.position);
        $2Ys9z.rotate(this.localOffsetB, this.localOffsetB, -bodyA.angle);
    }
    /**
     * The offset angle of bodyB in bodyA's frame.
     * @property {Number} localAngleB
     */ this.localAngleB = 0;
    if (typeof options.localAngleB === "number") this.localAngleB = options.localAngleB;
    else // Construct
    this.localAngleB = bodyB.angle - bodyA.angle;
    this.equations.push(x, y, rot);
    this.setMaxForce(maxForce);
}
$30229da6f24f1f47$var$LockConstraint.prototype = new $3iby4();
$30229da6f24f1f47$var$LockConstraint.prototype.constructor = $30229da6f24f1f47$var$LockConstraint;
/**
 * Set the maximum force to be applied.
 * @method setMaxForce
 * @param {Number} force
 */ $30229da6f24f1f47$var$LockConstraint.prototype.setMaxForce = function(force) {
    var eqs = this.equations;
    for(var i = 0; i < this.equations.length; i++){
        eqs[i].maxForce = force;
        eqs[i].minForce = -force;
    }
};
/**
 * Get the max force.
 * @method getMaxForce
 * @return {Number}
 */ $30229da6f24f1f47$var$LockConstraint.prototype.getMaxForce = function() {
    return this.equations[0].maxForce;
};
var $30229da6f24f1f47$var$l = $2Ys9z.create();
var $30229da6f24f1f47$var$r = $2Ys9z.create();
var $30229da6f24f1f47$var$t = $2Ys9z.create();
var $30229da6f24f1f47$var$xAxis = $2Ys9z.fromValues(1, 0);
var $30229da6f24f1f47$var$yAxis = $2Ys9z.fromValues(0, 1);
$30229da6f24f1f47$var$LockConstraint.prototype.update = function() {
    var x = this.equations[0], y = this.equations[1], rot = this.equations[2], bodyA = this.bodyA, bodyB = this.bodyB;
    $2Ys9z.rotate($30229da6f24f1f47$var$l, this.localOffsetB, bodyA.angle);
    $2Ys9z.rotate($30229da6f24f1f47$var$r, this.localOffsetB, bodyB.angle - this.localAngleB);
    $2Ys9z.scale($30229da6f24f1f47$var$r, $30229da6f24f1f47$var$r, -1);
    $2Ys9z.rotate($30229da6f24f1f47$var$t, $30229da6f24f1f47$var$r, Math.PI / 2);
    $2Ys9z.normalize($30229da6f24f1f47$var$t, $30229da6f24f1f47$var$t);
    x.G[0] = -1;
    x.G[1] = 0;
    x.G[2] = -$2Ys9z.crossLength($30229da6f24f1f47$var$l, $30229da6f24f1f47$var$xAxis);
    x.G[3] = 1;
    y.G[0] = 0;
    y.G[1] = -1;
    y.G[2] = -$2Ys9z.crossLength($30229da6f24f1f47$var$l, $30229da6f24f1f47$var$yAxis);
    y.G[4] = 1;
    rot.G[0] = -$30229da6f24f1f47$var$t[0];
    rot.G[1] = -$30229da6f24f1f47$var$t[1];
    rot.G[3] = $30229da6f24f1f47$var$t[0];
    rot.G[4] = $30229da6f24f1f47$var$t[1];
    rot.G[5] = $2Ys9z.crossLength($30229da6f24f1f47$var$r, $30229da6f24f1f47$var$t);
};

});

parcelRegister("3QUo8", function(module, exports) {

var $2Ys9z = parcelRequire("2Ys9z");
var $2ce1f7f3add6a2a7$var$sub = $2Ys9z.sub, $2ce1f7f3add6a2a7$var$add = $2Ys9z.add, $2ce1f7f3add6a2a7$var$dot = $2Ys9z.dot;
parcelRequire("dMz05");

var $8P1Fq = parcelRequire("8P1Fq");

var $gwWMZ = parcelRequire("gwWMZ");

var $jFBgF = parcelRequire("jFBgF");

var $f0tQu = parcelRequire("f0tQu");
parcelRequire("cSwh0");
parcelRequire("jNxse");

var $OJ0UJ = parcelRequire("OJ0UJ");

var $clDtn = parcelRequire("clDtn");

var $k7z01 = parcelRequire("k7z01");
parcelRequire("e7hLo");

var $62ywx = parcelRequire("62ywx");
module.exports = $2ce1f7f3add6a2a7$var$Narrowphase;
// Temp things
var $2ce1f7f3add6a2a7$var$yAxis = $2Ys9z.fromValues(0, 1);
var $2ce1f7f3add6a2a7$var$tmp1 = $2Ys9z.fromValues(0, 0), $2ce1f7f3add6a2a7$var$tmp2 = $2Ys9z.fromValues(0, 0), $2ce1f7f3add6a2a7$var$tmp3 = $2Ys9z.fromValues(0, 0), $2ce1f7f3add6a2a7$var$tmp4 = $2Ys9z.fromValues(0, 0), $2ce1f7f3add6a2a7$var$tmp5 = $2Ys9z.fromValues(0, 0), $2ce1f7f3add6a2a7$var$tmp6 = $2Ys9z.fromValues(0, 0), $2ce1f7f3add6a2a7$var$tmp7 = $2Ys9z.fromValues(0, 0), $2ce1f7f3add6a2a7$var$tmp8 = $2Ys9z.fromValues(0, 0), $2ce1f7f3add6a2a7$var$tmp9 = $2Ys9z.fromValues(0, 0), $2ce1f7f3add6a2a7$var$tmp10 = $2Ys9z.fromValues(0, 0), $2ce1f7f3add6a2a7$var$tmp11 = $2Ys9z.fromValues(0, 0), $2ce1f7f3add6a2a7$var$tmp12 = $2Ys9z.fromValues(0, 0), $2ce1f7f3add6a2a7$var$tmp13 = $2Ys9z.fromValues(0, 0), $2ce1f7f3add6a2a7$var$tmp14 = $2Ys9z.fromValues(0, 0), $2ce1f7f3add6a2a7$var$tmp15 = $2Ys9z.fromValues(0, 0), $2ce1f7f3add6a2a7$var$tmp16 = $2Ys9z.fromValues(0, 0), $2ce1f7f3add6a2a7$var$tmp17 = $2Ys9z.fromValues(0, 0), $2ce1f7f3add6a2a7$var$tmp18 = $2Ys9z.fromValues(0, 0), $2ce1f7f3add6a2a7$var$tmpArray = [];
/**
 * Narrowphase. Creates contacts and friction given shapes and transforms.
 * @class Narrowphase
 * @constructor
 */ function $2ce1f7f3add6a2a7$var$Narrowphase() {
    /**
     * @property contactEquations
     * @type {Array}
     */ this.contactEquations = [];
    /**
     * @property frictionEquations
     * @type {Array}
     */ this.frictionEquations = [];
    /**
     * Whether to make friction equations in the upcoming contacts.
     * @property enableFriction
     * @type {Boolean}
     */ this.enableFriction = true;
    /**
     * Whether to make equations enabled in upcoming contacts.
     * @property enabledEquations
     * @type {Boolean}
     */ this.enabledEquations = true;
    /**
     * The friction slip force to use when creating friction equations.
     * @property slipForce
     * @type {Number}
     */ this.slipForce = 10.0;
    /**
     * The friction value to use in the upcoming friction equations.
     * @property frictionCoefficient
     * @type {Number}
     */ this.frictionCoefficient = 0.3;
    /**
     * Will be the .relativeVelocity in each produced FrictionEquation.
     * @property {Number} surfaceVelocity
     */ this.surfaceVelocity = 0;
    /**
     * Keeps track of the allocated ContactEquations.
     * @property {ContactEquationPool} contactEquationPool
     *
     * @example
     *
     *     // Allocate a few equations before starting the simulation.
     *     // This way, no contact objects need to be created on the fly in the game loop.
     *     world.narrowphase.contactEquationPool.resize(1024);
     *     world.narrowphase.frictionEquationPool.resize(1024);
     */ this.contactEquationPool = new $8P1Fq({
        size: 32
    });
    /**
     * Keeps track of the allocated ContactEquations.
     * @property {FrictionEquationPool} frictionEquationPool
     */ this.frictionEquationPool = new $gwWMZ({
        size: 64
    });
    /**
     * The restitution value to use in the next contact equations.
     * @property restitution
     * @type {Number}
     */ this.restitution = 0;
    /**
     * The stiffness value to use in the next contact equations.
     * @property {Number} stiffness
     */ this.stiffness = $f0tQu.DEFAULT_STIFFNESS;
    /**
     * The stiffness value to use in the next contact equations.
     * @property {Number} stiffness
     */ this.relaxation = $f0tQu.DEFAULT_RELAXATION;
    /**
     * The stiffness value to use in the next friction equations.
     * @property frictionStiffness
     * @type {Number}
     */ this.frictionStiffness = $f0tQu.DEFAULT_STIFFNESS;
    /**
     * The relaxation value to use in the next friction equations.
     * @property frictionRelaxation
     * @type {Number}
     */ this.frictionRelaxation = $f0tQu.DEFAULT_RELAXATION;
    /**
     * Enable reduction of friction equations. If disabled, a box on a plane will generate 2 contact equations and 2 friction equations. If enabled, there will be only one friction equation. Same kind of simplifications are made  for all collision types.
     * @property enableFrictionReduction
     * @type {Boolean}
     * @deprecated This flag will be removed when the feature is stable enough.
     * @default true
     */ this.enableFrictionReduction = true;
    /**
     * Keeps track of the colliding bodies last step.
     * @private
     * @property collidingBodiesLastStep
     * @type {TupleDictionary}
     */ this.collidingBodiesLastStep = new $jFBgF();
    /**
     * Contact skin size value to use in the next contact equations.
     * @property {Number} contactSkinSize
     * @default 0.01
     */ this.contactSkinSize = 0.01;
}
var $2ce1f7f3add6a2a7$var$bodiesOverlap_shapePositionA = $2Ys9z.create();
var $2ce1f7f3add6a2a7$var$bodiesOverlap_shapePositionB = $2Ys9z.create();
/**
 * @method bodiesOverlap
 * @param  {Body} bodyA
 * @param  {Body} bodyB
 * @return {Boolean}
 * @todo shape world transforms are wrong
 */ $2ce1f7f3add6a2a7$var$Narrowphase.prototype.bodiesOverlap = function(bodyA, bodyB) {
    var shapePositionA = $2ce1f7f3add6a2a7$var$bodiesOverlap_shapePositionA;
    var shapePositionB = $2ce1f7f3add6a2a7$var$bodiesOverlap_shapePositionB;
    // Loop over all shapes of bodyA
    for(var k = 0, Nshapesi = bodyA.shapes.length; k !== Nshapesi; k++){
        var shapeA = bodyA.shapes[k];
        bodyA.toWorldFrame(shapePositionA, shapeA.position);
        // All shapes of body j
        for(var l = 0, Nshapesj = bodyB.shapes.length; l !== Nshapesj; l++){
            var shapeB = bodyB.shapes[l];
            bodyB.toWorldFrame(shapePositionB, shapeB.position);
            if (this[shapeA.type | shapeB.type](bodyA, shapeA, shapePositionA, shapeA.angle + bodyA.angle, bodyB, shapeB, shapePositionB, shapeB.angle + bodyB.angle, true)) return true;
        }
    }
    return false;
};
/**
 * Check if the bodies were in contact since the last reset().
 * @method collidedLastStep
 * @param  {Body} bodyA
 * @param  {Body} bodyB
 * @return {Boolean}
 */ $2ce1f7f3add6a2a7$var$Narrowphase.prototype.collidedLastStep = function(bodyA, bodyB) {
    var id1 = bodyA.id | 0, id2 = bodyB.id | 0;
    return !!this.collidingBodiesLastStep.get(id1, id2);
};
/**
 * Throws away the old equations and gets ready to create new
 * @method reset
 */ $2ce1f7f3add6a2a7$var$Narrowphase.prototype.reset = function() {
    this.collidingBodiesLastStep.reset();
    var eqs = this.contactEquations;
    var l = eqs.length;
    while(l--){
        var eq = eqs[l], id1 = eq.bodyA.id, id2 = eq.bodyB.id;
        this.collidingBodiesLastStep.set(id1, id2, true);
    }
    var ce = this.contactEquations, fe = this.frictionEquations;
    for(var i = 0; i < ce.length; i++)this.contactEquationPool.release(ce[i]);
    for(var i = 0; i < fe.length; i++)this.frictionEquationPool.release(fe[i]);
    // Reset
    this.contactEquations.length = this.frictionEquations.length = 0;
};
/**
 * Creates a ContactEquation, either by reusing an existing object or creating a new one.
 * @method createContactEquation
 * @param  {Body} bodyA
 * @param  {Body} bodyB
 * @return {ContactEquation}
 */ $2ce1f7f3add6a2a7$var$Narrowphase.prototype.createContactEquation = function(bodyA, bodyB, shapeA, shapeB) {
    var c = this.contactEquationPool.get();
    c.bodyA = bodyA;
    c.bodyB = bodyB;
    c.shapeA = shapeA;
    c.shapeB = shapeB;
    c.restitution = this.restitution;
    c.firstImpact = !this.collidedLastStep(bodyA, bodyB);
    c.stiffness = this.stiffness;
    c.relaxation = this.relaxation;
    c.needsUpdate = true;
    c.enabled = this.enabledEquations;
    c.offset = this.contactSkinSize;
    return c;
};
/**
 * Creates a FrictionEquation, either by reusing an existing object or creating a new one.
 * @method createFrictionEquation
 * @param  {Body} bodyA
 * @param  {Body} bodyB
 * @return {FrictionEquation}
 */ $2ce1f7f3add6a2a7$var$Narrowphase.prototype.createFrictionEquation = function(bodyA, bodyB, shapeA, shapeB) {
    var c = this.frictionEquationPool.get();
    c.bodyA = bodyA;
    c.bodyB = bodyB;
    c.shapeA = shapeA;
    c.shapeB = shapeB;
    c.setSlipForce(this.slipForce);
    c.frictionCoefficient = this.frictionCoefficient;
    c.relativeVelocity = this.surfaceVelocity;
    c.enabled = this.enabledEquations;
    c.needsUpdate = true;
    c.stiffness = this.frictionStiffness;
    c.relaxation = this.frictionRelaxation;
    c.contactEquations.length = 0;
    return c;
};
/**
 * Creates a FrictionEquation given the data in the ContactEquation. Uses same offset vectors ri and rj, but the tangent vector will be constructed from the collision normal.
 * @method createFrictionFromContact
 * @param  {ContactEquation} contactEquation
 * @return {FrictionEquation}
 */ $2ce1f7f3add6a2a7$var$Narrowphase.prototype.createFrictionFromContact = function(c) {
    var eq = this.createFrictionEquation(c.bodyA, c.bodyB, c.shapeA, c.shapeB);
    $2Ys9z.copy(eq.contactPointA, c.contactPointA);
    $2Ys9z.copy(eq.contactPointB, c.contactPointB);
    $2Ys9z.rotate90cw(eq.t, c.normalA);
    eq.contactEquations.push(c);
    return eq;
};
// Take the average N latest contact point on the plane.
$2ce1f7f3add6a2a7$var$Narrowphase.prototype.createFrictionFromAverage = function(numContacts) {
    var c = this.contactEquations[this.contactEquations.length - 1];
    var eq = this.createFrictionEquation(c.bodyA, c.bodyB, c.shapeA, c.shapeB);
    var bodyA = c.bodyA;
    var bodyB = c.bodyB;
    $2Ys9z.set(eq.contactPointA, 0, 0);
    $2Ys9z.set(eq.contactPointB, 0, 0);
    $2Ys9z.set(eq.t, 0, 0);
    for(var i = 0; i !== numContacts; i++){
        c = this.contactEquations[this.contactEquations.length - 1 - i];
        if (c.bodyA === bodyA) {
            $2Ys9z.add(eq.t, eq.t, c.normalA);
            $2Ys9z.add(eq.contactPointA, eq.contactPointA, c.contactPointA);
            $2Ys9z.add(eq.contactPointB, eq.contactPointB, c.contactPointB);
        } else {
            $2Ys9z.sub(eq.t, eq.t, c.normalA);
            $2Ys9z.add(eq.contactPointA, eq.contactPointA, c.contactPointB);
            $2Ys9z.add(eq.contactPointB, eq.contactPointB, c.contactPointA);
        }
        eq.contactEquations.push(c);
    }
    var invNumContacts = 1 / numContacts;
    $2Ys9z.scale(eq.contactPointA, eq.contactPointA, invNumContacts);
    $2Ys9z.scale(eq.contactPointB, eq.contactPointB, invNumContacts);
    $2Ys9z.normalize(eq.t, eq.t);
    $2Ys9z.rotate90cw(eq.t, eq.t);
    return eq;
};
/**
 * Convex/line narrowphase
 * @method convexLine
 * @param  {Body}       convexBody
 * @param  {Convex}     convexShape
 * @param  {Array}      convexOffset
 * @param  {Number}     convexAngle
 * @param  {Body}       lineBody
 * @param  {Line}       lineShape
 * @param  {Array}      lineOffset
 * @param  {Number}     lineAngle
 * @param {boolean}     justTest
 * @todo Implement me!
 */ $2ce1f7f3add6a2a7$var$Narrowphase.prototype[$k7z01.LINE | $k7z01.CONVEX] = $2ce1f7f3add6a2a7$var$Narrowphase.prototype.convexLine = function(convexBody, convexShape, convexOffset, convexAngle, lineBody, lineShape, lineOffset, lineAngle, justTest) {
    // TODO
    if (justTest) return false;
    else return 0;
};
/**
 * Line/box narrowphase
 * @method lineBox
 * @param  {Body}       lineBody
 * @param  {Line}       lineShape
 * @param  {Array}      lineOffset
 * @param  {Number}     lineAngle
 * @param  {Body}       boxBody
 * @param  {Box}  boxShape
 * @param  {Array}      boxOffset
 * @param  {Number}     boxAngle
 * @param  {Boolean}    justTest
 * @todo Implement me!
 */ $2ce1f7f3add6a2a7$var$Narrowphase.prototype[$k7z01.LINE | $k7z01.BOX] = $2ce1f7f3add6a2a7$var$Narrowphase.prototype.lineBox = function(lineBody, lineShape, lineOffset, lineAngle, boxBody, boxShape, boxOffset, boxAngle, justTest) {
    // TODO
    if (justTest) return false;
    else return 0;
};
function $2ce1f7f3add6a2a7$var$setConvexToCapsuleShapeMiddle(convexShape, capsuleShape) {
    $2Ys9z.set(convexShape.vertices[0], -capsuleShape.length * 0.5, -capsuleShape.radius);
    $2Ys9z.set(convexShape.vertices[1], capsuleShape.length * 0.5, -capsuleShape.radius);
    $2Ys9z.set(convexShape.vertices[2], capsuleShape.length * 0.5, capsuleShape.radius);
    $2Ys9z.set(convexShape.vertices[3], -capsuleShape.length * 0.5, capsuleShape.radius);
}
var $2ce1f7f3add6a2a7$var$convexCapsule_tempRect = new $62ywx({
    width: 1,
    height: 1
}), $2ce1f7f3add6a2a7$var$convexCapsule_tempVec = $2Ys9z.create();
/**
 * Convex/capsule narrowphase
 * @method convexCapsule
 * @param  {Body}       convexBody
 * @param  {Convex}     convexShape
 * @param  {Array}      convexPosition
 * @param  {Number}     convexAngle
 * @param  {Body}       capsuleBody
 * @param  {Capsule}    capsuleShape
 * @param  {Array}      capsulePosition
 * @param  {Number}     capsuleAngle
 */ $2ce1f7f3add6a2a7$var$Narrowphase.prototype[$k7z01.CAPSULE | $k7z01.CONVEX] = $2ce1f7f3add6a2a7$var$Narrowphase.prototype[$k7z01.CAPSULE | $k7z01.BOX] = $2ce1f7f3add6a2a7$var$Narrowphase.prototype.convexCapsule = function(convexBody, convexShape, convexPosition, convexAngle, capsuleBody, capsuleShape, capsulePosition, capsuleAngle, justTest) {
    // Check the circles
    // Add offsets!
    var circlePos = $2ce1f7f3add6a2a7$var$convexCapsule_tempVec;
    $2Ys9z.set(circlePos, capsuleShape.length / 2, 0);
    $2Ys9z.rotate(circlePos, circlePos, capsuleAngle);
    $2Ys9z.add(circlePos, circlePos, capsulePosition);
    var result1 = this.circleConvex(capsuleBody, capsuleShape, circlePos, capsuleAngle, convexBody, convexShape, convexPosition, convexAngle, justTest, capsuleShape.radius);
    $2Ys9z.set(circlePos, -capsuleShape.length / 2, 0);
    $2Ys9z.rotate(circlePos, circlePos, capsuleAngle);
    $2Ys9z.add(circlePos, circlePos, capsulePosition);
    var result2 = this.circleConvex(capsuleBody, capsuleShape, circlePos, capsuleAngle, convexBody, convexShape, convexPosition, convexAngle, justTest, capsuleShape.radius);
    if (justTest && (result1 || result2)) return true;
    // Check center rect
    var r = $2ce1f7f3add6a2a7$var$convexCapsule_tempRect;
    $2ce1f7f3add6a2a7$var$setConvexToCapsuleShapeMiddle(r, capsuleShape);
    var result = this.convexConvex(convexBody, convexShape, convexPosition, convexAngle, capsuleBody, r, capsulePosition, capsuleAngle, justTest);
    return result + result1 + result2;
};
/**
 * Capsule/line narrowphase
 * @method lineCapsule
 * @param  {Body}       lineBody
 * @param  {Line}       lineShape
 * @param  {Array}      linePosition
 * @param  {Number}     lineAngle
 * @param  {Body}       capsuleBody
 * @param  {Capsule}    capsuleShape
 * @param  {Array}      capsulePosition
 * @param  {Number}     capsuleAngle
 * @todo Implement me!
 */ $2ce1f7f3add6a2a7$var$Narrowphase.prototype[$k7z01.CAPSULE | $k7z01.LINE] = $2ce1f7f3add6a2a7$var$Narrowphase.prototype.lineCapsule = function(lineBody, lineShape, linePosition, lineAngle, capsuleBody, capsuleShape, capsulePosition, capsuleAngle, justTest) {
    // TODO
    if (justTest) return false;
    else return 0;
};
var $2ce1f7f3add6a2a7$var$capsuleCapsule_tempVec1 = $2Ys9z.create();
var $2ce1f7f3add6a2a7$var$capsuleCapsule_tempVec2 = $2Ys9z.create();
var $2ce1f7f3add6a2a7$var$capsuleCapsule_tempRect1 = new $62ywx({
    width: 1,
    height: 1
});
/**
 * Capsule/capsule narrowphase
 * @method capsuleCapsule
 * @param  {Body}       bi
 * @param  {Capsule}    si
 * @param  {Array}      xi
 * @param  {Number}     ai
 * @param  {Body}       bj
 * @param  {Capsule}    sj
 * @param  {Array}      xj
 * @param  {Number}     aj
 */ $2ce1f7f3add6a2a7$var$Narrowphase.prototype[$k7z01.CAPSULE | $k7z01.CAPSULE] = $2ce1f7f3add6a2a7$var$Narrowphase.prototype.capsuleCapsule = function(bi, si, xi, ai, bj, sj, xj, aj, justTest) {
    var enableFrictionBefore;
    // Check the circles
    // Add offsets!
    var circlePosi = $2ce1f7f3add6a2a7$var$capsuleCapsule_tempVec1, circlePosj = $2ce1f7f3add6a2a7$var$capsuleCapsule_tempVec2;
    var numContacts = 0;
    // Need 4 circle checks, between all
    for(var i = 0; i < 2; i++){
        $2Ys9z.set(circlePosi, (i === 0 ? -1 : 1) * si.length / 2, 0);
        $2Ys9z.rotate(circlePosi, circlePosi, ai);
        $2Ys9z.add(circlePosi, circlePosi, xi);
        for(var j = 0; j < 2; j++){
            $2Ys9z.set(circlePosj, (j === 0 ? -1 : 1) * sj.length / 2, 0);
            $2Ys9z.rotate(circlePosj, circlePosj, aj);
            $2Ys9z.add(circlePosj, circlePosj, xj);
            // Temporarily turn off friction
            if (this.enableFrictionReduction) {
                enableFrictionBefore = this.enableFriction;
                this.enableFriction = false;
            }
            var result = this.circleCircle(bi, si, circlePosi, ai, bj, sj, circlePosj, aj, justTest, si.radius, sj.radius);
            if (this.enableFrictionReduction) this.enableFriction = enableFrictionBefore;
            if (justTest && result) return true;
            numContacts += result;
        }
    }
    if (this.enableFrictionReduction) {
        // Temporarily turn off friction
        enableFrictionBefore = this.enableFriction;
        this.enableFriction = false;
    }
    // Check circles against the center boxs
    var rect = $2ce1f7f3add6a2a7$var$capsuleCapsule_tempRect1;
    $2ce1f7f3add6a2a7$var$setConvexToCapsuleShapeMiddle(rect, si);
    var result1 = this.convexCapsule(bi, rect, xi, ai, bj, sj, xj, aj, justTest);
    if (this.enableFrictionReduction) this.enableFriction = enableFrictionBefore;
    if (justTest && result1) return true;
    numContacts += result1;
    if (this.enableFrictionReduction) {
        // Temporarily turn off friction
        var enableFrictionBefore = this.enableFriction;
        this.enableFriction = false;
    }
    $2ce1f7f3add6a2a7$var$setConvexToCapsuleShapeMiddle(rect, sj);
    var result2 = this.convexCapsule(bj, rect, xj, aj, bi, si, xi, ai, justTest);
    if (this.enableFrictionReduction) this.enableFriction = enableFrictionBefore;
    if (justTest && result2) return true;
    numContacts += result2;
    if (this.enableFrictionReduction) {
        if (numContacts && this.enableFriction) this.frictionEquations.push(this.createFrictionFromAverage(numContacts));
    }
    return numContacts;
};
/**
 * Line/line narrowphase
 * @method lineLine
 * @param  {Body}       bodyA
 * @param  {Line}       shapeA
 * @param  {Array}      positionA
 * @param  {Number}     angleA
 * @param  {Body}       bodyB
 * @param  {Line}       shapeB
 * @param  {Array}      positionB
 * @param  {Number}     angleB
 * @todo Implement me!
 */ $2ce1f7f3add6a2a7$var$Narrowphase.prototype[$k7z01.LINE | $k7z01.LINE] = $2ce1f7f3add6a2a7$var$Narrowphase.prototype.lineLine = function(bodyA, shapeA, positionA, angleA, bodyB, shapeB, positionB, angleB, justTest) {
    // TODO
    if (justTest) return false;
    else return 0;
};
/**
 * Plane/line Narrowphase
 * @method planeLine
 * @param  {Body}   planeBody
 * @param  {Plane}  planeShape
 * @param  {Array}  planeOffset
 * @param  {Number} planeAngle
 * @param  {Body}   lineBody
 * @param  {Line}   lineShape
 * @param  {Array}  lineOffset
 * @param  {Number} lineAngle
 */ $2ce1f7f3add6a2a7$var$Narrowphase.prototype[$k7z01.PLANE | $k7z01.LINE] = $2ce1f7f3add6a2a7$var$Narrowphase.prototype.planeLine = function(planeBody, planeShape, planeOffset, planeAngle, lineBody, lineShape, lineOffset, lineAngle, justTest) {
    var worldVertex0 = $2ce1f7f3add6a2a7$var$tmp1, worldVertex1 = $2ce1f7f3add6a2a7$var$tmp2, worldVertex01 = $2ce1f7f3add6a2a7$var$tmp3, worldVertex11 = $2ce1f7f3add6a2a7$var$tmp4, worldEdge = $2ce1f7f3add6a2a7$var$tmp5, worldEdgeUnit = $2ce1f7f3add6a2a7$var$tmp6, dist = $2ce1f7f3add6a2a7$var$tmp7, worldNormal = $2ce1f7f3add6a2a7$var$tmp8, worldTangent = $2ce1f7f3add6a2a7$var$tmp9, verts = $2ce1f7f3add6a2a7$var$tmpArray, numContacts = 0;
    // Get start and end points
    $2Ys9z.set(worldVertex0, -lineShape.length / 2, 0);
    $2Ys9z.set(worldVertex1, lineShape.length / 2, 0);
    // Not sure why we have to use worldVertex*1 here, but it won't work otherwise. Tired.
    $2Ys9z.rotate(worldVertex01, worldVertex0, lineAngle);
    $2Ys9z.rotate(worldVertex11, worldVertex1, lineAngle);
    $2ce1f7f3add6a2a7$var$add(worldVertex01, worldVertex01, lineOffset);
    $2ce1f7f3add6a2a7$var$add(worldVertex11, worldVertex11, lineOffset);
    $2Ys9z.copy(worldVertex0, worldVertex01);
    $2Ys9z.copy(worldVertex1, worldVertex11);
    // Get vector along the line
    $2ce1f7f3add6a2a7$var$sub(worldEdge, worldVertex1, worldVertex0);
    $2Ys9z.normalize(worldEdgeUnit, worldEdge);
    // Get tangent to the edge.
    $2Ys9z.rotate90cw(worldTangent, worldEdgeUnit);
    $2Ys9z.rotate(worldNormal, $2ce1f7f3add6a2a7$var$yAxis, planeAngle);
    // Check line ends
    verts[0] = worldVertex0;
    verts[1] = worldVertex1;
    for(var i = 0; i < verts.length; i++){
        var v = verts[i];
        $2ce1f7f3add6a2a7$var$sub(dist, v, planeOffset);
        var d = $2ce1f7f3add6a2a7$var$dot(dist, worldNormal);
        if (d < 0) {
            if (justTest) return true;
            var c = this.createContactEquation(planeBody, lineBody, planeShape, lineShape);
            numContacts++;
            $2Ys9z.copy(c.normalA, worldNormal);
            $2Ys9z.normalize(c.normalA, c.normalA);
            // distance vector along plane normal
            $2Ys9z.scale(dist, worldNormal, d);
            // Vector from plane center to contact
            $2ce1f7f3add6a2a7$var$sub(c.contactPointA, v, dist);
            $2ce1f7f3add6a2a7$var$sub(c.contactPointA, c.contactPointA, planeBody.position);
            // From line center to contact
            $2ce1f7f3add6a2a7$var$sub(c.contactPointB, v, lineOffset);
            $2ce1f7f3add6a2a7$var$add(c.contactPointB, c.contactPointB, lineOffset);
            $2ce1f7f3add6a2a7$var$sub(c.contactPointB, c.contactPointB, lineBody.position);
            this.contactEquations.push(c);
            if (!this.enableFrictionReduction) {
                if (this.enableFriction) this.frictionEquations.push(this.createFrictionFromContact(c));
            }
        }
    }
    if (justTest) return false;
    if (!this.enableFrictionReduction) {
        if (numContacts && this.enableFriction) this.frictionEquations.push(this.createFrictionFromAverage(numContacts));
    }
    return numContacts;
};
$2ce1f7f3add6a2a7$var$Narrowphase.prototype[$k7z01.PARTICLE | $k7z01.CAPSULE] = $2ce1f7f3add6a2a7$var$Narrowphase.prototype.particleCapsule = function(particleBody, particleShape, particlePosition, particleAngle, capsuleBody, capsuleShape, capsulePosition, capsuleAngle, justTest) {
    return this.circleLine(particleBody, particleShape, particlePosition, particleAngle, capsuleBody, capsuleShape, capsulePosition, capsuleAngle, justTest, capsuleShape.radius, 0);
};
/**
 * Circle/line Narrowphase
 * @method circleLine
 * @param  {Body} circleBody
 * @param  {Circle} circleShape
 * @param  {Array} circleOffset
 * @param  {Number} circleAngle
 * @param  {Body} lineBody
 * @param  {Line} lineShape
 * @param  {Array} lineOffset
 * @param  {Number} lineAngle
 * @param {Boolean} justTest If set to true, this function will return the result (intersection or not) without adding equations.
 * @param {Number} lineRadius Radius to add to the line. Can be used to test Capsules.
 * @param {Number} circleRadius If set, this value overrides the circle shape radius.
 */ $2ce1f7f3add6a2a7$var$Narrowphase.prototype[$k7z01.CIRCLE | $k7z01.LINE] = $2ce1f7f3add6a2a7$var$Narrowphase.prototype.circleLine = function(circleBody, circleShape, circleOffset, circleAngle, lineBody, lineShape, lineOffset, lineAngle, justTest, lineRadius, circleRadius) {
    var lineRadius = lineRadius || 0, circleRadius = typeof circleRadius !== "undefined" ? circleRadius : circleShape.radius, orthoDist = $2ce1f7f3add6a2a7$var$tmp1, lineToCircleOrthoUnit = $2ce1f7f3add6a2a7$var$tmp2, projectedPoint = $2ce1f7f3add6a2a7$var$tmp3, centerDist = $2ce1f7f3add6a2a7$var$tmp4, worldTangent = $2ce1f7f3add6a2a7$var$tmp5, worldEdge = $2ce1f7f3add6a2a7$var$tmp6, worldEdgeUnit = $2ce1f7f3add6a2a7$var$tmp7, worldVertex0 = $2ce1f7f3add6a2a7$var$tmp8, worldVertex1 = $2ce1f7f3add6a2a7$var$tmp9, worldVertex01 = $2ce1f7f3add6a2a7$var$tmp10, worldVertex11 = $2ce1f7f3add6a2a7$var$tmp11, dist = $2ce1f7f3add6a2a7$var$tmp12, lineToCircle = $2ce1f7f3add6a2a7$var$tmp13, lineEndToLineRadius = $2ce1f7f3add6a2a7$var$tmp14, verts = $2ce1f7f3add6a2a7$var$tmpArray;
    // Get start and end points
    $2Ys9z.set(worldVertex0, -lineShape.length / 2, 0);
    $2Ys9z.set(worldVertex1, lineShape.length / 2, 0);
    // Not sure why we have to use worldVertex*1 here, but it won't work otherwise. Tired.
    $2Ys9z.rotate(worldVertex01, worldVertex0, lineAngle);
    $2Ys9z.rotate(worldVertex11, worldVertex1, lineAngle);
    $2ce1f7f3add6a2a7$var$add(worldVertex01, worldVertex01, lineOffset);
    $2ce1f7f3add6a2a7$var$add(worldVertex11, worldVertex11, lineOffset);
    $2Ys9z.copy(worldVertex0, worldVertex01);
    $2Ys9z.copy(worldVertex1, worldVertex11);
    // Get vector along the line
    $2ce1f7f3add6a2a7$var$sub(worldEdge, worldVertex1, worldVertex0);
    $2Ys9z.normalize(worldEdgeUnit, worldEdge);
    // Get tangent to the edge.
    $2Ys9z.rotate90cw(worldTangent, worldEdgeUnit);
    // Check distance from the plane spanned by the edge vs the circle
    $2ce1f7f3add6a2a7$var$sub(dist, circleOffset, worldVertex0);
    var d = $2ce1f7f3add6a2a7$var$dot(dist, worldTangent); // Distance from center of line to circle center
    $2ce1f7f3add6a2a7$var$sub(centerDist, worldVertex0, lineOffset);
    $2ce1f7f3add6a2a7$var$sub(lineToCircle, circleOffset, lineOffset);
    var radiusSum = circleRadius + lineRadius;
    if (Math.abs(d) < radiusSum) {
        // Now project the circle onto the edge
        $2Ys9z.scale(orthoDist, worldTangent, d);
        $2ce1f7f3add6a2a7$var$sub(projectedPoint, circleOffset, orthoDist);
        // Add the missing line radius
        $2Ys9z.scale(lineToCircleOrthoUnit, worldTangent, $2ce1f7f3add6a2a7$var$dot(worldTangent, lineToCircle));
        $2Ys9z.normalize(lineToCircleOrthoUnit, lineToCircleOrthoUnit);
        $2Ys9z.scale(lineToCircleOrthoUnit, lineToCircleOrthoUnit, lineRadius);
        $2ce1f7f3add6a2a7$var$add(projectedPoint, projectedPoint, lineToCircleOrthoUnit);
        // Check if the point is within the edge span
        var pos = $2ce1f7f3add6a2a7$var$dot(worldEdgeUnit, projectedPoint);
        var pos0 = $2ce1f7f3add6a2a7$var$dot(worldEdgeUnit, worldVertex0);
        var pos1 = $2ce1f7f3add6a2a7$var$dot(worldEdgeUnit, worldVertex1);
        if (pos > pos0 && pos < pos1) {
            // We got contact!
            if (justTest) return true;
            var c = this.createContactEquation(circleBody, lineBody, circleShape, lineShape);
            $2Ys9z.scale(c.normalA, orthoDist, -1);
            $2Ys9z.normalize(c.normalA, c.normalA);
            $2Ys9z.scale(c.contactPointA, c.normalA, circleRadius);
            $2ce1f7f3add6a2a7$var$add(c.contactPointA, c.contactPointA, circleOffset);
            $2ce1f7f3add6a2a7$var$sub(c.contactPointA, c.contactPointA, circleBody.position);
            $2ce1f7f3add6a2a7$var$sub(c.contactPointB, projectedPoint, lineOffset);
            $2ce1f7f3add6a2a7$var$add(c.contactPointB, c.contactPointB, lineOffset);
            $2ce1f7f3add6a2a7$var$sub(c.contactPointB, c.contactPointB, lineBody.position);
            this.contactEquations.push(c);
            if (this.enableFriction) this.frictionEquations.push(this.createFrictionFromContact(c));
            return 1;
        }
    }
    // Add corner
    verts[0] = worldVertex0;
    verts[1] = worldVertex1;
    for(var i = 0; i < verts.length; i++){
        var v = verts[i];
        $2ce1f7f3add6a2a7$var$sub(dist, v, circleOffset);
        if ($2Ys9z.squaredLength(dist) < Math.pow(radiusSum, 2)) {
            if (justTest) return true;
            var c = this.createContactEquation(circleBody, lineBody, circleShape, lineShape);
            $2Ys9z.copy(c.normalA, dist);
            $2Ys9z.normalize(c.normalA, c.normalA);
            // Vector from circle to contact point is the normal times the circle radius
            $2Ys9z.scale(c.contactPointA, c.normalA, circleRadius);
            $2ce1f7f3add6a2a7$var$add(c.contactPointA, c.contactPointA, circleOffset);
            $2ce1f7f3add6a2a7$var$sub(c.contactPointA, c.contactPointA, circleBody.position);
            $2ce1f7f3add6a2a7$var$sub(c.contactPointB, v, lineOffset);
            $2Ys9z.scale(lineEndToLineRadius, c.normalA, -lineRadius);
            $2ce1f7f3add6a2a7$var$add(c.contactPointB, c.contactPointB, lineEndToLineRadius);
            $2ce1f7f3add6a2a7$var$add(c.contactPointB, c.contactPointB, lineOffset);
            $2ce1f7f3add6a2a7$var$sub(c.contactPointB, c.contactPointB, lineBody.position);
            this.contactEquations.push(c);
            if (this.enableFriction) this.frictionEquations.push(this.createFrictionFromContact(c));
            return 1;
        }
    }
    return 0;
};
/**
 * Circle/capsule Narrowphase
 * @method circleCapsule
 * @param  {Body}   bi
 * @param  {Circle} si
 * @param  {Array}  xi
 * @param  {Number} ai
 * @param  {Body}   bj
 * @param  {Line}   sj
 * @param  {Array}  xj
 * @param  {Number} aj
 */ $2ce1f7f3add6a2a7$var$Narrowphase.prototype[$k7z01.CIRCLE | $k7z01.CAPSULE] = $2ce1f7f3add6a2a7$var$Narrowphase.prototype.circleCapsule = function(bi, si, xi, ai, bj, sj, xj, aj, justTest) {
    return this.circleLine(bi, si, xi, ai, bj, sj, xj, aj, justTest, sj.radius);
};
/**
 * Circle/convex Narrowphase.
 * @method circleConvex
 * @param  {Body} circleBody
 * @param  {Circle} circleShape
 * @param  {Array} circleOffset
 * @param  {Number} circleAngle
 * @param  {Body} convexBody
 * @param  {Convex} convexShape
 * @param  {Array} convexOffset
 * @param  {Number} convexAngle
 * @param  {Boolean} justTest
 * @param  {Number} circleRadius
 */ $2ce1f7f3add6a2a7$var$Narrowphase.prototype[$k7z01.CIRCLE | $k7z01.CONVEX] = $2ce1f7f3add6a2a7$var$Narrowphase.prototype[$k7z01.CIRCLE | $k7z01.BOX] = $2ce1f7f3add6a2a7$var$Narrowphase.prototype.circleConvex = function(circleBody, circleShape, circleOffset, circleAngle, convexBody, convexShape, convexOffset, convexAngle, justTest, circleRadius) {
    var circleRadius = typeof circleRadius === "number" ? circleRadius : circleShape.radius;
    var worldVertex0 = $2ce1f7f3add6a2a7$var$tmp1, worldVertex1 = $2ce1f7f3add6a2a7$var$tmp2, worldEdge = $2ce1f7f3add6a2a7$var$tmp3, worldEdgeUnit = $2ce1f7f3add6a2a7$var$tmp4, worldNormal = $2ce1f7f3add6a2a7$var$tmp5, centerDist = $2ce1f7f3add6a2a7$var$tmp6, convexToCircle = $2ce1f7f3add6a2a7$var$tmp7, orthoDist = $2ce1f7f3add6a2a7$var$tmp8, projectedPoint = $2ce1f7f3add6a2a7$var$tmp9, dist = $2ce1f7f3add6a2a7$var$tmp10, worldVertex = $2ce1f7f3add6a2a7$var$tmp11, closestEdge = -1, closestEdgeDistance = null, closestEdgeOrthoDist = $2ce1f7f3add6a2a7$var$tmp12, closestEdgeProjectedPoint = $2ce1f7f3add6a2a7$var$tmp13, candidate = $2ce1f7f3add6a2a7$var$tmp14, candidateDist = $2ce1f7f3add6a2a7$var$tmp15, minCandidate = $2ce1f7f3add6a2a7$var$tmp16, found = false, minCandidateDistance = Number.MAX_VALUE;
    var numReported = 0;
    // New algorithm:
    // 1. Check so center of circle is not inside the polygon. If it is, this wont work...
    // 2. For each edge
    // 2. 1. Get point on circle that is closest to the edge (scale normal with -radius)
    // 2. 2. Check if point is inside.
    var verts = convexShape.vertices;
    // Check all edges first
    for(var i = 0; i !== verts.length + 1; i++){
        var v0 = verts[i % verts.length], v1 = verts[(i + 1) % verts.length];
        $2Ys9z.rotate(worldVertex0, v0, convexAngle);
        $2Ys9z.rotate(worldVertex1, v1, convexAngle);
        $2ce1f7f3add6a2a7$var$add(worldVertex0, worldVertex0, convexOffset);
        $2ce1f7f3add6a2a7$var$add(worldVertex1, worldVertex1, convexOffset);
        $2ce1f7f3add6a2a7$var$sub(worldEdge, worldVertex1, worldVertex0);
        $2Ys9z.normalize(worldEdgeUnit, worldEdge);
        // Get tangent to the edge. Points out of the Convex
        $2Ys9z.rotate90cw(worldNormal, worldEdgeUnit);
        // Get point on circle, closest to the polygon
        $2Ys9z.scale(candidate, worldNormal, -circleShape.radius);
        $2ce1f7f3add6a2a7$var$add(candidate, candidate, circleOffset);
        if ($2ce1f7f3add6a2a7$var$pointInConvex(candidate, convexShape, convexOffset, convexAngle)) {
            $2Ys9z.sub(candidateDist, worldVertex0, candidate);
            var candidateDistance = Math.abs($2Ys9z.dot(candidateDist, worldNormal));
            if (candidateDistance < minCandidateDistance) {
                $2Ys9z.copy(minCandidate, candidate);
                minCandidateDistance = candidateDistance;
                $2Ys9z.scale(closestEdgeProjectedPoint, worldNormal, candidateDistance);
                $2Ys9z.add(closestEdgeProjectedPoint, closestEdgeProjectedPoint, candidate);
                found = true;
            }
        }
    }
    if (found) {
        if (justTest) return true;
        var c = this.createContactEquation(circleBody, convexBody, circleShape, convexShape);
        $2Ys9z.sub(c.normalA, minCandidate, circleOffset);
        $2Ys9z.normalize(c.normalA, c.normalA);
        $2Ys9z.scale(c.contactPointA, c.normalA, circleRadius);
        $2ce1f7f3add6a2a7$var$add(c.contactPointA, c.contactPointA, circleOffset);
        $2ce1f7f3add6a2a7$var$sub(c.contactPointA, c.contactPointA, circleBody.position);
        $2ce1f7f3add6a2a7$var$sub(c.contactPointB, closestEdgeProjectedPoint, convexOffset);
        $2ce1f7f3add6a2a7$var$add(c.contactPointB, c.contactPointB, convexOffset);
        $2ce1f7f3add6a2a7$var$sub(c.contactPointB, c.contactPointB, convexBody.position);
        this.contactEquations.push(c);
        if (this.enableFriction) this.frictionEquations.push(this.createFrictionFromContact(c));
        return 1;
    }
    // Check all vertices
    if (circleRadius > 0) for(var i = 0; i < verts.length; i++){
        var localVertex = verts[i];
        $2Ys9z.rotate(worldVertex, localVertex, convexAngle);
        $2ce1f7f3add6a2a7$var$add(worldVertex, worldVertex, convexOffset);
        $2ce1f7f3add6a2a7$var$sub(dist, worldVertex, circleOffset);
        if ($2Ys9z.squaredLength(dist) < Math.pow(circleRadius, 2)) {
            if (justTest) return true;
            var c = this.createContactEquation(circleBody, convexBody, circleShape, convexShape);
            $2Ys9z.copy(c.normalA, dist);
            $2Ys9z.normalize(c.normalA, c.normalA);
            // Vector from circle to contact point is the normal times the circle radius
            $2Ys9z.scale(c.contactPointA, c.normalA, circleRadius);
            $2ce1f7f3add6a2a7$var$add(c.contactPointA, c.contactPointA, circleOffset);
            $2ce1f7f3add6a2a7$var$sub(c.contactPointA, c.contactPointA, circleBody.position);
            $2ce1f7f3add6a2a7$var$sub(c.contactPointB, worldVertex, convexOffset);
            $2ce1f7f3add6a2a7$var$add(c.contactPointB, c.contactPointB, convexOffset);
            $2ce1f7f3add6a2a7$var$sub(c.contactPointB, c.contactPointB, convexBody.position);
            this.contactEquations.push(c);
            if (this.enableFriction) this.frictionEquations.push(this.createFrictionFromContact(c));
            return 1;
        }
    }
    return 0;
};
var $2ce1f7f3add6a2a7$var$pic_worldVertex0 = $2Ys9z.create(), $2ce1f7f3add6a2a7$var$pic_worldVertex1 = $2Ys9z.create(), $2ce1f7f3add6a2a7$var$pic_r0 = $2Ys9z.create(), $2ce1f7f3add6a2a7$var$pic_r1 = $2Ys9z.create();
/*
 * Check if a point is in a polygon
 */ function $2ce1f7f3add6a2a7$var$pointInConvex(worldPoint, convexShape, convexOffset, convexAngle) {
    var worldVertex0 = $2ce1f7f3add6a2a7$var$pic_worldVertex0, worldVertex1 = $2ce1f7f3add6a2a7$var$pic_worldVertex1, r0 = $2ce1f7f3add6a2a7$var$pic_r0, r1 = $2ce1f7f3add6a2a7$var$pic_r1, point = worldPoint, verts = convexShape.vertices, lastCross = null;
    for(var i = 0; i !== verts.length + 1; i++){
        var v0 = verts[i % verts.length], v1 = verts[(i + 1) % verts.length];
        // Transform vertices to world
        // @todo The point should be transformed to local coordinates in the convex, no need to transform each vertex
        $2Ys9z.rotate(worldVertex0, v0, convexAngle);
        $2Ys9z.rotate(worldVertex1, v1, convexAngle);
        $2ce1f7f3add6a2a7$var$add(worldVertex0, worldVertex0, convexOffset);
        $2ce1f7f3add6a2a7$var$add(worldVertex1, worldVertex1, convexOffset);
        $2ce1f7f3add6a2a7$var$sub(r0, worldVertex0, point);
        $2ce1f7f3add6a2a7$var$sub(r1, worldVertex1, point);
        var cross = $2Ys9z.crossLength(r0, r1);
        if (lastCross === null) lastCross = cross;
        // If we got a different sign of the distance vector, the point is out of the polygon
        if (cross * lastCross <= 0) return false;
        lastCross = cross;
    }
    return true;
}
/**
 * Particle/convex Narrowphase
 * @method particleConvex
 * @param  {Body} particleBody
 * @param  {Particle} particleShape
 * @param  {Array} particleOffset
 * @param  {Number} particleAngle
 * @param  {Body} convexBody
 * @param  {Convex} convexShape
 * @param  {Array} convexOffset
 * @param  {Number} convexAngle
 * @param {Boolean} justTest
 * @todo use pointInConvex and code more similar to circleConvex
 * @todo don't transform each vertex, but transform the particle position to convex-local instead
 */ $2ce1f7f3add6a2a7$var$Narrowphase.prototype[$k7z01.PARTICLE | $k7z01.CONVEX] = $2ce1f7f3add6a2a7$var$Narrowphase.prototype[$k7z01.PARTICLE | $k7z01.BOX] = $2ce1f7f3add6a2a7$var$Narrowphase.prototype.particleConvex = function(particleBody, particleShape, particleOffset, particleAngle, convexBody, convexShape, convexOffset, convexAngle, justTest) {
    var worldVertex0 = $2ce1f7f3add6a2a7$var$tmp1, worldVertex1 = $2ce1f7f3add6a2a7$var$tmp2, worldEdge = $2ce1f7f3add6a2a7$var$tmp3, worldEdgeUnit = $2ce1f7f3add6a2a7$var$tmp4, worldTangent = $2ce1f7f3add6a2a7$var$tmp5, centerDist = $2ce1f7f3add6a2a7$var$tmp6, convexToparticle = $2ce1f7f3add6a2a7$var$tmp7, orthoDist = $2ce1f7f3add6a2a7$var$tmp8, projectedPoint = $2ce1f7f3add6a2a7$var$tmp9, dist = $2ce1f7f3add6a2a7$var$tmp10, worldVertex = $2ce1f7f3add6a2a7$var$tmp11, closestEdge = -1, closestEdgeDistance = null, closestEdgeOrthoDist = $2ce1f7f3add6a2a7$var$tmp12, closestEdgeProjectedPoint = $2ce1f7f3add6a2a7$var$tmp13, r0 = $2ce1f7f3add6a2a7$var$tmp14, r1 = $2ce1f7f3add6a2a7$var$tmp15, localPoint = $2ce1f7f3add6a2a7$var$tmp16, candidateDist = $2ce1f7f3add6a2a7$var$tmp17, minEdgeNormal = $2ce1f7f3add6a2a7$var$tmp18, minCandidateDistance = Number.MAX_VALUE;
    var numReported = 0, found = false, verts = convexShape.vertices;
    // Check if the particle is in the polygon at all
    if (!$2ce1f7f3add6a2a7$var$pointInConvex(particleOffset, convexShape, convexOffset, convexAngle)) return 0;
    if (justTest) return true;
    // Check edges first
    var lastCross = null;
    for(var i = 0; i !== verts.length + 1; i++){
        var v0 = verts[i % verts.length], v1 = verts[(i + 1) % verts.length];
        // Transform vertices to world
        $2Ys9z.rotate(worldVertex0, v0, convexAngle);
        $2Ys9z.rotate(worldVertex1, v1, convexAngle);
        $2ce1f7f3add6a2a7$var$add(worldVertex0, worldVertex0, convexOffset);
        $2ce1f7f3add6a2a7$var$add(worldVertex1, worldVertex1, convexOffset);
        // Get world edge
        $2ce1f7f3add6a2a7$var$sub(worldEdge, worldVertex1, worldVertex0);
        $2Ys9z.normalize(worldEdgeUnit, worldEdge);
        // Get tangent to the edge. Points out of the Convex
        $2Ys9z.rotate90cw(worldTangent, worldEdgeUnit);
        // Check distance from the infinite line (spanned by the edge) to the particle
        $2ce1f7f3add6a2a7$var$sub(dist, particleOffset, worldVertex0);
        var d = $2ce1f7f3add6a2a7$var$dot(dist, worldTangent);
        $2ce1f7f3add6a2a7$var$sub(centerDist, worldVertex0, convexOffset);
        $2ce1f7f3add6a2a7$var$sub(convexToparticle, particleOffset, convexOffset);
        $2Ys9z.sub(candidateDist, worldVertex0, particleOffset);
        var candidateDistance = Math.abs($2Ys9z.dot(candidateDist, worldTangent));
        if (candidateDistance < minCandidateDistance) {
            minCandidateDistance = candidateDistance;
            $2Ys9z.scale(closestEdgeProjectedPoint, worldTangent, candidateDistance);
            $2Ys9z.add(closestEdgeProjectedPoint, closestEdgeProjectedPoint, particleOffset);
            $2Ys9z.copy(minEdgeNormal, worldTangent);
            found = true;
        }
    }
    if (found) {
        var c = this.createContactEquation(particleBody, convexBody, particleShape, convexShape);
        $2Ys9z.scale(c.normalA, minEdgeNormal, -1);
        $2Ys9z.normalize(c.normalA, c.normalA);
        // Particle has no extent to the contact point
        $2Ys9z.set(c.contactPointA, 0, 0);
        $2ce1f7f3add6a2a7$var$add(c.contactPointA, c.contactPointA, particleOffset);
        $2ce1f7f3add6a2a7$var$sub(c.contactPointA, c.contactPointA, particleBody.position);
        // From convex center to point
        $2ce1f7f3add6a2a7$var$sub(c.contactPointB, closestEdgeProjectedPoint, convexOffset);
        $2ce1f7f3add6a2a7$var$add(c.contactPointB, c.contactPointB, convexOffset);
        $2ce1f7f3add6a2a7$var$sub(c.contactPointB, c.contactPointB, convexBody.position);
        this.contactEquations.push(c);
        if (this.enableFriction) this.frictionEquations.push(this.createFrictionFromContact(c));
        return 1;
    }
    return 0;
};
/**
 * Circle/circle Narrowphase
 * @method circleCircle
 * @param  {Body} bodyA
 * @param  {Circle} shapeA
 * @param  {Array} offsetA
 * @param  {Number} angleA
 * @param  {Body} bodyB
 * @param  {Circle} shapeB
 * @param  {Array} offsetB
 * @param  {Number} angleB
 * @param {Boolean} justTest
 * @param {Number} [radiusA] Optional radius to use for shapeA
 * @param {Number} [radiusB] Optional radius to use for shapeB
 */ $2ce1f7f3add6a2a7$var$Narrowphase.prototype[$k7z01.CIRCLE] = $2ce1f7f3add6a2a7$var$Narrowphase.prototype.circleCircle = function(bodyA, shapeA, offsetA, angleA, bodyB, shapeB, offsetB, angleB, justTest, radiusA, radiusB) {
    var dist = $2ce1f7f3add6a2a7$var$tmp1, radiusA = radiusA || shapeA.radius, radiusB = radiusB || shapeB.radius;
    $2ce1f7f3add6a2a7$var$sub(dist, offsetA, offsetB);
    var r = radiusA + radiusB;
    if ($2Ys9z.squaredLength(dist) > Math.pow(r, 2)) return 0;
    if (justTest) return true;
    var c = this.createContactEquation(bodyA, bodyB, shapeA, shapeB);
    $2ce1f7f3add6a2a7$var$sub(c.normalA, offsetB, offsetA);
    $2Ys9z.normalize(c.normalA, c.normalA);
    $2Ys9z.scale(c.contactPointA, c.normalA, radiusA);
    $2Ys9z.scale(c.contactPointB, c.normalA, -radiusB);
    $2ce1f7f3add6a2a7$var$add(c.contactPointA, c.contactPointA, offsetA);
    $2ce1f7f3add6a2a7$var$sub(c.contactPointA, c.contactPointA, bodyA.position);
    $2ce1f7f3add6a2a7$var$add(c.contactPointB, c.contactPointB, offsetB);
    $2ce1f7f3add6a2a7$var$sub(c.contactPointB, c.contactPointB, bodyB.position);
    this.contactEquations.push(c);
    if (this.enableFriction) this.frictionEquations.push(this.createFrictionFromContact(c));
    return 1;
};
/**
 * Plane/Convex Narrowphase
 * @method planeConvex
 * @param  {Body} planeBody
 * @param  {Plane} planeShape
 * @param  {Array} planeOffset
 * @param  {Number} planeAngle
 * @param  {Body} convexBody
 * @param  {Convex} convexShape
 * @param  {Array} convexOffset
 * @param  {Number} convexAngle
 * @param {Boolean} justTest
 */ $2ce1f7f3add6a2a7$var$Narrowphase.prototype[$k7z01.PLANE | $k7z01.CONVEX] = $2ce1f7f3add6a2a7$var$Narrowphase.prototype[$k7z01.PLANE | $k7z01.BOX] = $2ce1f7f3add6a2a7$var$Narrowphase.prototype.planeConvex = function(planeBody, planeShape, planeOffset, planeAngle, convexBody, convexShape, convexOffset, convexAngle, justTest) {
    var worldVertex = $2ce1f7f3add6a2a7$var$tmp1, worldNormal = $2ce1f7f3add6a2a7$var$tmp2, dist = $2ce1f7f3add6a2a7$var$tmp3;
    var numReported = 0;
    $2Ys9z.rotate(worldNormal, $2ce1f7f3add6a2a7$var$yAxis, planeAngle);
    for(var i = 0; i !== convexShape.vertices.length; i++){
        var v = convexShape.vertices[i];
        $2Ys9z.rotate(worldVertex, v, convexAngle);
        $2ce1f7f3add6a2a7$var$add(worldVertex, worldVertex, convexOffset);
        $2ce1f7f3add6a2a7$var$sub(dist, worldVertex, planeOffset);
        if ($2ce1f7f3add6a2a7$var$dot(dist, worldNormal) <= 0) {
            if (justTest) return true;
            // Found vertex
            numReported++;
            var c = this.createContactEquation(planeBody, convexBody, planeShape, convexShape);
            $2ce1f7f3add6a2a7$var$sub(dist, worldVertex, planeOffset);
            $2Ys9z.copy(c.normalA, worldNormal);
            var d = $2ce1f7f3add6a2a7$var$dot(dist, c.normalA);
            $2Ys9z.scale(dist, c.normalA, d);
            // rj is from convex center to contact
            $2ce1f7f3add6a2a7$var$sub(c.contactPointB, worldVertex, convexBody.position);
            // ri is from plane center to contact
            $2ce1f7f3add6a2a7$var$sub(c.contactPointA, worldVertex, dist);
            $2ce1f7f3add6a2a7$var$sub(c.contactPointA, c.contactPointA, planeBody.position);
            this.contactEquations.push(c);
            if (!this.enableFrictionReduction) {
                if (this.enableFriction) this.frictionEquations.push(this.createFrictionFromContact(c));
            }
        }
    }
    if (this.enableFrictionReduction) {
        if (this.enableFriction && numReported) this.frictionEquations.push(this.createFrictionFromAverage(numReported));
    }
    return numReported;
};
/**
 * Narrowphase for particle vs plane
 * @method particlePlane
 * @param  {Body}       particleBody
 * @param  {Particle}   particleShape
 * @param  {Array}      particleOffset
 * @param  {Number}     particleAngle
 * @param  {Body}       planeBody
 * @param  {Plane}      planeShape
 * @param  {Array}      planeOffset
 * @param  {Number}     planeAngle
 * @param {Boolean}     justTest
 */ $2ce1f7f3add6a2a7$var$Narrowphase.prototype[$k7z01.PARTICLE | $k7z01.PLANE] = $2ce1f7f3add6a2a7$var$Narrowphase.prototype.particlePlane = function(particleBody, particleShape, particleOffset, particleAngle, planeBody, planeShape, planeOffset, planeAngle, justTest) {
    var dist = $2ce1f7f3add6a2a7$var$tmp1, worldNormal = $2ce1f7f3add6a2a7$var$tmp2;
    planeAngle = planeAngle || 0;
    $2ce1f7f3add6a2a7$var$sub(dist, particleOffset, planeOffset);
    $2Ys9z.rotate(worldNormal, $2ce1f7f3add6a2a7$var$yAxis, planeAngle);
    var d = $2ce1f7f3add6a2a7$var$dot(dist, worldNormal);
    if (d > 0) return 0;
    if (justTest) return true;
    var c = this.createContactEquation(planeBody, particleBody, planeShape, particleShape);
    $2Ys9z.copy(c.normalA, worldNormal);
    $2Ys9z.scale(dist, c.normalA, d);
    // dist is now the distance vector in the normal direction
    // ri is the particle position projected down onto the plane, from the plane center
    $2ce1f7f3add6a2a7$var$sub(c.contactPointA, particleOffset, dist);
    $2ce1f7f3add6a2a7$var$sub(c.contactPointA, c.contactPointA, planeBody.position);
    // rj is from the body center to the particle center
    $2ce1f7f3add6a2a7$var$sub(c.contactPointB, particleOffset, particleBody.position);
    this.contactEquations.push(c);
    if (this.enableFriction) this.frictionEquations.push(this.createFrictionFromContact(c));
    return 1;
};
/**
 * Circle/Particle Narrowphase
 * @method circleParticle
 * @param  {Body} circleBody
 * @param  {Circle} circleShape
 * @param  {Array} circleOffset
 * @param  {Number} circleAngle
 * @param  {Body} particleBody
 * @param  {Particle} particleShape
 * @param  {Array} particleOffset
 * @param  {Number} particleAngle
 * @param  {Boolean} justTest
 */ $2ce1f7f3add6a2a7$var$Narrowphase.prototype[$k7z01.CIRCLE | $k7z01.PARTICLE] = $2ce1f7f3add6a2a7$var$Narrowphase.prototype.circleParticle = function(circleBody, circleShape, circleOffset, circleAngle, particleBody, particleShape, particleOffset, particleAngle, justTest) {
    var dist = $2ce1f7f3add6a2a7$var$tmp1;
    $2ce1f7f3add6a2a7$var$sub(dist, particleOffset, circleOffset);
    if ($2Ys9z.squaredLength(dist) > Math.pow(circleShape.radius, 2)) return 0;
    if (justTest) return true;
    var c = this.createContactEquation(circleBody, particleBody, circleShape, particleShape);
    $2Ys9z.copy(c.normalA, dist);
    $2Ys9z.normalize(c.normalA, c.normalA);
    // Vector from circle to contact point is the normal times the circle radius
    $2Ys9z.scale(c.contactPointA, c.normalA, circleShape.radius);
    $2ce1f7f3add6a2a7$var$add(c.contactPointA, c.contactPointA, circleOffset);
    $2ce1f7f3add6a2a7$var$sub(c.contactPointA, c.contactPointA, circleBody.position);
    // Vector from particle center to contact point is zero
    $2ce1f7f3add6a2a7$var$sub(c.contactPointB, particleOffset, particleBody.position);
    this.contactEquations.push(c);
    if (this.enableFriction) this.frictionEquations.push(this.createFrictionFromContact(c));
    return 1;
};
var $2ce1f7f3add6a2a7$var$planeCapsule_tmpCircle = new $OJ0UJ({
    radius: 1
}), $2ce1f7f3add6a2a7$var$planeCapsule_tmp1 = $2Ys9z.create(), $2ce1f7f3add6a2a7$var$planeCapsule_tmp2 = $2Ys9z.create(), $2ce1f7f3add6a2a7$var$planeCapsule_tmp3 = $2Ys9z.create();
/**
 * @method planeCapsule
 * @param  {Body} planeBody
 * @param  {Circle} planeShape
 * @param  {Array} planeOffset
 * @param  {Number} planeAngle
 * @param  {Body} capsuleBody
 * @param  {Particle} capsuleShape
 * @param  {Array} capsuleOffset
 * @param  {Number} capsuleAngle
 * @param {Boolean} justTest
 */ $2ce1f7f3add6a2a7$var$Narrowphase.prototype[$k7z01.PLANE | $k7z01.CAPSULE] = $2ce1f7f3add6a2a7$var$Narrowphase.prototype.planeCapsule = function(planeBody, planeShape, planeOffset, planeAngle, capsuleBody, capsuleShape, capsuleOffset, capsuleAngle, justTest) {
    var end1 = $2ce1f7f3add6a2a7$var$planeCapsule_tmp1, end2 = $2ce1f7f3add6a2a7$var$planeCapsule_tmp2, circle = $2ce1f7f3add6a2a7$var$planeCapsule_tmpCircle, dst = $2ce1f7f3add6a2a7$var$planeCapsule_tmp3;
    // Compute world end positions
    $2Ys9z.set(end1, -capsuleShape.length / 2, 0);
    $2Ys9z.rotate(end1, end1, capsuleAngle);
    $2ce1f7f3add6a2a7$var$add(end1, end1, capsuleOffset);
    $2Ys9z.set(end2, capsuleShape.length / 2, 0);
    $2Ys9z.rotate(end2, end2, capsuleAngle);
    $2ce1f7f3add6a2a7$var$add(end2, end2, capsuleOffset);
    circle.radius = capsuleShape.radius;
    var enableFrictionBefore;
    // Temporarily turn off friction
    if (this.enableFrictionReduction) {
        enableFrictionBefore = this.enableFriction;
        this.enableFriction = false;
    }
    // Do Narrowphase as two circles
    var numContacts1 = this.circlePlane(capsuleBody, circle, end1, 0, planeBody, planeShape, planeOffset, planeAngle, justTest), numContacts2 = this.circlePlane(capsuleBody, circle, end2, 0, planeBody, planeShape, planeOffset, planeAngle, justTest);
    // Restore friction
    if (this.enableFrictionReduction) this.enableFriction = enableFrictionBefore;
    if (justTest) return numContacts1 || numContacts2;
    else {
        var numTotal = numContacts1 + numContacts2;
        if (this.enableFrictionReduction) {
            if (numTotal) this.frictionEquations.push(this.createFrictionFromAverage(numTotal));
        }
        return numTotal;
    }
};
/**
 * Creates ContactEquations and FrictionEquations for a collision.
 * @method circlePlane
 * @param  {Body}    bi     The first body that should be connected to the equations.
 * @param  {Circle}  si     The circle shape participating in the collision.
 * @param  {Array}   xi     Extra offset to take into account for the Shape, in addition to the one in circleBody.position. Will *not* be rotated by circleBody.angle (maybe it should, for sake of homogenity?). Set to null if none.
 * @param  {Body}    bj     The second body that should be connected to the equations.
 * @param  {Plane}   sj     The Plane shape that is participating
 * @param  {Array}   xj     Extra offset for the plane shape.
 * @param  {Number}  aj     Extra angle to apply to the plane
 */ $2ce1f7f3add6a2a7$var$Narrowphase.prototype[$k7z01.CIRCLE | $k7z01.PLANE] = $2ce1f7f3add6a2a7$var$Narrowphase.prototype.circlePlane = function(bi, si, xi, ai, bj, sj, xj, aj, justTest) {
    var circleBody = bi, circleShape = si, circleOffset = xi, planeBody = bj, shapeB = sj, planeOffset = xj, planeAngle = aj;
    planeAngle = planeAngle || 0;
    // Vector from plane to circle
    var planeToCircle = $2ce1f7f3add6a2a7$var$tmp1, worldNormal = $2ce1f7f3add6a2a7$var$tmp2, temp = $2ce1f7f3add6a2a7$var$tmp3;
    $2ce1f7f3add6a2a7$var$sub(planeToCircle, circleOffset, planeOffset);
    // World plane normal
    $2Ys9z.rotate(worldNormal, $2ce1f7f3add6a2a7$var$yAxis, planeAngle);
    // Normal direction distance
    var d = $2ce1f7f3add6a2a7$var$dot(worldNormal, planeToCircle);
    if (d > circleShape.radius) return 0; // No overlap. Abort.
    if (justTest) return true;
    // Create contact
    var contact = this.createContactEquation(planeBody, circleBody, sj, si);
    // ni is the plane world normal
    $2Ys9z.copy(contact.normalA, worldNormal);
    // rj is the vector from circle center to the contact point
    $2Ys9z.scale(contact.contactPointB, contact.normalA, -circleShape.radius);
    $2ce1f7f3add6a2a7$var$add(contact.contactPointB, contact.contactPointB, circleOffset);
    $2ce1f7f3add6a2a7$var$sub(contact.contactPointB, contact.contactPointB, circleBody.position);
    // ri is the distance from plane center to contact.
    $2Ys9z.scale(temp, contact.normalA, d);
    $2ce1f7f3add6a2a7$var$sub(contact.contactPointA, planeToCircle, temp); // Subtract normal distance vector from the distance vector
    $2ce1f7f3add6a2a7$var$add(contact.contactPointA, contact.contactPointA, planeOffset);
    $2ce1f7f3add6a2a7$var$sub(contact.contactPointA, contact.contactPointA, planeBody.position);
    this.contactEquations.push(contact);
    if (this.enableFriction) this.frictionEquations.push(this.createFrictionFromContact(contact));
    return 1;
};
/**
 * Convex/convex Narrowphase.See <a href="http://www.altdevblogaday.com/2011/05/13/contact-generation-between-3d-convex-meshes/">this article</a> for more info.
 * @method convexConvex
 * @param  {Body} bi
 * @param  {Convex} si
 * @param  {Array} xi
 * @param  {Number} ai
 * @param  {Body} bj
 * @param  {Convex} sj
 * @param  {Array} xj
 * @param  {Number} aj
 */ $2ce1f7f3add6a2a7$var$Narrowphase.prototype[$k7z01.CONVEX] = $2ce1f7f3add6a2a7$var$Narrowphase.prototype[$k7z01.CONVEX | $k7z01.BOX] = $2ce1f7f3add6a2a7$var$Narrowphase.prototype[$k7z01.BOX] = $2ce1f7f3add6a2a7$var$Narrowphase.prototype.convexConvex = function(bi, si, xi, ai, bj, sj, xj, aj, justTest, precision) {
    var sepAxis = $2ce1f7f3add6a2a7$var$tmp1, worldPoint = $2ce1f7f3add6a2a7$var$tmp2, worldPoint0 = $2ce1f7f3add6a2a7$var$tmp3, worldPoint1 = $2ce1f7f3add6a2a7$var$tmp4, worldEdge = $2ce1f7f3add6a2a7$var$tmp5, projected = $2ce1f7f3add6a2a7$var$tmp6, penetrationVec = $2ce1f7f3add6a2a7$var$tmp7, dist = $2ce1f7f3add6a2a7$var$tmp8, worldNormal = $2ce1f7f3add6a2a7$var$tmp9, numContacts = 0, precision = typeof precision === "number" ? precision : 0;
    var found = $2ce1f7f3add6a2a7$var$Narrowphase.findSeparatingAxis(si, xi, ai, sj, xj, aj, sepAxis);
    if (!found) return 0;
    // Make sure the separating axis is directed from shape i to shape j
    $2ce1f7f3add6a2a7$var$sub(dist, xj, xi);
    if ($2ce1f7f3add6a2a7$var$dot(sepAxis, dist) > 0) $2Ys9z.scale(sepAxis, sepAxis, -1);
    // Find edges with normals closest to the separating axis
    var closestEdge1 = $2ce1f7f3add6a2a7$var$Narrowphase.getClosestEdge(si, ai, sepAxis, true), closestEdge2 = $2ce1f7f3add6a2a7$var$Narrowphase.getClosestEdge(sj, aj, sepAxis);
    if (closestEdge1 === -1 || closestEdge2 === -1) return 0;
    // Loop over the shapes
    for(var k = 0; k < 2; k++){
        var closestEdgeA = closestEdge1, closestEdgeB = closestEdge2, shapeA = si, shapeB = sj, offsetA = xi, offsetB = xj, angleA = ai, angleB = aj, bodyA = bi, bodyB = bj;
        if (k === 0) {
            // Swap!
            var tmp;
            tmp = closestEdgeA;
            closestEdgeA = closestEdgeB;
            closestEdgeB = tmp;
            tmp = shapeA;
            shapeA = shapeB;
            shapeB = tmp;
            tmp = offsetA;
            offsetA = offsetB;
            offsetB = tmp;
            tmp = angleA;
            angleA = angleB;
            angleB = tmp;
            tmp = bodyA;
            bodyA = bodyB;
            bodyB = tmp;
        }
        // Loop over 2 points in convex B
        for(var j = closestEdgeB; j < closestEdgeB + 2; j++){
            // Get world point
            var v = shapeB.vertices[(j + shapeB.vertices.length) % shapeB.vertices.length];
            $2Ys9z.rotate(worldPoint, v, angleB);
            $2ce1f7f3add6a2a7$var$add(worldPoint, worldPoint, offsetB);
            var insideNumEdges = 0;
            // Loop over the 3 closest edges in convex A
            for(var i = closestEdgeA - 1; i < closestEdgeA + 2; i++){
                var v0 = shapeA.vertices[(i + shapeA.vertices.length) % shapeA.vertices.length], v1 = shapeA.vertices[(i + 1 + shapeA.vertices.length) % shapeA.vertices.length];
                // Construct the edge
                $2Ys9z.rotate(worldPoint0, v0, angleA);
                $2Ys9z.rotate(worldPoint1, v1, angleA);
                $2ce1f7f3add6a2a7$var$add(worldPoint0, worldPoint0, offsetA);
                $2ce1f7f3add6a2a7$var$add(worldPoint1, worldPoint1, offsetA);
                $2ce1f7f3add6a2a7$var$sub(worldEdge, worldPoint1, worldPoint0);
                $2Ys9z.rotate90cw(worldNormal, worldEdge); // Normal points out of convex 1
                $2Ys9z.normalize(worldNormal, worldNormal);
                $2ce1f7f3add6a2a7$var$sub(dist, worldPoint, worldPoint0);
                var d = $2ce1f7f3add6a2a7$var$dot(worldNormal, dist);
                if (i === closestEdgeA && d <= precision || i !== closestEdgeA && d <= 0) insideNumEdges++;
            }
            if (insideNumEdges >= 3) {
                if (justTest) return true;
                // worldPoint was on the "inside" side of each of the 3 checked edges.
                // Project it to the center edge and use the projection direction as normal
                // Create contact
                var c = this.createContactEquation(bodyA, bodyB, shapeA, shapeB);
                numContacts++;
                // Get center edge from body A
                var v0 = shapeA.vertices[closestEdgeA % shapeA.vertices.length], v1 = shapeA.vertices[(closestEdgeA + 1) % shapeA.vertices.length];
                // Construct the edge
                $2Ys9z.rotate(worldPoint0, v0, angleA);
                $2Ys9z.rotate(worldPoint1, v1, angleA);
                $2ce1f7f3add6a2a7$var$add(worldPoint0, worldPoint0, offsetA);
                $2ce1f7f3add6a2a7$var$add(worldPoint1, worldPoint1, offsetA);
                $2ce1f7f3add6a2a7$var$sub(worldEdge, worldPoint1, worldPoint0);
                $2Ys9z.rotate90cw(c.normalA, worldEdge); // Normal points out of convex A
                $2Ys9z.normalize(c.normalA, c.normalA);
                $2ce1f7f3add6a2a7$var$sub(dist, worldPoint, worldPoint0); // From edge point to the penetrating point
                var d = $2ce1f7f3add6a2a7$var$dot(c.normalA, dist); // Penetration
                $2Ys9z.scale(penetrationVec, c.normalA, d); // Vector penetration
                $2ce1f7f3add6a2a7$var$sub(c.contactPointA, worldPoint, offsetA);
                $2ce1f7f3add6a2a7$var$sub(c.contactPointA, c.contactPointA, penetrationVec);
                $2ce1f7f3add6a2a7$var$add(c.contactPointA, c.contactPointA, offsetA);
                $2ce1f7f3add6a2a7$var$sub(c.contactPointA, c.contactPointA, bodyA.position);
                $2ce1f7f3add6a2a7$var$sub(c.contactPointB, worldPoint, offsetB);
                $2ce1f7f3add6a2a7$var$add(c.contactPointB, c.contactPointB, offsetB);
                $2ce1f7f3add6a2a7$var$sub(c.contactPointB, c.contactPointB, bodyB.position);
                this.contactEquations.push(c);
                // Todo reduce to 1 friction equation if we have 2 contact points
                if (!this.enableFrictionReduction) {
                    if (this.enableFriction) this.frictionEquations.push(this.createFrictionFromContact(c));
                }
            }
        }
    }
    if (this.enableFrictionReduction) {
        if (this.enableFriction && numContacts) this.frictionEquations.push(this.createFrictionFromAverage(numContacts));
    }
    return numContacts;
};
// .projectConvex is called by other functions, need local tmp vectors
var $2ce1f7f3add6a2a7$var$pcoa_tmp1 = $2Ys9z.fromValues(0, 0);
/**
 * Project a Convex onto a world-oriented axis
 * @method projectConvexOntoAxis
 * @static
 * @param  {Convex} convexShape
 * @param  {Array} convexOffset
 * @param  {Number} convexAngle
 * @param  {Array} worldAxis
 * @param  {Array} result
 */ $2ce1f7f3add6a2a7$var$Narrowphase.projectConvexOntoAxis = function(convexShape, convexOffset, convexAngle, worldAxis, result) {
    var max = null, min = null, v, value, localAxis = $2ce1f7f3add6a2a7$var$pcoa_tmp1;
    // Convert the axis to local coords of the body
    $2Ys9z.rotate(localAxis, worldAxis, -convexAngle);
    // Get projected position of all vertices
    for(var i = 0; i < convexShape.vertices.length; i++){
        v = convexShape.vertices[i];
        value = $2ce1f7f3add6a2a7$var$dot(v, localAxis);
        if (max === null || value > max) max = value;
        if (min === null || value < min) min = value;
    }
    if (min > max) {
        var t = min;
        min = max;
        max = t;
    }
    // Project the position of the body onto the axis - need to add this to the result
    var offset = $2ce1f7f3add6a2a7$var$dot(convexOffset, worldAxis);
    $2Ys9z.set(result, min + offset, max + offset);
};
// .findSeparatingAxis is called by other functions, need local tmp vectors
var $2ce1f7f3add6a2a7$var$fsa_tmp1 = $2Ys9z.fromValues(0, 0), $2ce1f7f3add6a2a7$var$fsa_tmp2 = $2Ys9z.fromValues(0, 0), $2ce1f7f3add6a2a7$var$fsa_tmp3 = $2Ys9z.fromValues(0, 0), $2ce1f7f3add6a2a7$var$fsa_tmp4 = $2Ys9z.fromValues(0, 0), $2ce1f7f3add6a2a7$var$fsa_tmp5 = $2Ys9z.fromValues(0, 0), $2ce1f7f3add6a2a7$var$fsa_tmp6 = $2Ys9z.fromValues(0, 0);
/**
 * Find a separating axis between the shapes, that maximizes the separating distance between them.
 * @method findSeparatingAxis
 * @static
 * @param  {Convex}     c1
 * @param  {Array}      offset1
 * @param  {Number}     angle1
 * @param  {Convex}     c2
 * @param  {Array}      offset2
 * @param  {Number}     angle2
 * @param  {Array}      sepAxis     The resulting axis
 * @return {Boolean}                Whether the axis could be found.
 */ $2ce1f7f3add6a2a7$var$Narrowphase.findSeparatingAxis = function(c1, offset1, angle1, c2, offset2, angle2, sepAxis) {
    var maxDist = null, overlap = false, found = false, edge = $2ce1f7f3add6a2a7$var$fsa_tmp1, worldPoint0 = $2ce1f7f3add6a2a7$var$fsa_tmp2, worldPoint1 = $2ce1f7f3add6a2a7$var$fsa_tmp3, normal = $2ce1f7f3add6a2a7$var$fsa_tmp4, span1 = $2ce1f7f3add6a2a7$var$fsa_tmp5, span2 = $2ce1f7f3add6a2a7$var$fsa_tmp6;
    if (c1 instanceof $62ywx && c2 instanceof $62ywx) for(var j = 0; j !== 2; j++){
        var c = c1, angle = angle1;
        if (j === 1) {
            c = c2;
            angle = angle2;
        }
        for(var i = 0; i !== 2; i++){
            // Get the world edge
            if (i === 0) $2Ys9z.set(normal, 0, 1);
            else if (i === 1) $2Ys9z.set(normal, 1, 0);
            if (angle !== 0) $2Ys9z.rotate(normal, normal, angle);
            // Project hulls onto that normal
            $2ce1f7f3add6a2a7$var$Narrowphase.projectConvexOntoAxis(c1, offset1, angle1, normal, span1);
            $2ce1f7f3add6a2a7$var$Narrowphase.projectConvexOntoAxis(c2, offset2, angle2, normal, span2);
            // Order by span position
            var a = span1, b = span2, swapped = false;
            if (span1[0] > span2[0]) {
                b = span1;
                a = span2;
                swapped = true;
            }
            // Get separating distance
            var dist = b[0] - a[1];
            overlap = dist <= 0;
            if (maxDist === null || dist > maxDist) {
                $2Ys9z.copy(sepAxis, normal);
                maxDist = dist;
                found = overlap;
            }
        }
    }
    else for(var j = 0; j !== 2; j++){
        var c = c1, angle = angle1;
        if (j === 1) {
            c = c2;
            angle = angle2;
        }
        for(var i = 0; i !== c.vertices.length; i++){
            // Get the world edge
            $2Ys9z.rotate(worldPoint0, c.vertices[i], angle);
            $2Ys9z.rotate(worldPoint1, c.vertices[(i + 1) % c.vertices.length], angle);
            $2ce1f7f3add6a2a7$var$sub(edge, worldPoint1, worldPoint0);
            // Get normal - just rotate 90 degrees since vertices are given in CCW
            $2Ys9z.rotate90cw(normal, edge);
            $2Ys9z.normalize(normal, normal);
            // Project hulls onto that normal
            $2ce1f7f3add6a2a7$var$Narrowphase.projectConvexOntoAxis(c1, offset1, angle1, normal, span1);
            $2ce1f7f3add6a2a7$var$Narrowphase.projectConvexOntoAxis(c2, offset2, angle2, normal, span2);
            // Order by span position
            var a = span1, b = span2, swapped = false;
            if (span1[0] > span2[0]) {
                b = span1;
                a = span2;
                swapped = true;
            }
            // Get separating distance
            var dist = b[0] - a[1];
            overlap = dist <= 0;
            if (maxDist === null || dist > maxDist) {
                $2Ys9z.copy(sepAxis, normal);
                maxDist = dist;
                found = overlap;
            }
        }
    }
    /*
    // Needs to be tested some more
    for(var j=0; j!==2; j++){
        var c = c1,
            angle = angle1;
        if(j===1){
            c = c2;
            angle = angle2;
        }

        for(var i=0; i!==c.axes.length; i++){

            var normal = c.axes[i];

            // Project hulls onto that normal
            Narrowphase.projectConvexOntoAxis(c1, offset1, angle1, normal, span1);
            Narrowphase.projectConvexOntoAxis(c2, offset2, angle2, normal, span2);

            // Order by span position
            var a=span1,
                b=span2,
                swapped = false;
            if(span1[0] > span2[0]){
                b=span1;
                a=span2;
                swapped = true;
            }

            // Get separating distance
            var dist = b[0] - a[1];
            overlap = (dist <= Narrowphase.convexPrecision);

            if(maxDist===null || dist > maxDist){
                vec2.copy(sepAxis, normal);
                maxDist = dist;
                found = overlap;
            }
        }
    }
    */ return found;
};
// .getClosestEdge is called by other functions, need local tmp vectors
var $2ce1f7f3add6a2a7$var$gce_tmp1 = $2Ys9z.fromValues(0, 0), $2ce1f7f3add6a2a7$var$gce_tmp2 = $2Ys9z.fromValues(0, 0), $2ce1f7f3add6a2a7$var$gce_tmp3 = $2Ys9z.fromValues(0, 0);
/**
 * Get the edge that has a normal closest to an axis.
 * @method getClosestEdge
 * @static
 * @param  {Convex}     c
 * @param  {Number}     angle
 * @param  {Array}      axis
 * @param  {Boolean}    flip
 * @return {Number}             Index of the edge that is closest. This index and the next spans the resulting edge. Returns -1 if failed.
 */ $2ce1f7f3add6a2a7$var$Narrowphase.getClosestEdge = function(c, angle, axis, flip) {
    var localAxis = $2ce1f7f3add6a2a7$var$gce_tmp1, edge = $2ce1f7f3add6a2a7$var$gce_tmp2, normal = $2ce1f7f3add6a2a7$var$gce_tmp3;
    // Convert the axis to local coords of the body
    $2Ys9z.rotate(localAxis, axis, -angle);
    if (flip) $2Ys9z.scale(localAxis, localAxis, -1);
    var closestEdge = -1, N = c.vertices.length, maxDot = -1;
    for(var i = 0; i !== N; i++){
        // Get the edge
        $2ce1f7f3add6a2a7$var$sub(edge, c.vertices[(i + 1) % N], c.vertices[i % N]);
        // Get normal - just rotate 90 degrees since vertices are given in CCW
        $2Ys9z.rotate90cw(normal, edge);
        $2Ys9z.normalize(normal, normal);
        var d = $2ce1f7f3add6a2a7$var$dot(normal, localAxis);
        if (closestEdge === -1 || d > maxDot) {
            closestEdge = i % N;
            maxDot = d;
        }
    }
    return closestEdge;
};
var $2ce1f7f3add6a2a7$var$circleHeightfield_candidate = $2Ys9z.create(), $2ce1f7f3add6a2a7$var$circleHeightfield_dist = $2Ys9z.create(), $2ce1f7f3add6a2a7$var$circleHeightfield_v0 = $2Ys9z.create(), $2ce1f7f3add6a2a7$var$circleHeightfield_v1 = $2Ys9z.create(), $2ce1f7f3add6a2a7$var$circleHeightfield_minCandidate = $2Ys9z.create(), $2ce1f7f3add6a2a7$var$circleHeightfield_worldNormal = $2Ys9z.create(), $2ce1f7f3add6a2a7$var$circleHeightfield_minCandidateNormal = $2Ys9z.create();
/**
 * @method circleHeightfield
 * @param  {Body}           bi
 * @param  {Circle}         si
 * @param  {Array}          xi
 * @param  {Body}           bj
 * @param  {Heightfield}    sj
 * @param  {Array}          xj
 * @param  {Number}         aj
 */ $2ce1f7f3add6a2a7$var$Narrowphase.prototype[$k7z01.CIRCLE | $k7z01.HEIGHTFIELD] = $2ce1f7f3add6a2a7$var$Narrowphase.prototype.circleHeightfield = function(circleBody, circleShape, circlePos, circleAngle, hfBody, hfShape, hfPos, hfAngle, justTest, radius) {
    var data = hfShape.heights, radius = radius || circleShape.radius, w = hfShape.elementWidth, dist = $2ce1f7f3add6a2a7$var$circleHeightfield_dist, candidate = $2ce1f7f3add6a2a7$var$circleHeightfield_candidate, minCandidate = $2ce1f7f3add6a2a7$var$circleHeightfield_minCandidate, minCandidateNormal = $2ce1f7f3add6a2a7$var$circleHeightfield_minCandidateNormal, worldNormal = $2ce1f7f3add6a2a7$var$circleHeightfield_worldNormal, v0 = $2ce1f7f3add6a2a7$var$circleHeightfield_v0, v1 = $2ce1f7f3add6a2a7$var$circleHeightfield_v1;
    // Get the index of the points to test against
    var idxA = Math.floor((circlePos[0] - radius - hfPos[0]) / w), idxB = Math.ceil((circlePos[0] + radius - hfPos[0]) / w);
    /*if(idxB < 0 || idxA >= data.length)
        return justTest ? false : 0;*/ if (idxA < 0) idxA = 0;
    if (idxB >= data.length) idxB = data.length - 1;
    // Get max and min
    var max = data[idxA], min = data[idxB];
    for(var i = idxA; i < idxB; i++){
        if (data[i] < min) min = data[i];
        if (data[i] > max) max = data[i];
    }
    if (circlePos[1] - radius > max) return justTest ? false : 0;
    /*
    if(circlePos[1]+radius < min){
        // Below the minimum point... We can just guess.
        // TODO
    }
    */ // 1. Check so center of circle is not inside the field. If it is, this wont work...
    // 2. For each edge
    // 2. 1. Get point on circle that is closest to the edge (scale normal with -radius)
    // 2. 2. Check if point is inside.
    var found = false;
    // Check all edges first
    for(var i = idxA; i < idxB; i++){
        // Get points
        $2Ys9z.set(v0, i * w, data[i]);
        $2Ys9z.set(v1, (i + 1) * w, data[i + 1]);
        $2Ys9z.add(v0, v0, hfPos);
        $2Ys9z.add(v1, v1, hfPos);
        // Get normal
        $2Ys9z.sub(worldNormal, v1, v0);
        $2Ys9z.rotate(worldNormal, worldNormal, Math.PI / 2);
        $2Ys9z.normalize(worldNormal, worldNormal);
        // Get point on circle, closest to the edge
        $2Ys9z.scale(candidate, worldNormal, -radius);
        $2Ys9z.add(candidate, candidate, circlePos);
        // Distance from v0 to the candidate point
        $2Ys9z.sub(dist, candidate, v0);
        // Check if it is in the element "stick"
        var d = $2Ys9z.dot(dist, worldNormal);
        if (candidate[0] >= v0[0] && candidate[0] < v1[0] && d <= 0) {
            if (justTest) return true;
            found = true;
            // Store the candidate point, projected to the edge
            $2Ys9z.scale(dist, worldNormal, -d);
            $2Ys9z.add(minCandidate, candidate, dist);
            $2Ys9z.copy(minCandidateNormal, worldNormal);
            var c = this.createContactEquation(hfBody, circleBody, hfShape, circleShape);
            // Normal is out of the heightfield
            $2Ys9z.copy(c.normalA, minCandidateNormal);
            // Vector from circle to heightfield
            $2Ys9z.scale(c.contactPointB, c.normalA, -radius);
            $2ce1f7f3add6a2a7$var$add(c.contactPointB, c.contactPointB, circlePos);
            $2ce1f7f3add6a2a7$var$sub(c.contactPointB, c.contactPointB, circleBody.position);
            $2Ys9z.copy(c.contactPointA, minCandidate);
            $2Ys9z.sub(c.contactPointA, c.contactPointA, hfBody.position);
            this.contactEquations.push(c);
            if (this.enableFriction) this.frictionEquations.push(this.createFrictionFromContact(c));
        }
    }
    // Check all vertices
    found = false;
    if (radius > 0) for(var i = idxA; i <= idxB; i++){
        // Get point
        $2Ys9z.set(v0, i * w, data[i]);
        $2Ys9z.add(v0, v0, hfPos);
        $2Ys9z.sub(dist, circlePos, v0);
        if ($2Ys9z.squaredLength(dist) < Math.pow(radius, 2)) {
            if (justTest) return true;
            found = true;
            var c = this.createContactEquation(hfBody, circleBody, hfShape, circleShape);
            // Construct normal - out of heightfield
            $2Ys9z.copy(c.normalA, dist);
            $2Ys9z.normalize(c.normalA, c.normalA);
            $2Ys9z.scale(c.contactPointB, c.normalA, -radius);
            $2ce1f7f3add6a2a7$var$add(c.contactPointB, c.contactPointB, circlePos);
            $2ce1f7f3add6a2a7$var$sub(c.contactPointB, c.contactPointB, circleBody.position);
            $2ce1f7f3add6a2a7$var$sub(c.contactPointA, v0, hfPos);
            $2ce1f7f3add6a2a7$var$add(c.contactPointA, c.contactPointA, hfPos);
            $2ce1f7f3add6a2a7$var$sub(c.contactPointA, c.contactPointA, hfBody.position);
            this.contactEquations.push(c);
            if (this.enableFriction) this.frictionEquations.push(this.createFrictionFromContact(c));
        }
    }
    if (found) return 1;
    return 0;
};
var $2ce1f7f3add6a2a7$var$convexHeightfield_v0 = $2Ys9z.create(), $2ce1f7f3add6a2a7$var$convexHeightfield_v1 = $2Ys9z.create(), $2ce1f7f3add6a2a7$var$convexHeightfield_tilePos = $2Ys9z.create(), $2ce1f7f3add6a2a7$var$convexHeightfield_tempConvexShape = new $clDtn({
    vertices: [
        $2Ys9z.create(),
        $2Ys9z.create(),
        $2Ys9z.create(),
        $2Ys9z.create()
    ]
});
/**
 * @method circleHeightfield
 * @param  {Body}           bi
 * @param  {Circle}         si
 * @param  {Array}          xi
 * @param  {Body}           bj
 * @param  {Heightfield}    sj
 * @param  {Array}          xj
 * @param  {Number}         aj
 */ $2ce1f7f3add6a2a7$var$Narrowphase.prototype[$k7z01.BOX | $k7z01.HEIGHTFIELD] = $2ce1f7f3add6a2a7$var$Narrowphase.prototype[$k7z01.CONVEX | $k7z01.HEIGHTFIELD] = $2ce1f7f3add6a2a7$var$Narrowphase.prototype.convexHeightfield = function(convexBody, convexShape, convexPos, convexAngle, hfBody, hfShape, hfPos, hfAngle, justTest) {
    var data = hfShape.heights, w = hfShape.elementWidth, v0 = $2ce1f7f3add6a2a7$var$convexHeightfield_v0, v1 = $2ce1f7f3add6a2a7$var$convexHeightfield_v1, tilePos = $2ce1f7f3add6a2a7$var$convexHeightfield_tilePos, tileConvex = $2ce1f7f3add6a2a7$var$convexHeightfield_tempConvexShape;
    // Get the index of the points to test against
    var idxA = Math.floor((convexBody.aabb.lowerBound[0] - hfPos[0]) / w), idxB = Math.ceil((convexBody.aabb.upperBound[0] - hfPos[0]) / w);
    if (idxA < 0) idxA = 0;
    if (idxB >= data.length) idxB = data.length - 1;
    // Get max and min
    var max = data[idxA], min = data[idxB];
    for(var i = idxA; i < idxB; i++){
        if (data[i] < min) min = data[i];
        if (data[i] > max) max = data[i];
    }
    if (convexBody.aabb.lowerBound[1] > max) return justTest ? false : 0;
    var found = false;
    var numContacts = 0;
    // Loop over all edges
    // TODO: If possible, construct a convex from several data points (need o check if the points make a convex shape)
    for(var i = idxA; i < idxB; i++){
        // Get points
        $2Ys9z.set(v0, i * w, data[i]);
        $2Ys9z.set(v1, (i + 1) * w, data[i + 1]);
        $2Ys9z.add(v0, v0, hfPos);
        $2Ys9z.add(v1, v1, hfPos);
        // Construct a convex
        var tileHeight = 100; // todo
        $2Ys9z.set(tilePos, (v1[0] + v0[0]) * 0.5, (v1[1] + v0[1] - tileHeight) * 0.5);
        $2Ys9z.sub(tileConvex.vertices[0], v1, tilePos);
        $2Ys9z.sub(tileConvex.vertices[1], v0, tilePos);
        $2Ys9z.copy(tileConvex.vertices[2], tileConvex.vertices[1]);
        $2Ys9z.copy(tileConvex.vertices[3], tileConvex.vertices[0]);
        tileConvex.vertices[2][1] -= tileHeight;
        tileConvex.vertices[3][1] -= tileHeight;
        // Do convex collision
        numContacts += this.convexConvex(convexBody, convexShape, convexPos, convexAngle, hfBody, tileConvex, tilePos, 0, justTest);
    }
    return numContacts;
};

});
parcelRegister("jFBgF", function(module, exports) {

var $dMz05 = parcelRequire("dMz05");
module.exports = $e51ec140a1f3ad06$var$TupleDictionary;
/**
 * @class TupleDictionary
 * @constructor
 */ function $e51ec140a1f3ad06$var$TupleDictionary() {
    /**
     * The data storage
     * @property data
     * @type {Object}
     */ this.data = {};
    /**
     * Keys that are currently used.
     * @property {Array} keys
     */ this.keys = [];
}
/**
 * Generate a key given two integers
 * @method getKey
 * @param  {number} i
 * @param  {number} j
 * @return {string}
 */ $e51ec140a1f3ad06$var$TupleDictionary.prototype.getKey = function(id1, id2) {
    id1 = id1 | 0;
    id2 = id2 | 0;
    if ((id1 | 0) === (id2 | 0)) return -1;
    // valid for values < 2^16
    return ((id1 | 0) > (id2 | 0) ? id1 << 16 | id2 & 0xFFFF : id2 << 16 | id1 & 0xFFFF) | 0;
};
/**
 * @method getByKey
 * @param  {Number} key
 * @return {Object}
 */ $e51ec140a1f3ad06$var$TupleDictionary.prototype.getByKey = function(key) {
    key = key | 0;
    return this.data[key];
};
/**
 * @method get
 * @param  {Number} i
 * @param  {Number} j
 * @return {Number}
 */ $e51ec140a1f3ad06$var$TupleDictionary.prototype.get = function(i, j) {
    return this.data[this.getKey(i, j)];
};
/**
 * Set a value.
 * @method set
 * @param  {Number} i
 * @param  {Number} j
 * @param {Number} value
 */ $e51ec140a1f3ad06$var$TupleDictionary.prototype.set = function(i, j, value) {
    if (!value) throw new Error("No data!");
    var key = this.getKey(i, j);
    // Check if key already exists
    if (!this.data[key]) this.keys.push(key);
    this.data[key] = value;
    return key;
};
/**
 * Remove all data.
 * @method reset
 */ $e51ec140a1f3ad06$var$TupleDictionary.prototype.reset = function() {
    var data = this.data, keys = this.keys;
    var l = keys.length;
    while(l--)delete data[keys[l]];
    keys.length = 0;
};
/**
 * Copy another TupleDictionary. Note that all data in this dictionary will be removed.
 * @method copy
 * @param {TupleDictionary} dict The TupleDictionary to copy into this one.
 */ $e51ec140a1f3ad06$var$TupleDictionary.prototype.copy = function(dict) {
    this.reset();
    $dMz05.appendArray(this.keys, dict.keys);
    var l = dict.keys.length;
    while(l--){
        var key = dict.keys[l];
        this.data[key] = dict.data[key];
    }
};

});

parcelRegister("62ywx", function(module, exports) {

var $2Ys9z = parcelRequire("2Ys9z");

var $k7z01 = parcelRequire("k7z01");

var $clDtn = parcelRequire("clDtn");
module.exports = $465db5af288332c5$var$Box;
/**
 * Box shape class.
 * @class Box
 * @constructor
 * @param {object} [options] (Note that this options object will be passed on to the {{#crossLink "Shape"}}{{/crossLink}} constructor.)
 * @param {Number} [options.width=1] Total width of the box
 * @param {Number} [options.height=1] Total height of the box
 * @extends Convex
 */ function $465db5af288332c5$var$Box(options) {
    if (typeof arguments[0] === "number" && typeof arguments[1] === "number") {
        options = {
            width: arguments[0],
            height: arguments[1]
        };
        console.warn("The Rectangle has been renamed to Box and its constructor signature has changed. Please use the following format: new Box({ width: 1, height: 1, ... })");
    }
    options = options || {};
    /**
     * Total width of the box
     * @property width
     * @type {Number}
     */ var width = this.width = options.width || 1;
    /**
     * Total height of the box
     * @property height
     * @type {Number}
     */ var height = this.height = options.height || 1;
    var verts = [
        $2Ys9z.fromValues(-width / 2, -height / 2),
        $2Ys9z.fromValues(width / 2, -height / 2),
        $2Ys9z.fromValues(width / 2, height / 2),
        $2Ys9z.fromValues(-width / 2, height / 2)
    ];
    var axes = [
        $2Ys9z.fromValues(1, 0),
        $2Ys9z.fromValues(0, 1)
    ];
    options.vertices = verts;
    options.axes = axes;
    options.type = $k7z01.BOX;
    $clDtn.call(this, options);
}
$465db5af288332c5$var$Box.prototype = new $clDtn();
$465db5af288332c5$var$Box.prototype.constructor = $465db5af288332c5$var$Box;
/**
 * Compute moment of inertia
 * @method computeMomentOfInertia
 * @param  {Number} mass
 * @return {Number}
 */ $465db5af288332c5$var$Box.prototype.computeMomentOfInertia = function(mass) {
    var w = this.width, h = this.height;
    return mass * (h * h + w * w) / 12;
};
/**
 * Update the bounding radius
 * @method updateBoundingRadius
 */ $465db5af288332c5$var$Box.prototype.updateBoundingRadius = function() {
    var w = this.width, h = this.height;
    this.boundingRadius = Math.sqrt(w * w + h * h) / 2;
};
var $465db5af288332c5$var$corner1 = $2Ys9z.create(), $465db5af288332c5$var$corner2 = $2Ys9z.create(), $465db5af288332c5$var$corner3 = $2Ys9z.create(), $465db5af288332c5$var$corner4 = $2Ys9z.create();
/**
 * @method computeAABB
 * @param  {AABB}   out      The resulting AABB.
 * @param  {Array}  position
 * @param  {Number} angle
 */ $465db5af288332c5$var$Box.prototype.computeAABB = function(out, position, angle) {
    out.setFromPoints(this.vertices, position, angle, 0);
};
$465db5af288332c5$var$Box.prototype.updateArea = function() {
    this.area = this.width * this.height;
};

});


parcelRegister("8e56j", function(module, exports) {
parcelRequire("OJ0UJ");
parcelRequire("hNAi3");
parcelRequire("k7z01");
parcelRequire("fwNHk");

var $dQgku = parcelRequire("dQgku");
parcelRequire("2Ys9z");
module.exports = $5fd396785f3a7a98$var$NaiveBroadphase;
/**
 * Naive broadphase implementation. Does N^2 tests.
 *
 * @class NaiveBroadphase
 * @constructor
 * @extends Broadphase
 */ function $5fd396785f3a7a98$var$NaiveBroadphase() {
    $dQgku.call(this, $dQgku.NAIVE);
}
$5fd396785f3a7a98$var$NaiveBroadphase.prototype = new $dQgku();
$5fd396785f3a7a98$var$NaiveBroadphase.prototype.constructor = $5fd396785f3a7a98$var$NaiveBroadphase;
/**
 * Get the colliding pairs
 * @method getCollisionPairs
 * @param  {World} world
 * @return {Array}
 */ $5fd396785f3a7a98$var$NaiveBroadphase.prototype.getCollisionPairs = function(world) {
    var bodies = world.bodies, result = this.result;
    result.length = 0;
    for(var i = 0, Ncolliding = bodies.length; i !== Ncolliding; i++){
        var bi = bodies[i];
        for(var j = 0; j < i; j++){
            var bj = bodies[j];
            if ($dQgku.canCollide(bi, bj) && this.boundingVolumeCheck(bi, bj)) result.push(bi, bj);
        }
    }
    return result;
};
/**
 * Returns all the bodies within an AABB.
 * @method aabbQuery
 * @param  {World} world
 * @param  {AABB} aabb
 * @param {array} result An array to store resulting bodies in.
 * @return {array}
 */ $5fd396785f3a7a98$var$NaiveBroadphase.prototype.aabbQuery = function(world, aabb, result) {
    result = result || [];
    var bodies = world.bodies;
    for(var i = 0; i < bodies.length; i++){
        var b = bodies[i];
        if (b.aabbNeedsUpdate) b.updateAABB();
        if (b.aabb.overlaps(aabb)) result.push(b);
    }
    return result;
};

});
parcelRegister("hNAi3", function(module, exports) {

var $k7z01 = parcelRequire("k7z01");

var $2Ys9z = parcelRequire("2Ys9z");
parcelRequire("dMz05");
module.exports = $cf5329bd50db2f04$var$Plane;
/**
 * Plane shape class. The plane is facing in the Y direction.
 * @class Plane
 * @extends Shape
 * @constructor
 * @param {object} [options] (Note that this options object will be passed on to the {{#crossLink "Shape"}}{{/crossLink}} constructor.)
 */ function $cf5329bd50db2f04$var$Plane(options) {
    options = options || {};
    options.type = $k7z01.PLANE;
    $k7z01.call(this, options);
}
$cf5329bd50db2f04$var$Plane.prototype = new $k7z01();
$cf5329bd50db2f04$var$Plane.prototype.constructor = $cf5329bd50db2f04$var$Plane;
/**
 * Compute moment of inertia
 * @method computeMomentOfInertia
 */ $cf5329bd50db2f04$var$Plane.prototype.computeMomentOfInertia = function(mass) {
    return 0; // Plane is infinite. The inertia should therefore be infinty but by convention we set 0 here
};
/**
 * Update the bounding radius
 * @method updateBoundingRadius
 */ $cf5329bd50db2f04$var$Plane.prototype.updateBoundingRadius = function() {
    this.boundingRadius = Number.MAX_VALUE;
};
/**
 * @method computeAABB
 * @param  {AABB}   out
 * @param  {Array}  position
 * @param  {Number} angle
 */ $cf5329bd50db2f04$var$Plane.prototype.computeAABB = function(out, position, angle) {
    var a = angle % (2 * Math.PI);
    var set = $2Ys9z.set;
    var max = 1e7;
    var lowerBound = out.lowerBound;
    var upperBound = out.upperBound;
    // Set max bounds
    set(lowerBound, -max, -max);
    set(upperBound, max, max);
    if (a === 0) // y goes from -inf to 0
    upperBound[1] = 0;
    else if (a === Math.PI / 2) // x goes from 0 to inf
    lowerBound[0] = 0;
    else if (a === Math.PI) // y goes from 0 to inf
    lowerBound[1] = 0;
    else if (a === 3 * Math.PI / 2) // x goes from -inf to 0
    upperBound[0] = 0;
};
$cf5329bd50db2f04$var$Plane.prototype.updateArea = function() {
    this.area = Number.MAX_VALUE;
};
var $cf5329bd50db2f04$var$intersectPlane_planePointToFrom = $2Ys9z.create();
var $cf5329bd50db2f04$var$intersectPlane_dir_scaled_with_t = $2Ys9z.create();
var $cf5329bd50db2f04$var$intersectPlane_hitPoint = $2Ys9z.create();
var $cf5329bd50db2f04$var$intersectPlane_normal = $2Ys9z.create();
var $cf5329bd50db2f04$var$intersectPlane_len = $2Ys9z.create();
/**
 * @method raycast
 * @param  {RayResult} result
 * @param  {Ray} ray
 * @param  {array} position
 * @param  {number} angle
 */ $cf5329bd50db2f04$var$Plane.prototype.raycast = function(result, ray, position, angle) {
    var from = ray.from;
    var to = ray.to;
    var direction = ray.direction;
    var planePointToFrom = $cf5329bd50db2f04$var$intersectPlane_planePointToFrom;
    var dir_scaled_with_t = $cf5329bd50db2f04$var$intersectPlane_dir_scaled_with_t;
    var hitPoint = $cf5329bd50db2f04$var$intersectPlane_hitPoint;
    var normal = $cf5329bd50db2f04$var$intersectPlane_normal;
    var len = $cf5329bd50db2f04$var$intersectPlane_len;
    // Get plane normal
    $2Ys9z.set(normal, 0, 1);
    $2Ys9z.rotate(normal, normal, angle);
    $2Ys9z.sub(len, from, position);
    var planeToFrom = $2Ys9z.dot(len, normal);
    $2Ys9z.sub(len, to, position);
    var planeToTo = $2Ys9z.dot(len, normal);
    if (planeToFrom * planeToTo > 0) // "from" and "to" are on the same side of the plane... bail out
    return;
    if ($2Ys9z.squaredDistance(from, to) < planeToFrom * planeToFrom) return;
    var n_dot_dir = $2Ys9z.dot(normal, direction);
    $2Ys9z.sub(planePointToFrom, from, position);
    var t = -$2Ys9z.dot(normal, planePointToFrom) / n_dot_dir / ray.length;
    ray.reportIntersection(result, t, normal, -1);
};

});

parcelRegister("fwNHk", function(module, exports) {

var $k7z01 = parcelRequire("k7z01");

var $2Ys9z = parcelRequire("2Ys9z");
module.exports = $b4e0651ff5e40f92$var$Particle;
/**
 * Particle shape class.
 * @class Particle
 * @constructor
 * @param {object} [options] (Note that this options object will be passed on to the {{#crossLink "Shape"}}{{/crossLink}} constructor.)
 * @extends Shape
 */ function $b4e0651ff5e40f92$var$Particle(options) {
    options = options || {};
    options.type = $k7z01.PARTICLE;
    $k7z01.call(this, options);
}
$b4e0651ff5e40f92$var$Particle.prototype = new $k7z01();
$b4e0651ff5e40f92$var$Particle.prototype.constructor = $b4e0651ff5e40f92$var$Particle;
$b4e0651ff5e40f92$var$Particle.prototype.computeMomentOfInertia = function(mass) {
    return 0; // Can't rotate a particle
};
$b4e0651ff5e40f92$var$Particle.prototype.updateBoundingRadius = function() {
    this.boundingRadius = 0;
};
/**
 * @method computeAABB
 * @param  {AABB}   out
 * @param  {Array}  position
 * @param  {Number} angle
 */ $b4e0651ff5e40f92$var$Particle.prototype.computeAABB = function(out, position, angle) {
    $2Ys9z.copy(out.lowerBound, position);
    $2Ys9z.copy(out.upperBound, position);
};

});


parcelRegister("fc4SC", function(module, exports) {

var $3iby4 = parcelRequire("3iby4");

var $f0tQu = parcelRequire("f0tQu");

var $5vxRN = parcelRequire("5vxRN");

var $5UnY9 = parcelRequire("5UnY9");

var $2Ys9z = parcelRequire("2Ys9z");
module.exports = $b0fbc309f6f5f11f$var$RevoluteConstraint;
var $b0fbc309f6f5f11f$var$worldPivotA = $2Ys9z.create(), $b0fbc309f6f5f11f$var$worldPivotB = $2Ys9z.create(), $b0fbc309f6f5f11f$var$xAxis = $2Ys9z.fromValues(1, 0), $b0fbc309f6f5f11f$var$yAxis = $2Ys9z.fromValues(0, 1), $b0fbc309f6f5f11f$var$g = $2Ys9z.create();
/**
 * Connects two bodies at given offset points, letting them rotate relative to each other around this point.
 * @class RevoluteConstraint
 * @constructor
 * @author schteppe
 * @param {Body}    bodyA
 * @param {Body}    bodyB
 * @param {Object}  [options]
 * @param {Array}   [options.worldPivot] A pivot point given in world coordinates. If specified, localPivotA and localPivotB are automatically computed from this value.
 * @param {Array}   [options.localPivotA] The point relative to the center of mass of bodyA which bodyA is constrained to.
 * @param {Array}   [options.localPivotB] See localPivotA.
 * @param {Number}  [options.maxForce] The maximum force that should be applied to constrain the bodies.
 * @extends Constraint
 *
 * @example
 *     // This will create a revolute constraint between two bodies with pivot point in between them.
 *     var bodyA = new Body({ mass: 1, position: [-1, 0] });
 *     var bodyB = new Body({ mass: 1, position: [1, 0] });
 *     var constraint = new RevoluteConstraint(bodyA, bodyB, {
 *         worldPivot: [0, 0]
 *     });
 *     world.addConstraint(constraint);
 *
 *     // Using body-local pivot points, the constraint could have been constructed like this:
 *     var constraint = new RevoluteConstraint(bodyA, bodyB, {
 *         localPivotA: [1, 0],
 *         localPivotB: [-1, 0]
 *     });
 */ function $b0fbc309f6f5f11f$var$RevoluteConstraint(bodyA, bodyB, options) {
    options = options || {};
    $3iby4.call(this, bodyA, bodyB, $3iby4.REVOLUTE, options);
    var maxForce = this.maxForce = typeof options.maxForce !== "undefined" ? options.maxForce : Number.MAX_VALUE;
    /**
     * @property {Array} pivotA
     */ this.pivotA = $2Ys9z.create();
    /**
     * @property {Array} pivotB
     */ this.pivotB = $2Ys9z.create();
    if (options.worldPivot) {
        // Compute pivotA and pivotB
        $2Ys9z.sub(this.pivotA, options.worldPivot, bodyA.position);
        $2Ys9z.sub(this.pivotB, options.worldPivot, bodyB.position);
        // Rotate to local coordinate system
        $2Ys9z.rotate(this.pivotA, this.pivotA, -bodyA.angle);
        $2Ys9z.rotate(this.pivotB, this.pivotB, -bodyB.angle);
    } else {
        // Get pivotA and pivotB
        $2Ys9z.copy(this.pivotA, options.localPivotA);
        $2Ys9z.copy(this.pivotB, options.localPivotB);
    }
    // Equations to be fed to the solver
    var eqs = this.equations = [
        new $f0tQu(bodyA, bodyB, -maxForce, maxForce),
        new $f0tQu(bodyA, bodyB, -maxForce, maxForce)
    ];
    var x = eqs[0];
    var y = eqs[1];
    var that = this;
    x.computeGq = function() {
        $2Ys9z.rotate($b0fbc309f6f5f11f$var$worldPivotA, that.pivotA, bodyA.angle);
        $2Ys9z.rotate($b0fbc309f6f5f11f$var$worldPivotB, that.pivotB, bodyB.angle);
        $2Ys9z.add($b0fbc309f6f5f11f$var$g, bodyB.position, $b0fbc309f6f5f11f$var$worldPivotB);
        $2Ys9z.sub($b0fbc309f6f5f11f$var$g, $b0fbc309f6f5f11f$var$g, bodyA.position);
        $2Ys9z.sub($b0fbc309f6f5f11f$var$g, $b0fbc309f6f5f11f$var$g, $b0fbc309f6f5f11f$var$worldPivotA);
        return $2Ys9z.dot($b0fbc309f6f5f11f$var$g, $b0fbc309f6f5f11f$var$xAxis);
    };
    y.computeGq = function() {
        $2Ys9z.rotate($b0fbc309f6f5f11f$var$worldPivotA, that.pivotA, bodyA.angle);
        $2Ys9z.rotate($b0fbc309f6f5f11f$var$worldPivotB, that.pivotB, bodyB.angle);
        $2Ys9z.add($b0fbc309f6f5f11f$var$g, bodyB.position, $b0fbc309f6f5f11f$var$worldPivotB);
        $2Ys9z.sub($b0fbc309f6f5f11f$var$g, $b0fbc309f6f5f11f$var$g, bodyA.position);
        $2Ys9z.sub($b0fbc309f6f5f11f$var$g, $b0fbc309f6f5f11f$var$g, $b0fbc309f6f5f11f$var$worldPivotA);
        return $2Ys9z.dot($b0fbc309f6f5f11f$var$g, $b0fbc309f6f5f11f$var$yAxis);
    };
    y.minForce = x.minForce = -maxForce;
    y.maxForce = x.maxForce = maxForce;
    this.motorEquation = new $5vxRN(bodyA, bodyB);
    /**
     * Indicates whether the motor is enabled. Use .enableMotor() to enable the constraint motor.
     * @property {Boolean} motorEnabled
     * @readOnly
     */ this.motorEnabled = false;
    /**
     * The constraint position.
     * @property angle
     * @type {Number}
     * @readOnly
     */ this.angle = 0;
    /**
     * Set to true to enable lower limit
     * @property lowerLimitEnabled
     * @type {Boolean}
     */ this.lowerLimitEnabled = false;
    /**
     * Set to true to enable upper limit
     * @property upperLimitEnabled
     * @type {Boolean}
     */ this.upperLimitEnabled = false;
    /**
     * The lower limit on the constraint angle.
     * @property lowerLimit
     * @type {Boolean}
     */ this.lowerLimit = 0;
    /**
     * The upper limit on the constraint angle.
     * @property upperLimit
     * @type {Boolean}
     */ this.upperLimit = 0;
    this.upperLimitEquation = new $5UnY9(bodyA, bodyB);
    this.lowerLimitEquation = new $5UnY9(bodyA, bodyB);
    this.upperLimitEquation.minForce = 0;
    this.lowerLimitEquation.maxForce = 0;
}
$b0fbc309f6f5f11f$var$RevoluteConstraint.prototype = new $3iby4();
$b0fbc309f6f5f11f$var$RevoluteConstraint.prototype.constructor = $b0fbc309f6f5f11f$var$RevoluteConstraint;
/**
 * Set the constraint angle limits.
 * @method setLimits
 * @param {number} lower Lower angle limit.
 * @param {number} upper Upper angle limit.
 */ $b0fbc309f6f5f11f$var$RevoluteConstraint.prototype.setLimits = function(lower, upper) {
    if (typeof lower === "number") {
        this.lowerLimit = lower;
        this.lowerLimitEnabled = true;
    } else {
        this.lowerLimit = lower;
        this.lowerLimitEnabled = false;
    }
    if (typeof upper === "number") {
        this.upperLimit = upper;
        this.upperLimitEnabled = true;
    } else {
        this.upperLimit = upper;
        this.upperLimitEnabled = false;
    }
};
$b0fbc309f6f5f11f$var$RevoluteConstraint.prototype.update = function() {
    var bodyA = this.bodyA, bodyB = this.bodyB, pivotA = this.pivotA, pivotB = this.pivotB, eqs = this.equations, normal = eqs[0], tangent = eqs[1], x = eqs[0], y = eqs[1], upperLimit = this.upperLimit, lowerLimit = this.lowerLimit, upperLimitEquation = this.upperLimitEquation, lowerLimitEquation = this.lowerLimitEquation;
    var relAngle = this.angle = bodyB.angle - bodyA.angle;
    if (this.upperLimitEnabled && relAngle > upperLimit) {
        upperLimitEquation.angle = upperLimit;
        if (eqs.indexOf(upperLimitEquation) === -1) eqs.push(upperLimitEquation);
    } else {
        var idx = eqs.indexOf(upperLimitEquation);
        if (idx !== -1) eqs.splice(idx, 1);
    }
    if (this.lowerLimitEnabled && relAngle < lowerLimit) {
        lowerLimitEquation.angle = lowerLimit;
        if (eqs.indexOf(lowerLimitEquation) === -1) eqs.push(lowerLimitEquation);
    } else {
        var idx = eqs.indexOf(lowerLimitEquation);
        if (idx !== -1) eqs.splice(idx, 1);
    }
    /*

    The constraint violation is

        g = xj + rj - xi - ri

    ...where xi and xj are the body positions and ri and rj world-oriented offset vectors. Differentiate:

        gdot = vj + wj x rj - vi - wi x ri

    We split this into x and y directions. (let x and y be unit vectors along the respective axes)

        gdot * x = ( vj + wj x rj - vi - wi x ri ) * x
                 = ( vj*x + (wj x rj)*x -vi*x -(wi x ri)*x
                 = ( vj*x + (rj x x)*wj -vi*x -(ri x x)*wi
                 = [ -x   -(ri x x)   x   (rj x x)] * [vi wi vj wj]
                 = G*W

    ...and similar for y. We have then identified the jacobian entries for x and y directions:

        Gx = [ x   (rj x x)   -x   -(ri x x)]
        Gy = [ y   (rj x y)   -y   -(ri x y)]

     */ $2Ys9z.rotate($b0fbc309f6f5f11f$var$worldPivotA, pivotA, bodyA.angle);
    $2Ys9z.rotate($b0fbc309f6f5f11f$var$worldPivotB, pivotB, bodyB.angle);
    // todo: these are a bit sparse. We could save some computations on making custom eq.computeGW functions, etc
    x.G[0] = -1;
    x.G[1] = 0;
    x.G[2] = -$2Ys9z.crossLength($b0fbc309f6f5f11f$var$worldPivotA, $b0fbc309f6f5f11f$var$xAxis);
    x.G[3] = 1;
    x.G[4] = 0;
    x.G[5] = $2Ys9z.crossLength($b0fbc309f6f5f11f$var$worldPivotB, $b0fbc309f6f5f11f$var$xAxis);
    y.G[0] = 0;
    y.G[1] = -1;
    y.G[2] = -$2Ys9z.crossLength($b0fbc309f6f5f11f$var$worldPivotA, $b0fbc309f6f5f11f$var$yAxis);
    y.G[3] = 0;
    y.G[4] = 1;
    y.G[5] = $2Ys9z.crossLength($b0fbc309f6f5f11f$var$worldPivotB, $b0fbc309f6f5f11f$var$yAxis);
};
/**
 * Enable the rotational motor
 * @method enableMotor
 */ $b0fbc309f6f5f11f$var$RevoluteConstraint.prototype.enableMotor = function() {
    if (this.motorEnabled) return;
    this.equations.push(this.motorEquation);
    this.motorEnabled = true;
};
/**
 * Disable the rotational motor
 * @method disableMotor
 */ $b0fbc309f6f5f11f$var$RevoluteConstraint.prototype.disableMotor = function() {
    if (!this.motorEnabled) return;
    var i = this.equations.indexOf(this.motorEquation);
    this.equations.splice(i, 1);
    this.motorEnabled = false;
};
/**
 * Check if the motor is enabled.
 * @method motorIsEnabled
 * @deprecated use property motorEnabled instead.
 * @return {Boolean}
 */ $b0fbc309f6f5f11f$var$RevoluteConstraint.prototype.motorIsEnabled = function() {
    return !!this.motorEnabled;
};
/**
 * Set the speed of the rotational constraint motor
 * @method setMotorSpeed
 * @param  {Number} speed
 */ $b0fbc309f6f5f11f$var$RevoluteConstraint.prototype.setMotorSpeed = function(speed) {
    if (!this.motorEnabled) return;
    var i = this.equations.indexOf(this.motorEquation);
    this.equations[i].relativeVelocity = speed;
};
/**
 * Get the speed of the rotational constraint motor
 * @method getMotorSpeed
 * @return {Number} The current speed, or false if the motor is not enabled.
 */ $b0fbc309f6f5f11f$var$RevoluteConstraint.prototype.getMotorSpeed = function() {
    if (!this.motorEnabled) return false;
    return this.motorEquation.relativeVelocity;
};

});
parcelRegister("5vxRN", function(module, exports) {

var $f0tQu = parcelRequire("f0tQu");
parcelRequire("2Ys9z");
module.exports = $402a1e36da19cf95$var$RotationalVelocityEquation;
/**
 * Syncs rotational velocity of two bodies, or sets a relative velocity (motor).
 *
 * @class RotationalVelocityEquation
 * @constructor
 * @extends Equation
 * @param {Body} bodyA
 * @param {Body} bodyB
 */ function $402a1e36da19cf95$var$RotationalVelocityEquation(bodyA, bodyB) {
    $f0tQu.call(this, bodyA, bodyB, -Number.MAX_VALUE, Number.MAX_VALUE);
    this.relativeVelocity = 1;
    this.ratio = 1;
}
$402a1e36da19cf95$var$RotationalVelocityEquation.prototype = new $f0tQu();
$402a1e36da19cf95$var$RotationalVelocityEquation.prototype.constructor = $402a1e36da19cf95$var$RotationalVelocityEquation;
$402a1e36da19cf95$var$RotationalVelocityEquation.prototype.computeB = function(a, b, h) {
    var G = this.G;
    G[2] = -1;
    G[5] = this.ratio;
    var GiMf = this.computeGiMf();
    var GW = this.computeGW();
    var B = -GW * b - h * GiMf;
    return B;
};

});

parcelRegister("5UnY9", function(module, exports) {

var $f0tQu = parcelRequire("f0tQu");

var $2Ys9z = parcelRequire("2Ys9z");
module.exports = $44d4c67ddbb0d8a5$var$RotationalLockEquation;
/**
 * Locks the relative angle between two bodies. The constraint tries to keep the dot product between two vectors, local in each body, to zero. The local angle in body i is a parameter.
 *
 * @class RotationalLockEquation
 * @constructor
 * @extends Equation
 * @param {Body} bodyA
 * @param {Body} bodyB
 * @param {Object} [options]
 * @param {Number} [options.angle] Angle to add to the local vector in bodyA.
 */ function $44d4c67ddbb0d8a5$var$RotationalLockEquation(bodyA, bodyB, options) {
    options = options || {};
    $f0tQu.call(this, bodyA, bodyB, -Number.MAX_VALUE, Number.MAX_VALUE);
    /**
     * @property {number} angle
     */ this.angle = options.angle || 0;
    var G = this.G;
    G[2] = 1;
    G[5] = -1;
}
$44d4c67ddbb0d8a5$var$RotationalLockEquation.prototype = new $f0tQu();
$44d4c67ddbb0d8a5$var$RotationalLockEquation.prototype.constructor = $44d4c67ddbb0d8a5$var$RotationalLockEquation;
var $44d4c67ddbb0d8a5$var$worldVectorA = $2Ys9z.create(), $44d4c67ddbb0d8a5$var$worldVectorB = $2Ys9z.create(), $44d4c67ddbb0d8a5$var$xAxis = $2Ys9z.fromValues(1, 0), $44d4c67ddbb0d8a5$var$yAxis = $2Ys9z.fromValues(0, 1);
$44d4c67ddbb0d8a5$var$RotationalLockEquation.prototype.computeGq = function() {
    $2Ys9z.rotate($44d4c67ddbb0d8a5$var$worldVectorA, $44d4c67ddbb0d8a5$var$xAxis, this.bodyA.angle + this.angle);
    $2Ys9z.rotate($44d4c67ddbb0d8a5$var$worldVectorB, $44d4c67ddbb0d8a5$var$yAxis, this.bodyB.angle);
    return $2Ys9z.dot($44d4c67ddbb0d8a5$var$worldVectorA, $44d4c67ddbb0d8a5$var$worldVectorB);
};

});


parcelRegister("1u9oZ", function(module, exports) {

var $3iby4 = parcelRequire("3iby4");

var $cSwh0 = parcelRequire("cSwh0");

var $f0tQu = parcelRequire("f0tQu");

var $2Ys9z = parcelRequire("2Ys9z");

var $5UnY9 = parcelRequire("5UnY9");
module.exports = $114fe2d7375fdc4f$var$PrismaticConstraint;
/**
 * Constraint that only allows bodies to move along a line, relative to each other. See <a href="http://www.iforce2d.net/b2dtut/joints-prismatic">this tutorial</a>. Also called "slider constraint".
 *
 * @class PrismaticConstraint
 * @constructor
 * @extends Constraint
 * @author schteppe
 * @param {Body}    bodyA
 * @param {Body}    bodyB
 * @param {Object}  [options]
 * @param {Number}  [options.maxForce]                Max force to be applied by the constraint
 * @param {Array}   [options.localAnchorA]            Body A's anchor point, defined in its own local frame.
 * @param {Array}   [options.localAnchorB]            Body B's anchor point, defined in its own local frame.
 * @param {Array}   [options.localAxisA]              An axis, defined in body A frame, that body B's anchor point may slide along.
 * @param {Boolean} [options.disableRotationalLock]   If set to true, bodyB will be free to rotate around its anchor point.
 * @param {Number}  [options.upperLimit]
 * @param {Number}  [options.lowerLimit]
 * @todo Ability to create using only a point and a worldAxis
 */ function $114fe2d7375fdc4f$var$PrismaticConstraint(bodyA, bodyB, options) {
    options = options || {};
    $3iby4.call(this, bodyA, bodyB, $3iby4.PRISMATIC, options);
    // Get anchors
    var localAnchorA = $2Ys9z.fromValues(0, 0), localAxisA = $2Ys9z.fromValues(1, 0), localAnchorB = $2Ys9z.fromValues(0, 0);
    if (options.localAnchorA) $2Ys9z.copy(localAnchorA, options.localAnchorA);
    if (options.localAxisA) $2Ys9z.copy(localAxisA, options.localAxisA);
    if (options.localAnchorB) $2Ys9z.copy(localAnchorB, options.localAnchorB);
    /**
     * @property localAnchorA
     * @type {Array}
     */ this.localAnchorA = localAnchorA;
    /**
     * @property localAnchorB
     * @type {Array}
     */ this.localAnchorB = localAnchorB;
    /**
     * @property localAxisA
     * @type {Array}
     */ this.localAxisA = localAxisA;
    /*

    The constraint violation for the common axis point is

        g = ( xj + rj - xi - ri ) * t   :=  gg*t

    where r are body-local anchor points, and t is a tangent to the constraint axis defined in body i frame.

        gdot =  ( vj + wj x rj - vi - wi x ri ) * t + ( xj + rj - xi - ri ) * ( wi x t )

    Note the use of the chain rule. Now we identify the jacobian

        G*W = [ -t      -ri x t + t x gg     t    rj x t ] * [vi wi vj wj]

    The rotational part is just a rotation lock.

     */ var maxForce = this.maxForce = typeof options.maxForce !== "undefined" ? options.maxForce : Number.MAX_VALUE;
    // Translational part
    var trans = new $f0tQu(bodyA, bodyB, -maxForce, maxForce);
    var ri = new $2Ys9z.create(), rj = new $2Ys9z.create(), gg = new $2Ys9z.create(), t = new $2Ys9z.create();
    trans.computeGq = function() {
        // g = ( xj + rj - xi - ri ) * t
        return $2Ys9z.dot(gg, t);
    };
    trans.updateJacobian = function() {
        var G = this.G, xi = bodyA.position, xj = bodyB.position;
        $2Ys9z.rotate(ri, localAnchorA, bodyA.angle);
        $2Ys9z.rotate(rj, localAnchorB, bodyB.angle);
        $2Ys9z.add(gg, xj, rj);
        $2Ys9z.sub(gg, gg, xi);
        $2Ys9z.sub(gg, gg, ri);
        $2Ys9z.rotate(t, localAxisA, bodyA.angle + Math.PI / 2);
        G[0] = -t[0];
        G[1] = -t[1];
        G[2] = -$2Ys9z.crossLength(ri, t) + $2Ys9z.crossLength(t, gg);
        G[3] = t[0];
        G[4] = t[1];
        G[5] = $2Ys9z.crossLength(rj, t);
    };
    this.equations.push(trans);
    // Rotational part
    if (!options.disableRotationalLock) {
        var rot = new $5UnY9(bodyA, bodyB, -maxForce, maxForce);
        this.equations.push(rot);
    }
    /**
     * The position of anchor A relative to anchor B, along the constraint axis.
     * @property position
     * @type {Number}
     */ this.position = 0;
    // Is this one used at all?
    this.velocity = 0;
    /**
     * Set to true to enable lower limit.
     * @property lowerLimitEnabled
     * @type {Boolean}
     */ this.lowerLimitEnabled = typeof options.lowerLimit !== "undefined" ? true : false;
    /**
     * Set to true to enable upper limit.
     * @property upperLimitEnabled
     * @type {Boolean}
     */ this.upperLimitEnabled = typeof options.upperLimit !== "undefined" ? true : false;
    /**
     * Lower constraint limit. The constraint position is forced to be larger than this value.
     * @property lowerLimit
     * @type {Number}
     */ this.lowerLimit = typeof options.lowerLimit !== "undefined" ? options.lowerLimit : 0;
    /**
     * Upper constraint limit. The constraint position is forced to be smaller than this value.
     * @property upperLimit
     * @type {Number}
     */ this.upperLimit = typeof options.upperLimit !== "undefined" ? options.upperLimit : 1;
    // Equations used for limits
    this.upperLimitEquation = new $cSwh0(bodyA, bodyB);
    this.lowerLimitEquation = new $cSwh0(bodyA, bodyB);
    // Set max/min forces
    this.upperLimitEquation.minForce = this.lowerLimitEquation.minForce = 0;
    this.upperLimitEquation.maxForce = this.lowerLimitEquation.maxForce = maxForce;
    /**
     * Equation used for the motor.
     * @property motorEquation
     * @type {Equation}
     */ this.motorEquation = new $f0tQu(bodyA, bodyB);
    /**
     * The current motor state. Enable or disable the motor using .enableMotor
     * @property motorEnabled
     * @type {Boolean}
     */ this.motorEnabled = false;
    /**
     * Set the target speed for the motor.
     * @property motorSpeed
     * @type {Number}
     */ this.motorSpeed = 0;
    var that = this;
    var motorEquation = this.motorEquation;
    var old = motorEquation.computeGW;
    motorEquation.computeGq = function() {
        return 0;
    };
    motorEquation.computeGW = function() {
        var G = this.G, bi = this.bodyA, bj = this.bodyB, vi = bi.velocity, vj = bj.velocity, wi = bi.angularVelocity, wj = bj.angularVelocity;
        return this.gmult(G, vi, wi, vj, wj) + that.motorSpeed;
    };
}
$114fe2d7375fdc4f$var$PrismaticConstraint.prototype = new $3iby4();
$114fe2d7375fdc4f$var$PrismaticConstraint.prototype.constructor = $114fe2d7375fdc4f$var$PrismaticConstraint;
var $114fe2d7375fdc4f$var$worldAxisA = $2Ys9z.create(), $114fe2d7375fdc4f$var$worldAnchorA = $2Ys9z.create(), $114fe2d7375fdc4f$var$worldAnchorB = $2Ys9z.create(), $114fe2d7375fdc4f$var$orientedAnchorA = $2Ys9z.create(), $114fe2d7375fdc4f$var$orientedAnchorB = $2Ys9z.create(), $114fe2d7375fdc4f$var$tmp = $2Ys9z.create();
/**
 * Update the constraint equations. Should be done if any of the bodies changed position, before solving.
 * @method update
 */ $114fe2d7375fdc4f$var$PrismaticConstraint.prototype.update = function() {
    var eqs = this.equations, trans = eqs[0], upperLimit = this.upperLimit, lowerLimit = this.lowerLimit, upperLimitEquation = this.upperLimitEquation, lowerLimitEquation = this.lowerLimitEquation, bodyA = this.bodyA, bodyB = this.bodyB, localAxisA = this.localAxisA, localAnchorA = this.localAnchorA, localAnchorB = this.localAnchorB;
    trans.updateJacobian();
    // Transform local things to world
    $2Ys9z.rotate($114fe2d7375fdc4f$var$worldAxisA, localAxisA, bodyA.angle);
    $2Ys9z.rotate($114fe2d7375fdc4f$var$orientedAnchorA, localAnchorA, bodyA.angle);
    $2Ys9z.add($114fe2d7375fdc4f$var$worldAnchorA, $114fe2d7375fdc4f$var$orientedAnchorA, bodyA.position);
    $2Ys9z.rotate($114fe2d7375fdc4f$var$orientedAnchorB, localAnchorB, bodyB.angle);
    $2Ys9z.add($114fe2d7375fdc4f$var$worldAnchorB, $114fe2d7375fdc4f$var$orientedAnchorB, bodyB.position);
    var relPosition = this.position = $2Ys9z.dot($114fe2d7375fdc4f$var$worldAnchorB, $114fe2d7375fdc4f$var$worldAxisA) - $2Ys9z.dot($114fe2d7375fdc4f$var$worldAnchorA, $114fe2d7375fdc4f$var$worldAxisA);
    // Motor
    if (this.motorEnabled) {
        // G = [ a     a x ri   -a   -a x rj ]
        var G = this.motorEquation.G;
        G[0] = $114fe2d7375fdc4f$var$worldAxisA[0];
        G[1] = $114fe2d7375fdc4f$var$worldAxisA[1];
        G[2] = $2Ys9z.crossLength($114fe2d7375fdc4f$var$worldAxisA, $114fe2d7375fdc4f$var$orientedAnchorB);
        G[3] = -$114fe2d7375fdc4f$var$worldAxisA[0];
        G[4] = -$114fe2d7375fdc4f$var$worldAxisA[1];
        G[5] = -$2Ys9z.crossLength($114fe2d7375fdc4f$var$worldAxisA, $114fe2d7375fdc4f$var$orientedAnchorA);
    }
    /*
        Limits strategy:
        Add contact equation, with normal along the constraint axis.
        min/maxForce is set so the constraint is repulsive in the correct direction.
        Some offset is added to either equation.contactPointA or .contactPointB to get the correct upper/lower limit.

                 ^
                 |
      upperLimit x
                 |    ------
         anchorB x<---|  B |
                 |    |    |
        ------   |    ------
        |    |   |
        |  A |-->x anchorA
        ------   |
                 x lowerLimit
                 |
                axis
     */ if (this.upperLimitEnabled && relPosition > upperLimit) {
        // Update contact constraint normal, etc
        $2Ys9z.scale(upperLimitEquation.normalA, $114fe2d7375fdc4f$var$worldAxisA, -1);
        $2Ys9z.sub(upperLimitEquation.contactPointA, $114fe2d7375fdc4f$var$worldAnchorA, bodyA.position);
        $2Ys9z.sub(upperLimitEquation.contactPointB, $114fe2d7375fdc4f$var$worldAnchorB, bodyB.position);
        $2Ys9z.scale($114fe2d7375fdc4f$var$tmp, $114fe2d7375fdc4f$var$worldAxisA, upperLimit);
        $2Ys9z.add(upperLimitEquation.contactPointA, upperLimitEquation.contactPointA, $114fe2d7375fdc4f$var$tmp);
        if (eqs.indexOf(upperLimitEquation) === -1) eqs.push(upperLimitEquation);
    } else {
        var idx = eqs.indexOf(upperLimitEquation);
        if (idx !== -1) eqs.splice(idx, 1);
    }
    if (this.lowerLimitEnabled && relPosition < lowerLimit) {
        // Update contact constraint normal, etc
        $2Ys9z.scale(lowerLimitEquation.normalA, $114fe2d7375fdc4f$var$worldAxisA, 1);
        $2Ys9z.sub(lowerLimitEquation.contactPointA, $114fe2d7375fdc4f$var$worldAnchorA, bodyA.position);
        $2Ys9z.sub(lowerLimitEquation.contactPointB, $114fe2d7375fdc4f$var$worldAnchorB, bodyB.position);
        $2Ys9z.scale($114fe2d7375fdc4f$var$tmp, $114fe2d7375fdc4f$var$worldAxisA, lowerLimit);
        $2Ys9z.sub(lowerLimitEquation.contactPointB, lowerLimitEquation.contactPointB, $114fe2d7375fdc4f$var$tmp);
        if (eqs.indexOf(lowerLimitEquation) === -1) eqs.push(lowerLimitEquation);
    } else {
        var idx = eqs.indexOf(lowerLimitEquation);
        if (idx !== -1) eqs.splice(idx, 1);
    }
};
/**
 * Enable the motor
 * @method enableMotor
 */ $114fe2d7375fdc4f$var$PrismaticConstraint.prototype.enableMotor = function() {
    if (this.motorEnabled) return;
    this.equations.push(this.motorEquation);
    this.motorEnabled = true;
};
/**
 * Disable the rotational motor
 * @method disableMotor
 */ $114fe2d7375fdc4f$var$PrismaticConstraint.prototype.disableMotor = function() {
    if (!this.motorEnabled) return;
    var i = this.equations.indexOf(this.motorEquation);
    this.equations.splice(i, 1);
    this.motorEnabled = false;
};
/**
 * Set the constraint limits.
 * @method setLimits
 * @param {number} lower Lower limit.
 * @param {number} upper Upper limit.
 */ $114fe2d7375fdc4f$var$PrismaticConstraint.prototype.setLimits = function(lower, upper) {
    if (typeof lower === "number") {
        this.lowerLimit = lower;
        this.lowerLimitEnabled = true;
    } else {
        this.lowerLimit = lower;
        this.lowerLimitEnabled = false;
    }
    if (typeof upper === "number") {
        this.upperLimit = upper;
        this.upperLimitEnabled = true;
    } else {
        this.upperLimit = upper;
        this.upperLimitEnabled = false;
    }
};

});

parcelRegister("konik", function(module, exports) {

var $dMz05 = parcelRequire("dMz05");

var $dQgku = parcelRequire("dQgku");
module.exports = $ed881e60f3706c0e$var$SAPBroadphase;
/**
 * Sweep and prune broadphase along one axis.
 *
 * @class SAPBroadphase
 * @constructor
 * @extends Broadphase
 */ function $ed881e60f3706c0e$var$SAPBroadphase() {
    $dQgku.call(this, $dQgku.SAP);
    /**
     * List of bodies currently in the broadphase.
     * @property axisList
     * @type {Array}
     */ this.axisList = [];
    /**
     * The axis to sort along. 0 means x-axis and 1 y-axis. If your bodies are more spread out over the X axis, set axisIndex to 0, and you will gain some performance.
     * @property axisIndex
     * @type {Number}
     */ this.axisIndex = 0;
    var that = this;
    this._addBodyHandler = function(e) {
        that.axisList.push(e.body);
    };
    this._removeBodyHandler = function(e) {
        // Remove from list
        var idx = that.axisList.indexOf(e.body);
        if (idx !== -1) that.axisList.splice(idx, 1);
    };
}
$ed881e60f3706c0e$var$SAPBroadphase.prototype = new $dQgku();
$ed881e60f3706c0e$var$SAPBroadphase.prototype.constructor = $ed881e60f3706c0e$var$SAPBroadphase;
/**
 * Change the world
 * @method setWorld
 * @param {World} world
 */ $ed881e60f3706c0e$var$SAPBroadphase.prototype.setWorld = function(world) {
    // Clear the old axis array
    this.axisList.length = 0;
    // Add all bodies from the new world
    $dMz05.appendArray(this.axisList, world.bodies);
    // Remove old handlers, if any
    world.off("addBody", this._addBodyHandler).off("removeBody", this._removeBodyHandler);
    // Add handlers to update the list of bodies.
    world.on("addBody", this._addBodyHandler).on("removeBody", this._removeBodyHandler);
    this.world = world;
};
/**
 * Sorts bodies along an axis.
 * @method sortAxisList
 * @param {Array} a
 * @param {number} axisIndex
 * @return {Array}
 */ $ed881e60f3706c0e$var$SAPBroadphase.sortAxisList = function(a, axisIndex) {
    axisIndex = axisIndex | 0;
    for(var i = 1, l = a.length; i < l; i++){
        var v = a[i];
        for(var j = i - 1; j >= 0; j--){
            if (a[j].aabb.lowerBound[axisIndex] <= v.aabb.lowerBound[axisIndex]) break;
            a[j + 1] = a[j];
        }
        a[j + 1] = v;
    }
    return a;
};
$ed881e60f3706c0e$var$SAPBroadphase.prototype.sortList = function() {
    var bodies = this.axisList, axisIndex = this.axisIndex;
    // Sort the lists
    $ed881e60f3706c0e$var$SAPBroadphase.sortAxisList(bodies, axisIndex);
};
/**
 * Get the colliding pairs
 * @method getCollisionPairs
 * @param  {World} world
 * @return {Array}
 */ $ed881e60f3706c0e$var$SAPBroadphase.prototype.getCollisionPairs = function(world) {
    var bodies = this.axisList, result = this.result, axisIndex = this.axisIndex;
    result.length = 0;
    // Update all AABBs if needed
    var l = bodies.length;
    while(l--){
        var b = bodies[l];
        if (b.aabbNeedsUpdate) b.updateAABB();
    }
    // Sort the lists
    this.sortList();
    // Look through the X list
    for(var i = 0, N = bodies.length | 0; i !== N; i++){
        var bi = bodies[i];
        for(var j = i + 1; j < N; j++){
            var bj = bodies[j];
            // Bounds overlap?
            var overlaps = bj.aabb.lowerBound[axisIndex] <= bi.aabb.upperBound[axisIndex];
            if (!overlaps) break;
            if ($dQgku.canCollide(bi, bj) && this.boundingVolumeCheck(bi, bj)) result.push(bi, bj);
        }
    }
    return result;
};
/**
 * Returns all the bodies within an AABB.
 * @method aabbQuery
 * @param  {World} world
 * @param  {AABB} aabb
 * @param {array} result An array to store resulting bodies in.
 * @return {array}
 */ $ed881e60f3706c0e$var$SAPBroadphase.prototype.aabbQuery = function(world, aabb, result) {
    result = result || [];
    this.sortList();
    var axisIndex = this.axisIndex;
    var axis = "x";
    if (axisIndex === 1) axis = "y";
    if (axisIndex === 2) axis = "z";
    var axisList = this.axisList;
    var lower = aabb.lowerBound[axis];
    var upper = aabb.upperBound[axis];
    for(var i = 0; i < axisList.length; i++){
        var b = axisList[i];
        if (b.aabbNeedsUpdate) b.updateAABB();
        if (b.aabb.overlaps(aabb)) result.push(b);
    }
    return result;
};

});

parcelRegister("94u9A", function(module, exports) {
parcelRequire("2Ys9z");

var $dMz05 = parcelRequire("dMz05");
module.exports = $69abe0a67fd3e3ca$var$Spring;
/**
 * A spring, connecting two bodies. The Spring explicitly adds force and angularForce to the bodies and does therefore not put load on the constraint solver.
 *
 * @class Spring
 * @constructor
 * @param {Body} bodyA
 * @param {Body} bodyB
 * @param {Object} [options]
 * @param {number} [options.stiffness=100]  Spring constant (see Hookes Law). A number >= 0.
 * @param {number} [options.damping=1]      A number >= 0. Default: 1
 * @param {Array}  [options.localAnchorA]   Where to hook the spring to body A, in local body coordinates. Defaults to the body center.
 * @param {Array}  [options.localAnchorB]
 * @param {Array}  [options.worldAnchorA]   Where to hook the spring to body A, in world coordinates. Overrides the option "localAnchorA" if given.
 * @param {Array}  [options.worldAnchorB]
 */ function $69abe0a67fd3e3ca$var$Spring(bodyA, bodyB, options) {
    options = $dMz05.defaults(options, {
        stiffness: 100,
        damping: 1
    });
    /**
     * Stiffness of the spring.
     * @property stiffness
     * @type {number}
     */ this.stiffness = options.stiffness;
    /**
     * Damping of the spring.
     * @property damping
     * @type {number}
     */ this.damping = options.damping;
    /**
     * First connected body.
     * @property bodyA
     * @type {Body}
     */ this.bodyA = bodyA;
    /**
     * Second connected body.
     * @property bodyB
     * @type {Body}
     */ this.bodyB = bodyB;
}
/**
 * Apply the spring force to the connected bodies.
 * @method applyForce
 */ $69abe0a67fd3e3ca$var$Spring.prototype.applyForce = function() {
// To be implemented by subclasses
};

});

parcelRegister("3TW5l", function(module, exports) {

var $2Ys9z = parcelRequire("2Ys9z");
parcelRequire("dMz05");

var $3iby4 = parcelRequire("3iby4");

var $jNxse = parcelRequire("jNxse");

var $e7hLo = parcelRequire("e7hLo");
module.exports = $2d7390aa62f5a93b$var$TopDownVehicle;
/**
 * @class TopDownVehicle
 * @constructor
 * @param {Body} chassisBody A dynamic body, already added to the world.
 * @param {Object} [options]
 *
 * @example
 *
 *     // Create a dynamic body for the chassis
 *     var chassisBody = new Body({
 *         mass: 1
 *     });
 *     var boxShape = new Box({ width: 0.5, height: 1 });
 *     chassisBody.addShape(boxShape);
 *     world.addBody(chassisBody);
 *
 *     // Create the vehicle
 *     var vehicle = new TopDownVehicle(chassisBody);
 *
 *     // Add one front wheel and one back wheel - we don't actually need four :)
 *     var frontWheel = vehicle.addWheel({
 *         localPosition: [0, 0.5] // front
 *     });
 *     frontWheel.setSideFriction(4);
 *
 *     // Back wheel
 *     var backWheel = vehicle.addWheel({
 *         localPosition: [0, -0.5] // back
 *     });
 *     backWheel.setSideFriction(3); // Less side friction on back wheel makes it easier to drift
 *     vehicle.addToWorld(world);
 *
 *     // Steer value zero means straight forward. Positive is left and negative right.
 *     frontWheel.steerValue = Math.PI / 16;
 *
 *     // Engine force forward
 *     backWheel.engineForce = 10;
 *     backWheel.setBrakeForce(0);
 */ function $2d7390aa62f5a93b$var$TopDownVehicle(chassisBody, options) {
    options = options || {};
    /**
     * @property {Body} chassisBody
     */ this.chassisBody = chassisBody;
    /**
     * @property {Array} wheels
     */ this.wheels = [];
    // A dummy body to constrain the chassis to
    this.groundBody = new $e7hLo({
        mass: 0
    });
    this.world = null;
    var that = this;
    this.preStepCallback = function() {
        that.update();
    };
}
/**
 * @method addToWorld
 * @param {World} world
 */ $2d7390aa62f5a93b$var$TopDownVehicle.prototype.addToWorld = function(world) {
    this.world = world;
    world.addBody(this.groundBody);
    world.on("preStep", this.preStepCallback);
    for(var i = 0; i < this.wheels.length; i++){
        var wheel = this.wheels[i];
        world.addConstraint(wheel);
    }
};
/**
 * @method removeFromWorld
 * @param {World} world
 */ $2d7390aa62f5a93b$var$TopDownVehicle.prototype.removeFromWorld = function() {
    var world = this.world;
    world.removeBody(this.groundBody);
    world.off("preStep", this.preStepCallback);
    for(var i = 0; i < this.wheels.length; i++){
        var wheel = this.wheels[i];
        world.removeConstraint(wheel);
    }
    this.world = null;
};
/**
 * @method addWheel
 * @param {object} [wheelOptions]
 * @return {WheelConstraint}
 */ $2d7390aa62f5a93b$var$TopDownVehicle.prototype.addWheel = function(wheelOptions) {
    var wheel = new $2d7390aa62f5a93b$var$WheelConstraint(this, wheelOptions);
    this.wheels.push(wheel);
    return wheel;
};
/**
 * @method update
 */ $2d7390aa62f5a93b$var$TopDownVehicle.prototype.update = function() {
    for(var i = 0; i < this.wheels.length; i++)this.wheels[i].update();
};
/**
 * @class WheelConstraint
 * @constructor
 * @extends {Constraint}
 * @param {Vehicle} vehicle
 * @param {object} [options]
 * @param {Array} [options.localForwardVector]The local wheel forward vector in local body space. Default is zero.
 * @param {Array} [options.localPosition] The local position of the wheen in the chassis body. Default is zero - the center of the body.
 * @param {Array} [options.sideFriction=5] The max friction force in the sideways direction.
 */ function $2d7390aa62f5a93b$var$WheelConstraint(vehicle, options) {
    options = options || {};
    this.vehicle = vehicle;
    this.forwardEquation = new $jNxse(vehicle.chassisBody, vehicle.groundBody);
    this.sideEquation = new $jNxse(vehicle.chassisBody, vehicle.groundBody);
    /**
     * @property {number} steerValue
     */ this.steerValue = 0;
    /**
     * @property {number} engineForce
     */ this.engineForce = 0;
    this.setSideFriction(options.sideFriction !== undefined ? options.sideFriction : 5);
    /**
     * @property {Array} localForwardVector
     */ this.localForwardVector = $2Ys9z.fromValues(0, 1);
    if (options.localForwardVector) $2Ys9z.copy(this.localForwardVector, options.localForwardVector);
    /**
     * @property {Array} localPosition
     */ this.localPosition = $2Ys9z.fromValues(0, 0);
    if (options.localPosition) $2Ys9z.copy(this.localPosition, options.localPosition);
    $3iby4.apply(this, vehicle.chassisBody, vehicle.groundBody);
    this.equations.push(this.forwardEquation, this.sideEquation);
    this.setBrakeForce(0);
}
$2d7390aa62f5a93b$var$WheelConstraint.prototype = new $3iby4();
/**
 * @method setForwardFriction
 */ $2d7390aa62f5a93b$var$WheelConstraint.prototype.setBrakeForce = function(force) {
    this.forwardEquation.setSlipForce(force);
};
/**
 * @method setSideFriction
 */ $2d7390aa62f5a93b$var$WheelConstraint.prototype.setSideFriction = function(force) {
    this.sideEquation.setSlipForce(force);
};
var $2d7390aa62f5a93b$var$worldVelocity = $2Ys9z.create();
var $2d7390aa62f5a93b$var$relativePoint = $2Ys9z.create();
/**
 * @method getSpeed
 */ $2d7390aa62f5a93b$var$WheelConstraint.prototype.getSpeed = function() {
    this.vehicle.chassisBody.vectorToWorldFrame($2d7390aa62f5a93b$var$relativePoint, this.localForwardVector);
    this.vehicle.chassisBody.getVelocityAtPoint($2d7390aa62f5a93b$var$worldVelocity, $2d7390aa62f5a93b$var$relativePoint);
    return $2Ys9z.dot($2d7390aa62f5a93b$var$worldVelocity, $2d7390aa62f5a93b$var$relativePoint);
};
var $2d7390aa62f5a93b$var$tmpVec = $2Ys9z.create();
/**
 * @method update
 */ $2d7390aa62f5a93b$var$WheelConstraint.prototype.update = function() {
    // Directional
    this.vehicle.chassisBody.vectorToWorldFrame(this.forwardEquation.t, this.localForwardVector);
    $2Ys9z.rotate(this.sideEquation.t, this.localForwardVector, Math.PI / 2);
    this.vehicle.chassisBody.vectorToWorldFrame(this.sideEquation.t, this.sideEquation.t);
    $2Ys9z.rotate(this.forwardEquation.t, this.forwardEquation.t, this.steerValue);
    $2Ys9z.rotate(this.sideEquation.t, this.sideEquation.t, this.steerValue);
    // Attachment point
    this.vehicle.chassisBody.toWorldFrame(this.forwardEquation.contactPointB, this.localPosition);
    $2Ys9z.copy(this.sideEquation.contactPointB, this.forwardEquation.contactPointB);
    this.vehicle.chassisBody.vectorToWorldFrame(this.forwardEquation.contactPointA, this.localPosition);
    $2Ys9z.copy(this.sideEquation.contactPointA, this.forwardEquation.contactPointA);
    // Add engine force
    $2Ys9z.normalize($2d7390aa62f5a93b$var$tmpVec, this.forwardEquation.t);
    $2Ys9z.scale($2d7390aa62f5a93b$var$tmpVec, $2d7390aa62f5a93b$var$tmpVec, this.engineForce);
    this.vehicle.chassisBody.applyForce($2d7390aa62f5a93b$var$tmpVec, this.forwardEquation.contactPointA);
};

});

parcelRegister("8ZZ8g", function(module, exports) {

var $2Ys9z = parcelRequire("2Ys9z");

var $94u9A = parcelRequire("94u9A");
parcelRequire("dMz05");
module.exports = $68d370db3526695c$var$LinearSpring;
/**
 * A spring, connecting two bodies.
 *
 * The Spring explicitly adds force and angularForce to the bodies.
 *
 * @class LinearSpring
 * @extends Spring
 * @constructor
 * @param {Body} bodyA
 * @param {Body} bodyB
 * @param {Object} [options]
 * @param {number} [options.restLength]   A number > 0. Default is the current distance between the world anchor points.
 * @param {number} [options.stiffness=100]  Spring constant (see Hookes Law). A number >= 0.
 * @param {number} [options.damping=1]      A number >= 0. Default: 1
 * @param {Array}  [options.worldAnchorA]   Where to hook the spring to body A, in world coordinates. Overrides the option "localAnchorA" if given.
 * @param {Array}  [options.worldAnchorB]
 * @param {Array}  [options.localAnchorA]   Where to hook the spring to body A, in local body coordinates. Defaults to the body center.
 * @param {Array}  [options.localAnchorB]
 */ function $68d370db3526695c$var$LinearSpring(bodyA, bodyB, options) {
    options = options || {};
    $94u9A.call(this, bodyA, bodyB, options);
    /**
     * Anchor for bodyA in local bodyA coordinates.
     * @property localAnchorA
     * @type {Array}
     */ this.localAnchorA = $2Ys9z.fromValues(0, 0);
    /**
     * Anchor for bodyB in local bodyB coordinates.
     * @property localAnchorB
     * @type {Array}
     */ this.localAnchorB = $2Ys9z.fromValues(0, 0);
    if (options.localAnchorA) $2Ys9z.copy(this.localAnchorA, options.localAnchorA);
    if (options.localAnchorB) $2Ys9z.copy(this.localAnchorB, options.localAnchorB);
    if (options.worldAnchorA) this.setWorldAnchorA(options.worldAnchorA);
    if (options.worldAnchorB) this.setWorldAnchorB(options.worldAnchorB);
    var worldAnchorA = $2Ys9z.create();
    var worldAnchorB = $2Ys9z.create();
    this.getWorldAnchorA(worldAnchorA);
    this.getWorldAnchorB(worldAnchorB);
    var worldDistance = $2Ys9z.distance(worldAnchorA, worldAnchorB);
    /**
     * Rest length of the spring.
     * @property restLength
     * @type {number}
     */ this.restLength = typeof options.restLength === "number" ? options.restLength : worldDistance;
}
$68d370db3526695c$var$LinearSpring.prototype = new $94u9A();
$68d370db3526695c$var$LinearSpring.prototype.constructor = $68d370db3526695c$var$LinearSpring;
/**
 * Set the anchor point on body A, using world coordinates.
 * @method setWorldAnchorA
 * @param {Array} worldAnchorA
 */ $68d370db3526695c$var$LinearSpring.prototype.setWorldAnchorA = function(worldAnchorA) {
    this.bodyA.toLocalFrame(this.localAnchorA, worldAnchorA);
};
/**
 * Set the anchor point on body B, using world coordinates.
 * @method setWorldAnchorB
 * @param {Array} worldAnchorB
 */ $68d370db3526695c$var$LinearSpring.prototype.setWorldAnchorB = function(worldAnchorB) {
    this.bodyB.toLocalFrame(this.localAnchorB, worldAnchorB);
};
/**
 * Get the anchor point on body A, in world coordinates.
 * @method getWorldAnchorA
 * @param {Array} result The vector to store the result in.
 */ $68d370db3526695c$var$LinearSpring.prototype.getWorldAnchorA = function(result) {
    this.bodyA.toWorldFrame(result, this.localAnchorA);
};
/**
 * Get the anchor point on body B, in world coordinates.
 * @method getWorldAnchorB
 * @param {Array} result The vector to store the result in.
 */ $68d370db3526695c$var$LinearSpring.prototype.getWorldAnchorB = function(result) {
    this.bodyB.toWorldFrame(result, this.localAnchorB);
};
var $68d370db3526695c$var$applyForce_r = $2Ys9z.create(), $68d370db3526695c$var$applyForce_r_unit = $2Ys9z.create(), $68d370db3526695c$var$applyForce_u = $2Ys9z.create(), $68d370db3526695c$var$applyForce_f = $2Ys9z.create(), $68d370db3526695c$var$applyForce_worldAnchorA = $2Ys9z.create(), $68d370db3526695c$var$applyForce_worldAnchorB = $2Ys9z.create(), $68d370db3526695c$var$applyForce_ri = $2Ys9z.create(), $68d370db3526695c$var$applyForce_rj = $2Ys9z.create(), $68d370db3526695c$var$applyForce_tmp = $2Ys9z.create();
/**
 * Apply the spring force to the connected bodies.
 * @method applyForce
 */ $68d370db3526695c$var$LinearSpring.prototype.applyForce = function() {
    var k = this.stiffness, d = this.damping, l = this.restLength, bodyA = this.bodyA, bodyB = this.bodyB, r = $68d370db3526695c$var$applyForce_r, r_unit = $68d370db3526695c$var$applyForce_r_unit, u = $68d370db3526695c$var$applyForce_u, f = $68d370db3526695c$var$applyForce_f, tmp = $68d370db3526695c$var$applyForce_tmp;
    var worldAnchorA = $68d370db3526695c$var$applyForce_worldAnchorA, worldAnchorB = $68d370db3526695c$var$applyForce_worldAnchorB, ri = $68d370db3526695c$var$applyForce_ri, rj = $68d370db3526695c$var$applyForce_rj;
    // Get world anchors
    this.getWorldAnchorA(worldAnchorA);
    this.getWorldAnchorB(worldAnchorB);
    // Get offset points
    $2Ys9z.sub(ri, worldAnchorA, bodyA.position);
    $2Ys9z.sub(rj, worldAnchorB, bodyB.position);
    // Compute distance vector between world anchor points
    $2Ys9z.sub(r, worldAnchorB, worldAnchorA);
    var rlen = $2Ys9z.len(r);
    $2Ys9z.normalize(r_unit, r);
    //console.log(rlen)
    //console.log("A",vec2.str(worldAnchorA),"B",vec2.str(worldAnchorB))
    // Compute relative velocity of the anchor points, u
    $2Ys9z.sub(u, bodyB.velocity, bodyA.velocity);
    $2Ys9z.crossZV(tmp, bodyB.angularVelocity, rj);
    $2Ys9z.add(u, u, tmp);
    $2Ys9z.crossZV(tmp, bodyA.angularVelocity, ri);
    $2Ys9z.sub(u, u, tmp);
    // F = - k * ( x - L ) - D * ( u )
    $2Ys9z.scale(f, r_unit, -k * (rlen - l) - d * $2Ys9z.dot(u, r_unit));
    // Add forces to bodies
    $2Ys9z.sub(bodyA.force, bodyA.force, f);
    $2Ys9z.add(bodyB.force, bodyB.force, f);
    // Angular force
    var ri_x_f = $2Ys9z.crossLength(ri, f);
    var rj_x_f = $2Ys9z.crossLength(rj, f);
    bodyA.angularForce -= ri_x_f;
    bodyB.angularForce += rj_x_f;
};

});

parcelRegister("B7IZE", function(module, exports) {
parcelRequire("2Ys9z");

var $94u9A = parcelRequire("94u9A");
module.exports = $06f972c7d347034e$var$RotationalSpring;
/**
 * A rotational spring, connecting two bodies rotation. This spring explicitly adds angularForce (torque) to the bodies.
 *
 * The spring can be combined with a {{#crossLink "RevoluteConstraint"}}{{/crossLink}} to make, for example, a mouse trap.
 *
 * @class RotationalSpring
 * @extends Spring
 * @constructor
 * @param {Body} bodyA
 * @param {Body} bodyB
 * @param {Object} [options]
 * @param {number} [options.restAngle] The relative angle of bodies at which the spring is at rest. If not given, it's set to the current relative angle between the bodies.
 * @param {number} [options.stiffness=100] Spring constant (see Hookes Law). A number >= 0.
 * @param {number} [options.damping=1] A number >= 0.
 */ function $06f972c7d347034e$var$RotationalSpring(bodyA, bodyB, options) {
    options = options || {};
    $94u9A.call(this, bodyA, bodyB, options);
    /**
     * Rest angle of the spring.
     * @property restAngle
     * @type {number}
     */ this.restAngle = typeof options.restAngle === "number" ? options.restAngle : bodyB.angle - bodyA.angle;
}
$06f972c7d347034e$var$RotationalSpring.prototype = new $94u9A();
$06f972c7d347034e$var$RotationalSpring.prototype.constructor = $06f972c7d347034e$var$RotationalSpring;
/**
 * Apply the spring force to the connected bodies.
 * @method applyForce
 */ $06f972c7d347034e$var$RotationalSpring.prototype.applyForce = function() {
    var k = this.stiffness, d = this.damping, l = this.restAngle, bodyA = this.bodyA, bodyB = this.bodyB, x = bodyB.angle - bodyA.angle, u = bodyB.angularVelocity - bodyA.angularVelocity;
    var torque = -k * (x - l) - d * u * 0;
    bodyA.angularForce -= torque;
    bodyB.angularForce += torque;
};

});

parcelRegister("hGmj1", function(module, exports) {

var $hejTV = parcelRequire("hejTV");
parcelRequire("aZxNS");
parcelRequire("l9ZUH");

var $2Ys9z = parcelRequire("2Ys9z");

var $OJ0UJ = parcelRequire("OJ0UJ");

var $clDtn = parcelRequire("clDtn");
parcelRequire("d7wN7");

var $hNAi3 = parcelRequire("hNAi3");

var $4flMw = parcelRequire("4flMw");

var $fwNHk = parcelRequire("fwNHk");

var $5POlg = parcelRequire("5POlg");

var $e7hLo = parcelRequire("e7hLo");
parcelRequire("k7z01");
parcelRequire("8ZZ8g");

var $kfn8e = parcelRequire("kfn8e");

var $hzM8V = parcelRequire("hzM8V");
parcelRequire("2pi2h");
parcelRequire("3iby4");
parcelRequire("48dNO");
parcelRequire("fc4SC");
parcelRequire("1u9oZ");
parcelRequire("bb1X1");
parcelRequire("hIDwd");
parcelRequire("dQgku");

var $hkl1e = parcelRequire("hkl1e");

var $konik = parcelRequire("konik");

var $3QUo8 = parcelRequire("3QUo8");

var $dMz05 = parcelRequire("dMz05");

var $lST4l = parcelRequire("lST4l");

var $9JhUu = parcelRequire("9JhUu");
parcelRequire("B7IZE");
module.exports = $cdf7a95ffc36e12c$var$World;
/**
 * The dynamics world, where all bodies and constraints live.
 *
 * @class World
 * @constructor
 * @param {Object} [options]
 * @param {Solver} [options.solver] Defaults to GSSolver.
 * @param {Array} [options.gravity] Defaults to y=-9.78.
 * @param {Broadphase} [options.broadphase] Defaults to SAPBroadphase
 * @param {Boolean} [options.islandSplit=true]
 * @extends EventEmitter
 *
 * @example
 *     var world = new World({
 *         gravity: [0, -10],
 *         broadphase: new SAPBroadphase()
 *     });
 *     world.addBody(new Body());
 */ function $cdf7a95ffc36e12c$var$World(options) {
    $5POlg.apply(this);
    options = options || {};
    /**
     * All springs in the world. To add a spring to the world, use {{#crossLink "World/addSpring:method"}}{{/crossLink}}.
     *
     * @property springs
     * @type {Array}
     */ this.springs = [];
    /**
     * All bodies in the world. To add a body to the world, use {{#crossLink "World/addBody:method"}}{{/crossLink}}.
     * @property {Array} bodies
     */ this.bodies = [];
    /**
     * Disabled body collision pairs. See {{#crossLink "World/disableBodyCollision:method"}}.
     * @private
     * @property {Array} disabledBodyCollisionPairs
     */ this.disabledBodyCollisionPairs = [];
    /**
     * The solver used to satisfy constraints and contacts. Default is {{#crossLink "GSSolver"}}{{/crossLink}}.
     * @property {Solver} solver
     */ this.solver = options.solver || new $hejTV();
    /**
     * The narrowphase to use to generate contacts.
     *
     * @property narrowphase
     * @type {Narrowphase}
     */ this.narrowphase = new $3QUo8(this);
    /**
     * The island manager of this world.
     * @property {IslandManager} islandManager
     */ this.islandManager = new $9JhUu();
    /**
     * Gravity in the world. This is applied on all bodies in the beginning of each step().
     *
     * @property gravity
     * @type {Array}
     */ this.gravity = $2Ys9z.fromValues(0, -9.78);
    if (options.gravity) $2Ys9z.copy(this.gravity, options.gravity);
    /**
     * Gravity to use when approximating the friction max force (mu*mass*gravity).
     * @property {Number} frictionGravity
     */ this.frictionGravity = $2Ys9z.length(this.gravity) || 10;
    /**
     * Set to true if you want .frictionGravity to be automatically set to the length of .gravity.
     * @property {Boolean} useWorldGravityAsFrictionGravity
     * @default true
     */ this.useWorldGravityAsFrictionGravity = true;
    /**
     * If the length of .gravity is zero, and .useWorldGravityAsFrictionGravity=true, then switch to using .frictionGravity for friction instead. This fallback is useful for gravityless games.
     * @property {Boolean} useFrictionGravityOnZeroGravity
     * @default true
     */ this.useFrictionGravityOnZeroGravity = true;
    /**
     * The broadphase algorithm to use.
     *
     * @property broadphase
     * @type {Broadphase}
     */ this.broadphase = options.broadphase || new $konik();
    this.broadphase.setWorld(this);
    /**
     * User-added constraints.
     *
     * @property constraints
     * @type {Array}
     */ this.constraints = [];
    /**
     * Dummy default material in the world, used in .defaultContactMaterial
     * @property {Material} defaultMaterial
     */ this.defaultMaterial = new $kfn8e();
    /**
     * The default contact material to use, if no contact material was set for the colliding materials.
     * @property {ContactMaterial} defaultContactMaterial
     */ this.defaultContactMaterial = new $hzM8V(this.defaultMaterial, this.defaultMaterial);
    /**
     * For keeping track of what time step size we used last step
     * @property lastTimeStep
     * @type {Number}
     */ this.lastTimeStep = 1 / 60;
    /**
     * Enable to automatically apply spring forces each step.
     * @property applySpringForces
     * @type {Boolean}
     * @default true
     */ this.applySpringForces = true;
    /**
     * Enable to automatically apply body damping each step.
     * @property applyDamping
     * @type {Boolean}
     * @default true
     */ this.applyDamping = true;
    /**
     * Enable to automatically apply gravity each step.
     * @property applyGravity
     * @type {Boolean}
     * @default true
     */ this.applyGravity = true;
    /**
     * Enable/disable constraint solving in each step.
     * @property solveConstraints
     * @type {Boolean}
     * @default true
     */ this.solveConstraints = true;
    /**
     * The ContactMaterials added to the World.
     * @property contactMaterials
     * @type {Array}
     */ this.contactMaterials = [];
    /**
     * World time.
     * @property time
     * @type {Number}
     */ this.time = 0.0;
    this.accumulator = 0;
    /**
     * Is true during step().
     * @property {Boolean} stepping
     */ this.stepping = false;
    /**
     * Bodies that are scheduled to be removed at the end of the step.
     * @property {Array} bodiesToBeRemoved
     * @private
     */ this.bodiesToBeRemoved = [];
    /**
     * Whether to enable island splitting. Island splitting can be an advantage for both precision and performance. See {{#crossLink "IslandManager"}}{{/crossLink}}.
     * @property {Boolean} islandSplit
     * @default true
     */ this.islandSplit = typeof options.islandSplit !== "undefined" ? !!options.islandSplit : true;
    /**
     * Set to true if you want to the world to emit the "impact" event. Turning this off could improve performance.
     * @property emitImpactEvent
     * @type {Boolean}
     * @default true
     */ this.emitImpactEvent = true;
    // Id counters
    this._constraintIdCounter = 0;
    this._bodyIdCounter = 0;
    /**
     * Fired after the step().
     * @event postStep
     */ this.postStepEvent = {
        type: "postStep"
    };
    /**
     * Fired when a body is added to the world.
     * @event addBody
     * @param {Body} body
     */ this.addBodyEvent = {
        type: "addBody",
        body: null
    };
    /**
     * Fired when a body is removed from the world.
     * @event removeBody
     * @param {Body} body
     */ this.removeBodyEvent = {
        type: "removeBody",
        body: null
    };
    /**
     * Fired when a spring is added to the world.
     * @event addSpring
     * @param {Spring} spring
     */ this.addSpringEvent = {
        type: "addSpring",
        spring: null
    };
    /**
     * Fired when a first contact is created between two bodies. This event is fired after the step has been done.
     * @event impact
     * @param {Body} bodyA
     * @param {Body} bodyB
     */ this.impactEvent = {
        type: "impact",
        bodyA: null,
        bodyB: null,
        shapeA: null,
        shapeB: null,
        contactEquation: null
    };
    /**
     * Fired after the Broadphase has collected collision pairs in the world.
     * Inside the event handler, you can modify the pairs array as you like, to
     * prevent collisions between objects that you don't want.
     * @event postBroadphase
     * @param {Array} pairs An array of collision pairs. If this array is [body1,body2,body3,body4], then the body pairs 1,2 and 3,4 would advance to narrowphase.
     */ this.postBroadphaseEvent = {
        type: "postBroadphase",
        pairs: null
    };
    /**
     * How to deactivate bodies during simulation. Possible modes are: {{#crossLink "World/NO_SLEEPING:property"}}World.NO_SLEEPING{{/crossLink}}, {{#crossLink "World/BODY_SLEEPING:property"}}World.BODY_SLEEPING{{/crossLink}} and {{#crossLink "World/ISLAND_SLEEPING:property"}}World.ISLAND_SLEEPING{{/crossLink}}.
     * If sleeping is enabled, you might need to {{#crossLink "Body/wakeUp:method"}}wake up{{/crossLink}} the bodies if they fall asleep when they shouldn't. If you want to enable sleeping in the world, but want to disable it for a particular body, see {{#crossLink "Body/allowSleep:property"}}Body.allowSleep{{/crossLink}}.
     * @property sleepMode
     * @type {number}
     * @default World.NO_SLEEPING
     */ this.sleepMode = $cdf7a95ffc36e12c$var$World.NO_SLEEPING;
    /**
     * Fired when two shapes starts start to overlap. Fired in the narrowphase, during step.
     * @event beginContact
     * @param {Shape} shapeA
     * @param {Shape} shapeB
     * @param {Body}  bodyA
     * @param {Body}  bodyB
     * @param {Array} contactEquations
     */ this.beginContactEvent = {
        type: "beginContact",
        shapeA: null,
        shapeB: null,
        bodyA: null,
        bodyB: null,
        contactEquations: []
    };
    /**
     * Fired when two shapes stop overlapping, after the narrowphase (during step).
     * @event endContact
     * @param {Shape} shapeA
     * @param {Shape} shapeB
     * @param {Body}  bodyA
     * @param {Body}  bodyB
     */ this.endContactEvent = {
        type: "endContact",
        shapeA: null,
        shapeB: null,
        bodyA: null,
        bodyB: null
    };
    /**
     * Fired just before equations are added to the solver to be solved. Can be used to control what equations goes into the solver.
     * @event preSolve
     * @param {Array} contactEquations  An array of contacts to be solved.
     * @param {Array} frictionEquations An array of friction equations to be solved.
     */ this.preSolveEvent = {
        type: "preSolve",
        contactEquations: null,
        frictionEquations: null
    };
    // For keeping track of overlapping shapes
    this.overlappingShapesLastState = {
        keys: []
    };
    this.overlappingShapesCurrentState = {
        keys: []
    };
    /**
     * @property {OverlapKeeper} overlapKeeper
     */ this.overlapKeeper = new $lST4l();
}
$cdf7a95ffc36e12c$var$World.prototype = new Object($5POlg.prototype);
$cdf7a95ffc36e12c$var$World.prototype.constructor = $cdf7a95ffc36e12c$var$World;
/**
 * Never deactivate bodies.
 * @static
 * @property {number} NO_SLEEPING
 */ $cdf7a95ffc36e12c$var$World.NO_SLEEPING = 1;
/**
 * Deactivate individual bodies if they are sleepy.
 * @static
 * @property {number} BODY_SLEEPING
 */ $cdf7a95ffc36e12c$var$World.BODY_SLEEPING = 2;
/**
 * Deactivates bodies that are in contact, if all of them are sleepy. Note that you must enable {{#crossLink "World/islandSplit:property"}}.islandSplit{{/crossLink}} for this to work.
 * @static
 * @property {number} ISLAND_SLEEPING
 */ $cdf7a95ffc36e12c$var$World.ISLAND_SLEEPING = 4;
/**
 * Add a constraint to the simulation.
 *
 * @method addConstraint
 * @param {Constraint} constraint
 * @example
 *     var constraint = new LockConstraint(bodyA, bodyB);
 *     world.addConstraint(constraint);
 */ $cdf7a95ffc36e12c$var$World.prototype.addConstraint = function(constraint) {
    this.constraints.push(constraint);
};
/**
 * Add a ContactMaterial to the simulation.
 * @method addContactMaterial
 * @param {ContactMaterial} contactMaterial
 */ $cdf7a95ffc36e12c$var$World.prototype.addContactMaterial = function(contactMaterial) {
    this.contactMaterials.push(contactMaterial);
};
/**
 * Removes a contact material
 *
 * @method removeContactMaterial
 * @param {ContactMaterial} cm
 */ $cdf7a95ffc36e12c$var$World.prototype.removeContactMaterial = function(cm) {
    var idx = this.contactMaterials.indexOf(cm);
    if (idx !== -1) $dMz05.splice(this.contactMaterials, idx, 1);
};
/**
 * Get a contact material given two materials
 * @method getContactMaterial
 * @param {Material} materialA
 * @param {Material} materialB
 * @return {ContactMaterial} The matching ContactMaterial, or false on fail.
 * @todo Use faster hash map to lookup from material id's
 */ $cdf7a95ffc36e12c$var$World.prototype.getContactMaterial = function(materialA, materialB) {
    var cmats = this.contactMaterials;
    for(var i = 0, N = cmats.length; i !== N; i++){
        var cm = cmats[i];
        if (cm.materialA.id === materialA.id && cm.materialB.id === materialB.id || cm.materialA.id === materialB.id && cm.materialB.id === materialA.id) return cm;
    }
    return false;
};
/**
 * Removes a constraint
 *
 * @method removeConstraint
 * @param {Constraint} constraint
 */ $cdf7a95ffc36e12c$var$World.prototype.removeConstraint = function(constraint) {
    var idx = this.constraints.indexOf(constraint);
    if (idx !== -1) $dMz05.splice(this.constraints, idx, 1);
};
var $cdf7a95ffc36e12c$var$step_r = $2Ys9z.create(), $cdf7a95ffc36e12c$var$step_runit = $2Ys9z.create(), $cdf7a95ffc36e12c$var$step_u = $2Ys9z.create(), $cdf7a95ffc36e12c$var$step_f = $2Ys9z.create(), $cdf7a95ffc36e12c$var$step_fhMinv = $2Ys9z.create(), $cdf7a95ffc36e12c$var$step_velodt = $2Ys9z.create(), $cdf7a95ffc36e12c$var$step_mg = $2Ys9z.create(), $cdf7a95ffc36e12c$var$xiw = $2Ys9z.fromValues(0, 0), $cdf7a95ffc36e12c$var$xjw = $2Ys9z.fromValues(0, 0), $cdf7a95ffc36e12c$var$zero = $2Ys9z.fromValues(0, 0), $cdf7a95ffc36e12c$var$interpvelo = $2Ys9z.fromValues(0, 0);
/**
 * Step the physics world forward in time.
 *
 * There are two modes. The simple mode is fixed timestepping without interpolation. In this case you only use the first argument. The second case uses interpolation. In that you also provide the time since the function was last used, as well as the maximum fixed timesteps to take.
 *
 * @method step
 * @param {Number} dt                       The fixed time step size to use.
 * @param {Number} [timeSinceLastCalled=0]  The time elapsed since the function was last called.
 * @param {Number} [maxSubSteps=10]         Maximum number of fixed steps to take per function call.
 *
 * @example
 *     // Simple fixed timestepping without interpolation
 *     var fixedTimeStep = 1 / 60;
 *     var world = new World();
 *     var body = new Body({ mass: 1 });
 *     world.addBody(body);
 *
 *     function animate(){
 *         requestAnimationFrame(animate);
 *         world.step(fixedTimeStep);
 *         renderBody(body.position, body.angle);
 *     }
 *
 *     // Start animation loop
 *     requestAnimationFrame(animate);
 *
 * @example
 *     // Fixed timestepping with interpolation
 *     var maxSubSteps = 10;
 *     var lastTimeSeconds;
 *
 *     function animate(t){
 *         requestAnimationFrame(animate);
 *         timeSeconds = t / 1000;
 *         lastTimeSeconds = lastTimeSeconds || timeSeconds;
 *
 *         deltaTime = timeSeconds - lastTimeSeconds;
 *         world.step(fixedTimeStep, deltaTime, maxSubSteps);
 *
 *         renderBody(body.interpolatedPosition, body.interpolatedAngle);
 *     }
 *
 *     // Start animation loop
 *     requestAnimationFrame(animate);
 *
 * @see http://bulletphysics.org/mediawiki-1.5.8/index.php/Stepping_The_World
 */ $cdf7a95ffc36e12c$var$World.prototype.step = function(dt, timeSinceLastCalled, maxSubSteps) {
    maxSubSteps = maxSubSteps || 10;
    timeSinceLastCalled = timeSinceLastCalled || 0;
    if (timeSinceLastCalled === 0) {
        this.internalStep(dt);
        // Increment time
        this.time += dt;
    } else {
        this.accumulator += timeSinceLastCalled;
        var substeps = 0;
        while(this.accumulator >= dt && substeps < maxSubSteps){
            // Do fixed steps to catch up
            this.internalStep(dt);
            this.time += dt;
            this.accumulator -= dt;
            substeps++;
        }
        var t = this.accumulator % dt / dt;
        for(var j = 0; j !== this.bodies.length; j++){
            var b = this.bodies[j];
            $2Ys9z.lerp(b.interpolatedPosition, b.previousPosition, b.position, t);
            b.interpolatedAngle = b.previousAngle + t * (b.angle - b.previousAngle);
        }
    }
};
var $cdf7a95ffc36e12c$var$endOverlaps = [];
/**
 * Make a fixed step.
 * @method internalStep
 * @param  {number} dt
 * @private
 */ $cdf7a95ffc36e12c$var$World.prototype.internalStep = function(dt) {
    this.stepping = true;
    var that = this, Nsprings = this.springs.length, springs = this.springs, bodies = this.bodies, g = this.gravity, solver = this.solver, Nbodies = this.bodies.length, broadphase = this.broadphase, np = this.narrowphase, constraints = this.constraints, t0, t1, fhMinv = $cdf7a95ffc36e12c$var$step_fhMinv, velodt = $cdf7a95ffc36e12c$var$step_velodt, mg = $cdf7a95ffc36e12c$var$step_mg, scale = $2Ys9z.scale, add = $2Ys9z.add, rotate = $2Ys9z.rotate, islandManager = this.islandManager;
    this.overlapKeeper.tick();
    this.lastTimeStep = dt;
    // Update approximate friction gravity.
    if (this.useWorldGravityAsFrictionGravity) {
        var gravityLen = $2Ys9z.length(this.gravity);
        if (!(gravityLen === 0 && this.useFrictionGravityOnZeroGravity)) // Nonzero gravity. Use it.
        this.frictionGravity = gravityLen;
    }
    // Add gravity to bodies
    if (this.applyGravity) for(var i = 0; i !== Nbodies; i++){
        var b = bodies[i], fi = b.force;
        if (b.type !== $e7hLo.DYNAMIC || b.sleepState === $e7hLo.SLEEPING) continue;
        $2Ys9z.scale(mg, g, b.mass * b.gravityScale); // F=m*g
        add(fi, fi, mg);
    }
    // Add spring forces
    if (this.applySpringForces) for(var i = 0; i !== Nsprings; i++){
        var s = springs[i];
        s.applyForce();
    }
    if (this.applyDamping) for(var i = 0; i !== Nbodies; i++){
        var b = bodies[i];
        if (b.type === $e7hLo.DYNAMIC) b.applyDamping(dt);
    }
    // Broadphase
    var result = broadphase.getCollisionPairs(this);
    // Remove ignored collision pairs
    var ignoredPairs = this.disabledBodyCollisionPairs;
    for(var i = ignoredPairs.length - 2; i >= 0; i -= 2){
        for(var j = result.length - 2; j >= 0; j -= 2)if (ignoredPairs[i] === result[j] && ignoredPairs[i + 1] === result[j + 1] || ignoredPairs[i + 1] === result[j] && ignoredPairs[i] === result[j + 1]) result.splice(j, 2);
    }
    // Remove constrained pairs with collideConnected == false
    var Nconstraints = constraints.length;
    for(i = 0; i !== Nconstraints; i++){
        var c = constraints[i];
        if (!c.collideConnected) {
            for(var j = result.length - 2; j >= 0; j -= 2)if (c.bodyA === result[j] && c.bodyB === result[j + 1] || c.bodyB === result[j] && c.bodyA === result[j + 1]) result.splice(j, 2);
        }
    }
    // postBroadphase event
    this.postBroadphaseEvent.pairs = result;
    this.emit(this.postBroadphaseEvent);
    this.postBroadphaseEvent.pairs = null;
    // Narrowphase
    np.reset(this);
    for(var i = 0, Nresults = result.length; i !== Nresults; i += 2){
        var bi = result[i], bj = result[i + 1];
        // Loop over all shapes of body i
        for(var k = 0, Nshapesi = bi.shapes.length; k !== Nshapesi; k++){
            var si = bi.shapes[k], xi = si.position, ai = si.angle;
            // All shapes of body j
            for(var l = 0, Nshapesj = bj.shapes.length; l !== Nshapesj; l++){
                var sj = bj.shapes[l], xj = sj.position, aj = sj.angle;
                var cm = this.defaultContactMaterial;
                if (si.material && sj.material) {
                    var tmp = this.getContactMaterial(si.material, sj.material);
                    if (tmp) cm = tmp;
                }
                this.runNarrowphase(np, bi, si, xi, ai, bj, sj, xj, aj, cm, this.frictionGravity);
            }
        }
    }
    // Wake up bodies
    for(var i = 0; i !== Nbodies; i++){
        var body = bodies[i];
        if (body._wakeUpAfterNarrowphase) {
            body.wakeUp();
            body._wakeUpAfterNarrowphase = false;
        }
    }
    // Emit end overlap events
    if (this.has("endContact")) {
        this.overlapKeeper.getEndOverlaps($cdf7a95ffc36e12c$var$endOverlaps);
        var e = this.endContactEvent;
        var l = $cdf7a95ffc36e12c$var$endOverlaps.length;
        while(l--){
            var data = $cdf7a95ffc36e12c$var$endOverlaps[l];
            e.shapeA = data.shapeA;
            e.shapeB = data.shapeB;
            e.bodyA = data.bodyA;
            e.bodyB = data.bodyB;
            this.emit(e);
        }
        $cdf7a95ffc36e12c$var$endOverlaps.length = 0;
    }
    var preSolveEvent = this.preSolveEvent;
    preSolveEvent.contactEquations = np.contactEquations;
    preSolveEvent.frictionEquations = np.frictionEquations;
    this.emit(preSolveEvent);
    preSolveEvent.contactEquations = preSolveEvent.frictionEquations = null;
    // update constraint equations
    var Nconstraints = constraints.length;
    for(i = 0; i !== Nconstraints; i++)constraints[i].update();
    if (np.contactEquations.length || np.frictionEquations.length || Nconstraints) {
        if (this.islandSplit) {
            // Split into islands
            islandManager.equations.length = 0;
            $dMz05.appendArray(islandManager.equations, np.contactEquations);
            $dMz05.appendArray(islandManager.equations, np.frictionEquations);
            for(i = 0; i !== Nconstraints; i++)$dMz05.appendArray(islandManager.equations, constraints[i].equations);
            islandManager.split(this);
            for(var i = 0; i !== islandManager.islands.length; i++){
                var island = islandManager.islands[i];
                if (island.equations.length) solver.solveIsland(dt, island);
            }
        } else {
            // Add contact equations to solver
            solver.addEquations(np.contactEquations);
            solver.addEquations(np.frictionEquations);
            // Add user-defined constraint equations
            for(i = 0; i !== Nconstraints; i++)solver.addEquations(constraints[i].equations);
            if (this.solveConstraints) solver.solve(dt, this);
            solver.removeAllEquations();
        }
    }
    // Step forward
    for(var i = 0; i !== Nbodies; i++){
        var body = bodies[i];
        // if(body.sleepState !== Body.SLEEPING && body.type !== Body.STATIC){
        body.integrate(dt);
    // }
    }
    // Reset force
    for(var i = 0; i !== Nbodies; i++)bodies[i].setZeroForce();
    // Emit impact event
    if (this.emitImpactEvent && this.has("impact")) {
        var ev = this.impactEvent;
        for(var i = 0; i !== np.contactEquations.length; i++){
            var eq = np.contactEquations[i];
            if (eq.firstImpact) {
                ev.bodyA = eq.bodyA;
                ev.bodyB = eq.bodyB;
                ev.shapeA = eq.shapeA;
                ev.shapeB = eq.shapeB;
                ev.contactEquation = eq;
                this.emit(ev);
            }
        }
    }
    // Sleeping update
    if (this.sleepMode === $cdf7a95ffc36e12c$var$World.BODY_SLEEPING) for(i = 0; i !== Nbodies; i++)bodies[i].sleepTick(this.time, false, dt);
    else if (this.sleepMode === $cdf7a95ffc36e12c$var$World.ISLAND_SLEEPING && this.islandSplit) {
        // Tell all bodies to sleep tick but dont sleep yet
        for(i = 0; i !== Nbodies; i++)bodies[i].sleepTick(this.time, true, dt);
        // Sleep islands
        for(var i = 0; i < this.islandManager.islands.length; i++){
            var island = this.islandManager.islands[i];
            if (island.wantsToSleep()) island.sleep();
        }
    }
    this.stepping = false;
    // Remove bodies that are scheduled for removal
    var bodiesToBeRemoved = this.bodiesToBeRemoved;
    for(var i = 0; i !== bodiesToBeRemoved.length; i++)this.removeBody(bodiesToBeRemoved[i]);
    bodiesToBeRemoved.length = 0;
    this.emit(this.postStepEvent);
};
/**
 * Runs narrowphase for the shape pair i and j.
 * @method runNarrowphase
 * @param  {Narrowphase} np
 * @param  {Body} bi
 * @param  {Shape} si
 * @param  {Array} xi
 * @param  {Number} ai
 * @param  {Body} bj
 * @param  {Shape} sj
 * @param  {Array} xj
 * @param  {Number} aj
 * @param  {Number} mu
 */ $cdf7a95ffc36e12c$var$World.prototype.runNarrowphase = function(np, bi, si, xi, ai, bj, sj, xj, aj, cm, glen) {
    // Check collision groups and masks
    if (!((si.collisionGroup & sj.collisionMask) !== 0 && (sj.collisionGroup & si.collisionMask) !== 0)) return;
    // Get world position and angle of each shape
    $2Ys9z.rotate($cdf7a95ffc36e12c$var$xiw, xi, bi.angle);
    $2Ys9z.rotate($cdf7a95ffc36e12c$var$xjw, xj, bj.angle);
    $2Ys9z.add($cdf7a95ffc36e12c$var$xiw, $cdf7a95ffc36e12c$var$xiw, bi.position);
    $2Ys9z.add($cdf7a95ffc36e12c$var$xjw, $cdf7a95ffc36e12c$var$xjw, bj.position);
    var aiw = ai + bi.angle;
    var ajw = aj + bj.angle;
    np.enableFriction = cm.friction > 0;
    np.frictionCoefficient = cm.friction;
    var reducedMass;
    if (bi.type === $e7hLo.STATIC || bi.type === $e7hLo.KINEMATIC) reducedMass = bj.mass;
    else if (bj.type === $e7hLo.STATIC || bj.type === $e7hLo.KINEMATIC) reducedMass = bi.mass;
    else reducedMass = bi.mass * bj.mass / (bi.mass + bj.mass);
    np.slipForce = cm.friction * glen * reducedMass;
    np.restitution = cm.restitution;
    np.surfaceVelocity = cm.surfaceVelocity;
    np.frictionStiffness = cm.frictionStiffness;
    np.frictionRelaxation = cm.frictionRelaxation;
    np.stiffness = cm.stiffness;
    np.relaxation = cm.relaxation;
    np.contactSkinSize = cm.contactSkinSize;
    np.enabledEquations = bi.collisionResponse && bj.collisionResponse && si.collisionResponse && sj.collisionResponse;
    var resolver = np[si.type | sj.type], numContacts = 0;
    if (resolver) {
        var sensor = si.sensor || sj.sensor;
        var numFrictionBefore = np.frictionEquations.length;
        if (si.type < sj.type) numContacts = resolver.call(np, bi, si, $cdf7a95ffc36e12c$var$xiw, aiw, bj, sj, $cdf7a95ffc36e12c$var$xjw, ajw, sensor);
        else numContacts = resolver.call(np, bj, sj, $cdf7a95ffc36e12c$var$xjw, ajw, bi, si, $cdf7a95ffc36e12c$var$xiw, aiw, sensor);
        var numFrictionEquations = np.frictionEquations.length - numFrictionBefore;
        if (numContacts) {
            if (bi.allowSleep && bi.type === $e7hLo.DYNAMIC && bi.sleepState === $e7hLo.SLEEPING && bj.sleepState === $e7hLo.AWAKE && bj.type !== $e7hLo.STATIC) {
                var speedSquaredB = $2Ys9z.squaredLength(bj.velocity) + Math.pow(bj.angularVelocity, 2);
                var speedLimitSquaredB = Math.pow(bj.sleepSpeedLimit, 2);
                if (speedSquaredB >= speedLimitSquaredB * 2) bi._wakeUpAfterNarrowphase = true;
            }
            if (bj.allowSleep && bj.type === $e7hLo.DYNAMIC && bj.sleepState === $e7hLo.SLEEPING && bi.sleepState === $e7hLo.AWAKE && bi.type !== $e7hLo.STATIC) {
                var speedSquaredA = $2Ys9z.squaredLength(bi.velocity) + Math.pow(bi.angularVelocity, 2);
                var speedLimitSquaredA = Math.pow(bi.sleepSpeedLimit, 2);
                if (speedSquaredA >= speedLimitSquaredA * 2) bj._wakeUpAfterNarrowphase = true;
            }
            this.overlapKeeper.setOverlapping(bi, si, bj, sj);
            if (this.has("beginContact") && this.overlapKeeper.isNewOverlap(si, sj)) {
                // Report new shape overlap
                var e = this.beginContactEvent;
                e.shapeA = si;
                e.shapeB = sj;
                e.bodyA = bi;
                e.bodyB = bj;
                // Reset contact equations
                e.contactEquations.length = 0;
                if (typeof numContacts === "number") for(var i = np.contactEquations.length - numContacts; i < np.contactEquations.length; i++)e.contactEquations.push(np.contactEquations[i]);
                this.emit(e);
            }
            // divide the max friction force by the number of contacts
            if (typeof numContacts === "number" && numFrictionEquations > 1) for(var i = np.frictionEquations.length - numFrictionEquations; i < np.frictionEquations.length; i++){
                var f = np.frictionEquations[i];
                f.setSlipForce(f.getSlipForce() / numFrictionEquations);
            }
        }
    }
};
/**
 * Add a spring to the simulation
 *
 * @method addSpring
 * @param {Spring} spring
 */ $cdf7a95ffc36e12c$var$World.prototype.addSpring = function(spring) {
    this.springs.push(spring);
    var evt = this.addSpringEvent;
    evt.spring = spring;
    this.emit(evt);
    evt.spring = null;
};
/**
 * Remove a spring
 *
 * @method removeSpring
 * @param {Spring} spring
 */ $cdf7a95ffc36e12c$var$World.prototype.removeSpring = function(spring) {
    var idx = this.springs.indexOf(spring);
    if (idx !== -1) $dMz05.splice(this.springs, idx, 1);
};
/**
 * Add a body to the simulation
 *
 * @method addBody
 * @param {Body} body
 *
 * @example
 *     var world = new World(),
 *         body = new Body();
 *     world.addBody(body);
 * @todo What if this is done during step?
 */ $cdf7a95ffc36e12c$var$World.prototype.addBody = function(body) {
    if (this.bodies.indexOf(body) === -1) {
        this.bodies.push(body);
        body.world = this;
        var evt = this.addBodyEvent;
        evt.body = body;
        this.emit(evt);
        evt.body = null;
    }
};
/**
 * Remove a body from the simulation. If this method is called during step(), the body removal is scheduled to after the step.
 *
 * @method removeBody
 * @param {Body} body
 */ $cdf7a95ffc36e12c$var$World.prototype.removeBody = function(body) {
    if (this.stepping) this.bodiesToBeRemoved.push(body);
    else {
        body.world = null;
        var idx = this.bodies.indexOf(body);
        if (idx !== -1) {
            $dMz05.splice(this.bodies, idx, 1);
            this.removeBodyEvent.body = body;
            body.resetConstraintVelocity();
            this.emit(this.removeBodyEvent);
            this.removeBodyEvent.body = null;
        }
    }
};
/**
 * Get a body by its id.
 * @method getBodyById
 * @param {number} id
 * @return {Body} The body, or false if it was not found.
 */ $cdf7a95ffc36e12c$var$World.prototype.getBodyById = function(id) {
    var bodies = this.bodies;
    for(var i = 0; i < bodies.length; i++){
        var b = bodies[i];
        if (b.id === id) return b;
    }
    return false;
};
/**
 * Disable collision between two bodies
 * @method disableBodyCollision
 * @param {Body} bodyA
 * @param {Body} bodyB
 */ $cdf7a95ffc36e12c$var$World.prototype.disableBodyCollision = function(bodyA, bodyB) {
    this.disabledBodyCollisionPairs.push(bodyA, bodyB);
};
/**
 * Enable collisions between the given two bodies
 * @method enableBodyCollision
 * @param {Body} bodyA
 * @param {Body} bodyB
 */ $cdf7a95ffc36e12c$var$World.prototype.enableBodyCollision = function(bodyA, bodyB) {
    var pairs = this.disabledBodyCollisionPairs;
    for(var i = 0; i < pairs.length; i += 2)if (pairs[i] === bodyA && pairs[i + 1] === bodyB || pairs[i + 1] === bodyA && pairs[i] === bodyB) {
        pairs.splice(i, 2);
        return;
    }
};
/**
 * Resets the World, removes all bodies, constraints and springs.
 *
 * @method clear
 */ $cdf7a95ffc36e12c$var$World.prototype.clear = function() {
    this.time = 0;
    // Remove all solver equations
    if (this.solver && this.solver.equations.length) this.solver.removeAllEquations();
    // Remove all constraints
    var cs = this.constraints;
    for(var i = cs.length - 1; i >= 0; i--)this.removeConstraint(cs[i]);
    // Remove all bodies
    var bodies = this.bodies;
    for(var i = bodies.length - 1; i >= 0; i--)this.removeBody(bodies[i]);
    // Remove all springs
    var springs = this.springs;
    for(var i = springs.length - 1; i >= 0; i--)this.removeSpring(springs[i]);
    // Remove all contact materials
    var cms = this.contactMaterials;
    for(var i = cms.length - 1; i >= 0; i--)this.removeContactMaterial(cms[i]);
    $cdf7a95ffc36e12c$var$World.apply(this);
};
var $cdf7a95ffc36e12c$var$hitTest_tmp1 = $2Ys9z.create(), $cdf7a95ffc36e12c$var$hitTest_zero = $2Ys9z.fromValues(0, 0), $cdf7a95ffc36e12c$var$hitTest_tmp2 = $2Ys9z.fromValues(0, 0);
/**
 * Test if a world point overlaps bodies
 * @method hitTest
 * @param  {Array}  worldPoint  Point to use for intersection tests
 * @param  {Array}  bodies      A list of objects to check for intersection
 * @param  {Number} precision   Used for matching against particles and lines. Adds some margin to these infinitesimal objects.
 * @return {Array}              Array of bodies that overlap the point
 * @todo Should use an api similar to the raycast function
 * @todo Should probably implement a .containsPoint method for all shapes. Would be more efficient
 * @todo Should use the broadphase
 */ $cdf7a95ffc36e12c$var$World.prototype.hitTest = function(worldPoint, bodies, precision) {
    precision = precision || 0;
    // Create a dummy particle body with a particle shape to test against the bodies
    var pb = new $e7hLo({
        position: worldPoint
    }), ps = new $fwNHk(), px = worldPoint, pa = 0, x = $cdf7a95ffc36e12c$var$hitTest_tmp1, zero = $cdf7a95ffc36e12c$var$hitTest_zero, tmp = $cdf7a95ffc36e12c$var$hitTest_tmp2;
    pb.addShape(ps);
    var n = this.narrowphase, result = [];
    // Check bodies
    for(var i = 0, N = bodies.length; i !== N; i++){
        var b = bodies[i];
        for(var j = 0, NS = b.shapes.length; j !== NS; j++){
            var s = b.shapes[j];
            // Get shape world position + angle
            $2Ys9z.rotate(x, s.position, b.angle);
            $2Ys9z.add(x, x, b.position);
            var a = s.angle + b.angle;
            if (s instanceof $OJ0UJ && n.circleParticle(b, s, x, a, pb, ps, px, pa, true) || s instanceof $clDtn && n.particleConvex(pb, ps, px, pa, b, s, x, a, true) || s instanceof $hNAi3 && n.particlePlane(pb, ps, px, pa, b, s, x, a, true) || s instanceof $4flMw && n.particleCapsule(pb, ps, px, pa, b, s, x, a, true) || s instanceof $fwNHk && $2Ys9z.squaredLength($2Ys9z.sub(tmp, x, worldPoint)) < precision * precision) result.push(b);
        }
    }
    return result;
};
/**
 * Set the stiffness for all equations and contact materials.
 * @method setGlobalStiffness
 * @param {Number} stiffness
 */ $cdf7a95ffc36e12c$var$World.prototype.setGlobalStiffness = function(stiffness) {
    // Set for all constraints
    var constraints = this.constraints;
    for(var i = 0; i !== constraints.length; i++){
        var c = constraints[i];
        for(var j = 0; j !== c.equations.length; j++){
            var eq = c.equations[j];
            eq.stiffness = stiffness;
            eq.needsUpdate = true;
        }
    }
    // Set for all contact materials
    var contactMaterials = this.contactMaterials;
    for(var i = 0; i !== contactMaterials.length; i++){
        var c = contactMaterials[i];
        c.stiffness = c.frictionStiffness = stiffness;
    }
    // Set for default contact material
    var c = this.defaultContactMaterial;
    c.stiffness = c.frictionStiffness = stiffness;
};
/**
 * Set the relaxation for all equations and contact materials.
 * @method setGlobalRelaxation
 * @param {Number} relaxation
 */ $cdf7a95ffc36e12c$var$World.prototype.setGlobalRelaxation = function(relaxation) {
    // Set for all constraints
    for(var i = 0; i !== this.constraints.length; i++){
        var c = this.constraints[i];
        for(var j = 0; j !== c.equations.length; j++){
            var eq = c.equations[j];
            eq.relaxation = relaxation;
            eq.needsUpdate = true;
        }
    }
    // Set for all contact materials
    for(var i = 0; i !== this.contactMaterials.length; i++){
        var c = this.contactMaterials[i];
        c.relaxation = c.frictionRelaxation = relaxation;
    }
    // Set for default contact material
    var c = this.defaultContactMaterial;
    c.relaxation = c.frictionRelaxation = relaxation;
};
var $cdf7a95ffc36e12c$var$tmpAABB = new $hkl1e();
var $cdf7a95ffc36e12c$var$tmpArray = [];
/**
 * Ray cast against all bodies in the world.
 * @method raycast
 * @param  {RaycastResult} result
 * @param  {Ray} ray
 * @return {boolean} True if any body was hit.
 *
 * @example
 *     var ray = new Ray({
 *         mode: Ray.CLOSEST, // or ANY
 *         from: [0, 0],
 *         to: [10, 0],
 *     });
 *     var result = new RaycastResult();
 *     world.raycast(result, ray);
 *
 *     // Get the hit point
 *     var hitPoint = vec2.create();
 *     result.getHitPoint(hitPoint, ray);
 *     console.log('Hit point: ', hitPoint[0], hitPoint[1], ' at distance ' + result.getHitDistance(ray));
 *
 * @example
 *     var ray = new Ray({
 *         mode: Ray.ALL,
 *         from: [0, 0],
 *         to: [10, 0],
 *         callback: function(result){
 *
 *             // Print some info about the hit
 *             console.log('Hit body and shape: ', result.body, result.shape);
 *
 *             // Get the hit point
 *             var hitPoint = vec2.create();
 *             result.getHitPoint(hitPoint, ray);
 *             console.log('Hit point: ', hitPoint[0], hitPoint[1], ' at distance ' + result.getHitDistance(ray));
 *
 *             // If you are happy with the hits you got this far, you can stop the traversal here:
 *             result.stop();
 *         }
 *     });
 *     var result = new RaycastResult();
 *     world.raycast(result, ray);
 */ $cdf7a95ffc36e12c$var$World.prototype.raycast = function(result, ray) {
    // Get all bodies within the ray AABB
    ray.getAABB($cdf7a95ffc36e12c$var$tmpAABB);
    this.broadphase.aabbQuery(this, $cdf7a95ffc36e12c$var$tmpAABB, $cdf7a95ffc36e12c$var$tmpArray);
    ray.intersectBodies(result, $cdf7a95ffc36e12c$var$tmpArray);
    $cdf7a95ffc36e12c$var$tmpArray.length = 0;
    return result.hasHit();
};

});
parcelRegister("hIDwd", function(module, exports) {
module.exports = JSON.parse('{"name":"p2","version":"0.7.1","description":"A JavaScript 2D physics engine.","author":"Stefan Hedman <schteppe@gmail.com> (http://steffe.se)","keywords":["p2.js","p2","physics","engine","2d"],"main":"./src/p2.js","engines":{"node":"*"},"repository":{"type":"git","url":"https://github.com/schteppe/p2.js.git"},"bugs":{"url":"https://github.com/schteppe/p2.js/issues"},"licenses":[{"type":"MIT"}],"devDependencies":{"grunt":"^0.4.5","grunt-contrib-jshint":"^0.11.2","grunt-contrib-nodeunit":"^0.4.1","grunt-contrib-uglify":"~0.4.0","grunt-contrib-watch":"~0.5.0","grunt-browserify":"~2.0.1","grunt-contrib-concat":"^0.4.0"},"dependencies":{"poly-decomp":"0.1.1"}}');

});

parcelRegister("lST4l", function(module, exports) {

var $jFBgF = parcelRequire("jFBgF");
parcelRequire("5IjXE");

var $8jYw9 = parcelRequire("8jYw9");
parcelRequire("dMz05");
module.exports = $fee95bb0a8dde0c7$var$OverlapKeeper;
/**
 * Keeps track of overlaps in the current state and the last step state.
 * @class OverlapKeeper
 * @constructor
 */ function $fee95bb0a8dde0c7$var$OverlapKeeper() {
    this.overlappingShapesLastState = new $jFBgF();
    this.overlappingShapesCurrentState = new $jFBgF();
    this.recordPool = new $8jYw9({
        size: 16
    });
    this.tmpDict = new $jFBgF();
    this.tmpArray1 = [];
}
/**
 * Ticks one step forward in time. This will move the current overlap state to the "old" overlap state, and create a new one as current.
 * @method tick
 */ $fee95bb0a8dde0c7$var$OverlapKeeper.prototype.tick = function() {
    var last = this.overlappingShapesLastState;
    var current = this.overlappingShapesCurrentState;
    // Save old objects into pool
    var l = last.keys.length;
    while(l--){
        var key = last.keys[l];
        var lastObject = last.getByKey(key);
        var currentObject = current.getByKey(key);
        if (lastObject) // The record is only used in the "last" dict, and will be removed. We might as well pool it.
        this.recordPool.release(lastObject);
    }
    // Clear last object
    last.reset();
    // Transfer from new object to old
    last.copy(current);
    // Clear current object
    current.reset();
};
/**
 * @method setOverlapping
 * @param {Body} bodyA
 * @param {Body} shapeA
 * @param {Body} bodyB
 * @param {Body} shapeB
 */ $fee95bb0a8dde0c7$var$OverlapKeeper.prototype.setOverlapping = function(bodyA, shapeA, bodyB, shapeB) {
    var last = this.overlappingShapesLastState;
    var current = this.overlappingShapesCurrentState;
    // Store current contact state
    if (!current.get(shapeA.id, shapeB.id)) {
        var data = this.recordPool.get();
        data.set(bodyA, shapeA, bodyB, shapeB);
        current.set(shapeA.id, shapeB.id, data);
    }
};
$fee95bb0a8dde0c7$var$OverlapKeeper.prototype.getNewOverlaps = function(result) {
    return this.getDiff(this.overlappingShapesLastState, this.overlappingShapesCurrentState, result);
};
$fee95bb0a8dde0c7$var$OverlapKeeper.prototype.getEndOverlaps = function(result) {
    return this.getDiff(this.overlappingShapesCurrentState, this.overlappingShapesLastState, result);
};
/**
 * Checks if two bodies are currently overlapping.
 * @method bodiesAreOverlapping
 * @param  {Body} bodyA
 * @param  {Body} bodyB
 * @return {boolean}
 */ $fee95bb0a8dde0c7$var$OverlapKeeper.prototype.bodiesAreOverlapping = function(bodyA, bodyB) {
    var current = this.overlappingShapesCurrentState;
    var l = current.keys.length;
    while(l--){
        var key = current.keys[l];
        var data = current.data[key];
        if (data.bodyA === bodyA && data.bodyB === bodyB || data.bodyA === bodyB && data.bodyB === bodyA) return true;
    }
    return false;
};
$fee95bb0a8dde0c7$var$OverlapKeeper.prototype.getDiff = function(dictA, dictB, result) {
    var result = result || [];
    var last = dictA;
    var current = dictB;
    result.length = 0;
    var l = current.keys.length;
    while(l--){
        var key = current.keys[l];
        var data = current.data[key];
        if (!data) throw new Error("Key " + key + " had no data!");
        var lastData = last.data[key];
        if (!lastData) // Not overlapping in last state, but in current.
        result.push(data);
    }
    return result;
};
$fee95bb0a8dde0c7$var$OverlapKeeper.prototype.isNewOverlap = function(shapeA, shapeB) {
    var idA = shapeA.id | 0, idB = shapeB.id | 0;
    var last = this.overlappingShapesLastState;
    var current = this.overlappingShapesCurrentState;
    // Not in last but in new
    return !!!last.get(idA, idB) && !!current.get(idA, idB);
};
$fee95bb0a8dde0c7$var$OverlapKeeper.prototype.getNewBodyOverlaps = function(result) {
    this.tmpArray1.length = 0;
    var overlaps = this.getNewOverlaps(this.tmpArray1);
    return this.getBodyDiff(overlaps, result);
};
$fee95bb0a8dde0c7$var$OverlapKeeper.prototype.getEndBodyOverlaps = function(result) {
    this.tmpArray1.length = 0;
    var overlaps = this.getEndOverlaps(this.tmpArray1);
    return this.getBodyDiff(overlaps, result);
};
$fee95bb0a8dde0c7$var$OverlapKeeper.prototype.getBodyDiff = function(overlaps, result) {
    result = result || [];
    var accumulator = this.tmpDict;
    var l = overlaps.length;
    while(l--){
        var data = overlaps[l];
        // Since we use body id's for the accumulator, these will be a subset of the original one
        accumulator.set(data.bodyA.id | 0, data.bodyB.id | 0, data);
    }
    l = accumulator.keys.length;
    while(l--){
        var data = accumulator.getByKey(accumulator.keys[l]);
        if (data) result.push(data.bodyA, data.bodyB);
    }
    accumulator.reset();
    return result;
};

});
parcelRegister("5IjXE", function(module, exports) {
module.exports = $42908ba6b1df7d06$var$OverlapKeeperRecord;
/**
 * Overlap data container for the OverlapKeeper
 * @class OverlapKeeperRecord
 * @constructor
 * @param {Body} bodyA
 * @param {Shape} shapeA
 * @param {Body} bodyB
 * @param {Shape} shapeB
 */ function $42908ba6b1df7d06$var$OverlapKeeperRecord(bodyA, shapeA, bodyB, shapeB) {
    /**
     * @property {Shape} shapeA
     */ this.shapeA = shapeA;
    /**
     * @property {Shape} shapeB
     */ this.shapeB = shapeB;
    /**
     * @property {Body} bodyA
     */ this.bodyA = bodyA;
    /**
     * @property {Body} bodyB
     */ this.bodyB = bodyB;
}
/**
 * Set the data for the record
 * @method set
 * @param {Body} bodyA
 * @param {Shape} shapeA
 * @param {Body} bodyB
 * @param {Shape} shapeB
 */ $42908ba6b1df7d06$var$OverlapKeeperRecord.prototype.set = function(bodyA, shapeA, bodyB, shapeB) {
    $42908ba6b1df7d06$var$OverlapKeeperRecord.call(this, bodyA, shapeA, bodyB, shapeB);
};

});

parcelRegister("8jYw9", function(module, exports) {

var $5IjXE = parcelRequire("5IjXE");

var $kaNFS = parcelRequire("kaNFS");
module.exports = $60ef0a975cb5d592$var$OverlapKeeperRecordPool;
/**
 * @class
 */ function $60ef0a975cb5d592$var$OverlapKeeperRecordPool() {
    $kaNFS.apply(this, arguments);
}
$60ef0a975cb5d592$var$OverlapKeeperRecordPool.prototype = new $kaNFS();
$60ef0a975cb5d592$var$OverlapKeeperRecordPool.prototype.constructor = $60ef0a975cb5d592$var$OverlapKeeperRecordPool;
/**
 * @method create
 * @return {OverlapKeeperRecord}
 */ $60ef0a975cb5d592$var$OverlapKeeperRecordPool.prototype.create = function() {
    return new $5IjXE();
};
/**
 * @method destroy
 * @param {OverlapKeeperRecord} record
 * @return {OverlapKeeperRecordPool}
 */ $60ef0a975cb5d592$var$OverlapKeeperRecordPool.prototype.destroy = function(record) {
    record.bodyA = record.bodyB = record.shapeA = record.shapeB = null;
    return this;
};

});


parcelRegister("9JhUu", function(module, exports) {
parcelRequire("2Ys9z");
parcelRequire("Nc8B5");
parcelRequire("41pPr");

var $kQdy2 = parcelRequire("kQdy2");

var $3HB0m = parcelRequire("3HB0m");

var $e7hLo = parcelRequire("e7hLo");
module.exports = $715635955fbf123c$var$IslandManager;
/**
 * Splits the system of bodies and equations into independent islands
 *
 * @class IslandManager
 * @constructor
 * @param {Object} [options]
 * @extends Solver
 */ function $715635955fbf123c$var$IslandManager(options) {
    /**
     * @property nodePool
     * @type {IslandNodePool}
     */ this.nodePool = new $kQdy2({
        size: 16
    });
    /**
     * @property islandPool
     * @type {IslandPool}
     */ this.islandPool = new $3HB0m({
        size: 8
    });
    /**
     * The equations to split. Manually fill this array before running .split().
     * @property {Array} equations
     */ this.equations = [];
    /**
     * The resulting {{#crossLink "Island"}}{{/crossLink}}s.
     * @property {Array} islands
     */ this.islands = [];
    /**
     * The resulting graph nodes.
     * @property {Array} nodes
     */ this.nodes = [];
    /**
     * The node queue, used when traversing the graph of nodes.
     * @private
     * @property {Array} queue
     */ this.queue = [];
}
/**
 * Get an unvisited node from a list of nodes.
 * @static
 * @method getUnvisitedNode
 * @param  {Array} nodes
 * @return {IslandNode|boolean} The node if found, else false.
 */ $715635955fbf123c$var$IslandManager.getUnvisitedNode = function(nodes) {
    var Nnodes = nodes.length;
    for(var i = 0; i !== Nnodes; i++){
        var node = nodes[i];
        if (!node.visited && node.body.type === $e7hLo.DYNAMIC) return node;
    }
    return false;
};
/**
 * Visit a node.
 * @method visit
 * @param  {IslandNode} node
 * @param  {Array} bds
 * @param  {Array} eqs
 */ $715635955fbf123c$var$IslandManager.prototype.visit = function(node, bds, eqs) {
    bds.push(node.body);
    var Neqs = node.equations.length;
    for(var i = 0; i !== Neqs; i++){
        var eq = node.equations[i];
        if (eqs.indexOf(eq) === -1) eqs.push(eq);
    }
};
/**
 * Runs the search algorithm, starting at a root node. The resulting bodies and equations will be stored in the provided arrays.
 * @method bfs
 * @param  {IslandNode} root The node to start from
 * @param  {Array} bds  An array to append resulting Bodies to.
 * @param  {Array} eqs  An array to append resulting Equations to.
 */ $715635955fbf123c$var$IslandManager.prototype.bfs = function(root, bds, eqs) {
    // Reset the visit queue
    var queue = this.queue;
    queue.length = 0;
    // Add root node to queue
    queue.push(root);
    root.visited = true;
    this.visit(root, bds, eqs);
    // Process all queued nodes
    while(queue.length){
        // Get next node in the queue
        var node = queue.pop();
        // Visit unvisited neighboring nodes
        var child;
        while(child = $715635955fbf123c$var$IslandManager.getUnvisitedNode(node.neighbors)){
            child.visited = true;
            this.visit(child, bds, eqs);
            // Only visit the children of this node if it's dynamic
            if (child.body.type === $e7hLo.DYNAMIC) queue.push(child);
        }
    }
};
/**
 * Split the world into independent islands. The result is stored in .islands.
 * @method split
 * @param  {World} world
 * @return {Array} The generated islands
 */ $715635955fbf123c$var$IslandManager.prototype.split = function(world) {
    var bodies = world.bodies, nodes = this.nodes, equations = this.equations;
    // Move old nodes to the node pool
    while(nodes.length)this.nodePool.release(nodes.pop());
    // Create needed nodes, reuse if possible
    for(var i = 0; i !== bodies.length; i++){
        var node = this.nodePool.get();
        node.body = bodies[i];
        nodes.push(node);
    // if(this.nodePool.length){
    //     var node = this.nodePool.pop();
    //     node.reset();
    //     node.body = bodies[i];
    //     nodes.push(node);
    // } else {
    //     nodes.push(new IslandNode(bodies[i]));
    // }
    }
    // Add connectivity data. Each equation connects 2 bodies.
    for(var k = 0; k !== equations.length; k++){
        var eq = equations[k], i = bodies.indexOf(eq.bodyA), j = bodies.indexOf(eq.bodyB), ni = nodes[i], nj = nodes[j];
        ni.neighbors.push(nj);
        nj.neighbors.push(ni);
        ni.equations.push(eq);
        nj.equations.push(eq);
    }
    // Move old islands to the island pool
    var islands = this.islands;
    for(var i = 0; i < islands.length; i++)this.islandPool.release(islands[i]);
    islands.length = 0;
    // Get islands
    var child;
    while(child = $715635955fbf123c$var$IslandManager.getUnvisitedNode(nodes)){
        // Create new island
        var island = this.islandPool.get();
        // Get all equations and bodies in this island
        this.bfs(child, island.bodies, island.equations);
        islands.push(island);
    }
    return islands;
};

});
parcelRegister("Nc8B5", function(module, exports) {

var $e7hLo = parcelRequire("e7hLo");
module.exports = $093dfe014d5a9292$var$Island;
/**
 * An island of bodies connected with equations.
 * @class Island
 * @constructor
 */ function $093dfe014d5a9292$var$Island() {
    /**
     * Current equations in this island.
     * @property equations
     * @type {Array}
     */ this.equations = [];
    /**
     * Current bodies in this island.
     * @property bodies
     * @type {Array}
     */ this.bodies = [];
}
/**
 * Clean this island from bodies and equations.
 * @method reset
 */ $093dfe014d5a9292$var$Island.prototype.reset = function() {
    this.equations.length = this.bodies.length = 0;
};
var $093dfe014d5a9292$var$bodyIds = [];
/**
 * Get all unique bodies in this island.
 * @method getBodies
 * @return {Array} An array of Body
 */ $093dfe014d5a9292$var$Island.prototype.getBodies = function(result) {
    var bodies = result || [], eqs = this.equations;
    $093dfe014d5a9292$var$bodyIds.length = 0;
    for(var i = 0; i !== eqs.length; i++){
        var eq = eqs[i];
        if ($093dfe014d5a9292$var$bodyIds.indexOf(eq.bodyA.id) === -1) {
            bodies.push(eq.bodyA);
            $093dfe014d5a9292$var$bodyIds.push(eq.bodyA.id);
        }
        if ($093dfe014d5a9292$var$bodyIds.indexOf(eq.bodyB.id) === -1) {
            bodies.push(eq.bodyB);
            $093dfe014d5a9292$var$bodyIds.push(eq.bodyB.id);
        }
    }
    return bodies;
};
/**
 * Check if the entire island wants to sleep.
 * @method wantsToSleep
 * @return {Boolean}
 */ $093dfe014d5a9292$var$Island.prototype.wantsToSleep = function() {
    for(var i = 0; i < this.bodies.length; i++){
        var b = this.bodies[i];
        if (b.type === $e7hLo.DYNAMIC && !b.wantsToSleep) return false;
    }
    return true;
};
/**
 * Make all bodies in the island sleep.
 * @method sleep
 */ $093dfe014d5a9292$var$Island.prototype.sleep = function() {
    for(var i = 0; i < this.bodies.length; i++){
        var b = this.bodies[i];
        b.sleep();
    }
    return true;
};

});

parcelRegister("41pPr", function(module, exports) {
module.exports = $2edb4a7c51a2c2bf$var$IslandNode;
/**
 * Holds a body and keeps track of some additional properties needed for graph traversal.
 * @class IslandNode
 * @constructor
 * @param {Body} body
 */ function $2edb4a7c51a2c2bf$var$IslandNode(body) {
    /**
	 * The body that is contained in this node.
	 * @property {Body} body
	 */ this.body = body;
    /**
     * Neighboring IslandNodes
     * @property {Array} neighbors
     */ this.neighbors = [];
    /**
     * Equations connected to this node.
     * @property {Array} equations
     */ this.equations = [];
    /**
     * If this node was visiting during the graph traversal.
     * @property visited
     * @type {Boolean}
     */ this.visited = false;
}
/**
 * Clean this node from bodies and equations.
 * @method reset
 */ $2edb4a7c51a2c2bf$var$IslandNode.prototype.reset = function() {
    this.equations.length = 0;
    this.neighbors.length = 0;
    this.visited = false;
    this.body = null;
};

});

parcelRegister("kQdy2", function(module, exports) {

var $41pPr = parcelRequire("41pPr");

var $kaNFS = parcelRequire("kaNFS");
module.exports = $f2c32c4db917f534$var$IslandNodePool;
/**
 * @class
 */ function $f2c32c4db917f534$var$IslandNodePool() {
    $kaNFS.apply(this, arguments);
}
$f2c32c4db917f534$var$IslandNodePool.prototype = new $kaNFS();
$f2c32c4db917f534$var$IslandNodePool.prototype.constructor = $f2c32c4db917f534$var$IslandNodePool;
/**
 * @method create
 * @return {IslandNode}
 */ $f2c32c4db917f534$var$IslandNodePool.prototype.create = function() {
    return new $41pPr();
};
/**
 * @method destroy
 * @param {IslandNode} node
 * @return {IslandNodePool}
 */ $f2c32c4db917f534$var$IslandNodePool.prototype.destroy = function(node) {
    node.reset();
    return this;
};

});

parcelRegister("3HB0m", function(module, exports) {

var $Nc8B5 = parcelRequire("Nc8B5");

var $kaNFS = parcelRequire("kaNFS");
module.exports = $2b22179ccdf77f84$var$IslandPool;
/**
 * @class
 */ function $2b22179ccdf77f84$var$IslandPool() {
    $kaNFS.apply(this, arguments);
}
$2b22179ccdf77f84$var$IslandPool.prototype = new $kaNFS();
$2b22179ccdf77f84$var$IslandPool.prototype.constructor = $2b22179ccdf77f84$var$IslandPool;
/**
 * @method create
 * @return {Island}
 */ $2b22179ccdf77f84$var$IslandPool.prototype.create = function() {
    return new $Nc8B5();
};
/**
 * @method destroy
 * @param {Island} island
 * @return {IslandPool}
 */ $2b22179ccdf77f84$var$IslandPool.prototype.destroy = function(island) {
    island.reset();
    return this;
};

});



parcelRegister("1b2ls", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $0db8a335f84591c1$export$ffb0004e005737fa, (v) => $0db8a335f84591c1$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $0db8a335f84591c1$export$34b9dba7ce09269b, (v) => $0db8a335f84591c1$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $0db8a335f84591c1$export$25062201e9e25d76, (v) => $0db8a335f84591c1$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $0db8a335f84591c1$export$ffb0004e005737fa;
var $0db8a335f84591c1$export$34b9dba7ce09269b;
var $0db8a335f84591c1$export$25062201e9e25d76;
"use strict";

var $acw62 = parcelRequire("acw62");
var $0db8a335f84591c1$var$k = Symbol.for("react.element"), $0db8a335f84591c1$var$l = Symbol.for("react.fragment"), $0db8a335f84591c1$var$m = Object.prototype.hasOwnProperty, $0db8a335f84591c1$var$n = $acw62.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $0db8a335f84591c1$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $0db8a335f84591c1$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$0db8a335f84591c1$var$m.call(a, b) && !$0db8a335f84591c1$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $0db8a335f84591c1$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $0db8a335f84591c1$var$n.current
    };
}
$0db8a335f84591c1$export$ffb0004e005737fa = $0db8a335f84591c1$var$l;
$0db8a335f84591c1$export$34b9dba7ce09269b = $0db8a335f84591c1$var$q;
$0db8a335f84591c1$export$25062201e9e25d76 = $0db8a335f84591c1$var$q;

});
parcelRegister("acw62", function(module, exports) {
"use strict";

module.exports = (parcelRequire("2pUnB"));

});
parcelRegister("2pUnB", function(module, exports) {

$parcel$export(module.exports, "Children", () => $1c29a66706a62afd$export$dca3b0875bd9a954, (v) => $1c29a66706a62afd$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $1c29a66706a62afd$export$16fa2f45be04daa8, (v) => $1c29a66706a62afd$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $1c29a66706a62afd$export$ffb0004e005737fa, (v) => $1c29a66706a62afd$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $1c29a66706a62afd$export$e2c29f18771995cb, (v) => $1c29a66706a62afd$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $1c29a66706a62afd$export$221d75b3f55bb0bd, (v) => $1c29a66706a62afd$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $1c29a66706a62afd$export$5f8d39834fd61797, (v) => $1c29a66706a62afd$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $1c29a66706a62afd$export$74bf444e3cd11ea5, (v) => $1c29a66706a62afd$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $1c29a66706a62afd$export$ae55be85d98224ed, (v) => $1c29a66706a62afd$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "act", () => $1c29a66706a62afd$export$3ba232387fd5d6dd, (v) => $1c29a66706a62afd$export$3ba232387fd5d6dd = v);
$parcel$export(module.exports, "cloneElement", () => $1c29a66706a62afd$export$e530037191fcd5d7, (v) => $1c29a66706a62afd$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $1c29a66706a62afd$export$fd42f52fd3ae1109, (v) => $1c29a66706a62afd$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $1c29a66706a62afd$export$c8a8987d4410bf2d, (v) => $1c29a66706a62afd$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createFactory", () => $1c29a66706a62afd$export$d38cd72104c1f0e9, (v) => $1c29a66706a62afd$export$d38cd72104c1f0e9 = v);
$parcel$export(module.exports, "createRef", () => $1c29a66706a62afd$export$7d1e3a5e95ceca43, (v) => $1c29a66706a62afd$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $1c29a66706a62afd$export$257a8862b851cb5b, (v) => $1c29a66706a62afd$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $1c29a66706a62afd$export$a8257692ac88316c, (v) => $1c29a66706a62afd$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $1c29a66706a62afd$export$488013bae63b21da, (v) => $1c29a66706a62afd$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $1c29a66706a62afd$export$7c73462e0d25e514, (v) => $1c29a66706a62afd$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $1c29a66706a62afd$export$7568632d0d33d16d, (v) => $1c29a66706a62afd$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_act", () => $1c29a66706a62afd$export$88948ce120ea2619, (v) => $1c29a66706a62afd$export$88948ce120ea2619 = v);
$parcel$export(module.exports, "useCallback", () => $1c29a66706a62afd$export$35808ee640e87ca7, (v) => $1c29a66706a62afd$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $1c29a66706a62afd$export$fae74005e78b1a27, (v) => $1c29a66706a62afd$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $1c29a66706a62afd$export$dc8fbce3eb94dc1e, (v) => $1c29a66706a62afd$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $1c29a66706a62afd$export$6a7bc4e911dc01cf, (v) => $1c29a66706a62afd$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $1c29a66706a62afd$export$6d9c69b0de29b591, (v) => $1c29a66706a62afd$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useId", () => $1c29a66706a62afd$export$f680877a34711e37, (v) => $1c29a66706a62afd$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $1c29a66706a62afd$export$d5a552a76deda3c2, (v) => $1c29a66706a62afd$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $1c29a66706a62afd$export$aaabe4eda9ed9969, (v) => $1c29a66706a62afd$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $1c29a66706a62afd$export$e5c5a5f917a5871c, (v) => $1c29a66706a62afd$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $1c29a66706a62afd$export$1538c33de8887b59, (v) => $1c29a66706a62afd$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useReducer", () => $1c29a66706a62afd$export$13e3392192263954, (v) => $1c29a66706a62afd$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $1c29a66706a62afd$export$b8f5890fc79d6aca, (v) => $1c29a66706a62afd$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $1c29a66706a62afd$export$60241385465d0a34, (v) => $1c29a66706a62afd$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $1c29a66706a62afd$export$306c0aa65ff9ec16, (v) => $1c29a66706a62afd$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $1c29a66706a62afd$export$7b286972b8d8ccbf, (v) => $1c29a66706a62afd$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $1c29a66706a62afd$export$83d89fbfd8236492, (v) => $1c29a66706a62afd$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $1c29a66706a62afd$export$dca3b0875bd9a954;
var $1c29a66706a62afd$export$16fa2f45be04daa8;
var $1c29a66706a62afd$export$ffb0004e005737fa;
var $1c29a66706a62afd$export$e2c29f18771995cb;
var $1c29a66706a62afd$export$221d75b3f55bb0bd;
var $1c29a66706a62afd$export$5f8d39834fd61797;
var $1c29a66706a62afd$export$74bf444e3cd11ea5;
var $1c29a66706a62afd$export$ae55be85d98224ed;
var $1c29a66706a62afd$export$3ba232387fd5d6dd;
var $1c29a66706a62afd$export$e530037191fcd5d7;
var $1c29a66706a62afd$export$fd42f52fd3ae1109;
var $1c29a66706a62afd$export$c8a8987d4410bf2d;
var $1c29a66706a62afd$export$d38cd72104c1f0e9;
var $1c29a66706a62afd$export$7d1e3a5e95ceca43;
var $1c29a66706a62afd$export$257a8862b851cb5b;
var $1c29a66706a62afd$export$a8257692ac88316c;
var $1c29a66706a62afd$export$488013bae63b21da;
var $1c29a66706a62afd$export$7c73462e0d25e514;
var $1c29a66706a62afd$export$7568632d0d33d16d;
var $1c29a66706a62afd$export$88948ce120ea2619;
var $1c29a66706a62afd$export$35808ee640e87ca7;
var $1c29a66706a62afd$export$fae74005e78b1a27;
var $1c29a66706a62afd$export$dc8fbce3eb94dc1e;
var $1c29a66706a62afd$export$6a7bc4e911dc01cf;
var $1c29a66706a62afd$export$6d9c69b0de29b591;
var $1c29a66706a62afd$export$f680877a34711e37;
var $1c29a66706a62afd$export$d5a552a76deda3c2;
var $1c29a66706a62afd$export$aaabe4eda9ed9969;
var $1c29a66706a62afd$export$e5c5a5f917a5871c;
var $1c29a66706a62afd$export$1538c33de8887b59;
var $1c29a66706a62afd$export$13e3392192263954;
var $1c29a66706a62afd$export$b8f5890fc79d6aca;
var $1c29a66706a62afd$export$60241385465d0a34;
var $1c29a66706a62afd$export$306c0aa65ff9ec16;
var $1c29a66706a62afd$export$7b286972b8d8ccbf;
var $1c29a66706a62afd$export$83d89fbfd8236492;
"use strict";
var $1c29a66706a62afd$var$l = Symbol.for("react.element"), $1c29a66706a62afd$var$n = Symbol.for("react.portal"), $1c29a66706a62afd$var$p = Symbol.for("react.fragment"), $1c29a66706a62afd$var$q = Symbol.for("react.strict_mode"), $1c29a66706a62afd$var$r = Symbol.for("react.profiler"), $1c29a66706a62afd$var$t = Symbol.for("react.provider"), $1c29a66706a62afd$var$u = Symbol.for("react.context"), $1c29a66706a62afd$var$v = Symbol.for("react.forward_ref"), $1c29a66706a62afd$var$w = Symbol.for("react.suspense"), $1c29a66706a62afd$var$x = Symbol.for("react.memo"), $1c29a66706a62afd$var$y = Symbol.for("react.lazy"), $1c29a66706a62afd$var$z = Symbol.iterator;
function $1c29a66706a62afd$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $1c29a66706a62afd$var$z && a[$1c29a66706a62afd$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $1c29a66706a62afd$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $1c29a66706a62afd$var$C = Object.assign, $1c29a66706a62afd$var$D = {};
function $1c29a66706a62afd$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $1c29a66706a62afd$var$D;
    this.updater = e || $1c29a66706a62afd$var$B;
}
$1c29a66706a62afd$var$E.prototype.isReactComponent = {};
$1c29a66706a62afd$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$1c29a66706a62afd$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $1c29a66706a62afd$var$F() {}
$1c29a66706a62afd$var$F.prototype = $1c29a66706a62afd$var$E.prototype;
function $1c29a66706a62afd$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $1c29a66706a62afd$var$D;
    this.updater = e || $1c29a66706a62afd$var$B;
}
var $1c29a66706a62afd$var$H = $1c29a66706a62afd$var$G.prototype = new $1c29a66706a62afd$var$F;
$1c29a66706a62afd$var$H.constructor = $1c29a66706a62afd$var$G;
$1c29a66706a62afd$var$C($1c29a66706a62afd$var$H, $1c29a66706a62afd$var$E.prototype);
$1c29a66706a62afd$var$H.isPureReactComponent = !0;
var $1c29a66706a62afd$var$I = Array.isArray, $1c29a66706a62afd$var$J = Object.prototype.hasOwnProperty, $1c29a66706a62afd$var$K = {
    current: null
}, $1c29a66706a62afd$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $1c29a66706a62afd$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$1c29a66706a62afd$var$J.call(b, d) && !$1c29a66706a62afd$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $1c29a66706a62afd$var$K.current
    };
}
function $1c29a66706a62afd$var$N(a, b) {
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $1c29a66706a62afd$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $1c29a66706a62afd$var$l;
}
function $1c29a66706a62afd$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $1c29a66706a62afd$var$P = /\/+/g;
function $1c29a66706a62afd$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $1c29a66706a62afd$var$escape("" + a.key) : b.toString(36);
}
function $1c29a66706a62afd$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $1c29a66706a62afd$var$l:
                case $1c29a66706a62afd$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $1c29a66706a62afd$var$Q(h, 0) : d, $1c29a66706a62afd$var$I(c) ? (e = "", null != a && (e = a.replace($1c29a66706a62afd$var$P, "$&/") + "/"), $1c29a66706a62afd$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($1c29a66706a62afd$var$O(c) && (c = $1c29a66706a62afd$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($1c29a66706a62afd$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($1c29a66706a62afd$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $1c29a66706a62afd$var$Q(k, g);
        h += $1c29a66706a62afd$var$R(k, b, e, f, c);
    }
    else if (f = $1c29a66706a62afd$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $1c29a66706a62afd$var$Q(k, g++), h += $1c29a66706a62afd$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $1c29a66706a62afd$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $1c29a66706a62afd$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $1c29a66706a62afd$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $1c29a66706a62afd$var$U = {
    current: null
}, $1c29a66706a62afd$var$V = {
    transition: null
}, $1c29a66706a62afd$var$W = {
    ReactCurrentDispatcher: $1c29a66706a62afd$var$U,
    ReactCurrentBatchConfig: $1c29a66706a62afd$var$V,
    ReactCurrentOwner: $1c29a66706a62afd$var$K
};
function $1c29a66706a62afd$var$X() {
    throw Error("act(...) is not supported in production builds of React.");
}
$1c29a66706a62afd$export$dca3b0875bd9a954 = {
    map: $1c29a66706a62afd$var$S,
    forEach: function(a, b, e) {
        $1c29a66706a62afd$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $1c29a66706a62afd$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $1c29a66706a62afd$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$1c29a66706a62afd$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$1c29a66706a62afd$export$16fa2f45be04daa8 = $1c29a66706a62afd$var$E;
$1c29a66706a62afd$export$ffb0004e005737fa = $1c29a66706a62afd$var$p;
$1c29a66706a62afd$export$e2c29f18771995cb = $1c29a66706a62afd$var$r;
$1c29a66706a62afd$export$221d75b3f55bb0bd = $1c29a66706a62afd$var$G;
$1c29a66706a62afd$export$5f8d39834fd61797 = $1c29a66706a62afd$var$q;
$1c29a66706a62afd$export$74bf444e3cd11ea5 = $1c29a66706a62afd$var$w;
$1c29a66706a62afd$export$ae55be85d98224ed = $1c29a66706a62afd$var$W;
$1c29a66706a62afd$export$3ba232387fd5d6dd = $1c29a66706a62afd$var$X;
$1c29a66706a62afd$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $1c29a66706a62afd$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $1c29a66706a62afd$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$1c29a66706a62afd$var$J.call(b, f) && !$1c29a66706a62afd$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$1c29a66706a62afd$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $1c29a66706a62afd$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $1c29a66706a62afd$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$1c29a66706a62afd$export$c8a8987d4410bf2d = $1c29a66706a62afd$var$M;
$1c29a66706a62afd$export$d38cd72104c1f0e9 = function(a) {
    var b = $1c29a66706a62afd$var$M.bind(null, a);
    b.type = a;
    return b;
};
$1c29a66706a62afd$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$1c29a66706a62afd$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $1c29a66706a62afd$var$v,
        render: a
    };
};
$1c29a66706a62afd$export$a8257692ac88316c = $1c29a66706a62afd$var$O;
$1c29a66706a62afd$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $1c29a66706a62afd$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $1c29a66706a62afd$var$T
    };
};
$1c29a66706a62afd$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $1c29a66706a62afd$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$1c29a66706a62afd$export$7568632d0d33d16d = function(a) {
    var b = $1c29a66706a62afd$var$V.transition;
    $1c29a66706a62afd$var$V.transition = {};
    try {
        a();
    } finally{
        $1c29a66706a62afd$var$V.transition = b;
    }
};
$1c29a66706a62afd$export$88948ce120ea2619 = $1c29a66706a62afd$var$X;
$1c29a66706a62afd$export$35808ee640e87ca7 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useCallback(a, b);
};
$1c29a66706a62afd$export$fae74005e78b1a27 = function(a) {
    return $1c29a66706a62afd$var$U.current.useContext(a);
};
$1c29a66706a62afd$export$dc8fbce3eb94dc1e = function() {};
$1c29a66706a62afd$export$6a7bc4e911dc01cf = function(a) {
    return $1c29a66706a62afd$var$U.current.useDeferredValue(a);
};
$1c29a66706a62afd$export$6d9c69b0de29b591 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useEffect(a, b);
};
$1c29a66706a62afd$export$f680877a34711e37 = function() {
    return $1c29a66706a62afd$var$U.current.useId();
};
$1c29a66706a62afd$export$d5a552a76deda3c2 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useImperativeHandle(a, b, e);
};
$1c29a66706a62afd$export$aaabe4eda9ed9969 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useInsertionEffect(a, b);
};
$1c29a66706a62afd$export$e5c5a5f917a5871c = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useLayoutEffect(a, b);
};
$1c29a66706a62afd$export$1538c33de8887b59 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useMemo(a, b);
};
$1c29a66706a62afd$export$13e3392192263954 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useReducer(a, b, e);
};
$1c29a66706a62afd$export$b8f5890fc79d6aca = function(a) {
    return $1c29a66706a62afd$var$U.current.useRef(a);
};
$1c29a66706a62afd$export$60241385465d0a34 = function(a) {
    return $1c29a66706a62afd$var$U.current.useState(a);
};
$1c29a66706a62afd$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useSyncExternalStore(a, b, e);
};
$1c29a66706a62afd$export$7b286972b8d8ccbf = function() {
    return $1c29a66706a62afd$var$U.current.useTransition();
};
$1c29a66706a62afd$export$83d89fbfd8236492 = "18.3.1";

});



parcelRegister("Xw6Mv", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $0b2e6adb871a3b94$export$ae55be85d98224ed, (v) => $0b2e6adb871a3b94$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "createPortal", () => $0b2e6adb871a3b94$export$d39a5bbd09211389, (v) => $0b2e6adb871a3b94$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "createRoot", () => $0b2e6adb871a3b94$export$882461b6382ed46c, (v) => $0b2e6adb871a3b94$export$882461b6382ed46c = v);
$parcel$export(module.exports, "findDOMNode", () => $0b2e6adb871a3b94$export$466bfc07425424d5, (v) => $0b2e6adb871a3b94$export$466bfc07425424d5 = v);
$parcel$export(module.exports, "flushSync", () => $0b2e6adb871a3b94$export$cd75ccfd720a3cd4, (v) => $0b2e6adb871a3b94$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "hydrate", () => $0b2e6adb871a3b94$export$fa8d919ba61d84db, (v) => $0b2e6adb871a3b94$export$fa8d919ba61d84db = v);
$parcel$export(module.exports, "hydrateRoot", () => $0b2e6adb871a3b94$export$757ceba2d55c277e, (v) => $0b2e6adb871a3b94$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "render", () => $0b2e6adb871a3b94$export$b3890eb0ae9dca99, (v) => $0b2e6adb871a3b94$export$b3890eb0ae9dca99 = v);
$parcel$export(module.exports, "unmountComponentAtNode", () => $0b2e6adb871a3b94$export$502457920280e6be, (v) => $0b2e6adb871a3b94$export$502457920280e6be = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $0b2e6adb871a3b94$export$c78a37762a8d58e1, (v) => $0b2e6adb871a3b94$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", () => $0b2e6adb871a3b94$export$dc54d992c10e8a18, (v) => $0b2e6adb871a3b94$export$dc54d992c10e8a18 = v);
$parcel$export(module.exports, "version", () => $0b2e6adb871a3b94$export$83d89fbfd8236492, (v) => $0b2e6adb871a3b94$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $0b2e6adb871a3b94$export$ae55be85d98224ed;
var $0b2e6adb871a3b94$export$d39a5bbd09211389;
var $0b2e6adb871a3b94$export$882461b6382ed46c;
var $0b2e6adb871a3b94$export$466bfc07425424d5;
var $0b2e6adb871a3b94$export$cd75ccfd720a3cd4;
var $0b2e6adb871a3b94$export$fa8d919ba61d84db;
var $0b2e6adb871a3b94$export$757ceba2d55c277e;
var $0b2e6adb871a3b94$export$b3890eb0ae9dca99;
var $0b2e6adb871a3b94$export$502457920280e6be;
var $0b2e6adb871a3b94$export$c78a37762a8d58e1;
var $0b2e6adb871a3b94$export$dc54d992c10e8a18;
var $0b2e6adb871a3b94$export$83d89fbfd8236492;
"use strict";

var $acw62 = parcelRequire("acw62");

var $fO90s = parcelRequire("fO90s");
function $0b2e6adb871a3b94$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $0b2e6adb871a3b94$var$da = new Set, $0b2e6adb871a3b94$var$ea = {};
function $0b2e6adb871a3b94$var$fa(a, b) {
    $0b2e6adb871a3b94$var$ha(a, b);
    $0b2e6adb871a3b94$var$ha(a + "Capture", b);
}
function $0b2e6adb871a3b94$var$ha(a, b) {
    $0b2e6adb871a3b94$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$0b2e6adb871a3b94$var$da.add(b[a]);
}
var $0b2e6adb871a3b94$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $0b2e6adb871a3b94$var$ja = Object.prototype.hasOwnProperty, $0b2e6adb871a3b94$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $0b2e6adb871a3b94$var$la = {}, $0b2e6adb871a3b94$var$ma = {};
function $0b2e6adb871a3b94$var$oa(a) {
    if ($0b2e6adb871a3b94$var$ja.call($0b2e6adb871a3b94$var$ma, a)) return !0;
    if ($0b2e6adb871a3b94$var$ja.call($0b2e6adb871a3b94$var$la, a)) return !1;
    if ($0b2e6adb871a3b94$var$ka.test(a)) return $0b2e6adb871a3b94$var$ma[a] = !0;
    $0b2e6adb871a3b94$var$la[a] = !0;
    return !1;
}
function $0b2e6adb871a3b94$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $0b2e6adb871a3b94$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $0b2e6adb871a3b94$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $0b2e6adb871a3b94$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $0b2e6adb871a3b94$var$ra = /[\-:]([a-z])/g;
function $0b2e6adb871a3b94$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$0b2e6adb871a3b94$var$z.xlinkHref = new $0b2e6adb871a3b94$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $0b2e6adb871a3b94$var$ta(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$z.hasOwnProperty(b) ? $0b2e6adb871a3b94$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $0b2e6adb871a3b94$var$qa(b, c, e, d) && (c = null), d || null === e ? $0b2e6adb871a3b94$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $0b2e6adb871a3b94$var$ua = $acw62.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $0b2e6adb871a3b94$var$va = Symbol.for("react.element"), $0b2e6adb871a3b94$var$wa = Symbol.for("react.portal"), $0b2e6adb871a3b94$var$ya = Symbol.for("react.fragment"), $0b2e6adb871a3b94$var$za = Symbol.for("react.strict_mode"), $0b2e6adb871a3b94$var$Aa = Symbol.for("react.profiler"), $0b2e6adb871a3b94$var$Ba = Symbol.for("react.provider"), $0b2e6adb871a3b94$var$Ca = Symbol.for("react.context"), $0b2e6adb871a3b94$var$Da = Symbol.for("react.forward_ref"), $0b2e6adb871a3b94$var$Ea = Symbol.for("react.suspense"), $0b2e6adb871a3b94$var$Fa = Symbol.for("react.suspense_list"), $0b2e6adb871a3b94$var$Ga = Symbol.for("react.memo"), $0b2e6adb871a3b94$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $0b2e6adb871a3b94$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $0b2e6adb871a3b94$var$Ja = Symbol.iterator;
function $0b2e6adb871a3b94$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $0b2e6adb871a3b94$var$Ja && a[$0b2e6adb871a3b94$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $0b2e6adb871a3b94$var$A = Object.assign, $0b2e6adb871a3b94$var$La;
function $0b2e6adb871a3b94$var$Ma(a) {
    if (void 0 === $0b2e6adb871a3b94$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $0b2e6adb871a3b94$var$La = b && b[1] || "";
    }
    return "\n" + $0b2e6adb871a3b94$var$La + a;
}
var $0b2e6adb871a3b94$var$Na = !1;
function $0b2e6adb871a3b94$var$Oa(a, b) {
    if (!a || $0b2e6adb871a3b94$var$Na) return "";
    $0b2e6adb871a3b94$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $0b2e6adb871a3b94$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $0b2e6adb871a3b94$var$Ma(a) : "";
}
function $0b2e6adb871a3b94$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $0b2e6adb871a3b94$var$Ma(a.type);
        case 16:
            return $0b2e6adb871a3b94$var$Ma("Lazy");
        case 13:
            return $0b2e6adb871a3b94$var$Ma("Suspense");
        case 19:
            return $0b2e6adb871a3b94$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $0b2e6adb871a3b94$var$Oa(a.type, !1), a;
        case 11:
            return a = $0b2e6adb871a3b94$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $0b2e6adb871a3b94$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $0b2e6adb871a3b94$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $0b2e6adb871a3b94$var$ya:
            return "Fragment";
        case $0b2e6adb871a3b94$var$wa:
            return "Portal";
        case $0b2e6adb871a3b94$var$Aa:
            return "Profiler";
        case $0b2e6adb871a3b94$var$za:
            return "StrictMode";
        case $0b2e6adb871a3b94$var$Ea:
            return "Suspense";
        case $0b2e6adb871a3b94$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $0b2e6adb871a3b94$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $0b2e6adb871a3b94$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $0b2e6adb871a3b94$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $0b2e6adb871a3b94$var$Ga:
            return b = a.displayName || null, null !== b ? b : $0b2e6adb871a3b94$var$Qa(a.type) || "Memo";
        case $0b2e6adb871a3b94$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $0b2e6adb871a3b94$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $0b2e6adb871a3b94$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $0b2e6adb871a3b94$var$Qa(b);
        case 8:
            return b === $0b2e6adb871a3b94$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $0b2e6adb871a3b94$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $0b2e6adb871a3b94$var$Ua(a) {
    var b = $0b2e6adb871a3b94$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $0b2e6adb871a3b94$var$Va(a) {
    a._valueTracker || (a._valueTracker = $0b2e6adb871a3b94$var$Ua(a));
}
function $0b2e6adb871a3b94$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $0b2e6adb871a3b94$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $0b2e6adb871a3b94$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $0b2e6adb871a3b94$var$Ya(a, b) {
    var c = b.checked;
    return $0b2e6adb871a3b94$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $0b2e6adb871a3b94$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $0b2e6adb871a3b94$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $0b2e6adb871a3b94$var$ab(a, b) {
    b = b.checked;
    null != b && $0b2e6adb871a3b94$var$ta(a, "checked", b, !1);
}
function $0b2e6adb871a3b94$var$bb(a, b) {
    $0b2e6adb871a3b94$var$ab(a, b);
    var c = $0b2e6adb871a3b94$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $0b2e6adb871a3b94$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $0b2e6adb871a3b94$var$cb(a, b.type, $0b2e6adb871a3b94$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $0b2e6adb871a3b94$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $0b2e6adb871a3b94$var$cb(a, b, c) {
    if ("number" !== b || $0b2e6adb871a3b94$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $0b2e6adb871a3b94$var$eb = Array.isArray;
function $0b2e6adb871a3b94$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $0b2e6adb871a3b94$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $0b2e6adb871a3b94$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($0b2e6adb871a3b94$var$p(91));
    return $0b2e6adb871a3b94$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $0b2e6adb871a3b94$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($0b2e6adb871a3b94$var$p(92));
            if ($0b2e6adb871a3b94$var$eb(c)) {
                if (1 < c.length) throw Error($0b2e6adb871a3b94$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $0b2e6adb871a3b94$var$Sa(c)
    };
}
function $0b2e6adb871a3b94$var$ib(a, b) {
    var c = $0b2e6adb871a3b94$var$Sa(b.value), d = $0b2e6adb871a3b94$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $0b2e6adb871a3b94$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $0b2e6adb871a3b94$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $0b2e6adb871a3b94$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $0b2e6adb871a3b94$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $0b2e6adb871a3b94$var$mb, $0b2e6adb871a3b94$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $0b2e6adb871a3b94$var$mb = $0b2e6adb871a3b94$var$mb || document.createElement("div");
        $0b2e6adb871a3b94$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $0b2e6adb871a3b94$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $0b2e6adb871a3b94$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $0b2e6adb871a3b94$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $0b2e6adb871a3b94$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($0b2e6adb871a3b94$var$pb).forEach(function(a) {
    $0b2e6adb871a3b94$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $0b2e6adb871a3b94$var$pb[b] = $0b2e6adb871a3b94$var$pb[a];
    });
});
function $0b2e6adb871a3b94$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $0b2e6adb871a3b94$var$pb.hasOwnProperty(a) && $0b2e6adb871a3b94$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $0b2e6adb871a3b94$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $0b2e6adb871a3b94$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $0b2e6adb871a3b94$var$tb = $0b2e6adb871a3b94$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $0b2e6adb871a3b94$var$ub(a, b) {
    if (b) {
        if ($0b2e6adb871a3b94$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($0b2e6adb871a3b94$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($0b2e6adb871a3b94$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($0b2e6adb871a3b94$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($0b2e6adb871a3b94$var$p(62));
    }
}
function $0b2e6adb871a3b94$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $0b2e6adb871a3b94$var$wb = null;
function $0b2e6adb871a3b94$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $0b2e6adb871a3b94$var$yb = null, $0b2e6adb871a3b94$var$zb = null, $0b2e6adb871a3b94$var$Ab = null;
function $0b2e6adb871a3b94$var$Bb(a) {
    if (a = $0b2e6adb871a3b94$var$Cb(a)) {
        if ("function" !== typeof $0b2e6adb871a3b94$var$yb) throw Error($0b2e6adb871a3b94$var$p(280));
        var b = a.stateNode;
        b && (b = $0b2e6adb871a3b94$var$Db(b), $0b2e6adb871a3b94$var$yb(a.stateNode, a.type, b));
    }
}
function $0b2e6adb871a3b94$var$Eb(a) {
    $0b2e6adb871a3b94$var$zb ? $0b2e6adb871a3b94$var$Ab ? $0b2e6adb871a3b94$var$Ab.push(a) : $0b2e6adb871a3b94$var$Ab = [
        a
    ] : $0b2e6adb871a3b94$var$zb = a;
}
function $0b2e6adb871a3b94$var$Fb() {
    if ($0b2e6adb871a3b94$var$zb) {
        var a = $0b2e6adb871a3b94$var$zb, b = $0b2e6adb871a3b94$var$Ab;
        $0b2e6adb871a3b94$var$Ab = $0b2e6adb871a3b94$var$zb = null;
        $0b2e6adb871a3b94$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$0b2e6adb871a3b94$var$Bb(b[a]);
    }
}
function $0b2e6adb871a3b94$var$Gb(a, b) {
    return a(b);
}
function $0b2e6adb871a3b94$var$Hb() {}
var $0b2e6adb871a3b94$var$Ib = !1;
function $0b2e6adb871a3b94$var$Jb(a, b, c) {
    if ($0b2e6adb871a3b94$var$Ib) return a(b, c);
    $0b2e6adb871a3b94$var$Ib = !0;
    try {
        return $0b2e6adb871a3b94$var$Gb(a, b, c);
    } finally{
        if ($0b2e6adb871a3b94$var$Ib = !1, null !== $0b2e6adb871a3b94$var$zb || null !== $0b2e6adb871a3b94$var$Ab) $0b2e6adb871a3b94$var$Hb(), $0b2e6adb871a3b94$var$Fb();
    }
}
function $0b2e6adb871a3b94$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $0b2e6adb871a3b94$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($0b2e6adb871a3b94$var$p(231, b, typeof c));
    return c;
}
var $0b2e6adb871a3b94$var$Lb = !1;
if ($0b2e6adb871a3b94$var$ia) try {
    var $0b2e6adb871a3b94$var$Mb = {};
    Object.defineProperty($0b2e6adb871a3b94$var$Mb, "passive", {
        get: function() {
            $0b2e6adb871a3b94$var$Lb = !0;
        }
    });
    window.addEventListener("test", $0b2e6adb871a3b94$var$Mb, $0b2e6adb871a3b94$var$Mb);
    window.removeEventListener("test", $0b2e6adb871a3b94$var$Mb, $0b2e6adb871a3b94$var$Mb);
} catch (a) {
    $0b2e6adb871a3b94$var$Lb = !1;
}
function $0b2e6adb871a3b94$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $0b2e6adb871a3b94$var$Ob = !1, $0b2e6adb871a3b94$var$Pb = null, $0b2e6adb871a3b94$var$Qb = !1, $0b2e6adb871a3b94$var$Rb = null, $0b2e6adb871a3b94$var$Sb = {
    onError: function(a) {
        $0b2e6adb871a3b94$var$Ob = !0;
        $0b2e6adb871a3b94$var$Pb = a;
    }
};
function $0b2e6adb871a3b94$var$Tb(a, b, c, d, e, f, g, h, k) {
    $0b2e6adb871a3b94$var$Ob = !1;
    $0b2e6adb871a3b94$var$Pb = null;
    $0b2e6adb871a3b94$var$Nb.apply($0b2e6adb871a3b94$var$Sb, arguments);
}
function $0b2e6adb871a3b94$var$Ub(a, b, c, d, e, f, g, h, k) {
    $0b2e6adb871a3b94$var$Tb.apply(this, arguments);
    if ($0b2e6adb871a3b94$var$Ob) {
        if ($0b2e6adb871a3b94$var$Ob) {
            var l = $0b2e6adb871a3b94$var$Pb;
            $0b2e6adb871a3b94$var$Ob = !1;
            $0b2e6adb871a3b94$var$Pb = null;
        } else throw Error($0b2e6adb871a3b94$var$p(198));
        $0b2e6adb871a3b94$var$Qb || ($0b2e6adb871a3b94$var$Qb = !0, $0b2e6adb871a3b94$var$Rb = l);
    }
}
function $0b2e6adb871a3b94$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $0b2e6adb871a3b94$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Xb(a) {
    if ($0b2e6adb871a3b94$var$Vb(a) !== a) throw Error($0b2e6adb871a3b94$var$p(188));
}
function $0b2e6adb871a3b94$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $0b2e6adb871a3b94$var$Vb(a);
        if (null === b) throw Error($0b2e6adb871a3b94$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $0b2e6adb871a3b94$var$Xb(e), a;
                if (f === d) return $0b2e6adb871a3b94$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($0b2e6adb871a3b94$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($0b2e6adb871a3b94$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($0b2e6adb871a3b94$var$p(190));
    }
    if (3 !== c.tag) throw Error($0b2e6adb871a3b94$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $0b2e6adb871a3b94$var$Zb(a) {
    a = $0b2e6adb871a3b94$var$Yb(a);
    return null !== a ? $0b2e6adb871a3b94$var$$b(a) : null;
}
function $0b2e6adb871a3b94$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $0b2e6adb871a3b94$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$ac = $fO90s.unstable_scheduleCallback, $0b2e6adb871a3b94$var$bc = $fO90s.unstable_cancelCallback, $0b2e6adb871a3b94$var$cc = $fO90s.unstable_shouldYield, $0b2e6adb871a3b94$var$dc = $fO90s.unstable_requestPaint, $0b2e6adb871a3b94$var$B = $fO90s.unstable_now, $0b2e6adb871a3b94$var$ec = $fO90s.unstable_getCurrentPriorityLevel, $0b2e6adb871a3b94$var$fc = $fO90s.unstable_ImmediatePriority, $0b2e6adb871a3b94$var$gc = $fO90s.unstable_UserBlockingPriority, $0b2e6adb871a3b94$var$hc = $fO90s.unstable_NormalPriority, $0b2e6adb871a3b94$var$ic = $fO90s.unstable_LowPriority, $0b2e6adb871a3b94$var$jc = $fO90s.unstable_IdlePriority, $0b2e6adb871a3b94$var$kc = null, $0b2e6adb871a3b94$var$lc = null;
function $0b2e6adb871a3b94$var$mc(a) {
    if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onCommitFiberRoot) try {
        $0b2e6adb871a3b94$var$lc.onCommitFiberRoot($0b2e6adb871a3b94$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $0b2e6adb871a3b94$var$oc = Math.clz32 ? Math.clz32 : $0b2e6adb871a3b94$var$nc, $0b2e6adb871a3b94$var$pc = Math.log, $0b2e6adb871a3b94$var$qc = Math.LN2;
function $0b2e6adb871a3b94$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($0b2e6adb871a3b94$var$pc(a) / $0b2e6adb871a3b94$var$qc | 0) | 0;
}
var $0b2e6adb871a3b94$var$rc = 64, $0b2e6adb871a3b94$var$sc = 4194304;
function $0b2e6adb871a3b94$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $0b2e6adb871a3b94$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $0b2e6adb871a3b94$var$tc(h) : (f &= g, 0 !== f && (d = $0b2e6adb871a3b94$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $0b2e6adb871a3b94$var$tc(g) : 0 !== f && (d = $0b2e6adb871a3b94$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $0b2e6adb871a3b94$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $0b2e6adb871a3b94$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $0b2e6adb871a3b94$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $0b2e6adb871a3b94$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $0b2e6adb871a3b94$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $0b2e6adb871a3b94$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $0b2e6adb871a3b94$var$yc() {
    var a = $0b2e6adb871a3b94$var$rc;
    $0b2e6adb871a3b94$var$rc <<= 1;
    0 === ($0b2e6adb871a3b94$var$rc & 4194240) && ($0b2e6adb871a3b94$var$rc = 64);
    return a;
}
function $0b2e6adb871a3b94$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $0b2e6adb871a3b94$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $0b2e6adb871a3b94$var$oc(b);
    a[b] = c;
}
function $0b2e6adb871a3b94$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $0b2e6adb871a3b94$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $0b2e6adb871a3b94$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $0b2e6adb871a3b94$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $0b2e6adb871a3b94$var$C = 0;
function $0b2e6adb871a3b94$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $0b2e6adb871a3b94$var$Ec, $0b2e6adb871a3b94$var$Fc, $0b2e6adb871a3b94$var$Gc, $0b2e6adb871a3b94$var$Hc, $0b2e6adb871a3b94$var$Ic, $0b2e6adb871a3b94$var$Jc = !1, $0b2e6adb871a3b94$var$Kc = [], $0b2e6adb871a3b94$var$Lc = null, $0b2e6adb871a3b94$var$Mc = null, $0b2e6adb871a3b94$var$Nc = null, $0b2e6adb871a3b94$var$Oc = new Map, $0b2e6adb871a3b94$var$Pc = new Map, $0b2e6adb871a3b94$var$Qc = [], $0b2e6adb871a3b94$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $0b2e6adb871a3b94$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $0b2e6adb871a3b94$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $0b2e6adb871a3b94$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $0b2e6adb871a3b94$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $0b2e6adb871a3b94$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $0b2e6adb871a3b94$var$Pc.delete(b.pointerId);
    }
}
function $0b2e6adb871a3b94$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $0b2e6adb871a3b94$var$Cb(b), null !== b && $0b2e6adb871a3b94$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $0b2e6adb871a3b94$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $0b2e6adb871a3b94$var$Lc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $0b2e6adb871a3b94$var$Mc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $0b2e6adb871a3b94$var$Nc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $0b2e6adb871a3b94$var$Oc.set(f, $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $0b2e6adb871a3b94$var$Pc.set(f, $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $0b2e6adb871a3b94$var$Vc(a) {
    var b = $0b2e6adb871a3b94$var$Wc(a.target);
    if (null !== b) {
        var c = $0b2e6adb871a3b94$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $0b2e6adb871a3b94$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $0b2e6adb871a3b94$var$Ic(a.priority, function() {
                        $0b2e6adb871a3b94$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $0b2e6adb871a3b94$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $0b2e6adb871a3b94$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $0b2e6adb871a3b94$var$wb = d;
            c.target.dispatchEvent(d);
            $0b2e6adb871a3b94$var$wb = null;
        } else return b = $0b2e6adb871a3b94$var$Cb(c), null !== b && $0b2e6adb871a3b94$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Zc(a, b, c) {
    $0b2e6adb871a3b94$var$Xc(a) && c.delete(b);
}
function $0b2e6adb871a3b94$var$$c() {
    $0b2e6adb871a3b94$var$Jc = !1;
    null !== $0b2e6adb871a3b94$var$Lc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Lc) && ($0b2e6adb871a3b94$var$Lc = null);
    null !== $0b2e6adb871a3b94$var$Mc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Mc) && ($0b2e6adb871a3b94$var$Mc = null);
    null !== $0b2e6adb871a3b94$var$Nc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Nc) && ($0b2e6adb871a3b94$var$Nc = null);
    $0b2e6adb871a3b94$var$Oc.forEach($0b2e6adb871a3b94$var$Zc);
    $0b2e6adb871a3b94$var$Pc.forEach($0b2e6adb871a3b94$var$Zc);
}
function $0b2e6adb871a3b94$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $0b2e6adb871a3b94$var$Jc || ($0b2e6adb871a3b94$var$Jc = !0, $fO90s.unstable_scheduleCallback($fO90s.unstable_NormalPriority, $0b2e6adb871a3b94$var$$c)));
}
function $0b2e6adb871a3b94$var$bd(a) {
    function b(b) {
        return $0b2e6adb871a3b94$var$ad(b, a);
    }
    if (0 < $0b2e6adb871a3b94$var$Kc.length) {
        $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Kc[0], a);
        for(var c = 1; c < $0b2e6adb871a3b94$var$Kc.length; c++){
            var d = $0b2e6adb871a3b94$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $0b2e6adb871a3b94$var$Lc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Lc, a);
    null !== $0b2e6adb871a3b94$var$Mc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Mc, a);
    null !== $0b2e6adb871a3b94$var$Nc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Nc, a);
    $0b2e6adb871a3b94$var$Oc.forEach(b);
    $0b2e6adb871a3b94$var$Pc.forEach(b);
    for(c = 0; c < $0b2e6adb871a3b94$var$Qc.length; c++)d = $0b2e6adb871a3b94$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $0b2e6adb871a3b94$var$Qc.length && (c = $0b2e6adb871a3b94$var$Qc[0], null === c.blockedOn);)$0b2e6adb871a3b94$var$Vc(c), null === c.blockedOn && $0b2e6adb871a3b94$var$Qc.shift();
}
var $0b2e6adb871a3b94$var$cd = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$dd = !0;
function $0b2e6adb871a3b94$var$ed(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$C, f = $0b2e6adb871a3b94$var$cd.transition;
    $0b2e6adb871a3b94$var$cd.transition = null;
    try {
        $0b2e6adb871a3b94$var$C = 1, $0b2e6adb871a3b94$var$fd(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$C = e, $0b2e6adb871a3b94$var$cd.transition = f;
    }
}
function $0b2e6adb871a3b94$var$gd(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$C, f = $0b2e6adb871a3b94$var$cd.transition;
    $0b2e6adb871a3b94$var$cd.transition = null;
    try {
        $0b2e6adb871a3b94$var$C = 4, $0b2e6adb871a3b94$var$fd(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$C = e, $0b2e6adb871a3b94$var$cd.transition = f;
    }
}
function $0b2e6adb871a3b94$var$fd(a, b, c, d) {
    if ($0b2e6adb871a3b94$var$dd) {
        var e = $0b2e6adb871a3b94$var$Yc(a, b, c, d);
        if (null === e) $0b2e6adb871a3b94$var$hd(a, b, d, $0b2e6adb871a3b94$var$id, c), $0b2e6adb871a3b94$var$Sc(a, d);
        else if ($0b2e6adb871a3b94$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($0b2e6adb871a3b94$var$Sc(a, d), b & 4 && -1 < $0b2e6adb871a3b94$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $0b2e6adb871a3b94$var$Cb(e);
                null !== f && $0b2e6adb871a3b94$var$Ec(f);
                f = $0b2e6adb871a3b94$var$Yc(a, b, c, d);
                null === f && $0b2e6adb871a3b94$var$hd(a, b, d, $0b2e6adb871a3b94$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $0b2e6adb871a3b94$var$hd(a, b, d, null, c);
    }
}
var $0b2e6adb871a3b94$var$id = null;
function $0b2e6adb871a3b94$var$Yc(a, b, c, d) {
    $0b2e6adb871a3b94$var$id = null;
    a = $0b2e6adb871a3b94$var$xb(d);
    a = $0b2e6adb871a3b94$var$Wc(a);
    if (null !== a) {
        if (b = $0b2e6adb871a3b94$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $0b2e6adb871a3b94$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $0b2e6adb871a3b94$var$id = a;
    return null;
}
function $0b2e6adb871a3b94$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($0b2e6adb871a3b94$var$ec()){
                case $0b2e6adb871a3b94$var$fc:
                    return 1;
                case $0b2e6adb871a3b94$var$gc:
                    return 4;
                case $0b2e6adb871a3b94$var$hc:
                case $0b2e6adb871a3b94$var$ic:
                    return 16;
                case $0b2e6adb871a3b94$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $0b2e6adb871a3b94$var$kd = null, $0b2e6adb871a3b94$var$ld = null, $0b2e6adb871a3b94$var$md = null;
function $0b2e6adb871a3b94$var$nd() {
    if ($0b2e6adb871a3b94$var$md) return $0b2e6adb871a3b94$var$md;
    var a, b = $0b2e6adb871a3b94$var$ld, c = b.length, d, e = "value" in $0b2e6adb871a3b94$var$kd ? $0b2e6adb871a3b94$var$kd.value : $0b2e6adb871a3b94$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $0b2e6adb871a3b94$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $0b2e6adb871a3b94$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $0b2e6adb871a3b94$var$pd() {
    return !0;
}
function $0b2e6adb871a3b94$var$qd() {
    return !1;
}
function $0b2e6adb871a3b94$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $0b2e6adb871a3b94$var$pd : $0b2e6adb871a3b94$var$qd;
        this.isPropagationStopped = $0b2e6adb871a3b94$var$qd;
        return this;
    }
    $0b2e6adb871a3b94$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $0b2e6adb871a3b94$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $0b2e6adb871a3b94$var$pd);
        },
        persist: function() {},
        isPersistent: $0b2e6adb871a3b94$var$pd
    });
    return b;
}
var $0b2e6adb871a3b94$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $0b2e6adb871a3b94$var$td = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$sd), $0b2e6adb871a3b94$var$ud = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    view: 0,
    detail: 0
}), $0b2e6adb871a3b94$var$vd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$ud), $0b2e6adb871a3b94$var$wd, $0b2e6adb871a3b94$var$xd, $0b2e6adb871a3b94$var$yd, $0b2e6adb871a3b94$var$Ad = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $0b2e6adb871a3b94$var$yd && ($0b2e6adb871a3b94$var$yd && "mousemove" === a.type ? ($0b2e6adb871a3b94$var$wd = a.screenX - $0b2e6adb871a3b94$var$yd.screenX, $0b2e6adb871a3b94$var$xd = a.screenY - $0b2e6adb871a3b94$var$yd.screenY) : $0b2e6adb871a3b94$var$xd = $0b2e6adb871a3b94$var$wd = 0, $0b2e6adb871a3b94$var$yd = a);
        return $0b2e6adb871a3b94$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $0b2e6adb871a3b94$var$xd;
    }
}), $0b2e6adb871a3b94$var$Bd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ad), $0b2e6adb871a3b94$var$Cd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    dataTransfer: 0
}), $0b2e6adb871a3b94$var$Dd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Cd), $0b2e6adb871a3b94$var$Ed = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    relatedTarget: 0
}), $0b2e6adb871a3b94$var$Fd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ed), $0b2e6adb871a3b94$var$Gd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $0b2e6adb871a3b94$var$Hd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Gd), $0b2e6adb871a3b94$var$Id = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $0b2e6adb871a3b94$var$Jd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Id), $0b2e6adb871a3b94$var$Kd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    data: 0
}), $0b2e6adb871a3b94$var$Ld = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Kd), $0b2e6adb871a3b94$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $0b2e6adb871a3b94$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $0b2e6adb871a3b94$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $0b2e6adb871a3b94$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $0b2e6adb871a3b94$var$Od[a]) ? !!b[a] : !1;
}
function $0b2e6adb871a3b94$var$zd() {
    return $0b2e6adb871a3b94$var$Pd;
}
var $0b2e6adb871a3b94$var$Qd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $0b2e6adb871a3b94$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $0b2e6adb871a3b94$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $0b2e6adb871a3b94$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $0b2e6adb871a3b94$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $0b2e6adb871a3b94$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $0b2e6adb871a3b94$var$Rd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Qd), $0b2e6adb871a3b94$var$Sd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $0b2e6adb871a3b94$var$Td = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Sd), $0b2e6adb871a3b94$var$Ud = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd
}), $0b2e6adb871a3b94$var$Vd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ud), $0b2e6adb871a3b94$var$Wd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $0b2e6adb871a3b94$var$Xd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Wd), $0b2e6adb871a3b94$var$Yd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $0b2e6adb871a3b94$var$Zd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Yd), $0b2e6adb871a3b94$var$$d = [
    9,
    13,
    27,
    32
], $0b2e6adb871a3b94$var$ae = $0b2e6adb871a3b94$var$ia && "CompositionEvent" in window, $0b2e6adb871a3b94$var$be = null;
$0b2e6adb871a3b94$var$ia && "documentMode" in document && ($0b2e6adb871a3b94$var$be = document.documentMode);
var $0b2e6adb871a3b94$var$ce = $0b2e6adb871a3b94$var$ia && "TextEvent" in window && !$0b2e6adb871a3b94$var$be, $0b2e6adb871a3b94$var$de = $0b2e6adb871a3b94$var$ia && (!$0b2e6adb871a3b94$var$ae || $0b2e6adb871a3b94$var$be && 8 < $0b2e6adb871a3b94$var$be && 11 >= $0b2e6adb871a3b94$var$be), $0b2e6adb871a3b94$var$ee = String.fromCharCode(32), $0b2e6adb871a3b94$var$fe = !1;
function $0b2e6adb871a3b94$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $0b2e6adb871a3b94$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $0b2e6adb871a3b94$var$ie = !1;
function $0b2e6adb871a3b94$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $0b2e6adb871a3b94$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $0b2e6adb871a3b94$var$fe = !0;
            return $0b2e6adb871a3b94$var$ee;
        case "textInput":
            return a = b.data, a === $0b2e6adb871a3b94$var$ee && $0b2e6adb871a3b94$var$fe ? null : a;
        default:
            return null;
    }
}
function $0b2e6adb871a3b94$var$ke(a, b) {
    if ($0b2e6adb871a3b94$var$ie) return "compositionend" === a || !$0b2e6adb871a3b94$var$ae && $0b2e6adb871a3b94$var$ge(a, b) ? (a = $0b2e6adb871a3b94$var$nd(), $0b2e6adb871a3b94$var$md = $0b2e6adb871a3b94$var$ld = $0b2e6adb871a3b94$var$kd = null, $0b2e6adb871a3b94$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $0b2e6adb871a3b94$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $0b2e6adb871a3b94$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $0b2e6adb871a3b94$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$0b2e6adb871a3b94$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $0b2e6adb871a3b94$var$ne(a, b, c, d) {
    $0b2e6adb871a3b94$var$Eb(d);
    b = $0b2e6adb871a3b94$var$oe(b, "onChange");
    0 < b.length && (c = new $0b2e6adb871a3b94$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $0b2e6adb871a3b94$var$pe = null, $0b2e6adb871a3b94$var$qe = null;
function $0b2e6adb871a3b94$var$re(a) {
    $0b2e6adb871a3b94$var$se(a, 0);
}
function $0b2e6adb871a3b94$var$te(a) {
    var b = $0b2e6adb871a3b94$var$ue(a);
    if ($0b2e6adb871a3b94$var$Wa(b)) return a;
}
function $0b2e6adb871a3b94$var$ve(a, b) {
    if ("change" === a) return b;
}
var $0b2e6adb871a3b94$var$we = !1;
if ($0b2e6adb871a3b94$var$ia) {
    var $0b2e6adb871a3b94$var$xe;
    if ($0b2e6adb871a3b94$var$ia) {
        var $0b2e6adb871a3b94$var$ye = "oninput" in document;
        if (!$0b2e6adb871a3b94$var$ye) {
            var $0b2e6adb871a3b94$var$ze = document.createElement("div");
            $0b2e6adb871a3b94$var$ze.setAttribute("oninput", "return;");
            $0b2e6adb871a3b94$var$ye = "function" === typeof $0b2e6adb871a3b94$var$ze.oninput;
        }
        $0b2e6adb871a3b94$var$xe = $0b2e6adb871a3b94$var$ye;
    } else $0b2e6adb871a3b94$var$xe = !1;
    $0b2e6adb871a3b94$var$we = $0b2e6adb871a3b94$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $0b2e6adb871a3b94$var$Ae() {
    $0b2e6adb871a3b94$var$pe && ($0b2e6adb871a3b94$var$pe.detachEvent("onpropertychange", $0b2e6adb871a3b94$var$Be), $0b2e6adb871a3b94$var$qe = $0b2e6adb871a3b94$var$pe = null);
}
function $0b2e6adb871a3b94$var$Be(a) {
    if ("value" === a.propertyName && $0b2e6adb871a3b94$var$te($0b2e6adb871a3b94$var$qe)) {
        var b = [];
        $0b2e6adb871a3b94$var$ne(b, $0b2e6adb871a3b94$var$qe, a, $0b2e6adb871a3b94$var$xb(a));
        $0b2e6adb871a3b94$var$Jb($0b2e6adb871a3b94$var$re, b);
    }
}
function $0b2e6adb871a3b94$var$Ce(a, b, c) {
    "focusin" === a ? ($0b2e6adb871a3b94$var$Ae(), $0b2e6adb871a3b94$var$pe = b, $0b2e6adb871a3b94$var$qe = c, $0b2e6adb871a3b94$var$pe.attachEvent("onpropertychange", $0b2e6adb871a3b94$var$Be)) : "focusout" === a && $0b2e6adb871a3b94$var$Ae();
}
function $0b2e6adb871a3b94$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $0b2e6adb871a3b94$var$te($0b2e6adb871a3b94$var$qe);
}
function $0b2e6adb871a3b94$var$Ee(a, b) {
    if ("click" === a) return $0b2e6adb871a3b94$var$te(b);
}
function $0b2e6adb871a3b94$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $0b2e6adb871a3b94$var$te(b);
}
function $0b2e6adb871a3b94$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $0b2e6adb871a3b94$var$He = "function" === typeof Object.is ? Object.is : $0b2e6adb871a3b94$var$Ge;
function $0b2e6adb871a3b94$var$Ie(a, b) {
    if ($0b2e6adb871a3b94$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$0b2e6adb871a3b94$var$ja.call(b, e) || !$0b2e6adb871a3b94$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $0b2e6adb871a3b94$var$Ke(a, b) {
    var c = $0b2e6adb871a3b94$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $0b2e6adb871a3b94$var$Je(c);
    }
}
function $0b2e6adb871a3b94$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $0b2e6adb871a3b94$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $0b2e6adb871a3b94$var$Me() {
    for(var a = window, b = $0b2e6adb871a3b94$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $0b2e6adb871a3b94$var$Xa(a.document);
    }
    return b;
}
function $0b2e6adb871a3b94$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $0b2e6adb871a3b94$var$Oe(a) {
    var b = $0b2e6adb871a3b94$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $0b2e6adb871a3b94$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $0b2e6adb871a3b94$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $0b2e6adb871a3b94$var$Ke(c, f);
                var g = $0b2e6adb871a3b94$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $0b2e6adb871a3b94$var$Pe = $0b2e6adb871a3b94$var$ia && "documentMode" in document && 11 >= document.documentMode, $0b2e6adb871a3b94$var$Qe = null, $0b2e6adb871a3b94$var$Re = null, $0b2e6adb871a3b94$var$Se = null, $0b2e6adb871a3b94$var$Te = !1;
function $0b2e6adb871a3b94$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $0b2e6adb871a3b94$var$Te || null == $0b2e6adb871a3b94$var$Qe || $0b2e6adb871a3b94$var$Qe !== $0b2e6adb871a3b94$var$Xa(d) || (d = $0b2e6adb871a3b94$var$Qe, "selectionStart" in d && $0b2e6adb871a3b94$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $0b2e6adb871a3b94$var$Se && $0b2e6adb871a3b94$var$Ie($0b2e6adb871a3b94$var$Se, d) || ($0b2e6adb871a3b94$var$Se = d, d = $0b2e6adb871a3b94$var$oe($0b2e6adb871a3b94$var$Re, "onSelect"), 0 < d.length && (b = new $0b2e6adb871a3b94$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $0b2e6adb871a3b94$var$Qe)));
}
function $0b2e6adb871a3b94$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $0b2e6adb871a3b94$var$We = {
    animationend: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationIteration"),
    animationstart: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationStart"),
    transitionend: $0b2e6adb871a3b94$var$Ve("Transition", "TransitionEnd")
}, $0b2e6adb871a3b94$var$Xe = {}, $0b2e6adb871a3b94$var$Ye = {};
$0b2e6adb871a3b94$var$ia && ($0b2e6adb871a3b94$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $0b2e6adb871a3b94$var$We.animationend.animation, delete $0b2e6adb871a3b94$var$We.animationiteration.animation, delete $0b2e6adb871a3b94$var$We.animationstart.animation), "TransitionEvent" in window || delete $0b2e6adb871a3b94$var$We.transitionend.transition);
function $0b2e6adb871a3b94$var$Ze(a) {
    if ($0b2e6adb871a3b94$var$Xe[a]) return $0b2e6adb871a3b94$var$Xe[a];
    if (!$0b2e6adb871a3b94$var$We[a]) return a;
    var b = $0b2e6adb871a3b94$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $0b2e6adb871a3b94$var$Ye) return $0b2e6adb871a3b94$var$Xe[a] = b[c];
    return a;
}
var $0b2e6adb871a3b94$var$$e = $0b2e6adb871a3b94$var$Ze("animationend"), $0b2e6adb871a3b94$var$af = $0b2e6adb871a3b94$var$Ze("animationiteration"), $0b2e6adb871a3b94$var$bf = $0b2e6adb871a3b94$var$Ze("animationstart"), $0b2e6adb871a3b94$var$cf = $0b2e6adb871a3b94$var$Ze("transitionend"), $0b2e6adb871a3b94$var$df = new Map, $0b2e6adb871a3b94$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $0b2e6adb871a3b94$var$ff(a, b) {
    $0b2e6adb871a3b94$var$df.set(a, b);
    $0b2e6adb871a3b94$var$fa(b, [
        a
    ]);
}
for(var $0b2e6adb871a3b94$var$gf = 0; $0b2e6adb871a3b94$var$gf < $0b2e6adb871a3b94$var$ef.length; $0b2e6adb871a3b94$var$gf++){
    var $0b2e6adb871a3b94$var$hf = $0b2e6adb871a3b94$var$ef[$0b2e6adb871a3b94$var$gf], $0b2e6adb871a3b94$var$jf = $0b2e6adb871a3b94$var$hf.toLowerCase(), $0b2e6adb871a3b94$var$kf = $0b2e6adb871a3b94$var$hf[0].toUpperCase() + $0b2e6adb871a3b94$var$hf.slice(1);
    $0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$jf, "on" + $0b2e6adb871a3b94$var$kf);
}
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$$e, "onAnimationEnd");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$af, "onAnimationIteration");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$bf, "onAnimationStart");
$0b2e6adb871a3b94$var$ff("dblclick", "onDoubleClick");
$0b2e6adb871a3b94$var$ff("focusin", "onFocus");
$0b2e6adb871a3b94$var$ff("focusout", "onBlur");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$cf, "onTransitionEnd");
$0b2e6adb871a3b94$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$0b2e6adb871a3b94$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$0b2e6adb871a3b94$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$0b2e6adb871a3b94$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$0b2e6adb871a3b94$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$0b2e6adb871a3b94$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$0b2e6adb871a3b94$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$0b2e6adb871a3b94$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$0b2e6adb871a3b94$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$0b2e6adb871a3b94$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $0b2e6adb871a3b94$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $0b2e6adb871a3b94$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($0b2e6adb871a3b94$var$lf));
function $0b2e6adb871a3b94$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $0b2e6adb871a3b94$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $0b2e6adb871a3b94$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $0b2e6adb871a3b94$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $0b2e6adb871a3b94$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($0b2e6adb871a3b94$var$Qb) throw a = $0b2e6adb871a3b94$var$Rb, $0b2e6adb871a3b94$var$Qb = !1, $0b2e6adb871a3b94$var$Rb = null, a;
}
function $0b2e6adb871a3b94$var$D(a, b) {
    var c = b[$0b2e6adb871a3b94$var$of];
    void 0 === c && (c = b[$0b2e6adb871a3b94$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($0b2e6adb871a3b94$var$pf(b, a, 2, !1), c.add(d));
}
function $0b2e6adb871a3b94$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $0b2e6adb871a3b94$var$pf(c, a, d, b);
}
var $0b2e6adb871a3b94$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $0b2e6adb871a3b94$var$sf(a) {
    if (!a[$0b2e6adb871a3b94$var$rf]) {
        a[$0b2e6adb871a3b94$var$rf] = !0;
        $0b2e6adb871a3b94$var$da.forEach(function(b) {
            "selectionchange" !== b && ($0b2e6adb871a3b94$var$mf.has(b) || $0b2e6adb871a3b94$var$qf(b, !1, a), $0b2e6adb871a3b94$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$0b2e6adb871a3b94$var$rf] || (b[$0b2e6adb871a3b94$var$rf] = !0, $0b2e6adb871a3b94$var$qf("selectionchange", !1, b));
    }
}
function $0b2e6adb871a3b94$var$pf(a, b, c, d) {
    switch($0b2e6adb871a3b94$var$jd(b)){
        case 1:
            var e = $0b2e6adb871a3b94$var$ed;
            break;
        case 4:
            e = $0b2e6adb871a3b94$var$gd;
            break;
        default:
            e = $0b2e6adb871a3b94$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$0b2e6adb871a3b94$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $0b2e6adb871a3b94$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $0b2e6adb871a3b94$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $0b2e6adb871a3b94$var$Jb(function() {
        var d = f, e = $0b2e6adb871a3b94$var$xb(c), g = [];
        a: {
            var h = $0b2e6adb871a3b94$var$df.get(a);
            if (void 0 !== h) {
                var k = $0b2e6adb871a3b94$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $0b2e6adb871a3b94$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $0b2e6adb871a3b94$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $0b2e6adb871a3b94$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $0b2e6adb871a3b94$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $0b2e6adb871a3b94$var$Vd;
                        break;
                    case $0b2e6adb871a3b94$var$$e:
                    case $0b2e6adb871a3b94$var$af:
                    case $0b2e6adb871a3b94$var$bf:
                        k = $0b2e6adb871a3b94$var$Hd;
                        break;
                    case $0b2e6adb871a3b94$var$cf:
                        k = $0b2e6adb871a3b94$var$Xd;
                        break;
                    case "scroll":
                        k = $0b2e6adb871a3b94$var$vd;
                        break;
                    case "wheel":
                        k = $0b2e6adb871a3b94$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $0b2e6adb871a3b94$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $0b2e6adb871a3b94$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $0b2e6adb871a3b94$var$Kb(w, x), null != F && t.push($0b2e6adb871a3b94$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $0b2e6adb871a3b94$var$wb && (n = c.relatedTarget || c.fromElement) && ($0b2e6adb871a3b94$var$Wc(n) || n[$0b2e6adb871a3b94$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $0b2e6adb871a3b94$var$Wc(n) : null, null !== n && (J = $0b2e6adb871a3b94$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $0b2e6adb871a3b94$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $0b2e6adb871a3b94$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $0b2e6adb871a3b94$var$ue(k);
                        u = null == n ? h : $0b2e6adb871a3b94$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $0b2e6adb871a3b94$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $0b2e6adb871a3b94$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $0b2e6adb871a3b94$var$vf(F))u++;
                            for(; 0 < w - u;)t = $0b2e6adb871a3b94$var$vf(t), w--;
                            for(; 0 < u - w;)x = $0b2e6adb871a3b94$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $0b2e6adb871a3b94$var$vf(t);
                                x = $0b2e6adb871a3b94$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $0b2e6adb871a3b94$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $0b2e6adb871a3b94$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $0b2e6adb871a3b94$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $0b2e6adb871a3b94$var$ve;
                else if ($0b2e6adb871a3b94$var$me(h)) {
                    if ($0b2e6adb871a3b94$var$we) na = $0b2e6adb871a3b94$var$Fe;
                    else {
                        na = $0b2e6adb871a3b94$var$De;
                        var xa = $0b2e6adb871a3b94$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $0b2e6adb871a3b94$var$Ee);
                if (na && (na = na(a, d))) {
                    $0b2e6adb871a3b94$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $0b2e6adb871a3b94$var$cb(h, "number", h.value);
            }
            xa = d ? $0b2e6adb871a3b94$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($0b2e6adb871a3b94$var$me(xa) || "true" === xa.contentEditable) $0b2e6adb871a3b94$var$Qe = xa, $0b2e6adb871a3b94$var$Re = d, $0b2e6adb871a3b94$var$Se = null;
                    break;
                case "focusout":
                    $0b2e6adb871a3b94$var$Se = $0b2e6adb871a3b94$var$Re = $0b2e6adb871a3b94$var$Qe = null;
                    break;
                case "mousedown":
                    $0b2e6adb871a3b94$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $0b2e6adb871a3b94$var$Te = !1;
                    $0b2e6adb871a3b94$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($0b2e6adb871a3b94$var$Pe) break;
                case "keydown":
                case "keyup":
                    $0b2e6adb871a3b94$var$Ue(g, c, e);
            }
            var $a;
            if ($0b2e6adb871a3b94$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $0b2e6adb871a3b94$var$ie ? $0b2e6adb871a3b94$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($0b2e6adb871a3b94$var$de && "ko" !== c.locale && ($0b2e6adb871a3b94$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $0b2e6adb871a3b94$var$ie && ($a = $0b2e6adb871a3b94$var$nd()) : ($0b2e6adb871a3b94$var$kd = e, $0b2e6adb871a3b94$var$ld = "value" in $0b2e6adb871a3b94$var$kd ? $0b2e6adb871a3b94$var$kd.value : $0b2e6adb871a3b94$var$kd.textContent, $0b2e6adb871a3b94$var$ie = !0)), xa = $0b2e6adb871a3b94$var$oe(d, ba), 0 < xa.length && (ba = new $0b2e6adb871a3b94$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $0b2e6adb871a3b94$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $0b2e6adb871a3b94$var$ce ? $0b2e6adb871a3b94$var$je(a, c) : $0b2e6adb871a3b94$var$ke(a, c)) d = $0b2e6adb871a3b94$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $0b2e6adb871a3b94$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $0b2e6adb871a3b94$var$se(g, b);
    });
}
function $0b2e6adb871a3b94$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $0b2e6adb871a3b94$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $0b2e6adb871a3b94$var$Kb(a, c), null != f && d.unshift($0b2e6adb871a3b94$var$tf(a, f, e)), f = $0b2e6adb871a3b94$var$Kb(a, b), null != f && d.push($0b2e6adb871a3b94$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $0b2e6adb871a3b94$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $0b2e6adb871a3b94$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $0b2e6adb871a3b94$var$Kb(c, f), null != k && g.unshift($0b2e6adb871a3b94$var$tf(c, k, h))) : e || (k = $0b2e6adb871a3b94$var$Kb(c, f), null != k && g.push($0b2e6adb871a3b94$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $0b2e6adb871a3b94$var$xf = /\r\n?/g, $0b2e6adb871a3b94$var$yf = /\u0000|\uFFFD/g;
function $0b2e6adb871a3b94$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($0b2e6adb871a3b94$var$xf, "\n").replace($0b2e6adb871a3b94$var$yf, "");
}
function $0b2e6adb871a3b94$var$Af(a, b, c) {
    b = $0b2e6adb871a3b94$var$zf(b);
    if ($0b2e6adb871a3b94$var$zf(a) !== b && c) throw Error($0b2e6adb871a3b94$var$p(425));
}
function $0b2e6adb871a3b94$var$Bf() {}
var $0b2e6adb871a3b94$var$Cf = null, $0b2e6adb871a3b94$var$Df = null;
function $0b2e6adb871a3b94$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $0b2e6adb871a3b94$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $0b2e6adb871a3b94$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $0b2e6adb871a3b94$var$Hf = "function" === typeof Promise ? Promise : void 0, $0b2e6adb871a3b94$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $0b2e6adb871a3b94$var$Hf ? function(a) {
    return $0b2e6adb871a3b94$var$Hf.resolve(null).then(a).catch($0b2e6adb871a3b94$var$If);
} : $0b2e6adb871a3b94$var$Ff;
function $0b2e6adb871a3b94$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $0b2e6adb871a3b94$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $0b2e6adb871a3b94$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $0b2e6adb871a3b94$var$bd(b);
}
function $0b2e6adb871a3b94$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $0b2e6adb871a3b94$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$Nf = Math.random().toString(36).slice(2), $0b2e6adb871a3b94$var$Of = "__reactFiber$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Pf = "__reactProps$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$uf = "__reactContainer$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$of = "__reactEvents$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Qf = "__reactListeners$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Rf = "__reactHandles$" + $0b2e6adb871a3b94$var$Nf;
function $0b2e6adb871a3b94$var$Wc(a) {
    var b = a[$0b2e6adb871a3b94$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$0b2e6adb871a3b94$var$uf] || c[$0b2e6adb871a3b94$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $0b2e6adb871a3b94$var$Mf(a); null !== a;){
                if (c = a[$0b2e6adb871a3b94$var$Of]) return c;
                a = $0b2e6adb871a3b94$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Cb(a) {
    a = a[$0b2e6adb871a3b94$var$Of] || a[$0b2e6adb871a3b94$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $0b2e6adb871a3b94$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($0b2e6adb871a3b94$var$p(33));
}
function $0b2e6adb871a3b94$var$Db(a) {
    return a[$0b2e6adb871a3b94$var$Pf] || null;
}
var $0b2e6adb871a3b94$var$Sf = [], $0b2e6adb871a3b94$var$Tf = -1;
function $0b2e6adb871a3b94$var$Uf(a) {
    return {
        current: a
    };
}
function $0b2e6adb871a3b94$var$E(a) {
    0 > $0b2e6adb871a3b94$var$Tf || (a.current = $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf], $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf] = null, $0b2e6adb871a3b94$var$Tf--);
}
function $0b2e6adb871a3b94$var$G(a, b) {
    $0b2e6adb871a3b94$var$Tf++;
    $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf] = a.current;
    a.current = b;
}
var $0b2e6adb871a3b94$var$Vf = {}, $0b2e6adb871a3b94$var$H = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$Vf), $0b2e6adb871a3b94$var$Wf = $0b2e6adb871a3b94$var$Uf(!1), $0b2e6adb871a3b94$var$Xf = $0b2e6adb871a3b94$var$Vf;
function $0b2e6adb871a3b94$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $0b2e6adb871a3b94$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $0b2e6adb871a3b94$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $0b2e6adb871a3b94$var$$f() {
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
}
function $0b2e6adb871a3b94$var$ag(a, b, c) {
    if ($0b2e6adb871a3b94$var$H.current !== $0b2e6adb871a3b94$var$Vf) throw Error($0b2e6adb871a3b94$var$p(168));
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, b);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, c);
}
function $0b2e6adb871a3b94$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($0b2e6adb871a3b94$var$p(108, $0b2e6adb871a3b94$var$Ra(a) || "Unknown", e));
    return $0b2e6adb871a3b94$var$A({}, c, d);
}
function $0b2e6adb871a3b94$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $0b2e6adb871a3b94$var$Vf;
    $0b2e6adb871a3b94$var$Xf = $0b2e6adb871a3b94$var$H.current;
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, a);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, $0b2e6adb871a3b94$var$Wf.current);
    return !0;
}
function $0b2e6adb871a3b94$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($0b2e6adb871a3b94$var$p(169));
    c ? (a = $0b2e6adb871a3b94$var$bg(a, b, $0b2e6adb871a3b94$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H), $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, a)) : $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, c);
}
var $0b2e6adb871a3b94$var$eg = null, $0b2e6adb871a3b94$var$fg = !1, $0b2e6adb871a3b94$var$gg = !1;
function $0b2e6adb871a3b94$var$hg(a) {
    null === $0b2e6adb871a3b94$var$eg ? $0b2e6adb871a3b94$var$eg = [
        a
    ] : $0b2e6adb871a3b94$var$eg.push(a);
}
function $0b2e6adb871a3b94$var$ig(a) {
    $0b2e6adb871a3b94$var$fg = !0;
    $0b2e6adb871a3b94$var$hg(a);
}
function $0b2e6adb871a3b94$var$jg() {
    if (!$0b2e6adb871a3b94$var$gg && null !== $0b2e6adb871a3b94$var$eg) {
        $0b2e6adb871a3b94$var$gg = !0;
        var a = 0, b = $0b2e6adb871a3b94$var$C;
        try {
            var c = $0b2e6adb871a3b94$var$eg;
            for($0b2e6adb871a3b94$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $0b2e6adb871a3b94$var$eg = null;
            $0b2e6adb871a3b94$var$fg = !1;
        } catch (e) {
            throw null !== $0b2e6adb871a3b94$var$eg && ($0b2e6adb871a3b94$var$eg = $0b2e6adb871a3b94$var$eg.slice(a + 1)), $0b2e6adb871a3b94$var$ac($0b2e6adb871a3b94$var$fc, $0b2e6adb871a3b94$var$jg), e;
        } finally{
            $0b2e6adb871a3b94$var$C = b, $0b2e6adb871a3b94$var$gg = !1;
        }
    }
    return null;
}
var $0b2e6adb871a3b94$var$kg = [], $0b2e6adb871a3b94$var$lg = 0, $0b2e6adb871a3b94$var$mg = null, $0b2e6adb871a3b94$var$ng = 0, $0b2e6adb871a3b94$var$og = [], $0b2e6adb871a3b94$var$pg = 0, $0b2e6adb871a3b94$var$qg = null, $0b2e6adb871a3b94$var$rg = 1, $0b2e6adb871a3b94$var$sg = "";
function $0b2e6adb871a3b94$var$tg(a, b) {
    $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg++] = $0b2e6adb871a3b94$var$ng;
    $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg++] = $0b2e6adb871a3b94$var$mg;
    $0b2e6adb871a3b94$var$mg = a;
    $0b2e6adb871a3b94$var$ng = b;
}
function $0b2e6adb871a3b94$var$ug(a, b, c) {
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$rg;
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$sg;
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$qg;
    $0b2e6adb871a3b94$var$qg = a;
    var d = $0b2e6adb871a3b94$var$rg;
    a = $0b2e6adb871a3b94$var$sg;
    var e = 32 - $0b2e6adb871a3b94$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $0b2e6adb871a3b94$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $0b2e6adb871a3b94$var$rg = 1 << 32 - $0b2e6adb871a3b94$var$oc(b) + e | c << e | d;
        $0b2e6adb871a3b94$var$sg = f + a;
    } else $0b2e6adb871a3b94$var$rg = 1 << f | c << e | d, $0b2e6adb871a3b94$var$sg = a;
}
function $0b2e6adb871a3b94$var$vg(a) {
    null !== a.return && ($0b2e6adb871a3b94$var$tg(a, 1), $0b2e6adb871a3b94$var$ug(a, 1, 0));
}
function $0b2e6adb871a3b94$var$wg(a) {
    for(; a === $0b2e6adb871a3b94$var$mg;)$0b2e6adb871a3b94$var$mg = $0b2e6adb871a3b94$var$kg[--$0b2e6adb871a3b94$var$lg], $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg] = null, $0b2e6adb871a3b94$var$ng = $0b2e6adb871a3b94$var$kg[--$0b2e6adb871a3b94$var$lg], $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg] = null;
    for(; a === $0b2e6adb871a3b94$var$qg;)$0b2e6adb871a3b94$var$qg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null, $0b2e6adb871a3b94$var$sg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null, $0b2e6adb871a3b94$var$rg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null;
}
var $0b2e6adb871a3b94$var$xg = null, $0b2e6adb871a3b94$var$yg = null, $0b2e6adb871a3b94$var$I = !1, $0b2e6adb871a3b94$var$zg = null;
function $0b2e6adb871a3b94$var$Ag(a, b) {
    var c = $0b2e6adb871a3b94$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $0b2e6adb871a3b94$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $0b2e6adb871a3b94$var$qg ? {
                id: $0b2e6adb871a3b94$var$rg,
                overflow: $0b2e6adb871a3b94$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $0b2e6adb871a3b94$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $0b2e6adb871a3b94$var$Eg(a) {
    if ($0b2e6adb871a3b94$var$I) {
        var b = $0b2e6adb871a3b94$var$yg;
        if (b) {
            var c = b;
            if (!$0b2e6adb871a3b94$var$Cg(a, b)) {
                if ($0b2e6adb871a3b94$var$Dg(a)) throw Error($0b2e6adb871a3b94$var$p(418));
                b = $0b2e6adb871a3b94$var$Lf(c.nextSibling);
                var d = $0b2e6adb871a3b94$var$xg;
                b && $0b2e6adb871a3b94$var$Cg(a, b) ? $0b2e6adb871a3b94$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $0b2e6adb871a3b94$var$I = !1, $0b2e6adb871a3b94$var$xg = a);
            }
        } else {
            if ($0b2e6adb871a3b94$var$Dg(a)) throw Error($0b2e6adb871a3b94$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $0b2e6adb871a3b94$var$I = !1;
            $0b2e6adb871a3b94$var$xg = a;
        }
    }
}
function $0b2e6adb871a3b94$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $0b2e6adb871a3b94$var$xg = a;
}
function $0b2e6adb871a3b94$var$Gg(a) {
    if (a !== $0b2e6adb871a3b94$var$xg) return !1;
    if (!$0b2e6adb871a3b94$var$I) return $0b2e6adb871a3b94$var$Fg(a), $0b2e6adb871a3b94$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$0b2e6adb871a3b94$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $0b2e6adb871a3b94$var$yg)) {
        if ($0b2e6adb871a3b94$var$Dg(a)) throw $0b2e6adb871a3b94$var$Hg(), Error($0b2e6adb871a3b94$var$p(418));
        for(; b;)$0b2e6adb871a3b94$var$Ag(a, b), b = $0b2e6adb871a3b94$var$Lf(b.nextSibling);
    }
    $0b2e6adb871a3b94$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($0b2e6adb871a3b94$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $0b2e6adb871a3b94$var$yg = null;
        }
    } else $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$xg ? $0b2e6adb871a3b94$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $0b2e6adb871a3b94$var$Hg() {
    for(var a = $0b2e6adb871a3b94$var$yg; a;)a = $0b2e6adb871a3b94$var$Lf(a.nextSibling);
}
function $0b2e6adb871a3b94$var$Ig() {
    $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$xg = null;
    $0b2e6adb871a3b94$var$I = !1;
}
function $0b2e6adb871a3b94$var$Jg(a) {
    null === $0b2e6adb871a3b94$var$zg ? $0b2e6adb871a3b94$var$zg = [
        a
    ] : $0b2e6adb871a3b94$var$zg.push(a);
}
var $0b2e6adb871a3b94$var$Kg = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig;
function $0b2e6adb871a3b94$var$Lg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($0b2e6adb871a3b94$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($0b2e6adb871a3b94$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($0b2e6adb871a3b94$var$p(284));
        if (!c._owner) throw Error($0b2e6adb871a3b94$var$p(290, a));
    }
    return a;
}
function $0b2e6adb871a3b94$var$Mg(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($0b2e6adb871a3b94$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $0b2e6adb871a3b94$var$Ng(a) {
    var b = a._init;
    return b(a._payload);
}
function $0b2e6adb871a3b94$var$Og(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $0b2e6adb871a3b94$var$Pg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $0b2e6adb871a3b94$var$Qg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $0b2e6adb871a3b94$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $0b2e6adb871a3b94$var$Ha && $0b2e6adb871a3b94$var$Ng(f) === b.type)) return d = e(b, c.props), d.ref = $0b2e6adb871a3b94$var$Lg(a, b, c), d.return = a, d;
        d = $0b2e6adb871a3b94$var$Rg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $0b2e6adb871a3b94$var$Lg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $0b2e6adb871a3b94$var$Sg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $0b2e6adb871a3b94$var$Tg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $0b2e6adb871a3b94$var$Qg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return c = $0b2e6adb871a3b94$var$Rg(b.type, b.key, b.props, null, a.mode, c), c.ref = $0b2e6adb871a3b94$var$Lg(a, null, b), c.return = a, c;
                case $0b2e6adb871a3b94$var$wa:
                    return b = $0b2e6adb871a3b94$var$Sg(b, a.mode, c), b.return = a, b;
                case $0b2e6adb871a3b94$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($0b2e6adb871a3b94$var$eb(b) || $0b2e6adb871a3b94$var$Ka(b)) return b = $0b2e6adb871a3b94$var$Tg(b, a.mode, c, null), b.return = a, b;
            $0b2e6adb871a3b94$var$Mg(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $0b2e6adb871a3b94$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $0b2e6adb871a3b94$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($0b2e6adb871a3b94$var$eb(c) || $0b2e6adb871a3b94$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $0b2e6adb871a3b94$var$Mg(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $0b2e6adb871a3b94$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $0b2e6adb871a3b94$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($0b2e6adb871a3b94$var$eb(d) || $0b2e6adb871a3b94$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $0b2e6adb871a3b94$var$Mg(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $0b2e6adb871a3b94$var$Ka(h);
        if ("function" !== typeof l) throw Error($0b2e6adb871a3b94$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($0b2e6adb871a3b94$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $0b2e6adb871a3b94$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $0b2e6adb871a3b94$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $0b2e6adb871a3b94$var$Ha && $0b2e6adb871a3b94$var$Ng(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $0b2e6adb871a3b94$var$Lg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $0b2e6adb871a3b94$var$ya ? (d = $0b2e6adb871a3b94$var$Tg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $0b2e6adb871a3b94$var$Rg(f.type, f.key, f.props, null, a.mode, h), h.ref = $0b2e6adb871a3b94$var$Lg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $0b2e6adb871a3b94$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $0b2e6adb871a3b94$var$Sg(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $0b2e6adb871a3b94$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($0b2e6adb871a3b94$var$eb(f)) return n(a, d, f, h);
            if ($0b2e6adb871a3b94$var$Ka(f)) return t(a, d, f, h);
            $0b2e6adb871a3b94$var$Mg(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $0b2e6adb871a3b94$var$Qg(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $0b2e6adb871a3b94$var$Ug = $0b2e6adb871a3b94$var$Og(!0), $0b2e6adb871a3b94$var$Vg = $0b2e6adb871a3b94$var$Og(!1), $0b2e6adb871a3b94$var$Wg = $0b2e6adb871a3b94$var$Uf(null), $0b2e6adb871a3b94$var$Xg = null, $0b2e6adb871a3b94$var$Yg = null, $0b2e6adb871a3b94$var$Zg = null;
function $0b2e6adb871a3b94$var$$g() {
    $0b2e6adb871a3b94$var$Zg = $0b2e6adb871a3b94$var$Yg = $0b2e6adb871a3b94$var$Xg = null;
}
function $0b2e6adb871a3b94$var$ah(a) {
    var b = $0b2e6adb871a3b94$var$Wg.current;
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wg);
    a._currentValue = b;
}
function $0b2e6adb871a3b94$var$bh(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $0b2e6adb871a3b94$var$ch(a, b) {
    $0b2e6adb871a3b94$var$Xg = a;
    $0b2e6adb871a3b94$var$Zg = $0b2e6adb871a3b94$var$Yg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($0b2e6adb871a3b94$var$dh = !0), a.firstContext = null);
}
function $0b2e6adb871a3b94$var$eh(a) {
    var b = a._currentValue;
    if ($0b2e6adb871a3b94$var$Zg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $0b2e6adb871a3b94$var$Yg) {
            if (null === $0b2e6adb871a3b94$var$Xg) throw Error($0b2e6adb871a3b94$var$p(308));
            $0b2e6adb871a3b94$var$Yg = a;
            $0b2e6adb871a3b94$var$Xg.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $0b2e6adb871a3b94$var$Yg = $0b2e6adb871a3b94$var$Yg.next = a;
    }
    return b;
}
var $0b2e6adb871a3b94$var$fh = null;
function $0b2e6adb871a3b94$var$gh(a) {
    null === $0b2e6adb871a3b94$var$fh ? $0b2e6adb871a3b94$var$fh = [
        a
    ] : $0b2e6adb871a3b94$var$fh.push(a);
}
function $0b2e6adb871a3b94$var$hh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $0b2e6adb871a3b94$var$gh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $0b2e6adb871a3b94$var$ih(a, d);
}
function $0b2e6adb871a3b94$var$ih(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $0b2e6adb871a3b94$var$jh = !1;
function $0b2e6adb871a3b94$var$kh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $0b2e6adb871a3b94$var$lh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $0b2e6adb871a3b94$var$mh(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $0b2e6adb871a3b94$var$nh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($0b2e6adb871a3b94$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $0b2e6adb871a3b94$var$ih(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $0b2e6adb871a3b94$var$gh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $0b2e6adb871a3b94$var$ih(a, c);
}
function $0b2e6adb871a3b94$var$oh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $0b2e6adb871a3b94$var$Cc(a, c);
    }
}
function $0b2e6adb871a3b94$var$ph(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $0b2e6adb871a3b94$var$qh(a, b, c, d) {
    var e = a.updateQueue;
    $0b2e6adb871a3b94$var$jh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $0b2e6adb871a3b94$var$A({}, q, r);
                            break a;
                        case 2:
                            $0b2e6adb871a3b94$var$jh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $0b2e6adb871a3b94$var$rh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $0b2e6adb871a3b94$var$sh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($0b2e6adb871a3b94$var$p(191, e));
            e.call(d);
        }
    }
}
var $0b2e6adb871a3b94$var$th = {}, $0b2e6adb871a3b94$var$uh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$th), $0b2e6adb871a3b94$var$vh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$th), $0b2e6adb871a3b94$var$wh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$th);
function $0b2e6adb871a3b94$var$xh(a) {
    if (a === $0b2e6adb871a3b94$var$th) throw Error($0b2e6adb871a3b94$var$p(174));
    return a;
}
function $0b2e6adb871a3b94$var$yh(a, b) {
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$wh, b);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$vh, a);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$uh, $0b2e6adb871a3b94$var$th);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $0b2e6adb871a3b94$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $0b2e6adb871a3b94$var$lb(b, a);
    }
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$uh);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$uh, b);
}
function $0b2e6adb871a3b94$var$zh() {
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$uh);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$vh);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$wh);
}
function $0b2e6adb871a3b94$var$Ah(a) {
    $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$wh.current);
    var b = $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$uh.current);
    var c = $0b2e6adb871a3b94$var$lb(b, a.type);
    b !== c && ($0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$vh, a), $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$uh, c));
}
function $0b2e6adb871a3b94$var$Bh(a) {
    $0b2e6adb871a3b94$var$vh.current === a && ($0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$uh), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$vh));
}
var $0b2e6adb871a3b94$var$L = $0b2e6adb871a3b94$var$Uf(0);
function $0b2e6adb871a3b94$var$Ch(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$Dh = [];
function $0b2e6adb871a3b94$var$Eh() {
    for(var a = 0; a < $0b2e6adb871a3b94$var$Dh.length; a++)$0b2e6adb871a3b94$var$Dh[a]._workInProgressVersionPrimary = null;
    $0b2e6adb871a3b94$var$Dh.length = 0;
}
var $0b2e6adb871a3b94$var$Fh = $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher, $0b2e6adb871a3b94$var$Gh = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$Hh = 0, $0b2e6adb871a3b94$var$M = null, $0b2e6adb871a3b94$var$N = null, $0b2e6adb871a3b94$var$O = null, $0b2e6adb871a3b94$var$Ih = !1, $0b2e6adb871a3b94$var$Jh = !1, $0b2e6adb871a3b94$var$Kh = 0, $0b2e6adb871a3b94$var$Lh = 0;
function $0b2e6adb871a3b94$var$P() {
    throw Error($0b2e6adb871a3b94$var$p(321));
}
function $0b2e6adb871a3b94$var$Mh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$0b2e6adb871a3b94$var$He(a[c], b[c])) return !1;
    return !0;
}
function $0b2e6adb871a3b94$var$Nh(a, b, c, d, e, f) {
    $0b2e6adb871a3b94$var$Hh = f;
    $0b2e6adb871a3b94$var$M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $0b2e6adb871a3b94$var$Fh.current = null === a || null === a.memoizedState ? $0b2e6adb871a3b94$var$Oh : $0b2e6adb871a3b94$var$Ph;
    a = c(d, e);
    if ($0b2e6adb871a3b94$var$Jh) {
        f = 0;
        do {
            $0b2e6adb871a3b94$var$Jh = !1;
            $0b2e6adb871a3b94$var$Kh = 0;
            if (25 <= f) throw Error($0b2e6adb871a3b94$var$p(301));
            f += 1;
            $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$N = null;
            b.updateQueue = null;
            $0b2e6adb871a3b94$var$Fh.current = $0b2e6adb871a3b94$var$Qh;
            a = c(d, e);
        }while ($0b2e6adb871a3b94$var$Jh);
    }
    $0b2e6adb871a3b94$var$Fh.current = $0b2e6adb871a3b94$var$Rh;
    b = null !== $0b2e6adb871a3b94$var$N && null !== $0b2e6adb871a3b94$var$N.next;
    $0b2e6adb871a3b94$var$Hh = 0;
    $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$N = $0b2e6adb871a3b94$var$M = null;
    $0b2e6adb871a3b94$var$Ih = !1;
    if (b) throw Error($0b2e6adb871a3b94$var$p(300));
    return a;
}
function $0b2e6adb871a3b94$var$Sh() {
    var a = 0 !== $0b2e6adb871a3b94$var$Kh;
    $0b2e6adb871a3b94$var$Kh = 0;
    return a;
}
function $0b2e6adb871a3b94$var$Th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $0b2e6adb871a3b94$var$O ? $0b2e6adb871a3b94$var$M.memoizedState = $0b2e6adb871a3b94$var$O = a : $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$O.next = a;
    return $0b2e6adb871a3b94$var$O;
}
function $0b2e6adb871a3b94$var$Uh() {
    if (null === $0b2e6adb871a3b94$var$N) {
        var a = $0b2e6adb871a3b94$var$M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $0b2e6adb871a3b94$var$N.next;
    var b = null === $0b2e6adb871a3b94$var$O ? $0b2e6adb871a3b94$var$M.memoizedState : $0b2e6adb871a3b94$var$O.next;
    if (null !== b) $0b2e6adb871a3b94$var$O = b, $0b2e6adb871a3b94$var$N = a;
    else {
        if (null === a) throw Error($0b2e6adb871a3b94$var$p(310));
        $0b2e6adb871a3b94$var$N = a;
        a = {
            memoizedState: $0b2e6adb871a3b94$var$N.memoizedState,
            baseState: $0b2e6adb871a3b94$var$N.baseState,
            baseQueue: $0b2e6adb871a3b94$var$N.baseQueue,
            queue: $0b2e6adb871a3b94$var$N.queue,
            next: null
        };
        null === $0b2e6adb871a3b94$var$O ? $0b2e6adb871a3b94$var$M.memoizedState = $0b2e6adb871a3b94$var$O = a : $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$O.next = a;
    }
    return $0b2e6adb871a3b94$var$O;
}
function $0b2e6adb871a3b94$var$Vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $0b2e6adb871a3b94$var$Wh(a) {
    var b = $0b2e6adb871a3b94$var$Uh(), c = b.queue;
    if (null === c) throw Error($0b2e6adb871a3b94$var$p(311));
    c.lastRenderedReducer = a;
    var d = $0b2e6adb871a3b94$var$N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($0b2e6adb871a3b94$var$Hh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $0b2e6adb871a3b94$var$M.lanes |= m;
                $0b2e6adb871a3b94$var$rh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $0b2e6adb871a3b94$var$He(d, b.memoizedState) || ($0b2e6adb871a3b94$var$dh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $0b2e6adb871a3b94$var$M.lanes |= f, $0b2e6adb871a3b94$var$rh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $0b2e6adb871a3b94$var$Xh(a) {
    var b = $0b2e6adb871a3b94$var$Uh(), c = b.queue;
    if (null === c) throw Error($0b2e6adb871a3b94$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $0b2e6adb871a3b94$var$He(f, b.memoizedState) || ($0b2e6adb871a3b94$var$dh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $0b2e6adb871a3b94$var$Yh() {}
function $0b2e6adb871a3b94$var$Zh(a, b) {
    var c = $0b2e6adb871a3b94$var$M, d = $0b2e6adb871a3b94$var$Uh(), e = b(), f = !$0b2e6adb871a3b94$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $0b2e6adb871a3b94$var$dh = !0);
    d = d.queue;
    $0b2e6adb871a3b94$var$$h($0b2e6adb871a3b94$var$ai.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $0b2e6adb871a3b94$var$O && $0b2e6adb871a3b94$var$O.memoizedState.tag & 1) {
        c.flags |= 2048;
        $0b2e6adb871a3b94$var$bi(9, $0b2e6adb871a3b94$var$ci.bind(null, c, d, e, b), void 0, null);
        if (null === $0b2e6adb871a3b94$var$Q) throw Error($0b2e6adb871a3b94$var$p(349));
        0 !== ($0b2e6adb871a3b94$var$Hh & 30) || $0b2e6adb871a3b94$var$di(c, b, e);
    }
    return e;
}
function $0b2e6adb871a3b94$var$di(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $0b2e6adb871a3b94$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $0b2e6adb871a3b94$var$M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $0b2e6adb871a3b94$var$ci(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $0b2e6adb871a3b94$var$ei(b) && $0b2e6adb871a3b94$var$fi(a);
}
function $0b2e6adb871a3b94$var$ai(a, b, c) {
    return c(function() {
        $0b2e6adb871a3b94$var$ei(b) && $0b2e6adb871a3b94$var$fi(a);
    });
}
function $0b2e6adb871a3b94$var$ei(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$0b2e6adb871a3b94$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $0b2e6adb871a3b94$var$fi(a) {
    var b = $0b2e6adb871a3b94$var$ih(a, 1);
    null !== b && $0b2e6adb871a3b94$var$gi(b, a, 1, -1);
}
function $0b2e6adb871a3b94$var$hi(a) {
    var b = $0b2e6adb871a3b94$var$Th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $0b2e6adb871a3b94$var$Vh,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $0b2e6adb871a3b94$var$ii.bind(null, $0b2e6adb871a3b94$var$M, a);
    return [
        b.memoizedState,
        a
    ];
}
function $0b2e6adb871a3b94$var$bi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $0b2e6adb871a3b94$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $0b2e6adb871a3b94$var$M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $0b2e6adb871a3b94$var$ji() {
    return $0b2e6adb871a3b94$var$Uh().memoizedState;
}
function $0b2e6adb871a3b94$var$ki(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$Th();
    $0b2e6adb871a3b94$var$M.flags |= a;
    e.memoizedState = $0b2e6adb871a3b94$var$bi(1 | b, c, void 0, void 0 === d ? null : d);
}
function $0b2e6adb871a3b94$var$li(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$Uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $0b2e6adb871a3b94$var$N) {
        var g = $0b2e6adb871a3b94$var$N.memoizedState;
        f = g.destroy;
        if (null !== d && $0b2e6adb871a3b94$var$Mh(d, g.deps)) {
            e.memoizedState = $0b2e6adb871a3b94$var$bi(b, c, f, d);
            return;
        }
    }
    $0b2e6adb871a3b94$var$M.flags |= a;
    e.memoizedState = $0b2e6adb871a3b94$var$bi(1 | b, c, f, d);
}
function $0b2e6adb871a3b94$var$mi(a, b) {
    return $0b2e6adb871a3b94$var$ki(8390656, 8, a, b);
}
function $0b2e6adb871a3b94$var$$h(a, b) {
    return $0b2e6adb871a3b94$var$li(2048, 8, a, b);
}
function $0b2e6adb871a3b94$var$ni(a, b) {
    return $0b2e6adb871a3b94$var$li(4, 2, a, b);
}
function $0b2e6adb871a3b94$var$oi(a, b) {
    return $0b2e6adb871a3b94$var$li(4, 4, a, b);
}
function $0b2e6adb871a3b94$var$pi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $0b2e6adb871a3b94$var$qi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $0b2e6adb871a3b94$var$li(4, 4, $0b2e6adb871a3b94$var$pi.bind(null, b, a), c);
}
function $0b2e6adb871a3b94$var$ri() {}
function $0b2e6adb871a3b94$var$si(a, b) {
    var c = $0b2e6adb871a3b94$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $0b2e6adb871a3b94$var$Mh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $0b2e6adb871a3b94$var$ti(a, b) {
    var c = $0b2e6adb871a3b94$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $0b2e6adb871a3b94$var$Mh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $0b2e6adb871a3b94$var$ui(a, b, c) {
    if (0 === ($0b2e6adb871a3b94$var$Hh & 21)) return a.baseState && (a.baseState = !1, $0b2e6adb871a3b94$var$dh = !0), a.memoizedState = c;
    $0b2e6adb871a3b94$var$He(c, b) || (c = $0b2e6adb871a3b94$var$yc(), $0b2e6adb871a3b94$var$M.lanes |= c, $0b2e6adb871a3b94$var$rh |= c, a.baseState = !0);
    return b;
}
function $0b2e6adb871a3b94$var$vi(a, b) {
    var c = $0b2e6adb871a3b94$var$C;
    $0b2e6adb871a3b94$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $0b2e6adb871a3b94$var$Gh.transition;
    $0b2e6adb871a3b94$var$Gh.transition = {};
    try {
        a(!1), b();
    } finally{
        $0b2e6adb871a3b94$var$C = c, $0b2e6adb871a3b94$var$Gh.transition = d;
    }
}
function $0b2e6adb871a3b94$var$wi() {
    return $0b2e6adb871a3b94$var$Uh().memoizedState;
}
function $0b2e6adb871a3b94$var$xi(a, b, c) {
    var d = $0b2e6adb871a3b94$var$yi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($0b2e6adb871a3b94$var$zi(a)) $0b2e6adb871a3b94$var$Ai(b, c);
    else if (c = $0b2e6adb871a3b94$var$hh(a, b, c, d), null !== c) {
        var e = $0b2e6adb871a3b94$var$R();
        $0b2e6adb871a3b94$var$gi(c, a, d, e);
        $0b2e6adb871a3b94$var$Bi(c, b, d);
    }
}
function $0b2e6adb871a3b94$var$ii(a, b, c) {
    var d = $0b2e6adb871a3b94$var$yi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($0b2e6adb871a3b94$var$zi(a)) $0b2e6adb871a3b94$var$Ai(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($0b2e6adb871a3b94$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $0b2e6adb871a3b94$var$gh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $0b2e6adb871a3b94$var$hh(a, b, e, d);
        null !== c && (e = $0b2e6adb871a3b94$var$R(), $0b2e6adb871a3b94$var$gi(c, a, d, e), $0b2e6adb871a3b94$var$Bi(c, b, d));
    }
}
function $0b2e6adb871a3b94$var$zi(a) {
    var b = a.alternate;
    return a === $0b2e6adb871a3b94$var$M || null !== b && b === $0b2e6adb871a3b94$var$M;
}
function $0b2e6adb871a3b94$var$Ai(a, b) {
    $0b2e6adb871a3b94$var$Jh = $0b2e6adb871a3b94$var$Ih = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $0b2e6adb871a3b94$var$Bi(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $0b2e6adb871a3b94$var$Cc(a, c);
    }
}
var $0b2e6adb871a3b94$var$Rh = {
    readContext: $0b2e6adb871a3b94$var$eh,
    useCallback: $0b2e6adb871a3b94$var$P,
    useContext: $0b2e6adb871a3b94$var$P,
    useEffect: $0b2e6adb871a3b94$var$P,
    useImperativeHandle: $0b2e6adb871a3b94$var$P,
    useInsertionEffect: $0b2e6adb871a3b94$var$P,
    useLayoutEffect: $0b2e6adb871a3b94$var$P,
    useMemo: $0b2e6adb871a3b94$var$P,
    useReducer: $0b2e6adb871a3b94$var$P,
    useRef: $0b2e6adb871a3b94$var$P,
    useState: $0b2e6adb871a3b94$var$P,
    useDebugValue: $0b2e6adb871a3b94$var$P,
    useDeferredValue: $0b2e6adb871a3b94$var$P,
    useTransition: $0b2e6adb871a3b94$var$P,
    useMutableSource: $0b2e6adb871a3b94$var$P,
    useSyncExternalStore: $0b2e6adb871a3b94$var$P,
    useId: $0b2e6adb871a3b94$var$P,
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$Oh = {
    readContext: $0b2e6adb871a3b94$var$eh,
    useCallback: function(a, b) {
        $0b2e6adb871a3b94$var$Th().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $0b2e6adb871a3b94$var$eh,
    useEffect: $0b2e6adb871a3b94$var$mi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $0b2e6adb871a3b94$var$ki(4194308, 4, $0b2e6adb871a3b94$var$pi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $0b2e6adb871a3b94$var$ki(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $0b2e6adb871a3b94$var$ki(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $0b2e6adb871a3b94$var$Th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $0b2e6adb871a3b94$var$Th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $0b2e6adb871a3b94$var$xi.bind(null, $0b2e6adb871a3b94$var$M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $0b2e6adb871a3b94$var$Th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $0b2e6adb871a3b94$var$hi,
    useDebugValue: $0b2e6adb871a3b94$var$ri,
    useDeferredValue: function(a) {
        return $0b2e6adb871a3b94$var$Th().memoizedState = a;
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$hi(!1), b = a[0];
        a = $0b2e6adb871a3b94$var$vi.bind(null, a[1]);
        $0b2e6adb871a3b94$var$Th().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $0b2e6adb871a3b94$var$M, e = $0b2e6adb871a3b94$var$Th();
        if ($0b2e6adb871a3b94$var$I) {
            if (void 0 === c) throw Error($0b2e6adb871a3b94$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $0b2e6adb871a3b94$var$Q) throw Error($0b2e6adb871a3b94$var$p(349));
            0 !== ($0b2e6adb871a3b94$var$Hh & 30) || $0b2e6adb871a3b94$var$di(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $0b2e6adb871a3b94$var$mi($0b2e6adb871a3b94$var$ai.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $0b2e6adb871a3b94$var$bi(9, $0b2e6adb871a3b94$var$ci.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $0b2e6adb871a3b94$var$Th(), b = $0b2e6adb871a3b94$var$Q.identifierPrefix;
        if ($0b2e6adb871a3b94$var$I) {
            var c = $0b2e6adb871a3b94$var$sg;
            var d = $0b2e6adb871a3b94$var$rg;
            c = (d & ~(1 << 32 - $0b2e6adb871a3b94$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $0b2e6adb871a3b94$var$Kh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $0b2e6adb871a3b94$var$Lh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$Ph = {
    readContext: $0b2e6adb871a3b94$var$eh,
    useCallback: $0b2e6adb871a3b94$var$si,
    useContext: $0b2e6adb871a3b94$var$eh,
    useEffect: $0b2e6adb871a3b94$var$$h,
    useImperativeHandle: $0b2e6adb871a3b94$var$qi,
    useInsertionEffect: $0b2e6adb871a3b94$var$ni,
    useLayoutEffect: $0b2e6adb871a3b94$var$oi,
    useMemo: $0b2e6adb871a3b94$var$ti,
    useReducer: $0b2e6adb871a3b94$var$Wh,
    useRef: $0b2e6adb871a3b94$var$ji,
    useState: function() {
        return $0b2e6adb871a3b94$var$Wh($0b2e6adb871a3b94$var$Vh);
    },
    useDebugValue: $0b2e6adb871a3b94$var$ri,
    useDeferredValue: function(a) {
        var b = $0b2e6adb871a3b94$var$Uh();
        return $0b2e6adb871a3b94$var$ui(b, $0b2e6adb871a3b94$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$Wh($0b2e6adb871a3b94$var$Vh)[0], b = $0b2e6adb871a3b94$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $0b2e6adb871a3b94$var$Yh,
    useSyncExternalStore: $0b2e6adb871a3b94$var$Zh,
    useId: $0b2e6adb871a3b94$var$wi,
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$Qh = {
    readContext: $0b2e6adb871a3b94$var$eh,
    useCallback: $0b2e6adb871a3b94$var$si,
    useContext: $0b2e6adb871a3b94$var$eh,
    useEffect: $0b2e6adb871a3b94$var$$h,
    useImperativeHandle: $0b2e6adb871a3b94$var$qi,
    useInsertionEffect: $0b2e6adb871a3b94$var$ni,
    useLayoutEffect: $0b2e6adb871a3b94$var$oi,
    useMemo: $0b2e6adb871a3b94$var$ti,
    useReducer: $0b2e6adb871a3b94$var$Xh,
    useRef: $0b2e6adb871a3b94$var$ji,
    useState: function() {
        return $0b2e6adb871a3b94$var$Xh($0b2e6adb871a3b94$var$Vh);
    },
    useDebugValue: $0b2e6adb871a3b94$var$ri,
    useDeferredValue: function(a) {
        var b = $0b2e6adb871a3b94$var$Uh();
        return null === $0b2e6adb871a3b94$var$N ? b.memoizedState = a : $0b2e6adb871a3b94$var$ui(b, $0b2e6adb871a3b94$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$Xh($0b2e6adb871a3b94$var$Vh)[0], b = $0b2e6adb871a3b94$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $0b2e6adb871a3b94$var$Yh,
    useSyncExternalStore: $0b2e6adb871a3b94$var$Zh,
    useId: $0b2e6adb871a3b94$var$wi,
    unstable_isNewReconciler: !1
};
function $0b2e6adb871a3b94$var$Ci(a, b) {
    if (a && a.defaultProps) {
        b = $0b2e6adb871a3b94$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $0b2e6adb871a3b94$var$Di(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $0b2e6adb871a3b94$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $0b2e6adb871a3b94$var$Ei = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $0b2e6adb871a3b94$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $0b2e6adb871a3b94$var$R(), e = $0b2e6adb871a3b94$var$yi(a), f = $0b2e6adb871a3b94$var$mh(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $0b2e6adb871a3b94$var$nh(a, f, e);
        null !== b && ($0b2e6adb871a3b94$var$gi(b, a, e, d), $0b2e6adb871a3b94$var$oh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $0b2e6adb871a3b94$var$R(), e = $0b2e6adb871a3b94$var$yi(a), f = $0b2e6adb871a3b94$var$mh(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $0b2e6adb871a3b94$var$nh(a, f, e);
        null !== b && ($0b2e6adb871a3b94$var$gi(b, a, e, d), $0b2e6adb871a3b94$var$oh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $0b2e6adb871a3b94$var$R(), d = $0b2e6adb871a3b94$var$yi(a), e = $0b2e6adb871a3b94$var$mh(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $0b2e6adb871a3b94$var$nh(a, e, d);
        null !== b && ($0b2e6adb871a3b94$var$gi(b, a, d, c), $0b2e6adb871a3b94$var$oh(b, a, d));
    }
};
function $0b2e6adb871a3b94$var$Fi(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$0b2e6adb871a3b94$var$Ie(c, d) || !$0b2e6adb871a3b94$var$Ie(e, f) : !0;
}
function $0b2e6adb871a3b94$var$Gi(a, b, c) {
    var d = !1, e = $0b2e6adb871a3b94$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $0b2e6adb871a3b94$var$eh(f) : (e = $0b2e6adb871a3b94$var$Zf(b) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $0b2e6adb871a3b94$var$Yf(a, e) : $0b2e6adb871a3b94$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $0b2e6adb871a3b94$var$Ei;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $0b2e6adb871a3b94$var$Hi(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $0b2e6adb871a3b94$var$Ei.enqueueReplaceState(b, b.state, null);
}
function $0b2e6adb871a3b94$var$Ii(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    $0b2e6adb871a3b94$var$kh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $0b2e6adb871a3b94$var$eh(f) : (f = $0b2e6adb871a3b94$var$Zf(b) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, e.context = $0b2e6adb871a3b94$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($0b2e6adb871a3b94$var$Di(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $0b2e6adb871a3b94$var$Ei.enqueueReplaceState(e, e.state, null), $0b2e6adb871a3b94$var$qh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $0b2e6adb871a3b94$var$Ji(a, b) {
    try {
        var c = "", d = b;
        do c += $0b2e6adb871a3b94$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $0b2e6adb871a3b94$var$Ki(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $0b2e6adb871a3b94$var$Li(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $0b2e6adb871a3b94$var$Mi = "function" === typeof WeakMap ? WeakMap : Map;
function $0b2e6adb871a3b94$var$Ni(a, b, c) {
    c = $0b2e6adb871a3b94$var$mh(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $0b2e6adb871a3b94$var$Oi || ($0b2e6adb871a3b94$var$Oi = !0, $0b2e6adb871a3b94$var$Pi = d);
        $0b2e6adb871a3b94$var$Li(a, b);
    };
    return c;
}
function $0b2e6adb871a3b94$var$Qi(a, b, c) {
    c = $0b2e6adb871a3b94$var$mh(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $0b2e6adb871a3b94$var$Li(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $0b2e6adb871a3b94$var$Li(a, b);
        "function" !== typeof d && (null === $0b2e6adb871a3b94$var$Ri ? $0b2e6adb871a3b94$var$Ri = new Set([
            this
        ]) : $0b2e6adb871a3b94$var$Ri.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $0b2e6adb871a3b94$var$Si(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $0b2e6adb871a3b94$var$Mi;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $0b2e6adb871a3b94$var$Ti.bind(null, a, b, c), b.then(a, a));
}
function $0b2e6adb871a3b94$var$Ui(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $0b2e6adb871a3b94$var$Vi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $0b2e6adb871a3b94$var$mh(-1, 1), b.tag = 2, $0b2e6adb871a3b94$var$nh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $0b2e6adb871a3b94$var$Wi = $0b2e6adb871a3b94$var$ua.ReactCurrentOwner, $0b2e6adb871a3b94$var$dh = !1;
function $0b2e6adb871a3b94$var$Xi(a, b, c, d) {
    b.child = null === a ? $0b2e6adb871a3b94$var$Vg(b, null, c, d) : $0b2e6adb871a3b94$var$Ug(b, a.child, c, d);
}
function $0b2e6adb871a3b94$var$Yi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $0b2e6adb871a3b94$var$ch(b, e);
    d = $0b2e6adb871a3b94$var$Nh(a, b, c, d, f, e);
    c = $0b2e6adb871a3b94$var$Sh();
    if (null !== a && !$0b2e6adb871a3b94$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $0b2e6adb871a3b94$var$Zi(a, b, e);
    $0b2e6adb871a3b94$var$I && c && $0b2e6adb871a3b94$var$vg(b);
    b.flags |= 1;
    $0b2e6adb871a3b94$var$Xi(a, b, d, e);
    return b.child;
}
function $0b2e6adb871a3b94$var$$i(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$0b2e6adb871a3b94$var$aj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $0b2e6adb871a3b94$var$bj(a, b, f, d, e);
        a = $0b2e6adb871a3b94$var$Rg(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $0b2e6adb871a3b94$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $0b2e6adb871a3b94$var$Zi(a, b, e);
    }
    b.flags |= 1;
    a = $0b2e6adb871a3b94$var$Pg(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $0b2e6adb871a3b94$var$bj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($0b2e6adb871a3b94$var$Ie(f, d) && a.ref === b.ref) {
            if ($0b2e6adb871a3b94$var$dh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($0b2e6adb871a3b94$var$dh = !0);
            else return b.lanes = a.lanes, $0b2e6adb871a3b94$var$Zi(a, b, e);
        }
    }
    return $0b2e6adb871a3b94$var$cj(a, b, c, d, e);
}
function $0b2e6adb871a3b94$var$dj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$ej, $0b2e6adb871a3b94$var$fj), $0b2e6adb871a3b94$var$fj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$ej, $0b2e6adb871a3b94$var$fj), $0b2e6adb871a3b94$var$fj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$ej, $0b2e6adb871a3b94$var$fj);
            $0b2e6adb871a3b94$var$fj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$ej, $0b2e6adb871a3b94$var$fj), $0b2e6adb871a3b94$var$fj |= d;
    $0b2e6adb871a3b94$var$Xi(a, b, e, c);
    return b.child;
}
function $0b2e6adb871a3b94$var$gj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $0b2e6adb871a3b94$var$cj(a, b, c, d, e) {
    var f = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current;
    f = $0b2e6adb871a3b94$var$Yf(b, f);
    $0b2e6adb871a3b94$var$ch(b, e);
    c = $0b2e6adb871a3b94$var$Nh(a, b, c, d, f, e);
    d = $0b2e6adb871a3b94$var$Sh();
    if (null !== a && !$0b2e6adb871a3b94$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $0b2e6adb871a3b94$var$Zi(a, b, e);
    $0b2e6adb871a3b94$var$I && d && $0b2e6adb871a3b94$var$vg(b);
    b.flags |= 1;
    $0b2e6adb871a3b94$var$Xi(a, b, c, e);
    return b.child;
}
function $0b2e6adb871a3b94$var$hj(a, b, c, d, e) {
    if ($0b2e6adb871a3b94$var$Zf(c)) {
        var f = !0;
        $0b2e6adb871a3b94$var$cg(b);
    } else f = !1;
    $0b2e6adb871a3b94$var$ch(b, e);
    if (null === b.stateNode) $0b2e6adb871a3b94$var$ij(a, b), $0b2e6adb871a3b94$var$Gi(b, c, d), $0b2e6adb871a3b94$var$Ii(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $0b2e6adb871a3b94$var$eh(l) : (l = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, l = $0b2e6adb871a3b94$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $0b2e6adb871a3b94$var$Hi(b, g, d, l);
        $0b2e6adb871a3b94$var$jh = !1;
        var r = b.memoizedState;
        g.state = r;
        $0b2e6adb871a3b94$var$qh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $0b2e6adb871a3b94$var$Wf.current || $0b2e6adb871a3b94$var$jh ? ("function" === typeof m && ($0b2e6adb871a3b94$var$Di(b, c, m, d), k = b.memoizedState), (h = $0b2e6adb871a3b94$var$jh || $0b2e6adb871a3b94$var$Fi(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $0b2e6adb871a3b94$var$lh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $0b2e6adb871a3b94$var$Ci(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $0b2e6adb871a3b94$var$eh(k) : (k = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, k = $0b2e6adb871a3b94$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $0b2e6adb871a3b94$var$Hi(b, g, d, k);
        $0b2e6adb871a3b94$var$jh = !1;
        r = b.memoizedState;
        g.state = r;
        $0b2e6adb871a3b94$var$qh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $0b2e6adb871a3b94$var$Wf.current || $0b2e6adb871a3b94$var$jh ? ("function" === typeof y && ($0b2e6adb871a3b94$var$Di(b, c, y, d), n = b.memoizedState), (l = $0b2e6adb871a3b94$var$jh || $0b2e6adb871a3b94$var$Fi(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $0b2e6adb871a3b94$var$jj(a, b, c, d, f, e);
}
function $0b2e6adb871a3b94$var$jj(a, b, c, d, e, f) {
    $0b2e6adb871a3b94$var$gj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $0b2e6adb871a3b94$var$dg(b, c, !1), $0b2e6adb871a3b94$var$Zi(a, b, f);
    d = b.stateNode;
    $0b2e6adb871a3b94$var$Wi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $0b2e6adb871a3b94$var$Ug(b, a.child, null, f), b.child = $0b2e6adb871a3b94$var$Ug(b, null, h, f)) : $0b2e6adb871a3b94$var$Xi(a, b, h, f);
    b.memoizedState = d.state;
    e && $0b2e6adb871a3b94$var$dg(b, c, !0);
    return b.child;
}
function $0b2e6adb871a3b94$var$kj(a) {
    var b = a.stateNode;
    b.pendingContext ? $0b2e6adb871a3b94$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $0b2e6adb871a3b94$var$ag(a, b.context, !1);
    $0b2e6adb871a3b94$var$yh(a, b.containerInfo);
}
function $0b2e6adb871a3b94$var$lj(a, b, c, d, e) {
    $0b2e6adb871a3b94$var$Ig();
    $0b2e6adb871a3b94$var$Jg(e);
    b.flags |= 256;
    $0b2e6adb871a3b94$var$Xi(a, b, c, d);
    return b.child;
}
var $0b2e6adb871a3b94$var$mj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $0b2e6adb871a3b94$var$nj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $0b2e6adb871a3b94$var$oj(a, b, c) {
    var d = b.pendingProps, e = $0b2e6adb871a3b94$var$L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, e & 1);
    if (null === a) {
        $0b2e6adb871a3b94$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $0b2e6adb871a3b94$var$pj(g, d, 0, null), a = $0b2e6adb871a3b94$var$Tg(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $0b2e6adb871a3b94$var$nj(c), b.memoizedState = $0b2e6adb871a3b94$var$mj, a) : $0b2e6adb871a3b94$var$qj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $0b2e6adb871a3b94$var$rj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $0b2e6adb871a3b94$var$Pg(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $0b2e6adb871a3b94$var$Pg(h, f) : (f = $0b2e6adb871a3b94$var$Tg(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $0b2e6adb871a3b94$var$nj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $0b2e6adb871a3b94$var$mj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $0b2e6adb871a3b94$var$Pg(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $0b2e6adb871a3b94$var$qj(a, b) {
    b = $0b2e6adb871a3b94$var$pj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $0b2e6adb871a3b94$var$sj(a, b, c, d) {
    null !== d && $0b2e6adb871a3b94$var$Jg(d);
    $0b2e6adb871a3b94$var$Ug(b, a.child, null, c);
    a = $0b2e6adb871a3b94$var$qj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $0b2e6adb871a3b94$var$rj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $0b2e6adb871a3b94$var$Ki(Error($0b2e6adb871a3b94$var$p(422))), $0b2e6adb871a3b94$var$sj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $0b2e6adb871a3b94$var$pj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $0b2e6adb871a3b94$var$Tg(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $0b2e6adb871a3b94$var$Ug(b, a.child, null, g);
        b.child.memoizedState = $0b2e6adb871a3b94$var$nj(g);
        b.memoizedState = $0b2e6adb871a3b94$var$mj;
        return f;
    }
    if (0 === (b.mode & 1)) return $0b2e6adb871a3b94$var$sj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($0b2e6adb871a3b94$var$p(419));
        d = $0b2e6adb871a3b94$var$Ki(f, d, void 0);
        return $0b2e6adb871a3b94$var$sj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($0b2e6adb871a3b94$var$dh || h) {
        d = $0b2e6adb871a3b94$var$Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $0b2e6adb871a3b94$var$ih(a, e), $0b2e6adb871a3b94$var$gi(d, a, e, -1));
        }
        $0b2e6adb871a3b94$var$tj();
        d = $0b2e6adb871a3b94$var$Ki(Error($0b2e6adb871a3b94$var$p(421)));
        return $0b2e6adb871a3b94$var$sj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $0b2e6adb871a3b94$var$uj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(e.nextSibling);
    $0b2e6adb871a3b94$var$xg = b;
    $0b2e6adb871a3b94$var$I = !0;
    $0b2e6adb871a3b94$var$zg = null;
    null !== a && ($0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$rg, $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$sg, $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$qg, $0b2e6adb871a3b94$var$rg = a.id, $0b2e6adb871a3b94$var$sg = a.overflow, $0b2e6adb871a3b94$var$qg = b);
    b = $0b2e6adb871a3b94$var$qj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $0b2e6adb871a3b94$var$vj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $0b2e6adb871a3b94$var$bh(a.return, b, c);
}
function $0b2e6adb871a3b94$var$wj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $0b2e6adb871a3b94$var$xj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $0b2e6adb871a3b94$var$Xi(a, b, d.children, c);
    d = $0b2e6adb871a3b94$var$L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $0b2e6adb871a3b94$var$vj(a, c, b);
            else if (19 === a.tag) $0b2e6adb871a3b94$var$vj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $0b2e6adb871a3b94$var$Ch(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $0b2e6adb871a3b94$var$wj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $0b2e6adb871a3b94$var$Ch(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $0b2e6adb871a3b94$var$wj(b, !0, c, null, f);
            break;
        case "together":
            $0b2e6adb871a3b94$var$wj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $0b2e6adb871a3b94$var$ij(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $0b2e6adb871a3b94$var$Zi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $0b2e6adb871a3b94$var$rh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($0b2e6adb871a3b94$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $0b2e6adb871a3b94$var$Pg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $0b2e6adb871a3b94$var$Pg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $0b2e6adb871a3b94$var$yj(a, b, c) {
    switch(b.tag){
        case 3:
            $0b2e6adb871a3b94$var$kj(b);
            $0b2e6adb871a3b94$var$Ig();
            break;
        case 5:
            $0b2e6adb871a3b94$var$Ah(b);
            break;
        case 1:
            $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$cg(b);
            break;
        case 4:
            $0b2e6adb871a3b94$var$yh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $0b2e6adb871a3b94$var$oj(a, b, c);
                $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current & 1);
                a = $0b2e6adb871a3b94$var$Zi(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $0b2e6adb871a3b94$var$xj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $0b2e6adb871a3b94$var$dj(a, b, c);
    }
    return $0b2e6adb871a3b94$var$Zi(a, b, c);
}
var $0b2e6adb871a3b94$var$zj, $0b2e6adb871a3b94$var$Aj, $0b2e6adb871a3b94$var$Bj, $0b2e6adb871a3b94$var$Cj;
$0b2e6adb871a3b94$var$zj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$0b2e6adb871a3b94$var$Aj = function() {};
$0b2e6adb871a3b94$var$Bj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$uh.current);
        var f = null;
        switch(c){
            case "input":
                e = $0b2e6adb871a3b94$var$Ya(a, e);
                d = $0b2e6adb871a3b94$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $0b2e6adb871a3b94$var$A({}, e, {
                    value: void 0
                });
                d = $0b2e6adb871a3b94$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $0b2e6adb871a3b94$var$gb(a, e);
                d = $0b2e6adb871a3b94$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $0b2e6adb871a3b94$var$Bf);
        }
        $0b2e6adb871a3b94$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $0b2e6adb871a3b94$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$0b2e6adb871a3b94$var$Cj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $0b2e6adb871a3b94$var$Dj(a, b) {
    if (!$0b2e6adb871a3b94$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $0b2e6adb871a3b94$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $0b2e6adb871a3b94$var$Ej(a, b, c) {
    var d = b.pendingProps;
    $0b2e6adb871a3b94$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $0b2e6adb871a3b94$var$S(b), null;
        case 1:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), $0b2e6adb871a3b94$var$S(b), null;
        case 3:
            d = b.stateNode;
            $0b2e6adb871a3b94$var$zh();
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
            $0b2e6adb871a3b94$var$Eh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $0b2e6adb871a3b94$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $0b2e6adb871a3b94$var$zg && ($0b2e6adb871a3b94$var$Fj($0b2e6adb871a3b94$var$zg), $0b2e6adb871a3b94$var$zg = null));
            $0b2e6adb871a3b94$var$Aj(a, b);
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 5:
            $0b2e6adb871a3b94$var$Bh(b);
            var e = $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$wh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $0b2e6adb871a3b94$var$Bj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($0b2e6adb871a3b94$var$p(166));
                    $0b2e6adb871a3b94$var$S(b);
                    return null;
                }
                a = $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$uh.current);
                if ($0b2e6adb871a3b94$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$0b2e6adb871a3b94$var$Of] = b;
                    d[$0b2e6adb871a3b94$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $0b2e6adb871a3b94$var$D("cancel", d);
                            $0b2e6adb871a3b94$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $0b2e6adb871a3b94$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $0b2e6adb871a3b94$var$lf.length; e++)$0b2e6adb871a3b94$var$D($0b2e6adb871a3b94$var$lf[e], d);
                            break;
                        case "source":
                            $0b2e6adb871a3b94$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $0b2e6adb871a3b94$var$D("error", d);
                            $0b2e6adb871a3b94$var$D("load", d);
                            break;
                        case "details":
                            $0b2e6adb871a3b94$var$D("toggle", d);
                            break;
                        case "input":
                            $0b2e6adb871a3b94$var$Za(d, f);
                            $0b2e6adb871a3b94$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $0b2e6adb871a3b94$var$D("invalid", d);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$hb(d, f), $0b2e6adb871a3b94$var$D("invalid", d);
                    }
                    $0b2e6adb871a3b94$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $0b2e6adb871a3b94$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $0b2e6adb871a3b94$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $0b2e6adb871a3b94$var$Va(d);
                            $0b2e6adb871a3b94$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$Va(d);
                            $0b2e6adb871a3b94$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $0b2e6adb871a3b94$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $0b2e6adb871a3b94$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$0b2e6adb871a3b94$var$Of] = b;
                    a[$0b2e6adb871a3b94$var$Pf] = d;
                    $0b2e6adb871a3b94$var$zj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $0b2e6adb871a3b94$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $0b2e6adb871a3b94$var$D("cancel", a);
                                $0b2e6adb871a3b94$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $0b2e6adb871a3b94$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $0b2e6adb871a3b94$var$lf.length; e++)$0b2e6adb871a3b94$var$D($0b2e6adb871a3b94$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $0b2e6adb871a3b94$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $0b2e6adb871a3b94$var$D("error", a);
                                $0b2e6adb871a3b94$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $0b2e6adb871a3b94$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $0b2e6adb871a3b94$var$Za(a, d);
                                e = $0b2e6adb871a3b94$var$Ya(a, d);
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $0b2e6adb871a3b94$var$A({}, d, {
                                    value: void 0
                                });
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            case "textarea":
                                $0b2e6adb871a3b94$var$hb(a, d);
                                e = $0b2e6adb871a3b94$var$gb(a, d);
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $0b2e6adb871a3b94$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $0b2e6adb871a3b94$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $0b2e6adb871a3b94$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $0b2e6adb871a3b94$var$ob(a, k) : "number" === typeof k && $0b2e6adb871a3b94$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $0b2e6adb871a3b94$var$D("scroll", a) : null != k && $0b2e6adb871a3b94$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $0b2e6adb871a3b94$var$Va(a);
                                $0b2e6adb871a3b94$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $0b2e6adb871a3b94$var$Va(a);
                                $0b2e6adb871a3b94$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $0b2e6adb871a3b94$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $0b2e6adb871a3b94$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $0b2e6adb871a3b94$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $0b2e6adb871a3b94$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $0b2e6adb871a3b94$var$Cj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($0b2e6adb871a3b94$var$p(166));
                c = $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$wh.current);
                $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$uh.current);
                if ($0b2e6adb871a3b94$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$0b2e6adb871a3b94$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $0b2e6adb871a3b94$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $0b2e6adb871a3b94$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$0b2e6adb871a3b94$var$Of] = b, b.stateNode = d;
            }
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 13:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($0b2e6adb871a3b94$var$I && null !== $0b2e6adb871a3b94$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $0b2e6adb871a3b94$var$Hg(), $0b2e6adb871a3b94$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $0b2e6adb871a3b94$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($0b2e6adb871a3b94$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($0b2e6adb871a3b94$var$p(317));
                        f[$0b2e6adb871a3b94$var$Of] = b;
                    } else $0b2e6adb871a3b94$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $0b2e6adb871a3b94$var$S(b);
                    f = !1;
                } else null !== $0b2e6adb871a3b94$var$zg && ($0b2e6adb871a3b94$var$Fj($0b2e6adb871a3b94$var$zg), $0b2e6adb871a3b94$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($0b2e6adb871a3b94$var$L.current & 1) ? 0 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 3) : $0b2e6adb871a3b94$var$tj()));
            null !== b.updateQueue && (b.flags |= 4);
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 4:
            return $0b2e6adb871a3b94$var$zh(), $0b2e6adb871a3b94$var$Aj(a, b), null === a && $0b2e6adb871a3b94$var$sf(b.stateNode.containerInfo), $0b2e6adb871a3b94$var$S(b), null;
        case 10:
            return $0b2e6adb871a3b94$var$ah(b.type._context), $0b2e6adb871a3b94$var$S(b), null;
        case 17:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), $0b2e6adb871a3b94$var$S(b), null;
        case 19:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
            f = b.memoizedState;
            if (null === f) return $0b2e6adb871a3b94$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $0b2e6adb871a3b94$var$Dj(f, !1);
                else {
                    if (0 !== $0b2e6adb871a3b94$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $0b2e6adb871a3b94$var$Ch(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $0b2e6adb871a3b94$var$Dj(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $0b2e6adb871a3b94$var$B() > $0b2e6adb871a3b94$var$Gj && (b.flags |= 128, d = !0, $0b2e6adb871a3b94$var$Dj(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $0b2e6adb871a3b94$var$Ch(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $0b2e6adb871a3b94$var$Dj(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$0b2e6adb871a3b94$var$I) return $0b2e6adb871a3b94$var$S(b), null;
                    } else 2 * $0b2e6adb871a3b94$var$B() - f.renderingStartTime > $0b2e6adb871a3b94$var$Gj && 1073741824 !== c && (b.flags |= 128, d = !0, $0b2e6adb871a3b94$var$Dj(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $0b2e6adb871a3b94$var$B(), b.sibling = null, c = $0b2e6adb871a3b94$var$L.current, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, d ? c & 1 | 2 : c & 1), b;
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 22:
        case 23:
            return $0b2e6adb871a3b94$var$Hj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($0b2e6adb871a3b94$var$fj & 1073741824) && ($0b2e6adb871a3b94$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $0b2e6adb871a3b94$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($0b2e6adb871a3b94$var$p(156, b.tag));
}
function $0b2e6adb871a3b94$var$Ij(a, b) {
    $0b2e6adb871a3b94$var$wg(b);
    switch(b.tag){
        case 1:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $0b2e6adb871a3b94$var$zh(), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H), $0b2e6adb871a3b94$var$Eh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $0b2e6adb871a3b94$var$Bh(b), null;
        case 13:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($0b2e6adb871a3b94$var$p(340));
                $0b2e6adb871a3b94$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L), null;
        case 4:
            return $0b2e6adb871a3b94$var$zh(), null;
        case 10:
            return $0b2e6adb871a3b94$var$ah(b.type._context), null;
        case 22:
        case 23:
            return $0b2e6adb871a3b94$var$Hj(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $0b2e6adb871a3b94$var$Jj = !1, $0b2e6adb871a3b94$var$U = !1, $0b2e6adb871a3b94$var$Kj = "function" === typeof WeakSet ? WeakSet : Set, $0b2e6adb871a3b94$var$V = null;
function $0b2e6adb871a3b94$var$Lj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $0b2e6adb871a3b94$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $0b2e6adb871a3b94$var$Mj(a, b, c) {
    try {
        c();
    } catch (d) {
        $0b2e6adb871a3b94$var$W(a, b, d);
    }
}
var $0b2e6adb871a3b94$var$Nj = !1;
function $0b2e6adb871a3b94$var$Oj(a, b) {
    $0b2e6adb871a3b94$var$Cf = $0b2e6adb871a3b94$var$dd;
    a = $0b2e6adb871a3b94$var$Me();
    if ($0b2e6adb871a3b94$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $0b2e6adb871a3b94$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $0b2e6adb871a3b94$var$dd = !1;
    for($0b2e6adb871a3b94$var$V = b; null !== $0b2e6adb871a3b94$var$V;)if (b = $0b2e6adb871a3b94$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $0b2e6adb871a3b94$var$V = a;
    else for(; null !== $0b2e6adb871a3b94$var$V;){
        b = $0b2e6adb871a3b94$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $0b2e6adb871a3b94$var$Ci(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(163));
            }
        } catch (F) {
            $0b2e6adb871a3b94$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $0b2e6adb871a3b94$var$V = a;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
    n = $0b2e6adb871a3b94$var$Nj;
    $0b2e6adb871a3b94$var$Nj = !1;
    return n;
}
function $0b2e6adb871a3b94$var$Pj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $0b2e6adb871a3b94$var$Mj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $0b2e6adb871a3b94$var$Qj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $0b2e6adb871a3b94$var$Rj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $0b2e6adb871a3b94$var$Sj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $0b2e6adb871a3b94$var$Sj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$0b2e6adb871a3b94$var$Of], delete b[$0b2e6adb871a3b94$var$Pf], delete b[$0b2e6adb871a3b94$var$of], delete b[$0b2e6adb871a3b94$var$Qf], delete b[$0b2e6adb871a3b94$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $0b2e6adb871a3b94$var$Tj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $0b2e6adb871a3b94$var$Uj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $0b2e6adb871a3b94$var$Tj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $0b2e6adb871a3b94$var$Vj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $0b2e6adb871a3b94$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($0b2e6adb871a3b94$var$Vj(a, b, c), a = a.sibling; null !== a;)$0b2e6adb871a3b94$var$Vj(a, b, c), a = a.sibling;
}
function $0b2e6adb871a3b94$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($0b2e6adb871a3b94$var$Wj(a, b, c), a = a.sibling; null !== a;)$0b2e6adb871a3b94$var$Wj(a, b, c), a = a.sibling;
}
var $0b2e6adb871a3b94$var$X = null, $0b2e6adb871a3b94$var$Xj = !1;
function $0b2e6adb871a3b94$var$Yj(a, b, c) {
    for(c = c.child; null !== c;)$0b2e6adb871a3b94$var$Zj(a, b, c), c = c.sibling;
}
function $0b2e6adb871a3b94$var$Zj(a, b, c) {
    if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onCommitFiberUnmount) try {
        $0b2e6adb871a3b94$var$lc.onCommitFiberUnmount($0b2e6adb871a3b94$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $0b2e6adb871a3b94$var$U || $0b2e6adb871a3b94$var$Lj(c, b);
        case 6:
            var d = $0b2e6adb871a3b94$var$X, e = $0b2e6adb871a3b94$var$Xj;
            $0b2e6adb871a3b94$var$X = null;
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            $0b2e6adb871a3b94$var$X = d;
            $0b2e6adb871a3b94$var$Xj = e;
            null !== $0b2e6adb871a3b94$var$X && ($0b2e6adb871a3b94$var$Xj ? (a = $0b2e6adb871a3b94$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $0b2e6adb871a3b94$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $0b2e6adb871a3b94$var$X && ($0b2e6adb871a3b94$var$Xj ? (a = $0b2e6adb871a3b94$var$X, c = c.stateNode, 8 === a.nodeType ? $0b2e6adb871a3b94$var$Kf(a.parentNode, c) : 1 === a.nodeType && $0b2e6adb871a3b94$var$Kf(a, c), $0b2e6adb871a3b94$var$bd(a)) : $0b2e6adb871a3b94$var$Kf($0b2e6adb871a3b94$var$X, c.stateNode));
            break;
        case 4:
            d = $0b2e6adb871a3b94$var$X;
            e = $0b2e6adb871a3b94$var$Xj;
            $0b2e6adb871a3b94$var$X = c.stateNode.containerInfo;
            $0b2e6adb871a3b94$var$Xj = !0;
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            $0b2e6adb871a3b94$var$X = d;
            $0b2e6adb871a3b94$var$Xj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$0b2e6adb871a3b94$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $0b2e6adb871a3b94$var$Mj(c, b, g) : 0 !== (f & 4) && $0b2e6adb871a3b94$var$Mj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            break;
        case 1:
            if (!$0b2e6adb871a3b94$var$U && ($0b2e6adb871a3b94$var$Lj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $0b2e6adb871a3b94$var$W(c, b, h);
            }
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            break;
        case 21:
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($0b2e6adb871a3b94$var$U = (d = $0b2e6adb871a3b94$var$U) || null !== c.memoizedState, $0b2e6adb871a3b94$var$Yj(a, b, c), $0b2e6adb871a3b94$var$U = d) : $0b2e6adb871a3b94$var$Yj(a, b, c);
            break;
        default:
            $0b2e6adb871a3b94$var$Yj(a, b, c);
    }
}
function $0b2e6adb871a3b94$var$ak(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $0b2e6adb871a3b94$var$Kj);
        b.forEach(function(b) {
            var d = $0b2e6adb871a3b94$var$bk.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $0b2e6adb871a3b94$var$ck(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $0b2e6adb871a3b94$var$X = h.stateNode;
                        $0b2e6adb871a3b94$var$Xj = !1;
                        break a;
                    case 3:
                        $0b2e6adb871a3b94$var$X = h.stateNode.containerInfo;
                        $0b2e6adb871a3b94$var$Xj = !0;
                        break a;
                    case 4:
                        $0b2e6adb871a3b94$var$X = h.stateNode.containerInfo;
                        $0b2e6adb871a3b94$var$Xj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $0b2e6adb871a3b94$var$X) throw Error($0b2e6adb871a3b94$var$p(160));
            $0b2e6adb871a3b94$var$Zj(f, g, e);
            $0b2e6adb871a3b94$var$X = null;
            $0b2e6adb871a3b94$var$Xj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $0b2e6adb871a3b94$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$0b2e6adb871a3b94$var$dk(b, a), b = b.sibling;
}
function $0b2e6adb871a3b94$var$dk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            if (d & 4) {
                try {
                    $0b2e6adb871a3b94$var$Pj(3, a, a.return), $0b2e6adb871a3b94$var$Qj(3, a);
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
                try {
                    $0b2e6adb871a3b94$var$Pj(5, a, a.return);
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            d & 512 && null !== c && $0b2e6adb871a3b94$var$Lj(c, c.return);
            break;
        case 5:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            d & 512 && null !== c && $0b2e6adb871a3b94$var$Lj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $0b2e6adb871a3b94$var$ob(e, "");
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $0b2e6adb871a3b94$var$ab(e, f);
                    $0b2e6adb871a3b94$var$vb(h, g);
                    var l = $0b2e6adb871a3b94$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $0b2e6adb871a3b94$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $0b2e6adb871a3b94$var$nb(e, q) : "children" === m ? $0b2e6adb871a3b94$var$ob(e, q) : $0b2e6adb871a3b94$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $0b2e6adb871a3b94$var$bb(e, f);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $0b2e6adb871a3b94$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $0b2e6adb871a3b94$var$fb(e, !!f.multiple, f.defaultValue, !0) : $0b2e6adb871a3b94$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$0b2e6adb871a3b94$var$Pf] = f;
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($0b2e6adb871a3b94$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $0b2e6adb871a3b94$var$bd(b.containerInfo);
            } catch (t) {
                $0b2e6adb871a3b94$var$W(a, a.return, t);
            }
            break;
        case 4:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            break;
        case 13:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($0b2e6adb871a3b94$var$fk = $0b2e6adb871a3b94$var$B()));
            d & 4 && $0b2e6adb871a3b94$var$ak(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($0b2e6adb871a3b94$var$U = (l = $0b2e6adb871a3b94$var$U) || m, $0b2e6adb871a3b94$var$ck(b, a), $0b2e6adb871a3b94$var$U = l) : $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($0b2e6adb871a3b94$var$V = a, m = a.child; null !== m;){
                    for(q = $0b2e6adb871a3b94$var$V = m; null !== $0b2e6adb871a3b94$var$V;){
                        r = $0b2e6adb871a3b94$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $0b2e6adb871a3b94$var$Pj(4, r, r.return);
                                break;
                            case 1:
                                $0b2e6adb871a3b94$var$Lj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $0b2e6adb871a3b94$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $0b2e6adb871a3b94$var$Lj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $0b2e6adb871a3b94$var$gk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $0b2e6adb871a3b94$var$V = y) : $0b2e6adb871a3b94$var$gk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $0b2e6adb871a3b94$var$rb("display", g));
                            } catch (t) {
                                $0b2e6adb871a3b94$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $0b2e6adb871a3b94$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            d & 4 && $0b2e6adb871a3b94$var$ak(a);
            break;
        case 21:
            break;
        default:
            $0b2e6adb871a3b94$var$ck(b, a), $0b2e6adb871a3b94$var$ek(a);
    }
}
function $0b2e6adb871a3b94$var$ek(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($0b2e6adb871a3b94$var$Tj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($0b2e6adb871a3b94$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($0b2e6adb871a3b94$var$ob(e, ""), d.flags &= -33);
                    var f = $0b2e6adb871a3b94$var$Uj(a);
                    $0b2e6adb871a3b94$var$Wj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $0b2e6adb871a3b94$var$Uj(a);
                    $0b2e6adb871a3b94$var$Vj(a, h, g);
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(161));
            }
        } catch (k) {
            $0b2e6adb871a3b94$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $0b2e6adb871a3b94$var$hk(a, b, c) {
    $0b2e6adb871a3b94$var$V = a;
    $0b2e6adb871a3b94$var$ik(a, b, c);
}
function $0b2e6adb871a3b94$var$ik(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $0b2e6adb871a3b94$var$V;){
        var e = $0b2e6adb871a3b94$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $0b2e6adb871a3b94$var$Jj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $0b2e6adb871a3b94$var$U;
                h = $0b2e6adb871a3b94$var$Jj;
                var l = $0b2e6adb871a3b94$var$U;
                $0b2e6adb871a3b94$var$Jj = g;
                if (($0b2e6adb871a3b94$var$U = k) && !l) for($0b2e6adb871a3b94$var$V = e; null !== $0b2e6adb871a3b94$var$V;)g = $0b2e6adb871a3b94$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $0b2e6adb871a3b94$var$jk(e) : null !== k ? (k.return = g, $0b2e6adb871a3b94$var$V = k) : $0b2e6adb871a3b94$var$jk(e);
                for(; null !== f;)$0b2e6adb871a3b94$var$V = f, $0b2e6adb871a3b94$var$ik(f, b, c), f = f.sibling;
                $0b2e6adb871a3b94$var$V = e;
                $0b2e6adb871a3b94$var$Jj = h;
                $0b2e6adb871a3b94$var$U = l;
            }
            $0b2e6adb871a3b94$var$kk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $0b2e6adb871a3b94$var$V = f) : $0b2e6adb871a3b94$var$kk(a, b, c);
    }
}
function $0b2e6adb871a3b94$var$kk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $0b2e6adb871a3b94$var$U || $0b2e6adb871a3b94$var$Qj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$0b2e6adb871a3b94$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $0b2e6adb871a3b94$var$Ci(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $0b2e6adb871a3b94$var$sh(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $0b2e6adb871a3b94$var$sh(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $0b2e6adb871a3b94$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($0b2e6adb871a3b94$var$p(163));
                }
                $0b2e6adb871a3b94$var$U || b.flags & 512 && $0b2e6adb871a3b94$var$Rj(b);
            } catch (r) {
                $0b2e6adb871a3b94$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $0b2e6adb871a3b94$var$V = c;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
function $0b2e6adb871a3b94$var$gk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $0b2e6adb871a3b94$var$V = c;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
function $0b2e6adb871a3b94$var$jk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Qj(4, b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $0b2e6adb871a3b94$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Rj(b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Rj(b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $0b2e6adb871a3b94$var$W(b, b.return, k);
        }
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $0b2e6adb871a3b94$var$V = h;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
var $0b2e6adb871a3b94$var$lk = Math.ceil, $0b2e6adb871a3b94$var$mk = $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher, $0b2e6adb871a3b94$var$nk = $0b2e6adb871a3b94$var$ua.ReactCurrentOwner, $0b2e6adb871a3b94$var$ok = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$K = 0, $0b2e6adb871a3b94$var$Q = null, $0b2e6adb871a3b94$var$Y = null, $0b2e6adb871a3b94$var$Z = 0, $0b2e6adb871a3b94$var$fj = 0, $0b2e6adb871a3b94$var$ej = $0b2e6adb871a3b94$var$Uf(0), $0b2e6adb871a3b94$var$T = 0, $0b2e6adb871a3b94$var$pk = null, $0b2e6adb871a3b94$var$rh = 0, $0b2e6adb871a3b94$var$qk = 0, $0b2e6adb871a3b94$var$rk = 0, $0b2e6adb871a3b94$var$sk = null, $0b2e6adb871a3b94$var$tk = null, $0b2e6adb871a3b94$var$fk = 0, $0b2e6adb871a3b94$var$Gj = Infinity, $0b2e6adb871a3b94$var$uk = null, $0b2e6adb871a3b94$var$Oi = !1, $0b2e6adb871a3b94$var$Pi = null, $0b2e6adb871a3b94$var$Ri = null, $0b2e6adb871a3b94$var$vk = !1, $0b2e6adb871a3b94$var$wk = null, $0b2e6adb871a3b94$var$xk = 0, $0b2e6adb871a3b94$var$yk = 0, $0b2e6adb871a3b94$var$zk = null, $0b2e6adb871a3b94$var$Ak = -1, $0b2e6adb871a3b94$var$Bk = 0;
function $0b2e6adb871a3b94$var$R() {
    return 0 !== ($0b2e6adb871a3b94$var$K & 6) ? $0b2e6adb871a3b94$var$B() : -1 !== $0b2e6adb871a3b94$var$Ak ? $0b2e6adb871a3b94$var$Ak : $0b2e6adb871a3b94$var$Ak = $0b2e6adb871a3b94$var$B();
}
function $0b2e6adb871a3b94$var$yi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($0b2e6adb871a3b94$var$K & 2) && 0 !== $0b2e6adb871a3b94$var$Z) return $0b2e6adb871a3b94$var$Z & -$0b2e6adb871a3b94$var$Z;
    if (null !== $0b2e6adb871a3b94$var$Kg.transition) return 0 === $0b2e6adb871a3b94$var$Bk && ($0b2e6adb871a3b94$var$Bk = $0b2e6adb871a3b94$var$yc()), $0b2e6adb871a3b94$var$Bk;
    a = $0b2e6adb871a3b94$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $0b2e6adb871a3b94$var$jd(a.type);
    return a;
}
function $0b2e6adb871a3b94$var$gi(a, b, c, d) {
    if (50 < $0b2e6adb871a3b94$var$yk) throw $0b2e6adb871a3b94$var$yk = 0, $0b2e6adb871a3b94$var$zk = null, Error($0b2e6adb871a3b94$var$p(185));
    $0b2e6adb871a3b94$var$Ac(a, c, d);
    if (0 === ($0b2e6adb871a3b94$var$K & 2) || a !== $0b2e6adb871a3b94$var$Q) a === $0b2e6adb871a3b94$var$Q && (0 === ($0b2e6adb871a3b94$var$K & 2) && ($0b2e6adb871a3b94$var$qk |= c), 4 === $0b2e6adb871a3b94$var$T && $0b2e6adb871a3b94$var$Ck(a, $0b2e6adb871a3b94$var$Z)), $0b2e6adb871a3b94$var$Dk(a, d), 1 === c && 0 === $0b2e6adb871a3b94$var$K && 0 === (b.mode & 1) && ($0b2e6adb871a3b94$var$Gj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$fg && $0b2e6adb871a3b94$var$jg());
}
function $0b2e6adb871a3b94$var$Dk(a, b) {
    var c = a.callbackNode;
    $0b2e6adb871a3b94$var$wc(a, b);
    var d = $0b2e6adb871a3b94$var$uc(a, a === $0b2e6adb871a3b94$var$Q ? $0b2e6adb871a3b94$var$Z : 0);
    if (0 === d) null !== c && $0b2e6adb871a3b94$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $0b2e6adb871a3b94$var$bc(c);
        if (1 === b) 0 === a.tag ? $0b2e6adb871a3b94$var$ig($0b2e6adb871a3b94$var$Ek.bind(null, a)) : $0b2e6adb871a3b94$var$hg($0b2e6adb871a3b94$var$Ek.bind(null, a)), $0b2e6adb871a3b94$var$Jf(function() {
            0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$jg();
        }), c = null;
        else {
            switch($0b2e6adb871a3b94$var$Dc(d)){
                case 1:
                    c = $0b2e6adb871a3b94$var$fc;
                    break;
                case 4:
                    c = $0b2e6adb871a3b94$var$gc;
                    break;
                case 16:
                    c = $0b2e6adb871a3b94$var$hc;
                    break;
                case 536870912:
                    c = $0b2e6adb871a3b94$var$jc;
                    break;
                default:
                    c = $0b2e6adb871a3b94$var$hc;
            }
            c = $0b2e6adb871a3b94$var$Fk(c, $0b2e6adb871a3b94$var$Gk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $0b2e6adb871a3b94$var$Gk(a, b) {
    $0b2e6adb871a3b94$var$Ak = -1;
    $0b2e6adb871a3b94$var$Bk = 0;
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    var c = a.callbackNode;
    if ($0b2e6adb871a3b94$var$Hk() && a.callbackNode !== c) return null;
    var d = $0b2e6adb871a3b94$var$uc(a, a === $0b2e6adb871a3b94$var$Q ? $0b2e6adb871a3b94$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $0b2e6adb871a3b94$var$Ik(a, d);
    else {
        b = d;
        var e = $0b2e6adb871a3b94$var$K;
        $0b2e6adb871a3b94$var$K |= 2;
        var f = $0b2e6adb871a3b94$var$Jk();
        if ($0b2e6adb871a3b94$var$Q !== a || $0b2e6adb871a3b94$var$Z !== b) $0b2e6adb871a3b94$var$uk = null, $0b2e6adb871a3b94$var$Gj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$Kk(a, b);
        for(;;)try {
            $0b2e6adb871a3b94$var$Lk();
            break;
        } catch (h) {
            $0b2e6adb871a3b94$var$Mk(a, h);
        }
        $0b2e6adb871a3b94$var$$g();
        $0b2e6adb871a3b94$var$mk.current = f;
        $0b2e6adb871a3b94$var$K = e;
        null !== $0b2e6adb871a3b94$var$Y ? b = 0 : ($0b2e6adb871a3b94$var$Q = null, $0b2e6adb871a3b94$var$Z = 0, b = $0b2e6adb871a3b94$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $0b2e6adb871a3b94$var$xc(a), 0 !== e && (d = e, b = $0b2e6adb871a3b94$var$Nk(a, e)));
        if (1 === b) throw c = $0b2e6adb871a3b94$var$pk, $0b2e6adb871a3b94$var$Kk(a, 0), $0b2e6adb871a3b94$var$Ck(a, d), $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B()), c;
        if (6 === b) $0b2e6adb871a3b94$var$Ck(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$0b2e6adb871a3b94$var$Ok(e) && (b = $0b2e6adb871a3b94$var$Ik(a, d), 2 === b && (f = $0b2e6adb871a3b94$var$xc(a), 0 !== f && (d = f, b = $0b2e6adb871a3b94$var$Nk(a, f))), 1 === b)) throw c = $0b2e6adb871a3b94$var$pk, $0b2e6adb871a3b94$var$Kk(a, 0), $0b2e6adb871a3b94$var$Ck(a, d), $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($0b2e6adb871a3b94$var$p(345));
                case 2:
                    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
                    break;
                case 3:
                    $0b2e6adb871a3b94$var$Ck(a, d);
                    if ((d & 130023424) === d && (b = $0b2e6adb871a3b94$var$fk + 500 - $0b2e6adb871a3b94$var$B(), 10 < b)) {
                        if (0 !== $0b2e6adb871a3b94$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $0b2e6adb871a3b94$var$R();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $0b2e6adb871a3b94$var$Ff($0b2e6adb871a3b94$var$Pk.bind(null, a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk), b);
                        break;
                    }
                    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
                    break;
                case 4:
                    $0b2e6adb871a3b94$var$Ck(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $0b2e6adb871a3b94$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $0b2e6adb871a3b94$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $0b2e6adb871a3b94$var$lk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $0b2e6adb871a3b94$var$Ff($0b2e6adb871a3b94$var$Pk.bind(null, a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk), d);
                        break;
                    }
                    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
                    break;
                case 5:
                    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(329));
            }
        }
    }
    $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B());
    return a.callbackNode === c ? $0b2e6adb871a3b94$var$Gk.bind(null, a) : null;
}
function $0b2e6adb871a3b94$var$Nk(a, b) {
    var c = $0b2e6adb871a3b94$var$sk;
    a.current.memoizedState.isDehydrated && ($0b2e6adb871a3b94$var$Kk(a, b).flags |= 256);
    a = $0b2e6adb871a3b94$var$Ik(a, b);
    2 !== a && (b = $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$tk = c, null !== b && $0b2e6adb871a3b94$var$Fj(b));
    return a;
}
function $0b2e6adb871a3b94$var$Fj(a) {
    null === $0b2e6adb871a3b94$var$tk ? $0b2e6adb871a3b94$var$tk = a : $0b2e6adb871a3b94$var$tk.push.apply($0b2e6adb871a3b94$var$tk, a);
}
function $0b2e6adb871a3b94$var$Ok(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$0b2e6adb871a3b94$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Ck(a, b) {
    b &= ~$0b2e6adb871a3b94$var$rk;
    b &= ~$0b2e6adb871a3b94$var$qk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $0b2e6adb871a3b94$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $0b2e6adb871a3b94$var$Ek(a) {
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    $0b2e6adb871a3b94$var$Hk();
    var b = $0b2e6adb871a3b94$var$uc(a, 0);
    if (0 === (b & 1)) return $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B()), null;
    var c = $0b2e6adb871a3b94$var$Ik(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $0b2e6adb871a3b94$var$xc(a);
        0 !== d && (b = d, c = $0b2e6adb871a3b94$var$Nk(a, d));
    }
    if (1 === c) throw c = $0b2e6adb871a3b94$var$pk, $0b2e6adb871a3b94$var$Kk(a, 0), $0b2e6adb871a3b94$var$Ck(a, b), $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B()), c;
    if (6 === c) throw Error($0b2e6adb871a3b94$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
    $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B());
    return null;
}
function $0b2e6adb871a3b94$var$Qk(a, b) {
    var c = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 1;
    try {
        return a(b);
    } finally{
        $0b2e6adb871a3b94$var$K = c, 0 === $0b2e6adb871a3b94$var$K && ($0b2e6adb871a3b94$var$Gj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$fg && $0b2e6adb871a3b94$var$jg());
    }
}
function $0b2e6adb871a3b94$var$Rk(a) {
    null !== $0b2e6adb871a3b94$var$wk && 0 === $0b2e6adb871a3b94$var$wk.tag && 0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$Hk();
    var b = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 1;
    var c = $0b2e6adb871a3b94$var$ok.transition, d = $0b2e6adb871a3b94$var$C;
    try {
        if ($0b2e6adb871a3b94$var$ok.transition = null, $0b2e6adb871a3b94$var$C = 1, a) return a();
    } finally{
        $0b2e6adb871a3b94$var$C = d, $0b2e6adb871a3b94$var$ok.transition = c, $0b2e6adb871a3b94$var$K = b, 0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$jg();
    }
}
function $0b2e6adb871a3b94$var$Hj() {
    $0b2e6adb871a3b94$var$fj = $0b2e6adb871a3b94$var$ej.current;
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$ej);
}
function $0b2e6adb871a3b94$var$Kk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $0b2e6adb871a3b94$var$Gf(c));
    if (null !== $0b2e6adb871a3b94$var$Y) for(c = $0b2e6adb871a3b94$var$Y.return; null !== c;){
        var d = c;
        $0b2e6adb871a3b94$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $0b2e6adb871a3b94$var$$f();
                break;
            case 3:
                $0b2e6adb871a3b94$var$zh();
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
                $0b2e6adb871a3b94$var$Eh();
                break;
            case 5:
                $0b2e6adb871a3b94$var$Bh(d);
                break;
            case 4:
                $0b2e6adb871a3b94$var$zh();
                break;
            case 13:
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
                break;
            case 19:
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
                break;
            case 10:
                $0b2e6adb871a3b94$var$ah(d.type._context);
                break;
            case 22:
            case 23:
                $0b2e6adb871a3b94$var$Hj();
        }
        c = c.return;
    }
    $0b2e6adb871a3b94$var$Q = a;
    $0b2e6adb871a3b94$var$Y = a = $0b2e6adb871a3b94$var$Pg(a.current, null);
    $0b2e6adb871a3b94$var$Z = $0b2e6adb871a3b94$var$fj = b;
    $0b2e6adb871a3b94$var$T = 0;
    $0b2e6adb871a3b94$var$pk = null;
    $0b2e6adb871a3b94$var$rk = $0b2e6adb871a3b94$var$qk = $0b2e6adb871a3b94$var$rh = 0;
    $0b2e6adb871a3b94$var$tk = $0b2e6adb871a3b94$var$sk = null;
    if (null !== $0b2e6adb871a3b94$var$fh) {
        for(b = 0; b < $0b2e6adb871a3b94$var$fh.length; b++)if (c = $0b2e6adb871a3b94$var$fh[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $0b2e6adb871a3b94$var$fh = null;
    }
    return a;
}
function $0b2e6adb871a3b94$var$Mk(a, b) {
    do {
        var c = $0b2e6adb871a3b94$var$Y;
        try {
            $0b2e6adb871a3b94$var$$g();
            $0b2e6adb871a3b94$var$Fh.current = $0b2e6adb871a3b94$var$Rh;
            if ($0b2e6adb871a3b94$var$Ih) {
                for(var d = $0b2e6adb871a3b94$var$M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $0b2e6adb871a3b94$var$Ih = !1;
            }
            $0b2e6adb871a3b94$var$Hh = 0;
            $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$N = $0b2e6adb871a3b94$var$M = null;
            $0b2e6adb871a3b94$var$Jh = !1;
            $0b2e6adb871a3b94$var$Kh = 0;
            $0b2e6adb871a3b94$var$nk.current = null;
            if (null === c || null === c.return) {
                $0b2e6adb871a3b94$var$T = 1;
                $0b2e6adb871a3b94$var$pk = b;
                $0b2e6adb871a3b94$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $0b2e6adb871a3b94$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $0b2e6adb871a3b94$var$Ui(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $0b2e6adb871a3b94$var$Vi(y, g, h, f, b);
                        y.mode & 1 && $0b2e6adb871a3b94$var$Si(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $0b2e6adb871a3b94$var$Si(f, l, b);
                            $0b2e6adb871a3b94$var$tj();
                            break a;
                        }
                        k = Error($0b2e6adb871a3b94$var$p(426));
                    }
                } else if ($0b2e6adb871a3b94$var$I && h.mode & 1) {
                    var J = $0b2e6adb871a3b94$var$Ui(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $0b2e6adb871a3b94$var$Vi(J, g, h, f, b);
                        $0b2e6adb871a3b94$var$Jg($0b2e6adb871a3b94$var$Ji(k, h));
                        break a;
                    }
                }
                f = k = $0b2e6adb871a3b94$var$Ji(k, h);
                4 !== $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 2);
                null === $0b2e6adb871a3b94$var$sk ? $0b2e6adb871a3b94$var$sk = [
                    f
                ] : $0b2e6adb871a3b94$var$sk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $0b2e6adb871a3b94$var$Ni(f, k, b);
                            $0b2e6adb871a3b94$var$ph(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $0b2e6adb871a3b94$var$Ri || !$0b2e6adb871a3b94$var$Ri.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $0b2e6adb871a3b94$var$Qi(f, h, b);
                                $0b2e6adb871a3b94$var$ph(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $0b2e6adb871a3b94$var$Sk(c);
        } catch (na) {
            b = na;
            $0b2e6adb871a3b94$var$Y === c && null !== c && ($0b2e6adb871a3b94$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $0b2e6adb871a3b94$var$Jk() {
    var a = $0b2e6adb871a3b94$var$mk.current;
    $0b2e6adb871a3b94$var$mk.current = $0b2e6adb871a3b94$var$Rh;
    return null === a ? $0b2e6adb871a3b94$var$Rh : a;
}
function $0b2e6adb871a3b94$var$tj() {
    if (0 === $0b2e6adb871a3b94$var$T || 3 === $0b2e6adb871a3b94$var$T || 2 === $0b2e6adb871a3b94$var$T) $0b2e6adb871a3b94$var$T = 4;
    null === $0b2e6adb871a3b94$var$Q || 0 === ($0b2e6adb871a3b94$var$rh & 268435455) && 0 === ($0b2e6adb871a3b94$var$qk & 268435455) || $0b2e6adb871a3b94$var$Ck($0b2e6adb871a3b94$var$Q, $0b2e6adb871a3b94$var$Z);
}
function $0b2e6adb871a3b94$var$Ik(a, b) {
    var c = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 2;
    var d = $0b2e6adb871a3b94$var$Jk();
    if ($0b2e6adb871a3b94$var$Q !== a || $0b2e6adb871a3b94$var$Z !== b) $0b2e6adb871a3b94$var$uk = null, $0b2e6adb871a3b94$var$Kk(a, b);
    for(;;)try {
        $0b2e6adb871a3b94$var$Tk();
        break;
    } catch (e) {
        $0b2e6adb871a3b94$var$Mk(a, e);
    }
    $0b2e6adb871a3b94$var$$g();
    $0b2e6adb871a3b94$var$K = c;
    $0b2e6adb871a3b94$var$mk.current = d;
    if (null !== $0b2e6adb871a3b94$var$Y) throw Error($0b2e6adb871a3b94$var$p(261));
    $0b2e6adb871a3b94$var$Q = null;
    $0b2e6adb871a3b94$var$Z = 0;
    return $0b2e6adb871a3b94$var$T;
}
function $0b2e6adb871a3b94$var$Tk() {
    for(; null !== $0b2e6adb871a3b94$var$Y;)$0b2e6adb871a3b94$var$Uk($0b2e6adb871a3b94$var$Y);
}
function $0b2e6adb871a3b94$var$Lk() {
    for(; null !== $0b2e6adb871a3b94$var$Y && !$0b2e6adb871a3b94$var$cc();)$0b2e6adb871a3b94$var$Uk($0b2e6adb871a3b94$var$Y);
}
function $0b2e6adb871a3b94$var$Uk(a) {
    var b = $0b2e6adb871a3b94$var$Vk(a.alternate, a, $0b2e6adb871a3b94$var$fj);
    a.memoizedProps = a.pendingProps;
    null === b ? $0b2e6adb871a3b94$var$Sk(a) : $0b2e6adb871a3b94$var$Y = b;
    $0b2e6adb871a3b94$var$nk.current = null;
}
function $0b2e6adb871a3b94$var$Sk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $0b2e6adb871a3b94$var$Ej(c, b, $0b2e6adb871a3b94$var$fj), null !== c) {
                $0b2e6adb871a3b94$var$Y = c;
                return;
            }
        } else {
            c = $0b2e6adb871a3b94$var$Ij(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $0b2e6adb871a3b94$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $0b2e6adb871a3b94$var$T = 6;
                $0b2e6adb871a3b94$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $0b2e6adb871a3b94$var$Y = b;
            return;
        }
        $0b2e6adb871a3b94$var$Y = b = a;
    }while (null !== b);
    0 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 5);
}
function $0b2e6adb871a3b94$var$Pk(a, b, c) {
    var d = $0b2e6adb871a3b94$var$C, e = $0b2e6adb871a3b94$var$ok.transition;
    try {
        $0b2e6adb871a3b94$var$ok.transition = null, $0b2e6adb871a3b94$var$C = 1, $0b2e6adb871a3b94$var$Wk(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$ok.transition = e, $0b2e6adb871a3b94$var$C = d;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Wk(a, b, c, d) {
    do $0b2e6adb871a3b94$var$Hk();
    while (null !== $0b2e6adb871a3b94$var$wk);
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($0b2e6adb871a3b94$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $0b2e6adb871a3b94$var$Bc(a, f);
    a === $0b2e6adb871a3b94$var$Q && ($0b2e6adb871a3b94$var$Y = $0b2e6adb871a3b94$var$Q = null, $0b2e6adb871a3b94$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $0b2e6adb871a3b94$var$vk || ($0b2e6adb871a3b94$var$vk = !0, $0b2e6adb871a3b94$var$Fk($0b2e6adb871a3b94$var$hc, function() {
        $0b2e6adb871a3b94$var$Hk();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $0b2e6adb871a3b94$var$ok.transition;
        $0b2e6adb871a3b94$var$ok.transition = null;
        var g = $0b2e6adb871a3b94$var$C;
        $0b2e6adb871a3b94$var$C = 1;
        var h = $0b2e6adb871a3b94$var$K;
        $0b2e6adb871a3b94$var$K |= 4;
        $0b2e6adb871a3b94$var$nk.current = null;
        $0b2e6adb871a3b94$var$Oj(a, c);
        $0b2e6adb871a3b94$var$dk(c, a);
        $0b2e6adb871a3b94$var$Oe($0b2e6adb871a3b94$var$Df);
        $0b2e6adb871a3b94$var$dd = !!$0b2e6adb871a3b94$var$Cf;
        $0b2e6adb871a3b94$var$Df = $0b2e6adb871a3b94$var$Cf = null;
        a.current = c;
        $0b2e6adb871a3b94$var$hk(c, a, e);
        $0b2e6adb871a3b94$var$dc();
        $0b2e6adb871a3b94$var$K = h;
        $0b2e6adb871a3b94$var$C = g;
        $0b2e6adb871a3b94$var$ok.transition = f;
    } else a.current = c;
    $0b2e6adb871a3b94$var$vk && ($0b2e6adb871a3b94$var$vk = !1, $0b2e6adb871a3b94$var$wk = a, $0b2e6adb871a3b94$var$xk = e);
    f = a.pendingLanes;
    0 === f && ($0b2e6adb871a3b94$var$Ri = null);
    $0b2e6adb871a3b94$var$mc(c.stateNode, d);
    $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($0b2e6adb871a3b94$var$Oi) throw $0b2e6adb871a3b94$var$Oi = !1, a = $0b2e6adb871a3b94$var$Pi, $0b2e6adb871a3b94$var$Pi = null, a;
    0 !== ($0b2e6adb871a3b94$var$xk & 1) && 0 !== a.tag && $0b2e6adb871a3b94$var$Hk();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $0b2e6adb871a3b94$var$zk ? $0b2e6adb871a3b94$var$yk++ : ($0b2e6adb871a3b94$var$yk = 0, $0b2e6adb871a3b94$var$zk = a) : $0b2e6adb871a3b94$var$yk = 0;
    $0b2e6adb871a3b94$var$jg();
    return null;
}
function $0b2e6adb871a3b94$var$Hk() {
    if (null !== $0b2e6adb871a3b94$var$wk) {
        var a = $0b2e6adb871a3b94$var$Dc($0b2e6adb871a3b94$var$xk), b = $0b2e6adb871a3b94$var$ok.transition, c = $0b2e6adb871a3b94$var$C;
        try {
            $0b2e6adb871a3b94$var$ok.transition = null;
            $0b2e6adb871a3b94$var$C = 16 > a ? 16 : a;
            if (null === $0b2e6adb871a3b94$var$wk) var d = !1;
            else {
                a = $0b2e6adb871a3b94$var$wk;
                $0b2e6adb871a3b94$var$wk = null;
                $0b2e6adb871a3b94$var$xk = 0;
                if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(331));
                var e = $0b2e6adb871a3b94$var$K;
                $0b2e6adb871a3b94$var$K |= 4;
                for($0b2e6adb871a3b94$var$V = a.current; null !== $0b2e6adb871a3b94$var$V;){
                    var f = $0b2e6adb871a3b94$var$V, g = f.child;
                    if (0 !== ($0b2e6adb871a3b94$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($0b2e6adb871a3b94$var$V = l; null !== $0b2e6adb871a3b94$var$V;){
                                    var m = $0b2e6adb871a3b94$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $0b2e6adb871a3b94$var$Pj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $0b2e6adb871a3b94$var$V = q;
                                    else for(; null !== $0b2e6adb871a3b94$var$V;){
                                        m = $0b2e6adb871a3b94$var$V;
                                        var r = m.sibling, y = m.return;
                                        $0b2e6adb871a3b94$var$Sj(m);
                                        if (m === l) {
                                            $0b2e6adb871a3b94$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $0b2e6adb871a3b94$var$V = r;
                                            break;
                                        }
                                        $0b2e6adb871a3b94$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $0b2e6adb871a3b94$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $0b2e6adb871a3b94$var$V = g;
                    else b: for(; null !== $0b2e6adb871a3b94$var$V;){
                        f = $0b2e6adb871a3b94$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $0b2e6adb871a3b94$var$Pj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $0b2e6adb871a3b94$var$V = x;
                            break b;
                        }
                        $0b2e6adb871a3b94$var$V = f.return;
                    }
                }
                var w = a.current;
                for($0b2e6adb871a3b94$var$V = w; null !== $0b2e6adb871a3b94$var$V;){
                    g = $0b2e6adb871a3b94$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $0b2e6adb871a3b94$var$V = u;
                    else b: for(g = w; null !== $0b2e6adb871a3b94$var$V;){
                        h = $0b2e6adb871a3b94$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $0b2e6adb871a3b94$var$Qj(9, h);
                            }
                        } catch (na) {
                            $0b2e6adb871a3b94$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $0b2e6adb871a3b94$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $0b2e6adb871a3b94$var$V = F;
                            break b;
                        }
                        $0b2e6adb871a3b94$var$V = h.return;
                    }
                }
                $0b2e6adb871a3b94$var$K = e;
                $0b2e6adb871a3b94$var$jg();
                if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onPostCommitFiberRoot) try {
                    $0b2e6adb871a3b94$var$lc.onPostCommitFiberRoot($0b2e6adb871a3b94$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $0b2e6adb871a3b94$var$C = c, $0b2e6adb871a3b94$var$ok.transition = b;
        }
    }
    return !1;
}
function $0b2e6adb871a3b94$var$Xk(a, b, c) {
    b = $0b2e6adb871a3b94$var$Ji(c, b);
    b = $0b2e6adb871a3b94$var$Ni(a, b, 1);
    a = $0b2e6adb871a3b94$var$nh(a, b, 1);
    b = $0b2e6adb871a3b94$var$R();
    null !== a && ($0b2e6adb871a3b94$var$Ac(a, 1, b), $0b2e6adb871a3b94$var$Dk(a, b));
}
function $0b2e6adb871a3b94$var$W(a, b, c) {
    if (3 === a.tag) $0b2e6adb871a3b94$var$Xk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $0b2e6adb871a3b94$var$Xk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $0b2e6adb871a3b94$var$Ri || !$0b2e6adb871a3b94$var$Ri.has(d))) {
                a = $0b2e6adb871a3b94$var$Ji(c, a);
                a = $0b2e6adb871a3b94$var$Qi(b, a, 1);
                b = $0b2e6adb871a3b94$var$nh(b, a, 1);
                a = $0b2e6adb871a3b94$var$R();
                null !== b && ($0b2e6adb871a3b94$var$Ac(b, 1, a), $0b2e6adb871a3b94$var$Dk(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $0b2e6adb871a3b94$var$Ti(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $0b2e6adb871a3b94$var$R();
    a.pingedLanes |= a.suspendedLanes & c;
    $0b2e6adb871a3b94$var$Q === a && ($0b2e6adb871a3b94$var$Z & c) === c && (4 === $0b2e6adb871a3b94$var$T || 3 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$Z & 130023424) === $0b2e6adb871a3b94$var$Z && 500 > $0b2e6adb871a3b94$var$B() - $0b2e6adb871a3b94$var$fk ? $0b2e6adb871a3b94$var$Kk(a, 0) : $0b2e6adb871a3b94$var$rk |= c);
    $0b2e6adb871a3b94$var$Dk(a, b);
}
function $0b2e6adb871a3b94$var$Yk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $0b2e6adb871a3b94$var$sc, $0b2e6adb871a3b94$var$sc <<= 1, 0 === ($0b2e6adb871a3b94$var$sc & 130023424) && ($0b2e6adb871a3b94$var$sc = 4194304)));
    var c = $0b2e6adb871a3b94$var$R();
    a = $0b2e6adb871a3b94$var$ih(a, b);
    null !== a && ($0b2e6adb871a3b94$var$Ac(a, b, c), $0b2e6adb871a3b94$var$Dk(a, c));
}
function $0b2e6adb871a3b94$var$uj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $0b2e6adb871a3b94$var$Yk(a, c);
}
function $0b2e6adb871a3b94$var$bk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($0b2e6adb871a3b94$var$p(314));
    }
    null !== d && d.delete(b);
    $0b2e6adb871a3b94$var$Yk(a, c);
}
var $0b2e6adb871a3b94$var$Vk;
$0b2e6adb871a3b94$var$Vk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $0b2e6adb871a3b94$var$Wf.current) $0b2e6adb871a3b94$var$dh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $0b2e6adb871a3b94$var$dh = !1, $0b2e6adb871a3b94$var$yj(a, b, c);
            $0b2e6adb871a3b94$var$dh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $0b2e6adb871a3b94$var$dh = !1, $0b2e6adb871a3b94$var$I && 0 !== (b.flags & 1048576) && $0b2e6adb871a3b94$var$ug(b, $0b2e6adb871a3b94$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $0b2e6adb871a3b94$var$ij(a, b);
            a = b.pendingProps;
            var e = $0b2e6adb871a3b94$var$Yf(b, $0b2e6adb871a3b94$var$H.current);
            $0b2e6adb871a3b94$var$ch(b, c);
            e = $0b2e6adb871a3b94$var$Nh(null, b, d, a, e, c);
            var f = $0b2e6adb871a3b94$var$Sh();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $0b2e6adb871a3b94$var$Zf(d) ? (f = !0, $0b2e6adb871a3b94$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $0b2e6adb871a3b94$var$kh(b), e.updater = $0b2e6adb871a3b94$var$Ei, b.stateNode = e, e._reactInternals = b, $0b2e6adb871a3b94$var$Ii(b, d, a, c), b = $0b2e6adb871a3b94$var$jj(null, b, d, !0, f, c)) : (b.tag = 0, $0b2e6adb871a3b94$var$I && f && $0b2e6adb871a3b94$var$vg(b), $0b2e6adb871a3b94$var$Xi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $0b2e6adb871a3b94$var$ij(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $0b2e6adb871a3b94$var$Zk(d);
                a = $0b2e6adb871a3b94$var$Ci(d, a);
                switch(e){
                    case 0:
                        b = $0b2e6adb871a3b94$var$cj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $0b2e6adb871a3b94$var$hj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $0b2e6adb871a3b94$var$Yi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $0b2e6adb871a3b94$var$$i(null, b, d, $0b2e6adb871a3b94$var$Ci(d.type, a), c);
                        break a;
                }
                throw Error($0b2e6adb871a3b94$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Ci(d, e), $0b2e6adb871a3b94$var$cj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Ci(d, e), $0b2e6adb871a3b94$var$hj(a, b, d, e, c);
        case 3:
            a: {
                $0b2e6adb871a3b94$var$kj(b);
                if (null === a) throw Error($0b2e6adb871a3b94$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $0b2e6adb871a3b94$var$lh(a, b);
                $0b2e6adb871a3b94$var$qh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $0b2e6adb871a3b94$var$Ji(Error($0b2e6adb871a3b94$var$p(423)), b);
                        b = $0b2e6adb871a3b94$var$lj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $0b2e6adb871a3b94$var$Ji(Error($0b2e6adb871a3b94$var$p(424)), b);
                        b = $0b2e6adb871a3b94$var$lj(a, b, d, c, e);
                        break a;
                    } else for($0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(b.stateNode.containerInfo.firstChild), $0b2e6adb871a3b94$var$xg = b, $0b2e6adb871a3b94$var$I = !0, $0b2e6adb871a3b94$var$zg = null, c = $0b2e6adb871a3b94$var$Vg(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $0b2e6adb871a3b94$var$Ig();
                    if (d === e) {
                        b = $0b2e6adb871a3b94$var$Zi(a, b, c);
                        break a;
                    }
                    $0b2e6adb871a3b94$var$Xi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $0b2e6adb871a3b94$var$Ah(b), null === a && $0b2e6adb871a3b94$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $0b2e6adb871a3b94$var$Ef(d, e) ? g = null : null !== f && $0b2e6adb871a3b94$var$Ef(d, f) && (b.flags |= 32), $0b2e6adb871a3b94$var$gj(a, b), $0b2e6adb871a3b94$var$Xi(a, b, g, c), b.child;
        case 6:
            return null === a && $0b2e6adb871a3b94$var$Eg(b), null;
        case 13:
            return $0b2e6adb871a3b94$var$oj(a, b, c);
        case 4:
            return $0b2e6adb871a3b94$var$yh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $0b2e6adb871a3b94$var$Ug(b, null, d, c) : $0b2e6adb871a3b94$var$Xi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Ci(d, e), $0b2e6adb871a3b94$var$Yi(a, b, d, e, c);
        case 7:
            return $0b2e6adb871a3b94$var$Xi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $0b2e6adb871a3b94$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $0b2e6adb871a3b94$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($0b2e6adb871a3b94$var$He(f.value, g)) {
                        if (f.children === e.children && !$0b2e6adb871a3b94$var$Wf.current) {
                            b = $0b2e6adb871a3b94$var$Zi(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $0b2e6adb871a3b94$var$mh(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $0b2e6adb871a3b94$var$bh(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($0b2e6adb871a3b94$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $0b2e6adb871a3b94$var$bh(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $0b2e6adb871a3b94$var$Xi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $0b2e6adb871a3b94$var$ch(b, c), e = $0b2e6adb871a3b94$var$eh(e), d = d(e), b.flags |= 1, $0b2e6adb871a3b94$var$Xi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $0b2e6adb871a3b94$var$Ci(d, b.pendingProps), e = $0b2e6adb871a3b94$var$Ci(d.type, e), $0b2e6adb871a3b94$var$$i(a, b, d, e, c);
        case 15:
            return $0b2e6adb871a3b94$var$bj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Ci(d, e), $0b2e6adb871a3b94$var$ij(a, b), b.tag = 1, $0b2e6adb871a3b94$var$Zf(d) ? (a = !0, $0b2e6adb871a3b94$var$cg(b)) : a = !1, $0b2e6adb871a3b94$var$ch(b, c), $0b2e6adb871a3b94$var$Gi(b, d, e), $0b2e6adb871a3b94$var$Ii(b, d, e, c), $0b2e6adb871a3b94$var$jj(null, b, d, !0, a, c);
        case 19:
            return $0b2e6adb871a3b94$var$xj(a, b, c);
        case 22:
            return $0b2e6adb871a3b94$var$dj(a, b, c);
    }
    throw Error($0b2e6adb871a3b94$var$p(156, b.tag));
};
function $0b2e6adb871a3b94$var$Fk(a, b) {
    return $0b2e6adb871a3b94$var$ac(a, b);
}
function $0b2e6adb871a3b94$var$$k(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $0b2e6adb871a3b94$var$Bg(a, b, c, d) {
    return new $0b2e6adb871a3b94$var$$k(a, b, c, d);
}
function $0b2e6adb871a3b94$var$aj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $0b2e6adb871a3b94$var$Zk(a) {
    if ("function" === typeof a) return $0b2e6adb871a3b94$var$aj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $0b2e6adb871a3b94$var$Da) return 11;
        if (a === $0b2e6adb871a3b94$var$Ga) return 14;
    }
    return 2;
}
function $0b2e6adb871a3b94$var$Pg(a, b) {
    var c = a.alternate;
    null === c ? (c = $0b2e6adb871a3b94$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $0b2e6adb871a3b94$var$Rg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $0b2e6adb871a3b94$var$aj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $0b2e6adb871a3b94$var$ya:
            return $0b2e6adb871a3b94$var$Tg(c.children, e, f, b);
        case $0b2e6adb871a3b94$var$za:
            g = 8;
            e |= 8;
            break;
        case $0b2e6adb871a3b94$var$Aa:
            return a = $0b2e6adb871a3b94$var$Bg(12, c, b, e | 2), a.elementType = $0b2e6adb871a3b94$var$Aa, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Ea:
            return a = $0b2e6adb871a3b94$var$Bg(13, c, b, e), a.elementType = $0b2e6adb871a3b94$var$Ea, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Fa:
            return a = $0b2e6adb871a3b94$var$Bg(19, c, b, e), a.elementType = $0b2e6adb871a3b94$var$Fa, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Ia:
            return $0b2e6adb871a3b94$var$pj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $0b2e6adb871a3b94$var$Ba:
                    g = 10;
                    break a;
                case $0b2e6adb871a3b94$var$Ca:
                    g = 9;
                    break a;
                case $0b2e6adb871a3b94$var$Da:
                    g = 11;
                    break a;
                case $0b2e6adb871a3b94$var$Ga:
                    g = 14;
                    break a;
                case $0b2e6adb871a3b94$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($0b2e6adb871a3b94$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $0b2e6adb871a3b94$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $0b2e6adb871a3b94$var$Tg(a, b, c, d) {
    a = $0b2e6adb871a3b94$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $0b2e6adb871a3b94$var$pj(a, b, c, d) {
    a = $0b2e6adb871a3b94$var$Bg(22, a, d, b);
    a.elementType = $0b2e6adb871a3b94$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $0b2e6adb871a3b94$var$Qg(a, b, c) {
    a = $0b2e6adb871a3b94$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $0b2e6adb871a3b94$var$Sg(a, b, c) {
    b = $0b2e6adb871a3b94$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $0b2e6adb871a3b94$var$al(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $0b2e6adb871a3b94$var$zc(0);
    this.expirationTimes = $0b2e6adb871a3b94$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $0b2e6adb871a3b94$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $0b2e6adb871a3b94$var$bl(a, b, c, d, e, f, g, h, k) {
    a = new $0b2e6adb871a3b94$var$al(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $0b2e6adb871a3b94$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $0b2e6adb871a3b94$var$kh(f);
    return a;
}
function $0b2e6adb871a3b94$var$cl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $0b2e6adb871a3b94$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $0b2e6adb871a3b94$var$dl(a) {
    if (!a) return $0b2e6adb871a3b94$var$Vf;
    a = a._reactInternals;
    a: {
        if ($0b2e6adb871a3b94$var$Vb(a) !== a || 1 !== a.tag) throw Error($0b2e6adb871a3b94$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($0b2e6adb871a3b94$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($0b2e6adb871a3b94$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($0b2e6adb871a3b94$var$Zf(c)) return $0b2e6adb871a3b94$var$bg(a, c, b);
    }
    return b;
}
function $0b2e6adb871a3b94$var$el(a, b, c, d, e, f, g, h, k) {
    a = $0b2e6adb871a3b94$var$bl(c, d, !0, a, e, f, g, h, k);
    a.context = $0b2e6adb871a3b94$var$dl(null);
    c = a.current;
    d = $0b2e6adb871a3b94$var$R();
    e = $0b2e6adb871a3b94$var$yi(c);
    f = $0b2e6adb871a3b94$var$mh(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $0b2e6adb871a3b94$var$nh(c, f, e);
    a.current.lanes = e;
    $0b2e6adb871a3b94$var$Ac(a, e, d);
    $0b2e6adb871a3b94$var$Dk(a, d);
    return a;
}
function $0b2e6adb871a3b94$var$fl(a, b, c, d) {
    var e = b.current, f = $0b2e6adb871a3b94$var$R(), g = $0b2e6adb871a3b94$var$yi(e);
    c = $0b2e6adb871a3b94$var$dl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $0b2e6adb871a3b94$var$mh(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $0b2e6adb871a3b94$var$nh(e, b, g);
    null !== a && ($0b2e6adb871a3b94$var$gi(a, e, g, f), $0b2e6adb871a3b94$var$oh(a, e, g));
    return g;
}
function $0b2e6adb871a3b94$var$gl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $0b2e6adb871a3b94$var$hl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $0b2e6adb871a3b94$var$il(a, b) {
    $0b2e6adb871a3b94$var$hl(a, b);
    (a = a.alternate) && $0b2e6adb871a3b94$var$hl(a, b);
}
function $0b2e6adb871a3b94$var$jl() {
    return null;
}
var $0b2e6adb871a3b94$var$kl = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $0b2e6adb871a3b94$var$ll(a) {
    this._internalRoot = a;
}
$0b2e6adb871a3b94$var$ml.prototype.render = $0b2e6adb871a3b94$var$ll.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($0b2e6adb871a3b94$var$p(409));
    $0b2e6adb871a3b94$var$fl(a, b, null, null);
};
$0b2e6adb871a3b94$var$ml.prototype.unmount = $0b2e6adb871a3b94$var$ll.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $0b2e6adb871a3b94$var$Rk(function() {
            $0b2e6adb871a3b94$var$fl(null, a, null, null);
        });
        b[$0b2e6adb871a3b94$var$uf] = null;
    }
};
function $0b2e6adb871a3b94$var$ml(a) {
    this._internalRoot = a;
}
$0b2e6adb871a3b94$var$ml.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $0b2e6adb871a3b94$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $0b2e6adb871a3b94$var$Qc.length && 0 !== b && b < $0b2e6adb871a3b94$var$Qc[c].priority; c++);
        $0b2e6adb871a3b94$var$Qc.splice(c, 0, a);
        0 === c && $0b2e6adb871a3b94$var$Vc(a);
    }
};
function $0b2e6adb871a3b94$var$nl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $0b2e6adb871a3b94$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $0b2e6adb871a3b94$var$pl() {}
function $0b2e6adb871a3b94$var$ql(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $0b2e6adb871a3b94$var$gl(g);
                f.call(a);
            };
        }
        var g = $0b2e6adb871a3b94$var$el(b, d, a, 0, null, !1, !1, "", $0b2e6adb871a3b94$var$pl);
        a._reactRootContainer = g;
        a[$0b2e6adb871a3b94$var$uf] = g.current;
        $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
        $0b2e6adb871a3b94$var$Rk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $0b2e6adb871a3b94$var$gl(k);
            h.call(a);
        };
    }
    var k = $0b2e6adb871a3b94$var$bl(a, 0, !1, null, null, !1, !1, "", $0b2e6adb871a3b94$var$pl);
    a._reactRootContainer = k;
    a[$0b2e6adb871a3b94$var$uf] = k.current;
    $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
    $0b2e6adb871a3b94$var$Rk(function() {
        $0b2e6adb871a3b94$var$fl(b, k, c, d);
    });
    return k;
}
function $0b2e6adb871a3b94$var$rl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $0b2e6adb871a3b94$var$gl(g);
                h.call(a);
            };
        }
        $0b2e6adb871a3b94$var$fl(b, g, a, e);
    } else g = $0b2e6adb871a3b94$var$ql(c, b, a, e, d);
    return $0b2e6adb871a3b94$var$gl(g);
}
$0b2e6adb871a3b94$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $0b2e6adb871a3b94$var$tc(b.pendingLanes);
                0 !== c && ($0b2e6adb871a3b94$var$Cc(b, c | 1), $0b2e6adb871a3b94$var$Dk(b, $0b2e6adb871a3b94$var$B()), 0 === ($0b2e6adb871a3b94$var$K & 6) && ($0b2e6adb871a3b94$var$Gj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$jg()));
            }
            break;
        case 13:
            $0b2e6adb871a3b94$var$Rk(function() {
                var b = $0b2e6adb871a3b94$var$ih(a, 1);
                if (null !== b) {
                    var c = $0b2e6adb871a3b94$var$R();
                    $0b2e6adb871a3b94$var$gi(b, a, 1, c);
                }
            }), $0b2e6adb871a3b94$var$il(a, 1);
    }
};
$0b2e6adb871a3b94$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $0b2e6adb871a3b94$var$ih(a, 134217728);
        if (null !== b) {
            var c = $0b2e6adb871a3b94$var$R();
            $0b2e6adb871a3b94$var$gi(b, a, 134217728, c);
        }
        $0b2e6adb871a3b94$var$il(a, 134217728);
    }
};
$0b2e6adb871a3b94$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $0b2e6adb871a3b94$var$yi(a), c = $0b2e6adb871a3b94$var$ih(a, b);
        if (null !== c) {
            var d = $0b2e6adb871a3b94$var$R();
            $0b2e6adb871a3b94$var$gi(c, a, b, d);
        }
        $0b2e6adb871a3b94$var$il(a, b);
    }
};
$0b2e6adb871a3b94$var$Hc = function() {
    return $0b2e6adb871a3b94$var$C;
};
$0b2e6adb871a3b94$var$Ic = function(a, b) {
    var c = $0b2e6adb871a3b94$var$C;
    try {
        return $0b2e6adb871a3b94$var$C = a, b();
    } finally{
        $0b2e6adb871a3b94$var$C = c;
    }
};
$0b2e6adb871a3b94$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $0b2e6adb871a3b94$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $0b2e6adb871a3b94$var$Db(d);
                        if (!e) throw Error($0b2e6adb871a3b94$var$p(90));
                        $0b2e6adb871a3b94$var$Wa(d);
                        $0b2e6adb871a3b94$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $0b2e6adb871a3b94$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $0b2e6adb871a3b94$var$fb(a, !!c.multiple, b, !1);
    }
};
$0b2e6adb871a3b94$var$Gb = $0b2e6adb871a3b94$var$Qk;
$0b2e6adb871a3b94$var$Hb = $0b2e6adb871a3b94$var$Rk;
var $0b2e6adb871a3b94$var$sl = {
    usingClientEntryPoint: !1,
    Events: [
        $0b2e6adb871a3b94$var$Cb,
        $0b2e6adb871a3b94$var$ue,
        $0b2e6adb871a3b94$var$Db,
        $0b2e6adb871a3b94$var$Eb,
        $0b2e6adb871a3b94$var$Fb,
        $0b2e6adb871a3b94$var$Qk
    ]
}, $0b2e6adb871a3b94$var$tl = {
    findFiberByHostInstance: $0b2e6adb871a3b94$var$Wc,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
var $0b2e6adb871a3b94$var$ul = {
    bundleType: $0b2e6adb871a3b94$var$tl.bundleType,
    version: $0b2e6adb871a3b94$var$tl.version,
    rendererPackageName: $0b2e6adb871a3b94$var$tl.rendererPackageName,
    rendererConfig: $0b2e6adb871a3b94$var$tl.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $0b2e6adb871a3b94$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $0b2e6adb871a3b94$var$tl.findFiberByHostInstance || $0b2e6adb871a3b94$var$jl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $0b2e6adb871a3b94$var$vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$0b2e6adb871a3b94$var$vl.isDisabled && $0b2e6adb871a3b94$var$vl.supportsFiber) try {
        $0b2e6adb871a3b94$var$kc = $0b2e6adb871a3b94$var$vl.inject($0b2e6adb871a3b94$var$ul), $0b2e6adb871a3b94$var$lc = $0b2e6adb871a3b94$var$vl;
    } catch (a) {}
}
$0b2e6adb871a3b94$export$ae55be85d98224ed = $0b2e6adb871a3b94$var$sl;
$0b2e6adb871a3b94$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$0b2e6adb871a3b94$var$nl(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$cl(a, b, null, c);
};
$0b2e6adb871a3b94$export$882461b6382ed46c = function(a, b) {
    if (!$0b2e6adb871a3b94$var$nl(a)) throw Error($0b2e6adb871a3b94$var$p(299));
    var c = !1, d = "", e = $0b2e6adb871a3b94$var$kl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $0b2e6adb871a3b94$var$bl(a, 1, !1, null, null, c, !1, d, e);
    a[$0b2e6adb871a3b94$var$uf] = b.current;
    $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $0b2e6adb871a3b94$var$ll(b);
};
$0b2e6adb871a3b94$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($0b2e6adb871a3b94$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($0b2e6adb871a3b94$var$p(268, a));
    }
    a = $0b2e6adb871a3b94$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$0b2e6adb871a3b94$export$cd75ccfd720a3cd4 = function(a) {
    return $0b2e6adb871a3b94$var$Rk(a);
};
$0b2e6adb871a3b94$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$ol(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$rl(null, a, b, !0, c);
};
$0b2e6adb871a3b94$export$757ceba2d55c277e = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$nl(a)) throw Error($0b2e6adb871a3b94$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $0b2e6adb871a3b94$var$kl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $0b2e6adb871a3b94$var$el(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$0b2e6adb871a3b94$var$uf] = b.current;
    $0b2e6adb871a3b94$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $0b2e6adb871a3b94$var$ml(b);
};
$0b2e6adb871a3b94$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$ol(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$rl(null, a, b, !1, c);
};
$0b2e6adb871a3b94$export$502457920280e6be = function(a) {
    if (!$0b2e6adb871a3b94$var$ol(a)) throw Error($0b2e6adb871a3b94$var$p(40));
    return a._reactRootContainer ? ($0b2e6adb871a3b94$var$Rk(function() {
        $0b2e6adb871a3b94$var$rl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$0b2e6adb871a3b94$var$uf] = null;
        });
    }), !0) : !1;
};
$0b2e6adb871a3b94$export$c78a37762a8d58e1 = $0b2e6adb871a3b94$var$Qk;
$0b2e6adb871a3b94$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$0b2e6adb871a3b94$var$ol(c)) throw Error($0b2e6adb871a3b94$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($0b2e6adb871a3b94$var$p(38));
    return $0b2e6adb871a3b94$var$rl(a, b, c, !1, d);
};
$0b2e6adb871a3b94$export$83d89fbfd8236492 = "18.3.1-next-f1338f8080-20240426";

});
parcelRegister("fO90s", function(module, exports) {
"use strict";

module.exports = (parcelRequire("gcnCG"));

});
parcelRegister("gcnCG", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $bcb017604639e9d7$export$c4744153514ff05d, (v) => $bcb017604639e9d7$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $bcb017604639e9d7$export$3e506c1ccc9cc1a7, (v) => $bcb017604639e9d7$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $bcb017604639e9d7$export$e26fe2ed2fa76875, (v) => $bcb017604639e9d7$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $bcb017604639e9d7$export$502329bbf4b505b1, (v) => $bcb017604639e9d7$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $bcb017604639e9d7$export$6e3807111c4874c4, (v) => $bcb017604639e9d7$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $bcb017604639e9d7$export$c27134553091fb3a, (v) => $bcb017604639e9d7$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $bcb017604639e9d7$export$33ee1acdc04fd2a2, (v) => $bcb017604639e9d7$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $bcb017604639e9d7$export$b00a404bbd5edef2, (v) => $bcb017604639e9d7$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_continueExecution", () => $bcb017604639e9d7$export$8352ce38b91d0c62, (v) => $bcb017604639e9d7$export$8352ce38b91d0c62 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $bcb017604639e9d7$export$d66a1c1c77bd778b, (v) => $bcb017604639e9d7$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $bcb017604639e9d7$export$d3dfb8e4810cb555, (v) => $bcb017604639e9d7$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_getFirstCallbackNode", () => $bcb017604639e9d7$export$839f9183b0465a69, (v) => $bcb017604639e9d7$export$839f9183b0465a69 = v);
$parcel$export(module.exports, "unstable_next", () => $bcb017604639e9d7$export$72fdf0e06517287b, (v) => $bcb017604639e9d7$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_pauseExecution", () => $bcb017604639e9d7$export$4b844e58a3e414b4, (v) => $bcb017604639e9d7$export$4b844e58a3e414b4 = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $bcb017604639e9d7$export$816d2913ae6b83b1, (v) => $bcb017604639e9d7$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $bcb017604639e9d7$export$61bcfe829111a1d0, (v) => $bcb017604639e9d7$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $bcb017604639e9d7$export$7ee8c9beb337bc3f, (v) => $bcb017604639e9d7$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $bcb017604639e9d7$export$b5836b71941fa3ed, (v) => $bcb017604639e9d7$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $bcb017604639e9d7$export$cf845f2c119da08a, (v) => $bcb017604639e9d7$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $bcb017604639e9d7$export$c4744153514ff05d;
var $bcb017604639e9d7$export$3e506c1ccc9cc1a7;
var $bcb017604639e9d7$export$e26fe2ed2fa76875;
var $bcb017604639e9d7$export$502329bbf4b505b1;
var $bcb017604639e9d7$export$6e3807111c4874c4;
var $bcb017604639e9d7$export$c27134553091fb3a;
var $bcb017604639e9d7$export$33ee1acdc04fd2a2;
var $bcb017604639e9d7$export$b00a404bbd5edef2;
var $bcb017604639e9d7$export$8352ce38b91d0c62;
var $bcb017604639e9d7$export$d66a1c1c77bd778b;
var $bcb017604639e9d7$export$d3dfb8e4810cb555;
var $bcb017604639e9d7$export$839f9183b0465a69;
var $bcb017604639e9d7$export$72fdf0e06517287b;
var $bcb017604639e9d7$export$4b844e58a3e414b4;
var $bcb017604639e9d7$export$816d2913ae6b83b1;
var $bcb017604639e9d7$export$61bcfe829111a1d0;
var $bcb017604639e9d7$export$7ee8c9beb337bc3f;
var $bcb017604639e9d7$export$b5836b71941fa3ed;
var $bcb017604639e9d7$export$cf845f2c119da08a;
"use strict";
function $bcb017604639e9d7$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $bcb017604639e9d7$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $bcb017604639e9d7$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $bcb017604639e9d7$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $bcb017604639e9d7$var$g(C, c)) n < e && 0 > $bcb017604639e9d7$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $bcb017604639e9d7$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $bcb017604639e9d7$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $bcb017604639e9d7$var$l = performance;
    $bcb017604639e9d7$export$c4744153514ff05d = function() {
        return $bcb017604639e9d7$var$l.now();
    };
} else {
    var $bcb017604639e9d7$var$p = Date, $bcb017604639e9d7$var$q = $bcb017604639e9d7$var$p.now();
    $bcb017604639e9d7$export$c4744153514ff05d = function() {
        return $bcb017604639e9d7$var$p.now() - $bcb017604639e9d7$var$q;
    };
}
var $bcb017604639e9d7$var$r = [], $bcb017604639e9d7$var$t = [], $bcb017604639e9d7$var$u = 1, $bcb017604639e9d7$var$v = null, $bcb017604639e9d7$var$y = 3, $bcb017604639e9d7$var$z = !1, $bcb017604639e9d7$var$A = !1, $bcb017604639e9d7$var$B = !1, $bcb017604639e9d7$var$D = "function" === typeof setTimeout ? setTimeout : null, $bcb017604639e9d7$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $bcb017604639e9d7$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $bcb017604639e9d7$var$G(a) {
    for(var b = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t); null !== b;){
        if (null === b.callback) $bcb017604639e9d7$var$k($bcb017604639e9d7$var$t);
        else if (b.startTime <= a) $bcb017604639e9d7$var$k($bcb017604639e9d7$var$t), b.sortIndex = b.expirationTime, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$r, b);
        else break;
        b = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t);
    }
}
function $bcb017604639e9d7$var$H(a) {
    $bcb017604639e9d7$var$B = !1;
    $bcb017604639e9d7$var$G(a);
    if (!$bcb017604639e9d7$var$A) {
        if (null !== $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r)) $bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$I($bcb017604639e9d7$var$J);
        else {
            var b = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t);
            null !== b && $bcb017604639e9d7$var$K($bcb017604639e9d7$var$H, b.startTime - a);
        }
    }
}
function $bcb017604639e9d7$var$J(a, b) {
    $bcb017604639e9d7$var$A = !1;
    $bcb017604639e9d7$var$B && ($bcb017604639e9d7$var$B = !1, $bcb017604639e9d7$var$E($bcb017604639e9d7$var$L), $bcb017604639e9d7$var$L = -1);
    $bcb017604639e9d7$var$z = !0;
    var c = $bcb017604639e9d7$var$y;
    try {
        $bcb017604639e9d7$var$G(b);
        for($bcb017604639e9d7$var$v = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r); null !== $bcb017604639e9d7$var$v && (!($bcb017604639e9d7$var$v.expirationTime > b) || a && !$bcb017604639e9d7$var$M());){
            var d = $bcb017604639e9d7$var$v.callback;
            if ("function" === typeof d) {
                $bcb017604639e9d7$var$v.callback = null;
                $bcb017604639e9d7$var$y = $bcb017604639e9d7$var$v.priorityLevel;
                var e = d($bcb017604639e9d7$var$v.expirationTime <= b);
                b = $bcb017604639e9d7$export$c4744153514ff05d();
                "function" === typeof e ? $bcb017604639e9d7$var$v.callback = e : $bcb017604639e9d7$var$v === $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r) && $bcb017604639e9d7$var$k($bcb017604639e9d7$var$r);
                $bcb017604639e9d7$var$G(b);
            } else $bcb017604639e9d7$var$k($bcb017604639e9d7$var$r);
            $bcb017604639e9d7$var$v = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r);
        }
        if (null !== $bcb017604639e9d7$var$v) var w = !0;
        else {
            var m = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t);
            null !== m && $bcb017604639e9d7$var$K($bcb017604639e9d7$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $bcb017604639e9d7$var$v = null, $bcb017604639e9d7$var$y = c, $bcb017604639e9d7$var$z = !1;
    }
}
var $bcb017604639e9d7$var$N = !1, $bcb017604639e9d7$var$O = null, $bcb017604639e9d7$var$L = -1, $bcb017604639e9d7$var$P = 5, $bcb017604639e9d7$var$Q = -1;
function $bcb017604639e9d7$var$M() {
    return $bcb017604639e9d7$export$c4744153514ff05d() - $bcb017604639e9d7$var$Q < $bcb017604639e9d7$var$P ? !1 : !0;
}
function $bcb017604639e9d7$var$R() {
    if (null !== $bcb017604639e9d7$var$O) {
        var a = $bcb017604639e9d7$export$c4744153514ff05d();
        $bcb017604639e9d7$var$Q = a;
        var b = !0;
        try {
            b = $bcb017604639e9d7$var$O(!0, a);
        } finally{
            b ? $bcb017604639e9d7$var$S() : ($bcb017604639e9d7$var$N = !1, $bcb017604639e9d7$var$O = null);
        }
    } else $bcb017604639e9d7$var$N = !1;
}
var $bcb017604639e9d7$var$S;
if ("function" === typeof $bcb017604639e9d7$var$F) $bcb017604639e9d7$var$S = function() {
    $bcb017604639e9d7$var$F($bcb017604639e9d7$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $bcb017604639e9d7$var$T = new MessageChannel, $bcb017604639e9d7$var$U = $bcb017604639e9d7$var$T.port2;
    $bcb017604639e9d7$var$T.port1.onmessage = $bcb017604639e9d7$var$R;
    $bcb017604639e9d7$var$S = function() {
        $bcb017604639e9d7$var$U.postMessage(null);
    };
} else $bcb017604639e9d7$var$S = function() {
    $bcb017604639e9d7$var$D($bcb017604639e9d7$var$R, 0);
};
function $bcb017604639e9d7$var$I(a) {
    $bcb017604639e9d7$var$O = a;
    $bcb017604639e9d7$var$N || ($bcb017604639e9d7$var$N = !0, $bcb017604639e9d7$var$S());
}
function $bcb017604639e9d7$var$K(a, b) {
    $bcb017604639e9d7$var$L = $bcb017604639e9d7$var$D(function() {
        a($bcb017604639e9d7$export$c4744153514ff05d());
    }, b);
}
$bcb017604639e9d7$export$3e506c1ccc9cc1a7 = 5;
$bcb017604639e9d7$export$e26fe2ed2fa76875 = 1;
$bcb017604639e9d7$export$502329bbf4b505b1 = 4;
$bcb017604639e9d7$export$6e3807111c4874c4 = 3;
$bcb017604639e9d7$export$c27134553091fb3a = null;
$bcb017604639e9d7$export$33ee1acdc04fd2a2 = 2;
$bcb017604639e9d7$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$bcb017604639e9d7$export$8352ce38b91d0c62 = function() {
    $bcb017604639e9d7$var$A || $bcb017604639e9d7$var$z || ($bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$I($bcb017604639e9d7$var$J));
};
$bcb017604639e9d7$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $bcb017604639e9d7$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$bcb017604639e9d7$export$d3dfb8e4810cb555 = function() {
    return $bcb017604639e9d7$var$y;
};
$bcb017604639e9d7$export$839f9183b0465a69 = function() {
    return $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r);
};
$bcb017604639e9d7$export$72fdf0e06517287b = function(a) {
    switch($bcb017604639e9d7$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $bcb017604639e9d7$var$y;
    }
    var c = $bcb017604639e9d7$var$y;
    $bcb017604639e9d7$var$y = b;
    try {
        return a();
    } finally{
        $bcb017604639e9d7$var$y = c;
    }
};
$bcb017604639e9d7$export$4b844e58a3e414b4 = function() {};
$bcb017604639e9d7$export$816d2913ae6b83b1 = function() {};
$bcb017604639e9d7$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $bcb017604639e9d7$var$y;
    $bcb017604639e9d7$var$y = a;
    try {
        return b();
    } finally{
        $bcb017604639e9d7$var$y = c;
    }
};
$bcb017604639e9d7$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $bcb017604639e9d7$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $bcb017604639e9d7$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$t, a), null === $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r) && a === $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t) && ($bcb017604639e9d7$var$B ? ($bcb017604639e9d7$var$E($bcb017604639e9d7$var$L), $bcb017604639e9d7$var$L = -1) : $bcb017604639e9d7$var$B = !0, $bcb017604639e9d7$var$K($bcb017604639e9d7$var$H, c - d))) : (a.sortIndex = e, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$r, a), $bcb017604639e9d7$var$A || $bcb017604639e9d7$var$z || ($bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$I($bcb017604639e9d7$var$J)));
    return a;
};
$bcb017604639e9d7$export$b5836b71941fa3ed = $bcb017604639e9d7$var$M;
$bcb017604639e9d7$export$cf845f2c119da08a = function(a) {
    var b = $bcb017604639e9d7$var$y;
    return function() {
        var c = $bcb017604639e9d7$var$y;
        $bcb017604639e9d7$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $bcb017604639e9d7$var$y = c;
        }
    };
};

});



parcelRegister("9KJyz", function(module, exports) {
module.exports = new URL("goalie-down.abd604be.flac", import.meta.url).toString();

});

parcelRegister("e5OlD", function(module, exports) {
module.exports = new URL("goal.bd7f3e94.flac", import.meta.url).toString();

});

parcelRegister("5kXBn", function(module, exports) {
module.exports = new URL("goal-horn.39a2e344.flac", import.meta.url).toString();

});

parcelRegister("kcrfF", function(module, exports) {
module.exports = new URL("gate-hit.9cdc2f85.flac", import.meta.url).toString();

});

parcelRegister("eoXur", function(module, exports) {
module.exports = new URL("game-start.83496793.flac", import.meta.url).toString();

});

parcelRegister("eIOhw", function(module, exports) {
module.exports = new URL("game-over.3ddc6242.flac", import.meta.url).toString();

});

parcelRegister("e2l3X", function(module, exports) {
module.exports = new URL("flipper-up.996f7d88.flac", import.meta.url).toString();

});

parcelRegister("3pswo", function(module, exports) {
module.exports = new URL("flipper-up-8.d639cd8b.flac", import.meta.url).toString();

});

parcelRegister("kVXKs", function(module, exports) {
module.exports = new URL("flipper-up-7.5a7fc9a0.flac", import.meta.url).toString();

});

parcelRegister("l8ZP4", function(module, exports) {
module.exports = new URL("flipper-up-6.e25904e7.flac", import.meta.url).toString();

});

parcelRegister("4rdo5", function(module, exports) {
module.exports = new URL("flipper-up-5.562a495b.flac", import.meta.url).toString();

});

parcelRegister("7VpP9", function(module, exports) {
module.exports = new URL("flipper-up-4.6b675471.flac", import.meta.url).toString();

});

parcelRegister("7LbxD", function(module, exports) {
module.exports = new URL("flipper-up-3.1fd6b063.flac", import.meta.url).toString();

});

parcelRegister("fgKYy", function(module, exports) {
module.exports = new URL("flipper-up-2.b992999f.flac", import.meta.url).toString();

});

parcelRegister("29cBf", function(module, exports) {
module.exports = new URL("flipper-hit.d13b137b.flac", import.meta.url).toString();

});

parcelRegister("eFkZY", function(module, exports) {
module.exports = new URL("flipper-down.b6adb5d1.flac", import.meta.url).toString();

});

parcelRegister("j1gLE", function(module, exports) {
module.exports = new URL("flipper-down-3.b24262bc.flac", import.meta.url).toString();

});

parcelRegister("12Tew", function(module, exports) {
module.exports = new URL("flipper-down-2.de13083f.flac", import.meta.url).toString();

});

parcelRegister("6l3mZ", function(module, exports) {
module.exports = new URL("drain.000bad93.flac", import.meta.url).toString();

});

parcelRegister("4mHKx", function(module, exports) {
module.exports = new URL("defender-up-2.842f0d1e.flac", import.meta.url).toString();

});

parcelRegister("S2z7r", function(module, exports) {
module.exports = new URL("defender-up-1.17bad00a.flac", import.meta.url).toString();

});

parcelRegister("iZztn", function(module, exports) {
module.exports = new URL("defender-down-3.0d38287b.flac", import.meta.url).toString();

});

parcelRegister("8c0OE", function(module, exports) {
module.exports = new URL("defender-down-2.2818ff07.flac", import.meta.url).toString();

});

parcelRegister("6UeJA", function(module, exports) {
module.exports = new URL("defender-down-1.6751f6db.flac", import.meta.url).toString();

});

parcelRegister("10hc9", function(module, exports) {
module.exports = new URL("buzz.817080bf.flac", import.meta.url).toString();

});

parcelRegister("luJqe", function(module, exports) {
module.exports = new URL("button-up-1.ec310530.flac", import.meta.url).toString();

});

parcelRegister("fgZMo", function(module, exports) {
module.exports = new URL("button-down-1.ebf0976a.flac", import.meta.url).toString();

});

parcelRegister("cXEQW", function(module, exports) {
module.exports = new URL("bumper-2.a336f61f.flac", import.meta.url).toString();

});

parcelRegister("adttp", function(module, exports) {
module.exports = new URL("bumper-1.fd6e5848.flac", import.meta.url).toString();

});

parcelRegister("gUQnr", function(module, exports) {
module.exports = new URL("boing-2.c25babe6.flac", import.meta.url).toString();

});

parcelRegister("aQTLX", function(module, exports) {
module.exports = new URL("boing-1.0b8f7566.flac", import.meta.url).toString();

});

parcelRegister("coCKr", function(module, exports) {
module.exports = new URL("ball-rolling.2835d606.flac", import.meta.url).toString();

});

parcelRegister("5Df8S", function(module, exports) {
module.exports = new URL("ball-rolling-raw-sm57.20fa3b10.flac", import.meta.url).toString();

});

parcelRegister("eDPcV", function(module, exports) {
module.exports = new URL("ball-rolling-raw-at3035.a9979fe0.flac", import.meta.url).toString();

});

parcelRegister("68hzO", function(module, exports) {
module.exports = new URL("ball-rolling-3.8b6a2a3b.flac", import.meta.url).toString();

});

parcelRegister("b3KML", function(module, exports) {
module.exports = new URL("ball-rolling-2.ee42e2ae.flac", import.meta.url).toString();

});

parcelRegister("eqETw", function(module, exports) {
module.exports = new URL("ball-on-ball-raw.da9f5762.flac", import.meta.url).toString();

});

parcelRegister("G4aMa", function(module, exports) {
module.exports = new URL("ball-on-ball-2.e6564b9f.flac", import.meta.url).toString();

});

parcelRegister("9Y3eX", function(module, exports) {
module.exports = new URL("ball-on-ball-1.fe0fa7f1.flac", import.meta.url).toString();

});

parcelRegister("1YU51", function(module, exports) {
module.exports = new URL("ball-drop-1.75900e08.flac", import.meta.url).toString();

});

parcelRegister("gE90K", function(module, exports) {
module.exports = new URL("wall-ao-1.a334bd8b.png", import.meta.url).toString();

});

parcelRegister("4GVgl", function(module, exports) {
module.exports = new URL("wall-1.fcbc61e7.png", import.meta.url).toString();

});

parcelRegister("as850", function(module, exports) {
module.exports = new URL("favicon.86aaaf0c.png", import.meta.url).toString();

});


var $i9BKe = parcelRequire("i9BKe");
"use strict";

const $c220e1d99a2da004$export$a6aad6334ef58a1c = {
    extension: {
        type: (0, $i9BKe.ExtensionType).Environment,
        name: "browser",
        priority: -1
    },
    test: ()=>true,
    load: async ()=>{
        await (parcelRequire("c4r3z"));
    }
};



var $i9BKe = parcelRequire("i9BKe");
"use strict";

const $a52ecd5a016ebe0a$export$ee43dd1acddf6cf8 = {
    extension: {
        type: (0, $i9BKe.ExtensionType).Environment,
        name: "webworker",
        priority: 0
    },
    test: ()=>typeof self !== "undefined" && self.WorkerGlobalScope !== void 0,
    load: async ()=>{
        await (parcelRequire("1Wz6q"));
    }
};



var $i9BKe = parcelRequire("i9BKe");
parcelRequire("7dx1H");
parcelRequire("4RJM2");












































var $i9BKe = parcelRequire("i9BKe");

var $iCGeI = parcelRequire("iCGeI");

var $3UUq4 = parcelRequire("3UUq4");
"use strict";
let $21de405eafa0c0bb$var$_isWebGLSupported;
function $21de405eafa0c0bb$export$83dc396b76015322(failIfMajorPerformanceCaveat) {
    if ($21de405eafa0c0bb$var$_isWebGLSupported !== void 0) return $21de405eafa0c0bb$var$_isWebGLSupported;
    $21de405eafa0c0bb$var$_isWebGLSupported = (()=>{
        const contextOptions = {
            stencil: true,
            failIfMajorPerformanceCaveat: failIfMajorPerformanceCaveat ?? (0, $3UUq4.AbstractRenderer).defaultOptions.failIfMajorPerformanceCaveat
        };
        try {
            if (!(0, $iCGeI.DOMAdapter).get().getWebGLRenderingContext()) return false;
            const canvas = (0, $iCGeI.DOMAdapter).get().createCanvas();
            let gl = canvas.getContext("webgl", contextOptions);
            const success = !!gl?.getContextAttributes()?.stencil;
            if (gl) {
                const loseContext = gl.getExtension("WEBGL_lose_context");
                if (loseContext) loseContext.loseContext();
            }
            gl = null;
            return success;
        } catch (e) {
            return false;
        }
    })();
    return $21de405eafa0c0bb$var$_isWebGLSupported;
}



var $iCGeI = parcelRequire("iCGeI");
"use strict";
let $7cb4832c2de4c977$var$_isWebGPUSupported;
async function $7cb4832c2de4c977$export$216169f30082c873(options = {}) {
    if ($7cb4832c2de4c977$var$_isWebGPUSupported !== void 0) return $7cb4832c2de4c977$var$_isWebGPUSupported;
    $7cb4832c2de4c977$var$_isWebGPUSupported = await (async ()=>{
        const gpu = (0, $iCGeI.DOMAdapter).get().getNavigator().gpu;
        if (!gpu) return false;
        try {
            const adapter = await gpu.requestAdapter(options);
            await adapter.requestDevice();
            return true;
        } catch (e) {
            return false;
        }
    })();
    return $7cb4832c2de4c977$var$_isWebGPUSupported;
}



var $3UUq4 = parcelRequire("3UUq4");
"use strict";
const $bf7ca24d384e2f55$var$renderPriority = [
    "webgl",
    "webgpu",
    "canvas"
];


async function $bf7ca24d384e2f55$export$3583b92ab8150eb6(options) {
    let preferredOrder = [];
    if (options.preference) {
        preferredOrder.push(options.preference);
        $bf7ca24d384e2f55$var$renderPriority.forEach((item)=>{
            if (item !== options.preference) preferredOrder.push(item);
        });
    } else preferredOrder = $bf7ca24d384e2f55$var$renderPriority.slice();
    let RendererClass;
    let finalOptions = {};
    for(let i = 0; i < preferredOrder.length; i++){
        const rendererType = preferredOrder[i];
        if (rendererType === "webgpu" && await (0, $7cb4832c2de4c977$export$216169f30082c873)()) {
            const { WebGPURenderer: WebGPURenderer } = await (parcelRequire("eOMWf"));
            RendererClass = WebGPURenderer;
            finalOptions = {
                ...options,
                ...options.webgpu
            };
            break;
        } else if (rendererType === "webgl" && (0, $21de405eafa0c0bb$export$83dc396b76015322)(options.failIfMajorPerformanceCaveat ?? (0, $3UUq4.AbstractRenderer).defaultOptions.failIfMajorPerformanceCaveat)) {
            const { WebGLRenderer: WebGLRenderer } = await (parcelRequire("opv27"));
            RendererClass = WebGLRenderer;
            finalOptions = {
                ...options,
                ...options.webgl
            };
            break;
        } else if (rendererType === "canvas") {
            finalOptions = {
                ...options
            };
            throw new Error("CanvasRenderer is not yet implemented");
        }
    }
    delete finalOptions.webgpu;
    delete finalOptions.webgl;
    if (!RendererClass) throw new Error("No available renderer for the current environment");
    const renderer = new RendererClass();
    await renderer.init(finalOptions);
    return renderer;
}



var $eicwU = parcelRequire("eicwU");

var $gVtOu = parcelRequire("gVtOu");

var $kXq8E = parcelRequire("kXq8E");
"use strict";
const $2202931bfc9ee5c9$var$_Application = class _Application {
    /** @ignore */ constructor(...args){
        /** The root display container that's rendered. */ this.stage = new (0, $eicwU.Container)();
        if (args[0] !== void 0) (0, $kXq8E.deprecation)((0, $kXq8E.v8_0_0), "Application constructor options are deprecated, please use Application.init() instead.");
    }
    /**
   * @param options - The optional application and renderer parameters.
   */ async init(options) {
        options = {
            ...options
        };
        this.renderer = await (0, $bf7ca24d384e2f55$export$3583b92ab8150eb6)(options);
        _Application._plugins.forEach((plugin)=>{
            plugin.init.call(this, options);
        });
    }
    /** Render the current stage. */ render() {
        this.renderer.render({
            container: this.stage
        });
    }
    /**
   * Reference to the renderer's canvas element.
   * @readonly
   * @member {HTMLCanvasElement}
   */ get canvas() {
        return this.renderer.canvas;
    }
    /**
   * Reference to the renderer's canvas element.
   * @member {HTMLCanvasElement}
   * @deprecated since 8.0.0
   */ get view() {
        (0, $kXq8E.deprecation)((0, $kXq8E.v8_0_0), "Application.view is deprecated, please use Application.canvas instead.");
        return this.renderer.canvas;
    }
    /**
   * Reference to the renderer's screen rectangle. Its safe to use as `filterArea` or `hitArea` for the whole screen.
   * @readonly
   */ get screen() {
        return this.renderer.screen;
    }
    /**
   * Destroys the application and all of its resources.
   * @param {object|boolean}[rendererDestroyOptions=false] - The options for destroying the renderer.
   * @param {boolean}[rendererDestroyOptions.removeView=false] - Removes the Canvas element from the DOM.
   * @param {object|boolean} [options=false] - The options for destroying the stage.
   * @param {boolean} [options.children=false] - If set to true, all the children will have their destroy method
   * called as well. `options` will be passed on to those calls.
   * @param {boolean} [options.texture=false] - Only used for children with textures e.g. Sprites.
   * If options.children is set to true,
   * it should destroy the texture of the child sprite.
   * @param {boolean} [options.textureSource=false] - Only used for children with textures e.g. Sprites.
   *  If options.children is set to true,
   * it should destroy the texture source of the child sprite.
   * @param {boolean} [options.context=false] - Only used for children with graphicsContexts e.g. Graphics.
   * If options.children is set to true,
   * it should destroy the context of the child graphics.
   */ destroy(rendererDestroyOptions = false, options = false) {
        const plugins = _Application._plugins.slice(0);
        plugins.reverse();
        plugins.forEach((plugin)=>{
            plugin.destroy.call(this);
        });
        this.stage.destroy(options);
        this.stage = null;
        this.renderer.destroy(rendererDestroyOptions);
        this.renderer = null;
    }
};
/**
 * Collection of installed plugins.
 * @alias _plugins
 */ $2202931bfc9ee5c9$var$_Application._plugins = [];
let $2202931bfc9ee5c9$export$16975c34e60e1e61 = $2202931bfc9ee5c9$var$_Application;
(0, $i9BKe.extensions).handleByList((0, $i9BKe.ExtensionType).Application, $2202931bfc9ee5c9$export$16975c34e60e1e61._plugins);
(0, $i9BKe.extensions).add((0, $gVtOu.ApplicationInitHook));





var $i9BKe = parcelRequire("i9BKe");

var $iEtN5 = parcelRequire("iEtN5");

var $5Oad7 = parcelRequire("5Oad7");

var $iCGeI = parcelRequire("iCGeI");

var $i9BKe = parcelRequire("i9BKe");

var $lzfZe = parcelRequire("lzfZe");

var $fM4Mk = parcelRequire("fM4Mk");

var $bLlTJ = parcelRequire("bLlTJ");

var $hlNkG = parcelRequire("hlNkG");

var $axl5b = parcelRequire("axl5b");
"use strict";
class $e203ca19ce7419c5$export$17957a09927cadc7 extends (0, $hlNkG.AbstractBitmapFont) {
    constructor(options, url){
        super();
        const { textures: textures, data: data } = options;
        Object.keys(data.pages).forEach((key)=>{
            const pageData = data.pages[parseInt(key, 10)];
            const texture = textures[pageData.id];
            this.pages.push({
                texture: texture
            });
        });
        Object.keys(data.chars).forEach((key)=>{
            const charData = data.chars[key];
            const { frame: textureFrame, source: textureSource } = textures[charData.page];
            const frameReal = new (0, $fM4Mk.Rectangle)(charData.x + textureFrame.x, charData.y + textureFrame.y, charData.width, charData.height);
            const texture = new (0, $bLlTJ.Texture)({
                source: textureSource,
                frame: frameReal
            });
            this.chars[key] = {
                id: key.codePointAt(0),
                xOffset: charData.xOffset,
                yOffset: charData.yOffset,
                xAdvance: charData.xAdvance,
                kerning: charData.kerning ?? {},
                texture: texture
            };
        });
        this.baseRenderedFontSize = data.fontSize;
        this.baseMeasurementFontSize = data.fontSize;
        this.fontMetrics = {
            ascent: 0,
            descent: 0,
            fontSize: data.fontSize
        };
        this.baseLineOffset = data.baseLineOffset;
        this.lineHeight = data.lineHeight;
        this.fontFamily = data.fontFamily;
        this.distanceField = data.distanceField ?? {
            type: "none",
            range: 0
        };
        this.url = url;
    }
    /** Destroys the BitmapFont object. */ destroy() {
        super.destroy();
        for(let i = 0; i < this.pages.length; i++){
            const { texture: texture } = this.pages[i];
            texture.destroy(true);
        }
        this.pages = null;
    }
    /**
   * Generates a bitmap-font for the given style and character set
   * @param options - Setup options for font generation.
   * @returns Font generated by style options.
   * @example
   * import { BitmapFont, BitmapText } from 'pixi.js';
   *
   * BitmapFont.install('TitleFont', {
   *     fontFamily: 'Arial',
   *     fontSize: 12,
   *     strokeThickness: 2,
   *     fill: 'purple',
   * });
   *
   * const title = new BitmapText({ text: 'This is the title', fontFamily: 'TitleFont' });
   */ static install(options) {
        (0, $axl5b.BitmapFontManager).install(options);
    }
    /**
   * Uninstalls a bitmap font from the cache.
   * @param {string} name - The name of the bitmap font to uninstall.
   */ static uninstall(name) {
        (0, $axl5b.BitmapFontManager).uninstall(name);
    }
}


"use strict";
const $2e97ab653ff7bb1e$export$4c1815a0944ccac0 = {
    test (data) {
        return typeof data === "string" && data.startsWith("info face=");
    },
    parse (txt) {
        const items = txt.match(/^[a-z]+\s+.+$/gm);
        const rawData = {
            info: [],
            common: [],
            page: [],
            char: [],
            chars: [],
            kerning: [],
            kernings: [],
            distanceField: []
        };
        for(const i in items){
            const name = items[i].match(/^[a-z]+/gm)[0];
            const attributeList = items[i].match(/[a-zA-Z]+=([^\s"']+|"([^"]*)")/gm);
            const itemData = {};
            for(const i2 in attributeList){
                const split = attributeList[i2].split("=");
                const key = split[0];
                const strValue = split[1].replace(/"/gm, "");
                const floatValue = parseFloat(strValue);
                const value = isNaN(floatValue) ? strValue : floatValue;
                itemData[key] = value;
            }
            rawData[name].push(itemData);
        }
        const font = {
            chars: {},
            pages: [],
            lineHeight: 0,
            fontSize: 0,
            fontFamily: "",
            distanceField: null,
            baseLineOffset: 0
        };
        const [info] = rawData.info;
        const [common] = rawData.common;
        const [distanceField] = rawData.distanceField ?? [];
        if (distanceField) font.distanceField = {
            range: parseInt(distanceField.distanceRange, 10),
            type: distanceField.fieldType
        };
        font.fontSize = parseInt(info.size, 10);
        font.fontFamily = info.face;
        font.lineHeight = parseInt(common.lineHeight, 10);
        const page = rawData.page;
        for(let i = 0; i < page.length; i++)font.pages.push({
            id: parseInt(page[i].id, 10) || 0,
            file: page[i].file
        });
        const map = {};
        font.baseLineOffset = font.lineHeight - parseInt(common.base, 10);
        const char = rawData.char;
        for(let i = 0; i < char.length; i++){
            const charNode = char[i];
            const id = parseInt(charNode.id, 10);
            let letter = charNode.letter ?? charNode.char ?? String.fromCharCode(id);
            if (letter === "space") letter = " ";
            map[id] = letter;
            font.chars[letter] = {
                id: id,
                // texture deets..
                page: parseInt(charNode.page, 10) || 0,
                x: parseInt(charNode.x, 10),
                y: parseInt(charNode.y, 10),
                width: parseInt(charNode.width, 10),
                height: parseInt(charNode.height, 10),
                xOffset: parseInt(charNode.xoffset, 10),
                yOffset: parseInt(charNode.yoffset, 10),
                xAdvance: parseInt(charNode.xadvance, 10),
                kerning: {}
            };
        }
        const kerning = rawData.kerning || [];
        for(let i = 0; i < kerning.length; i++){
            const first = parseInt(kerning[i].first, 10);
            const second = parseInt(kerning[i].second, 10);
            const amount = parseInt(kerning[i].amount, 10);
            font.chars[map[second]].kerning[map[first]] = amount;
        }
        return font;
    }
};



var $iCGeI = parcelRequire("iCGeI");
"use strict";
const $e7c71a5aa13eb859$export$7a7adbcafc5cf8e3 = {
    test (data) {
        const xml = data;
        return typeof xml !== "string" && "getElementsByTagName" in xml && xml.getElementsByTagName("page").length && xml.getElementsByTagName("info")[0].getAttribute("face") !== null;
    },
    parse (xml) {
        const data = {
            chars: {},
            pages: [],
            lineHeight: 0,
            fontSize: 0,
            fontFamily: "",
            distanceField: null,
            baseLineOffset: 0
        };
        const info = xml.getElementsByTagName("info")[0];
        const common = xml.getElementsByTagName("common")[0];
        const distanceField = xml.getElementsByTagName("distanceField")[0];
        if (distanceField) data.distanceField = {
            type: distanceField.getAttribute("fieldType"),
            range: parseInt(distanceField.getAttribute("distanceRange"), 10)
        };
        const page = xml.getElementsByTagName("page");
        const char = xml.getElementsByTagName("char");
        const kerning = xml.getElementsByTagName("kerning");
        data.fontSize = parseInt(info.getAttribute("size"), 10);
        data.fontFamily = info.getAttribute("face");
        data.lineHeight = parseInt(common.getAttribute("lineHeight"), 10);
        for(let i = 0; i < page.length; i++)data.pages.push({
            id: parseInt(page[i].getAttribute("id"), 10) || 0,
            file: page[i].getAttribute("file")
        });
        const map = {};
        data.baseLineOffset = data.lineHeight - parseInt(common.getAttribute("base"), 10);
        for(let i = 0; i < char.length; i++){
            const charNode = char[i];
            const id = parseInt(charNode.getAttribute("id"), 10);
            let letter = charNode.getAttribute("letter") ?? charNode.getAttribute("char") ?? String.fromCharCode(id);
            if (letter === "space") letter = " ";
            map[id] = letter;
            data.chars[letter] = {
                id: id,
                // texture deets..
                page: parseInt(charNode.getAttribute("page"), 10) || 0,
                x: parseInt(charNode.getAttribute("x"), 10),
                y: parseInt(charNode.getAttribute("y"), 10),
                width: parseInt(charNode.getAttribute("width"), 10),
                height: parseInt(charNode.getAttribute("height"), 10),
                // render deets..
                xOffset: parseInt(charNode.getAttribute("xoffset"), 10),
                yOffset: parseInt(charNode.getAttribute("yoffset"), 10),
                // + baseLineOffset,
                xAdvance: parseInt(charNode.getAttribute("xadvance"), 10),
                kerning: {}
            };
        }
        for(let i = 0; i < kerning.length; i++){
            const first = parseInt(kerning[i].getAttribute("first"), 10);
            const second = parseInt(kerning[i].getAttribute("second"), 10);
            const amount = parseInt(kerning[i].getAttribute("amount"), 10);
            data.chars[map[second]].kerning[map[first]] = amount;
        }
        return data;
    }
};


"use strict";
const $bc1a44b21cd9ad12$export$bfc0a19e2e2cc16 = {
    test (data) {
        if (typeof data === "string" && data.includes("<font>")) return (0, $e7c71a5aa13eb859$export$7a7adbcafc5cf8e3).test((0, $iCGeI.DOMAdapter).get().parseXML(data));
        return false;
    },
    parse (data) {
        return (0, $e7c71a5aa13eb859$export$7a7adbcafc5cf8e3).parse((0, $iCGeI.DOMAdapter).get().parseXML(data));
    }
};


"use strict";
const $67f0360d0045775d$var$validExtensions = [
    ".xml",
    ".fnt"
];
const $67f0360d0045775d$export$778a313228f06f6c = {
    extension: {
        type: (0, $i9BKe.ExtensionType).CacheParser,
        name: "cacheBitmapFont"
    },
    test: (asset)=>asset instanceof (0, $e203ca19ce7419c5$export$17957a09927cadc7),
    getCacheableAssets (keys, asset) {
        const out = {};
        keys.forEach((key)=>{
            out[key] = asset;
            out[`${key}-bitmap`] = asset;
        });
        out[`${asset.fontFamily}-bitmap`] = asset;
        return out;
    }
};
const $67f0360d0045775d$export$402edee29ac8bed4 = {
    extension: {
        type: (0, $i9BKe.ExtensionType).LoadParser,
        priority: (0, $iEtN5.LoaderParserPriority).Normal
    },
    name: "loadBitmapFont",
    test (url) {
        return $67f0360d0045775d$var$validExtensions.includes((0, $lzfZe.path).extname(url).toLowerCase());
    },
    async testParse (data) {
        return (0, $2e97ab653ff7bb1e$export$4c1815a0944ccac0).test(data) || (0, $bc1a44b21cd9ad12$export$bfc0a19e2e2cc16).test(data);
    },
    async parse (asset, data, loader) {
        const bitmapFontData = (0, $2e97ab653ff7bb1e$export$4c1815a0944ccac0).test(asset) ? (0, $2e97ab653ff7bb1e$export$4c1815a0944ccac0).parse(asset) : (0, $bc1a44b21cd9ad12$export$bfc0a19e2e2cc16).parse(asset);
        const { src: src } = data;
        const { pages: pages } = bitmapFontData;
        const textureUrls = [];
        const textureOptions = bitmapFontData.distanceField ? {
            scaleMode: "linear",
            alphaMode: "premultiply-alpha-on-upload",
            autoGenerateMipmaps: false,
            resolution: 1
        } : {};
        for(let i = 0; i < pages.length; ++i){
            const pageFile = pages[i].file;
            let imagePath = (0, $lzfZe.path).join((0, $lzfZe.path).dirname(src), pageFile);
            imagePath = (0, $5Oad7.copySearchParams)(imagePath, src);
            textureUrls.push({
                src: imagePath,
                data: textureOptions
            });
        }
        const loadedTextures = await loader.load(textureUrls);
        const textures = textureUrls.map((url)=>loadedTextures[url.src]);
        const bitmapFont = new (0, $e203ca19ce7419c5$export$17957a09927cadc7)({
            data: bitmapFontData,
            textures: textures
        }, src);
        return bitmapFont;
    },
    async load (url, _options) {
        const response = await (0, $iCGeI.DOMAdapter).get().fetch(url);
        return await response.text();
    },
    async unload (bitmapFont, _resolvedAsset, loader) {
        await Promise.all(bitmapFont.pages.map((page)=>loader.unload(page.texture.source._sourceOrigin)));
        bitmapFont.destroy();
    }
};



var $hUCK4 = parcelRequire("hUCK4");
"use strict";
class $1adc37b2cea8de16$export$1949379a83b843d5 {
    /**
   * @param loader
   * @param verbose - should the loader log to the console
   */ constructor(loader, verbose = false){
        this._loader = loader;
        this._assetList = [];
        this._isLoading = false;
        this._maxConcurrent = 1;
        this.verbose = verbose;
    }
    /**
   * Adds an array of assets to load.
   * @param assetUrls - assets to load
   */ add(assetUrls) {
        assetUrls.forEach((a)=>{
            this._assetList.push(a);
        });
        if (this.verbose) console.log("[BackgroundLoader] assets: ", this._assetList);
        if (this._isActive && !this._isLoading) this._next();
    }
    /**
   * Loads the next set of assets. Will try to load as many assets as it can at the same time.
   *
   * The max assets it will try to load at one time will be 4.
   */ async _next() {
        if (this._assetList.length && this._isActive) {
            this._isLoading = true;
            const toLoad = [];
            const toLoadAmount = Math.min(this._assetList.length, this._maxConcurrent);
            for(let i = 0; i < toLoadAmount; i++)toLoad.push(this._assetList.pop());
            await this._loader.load(toLoad);
            this._isLoading = false;
            this._next();
        }
    }
    /**
   * Activate/Deactivate the loading. If set to true then it will immediately continue to load the next asset.
   * @returns whether the class is active
   */ get active() {
        return this._isActive;
    }
    set active(value) {
        if (this._isActive === value) return;
        this._isActive = value;
        if (value && !this._isLoading) this._next();
    }
}



var $2IhKp = parcelRequire("2IhKp");

var $i9BKe = parcelRequire("i9BKe");

var $bLlTJ = parcelRequire("bLlTJ");
"use strict";
const $df4c0fb70a898168$export$407b4625a915919d = {
    extension: {
        type: (0, $i9BKe.ExtensionType).CacheParser,
        name: "cacheTextureArray"
    },
    test: (asset)=>Array.isArray(asset) && asset.every((t)=>t instanceof (0, $bLlTJ.Texture)),
    getCacheableAssets: (keys, asset)=>{
        const out = {};
        keys.forEach((key)=>{
            asset.forEach((item, i)=>{
                out[key + (i === 0 ? "" : i + 1)] = item;
            });
        });
        return out;
    }
};



var $i9BKe = parcelRequire("i9BKe");
"use strict";
async function $36c6a70b0c6633f6$export$7c459e568e7cea2c(imageData) {
    if ("Image" in globalThis) return new Promise((resolve)=>{
        const image = new Image();
        image.onload = ()=>{
            resolve(true);
        };
        image.onerror = ()=>{
            resolve(false);
        };
        image.src = imageData;
    });
    if ("createImageBitmap" in globalThis && "fetch" in globalThis) {
        try {
            const blob = await (await fetch(imageData)).blob();
            await createImageBitmap(blob);
        } catch (e) {
            return false;
        }
        return true;
    }
    return false;
}


"use strict";
const $ca5df6e874c0bc98$export$a60d2d4a3c570783 = {
    extension: {
        type: (0, $i9BKe.ExtensionType).DetectionParser,
        priority: 1
    },
    test: async ()=>(0, $36c6a70b0c6633f6$export$7c459e568e7cea2c)(// eslint-disable-next-line max-len
        "data:image/avif;base64,AAAAIGZ0eXBhdmlmAAAAAGF2aWZtaWYxbWlhZk1BMUIAAADybWV0YQAAAAAAAAAoaGRscgAAAAAAAAAAcGljdAAAAAAAAAAAAAAAAGxpYmF2aWYAAAAADnBpdG0AAAAAAAEAAAAeaWxvYwAAAABEAAABAAEAAAABAAABGgAAAB0AAAAoaWluZgAAAAAAAQAAABppbmZlAgAAAAABAABhdjAxQ29sb3IAAAAAamlwcnAAAABLaXBjbwAAABRpc3BlAAAAAAAAAAIAAAACAAAAEHBpeGkAAAAAAwgICAAAAAxhdjFDgQ0MAAAAABNjb2xybmNseAACAAIAAYAAAAAXaXBtYQAAAAAAAAABAAEEAQKDBAAAACVtZGF0EgAKCBgANogQEAwgMg8f8D///8WfhwB8+ErK42A="),
    add: async (formats)=>[
            ...formats,
            "avif"
        ],
    remove: async (formats)=>formats.filter((f)=>f !== "avif")
};



var $i9BKe = parcelRequire("i9BKe");
"use strict";
const $c65eb9bc0713cb5d$var$imageFormats = [
    "png",
    "jpg",
    "jpeg"
];
const $c65eb9bc0713cb5d$export$b106d7c2de3b4d89 = {
    extension: {
        type: (0, $i9BKe.ExtensionType).DetectionParser,
        priority: -1
    },
    test: ()=>Promise.resolve(true),
    add: async (formats)=>[
            ...formats,
            ...$c65eb9bc0713cb5d$var$imageFormats
        ],
    remove: async (formats)=>formats.filter((f)=>!$c65eb9bc0713cb5d$var$imageFormats.includes(f))
};



var $i9BKe = parcelRequire("i9BKe");
"use strict";
const $2ba590fe27c747f9$var$inWorker = "WorkerGlobalScope" in globalThis && globalThis instanceof globalThis.WorkerGlobalScope;
function $2ba590fe27c747f9$export$7a571c147b03abb1(mimeType) {
    if ($2ba590fe27c747f9$var$inWorker) return false;
    const video = document.createElement("video");
    return video.canPlayType(mimeType) !== "";
}


"use strict";
const $8c93018bb9bae76f$export$7726d83fee274e25 = {
    extension: {
        type: (0, $i9BKe.ExtensionType).DetectionParser,
        priority: 0
    },
    test: async ()=>(0, $2ba590fe27c747f9$export$7a571c147b03abb1)("video/mp4"),
    add: async (formats)=>[
            ...formats,
            "mp4",
            "m4v"
        ],
    remove: async (formats)=>formats.filter((f)=>f !== "mp4" && f !== "m4v")
};



var $i9BKe = parcelRequire("i9BKe");

"use strict";
const $dfa8be665f85221f$export$5a1da481121f806a = {
    extension: {
        type: (0, $i9BKe.ExtensionType).DetectionParser,
        priority: 0
    },
    test: async ()=>(0, $2ba590fe27c747f9$export$7a571c147b03abb1)("video/ogg"),
    add: async (formats)=>[
            ...formats,
            "ogv"
        ],
    remove: async (formats)=>formats.filter((f)=>f !== "ogv")
};



var $i9BKe = parcelRequire("i9BKe");

"use strict";
const $64abecc9a39a8c54$export$a041d698a1896657 = {
    extension: {
        type: (0, $i9BKe.ExtensionType).DetectionParser,
        priority: 0
    },
    test: async ()=>(0, $2ba590fe27c747f9$export$7a571c147b03abb1)("video/webm"),
    add: async (formats)=>[
            ...formats,
            "webm"
        ],
    remove: async (formats)=>formats.filter((f)=>f !== "webm")
};



var $i9BKe = parcelRequire("i9BKe");

"use strict";
const $c494cf4c5ea6913a$export$d19529a9ed9823d4 = {
    extension: {
        type: (0, $i9BKe.ExtensionType).DetectionParser,
        priority: 0
    },
    test: async ()=>(0, $36c6a70b0c6633f6$export$7c459e568e7cea2c)("data:image/webp;base64,UklGRh4AAABXRUJQVlA4TBEAAAAvAAAAAAfQ//73v/+BiOh/AAA="),
    add: async (formats)=>[
            ...formats,
            "webp"
        ],
    remove: async (formats)=>formats.filter((f)=>f !== "webp")
};



var $hUCK4 = parcelRequire("hUCK4");

var $lzfZe = parcelRequire("lzfZe");

var $3CHiv = parcelRequire("3CHiv");

var $4DmkB = parcelRequire("4DmkB");
"use strict";
class $be4c9d6031b69343$export$3b0d6d7590275603 {
    constructor(){
        this._parsers = [];
        this._parsersValidated = false;
        /**
     * All loader parsers registered
     * @type {assets.LoaderParser[]}
     */ this.parsers = new Proxy(this._parsers, {
            set: (target, key, value)=>{
                this._parsersValidated = false;
                target[key] = value;
                return true;
            }
        });
        /** Cache loading promises that ae currently active */ this.promiseCache = {};
    }
    /** function used for testing */ reset() {
        this._parsersValidated = false;
        this.promiseCache = {};
    }
    /**
   * Used internally to generate a promise for the asset to be loaded.
   * @param url - The URL to be loaded
   * @param data - any custom additional information relevant to the asset being loaded
   * @returns - a promise that will resolve to an Asset for example a Texture of a JSON object
   */ _getLoadPromiseAndParser(url, data) {
        const result = {
            promise: null,
            parser: null
        };
        result.promise = (async ()=>{
            let asset = null;
            let parser = null;
            if (data.loadParser) {
                parser = this._parserHash[data.loadParser];
                if (!parser) (0, $hUCK4.warn)(`[Assets] specified load parser "${data.loadParser}" not found while loading ${url}`);
            }
            if (!parser) {
                for(let i = 0; i < this.parsers.length; i++){
                    const parserX = this.parsers[i];
                    if (parserX.load && parserX.test?.(url, data, this)) {
                        parser = parserX;
                        break;
                    }
                }
                if (!parser) {
                    (0, $hUCK4.warn)(`[Assets] ${url} could not be loaded as we don't know how to parse it, ensure the correct parser has been added`);
                    return null;
                }
            }
            asset = await parser.load(url, data, this);
            result.parser = parser;
            for(let i = 0; i < this.parsers.length; i++){
                const parser2 = this.parsers[i];
                if (parser2.parse) {
                    if (parser2.parse && await parser2.testParse?.(asset, data, this)) {
                        asset = await parser2.parse(asset, data, this) || asset;
                        result.parser = parser2;
                    }
                }
            }
            return asset;
        })();
        return result;
    }
    async load(assetsToLoadIn, onProgress) {
        if (!this._parsersValidated) this._validateParsers();
        let count = 0;
        const assets = {};
        const singleAsset = (0, $4DmkB.isSingleItem)(assetsToLoadIn);
        const assetsToLoad = (0, $3CHiv.convertToList)(assetsToLoadIn, (item)=>({
                alias: [
                    item
                ],
                src: item,
                data: {}
            }));
        const total = assetsToLoad.length;
        const promises = assetsToLoad.map(async (asset)=>{
            const url = (0, $lzfZe.path).toAbsolute(asset.src);
            if (!assets[asset.src]) try {
                if (!this.promiseCache[url]) this.promiseCache[url] = this._getLoadPromiseAndParser(url, asset);
                assets[asset.src] = await this.promiseCache[url].promise;
                if (onProgress) onProgress(++count / total);
            } catch (e) {
                delete this.promiseCache[url];
                delete assets[asset.src];
                throw new Error(`[Loader.load] Failed to load ${url}.
${e}`);
            }
        });
        await Promise.all(promises);
        return singleAsset ? assets[assetsToLoad[0].src] : assets;
    }
    /**
   * Unloads one or more assets. Any unloaded assets will be destroyed, freeing up memory for your app.
   * The parser that created the asset, will be the one that unloads it.
   * @example
   * // Single asset:
   * const asset = await Loader.load('cool.png');
   *
   * await Loader.unload('cool.png');
   *
   * console.log(asset.destroyed); // true
   * @param assetsToUnloadIn - urls that you want to unload, or a single one!
   */ async unload(assetsToUnloadIn) {
        const assetsToUnload = (0, $3CHiv.convertToList)(assetsToUnloadIn, (item)=>({
                alias: [
                    item
                ],
                src: item
            }));
        const promises = assetsToUnload.map(async (asset)=>{
            const url = (0, $lzfZe.path).toAbsolute(asset.src);
            const loadPromise = this.promiseCache[url];
            if (loadPromise) {
                const loadedAsset = await loadPromise.promise;
                delete this.promiseCache[url];
                await loadPromise.parser?.unload?.(loadedAsset, asset, this);
            }
        });
        await Promise.all(promises);
    }
    /** validates our parsers, right now it only checks for name conflicts but we can add more here as required! */ _validateParsers() {
        this._parsersValidated = true;
        this._parserHash = this._parsers.filter((parser)=>parser.name).reduce((hash, parser)=>{
            if (!parser.name) (0, $hUCK4.warn)(`[Assets] loadParser should have a name`);
            else if (hash[parser.name]) (0, $hUCK4.warn)(`[Assets] loadParser name conflict "${parser.name}"`);
            return {
                ...hash,
                [parser.name]: parser
            };
        }, {});
    }
}



var $iCGeI = parcelRequire("iCGeI");

var $i9BKe = parcelRequire("i9BKe");
"use strict";
function $d89e452ad91824ca$export$7ff8b059fb914323(url, mimes) {
    if (Array.isArray(mimes)) {
        for (const mime of mimes){
            if (url.startsWith(`data:${mime}`)) return true;
        }
        return false;
    }
    return url.startsWith(`data:${mimes}`);
}



var $lzfZe = parcelRequire("lzfZe");
"use strict";
function $8f487e3828a5ee92$export$fd0180357b95b812(url, extension) {
    const tempURL = url.split("?")[0];
    const ext = (0, $lzfZe.path).extname(tempURL).toLowerCase();
    if (Array.isArray(extension)) return extension.includes(ext);
    return ext === extension;
}



var $iEtN5 = parcelRequire("iEtN5");
"use strict";
const $c569a63b2f914437$var$validJSONExtension = ".json";
const $c569a63b2f914437$var$validJSONMIME = "application/json";
const $c569a63b2f914437$export$e7c8553478f3aac7 = {
    extension: {
        type: (0, $i9BKe.ExtensionType).LoadParser,
        priority: (0, $iEtN5.LoaderParserPriority).Low
    },
    name: "loadJson",
    test (url) {
        return (0, $d89e452ad91824ca$export$7ff8b059fb914323)(url, $c569a63b2f914437$var$validJSONMIME) || (0, $8f487e3828a5ee92$export$fd0180357b95b812)(url, $c569a63b2f914437$var$validJSONExtension);
    },
    async load (url) {
        const response = await (0, $iCGeI.DOMAdapter).get().fetch(url);
        const json = await response.json();
        return json;
    }
};



var $iCGeI = parcelRequire("iCGeI");

var $i9BKe = parcelRequire("i9BKe");



var $iEtN5 = parcelRequire("iEtN5");
"use strict";
const $779da4c964b62347$var$validTXTExtension = ".txt";
const $779da4c964b62347$var$validTXTMIME = "text/plain";
const $779da4c964b62347$export$3835b7ee6dbebde8 = {
    name: "loadTxt",
    extension: {
        type: (0, $i9BKe.ExtensionType).LoadParser,
        priority: (0, $iEtN5.LoaderParserPriority).Low,
        name: "loadTxt"
    },
    test (url) {
        return (0, $d89e452ad91824ca$export$7ff8b059fb914323)(url, $779da4c964b62347$var$validTXTMIME) || (0, $8f487e3828a5ee92$export$fd0180357b95b812)(url, $779da4c964b62347$var$validTXTExtension);
    },
    async load (url) {
        const response = await (0, $iCGeI.DOMAdapter).get().fetch(url);
        const txt = await response.text();
        return txt;
    }
};



var $iCGeI = parcelRequire("iCGeI");

var $i9BKe = parcelRequire("i9BKe");

var $hUCK4 = parcelRequire("hUCK4");

var $lzfZe = parcelRequire("lzfZe");

var $2IhKp = parcelRequire("2IhKp");



var $iEtN5 = parcelRequire("iEtN5");
"use strict";
const $0568dcd95d86dd78$var$validWeights = [
    "normal",
    "bold",
    "100",
    "200",
    "300",
    "400",
    "500",
    "600",
    "700",
    "800",
    "900"
];
const $0568dcd95d86dd78$var$validFontExtensions = [
    ".ttf",
    ".otf",
    ".woff",
    ".woff2"
];
const $0568dcd95d86dd78$var$validFontMIMEs = [
    "font/ttf",
    "font/otf",
    "font/woff",
    "font/woff2"
];
const $0568dcd95d86dd78$var$CSS_IDENT_TOKEN_REGEX = /^(--|-?[A-Z_])[0-9A-Z_-]*$/i;
function $0568dcd95d86dd78$export$c461ca8f39d93d9b(url) {
    const ext = (0, $lzfZe.path).extname(url);
    const name = (0, $lzfZe.path).basename(url, ext);
    const nameWithSpaces = name.replace(/(-|_)/g, " ");
    const nameTokens = nameWithSpaces.toLowerCase().split(" ").map((word)=>word.charAt(0).toUpperCase() + word.slice(1));
    let valid = nameTokens.length > 0;
    for (const token of nameTokens)if (!token.match($0568dcd95d86dd78$var$CSS_IDENT_TOKEN_REGEX)) {
        valid = false;
        break;
    }
    let fontFamilyName = nameTokens.join(" ");
    if (!valid) fontFamilyName = `"${fontFamilyName.replace(/[\\"]/g, "\\$&")}"`;
    return fontFamilyName;
}
const $0568dcd95d86dd78$var$validURICharactersRegex = /^[0-9A-Za-z%:/?#\[\]@!\$&'()\*\+,;=\-._~]*$/;
function $0568dcd95d86dd78$var$encodeURIWhenNeeded(uri) {
    if ($0568dcd95d86dd78$var$validURICharactersRegex.test(uri)) return uri;
    return encodeURI(uri);
}
const $0568dcd95d86dd78$export$129ed93ad26b0298 = {
    extension: {
        type: (0, $i9BKe.ExtensionType).LoadParser,
        priority: (0, $iEtN5.LoaderParserPriority).Low
    },
    name: "loadWebFont",
    test (url) {
        return (0, $d89e452ad91824ca$export$7ff8b059fb914323)(url, $0568dcd95d86dd78$var$validFontMIMEs) || (0, $8f487e3828a5ee92$export$fd0180357b95b812)(url, $0568dcd95d86dd78$var$validFontExtensions);
    },
    async load (url, options) {
        const fonts = (0, $iCGeI.DOMAdapter).get().getFontFaceSet();
        if (fonts) {
            const fontFaces = [];
            const name = options.data?.family ?? $0568dcd95d86dd78$export$c461ca8f39d93d9b(url);
            const weights = options.data?.weights?.filter((weight)=>$0568dcd95d86dd78$var$validWeights.includes(weight)) ?? [
                "normal"
            ];
            const data = options.data ?? {};
            for(let i = 0; i < weights.length; i++){
                const weight = weights[i];
                const font = new FontFace(name, `url(${$0568dcd95d86dd78$var$encodeURIWhenNeeded(url)})`, {
                    ...data,
                    weight: weight
                });
                await font.load();
                fonts.add(font);
                fontFaces.push(font);
            }
            (0, $2IhKp.Cache).set(`${name}-and-url`, {
                url: url,
                fontFaces: fontFaces
            });
            return fontFaces.length === 1 ? fontFaces[0] : fontFaces;
        }
        (0, $hUCK4.warn)("[loadWebFont] FontFace API is not supported. Skipping loading font");
        return null;
    },
    unload (font) {
        (Array.isArray(font) ? font : [
            font
        ]).forEach((t)=>{
            (0, $2IhKp.Cache).remove(t.family);
            (0, $iCGeI.DOMAdapter).get().getFontFaceSet().delete(t);
        });
    }
};



var $iCGeI = parcelRequire("iCGeI");

var $i9BKe = parcelRequire("i9BKe");

var $aQPld = parcelRequire("aQPld");

var $8aC7P = parcelRequire("8aC7P");

var $8kCsw = parcelRequire("8kCsw");
"use strict";
function $69836a01b04ce50b$export$8695ab2f322d2637(url, defaultValue = 1) {
    const resolution = (0, $8kCsw.Resolver).RETINA_PREFIX?.exec(url);
    if (resolution) return parseFloat(resolution[1]);
    return defaultValue;
}





var $iEtN5 = parcelRequire("iEtN5");

var $bLlTJ = parcelRequire("bLlTJ");

var $hUCK4 = parcelRequire("hUCK4");

var $2IhKp = parcelRequire("2IhKp");
"use strict";
function $703462f38e5d63e3$export$37b981a8c575f415(source, loader, url) {
    source.label = url;
    source._sourceOrigin = url;
    const texture = new (0, $bLlTJ.Texture)({
        source: source,
        label: url
    });
    const unload = ()=>{
        delete loader.promiseCache[url];
        if ((0, $2IhKp.Cache).has(url)) (0, $2IhKp.Cache).remove(url);
    };
    texture.source.once("destroy", ()=>{
        if (loader.promiseCache[url]) {
            (0, $hUCK4.warn)("[Assets] A TextureSource managed by Assets was destroyed instead of unloaded! Use Assets.unload() instead of destroying the TextureSource.");
            unload();
        }
    });
    texture.once("destroy", ()=>{
        if (!source.destroyed) {
            (0, $hUCK4.warn)("[Assets] A Texture managed by Assets was destroyed instead of unloaded! Use Assets.unload() instead of destroying the Texture.");
            unload();
        }
    });
    return texture;
}


"use strict";
const $258a91d856307e86$var$validSVGExtension = ".svg";
const $258a91d856307e86$var$validSVGMIME = "image/svg+xml";
const $258a91d856307e86$export$b6a2e78b63791dfa = {
    extension: {
        type: (0, $i9BKe.ExtensionType).LoadParser,
        priority: (0, $iEtN5.LoaderParserPriority).Low,
        name: "loadSVG"
    },
    name: "loadSVG",
    config: {
        crossOrigin: "anonymous",
        parseAsGraphicsContext: false
    },
    test (url) {
        return (0, $d89e452ad91824ca$export$7ff8b059fb914323)(url, $258a91d856307e86$var$validSVGMIME) || (0, $8f487e3828a5ee92$export$fd0180357b95b812)(url, $258a91d856307e86$var$validSVGExtension);
    },
    async load (url, asset, loader) {
        if (asset.data.parseAsGraphicsContext ?? this.config.parseAsGraphicsContext) return $258a91d856307e86$var$loadAsGraphics(url);
        return $258a91d856307e86$var$loadAsTexture(url, asset, loader, this.config.crossOrigin);
    },
    unload (asset) {
        asset.destroy(true);
    }
};
async function $258a91d856307e86$var$loadAsTexture(url, asset, loader, crossOrigin) {
    const response = await (0, $iCGeI.DOMAdapter).get().fetch(url);
    const blob = await response.blob();
    const blobUrl = URL.createObjectURL(blob);
    const image = new Image();
    image.src = blobUrl;
    image.crossOrigin = crossOrigin;
    await image.decode();
    URL.revokeObjectURL(blobUrl);
    const canvas = document.createElement("canvas");
    const context = canvas.getContext("2d");
    const resolution = asset.data?.resolution || (0, $69836a01b04ce50b$export$8695ab2f322d2637)(url);
    const width = asset.data?.width ?? image.width;
    const height = asset.data?.height ?? image.height;
    canvas.width = width * resolution;
    canvas.height = height * resolution;
    context.drawImage(image, 0, 0, width * resolution, height * resolution);
    const { parseAsGraphicsContext: _p, ...rest } = asset.data;
    const base = new (0, $aQPld.ImageSource)({
        resource: canvas,
        alphaMode: "premultiply-alpha-on-upload",
        resolution: resolution,
        ...rest
    });
    return (0, $703462f38e5d63e3$export$37b981a8c575f415)(base, loader, url);
}
async function $258a91d856307e86$var$loadAsGraphics(url) {
    const response = await (0, $iCGeI.DOMAdapter).get().fetch(url);
    const svgSource = await response.text();
    const context = new (0, $8aC7P.GraphicsContext)();
    context.svg(svgSource);
    return context;
}



var $iCGeI = parcelRequire("iCGeI");

var $i9BKe = parcelRequire("i9BKe");

var $aQPld = parcelRequire("aQPld");



const $9a21140edc3f77d8$var$WORKER_CODE = '(function () {\n    \'use strict\';\n\n    const WHITE_PNG = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mP8/x8AAwMCAO+ip1sAAAAASUVORK5CYII=";\n    async function checkImageBitmap() {\n      try {\n        if (typeof createImageBitmap !== "function")\n          return false;\n        const response = await fetch(WHITE_PNG);\n        const imageBlob = await response.blob();\n        const imageBitmap = await createImageBitmap(imageBlob);\n        return imageBitmap.width === 1 && imageBitmap.height === 1;\n      } catch (e) {\n        return false;\n      }\n    }\n    void checkImageBitmap().then((result) => {\n      self.postMessage(result);\n    });\n\n})();\n';
let $9a21140edc3f77d8$var$WORKER_URL = null;
class $9a21140edc3f77d8$export$2e2bcd8739ae039 {
    constructor(){
        if (!$9a21140edc3f77d8$var$WORKER_URL) $9a21140edc3f77d8$var$WORKER_URL = URL.createObjectURL(new Blob([
            $9a21140edc3f77d8$var$WORKER_CODE
        ], {
            type: "application/javascript"
        }));
        this.worker = new Worker($9a21140edc3f77d8$var$WORKER_URL);
    }
}
$9a21140edc3f77d8$export$2e2bcd8739ae039.revokeObjectURL = function revokeObjectURL() {
    if ($9a21140edc3f77d8$var$WORKER_URL) {
        URL.revokeObjectURL($9a21140edc3f77d8$var$WORKER_URL);
        $9a21140edc3f77d8$var$WORKER_URL = null;
    }
};


const $361d1ede8b4541ed$var$WORKER_CODE = '(function () {\n    \'use strict\';\n\n    async function loadImageBitmap(url, alphaMode) {\n      const response = await fetch(url);\n      if (!response.ok) {\n        throw new Error(`[WorkerManager.loadImageBitmap] Failed to fetch ${url}: ${response.status} ${response.statusText}`);\n      }\n      const imageBlob = await response.blob();\n      return alphaMode === "premultiplied-alpha" ? createImageBitmap(imageBlob, { premultiplyAlpha: "none" }) : createImageBitmap(imageBlob);\n    }\n    self.onmessage = async (event) => {\n      try {\n        const imageBitmap = await loadImageBitmap(event.data.data[0], event.data.data[1]);\n        self.postMessage({\n          data: imageBitmap,\n          uuid: event.data.uuid,\n          id: event.data.id\n        }, [imageBitmap]);\n      } catch (e) {\n        self.postMessage({\n          error: e,\n          uuid: event.data.uuid,\n          id: event.data.id\n        });\n      }\n    };\n\n})();\n';
let $361d1ede8b4541ed$var$WORKER_URL = null;
class $361d1ede8b4541ed$export$2e2bcd8739ae039 {
    constructor(){
        if (!$361d1ede8b4541ed$var$WORKER_URL) $361d1ede8b4541ed$var$WORKER_URL = URL.createObjectURL(new Blob([
            $361d1ede8b4541ed$var$WORKER_CODE
        ], {
            type: "application/javascript"
        }));
        this.worker = new Worker($361d1ede8b4541ed$var$WORKER_URL);
    }
}
$361d1ede8b4541ed$export$2e2bcd8739ae039.revokeObjectURL = function revokeObjectURL() {
    if ($361d1ede8b4541ed$var$WORKER_URL) {
        URL.revokeObjectURL($361d1ede8b4541ed$var$WORKER_URL);
        $361d1ede8b4541ed$var$WORKER_URL = null;
    }
};


"use strict";
let $778464c1601fd395$var$UUID = 0;
let $778464c1601fd395$var$MAX_WORKERS;
class $778464c1601fd395$var$WorkerManagerClass {
    constructor(){
        this._initialized = false;
        this._createdWorkers = 0;
        this._workerPool = [];
        this._queue = [];
        this._resolveHash = {};
    }
    isImageBitmapSupported() {
        if (this._isImageBitmapSupported !== void 0) return this._isImageBitmapSupported;
        this._isImageBitmapSupported = new Promise((resolve)=>{
            const { worker: worker } = new (0, $9a21140edc3f77d8$export$2e2bcd8739ae039)();
            worker.addEventListener("message", (event)=>{
                worker.terminate();
                (0, $9a21140edc3f77d8$export$2e2bcd8739ae039).revokeObjectURL();
                resolve(event.data);
            });
        });
        return this._isImageBitmapSupported;
    }
    loadImageBitmap(src, asset) {
        return this._run("loadImageBitmap", [
            src,
            asset?.data?.alphaMode
        ]);
    }
    async _initWorkers() {
        if (this._initialized) return;
        this._initialized = true;
    }
    _getWorker() {
        if ($778464c1601fd395$var$MAX_WORKERS === void 0) $778464c1601fd395$var$MAX_WORKERS = navigator.hardwareConcurrency || 4;
        let worker = this._workerPool.pop();
        if (!worker && this._createdWorkers < $778464c1601fd395$var$MAX_WORKERS) {
            this._createdWorkers++;
            worker = new (0, $361d1ede8b4541ed$export$2e2bcd8739ae039)().worker;
            worker.addEventListener("message", (event)=>{
                this._complete(event.data);
                this._returnWorker(event.target);
                this._next();
            });
        }
        return worker;
    }
    _returnWorker(worker) {
        this._workerPool.push(worker);
    }
    _complete(data) {
        if (data.error !== void 0) this._resolveHash[data.uuid].reject(data.error);
        else this._resolveHash[data.uuid].resolve(data.data);
        this._resolveHash[data.uuid] = null;
    }
    async _run(id, args) {
        await this._initWorkers();
        const promise = new Promise((resolve, reject)=>{
            this._queue.push({
                id: id,
                arguments: args,
                resolve: resolve,
                reject: reject
            });
        });
        this._next();
        return promise;
    }
    _next() {
        if (!this._queue.length) return;
        const worker = this._getWorker();
        if (!worker) return;
        const toDo = this._queue.pop();
        const id = toDo.id;
        this._resolveHash[$778464c1601fd395$var$UUID] = {
            resolve: toDo.resolve,
            reject: toDo.reject
        };
        worker.postMessage({
            data: toDo.arguments,
            uuid: $778464c1601fd395$var$UUID++,
            id: id
        });
    }
}
const $778464c1601fd395$export$bcff6015853c67ce = new $778464c1601fd395$var$WorkerManagerClass();



var $iEtN5 = parcelRequire("iEtN5");

"use strict";
const $7390591d087b0cdb$var$validImageExtensions = [
    ".jpeg",
    ".jpg",
    ".png",
    ".webp",
    ".avif"
];
const $7390591d087b0cdb$var$validImageMIMEs = [
    "image/jpeg",
    "image/png",
    "image/webp",
    "image/avif"
];
async function $7390591d087b0cdb$export$c614e6247302006d(url, asset) {
    const response = await (0, $iCGeI.DOMAdapter).get().fetch(url);
    if (!response.ok) throw new Error(`[loadImageBitmap] Failed to fetch ${url}: ${response.status} ${response.statusText}`);
    const imageBlob = await response.blob();
    return asset?.data?.alphaMode === "premultiplied-alpha" ? createImageBitmap(imageBlob, {
        premultiplyAlpha: "none"
    }) : createImageBitmap(imageBlob);
}
const $7390591d087b0cdb$export$897b113ee8307cd0 = {
    name: "loadTextures",
    extension: {
        type: (0, $i9BKe.ExtensionType).LoadParser,
        priority: (0, $iEtN5.LoaderParserPriority).High,
        name: "loadTextures"
    },
    config: {
        preferWorkers: true,
        preferCreateImageBitmap: true,
        crossOrigin: "anonymous"
    },
    test (url) {
        return (0, $d89e452ad91824ca$export$7ff8b059fb914323)(url, $7390591d087b0cdb$var$validImageMIMEs) || (0, $8f487e3828a5ee92$export$fd0180357b95b812)(url, $7390591d087b0cdb$var$validImageExtensions);
    },
    async load (url, asset, loader) {
        let src = null;
        if (globalThis.createImageBitmap && this.config.preferCreateImageBitmap) {
            if (this.config.preferWorkers && await (0, $778464c1601fd395$export$bcff6015853c67ce).isImageBitmapSupported()) src = await (0, $778464c1601fd395$export$bcff6015853c67ce).loadImageBitmap(url, asset);
            else src = await $7390591d087b0cdb$export$c614e6247302006d(url, asset);
        } else src = await new Promise((resolve)=>{
            src = new Image();
            src.crossOrigin = this.config.crossOrigin;
            src.src = url;
            if (src.complete) resolve(src);
            else src.onload = ()=>{
                resolve(src);
            };
        });
        const base = new (0, $aQPld.ImageSource)({
            resource: src,
            alphaMode: "premultiply-alpha-on-upload",
            resolution: asset.data?.resolution || (0, $69836a01b04ce50b$export$8695ab2f322d2637)(url),
            ...asset.data
        });
        return (0, $703462f38e5d63e3$export$37b981a8c575f415)(base, loader, url);
    },
    unload (texture) {
        texture.destroy(true);
    }
};



var $i9BKe = parcelRequire("i9BKe");

var $hNatJ = parcelRequire("hNatJ");

var $7blVu = parcelRequire("7blVu");




"use strict";
const $170b999e73028fac$var$validVideoExtensions = [
    ".mp4",
    ".m4v",
    ".webm",
    ".ogg",
    ".ogv",
    ".h264",
    ".avi",
    ".mov"
];
const $170b999e73028fac$var$validVideoMIMEs = $170b999e73028fac$var$validVideoExtensions.map((ext)=>`video/${ext.substring(1)}`);
function $170b999e73028fac$export$c47cb7c63271266e(element, url, crossorigin) {
    if (crossorigin === void 0 && !url.startsWith("data:")) element.crossOrigin = $170b999e73028fac$export$292083da55c5b406(url);
    else if (crossorigin !== false) element.crossOrigin = typeof crossorigin === "string" ? crossorigin : "anonymous";
}
function $170b999e73028fac$export$856bfbe81968ff62(element) {
    return new Promise((resolve, reject)=>{
        element.addEventListener("canplaythrough", loaded);
        element.addEventListener("error", error);
        element.load();
        function loaded() {
            cleanup();
            resolve();
        }
        function error(err) {
            cleanup();
            reject(err);
        }
        function cleanup() {
            element.removeEventListener("canplaythrough", loaded);
            element.removeEventListener("error", error);
        }
    });
}
function $170b999e73028fac$export$292083da55c5b406(url, loc = globalThis.location) {
    if (url.startsWith("data:")) return "";
    loc = loc || globalThis.location;
    const parsedUrl = new URL(url, document.baseURI);
    if (parsedUrl.hostname !== loc.hostname || parsedUrl.port !== loc.port || parsedUrl.protocol !== loc.protocol) return "anonymous";
    return "";
}
const $170b999e73028fac$export$68fa0976ba667d63 = {
    name: "loadVideo",
    extension: {
        type: (0, $i9BKe.ExtensionType).LoadParser,
        name: "loadVideo"
    },
    test (url) {
        const isValidDataUrl = (0, $d89e452ad91824ca$export$7ff8b059fb914323)(url, $170b999e73028fac$var$validVideoMIMEs);
        const isValidExtension = (0, $8f487e3828a5ee92$export$fd0180357b95b812)(url, $170b999e73028fac$var$validVideoExtensions);
        return isValidDataUrl || isValidExtension;
    },
    async load (url, asset, loader) {
        const options = {
            ...(0, $hNatJ.VideoSource).defaultOptions,
            resolution: asset.data?.resolution || (0, $69836a01b04ce50b$export$8695ab2f322d2637)(url),
            alphaMode: asset.data?.alphaMode || await (0, $7blVu.detectVideoAlphaMode)(),
            ...asset.data
        };
        const videoElement = document.createElement("video");
        const attributeMap = {
            preload: options.autoLoad !== false ? "auto" : void 0,
            "webkit-playsinline": options.playsinline !== false ? "" : void 0,
            playsinline: options.playsinline !== false ? "" : void 0,
            muted: options.muted === true ? "" : void 0,
            loop: options.loop === true ? "" : void 0,
            autoplay: options.autoPlay !== false ? "" : void 0
        };
        Object.keys(attributeMap).forEach((key)=>{
            const value = attributeMap[key];
            if (value !== void 0) videoElement.setAttribute(key, value);
        });
        if (options.muted === true) videoElement.muted = true;
        $170b999e73028fac$export$c47cb7c63271266e(videoElement, url, options.crossorigin);
        const sourceElement = document.createElement("source");
        let mime;
        if (url.startsWith("data:")) mime = url.slice(5, url.indexOf(";"));
        else if (!url.startsWith("blob:")) {
            const ext = url.split("?")[0].slice(url.lastIndexOf(".") + 1).toLowerCase();
            mime = (0, $hNatJ.VideoSource).MIME_TYPES[ext] || `video/${ext}`;
        }
        sourceElement.src = url;
        if (mime) sourceElement.type = mime;
        return new Promise((resolve)=>{
            const onCanPlay = async ()=>{
                const base = new (0, $hNatJ.VideoSource)({
                    ...options,
                    resource: videoElement
                });
                videoElement.removeEventListener("canplay", onCanPlay);
                if (asset.data.preload) await $170b999e73028fac$export$856bfbe81968ff62(videoElement);
                resolve((0, $703462f38e5d63e3$export$37b981a8c575f415)(base, loader, url));
            };
            videoElement.addEventListener("canplay", onCanPlay);
            videoElement.appendChild(sourceElement);
        });
    },
    unload (texture) {
        texture.destroy(true);
    }
};



var $i9BKe = parcelRequire("i9BKe");

var $8kCsw = parcelRequire("8kCsw");

var $i9BKe = parcelRequire("i9BKe");


var $8kCsw = parcelRequire("8kCsw");
"use strict";
const $f9f0a4a658d5e519$export$cc356fa83de02bea = {
    extension: {
        type: (0, $i9BKe.ExtensionType).ResolveParser,
        name: "resolveTexture"
    },
    test: (0, $7390591d087b0cdb$export$897b113ee8307cd0).test,
    parse: (value)=>({
            resolution: parseFloat((0, $8kCsw.Resolver).RETINA_PREFIX.exec(value)?.[1] ?? "1"),
            format: value.split(".").pop(),
            src: value
        })
};


"use strict";
const $7c85897abf6bc2d6$export$2b5cca0b89cb089c = {
    extension: {
        type: (0, $i9BKe.ExtensionType).ResolveParser,
        priority: -2,
        name: "resolveJson"
    },
    test: (value)=>(0, $8kCsw.Resolver).RETINA_PREFIX.test(value) && value.endsWith(".json"),
    parse: (0, $f9f0a4a658d5e519$export$cc356fa83de02bea).parse
};




var $8kCsw = parcelRequire("8kCsw");

var $3CHiv = parcelRequire("3CHiv");

var $4DmkB = parcelRequire("4DmkB");
"use strict";
class $f4e4ce59fcdafcd2$export$137d4dd907afac85 {
    constructor(){
        this._detections = [];
        this._initialized = false;
        this.resolver = new (0, $8kCsw.Resolver)();
        this.loader = new (0, $be4c9d6031b69343$export$3b0d6d7590275603)();
        this.cache = (0, $2IhKp.Cache);
        this._backgroundLoader = new (0, $1adc37b2cea8de16$export$1949379a83b843d5)(this.loader);
        this._backgroundLoader.active = true;
        this.reset();
    }
    /**
   * Best practice is to call this function before any loading commences
   * Initiating is the best time to add any customization to the way things are loaded.
   *
   * you do not need to call this for the Assets class to work, only if you want to set any initial properties
   * @param options - options to initialize the Assets manager with
   */ async init(options = {}) {
        if (this._initialized) {
            (0, $hUCK4.warn)("[Assets]AssetManager already initialized, did you load before calling this Assets.init()?");
            return;
        }
        this._initialized = true;
        if (options.defaultSearchParams) this.resolver.setDefaultSearchParams(options.defaultSearchParams);
        if (options.basePath) this.resolver.basePath = options.basePath;
        if (options.bundleIdentifier) this.resolver.setBundleIdentifier(options.bundleIdentifier);
        if (options.manifest) {
            let manifest = options.manifest;
            if (typeof manifest === "string") manifest = await this.load(manifest);
            this.resolver.addManifest(manifest);
        }
        const resolutionPref = options.texturePreference?.resolution ?? 1;
        const resolution = typeof resolutionPref === "number" ? [
            resolutionPref
        ] : resolutionPref;
        const formats = await this._detectFormats({
            preferredFormats: options.texturePreference?.format,
            skipDetections: options.skipDetections,
            detections: this._detections
        });
        this.resolver.prefer({
            params: {
                format: formats,
                resolution: resolution
            }
        });
        if (options.preferences) this.setPreferences(options.preferences);
    }
    /**
   * Allows you to specify how to resolve any assets load requests.
   * There are a few ways to add things here as shown below:
   * @example
   * import { Assets } from 'pixi.js';
   *
   * // Simple
   * Assets.add({alias: 'bunnyBooBoo', src: 'bunny.png'});
   * const bunny = await Assets.load('bunnyBooBoo');
   *
   * // Multiple keys:
   * Assets.add({alias: ['burger', 'chicken'], src: 'bunny.png'});
   *
   * const bunny = await Assets.load('burger');
   * const bunny2 = await Assets.load('chicken');
   *
   * // passing options to to the object
   * Assets.add({
   *     alias: 'bunnyBooBooSmooth',
   *     src: 'bunny{png,webp}',
   *     data: { scaleMode: SCALE_MODES.NEAREST }, // Base texture options
   * });
   *
   * // Multiple assets
   *
   * // The following all do the same thing:
   *
   * Assets.add({alias: 'bunnyBooBoo', src: 'bunny{png,webp}'});
   *
   * Assets.add({
   *     alias: 'bunnyBooBoo',
   *     src: [
   *         'bunny.png',
   *         'bunny.webp',
   *    ],
   * });
   *
   * const bunny = await Assets.load('bunnyBooBoo'); // Will try to load WebP if available
   * @param assets - the unresolved assets to add to the resolver
   */ add(assets) {
        this.resolver.add(assets);
    }
    async load(urls, onProgress) {
        if (!this._initialized) await this.init();
        const singleAsset = (0, $4DmkB.isSingleItem)(urls);
        const urlArray = (0, $3CHiv.convertToList)(urls).map((url)=>{
            if (typeof url !== "string") {
                const aliases = this.resolver.getAlias(url);
                if (aliases.some((alias)=>!this.resolver.hasKey(alias))) this.add(url);
                return Array.isArray(aliases) ? aliases[0] : aliases;
            }
            if (!this.resolver.hasKey(url)) this.add({
                alias: url,
                src: url
            });
            return url;
        });
        const resolveResults = this.resolver.resolve(urlArray);
        const out = await this._mapLoadToResolve(resolveResults, onProgress);
        return singleAsset ? out[urlArray[0]] : out;
    }
    /**
   * This adds a bundle of assets in one go so that you can load them as a group.
   * For example you could add a bundle for each screen in you pixi app
   * @example
   * import { Assets } from 'pixi.js';
   *
   * Assets.addBundle('animals', [
   *  { alias: 'bunny', src: 'bunny.png' },
   *  { alias: 'chicken', src: 'chicken.png' },
   *  { alias: 'thumper', src: 'thumper.png' },
   * ]);
   * // or
   * Assets.addBundle('animals', {
   *     bunny: 'bunny.png',
   *     chicken: 'chicken.png',
   *     thumper: 'thumper.png',
   * });
   *
   * const assets = await Assets.loadBundle('animals');
   * @param bundleId - the id of the bundle to add
   * @param assets - a record of the asset or assets that will be chosen from when loading via the specified key
   */ addBundle(bundleId, assets) {
        this.resolver.addBundle(bundleId, assets);
    }
    /**
   * Bundles are a way to load multiple assets at once.
   * If a manifest has been provided to the init function then you can load a bundle, or bundles.
   * you can also add bundles via `addBundle`
   * @example
   * import { Assets } from 'pixi.js';
   *
   * // Manifest Example
   * const manifest = {
   *     bundles: [
   *         {
   *             name: 'load-screen',
   *             assets: [
   *                 {
   *                     alias: 'background',
   *                     src: 'sunset.png',
   *                 },
   *                 {
   *                     alias: 'bar',
   *                     src: 'load-bar.{png,webp}',
   *                 },
   *             ],
   *         },
   *         {
   *             name: 'game-screen',
   *             assets: [
   *                 {
   *                     alias: 'character',
   *                     src: 'robot.png',
   *                 },
   *                 {
   *                     alias: 'enemy',
   *                     src: 'bad-guy.png',
   *                 },
   *             ],
   *         },
   *     ]
   * };
   *
   * await Assets.init({ manifest });
   *
   * // Load a bundle...
   * loadScreenAssets = await Assets.loadBundle('load-screen');
   * // Load another bundle...
   * gameScreenAssets = await Assets.loadBundle('game-screen');
   * @param bundleIds - the bundle id or ids to load
   * @param onProgress - Optional function that is called when progress on asset loading is made.
   * The function is passed a single parameter, `progress`, which represents the percentage (0.0 - 1.0)
   * of the assets loaded. Do not use this function to detect when assets are complete and available,
   * instead use the Promise returned by this function.
   * @returns all the bundles assets or a hash of assets for each bundle specified
   */ async loadBundle(bundleIds, onProgress) {
        if (!this._initialized) await this.init();
        let singleAsset = false;
        if (typeof bundleIds === "string") {
            singleAsset = true;
            bundleIds = [
                bundleIds
            ];
        }
        const resolveResults = this.resolver.resolveBundle(bundleIds);
        const out = {};
        const keys = Object.keys(resolveResults);
        let count = 0;
        let total = 0;
        const _onProgress = ()=>{
            onProgress?.(++count / total);
        };
        const promises = keys.map((bundleId)=>{
            const resolveResult = resolveResults[bundleId];
            total += Object.keys(resolveResult).length;
            return this._mapLoadToResolve(resolveResult, _onProgress).then((resolveResult2)=>{
                out[bundleId] = resolveResult2;
            });
        });
        await Promise.all(promises);
        return singleAsset ? out[bundleIds[0]] : out;
    }
    /**
   * Initiate a background load of some assets. It will passively begin to load these assets in the background.
   * So when you actually come to loading them you will get a promise that resolves to the loaded assets immediately
   *
   * An example of this might be that you would background load game assets after your initial load.
   * then when you got to actually load your game screen assets when a player goes to the game - the loading
   * would already have stared or may even be complete, saving you having to show an interim load bar.
   * @example
   * import { Assets } from 'pixi.js';
   *
   * Assets.backgroundLoad('bunny.png');
   *
   * // later on in your app...
   * await Assets.loadBundle('bunny.png'); // Will resolve quicker as loading may have completed!
   * @param urls - the url / urls you want to background load
   */ async backgroundLoad(urls) {
        if (!this._initialized) await this.init();
        if (typeof urls === "string") urls = [
            urls
        ];
        const resolveResults = this.resolver.resolve(urls);
        this._backgroundLoader.add(Object.values(resolveResults));
    }
    /**
   * Initiate a background of a bundle, works exactly like backgroundLoad but for bundles.
   * this can only be used if the loader has been initiated with a manifest
   * @example
   * import { Assets } from 'pixi.js';
   *
   * await Assets.init({
   *     manifest: {
   *         bundles: [
   *             {
   *                 name: 'load-screen',
   *                 assets: [...],
   *             },
   *             ...
   *         ],
   *     },
   * });
   *
   * Assets.backgroundLoadBundle('load-screen');
   *
   * // Later on in your app...
   * await Assets.loadBundle('load-screen'); // Will resolve quicker as loading may have completed!
   * @param bundleIds - the bundleId / bundleIds you want to background load
   */ async backgroundLoadBundle(bundleIds) {
        if (!this._initialized) await this.init();
        if (typeof bundleIds === "string") bundleIds = [
            bundleIds
        ];
        const resolveResults = this.resolver.resolveBundle(bundleIds);
        Object.values(resolveResults).forEach((resolveResult)=>{
            this._backgroundLoader.add(Object.values(resolveResult));
        });
    }
    /**
   * Only intended for development purposes.
   * This will wipe the resolver and caches.
   * You will need to reinitialize the Asset
   */ reset() {
        this.resolver.reset();
        this.loader.reset();
        this.cache.reset();
        this._initialized = false;
    }
    get(keys) {
        if (typeof keys === "string") return (0, $2IhKp.Cache).get(keys);
        const assets = {};
        for(let i = 0; i < keys.length; i++)assets[i] = (0, $2IhKp.Cache).get(keys[i]);
        return assets;
    }
    /**
   * helper function to map resolved assets back to loaded assets
   * @param resolveResults - the resolve results from the resolver
   * @param onProgress - the progress callback
   */ async _mapLoadToResolve(resolveResults, onProgress) {
        const resolveArray = [
            ...new Set(Object.values(resolveResults))
        ];
        this._backgroundLoader.active = false;
        const loadedAssets = await this.loader.load(resolveArray, onProgress);
        this._backgroundLoader.active = true;
        const out = {};
        resolveArray.forEach((resolveResult)=>{
            const asset = loadedAssets[resolveResult.src];
            const keys = [
                resolveResult.src
            ];
            if (resolveResult.alias) keys.push(...resolveResult.alias);
            keys.forEach((key)=>{
                out[key] = asset;
            });
            (0, $2IhKp.Cache).set(keys, asset);
        });
        return out;
    }
    /**
   * Unload an asset or assets. As the Assets class is responsible for creating the assets via the `load` function
   * this will make sure to destroy any assets and release them from memory.
   * Once unloaded, you will need to load the asset again.
   *
   * Use this to help manage assets if you find that you have a large app and you want to free up memory.
   *
   * - it's up to you as the developer to make sure that textures are not actively being used when you unload them,
   * Pixi won't break but you will end up with missing assets. Not a good look for the user!
   * @example
   * import { Assets } from 'pixi.js';
   *
   * // Load a URL:
   * const myImageTexture = await Assets.load('http://some.url.com/image.png'); // => returns a texture
   *
   * await Assets.unload('http://some.url.com/image.png')
   *
   * // myImageTexture will be destroyed now.
   *
   * // Unload multiple assets:
   * const textures = await Assets.unload(['thumper', 'chicko']);
   * @param urls - the urls to unload
   */ async unload(urls) {
        if (!this._initialized) await this.init();
        const urlArray = (0, $3CHiv.convertToList)(urls).map((url)=>typeof url !== "string" ? url.src : url);
        const resolveResults = this.resolver.resolve(urlArray);
        await this._unloadFromResolved(resolveResults);
    }
    /**
   * Bundles are a way to manage multiple assets at once.
   * this will unload all files in a bundle.
   *
   * once a bundle has been unloaded, you need to load it again to have access to the assets.
   * @example
   * import { Assets } from 'pixi.js';
   *
   * Assets.addBundle({
   *     'thumper': 'http://some.url.com/thumper.png',
   * })
   *
   * const assets = await Assets.loadBundle('thumper');
   *
   * // Now to unload...
   *
   * await Assets.unloadBundle('thumper');
   *
   * // All assets in the assets object will now have been destroyed and purged from the cache
   * @param bundleIds - the bundle id or ids to unload
   */ async unloadBundle(bundleIds) {
        if (!this._initialized) await this.init();
        bundleIds = (0, $3CHiv.convertToList)(bundleIds);
        const resolveResults = this.resolver.resolveBundle(bundleIds);
        const promises = Object.keys(resolveResults).map((bundleId)=>this._unloadFromResolved(resolveResults[bundleId]));
        await Promise.all(promises);
    }
    async _unloadFromResolved(resolveResult) {
        const resolveArray = Object.values(resolveResult);
        resolveArray.forEach((resolveResult2)=>{
            (0, $2IhKp.Cache).remove(resolveResult2.src);
        });
        await this.loader.unload(resolveArray);
    }
    /**
   * Detects the supported formats for the browser, and returns an array of supported formats, respecting
   * the users preferred formats order.
   * @param options - the options to use when detecting formats
   * @param options.preferredFormats - the preferred formats to use
   * @param options.skipDetections - if we should skip the detections altogether
   * @param options.detections - the detections to use
   * @returns - the detected formats
   */ async _detectFormats(options) {
        let formats = [];
        if (options.preferredFormats) formats = Array.isArray(options.preferredFormats) ? options.preferredFormats : [
            options.preferredFormats
        ];
        for (const detection of options.detections){
            if (options.skipDetections || await detection.test()) formats = await detection.add(formats);
            else if (!options.skipDetections) formats = await detection.remove(formats);
        }
        formats = formats.filter((format, index)=>formats.indexOf(format) === index);
        return formats;
    }
    /** All the detection parsers currently added to the Assets class. */ get detections() {
        return this._detections;
    }
    /**
   * General setter for preferences. This is a helper function to set preferences on all parsers.
   * @param preferences - the preferences to set
   */ setPreferences(preferences) {
        this.loader.parsers.forEach((parser)=>{
            if (!parser.config) return;
            Object.keys(parser.config).filter((key)=>key in preferences).forEach((key)=>{
                parser.config[key] = preferences[key];
            });
        });
    }
}
const $f4e4ce59fcdafcd2$export$c8eca95e306f7116 = new $f4e4ce59fcdafcd2$export$137d4dd907afac85();
(0, $i9BKe.extensions).handleByList((0, $i9BKe.ExtensionType).LoadParser, $f4e4ce59fcdafcd2$export$c8eca95e306f7116.loader.parsers).handleByList((0, $i9BKe.ExtensionType).ResolveParser, $f4e4ce59fcdafcd2$export$c8eca95e306f7116.resolver.parsers).handleByList((0, $i9BKe.ExtensionType).CacheParser, $f4e4ce59fcdafcd2$export$c8eca95e306f7116.cache.parsers).handleByList((0, $i9BKe.ExtensionType).DetectionParser, $f4e4ce59fcdafcd2$export$c8eca95e306f7116.detections);
(0, $i9BKe.extensions).add((0, $df4c0fb70a898168$export$407b4625a915919d), (0, $c65eb9bc0713cb5d$export$b106d7c2de3b4d89), (0, $ca5df6e874c0bc98$export$a60d2d4a3c570783), (0, $c494cf4c5ea6913a$export$d19529a9ed9823d4), (0, $8c93018bb9bae76f$export$7726d83fee274e25), (0, $dfa8be665f85221f$export$5a1da481121f806a), (0, $64abecc9a39a8c54$export$a041d698a1896657), (0, $c569a63b2f914437$export$e7c8553478f3aac7), (0, $779da4c964b62347$export$3835b7ee6dbebde8), (0, $0568dcd95d86dd78$export$129ed93ad26b0298), (0, $258a91d856307e86$export$b6a2e78b63791dfa), (0, $7390591d087b0cdb$export$897b113ee8307cd0), (0, $170b999e73028fac$export$68fa0976ba667d63), (0, $67f0360d0045775d$export$402edee29ac8bed4), (0, $67f0360d0045775d$export$778a313228f06f6c), (0, $f9f0a4a658d5e519$export$cc356fa83de02bea), (0, $7c85897abf6bc2d6$export$2b5cca0b89cb089c));
const $f4e4ce59fcdafcd2$var$assetKeyMap = {
    loader: (0, $i9BKe.ExtensionType).LoadParser,
    resolver: (0, $i9BKe.ExtensionType).ResolveParser,
    cache: (0, $i9BKe.ExtensionType).CacheParser,
    detection: (0, $i9BKe.ExtensionType).DetectionParser
};
(0, $i9BKe.extensions).handle((0, $i9BKe.ExtensionType).Asset, (extension)=>{
    const ref = extension.ref;
    Object.entries($f4e4ce59fcdafcd2$var$assetKeyMap).filter(([key])=>!!ref[key]).forEach(([key, type])=>(0, $i9BKe.extensions).add(Object.assign(ref[key], // Allow the function to optionally define it's own
        // ExtensionMetadata, the use cases here is priority for LoaderParsers
        {
            extension: ref[key].extension ?? type
        })));
}, (extension)=>{
    const ref = extension.ref;
    Object.keys($f4e4ce59fcdafcd2$var$assetKeyMap).filter((key)=>!!ref[key]).forEach((key)=>(0, $i9BKe.extensions).remove(ref[key]));
});














































































































var $eY4rt = parcelRequire("eY4rt");





var $1HooC = parcelRequire("1HooC");









































































































































































































var $aFPUT = parcelRequire("aFPUT");






var $8QN7n = parcelRequire("8QN7n");


















var $eicwU = parcelRequire("eicwU");





































var $3cebA = parcelRequire("3cebA");











































var $4rhnu = parcelRequire("4rhnu");
























































var $3vRz3 = parcelRequire("3vRz3");

















var $2jYVZ = parcelRequire("2jYVZ");
"use strict";
(0, $i9BKe.extensions).add((0, $c220e1d99a2da004$export$a6aad6334ef58a1c), (0, $a52ecd5a016ebe0a$export$ee43dd1acddf6cf8));


var $aFPUT = parcelRequire("aFPUT");
var $83a57dc453139d82$exports = {};
// Export p2 classes












































var $83a57dc453139d82$var$p2 = $83a57dc453139d82$exports = {
    AABB: (parcelRequire("hkl1e")),
    AngleLockEquation: (parcelRequire("5PEF1")),
    Body: (parcelRequire("e7hLo")),
    Broadphase: (parcelRequire("dQgku")),
    Capsule: (parcelRequire("4flMw")),
    Circle: (parcelRequire("OJ0UJ")),
    Constraint: (parcelRequire("3iby4")),
    ContactEquation: (parcelRequire("cSwh0")),
    ContactEquationPool: (parcelRequire("8P1Fq")),
    ContactMaterial: (parcelRequire("hzM8V")),
    Convex: (parcelRequire("clDtn")),
    DistanceConstraint: (parcelRequire("2pi2h")),
    Equation: (parcelRequire("f0tQu")),
    EventEmitter: (parcelRequire("5POlg")),
    FrictionEquation: (parcelRequire("jNxse")),
    FrictionEquationPool: (parcelRequire("gwWMZ")),
    GearConstraint: (parcelRequire("bb1X1")),
    GSSolver: (parcelRequire("hejTV")),
    Heightfield: (parcelRequire("6Xtot")),
    Line: (parcelRequire("d7wN7")),
    LockConstraint: (parcelRequire("48dNO")),
    Material: (parcelRequire("kfn8e")),
    Narrowphase: (parcelRequire("3QUo8")),
    NaiveBroadphase: (parcelRequire("8e56j")),
    Particle: (parcelRequire("fwNHk")),
    Plane: (parcelRequire("hNAi3")),
    Pool: (parcelRequire("kaNFS")),
    RevoluteConstraint: (parcelRequire("fc4SC")),
    PrismaticConstraint: (parcelRequire("1u9oZ")),
    Ray: (parcelRequire("l9ZUH")),
    RaycastResult: (parcelRequire("ZlKj0")),
    Box: (parcelRequire("62ywx")),
    RotationalVelocityEquation: (parcelRequire("5vxRN")),
    SAPBroadphase: (parcelRequire("konik")),
    Shape: (parcelRequire("k7z01")),
    Solver: (parcelRequire("aZxNS")),
    Spring: (parcelRequire("94u9A")),
    TopDownVehicle: (parcelRequire("3TW5l")),
    LinearSpring: (parcelRequire("8ZZ8g")),
    RotationalSpring: (parcelRequire("B7IZE")),
    Utils: (parcelRequire("dMz05")),
    World: (parcelRequire("hGmj1")),
    vec2: (parcelRequire("2Ys9z")),
    version: (parcelRequire("hIDwd")).version
};
Object.defineProperty($83a57dc453139d82$var$p2, "Rectangle", {
    get: function() {
        console.warn("The Rectangle class has been renamed to Box.");
        return this.Box;
    }
});



function $2172aedd5a25ff17$export$842a2cf37af977e1(a, b) {
    return (a % b + b) % b;
}
function $2172aedd5a25ff17$export$f982906e4d317fcc(value) {
    return Math.max(value, 0);
}
function $2172aedd5a25ff17$export$7d15b64cf5a3a4c4(value, min = 0, max = 1) {
    return Math.max(min, Math.min(max, value));
}
function $2172aedd5a25ff17$export$56196e15071099de(t) {
    t = $2172aedd5a25ff17$export$7d15b64cf5a3a4c4(t);
    return 3 * t ** 2 - 2 * t ** 3;
}
function $2172aedd5a25ff17$export$92900799e793e1cd(t) {
    t = $2172aedd5a25ff17$export$7d15b64cf5a3a4c4(t);
    return 6 * t ** 5 - 15 * t ** 4 + 10 * t ** 3;
}
function $2172aedd5a25ff17$export$3a89f8d6f6bf6c9f(a, b, t = 0.5) {
    return (1 - t) * a + t * b;
}
function $2172aedd5a25ff17$export$249619bf5c02b900(a, b, t = 0.5) {
    const x = $2172aedd5a25ff17$export$3a89f8d6f6bf6c9f(a[0], b[0], t);
    const y = $2172aedd5a25ff17$export$3a89f8d6f6bf6c9f(a[1], b[1], t);
    return (0, $6b6a54a072724620$export$e7c866399fa523f5)(x, y);
}
function $2172aedd5a25ff17$export$e4d952dcf42a5ff5(a, b, t = 0.5, threshold = 0.01) {
    if (Math.abs(b - a) < threshold) return b;
    return $2172aedd5a25ff17$export$3a89f8d6f6bf6c9f(a, b, t);
}
function $2172aedd5a25ff17$export$e3df76cf4464bc81(angle) {
    return $2172aedd5a25ff17$export$842a2cf37af977e1(angle + Math.PI, Math.PI * 2) - Math.PI;
}
function $2172aedd5a25ff17$export$ff5848069bdbaf5a(a, b) {
    return $2172aedd5a25ff17$export$842a2cf37af977e1(b - a + Math.PI, Math.PI * 2) - Math.PI;
}
function $2172aedd5a25ff17$export$e6bfdeff8bfc94f9(degrees) {
    return degrees * Math.PI / 180;
}
function $2172aedd5a25ff17$export$54390e3b44c4a9cb(radians) {
    return radians * 180 / Math.PI;
}
function $2172aedd5a25ff17$export$33ee1f58d7bb6e30(theta) {
    return $2172aedd5a25ff17$export$e3df76cf4464bc81(Math.PI - theta);
}
function $2172aedd5a25ff17$export$f20e6a45c2713c2c(theta) {
    return $2172aedd5a25ff17$export$e3df76cf4464bc81(-theta);
}
function $2172aedd5a25ff17$export$d429e27eb9ce77d1(theta) {
    return $2172aedd5a25ff17$export$e3df76cf4464bc81(theta - Math.PI);
}
function $2172aedd5a25ff17$export$240e5320db1c20ee(theta, r) {
    return (0, $6b6a54a072724620$export$e7c866399fa523f5)(r * Math.cos(theta), r * Math.sin(theta));
}
function $2172aedd5a25ff17$export$d9385b944d276332(points) {
    let total = 0;
    for(let i = 1; i < points.length; i++){
        const [x1, y1] = points[i - 1];
        const [x2, y2] = points[i];
        total += (x2 - x1) * (y2 + y1);
    }
    return total > 0;
}
function $2172aedd5a25ff17$export$b26f3c29b28fecef(from, to, stepSize) {
    if (to > from) return Math.min(from + stepSize, to);
    else return Math.max(from - stepSize, to);
}


function $6b6a54a072724620$export$e7c866399fa523f5(x, y) {
    if (x instanceof $6b6a54a072724620$export$19606695c7c6ab3a) return x.clone();
    else if (x instanceof Array || x instanceof Float32Array) return new $6b6a54a072724620$export$19606695c7c6ab3a(x[0], x[1]);
    return new $6b6a54a072724620$export$19606695c7c6ab3a(x ?? 0, y ?? x ?? 0);
}
class $6b6a54a072724620$export$19606695c7c6ab3a extends Array {
    constructor(x, y){
        super();
        this.length = 2;
        if (isNaN(x) || isNaN(y)) throw new Error(`Can't make a V2d with NaN ${x},${y}`);
        this[0] = x;
        this[1] = y;
    }
    get v() {
        return this;
    }
    /** Return the result of adding this vector to another. */ add(other) {
        return this.clone().iadd(other);
    }
    /** (In Place) Return the result of adding this vector to another. */ iadd(other) {
        this[0] += other[0];
        this[1] += other[1];
        return this;
    }
    /** Return the result of multiplying a scalar by another vector and adding it to this. */ addScaled(other, scale) {
        return this.clone().iaddScaled(other, scale);
    }
    /** (In Place) Return the result of multiplying a scalar by another vector and adding it to this. */ iaddScaled(other, scale = 1) {
        this[0] += other[0] * scale;
        this[1] += other[1] * scale;
        return this;
    }
    /** Return the result of subtracting a vector from this one. */ sub(other) {
        return this.clone().isub(other);
    }
    /** (In Place) Return the result of subtracting a vector from this one. */ isub(other) {
        this[0] -= other[0];
        this[1] -= other[1];
        return this;
    }
    /** Return the result of multiplying this vector by a scalar. */ mul(scalar) {
        return this.clone().imul(scalar);
    }
    /** (In Place) Return the result of multiplying this vector by a scalar. */ imul(scalar) {
        this[0] *= scalar;
        this[1] *= scalar;
        return this;
    }
    /** Return the result of multiplying this vector by another vector componentwise. */ mulComponent(other) {
        return this.clone().imulComponent(other);
    }
    /** (In Place) Return the result of multiplying this vector by another vector componentwise. */ imulComponent(other) {
        this[0] *= other[0];
        this[1] *= other[1];
        return this;
    }
    /** Returns the result of rotating this vector 90 decgrees clockwise */ rotate90cw() {
        return new $6b6a54a072724620$export$19606695c7c6ab3a(this[1], -this[0]);
    }
    /** (In Place) Returns the result of rotating this vector 90 decgrees clockwise */ irotate90cw() {
        [this[0], this[1]] = [
            this[1],
            -this[0]
        ];
        return this;
    }
    /** Returns the result of rotating this vector 90 decgrees counter-clockwise */ rotate90ccw() {
        return new $6b6a54a072724620$export$19606695c7c6ab3a(-this[1], this[0]);
    }
    /** (In Place) Returns the result of rotating this vector 90 decgrees counter-clockwise */ irotate90ccw() {
        [this[0], this[1]] = [
            -this[1],
            this[0]
        ];
        return this;
    }
    /** Return the result of rotating this angle by `angle` radians ccw. */ rotate(angle) {
        return this.clone().irotate(angle);
    }
    /** (In Place) Return the result of rotating this angle by `angle` radians ccw. */ irotate(angle) {
        const cos = Math.cos(angle);
        const sin = Math.sin(angle);
        const x = this[0];
        const y = this[1];
        this[0] = cos * x - sin * y;
        this[1] = sin * x + cos * y;
        return this;
    }
    /** Return the dot product of this and another vector */ dot(other) {
        return this[0] * other[0] + this[1] * other[1];
    }
    set(x, y) {
        if (typeof x === "number") {
            this[0] = x;
            this[1] = y;
        } else {
            this[0] = x[0];
            this[1] = x[1];
        }
        return this;
    }
    /** Return a normalized version of this vector */ normalize(length = 1) {
        return this.clone().inormalize(length);
    }
    /** (In Place) Return a normalized version of this vector */ inormalize(length = 1) {
        if (!(this[0] === 0 && this[1] === 0)) this.magnitude = length;
        return this;
    }
    /** Limit the magnitude of this vector */ limit(max) {
        return this.clone().ilimit(max);
    }
    /** (In Place) Limit the magnitude of this vector */ ilimit(max) {
        if (this.magnitude > max) this.magnitude = max;
        return this;
    }
    /** Return a new vector with the same values as this one */ clone() {
        return new $6b6a54a072724620$export$19606695c7c6ab3a(this[0], this[1]);
    }
    /** Return a vector that is between this and other */ lerp(other, t = 0) {
        return this.clone().ilerp(other, t);
    }
    /** (In place) Return a vector that is between this and other */ ilerp(other, t = 0) {
        this[0] = (0, $2172aedd5a25ff17$export$3a89f8d6f6bf6c9f)(this[0], other[0], t);
        this[1] = (0, $2172aedd5a25ff17$export$3a89f8d6f6bf6c9f)(this[1], other[1], t);
        return this;
    }
    equals(other) {
        return other != undefined && other[0] == this[0] && other[1] == this[1];
    }
    /**
   * Alias for [0].
   */ get x() {
        return this[0];
    }
    set x(value) {
        this[0] = value;
    }
    /**
   * Alias for [1]
   */ get y() {
        return this[1];
    }
    set y(value) {
        this[1] = value;
    }
    /**
   * The magnitude (length) of this vector.
   * Changing it does not change the angle.
   */ get magnitude() {
        return Math.sqrt(this[0] * this[0] + this[1] * this[1]) || 0;
    }
    set magnitude(value) {
        if (this[0] !== 0 || this[1] !== 0) this.imul(value / this.magnitude);
    }
    /**
   * The angle in radians ccw from east of this vector.
   * Changing it does not change the magnitude.
   */ get angle() {
        return Math.atan2(this[1], this[0]);
    }
    set angle(value) {
        this.irotate(value - this.angle);
    }
}



var $eicwU = parcelRequire("eicwU");

class $348f60db61f8cc25$export$ee4b0c6dc2df0875 {
    constructor({ paralax: paralax = (0, $6b6a54a072724620$export$e7c866399fa523f5)(1.0, 1.0), anchor: anchor = (0, $6b6a54a072724620$export$e7c866399fa523f5)(0, 0), filters: filters = [], alpha: alpha = 1.0 } = {}){
        this.container = new $eicwU.Container();
        this.paralax = paralax;
        this.anchor = anchor;
        this.container.filters = filters;
        this.container.alpha = alpha;
    }
}


const $4fdefd1822880974$export$fdca3ba65b5cceec = {
    // The back plate
    back: new (0, $348f60db61f8cc25$export$ee4b0c6dc2df0875)(),
    // Skid marks and stuff
    backDecals: new (0, $348f60db61f8cc25$export$ee4b0c6dc2df0875)(),
    // Shadows and ambient occlusion
    shadows: new (0, $348f60db61f8cc25$export$ee4b0c6dc2df0875)(),
    holes: new (0, $348f60db61f8cc25$export$ee4b0c6dc2df0875)(),
    walls: new (0, $348f60db61f8cc25$export$ee4b0c6dc2df0875)(),
    pegs: new (0, $348f60db61f8cc25$export$ee4b0c6dc2df0875)(),
    // DEFAULT: The main stuff
    main: new (0, $348f60db61f8cc25$export$ee4b0c6dc2df0875)(),
    ball: new (0, $348f60db61f8cc25$export$ee4b0c6dc2df0875)(),
    // debugWorld
    debugWorld: new (0, $348f60db61f8cc25$export$ee4b0c6dc2df0875)(),
    // Stuff not in the world
    hud: new (0, $348f60db61f8cc25$export$ee4b0c6dc2df0875)({
        paralax: (0, $6b6a54a072724620$export$e7c866399fa523f5)(0, 0)
    }),
    // Stuff on the absolute top that's just used for debugging
    debugHud: new (0, $348f60db61f8cc25$export$ee4b0c6dc2df0875)({
        paralax: (0, $6b6a54a072724620$export$e7c866399fa523f5)(0, 0)
    })
};
const $4fdefd1822880974$export$3d0b505b9576cf7e = "main";


class $1d29da6ad0b954b4$export$2e2bcd8739ae039 {
    beginContact(contactInfo) {
        if ($1d29da6ad0b954b4$var$shouldTrack(contactInfo)) this.contacts.push(contactInfo);
    }
    endContact(contactInfo) {
        if ($1d29da6ad0b954b4$var$shouldTrack(contactInfo)) {
            const index = this.contacts.findIndex((info)=>$1d29da6ad0b954b4$var$contactsAreEqual(info, contactInfo));
            this.contacts.splice(index, 1);
        }
    }
    getContacts() {
        return this.contacts;
    }
    constructor(){
        this.contacts = [];
    }
}
/** Whether or not this is a collision we need to keep track of */ function $1d29da6ad0b954b4$var$shouldTrack({ shapeA: shapeA, shapeB: shapeB, bodyA: bodyA, bodyB: bodyB }) {
    return true;
}
/** Whether or not two ContactInfos represent the same contact */ function $1d29da6ad0b954b4$var$contactsAreEqual(a, b) {
    return a.bodyA === b.bodyA && a.bodyB === b.bodyB && a.shapeA === b.shapeA && a.shapeB === b.shapeB || a.bodyA === b.bodyB && a.bodyB === b.bodyA && a.shapeA === b.shapeB && a.shapeB === b.shapeA;
}


function $c0f9b00b45d3abcb$export$e4d4fc2de3f8add7(eventName) {
    return `on${eventName.charAt(0).toUpperCase()}${eventName.slice(1)}`;
}
function $c0f9b00b45d3abcb$export$7f9b4f9156103c75(handlerName) {
    const firstLetter = handlerName[2];
    const rest = handlerName.slice(3);
    return firstLetter.toLowerCase() + rest;
}


const $82e66643116ed123$export$b43c6e243e06c0f7 = (e)=>Boolean(e.onAfterPhysics);
const $82e66643116ed123$export$2111e3eecd094ce1 = (e)=>Boolean(e.onBeforeTick);
const $82e66643116ed123$export$60da9a422a2ce159 = (e)=>Boolean(e.onRender);
const $82e66643116ed123$export$b2d652a592070f7d = (e)=>Boolean(e.onLateRender);
const $82e66643116ed123$export$6bcff844eb68e7a1 = (e)=>Boolean(e.onTick);
const $82e66643116ed123$export$a6a03ec395687843 = (e)=>Boolean(e.onSlowTick);
const $82e66643116ed123$export$249c7b5e69175e84 = (e)=>Boolean(e.onPause);
const $82e66643116ed123$export$5ecc49a1eac18f11 = (e)=>Boolean(e.onResize);
const $82e66643116ed123$export$efe190848eea6a30 = (e)=>Boolean(e.onUnpause);
const $82e66643116ed123$export$57d24cb2f04f6e96 = (e)=>Boolean(e.body);
const $82e66643116ed123$export$fcf131c55a590803 = (e)=>Boolean(e.onButtonDown);
const $82e66643116ed123$export$bce9925042657969 = (e)=>Boolean(e.onButtonUp);
const $82e66643116ed123$export$4fb97c2e96dfe5d1 = (e)=>Boolean(e.onClick);
const $82e66643116ed123$export$785264017c24581c = (e)=>Boolean(e.onKeyDown);
const $82e66643116ed123$export$c6c6b94757b7aad3 = (e)=>Boolean(e.onKeyUp);
const $82e66643116ed123$export$d2d1ec3ab6955f6c = (e)=>Boolean(e.onMouseDown);
const $82e66643116ed123$export$244e66dc7e436f36 = (e)=>Boolean(e.onMouseUp);
const $82e66643116ed123$export$baf9aa95599589f7 = (e)=>Boolean(e.onRightClick);
const $82e66643116ed123$export$97638384bd009bac = (e)=>Boolean(e.onRightDown);
const $82e66643116ed123$export$7ff9159d045867c3 = (e)=>Boolean(e.onRightUp);
const $82e66643116ed123$export$6e39f70f695cba6b = (e)=>Boolean(e.onInputDeviceChange);


/** TODO: Document filter */ class $04179bd0fe63c1d8$export$2e2bcd8739ae039 {
    constructor(predicate){
        this.predicate = predicate;
        this.items = new Set();
    }
    addIfValid(item) {
        if (this.predicate(item)) this.items.add(item);
    }
    remove(item) {
        if (this.predicate(item)) this.items.delete(item);
    }
    get size() {
        return this.items.size;
    }
    get length() {
        return this.items.size;
    }
    [Symbol.iterator]() {
        return this.items[Symbol.iterator]();
    }
}


class $2bdf816bbe356527$export$eadac383198be9f3 {
    addFilter(filter, all = []) {
        if (!this.sets.has(filter)) {
            const set = new (0, $04179bd0fe63c1d8$export$2e2bcd8739ae039)(filter);
            for (const item of all)set.addIfValid(item);
            this.sets.set(filter, set);
        }
    }
    removeFilter(filter) {
        this.sets.delete(filter);
    }
    addItem(item) {
        for (const list of this.sets.values())list.addIfValid(item);
    }
    removeItem(item) {
        for (const list of this.sets.values())list.remove(item);
    }
    getItems(filter) {
        return this.sets.get(filter);
    }
    constructor(){
        this.sets = new Map();
    }
}


/**
 * A map of lists. Automatically creates and removes lists as needed.
 * TODO: Consider using a Set instead of an Array for the values.
 */ class $3afe5ecb614970f3$export$2e2bcd8739ae039 {
    constructor(){
        this.map = new Map();
    }
    add(key, value) {
        if (!this.map.has(key)) this.map.set(key, [
            value
        ]);
        else this.map.get(key).push(value);
    }
    get(key) {
        return this.map.get(key) ?? [];
    }
    has(key, value) {
        return this.map.has(key) && this.map.get(key).includes(value);
    }
    remove(key, value) {
        if (this.map.has(key)) {
            const array = this.map.get(key);
            const index = array.indexOf(value);
            if (index >= 0) {
                array.splice(index, 1);
                if (array.length === 0) this.map.delete(key);
                return;
            }
        }
        throw new Error(`<${key}:${value}> not found`);
    }
}


class $913c3d10ae4e12ec$export$2e2bcd8739ae039 {
    constructor(){
        /** Maps entity ids to entities */ this.idToEntity = new Map();
        /** Maps tags to entities */ this.tagged = new (0, $3afe5ecb614970f3$export$2e2bcd8739ae039)();
        /** Maps event types to entities that handle them */ this.handlers = new (0, $3afe5ecb614970f3$export$2e2bcd8739ae039)();
        /** Maps filters to entities that pass them */ this.filters = new (0, $2bdf816bbe356527$export$eadac383198be9f3)();
        /** All entities */ this.all = new Set();
        this.addFilter((0, $82e66643116ed123$export$57d24cb2f04f6e96));
    }
    get withBody() {
        return this.getByFilter((0, $82e66643116ed123$export$57d24cb2f04f6e96));
    }
    /** Adds an entity to this list and all sublists and does all the bookkeeping */ add(entity) {
        this.all.add(entity);
        this.filters.addItem(entity);
        if (entity.tags) for (const tag of entity.tags)this.tagged.add(tag, entity);
        for (const methodName of $913c3d10ae4e12ec$var$getAllMethods(entity))if (methodName.startsWith("on")) this.handlers.add((0, $c0f9b00b45d3abcb$export$7f9b4f9156103c75)(methodName), entity);
        if (entity.id) {
            if (this.idToEntity.has(entity.id)) throw new Error(`entities with duplicate ids: ${entity.id}`);
            this.idToEntity.set(entity.id, entity);
        }
    }
    /** Removes an entity from this list and all the sublists and does some bookkeeping */ remove(entity) {
        this.all.delete(entity);
        this.filters.removeItem(entity);
        if (entity.tags) for (const tag of entity.tags)this.tagged.remove(tag, entity);
        for (const methodName of $913c3d10ae4e12ec$var$getAllMethods(entity))if (methodName.startsWith("on")) this.handlers.remove((0, $c0f9b00b45d3abcb$export$7f9b4f9156103c75)(methodName), entity);
        if (entity.id) this.idToEntity.delete(entity.id);
    }
    /** Get the entity with the given id. */ getById(id) {
        return this.idToEntity.get(id);
    }
    /** Returns all entities with the given tag. */ getTagged(tag) {
        return this.tagged.get(tag);
    }
    /** Returns all entities that have all the given tags */ getTaggedAll(...tags) {
        if (tags.length === 0) return [];
        return this.getTagged(tags[0]).filter((e)=>tags.every((t)=>e.tags.includes(t)));
    }
    /** Returns all entities that have at least one of the given tags */ getTaggedAny(...tags) {
        const result = new Set();
        for (const tag of tags)for (const e of this.getTagged(tag))result.add(e);
        return [
            ...result
        ];
    }
    /**
   * Adds a filter for fast lookup with getByFilter() in the future.
   */ addFilter(filter) {
        this.filters.addFilter(filter, this.all);
    }
    /**
   * Removes a filter that was added with addFilter().
   */ removeFilter(filter) {
        this.filters.removeFilter(filter);
    }
    /**
   * Return all the entities that pass a type guard.
   * Pair with addFilter() to make this fast.
   */ getByFilter(filter) {
        const result = this.filters.getItems(filter);
        return result ?? [
            ...this.all
        ].filter(filter);
    }
    /**
   * Get all entities that handle a specific event type.
   */ getHandlers(eventType) {
        return this.handlers.get(eventType);
    }
    /**
   * Iterate through all the entities.
   */ [Symbol.iterator]() {
        return this.all[Symbol.iterator]();
    }
}
function $913c3d10ae4e12ec$var$getAllMethods(entity) {
    const methods = [];
    let current = entity;
    // Traverse up the prototype chain
    while(current !== null && current !== undefined && current !== Object.prototype){
        // Get own property names of the current object
        const propertyNames = Object.getOwnPropertyNames(current);
        // Filter out non-function properties and already added methods
        for (const name of propertyNames)// Access on entity and not currentObject because we're looking at prototypes
        if (typeof entity[name] === "function" && !methods.includes(name)) methods.push(name);
        // Move up the prototype chain
        current = Object.getPrototypeOf(current);
    }
    return methods;
}








var $eY4rt = parcelRequire("eY4rt");
var $1HooC = parcelRequire("1HooC");






function $ade141b390e8be57$export$9d43ca2c1f9c9b92(p1, p2) {
    const vector = p2.sub(p1);
    const midpoint = p1.add(p2).imul(0.5);
    return new (0, $83a57dc453139d82$exports.Line)({
        position: midpoint,
        angle: vector.angle,
        length: vector.magnitude
    });
}
function $ade141b390e8be57$export$5398643d93d9cfa1(shapeDef) {
    const shape = $ade141b390e8be57$var$baseShapeFromDef(shapeDef);
    shape.collisionGroup = shapeDef.collisionGroup;
    shape.collisionMask = shapeDef.collisionMask;
    return shape;
}
function $ade141b390e8be57$var$baseShapeFromDef(shapeDef) {
    switch(shapeDef.type){
        case "line":
            return $ade141b390e8be57$export$9d43ca2c1f9c9b92((0, $6b6a54a072724620$export$e7c866399fa523f5)(shapeDef.start), (0, $6b6a54a072724620$export$e7c866399fa523f5)(shapeDef.end));
        case "circle":
            return new (0, $83a57dc453139d82$exports.Circle)({
                radius: shapeDef.radius,
                position: (0, $6b6a54a072724620$export$e7c866399fa523f5)(shapeDef.center),
                angle: 0
            });
        case "box":
            return new (0, $83a57dc453139d82$exports.Box)({
                width: shapeDef.size[0],
                height: shapeDef.size[1],
                position: (0, $6b6a54a072724620$export$e7c866399fa523f5)(shapeDef.center),
                angle: shapeDef.angle
            });
        case "convex":
            return new (0, $83a57dc453139d82$exports.Convex)({
                vertices: [
                    ...shapeDef.vertices
                ]
            });
    }
}



var $3cebA = parcelRequire("3cebA");
var $4rhnu = parcelRequire("4rhnu");
function $3e96093e790a5ff7$export$365048a7a2b11da6(name, layerName, options) {
    const sprite = (0, $4rhnu.Sprite).from(name);
    sprite.layerName = layerName;
    if (options?.anchor) sprite.anchor.set(...options.anchor);
    if (options?.size) sprite.setSize(...options.size);
    return sprite;
}
function $3e96093e790a5ff7$export$9a089bbc6e8eca86(spriteDef) {
    return $3e96093e790a5ff7$export$365048a7a2b11da6(spriteDef.image, spriteDef.layer, {
        anchor: spriteDef.anchor,
        size: spriteDef.size
    });
}
function $3e96093e790a5ff7$export$f83f79acb3f2cc85(layerName) {
    const graphics = new (0, $3cebA.Graphics)();
    graphics.layerName = layerName;
    return graphics;
}


class $c59361981bac2575$export$2e2bcd8739ae039 {
    constructor(entityDef){
        this.children = [];
        this.game = undefined;
        this.pausable = true;
        this.persistenceLevel = 0;
        this.tags = [];
        if (entityDef) this.loadFromDef(entityDef);
    }
    loadFromDef(def) {
        if (this.game) throw new Error("Can't load from def after entity has been added to game.");
        if (def.sprites) {
            if (def.sprites.length === 1) this.sprite = (0, $3e96093e790a5ff7$export$9a089bbc6e8eca86)(def.sprites[0]);
            else this.sprites = def.sprites.map((spriteDef)=>(0, $3e96093e790a5ff7$export$9a089bbc6e8eca86)(spriteDef));
        }
        if (def.body) {
            this.body = new (0, $83a57dc453139d82$exports.Body)({
                mass: def.body.mass
            });
            for (const shapeDef of def.body.shapes){
                const shape = (0, $ade141b390e8be57$export$5398643d93d9cfa1)(shapeDef);
                this.body.addShape(shape, shape.position, shape.angle);
            }
        }
    }
    /** Convert local coordinates to world coordinates. Requires a body */ localToWorld(localPoint) {
        if (this.body) {
            const result = (0, $6b6a54a072724620$export$e7c866399fa523f5)(0, 0);
            this.body.toWorldFrame(result, localPoint);
            return result;
        }
        return (0, $6b6a54a072724620$export$e7c866399fa523f5)(0, 0);
    }
    worldToLocal(worldPoint) {
        if (this.body) {
            const result = (0, $6b6a54a072724620$export$e7c866399fa523f5)(0, 0);
            this.body.toLocalFrame(result, worldPoint);
            return result;
        }
        return (0, $6b6a54a072724620$export$e7c866399fa523f5)(0, 0);
    }
    getPosition() {
        if (this.body) return (0, $6b6a54a072724620$export$e7c866399fa523f5)(this.body.position);
        else if (this.sprite) return (0, $6b6a54a072724620$export$e7c866399fa523f5)(this.sprite.position.x, this.sprite.position.y);
        throw new Error("Position is not implemented for this entity");
    }
    get isDestroyed() {
        return this.game == null;
    }
    // Removes this from the game. You probably shouldn't override this method.
    destroy() {
        if (this.game) {
            this.game.removeEntity(this);
            while(this.children?.length)this.children[this.children.length - 1].destroy();
            if (this.parent) {
                const pChildren = this.parent.children;
                const index = pChildren.lastIndexOf(this);
                if (index < 0) throw new Error(`Parent doesn't have child`);
                pChildren.splice(index, 1);
            }
        }
    }
    /** Add another entity as a child of this one. Child entities will get destroyed when their parent is destroyed. */ addChild(child, changeParent = false) {
        if (child.parent) {
            if (changeParent) {
                // This can lead to weird state where a child is added but its parent isn't, dunno if that's bad
                const oldParent = child.parent;
                oldParent.children.splice(oldParent.children.indexOf(child), 1);
            } else throw new Error("Child already has a parent.");
        }
        child.parent = this;
        this.children = this.children ?? [];
        this.children.push(child);
        if (this.game && !child.game) this.game.addEntity(child);
        return child;
    }
    /** Add multiple entities as children of this one. See addChild. */ addChildren(...children) {
        for (const child of children)this.addChild(child);
    }
    /**
   * Fulfills after the given amount of game time.
   * Use with delay=0 to wait until the next tick.
   * @param onTick  Do something every tick while waiting
   */ wait(delay = 0, onTick, timerId) {
        return new Promise((resolve)=>{
            const timer = new $c59361981bac2575$var$Timer(delay, ()=>resolve(), onTick, timerId);
            timer.persistenceLevel = this.persistenceLevel;
            this.addChild(timer);
        });
    }
    /**
   * Fulfills after the given amount of game time.
   * Use with delay=0 to wait until the next tick.
   * @param onRender  Do something every render while waiting
   */ waitRender(delay = 0, onRender, timerId) {
        return new Promise((resolve)=>{
            const timer = new $c59361981bac2575$var$RenderTimer(delay, ()=>resolve(), onRender, timerId);
            timer.persistenceLevel = this.persistenceLevel;
            this.addChild(timer);
        });
    }
    /**
   * Wait until a condition is filled. Probably not great to use, but seems kinda cool too.
   */ waitUntil(predicate, onTick, timerId) {
        return new Promise((resolve)=>{
            const timer = new $c59361981bac2575$var$Timer(Infinity, ()=>resolve(), (dt, t)=>{
                if (onTick) onTick(dt, t);
                if (predicate()) timer.timeRemaining = 0;
            }, timerId);
            timer.persistenceLevel = this.persistenceLevel;
            this.addChild(timer);
        });
    }
    /**
   * Remove all timers from this instance. i.e. cancel all 'waits'.
   */ clearTimers(timerId) {
        if (this.children) {
            const timers = this.children.filter($c59361981bac2575$var$isTimer);
            for (const timer of timers)if (!timerId || timerId === timer.timerId) timer.destroy();
        }
    }
    /**
   * Update the time remaing on a timer (or all timers).
   */ updateTimers(value = 0, timerId) {
        if (this.children) {
            const timers = this.children.filter($c59361981bac2575$var$isTimer);
            for (const timer of timers)if (!timerId || timerId === timer.timerId) timer.timeRemaining = value;
        }
    }
    /** Dispatch an event. */ dispatch(eventName, data, respectPause) {
        this.game?.dispatch(eventName, data, respectPause);
    }
}
class $c59361981bac2575$var$Timer extends $c59361981bac2575$export$2e2bcd8739ae039 {
    constructor(delay, endEffect, duringEffect, timerId){
        super();
        this.delay = delay;
        this.timerId = timerId;
        this.timeRemaining = 0;
        this.timeRemaining = delay;
        this.endEffect = endEffect;
        this.duringEffect = duringEffect;
    }
    onTick(dt) {
        this.timeRemaining -= dt;
        const t = (0, $2172aedd5a25ff17$export$7d15b64cf5a3a4c4)(1.0 - this.timeRemaining / this.delay);
        this.duringEffect?.(dt, t);
        if (this.timeRemaining <= 0) {
            this.endEffect?.();
            this.destroy();
        }
    }
}
class $c59361981bac2575$var$RenderTimer extends $c59361981bac2575$export$2e2bcd8739ae039 {
    constructor(delay, endEffect, duringEffect, timerId){
        super();
        this.delay = delay;
        this.timerId = timerId;
        this.timeRemaining = 0;
        this.timeRemaining = delay;
        this.endEffect = endEffect;
        this.duringEffect = duringEffect;
    }
    onRender(dt) {
        this.timeRemaining -= dt;
        const t = (0, $2172aedd5a25ff17$export$7d15b64cf5a3a4c4)(1.0 - this.timeRemaining / this.delay);
        this.duringEffect?.(dt, t);
        if (this.timeRemaining <= 0) {
            this.endEffect?.();
            this.destroy();
        }
    }
}
function $c59361981bac2575$var$isTimer(e) {
    return e instanceof $c59361981bac2575$var$Timer;
}



class $5fd8a8f6f7c6b09a$export$d10b745905c2533b extends (0, $c59361981bac2575$export$2e2bcd8739ae039) {
    constructor(renderer, position = (0, $6b6a54a072724620$export$e7c866399fa523f5)([
        0,
        0
    ]), z = 25.0, angle = 0){
        super();
        this.tags = [
            "camera"
        ];
        this.persistenceLevel = 100;
        this.paralaxScale = 0.1;
        this.renderer = renderer;
        this.position = position;
        this.z = z;
        this.angle = angle;
        this.velocity = (0, $6b6a54a072724620$export$e7c866399fa523f5)([
            0,
            0
        ]);
    }
    get x() {
        return this.position[0];
    }
    set x(value) {
        this.position[0] = value;
    }
    get y() {
        return this.position[1];
    }
    set y(value) {
        this.position[1] = value;
    }
    get vx() {
        return this.velocity[0];
    }
    set vx(value) {
        this.velocity[0] = value;
    }
    get vy() {
        return this.velocity[1];
    }
    set vy(value) {
        this.velocity[1] = value;
    }
    getPosition() {
        return this.position;
    }
    onTick(dt) {
        this.x += this.vx * dt;
        this.y += this.vy * dt;
    }
    /** Center the camera on a position */ center([x, y]) {
        this.x = x;
        this.y = y;
    }
    /** Move the camera toward being centered on a position, with a target velocity */ smoothCenter([x, y], [vx, vy] = (0, $6b6a54a072724620$export$e7c866399fa523f5)([
        0,
        0
    ]), stiffness = 1.0, damping = 1.0) {
        const dx = x - this.x;
        const dy = y - this.y;
        const dt = this.game.averageDt;
        this.vx += (stiffness * dx - damping * (this.vx - vx)) * dt;
        this.vy += (stiffness * dy - damping * (this.vy - vy)) * dt;
    }
    smoothSetVelocity([vx, vy], stiffness = 0.9) {
        this.vx = (0, $2172aedd5a25ff17$export$e4d952dcf42a5ff5)(this.vx, vx, stiffness, 0.001);
        this.vy = (0, $2172aedd5a25ff17$export$e4d952dcf42a5ff5)(this.vy, vy, stiffness, 0.001);
    }
    /** Move the camera part of the way to the desired zoom. */ smoothZoom(z, smooth = 0.9) {
        this.z = smooth * this.z + (1 - smooth) * z;
    }
    /** Returns [width, height] of the viewport in pixels */ getViewportSize() {
        return (0, $6b6a54a072724620$export$e7c866399fa523f5)(this.renderer.canvas.width / this.renderer.app.renderer.resolution, this.renderer.canvas.height / this.renderer.app.renderer.resolution);
    }
    getWorldViewport() {
        const [top, left] = this.toWorld((0, $6b6a54a072724620$export$e7c866399fa523f5)(0, 0));
        const [bottom, right] = this.toWorld(this.getViewportSize());
        const width = right - left;
        const height = bottom - top;
        return {
            top: top,
            bottom: bottom,
            left: left,
            right: right,
            width: width,
            height: height
        };
    }
    /** Convert screen coordinates to world coordinates */ toWorld([x, y], parallax = (0, $6b6a54a072724620$export$e7c866399fa523f5)(1.0, 1.0)) {
        let p = new (0, $1HooC.Point)(x, y);
        p = this.getMatrix(parallax).applyInverse(p, p);
        return (0, $6b6a54a072724620$export$e7c866399fa523f5)(p.x, p.y);
    }
    /** Convert world coordinates to screen coordinates */ toScreen([x, y], parallax = (0, $6b6a54a072724620$export$e7c866399fa523f5)(1.0, 1.0)) {
        let p = new (0, $1HooC.Point)(x, y);
        p = this.getMatrix(parallax).apply(p, p);
        return (0, $6b6a54a072724620$export$e7c866399fa523f5)(p.x, p.y);
    }
    /** Creates a transformation matrix to go from screen world space to screen space. */ getMatrix([px, py] = [
        1,
        1
    ], [ax, ay] = (0, $6b6a54a072724620$export$e7c866399fa523f5)(0, 0)) {
        const [w, h] = this.getViewportSize();
        const { x: cx, y: cy, z: z, angle: angle } = this;
        return new (0, $eY4rt.Matrix)()// align the anchor with the camera
        .translate(ax * px, ay * py).translate(-cx * px, -cy * py)// do all the scaling and rotating
        .scale(z * px, z * py).rotate(angle)// put it back
        .translate(-ax * z, -ay * z).scale(1 / px, 1 / py)// Put it on the center of the screen
        .translate(w / 2.0, h / 2.0);
    }
    /** Update the properties of a renderer layer to match this camera */ updateLayer(layer) {
        const container = layer.container;
        if (!layer.paralax.equals([
            0,
            0
        ])) {
            const matrix = this.getMatrix(layer.paralax, layer.anchor);
            container.updateTransform({
                x: matrix.tx,
                y: matrix.ty,
                scaleX: matrix.a,
                scaleY: matrix.d,
                skewX: matrix.b,
                skewY: matrix.c
            });
        }
    }
}


class $b63a73ca255be033$export$4474c89b2a999acc {
    /** The number of sprites currently managed by this renderer. Mostly useful for debugging. */ get spriteCount() {
        return this._spriteCount;
    }
    set spriteCount(value) {
        this._spriteCount = value;
    }
    /** TODO: Document renderer.stage */ get stage() {
        return this.app.stage;
    }
    /** TODO: Document renderer.canvas */ get canvas() {
        return this.app.renderer.canvas;
    }
    /** TODO: Document renderer constructor */ constructor(layerInfos, defaultLayerName, onResize){
        this.layerInfos = layerInfos;
        this.defaultLayerName = defaultLayerName;
        this.onResize = onResize;
        this.cursor = "none";
        this._spriteCount = 0;
        this.app = new $2202931bfc9ee5c9$export$16975c34e60e1e61();
        this.showCursor();
        this.camera = new (0, $5fd8a8f6f7c6b09a$export$d10b745905c2533b)(this, (0, $6b6a54a072724620$export$e7c866399fa523f5)(0, 0));
        for (const layerInfo of Object.values((0, $4fdefd1822880974$export$fdca3ba65b5cceec)))this.app.stage.addChild(layerInfo.container);
        window.addEventListener("resize", ()=>this.handleResize());
    }
    async init(pixiOptions = {}) {
        await this.app.init({
            resizeTo: window,
            autoDensity: true,
            antialias: true,
            ...pixiOptions
        }).then(()=>{
            document.body.appendChild(this.canvas);
        });
    }
    /** TODO: Document request fullscreen */ requestFullscreen() {
        const makeFullScreen = ()=>{
            this.canvas.requestFullscreen();
            this.canvas.removeEventListener("click", makeFullScreen);
        };
        this.canvas.addEventListener("click", makeFullScreen);
    }
    getHeight() {
        return this.app.renderer.height / this.app.renderer.resolution;
    }
    getWidth() {
        return this.app.renderer.width / this.app.renderer.resolution;
    }
    getSize() {
        return (0, $6b6a54a072724620$export$e7c866399fa523f5)(this.getWidth(), this.getHeight());
    }
    handleResize() {
        this.app.resizeTo = window;
        this.app.resize();
        this.onResize?.(this.getSize());
    }
    hideCursor() {
        this.cursor = "none";
    }
    showCursor() {
        this.cursor = "auto";
    }
    setCursor(value) {
        this.cursor = value;
    }
    // Render the current frame.
    render() {
        for (const layerInfo of Object.values(this.layerInfos))this.camera.updateLayer(layerInfo);
        this.app.render();
        if (this.app.renderer.view.canvas.style) this.app.renderer.view.canvas.style.cursor = this.cursor;
    }
    addSprite(sprite) {
        const layerName = sprite.layerName ?? this.defaultLayerName;
        this.layerInfos[layerName].container.addChild(sprite);
        this.spriteCount += 1;
        return sprite;
    }
    // Remove a child from a specific layer.
    removeSprite(sprite) {
        const layerName = sprite.layerName ?? this.defaultLayerName;
        this.layerInfos[layerName].container.removeChild(sprite);
        this.spriteCount -= 1;
    }
    addLayerFilter(filter, layerName) {
        const container = this.layerInfos[layerName].container;
        if (!(container.filters instanceof Array)) throw new Error("layer.filters is not an array");
        container.filters;
        container.filters = [
            ...container.filters,
            filter
        ];
    }
    addStageFilter(filter) {
        if (!(this.stage.filters instanceof Array)) throw new Error("stage.filters is not an array");
        this.stage.filters ??= [];
        this.stage.filters.push(filter);
    }
    removeStageFilter(filterToRemove) {
        if (!(this.stage.filters instanceof Array)) throw new Error("stage.filters is not an array");
        this.stage.filters = (this.stage.filters ?? []).filter((filter)=>filter != filterToRemove);
    }
}




var $d52f33955bf62086$export$72d962784102bc5;
(function(ControllerAxis) {
    ControllerAxis[ControllerAxis["LEFT_X"] = 0] = "LEFT_X";
    ControllerAxis[ControllerAxis["LEFT_Y"] = 1] = "LEFT_Y";
    ControllerAxis[ControllerAxis["RIGHT_X"] = 2] = "RIGHT_X";
    ControllerAxis[ControllerAxis["RIGHT_Y"] = 3] = "RIGHT_Y";
})($d52f33955bf62086$export$72d962784102bc5 || ($d52f33955bf62086$export$72d962784102bc5 = {}));
var $d52f33955bf62086$export$a72c135d79aea91b;
(function(ControllerButton) {
    ControllerButton[ControllerButton["A"] = 0] = "A";
    ControllerButton[ControllerButton["B"] = 1] = "B";
    ControllerButton[ControllerButton["X"] = 2] = "X";
    ControllerButton[ControllerButton["Y"] = 3] = "Y";
    ControllerButton[ControllerButton["LB"] = 4] = "LB";
    ControllerButton[ControllerButton["RB"] = 5] = "RB";
    ControllerButton[ControllerButton["LT"] = 6] = "LT";
    ControllerButton[ControllerButton["RT"] = 7] = "RT";
    ControllerButton[ControllerButton["BACK"] = 8] = "BACK";
    ControllerButton[ControllerButton["START"] = 9] = "START";
    ControllerButton[ControllerButton["L3"] = 10] = "L3";
    ControllerButton[ControllerButton["R3"] = 11] = "R3";
    ControllerButton[ControllerButton["D_UP"] = 12] = "D_UP";
    ControllerButton[ControllerButton["D_DOWN"] = 13] = "D_DOWN";
    ControllerButton[ControllerButton["D_LEFT"] = 14] = "D_LEFT";
    ControllerButton[ControllerButton["D_RIGHT"] = 15] = "D_RIGHT";
    ControllerButton[ControllerButton["SPECIAL"] = 16] = "SPECIAL";
})($d52f33955bf62086$export$a72c135d79aea91b || ($d52f33955bf62086$export$a72c135d79aea91b = {}));




class $dc42310c64ff8212$export$2e2bcd8739ae039 {
    add(handler) {
        this.all.add(handler);
        for (const list of Object.values(this.filtered))list.addIfValid(handler);
    }
    remove(handler) {
        this.all.delete(handler);
        for (const list of Object.values(this.filtered))list.remove(handler);
    }
    [Symbol.iterator]() {
        return this.all[Symbol.iterator]();
    }
    constructor(){
        this.all = new Set();
        this.filtered = {
            onButtonDown: new (0, $04179bd0fe63c1d8$export$2e2bcd8739ae039)((0, $82e66643116ed123$export$fcf131c55a590803)),
            onButtonUp: new (0, $04179bd0fe63c1d8$export$2e2bcd8739ae039)((0, $82e66643116ed123$export$bce9925042657969)),
            onClick: new (0, $04179bd0fe63c1d8$export$2e2bcd8739ae039)((0, $82e66643116ed123$export$4fb97c2e96dfe5d1)),
            onKeyDown: new (0, $04179bd0fe63c1d8$export$2e2bcd8739ae039)((0, $82e66643116ed123$export$785264017c24581c)),
            onKeyUp: new (0, $04179bd0fe63c1d8$export$2e2bcd8739ae039)((0, $82e66643116ed123$export$c6c6b94757b7aad3)),
            onMouseDown: new (0, $04179bd0fe63c1d8$export$2e2bcd8739ae039)((0, $82e66643116ed123$export$d2d1ec3ab6955f6c)),
            onMouseUp: new (0, $04179bd0fe63c1d8$export$2e2bcd8739ae039)((0, $82e66643116ed123$export$244e66dc7e436f36)),
            onRightClick: new (0, $04179bd0fe63c1d8$export$2e2bcd8739ae039)((0, $82e66643116ed123$export$baf9aa95599589f7)),
            onRightDown: new (0, $04179bd0fe63c1d8$export$2e2bcd8739ae039)((0, $82e66643116ed123$export$97638384bd009bac)),
            onRightUp: new (0, $04179bd0fe63c1d8$export$2e2bcd8739ae039)((0, $82e66643116ed123$export$7ff9159d045867c3)),
            onInputDeviceChange: new (0, $04179bd0fe63c1d8$export$2e2bcd8739ae039)((0, $82e66643116ed123$export$6e39f70f695cba6b))
        };
    }
}


const $f19c05c4f687fa4a$export$f981f70d61d1405a = 0;
const $f19c05c4f687fa4a$export$aa43465df43b119e = 1;
const $f19c05c4f687fa4a$export$1cac5500365a4eb4 = 2;


const $1150a8e0cd0aefe2$var$GAMEPAD_POLLING_FREQUENCY = 250; // Hz
const $1150a8e0cd0aefe2$var$GAMEPAD_MINIMUM = 0.2;
const $1150a8e0cd0aefe2$var$GAMEPAD_MAXIMUM = 0.95;
class $1150a8e0cd0aefe2$export$ac2778e3d733463d {
    constructor(view){
        this.handlers = new (0, $dc42310c64ff8212$export$2e2bcd8739ae039)();
        this.keys = new Map();
        // buttons pressed last frame. Used for checking differences in state.
        this.lastButtons = [];
        this.mouseButtons = [
            false,
            false,
            false,
            false,
            false,
            false
        ];
        this.mousePosition = (0, $6b6a54a072724620$export$e7c866399fa523f5)(0, 0);
        this.usingGamepad = false // True if the gamepad is the main input device
        ;
        this.view = view;
        this.view.onclick = (e)=>this.onClick(e);
        this.view.onmousedown = (e)=>this.onMouseDown(e);
        this.view.onmouseup = (e)=>this.onMouseUp(e);
        this.view.onmousemove = (e)=>this.onMouseMove(e);
        this.view.oncontextmenu = (e)=>{
            e.preventDefault();
            this.onClick(e);
            return false;
        };
        document.onkeydown = (e)=>{
            this.onKeyDown(e);
        };
        document.onkeyup = (e)=>this.onKeyUp(e);
        document.onvisibilitychange = (event)=>{
            for (const keyCode of this.keys.keys()){
                this.keys.set(keyCode, false);
                for (const handler of this.handlers.filtered.onKeyUp)handler.onKeyUp({
                    key: keyCode
                });
            }
        };
        // Because this is a polling not pushing interface
        window.setInterval(()=>this.handleGamepads(), 1000 / $1150a8e0cd0aefe2$var$GAMEPAD_POLLING_FREQUENCY);
    }
    // True if the left mouse button is down.
    get lmb() {
        return this.mouseButtons[$f19c05c4f687fa4a$export$f981f70d61d1405a];
    }
    // True if the middle mouse button is down.
    get mmb() {
        return this.mouseButtons[$f19c05c4f687fa4a$export$aa43465df43b119e];
    }
    // True if the right mouse button is down.
    get rmb() {
        return this.mouseButtons[$f19c05c4f687fa4a$export$1cac5500365a4eb4];
    }
    // True if the given key is currently pressed down
    isKeyDown(key) {
        return Boolean(this.keys.get(key));
    }
    // Fire events for gamepad button presses.
    handleGamepads() {
        const gamepad = navigator.getGamepads()[0];
        if (gamepad) {
            const buttons = gamepad.buttons.map((button)=>button.pressed);
            for (const [button, isDown] of buttons.entries()){
                if (isDown && !this.lastButtons[button]) {
                    this.setUsingGamepad(true);
                    for (const handler of this.handlers.filtered.onButtonDown)handler.onButtonDown({
                        button: button
                    });
                } else if (!isDown && this.lastButtons[button]) for (const handler of this.handlers.filtered.onButtonUp)handler.onButtonUp({
                    button: button
                });
            }
            this.lastButtons = buttons;
        } else this.lastButtons = [];
    }
    setUsingGamepad(value) {
        if (this.usingGamepad != value) {
            this.usingGamepad = value;
            for (const handler of this.handlers.filtered.onInputDeviceChange)handler.onInputDeviceChange({
                usingGamepad: this.usingGamepad
            });
        }
    }
    addHandler(handler) {
        this.handlers.add(handler);
        if (handler.onInputDeviceChange) handler.onInputDeviceChange({
            usingGamepad: this.usingGamepad
        });
    }
    removeHandler(handler) {
        this.handlers.remove(handler);
    }
    // Update the position of the mouse.
    onMouseMove(event) {
        this.setUsingGamepad(false);
        this.mousePosition = (0, $6b6a54a072724620$export$e7c866399fa523f5)(event.clientX, event.clientY);
    }
    // Fire all click handlers.
    onClick(event) {
        this.setUsingGamepad(false);
        this.mousePosition = (0, $6b6a54a072724620$export$e7c866399fa523f5)(event.clientX, event.clientY);
        switch(event.button){
            case $f19c05c4f687fa4a$export$f981f70d61d1405a:
                for (const handler of this.handlers.filtered.onClick)handler.onClick();
                break;
            case $f19c05c4f687fa4a$export$1cac5500365a4eb4:
                for (const handler of this.handlers.filtered.onRightClick)handler.onRightClick();
                break;
        }
    }
    // Fire all mouse down handlers.
    onMouseDown(event) {
        this.setUsingGamepad(false);
        this.mousePosition = (0, $6b6a54a072724620$export$e7c866399fa523f5)(event.clientX, event.clientY);
        this.mouseButtons[event.button] = true;
        switch(event.button){
            case $f19c05c4f687fa4a$export$f981f70d61d1405a:
                for (const handler of this.handlers.filtered.onMouseDown)handler.onMouseDown();
                break;
            case $f19c05c4f687fa4a$export$1cac5500365a4eb4:
                for (const handler of this.handlers.filtered.onRightDown)handler.onRightDown();
                break;
        }
    }
    // Fire all mouse up handlers
    onMouseUp(event) {
        this.setUsingGamepad(false);
        this.mousePosition = (0, $6b6a54a072724620$export$e7c866399fa523f5)(event.clientX, event.clientY);
        this.mouseButtons[event.button] = false;
        switch(event.button){
            case $f19c05c4f687fa4a$export$f981f70d61d1405a:
                for (const handler of this.handlers.filtered.onMouseUp)handler.onMouseUp();
                break;
            case $f19c05c4f687fa4a$export$1cac5500365a4eb4:
                for (const handler of this.handlers.filtered.onRightUp)handler.onRightUp();
                break;
        }
    }
    // Determine whether or not to prevent the default action of a key press.
    shouldPreventDefault(event) {
        if (event.key === "Tab") return true;
        if (event.key.toLowerCase() === "s") // s for save
        return true;
        return false;
    }
    // Fire all key down handlers.
    onKeyDown(event) {
        const code = event.code;
        const wasPressed = this.keys.get(code); // for filtering out auto-repeat stuff
        this.keys.set(code, true);
        if (!wasPressed) for (const handler of this.handlers.filtered.onKeyDown)handler.onKeyDown({
            key: code,
            event: event
        });
        if (this.shouldPreventDefault(event)) {
            event.preventDefault();
            return false;
        }
    }
    // Fire all key up handlers.
    onKeyUp(event) {
        const code = event.code;
        this.keys.set(code, false);
        for (const handler of this.handlers.filtered.onKeyUp)handler.onKeyUp({
            key: code,
            event: event
        });
        if (this.shouldPreventDefault(event)) {
            event.preventDefault();
            return false;
        }
    }
    // Return the value of a gamepad axis.
    getAxis(axis) {
        switch(axis){
            case (0, $d52f33955bf62086$export$72d962784102bc5).LEFT_X:
                return this.getStick("left").x;
            case (0, $d52f33955bf62086$export$72d962784102bc5).LEFT_Y:
                return this.getStick("left").y;
            case (0, $d52f33955bf62086$export$72d962784102bc5).RIGHT_X:
                return this.getStick("right").x;
            case (0, $d52f33955bf62086$export$72d962784102bc5).RIGHT_Y:
                return this.getStick("right").y;
            default:
                throw new Error("unknown axis");
        }
    }
    getStick(stick) {
        const axes = (0, $6b6a54a072724620$export$e7c866399fa523f5)(0, 0);
        const gamepad = navigator.getGamepads()[0];
        if (gamepad) {
            if (stick === "left") {
                axes.x = gamepad.axes[(0, $d52f33955bf62086$export$72d962784102bc5).LEFT_X];
                axes.y = gamepad.axes[(0, $d52f33955bf62086$export$72d962784102bc5).LEFT_Y];
            } else {
                axes.x = gamepad.axes[(0, $d52f33955bf62086$export$72d962784102bc5).RIGHT_X];
                axes.y = gamepad.axes[(0, $d52f33955bf62086$export$72d962784102bc5).RIGHT_Y];
            }
            const gamepadRange = $1150a8e0cd0aefe2$var$GAMEPAD_MAXIMUM - $1150a8e0cd0aefe2$var$GAMEPAD_MINIMUM;
            axes.magnitude = (0, $2172aedd5a25ff17$export$f982906e4d317fcc)((axes.magnitude - $1150a8e0cd0aefe2$var$GAMEPAD_MINIMUM) / gamepadRange);
            axes.x = (0, $2172aedd5a25ff17$export$7d15b64cf5a3a4c4)(axes.x, -1, 1);
            axes.y = (0, $2172aedd5a25ff17$export$7d15b64cf5a3a4c4)(axes.y, -1, 1);
        }
        return axes;
    }
    //  Return the value of a button.
    getButton(button) {
        const gamepad = navigator.getGamepads()[0];
        return gamepad?.buttons[button]?.value ?? 0;
    }
    // Really standard based on WASD, arrow keys, or gamepad
    getMovementVector() {
        const result = (0, $6b6a54a072724620$export$e7c866399fa523f5)(0, 0);
        if (this.usingGamepad) result.iadd(this.getStick("left"));
        if (this.isKeyDown("KeyW") || this.isKeyDown("ArrowUp")) result[1] -= 1;
        if (this.isKeyDown("KeyD") || this.isKeyDown("ArrowRight")) result[0] += 1;
        if (this.isKeyDown("KeyS") || this.isKeyDown("ArrowDown")) result[1] += 1;
        if (this.isKeyDown("KeyA") || this.isKeyDown("ArrowLeft")) result[0] -= 1;
        result[0] = (0, $2172aedd5a25ff17$export$7d15b64cf5a3a4c4)(result[0], -1, 1);
        result[1] = (0, $2172aedd5a25ff17$export$7d15b64cf5a3a4c4)(result[1], -1, 1);
        return result;
    }
}





const $1dc14462fca3f439$var$CUSTOM_BROADPHASE_TYPE = 3;
const $1dc14462fca3f439$var$HUGE_LIMIT = 200;
const $1dc14462fca3f439$var$DEFAULT_CELL_SIZE = 6;
const $1dc14462fca3f439$var$HUGE = [];
class $1dc14462fca3f439$export$2e2bcd8739ae039 extends (0, $83a57dc453139d82$exports.SAPBroadphase) {
    constructor(// width/height of cell in meters
    cellSize = $1dc14462fca3f439$var$DEFAULT_CELL_SIZE, // number of cells wide
    width = 24, // number of cells tall
    height = 24){
        super($1dc14462fca3f439$var$CUSTOM_BROADPHASE_TYPE);
        this.cellSize = cellSize;
        this.width = width;
        this.height = height;
        this.particleBodies = new Set();
        this.dynamicBodies = new Set();
        this.kinematicBodies = new Set();
        this.hugeBodies = new Set();
        this.partitions = [];
        this.bodiesAdded = false;
        this.debugData = {
            numCollisions: 0
        };
        for(let i = 0; i < width * height; i++)this.partitions.push(new Set());
    }
    setWorld(world) {
        super.setWorld.call(this, world);
        world.on("addBody", ({ body: body })=>this.onAddBody(body));
        world.on("removeBody", ({ body: body })=>this.onRemoveBody(body));
    }
    resize(cellSize, width, height) {
        this.cellSize = cellSize;
        const oldBodies = new Set();
        for (const partition of this.partitions)for (const body of partition)oldBodies.add(body);
        this.partitions = [];
        for(let i = 0; i < width * height; i++)this.partitions.push(new Set());
        for (const body of oldBodies)this.addBodyToHash(body);
    }
    onAddBody(body) {
        if (body.type === (0, $83a57dc453139d82$exports.Body).DYNAMIC) {
            if ($1dc14462fca3f439$var$isParticleBody(body)) this.particleBodies.add(body);
            else this.dynamicBodies.add(body);
        } else if (body.type === (0, $83a57dc453139d82$exports.Body).KINEMATIC) this.kinematicBodies.add(body);
        else this.addBodyToHash(body);
    }
    onRemoveBody(body) {
        if (body.type === (0, $83a57dc453139d82$exports.Body).DYNAMIC) {
            this.dynamicBodies.delete(body);
            this.particleBodies.delete(body);
        } else if (body.type === (0, $83a57dc453139d82$exports.Body).KINEMATIC) this.kinematicBodies.delete(body);
        else this.removeBodyFromHash(body);
    }
    addBodyToHash(body) {
        const cells = this.aabbToCells(body.getAABB());
        if (cells === $1dc14462fca3f439$var$HUGE) this.hugeBodies.add(body);
        else for (const cell of cells)this.partitions[cell].add(body);
    }
    removeBodyFromHash(body) {
        const cells = this.aabbToCells(body.getAABB());
        if (cells === $1dc14462fca3f439$var$HUGE) this.hugeBodies.delete(body);
        else for (const cell of cells)this.partitions[cell].delete(body);
    }
    addExtraBodies() {
        for (const kBody of this.kinematicBodies)this.addBodyToHash(kBody);
        for (const dBody of this.dynamicBodies)this.addBodyToHash(dBody);
        for (const pBody of this.particleBodies)this.addBodyToHash(pBody);
    }
    removeExtraBodies() {
        for (const kBody of this.kinematicBodies)this.removeBodyFromHash(kBody);
        for (const dBody of this.dynamicBodies)this.removeBodyFromHash(dBody);
        for (const pBody of this.particleBodies)this.removeBodyFromHash(pBody);
    }
    /** Returns an array where every 2 entries represents a collision pair */ getCollisionPairs(world) {
        const result = [];
        for (const kBody of this.kinematicBodies)this.addBodyToHash(kBody);
        for (const dBody of this.dynamicBodies)this.addBodyToHash(dBody);
        //
        for (const pBody of this.particleBodies){
            for (const other of this.aabbQuery(world, pBody.getAABB(), undefined, false))if ((0, $83a57dc453139d82$exports.Broadphase).canCollide(pBody, other)) result.push(pBody, other);
        }
        for (const dBody of this.dynamicBodies){
            this.removeBodyFromHash(dBody); // This will make sure we don't overlap ourselves, and that we don't double count anything
            for (const other of this.aabbQuery(world, dBody.getAABB(), undefined, false))if ((0, $83a57dc453139d82$exports.Broadphase).canCollide(dBody, other)) result.push(dBody, other);
        }
        for (const kBody of this.kinematicBodies)this.removeBodyFromHash(kBody);
        this.debugData.numCollisions = result.length;
        return result;
    }
    xyToCell(x, y) {
        return (0, $2172aedd5a25ff17$export$842a2cf37af977e1)(x, this.width) + (0, $2172aedd5a25ff17$export$842a2cf37af977e1)(y, this.height) * this.width;
    }
    /** Returns the cells that overlap the aabb. Returns HUGE if the aabb is "huge". */ aabbToCells(aabb, checkHuge = true) {
        const result = [];
        const lowX = Math.floor(aabb.lowerBound[0] / this.cellSize);
        const lowY = Math.floor(aabb.lowerBound[1] / this.cellSize);
        const highX = Math.floor(aabb.upperBound[0] / this.cellSize);
        const highY = Math.floor(aabb.upperBound[1] / this.cellSize);
        // Check for huge
        if (checkHuge && (!isFinite(lowX) || !isFinite(lowY) || !isFinite(highX) || !isFinite(highY) || Math.abs(highX - lowX) * Math.abs(highY - lowY) > $1dc14462fca3f439$var$HUGE_LIMIT)) return $1dc14462fca3f439$var$HUGE;
        for(let x = lowX; x <= highX; x++)for(let y = lowY; y <= highY; y++)result.push(this.xyToCell(x, y));
        return result;
    }
    aabbQuery(_, aabb, result, shouldAddBodies = true) {
        result = result ?? [];
        if (shouldAddBodies) this.addExtraBodies();
        for (const cell of this.aabbToCells(aabb, false)){
            for (const body of this.partitions[cell])if (body.getAABB().overlaps(aabb) && result.indexOf(body) < 0) result.push(body);
        }
        for (const hugeBody of this.hugeBodies)if (aabb.overlaps(hugeBody.getAABB())) result.push(hugeBody);
        if (shouldAddBodies) this.removeExtraBodies();
        return result;
    }
    // TODO: This is broken for some reason
    rayQuery(ray, shouldAddBodies = true) {
        if (shouldAddBodies) this.addExtraBodies();
        const result = [];
        // See https://www.redblobgames.com/grids/line-drawing.html
        const x1 = ray.from[0] / this.cellSize;
        const y1 = ray.from[1] / this.cellSize;
        const x2 = ray.to[0] / this.cellSize;
        const y2 = ray.to[1] / this.cellSize;
        const dx = x2 - x1;
        const dy = y2 - y1;
        const xSteps = Math.ceil(Math.abs(dx));
        const ySteps = Math.ceil(Math.abs(dy));
        const signX = dx > 0 ? 1 : -1;
        const signY = dy > 0 ? 1 : -1;
        let cellX = Math.floor(x1);
        let cellY = Math.floor(y1);
        for(let ix = 0, iy = 0; ix < xSteps || iy < ySteps;){
            if ((0.5 + ix) / xSteps < (0.5 + iy) / ySteps) {
                // next step is horizontal
                cellX += signX;
                ix++;
            } else {
                // next step is vertical
                cellY += signY;
                iy++;
            }
            const cell = this.xyToCell(cellX, cellY);
            for (const body of this.partitions[cell])if (result.indexOf(body) < 0) result.push(body);
        }
        if (shouldAddBodies) this.removeExtraBodies();
        return result;
    }
}
// Returns true if this is a dynamic body with no non-particle shapes
function $1dc14462fca3f439$var$isParticleBody(body) {
    if (body.type !== (0, $83a57dc453139d82$exports.Body).DYNAMIC) return false;
    for (const shape of body.shapes){
        if (shape.type !== (0, $83a57dc453139d82$exports.Shape).PARTICLE) return false;
    }
    return true;
}



class $9719b6279ccaa645$export$2e2bcd8739ae039 extends (0, $83a57dc453139d82$exports.Narrowphase) {
}



class $2ecbc16ec51b8e17$export$2e2bcd8739ae039 extends (0, $83a57dc453139d82$exports.GSSolver) {
    constructor(){
        super({
            iterations: 1,
            tolerance: 0
        });
    }
    setWorld(world) {
        this.world = world;
    }
    prepareBodies() {
        for (const body of this.world.dynamicBodies)body.updateSolveMassProperties();
    }
    computeEquations(dt) {
        for (const eq of this.equations){
            eq.lambda = 0;
            if (eq.timeStep !== dt || eq.needsUpdate) {
                eq.timeStep = dt;
                eq.update();
            }
            eq.B = eq.computeB(eq.a, eq.b, dt);
            eq.invC = eq.computeInvC(eq.epsilon);
            eq.maxForceDt = eq.maxForce * dt;
            eq.minForceDt = eq.minForce * dt;
        }
    }
    prepareBodies2() {
        for (const body of this.world.dynamicBodies)body.resetConstraintVelocity();
    }
    // Add result to velocity
    postBodies() {
        for (const body of this.world.dynamicBodies)body.addConstraintVelocity();
    }
    doFriction(dt) {
        const maxFrictionIter = this.frictionIterations;
        const equations = this.equations;
        const tolSquared = Math.pow(this.tolerance * this.equations.length, 2);
        if (maxFrictionIter) {
            // Iterate over contact equations to get normal forces
            for(let iter = 0; iter !== maxFrictionIter; iter++){
                // Accumulate the total error for each iteration.
                let deltalambdaTot = 0.0;
                for (const c of equations){
                    var deltalambda = $2ecbc16ec51b8e17$var$iterateEquation(c);
                    deltalambdaTot += Math.abs(deltalambda);
                }
                this.usedIterations++;
                // If the total error is small enough - stop iterate
                if (deltalambdaTot * deltalambdaTot <= tolSquared) break;
            }
            this.postBodies();
            $2ecbc16ec51b8e17$var$updateMultipliers(equations, 1 / dt);
            // Set computed friction force
            for (const eq of equations)if (eq instanceof (0, $83a57dc453139d82$exports.FrictionEquation)) {
                var f = 0.0;
                for(var k = 0; k !== eq.contactEquations.length; k++)f += eq.contactEquations[k].multiplier;
                f *= eq.frictionCoefficient / eq.contactEquations.length;
                eq.maxForce = f;
                eq.minForce = -f;
                eq.maxForceDt = f * dt;
                eq.minForceDt = -f * dt;
            }
        }
    }
    doIterations(dt) {
        const maxIter = this.iterations;
        const tolSquared = Math.pow(this.tolerance * this.equations.length, 2);
        for(let iter = 0; iter !== maxIter; iter++){
            // Accumulate the total error for each iteration.
            let deltalambdaTot = 0.0;
            for (const c of this.equations){
                var deltalambda = $2ecbc16ec51b8e17$var$iterateEquation(c);
                deltalambdaTot += Math.abs(deltalambda);
            }
            this.usedIterations++;
            // If the total error is small enough - stop iterate
            if (deltalambdaTot * deltalambdaTot < tolSquared) break;
        }
    }
    solve(dt, world) {
        this.sortEquations();
        const equations = this.equations;
        const Neq = equations.length;
        this.usedIterations = 0;
        if (Neq !== 0) {
            this.prepareBodies();
            this.computeEquations(dt);
            this.prepareBodies2();
            this.doFriction(dt);
            this.doIterations(dt);
            this.postBodies();
            $2ecbc16ec51b8e17$var$updateMultipliers(equations, 1 / dt);
        }
    }
}
// Sets the .multiplier property of each equation
function $2ecbc16ec51b8e17$var$updateMultipliers(equations, invDt) {
    var l = equations.length;
    while(l--){
        var eq = equations[l];
        eq.multiplier = eq.lambda * invDt;
    }
}
function $2ecbc16ec51b8e17$var$iterateEquation(eq) {
    // Compute iteration
    var B = eq.B, eps = eq.epsilon, invC = eq.invC, lambdaj = eq.lambda, GWlambda = eq.computeGWlambda(), maxForce_dt = eq.maxForceDt, minForce_dt = eq.minForceDt;
    var deltalambda = invC * (B - GWlambda - eps * lambdaj);
    // Clamp if we are not within the min/max interval
    var lambdaj_plus_deltalambda = lambdaj + deltalambda;
    if (lambdaj_plus_deltalambda < minForce_dt) deltalambda = minForce_dt - lambdaj;
    else if (lambdaj_plus_deltalambda > maxForce_dt) deltalambda = maxForce_dt - lambdaj;
    eq.lambda += deltalambda;
    eq.addToWlambda(deltalambda);
    return deltalambda;
}


// Reduce allocations
const $4e6dcfd78737b253$var$step_mg = (0, $83a57dc453139d82$exports.vec2).create();
const $4e6dcfd78737b253$var$endOverlaps = [];
class $4e6dcfd78737b253$export$2e2bcd8739ae039 extends (0, $83a57dc453139d82$exports.World) {
    constructor(options = {}){
        super({
            broadphase: new (0, $1dc14462fca3f439$export$2e2bcd8739ae039)(),
            islandSplit: false,
            solver: new (0, $2ecbc16ec51b8e17$export$2e2bcd8739ae039)(),
            ...options
        });
        // Actual stuff that we're keeping track of now
        this.dynamicBodies = new Set();
        this.kinematicBodies = new Set();
        this.solver.setWorld(this);
        this.applyGravity = false;
        this.applyDamping = false;
        this.narrowphase = new (0, $9719b6279ccaa645$export$2e2bcd8739ae039)();
    }
    addBody(body) {
        super.addBody.call(this, body);
        if (body.type === (0, $83a57dc453139d82$exports.Body).DYNAMIC) this.dynamicBodies.add(body);
        else if (body.type === (0, $83a57dc453139d82$exports.Body).KINEMATIC) this.kinematicBodies.add(body);
    }
    removeBody(body) {
        super.removeBody.call(this, body);
        this.dynamicBodies.delete(body);
        this.kinematicBodies.delete(body);
    }
    raycast(result, ray, shouldAddBodies = true) {
        // Get all bodies within the ray AABB
        // const bodies = this.broadphase.rayQuery(ray, shouldAddBodies);
        // ray.intersectBodies(result, bodies);
        // return result.hasHit();
        const aabb = new (0, $83a57dc453139d82$exports.AABB)();
        // @ts-ignore
        const bodies = [];
        // @ts-ignore
        ray.getAABB(aabb);
        // @ts-ignore
        this.broadphase.aabbQuery(this, aabb, bodies, shouldAddBodies);
        // @ts-ignore
        ray.intersectBodies(result, bodies);
        return result.hasHit();
    }
    internalStep(dt) {
        this.stepping = true;
        this.overlapKeeper.tick();
        this.lastTimeStep = dt;
        this.stepPreCollision(dt);
        const broadphaseResult = this.stepBroadphase();
        this.stepNarrowphase(broadphaseResult);
        this.stepWakeup();
        this.stepContactEvents();
        this.stepConstraints(dt);
        this.stepIntegrate(dt);
        this.stepImpactEvents();
        this.stepSleep(dt);
        this.stepping = false;
        this.stepCleanup();
        this.emit(this.postStepEvent);
    }
    //#region internalStep
    stepPreCollision(dt) {
        const g = this.gravity;
        const mg = $4e6dcfd78737b253$var$step_mg;
        // Update approximate friction gravity.
        if (this.useWorldGravityAsFrictionGravity) {
            const gravityLen = (0, $83a57dc453139d82$exports.vec2).length(this.gravity);
            if (!(gravityLen === 0 && this.useFrictionGravityOnZeroGravity)) // Nonzero gravity. Use it.
            this.frictionGravity = gravityLen;
        }
        // Add gravity to bodies
        if (this.applyGravity) {
            for (const body of this.dynamicBodies)if (body.sleepState !== (0, $83a57dc453139d82$exports.Body).SLEEPING) {
                (0, $83a57dc453139d82$exports.vec2).scale(mg, g, body.mass * body.gravityScale);
                (0, $83a57dc453139d82$exports.vec2).add(body.force, body.force, mg);
            }
        }
        // Add spring forces
        if (this.applySpringForces) for (const s of this.springs)s.applyForce();
        // Add damping
        if (this.applyDamping) for (const body of this.dynamicBodies)body.applyDamping(dt);
    }
    stepBroadphase() {
        // Broadphase
        var result = this.broadphase.getCollisionPairs(this);
        // Remove ignored collision pairs
        var ignoredPairs = this.disabledBodyCollisionPairs;
        for(var i = ignoredPairs.length - 2; i >= 0; i -= 2){
            for(var j = result.length - 2; j >= 0; j -= 2)if (ignoredPairs[i] === result[j] && ignoredPairs[i + 1] === result[j + 1] || ignoredPairs[i + 1] === result[j] && ignoredPairs[i] === result[j + 1]) result.splice(j, 2);
        }
        // Remove constrained pairs with collideConnected == false
        var Nconstraints = this.constraints.length;
        for(i = 0; i !== Nconstraints; i++){
            var c = this.constraints[i];
            if (!c.collideConnected) {
                for(var j = result.length - 2; j >= 0; j -= 2)if (c.bodyA === result[j] && c.bodyB === result[j + 1] || c.bodyB === result[j] && c.bodyA === result[j + 1]) result.splice(j, 2);
            }
        }
        // postBroadphase event
        this.postBroadphaseEvent.pairs = result;
        this.emit(this.postBroadphaseEvent);
        this.postBroadphaseEvent.pairs = [];
        return result;
    }
    stepNarrowphase(broadphaseResult) {
        const np = this.narrowphase;
        // Narrowphase
        np.reset();
        for(var i = 0, Nresults = broadphaseResult.length; i !== Nresults; i += 2){
            var bi = broadphaseResult[i], bj = broadphaseResult[i + 1];
            // Loop over all shapes of body i
            for(var k = 0, Nshapesi = bi.shapes.length; k !== Nshapesi; k++){
                var si = bi.shapes[k], xi = si.position, ai = si.angle;
                // All shapes of body j
                for(var l = 0, Nshapesj = bj.shapes.length; l !== Nshapesj; l++){
                    var sj = bj.shapes[l], xj = sj.position, aj = sj.angle;
                    var cm = this.defaultContactMaterial;
                    if (si.material && sj.material) {
                        var tmp = this.getContactMaterial(si.material, sj.material);
                        if (tmp) cm = tmp;
                    }
                    this.runNarrowphase(np, bi, si, xi, ai, bj, sj, xj, aj, cm, this.frictionGravity);
                }
            }
        }
    }
    stepWakeup() {
        // Wake up bodies
        for (const body of this.dynamicBodies)if (body._wakeUpAfterNarrowphase) {
            body.wakeUp();
            body._wakeUpAfterNarrowphase = false;
        }
    }
    stepContactEvents() {
        const np = this.narrowphase;
        // Emit end overlap events
        if (this.has("endContact", undefined)) {
            this.overlapKeeper.getEndOverlaps($4e6dcfd78737b253$var$endOverlaps);
            const e = this.endContactEvent;
            let i = $4e6dcfd78737b253$var$endOverlaps.length;
            while(i--){
                var data = $4e6dcfd78737b253$var$endOverlaps[i];
                e.shapeA = data.shapeA;
                e.shapeB = data.shapeB;
                e.bodyA = data.bodyA;
                e.bodyB = data.bodyB;
                this.emit(e);
            }
            $4e6dcfd78737b253$var$endOverlaps.length = 0;
        }
        var preSolveEvent = this.preSolveEvent;
        preSolveEvent.contactEquations = np.contactEquations;
        preSolveEvent.frictionEquations = np.frictionEquations;
        this.emit(preSolveEvent);
        preSolveEvent.contactEquations = preSolveEvent.frictionEquations = [];
    }
    stepConstraints(dt) {
        const solver = this.solver;
        const np = this.narrowphase;
        const islandManager = this.islandManager;
        // update constraint equations
        for (const constraint of this.constraints)constraint.update();
        if (np.contactEquations.length || np.frictionEquations.length || this.constraints.length) {
            if (this.islandSplit) {
                // Split into islands
                islandManager.equations.length = 0;
                (0, $83a57dc453139d82$exports.Utils).appendArray(islandManager.equations, np.contactEquations);
                (0, $83a57dc453139d82$exports.Utils).appendArray(islandManager.equations, np.frictionEquations);
                for (const constraint of this.constraints)(0, $83a57dc453139d82$exports.Utils).appendArray(islandManager.equations, constraint.equations);
                for(let i = 0; i < this.constraints.length; i++);
                islandManager.split(this);
                for (const island of islandManager.islands)if (island.equations.length) solver.solveIsland(dt, island);
            } else {
                // Add contact equations to solver
                solver.addEquations(np.contactEquations);
                solver.addEquations(np.frictionEquations);
                // Add user-defined constraint equations
                for (const constraint of this.constraints)solver.addEquations(constraint.equations);
                if (this.solveConstraints) solver.solve(dt, this);
                solver.removeAllEquations();
            }
        }
    }
    stepIntegrate(dt) {
        // Step forward
        for (const body of this.kinematicBodies){
            body.integrate(dt);
            body.setZeroForce();
        }
        for (const body of this.dynamicBodies){
            body.integrate(dt);
            body.setZeroForce();
        }
    }
    stepImpactEvents() {
        const np = this.narrowphase;
        // Emit impact event
        if (this.emitImpactEvent && this.has("impact")) {
            var ev = this.impactEvent;
            for(var i = 0; i !== np.contactEquations.length; i++){
                var eq = np.contactEquations[i];
                if (eq.firstImpact) {
                    ev.bodyA = eq.bodyA;
                    ev.bodyB = eq.bodyB;
                    ev.shapeA = eq.shapeA;
                    ev.shapeB = eq.shapeB;
                    ev.contactEquation = eq;
                    this.emit(ev);
                }
            }
        }
    }
    stepSleep(dt) {
        const bodies = this.bodies;
        const Nbodies = bodies.length;
        // Sleeping update
        if (this.sleepMode === (0, $83a57dc453139d82$exports.World).BODY_SLEEPING) for(i = 0; i !== Nbodies; i++)bodies[i].sleepTick(this.time, false, dt);
        else if (this.sleepMode === (0, $83a57dc453139d82$exports.World).ISLAND_SLEEPING && this.islandSplit) {
            // Tell all bodies to sleep tick but dont sleep yet
            for(i = 0; i !== Nbodies; i++)bodies[i].sleepTick(this.time, true, dt);
            // Sleep islands
            for(var i = 0; i < this.islandManager.islands.length; i++){
                var island = this.islandManager.islands[i];
                if (island.wantsToSleep()) island.sleep();
            }
        }
    }
    stepCleanup() {
        // Remove bodies that are scheduled for removal
        var bodiesToBeRemoved = this.bodiesToBeRemoved;
        for(var i = 0; i !== bodiesToBeRemoved.length; i++)this.removeBody(bodiesToBeRemoved[i]);
        bodiesToBeRemoved.length = 0;
    }
}



class $e4c72b6b95368f7f$export$2e2bcd8739ae039 {
    get io() {
        return this._io;
    }
    set io(value) {
        this._io = value;
    }
    /** TODO: Document game.camera */ get camera() {
        return this.renderer.camera;
    }
    get averageDt() {
        return this.slowMo / (this.averageFrameDuration * this.ticksPerSecond);
    }
    /** Multiplier of time that passes during tick */ get slowMo() {
        return this._slowMo;
    }
    set slowMo(value) {
        if (value != this._slowMo) {
            this._slowMo = value;
            this.dispatch("slowMoChanged", {
                slowMo: this._slowMo
            });
        }
    }
    /**
   * Create a new Game.
   * NOTE: You must call .init() before actually using the game.
   */ constructor({ audio: audio, ticksPerSecond: ticksPerSecond = 120, world: world } = {}){
        /** Readonly. Whether or not the game is paused */ this.paused = false;
        /** Readonly. Number of frames that have gone by */ this.framenumber = 0;
        /** Readonly. Number of ticks that have gone by */ this.ticknumber = 0;
        /** The timestamp when the last frame started */ this.lastFrameTime = window.performance.now();
        /** Total amount of game time that has elapsed */ this.elapsedTime = 0;
        /** Total amount of game time that has elapsed while not paused */ this.elapsedUnpausedTime = 0;
        /** Keep track of how long each frame is taking on average */ this.averageFrameDuration = 1 / 60;
        this._slowMo = 1.0;
        /** Add an entity to the game. */ this.addEntity = (entity)=>{
            entity.game = this;
            if (entity.onAdd) entity.onAdd({
                game: this
            });
            // If the entity was destroyed during it's onAdd, we shouldn't add it
            if (!entity.game) return entity;
            this.entities.add(entity);
            this.io.addHandler(entity);
            if (entity.body) {
                entity.body.owner = entity;
                this.world.addBody(entity.body);
            }
            if (entity.bodies) for (const body of entity.bodies){
                body.owner = entity;
                this.world.addBody(body);
            }
            if (entity.springs) for (const spring of entity.springs)this.world.addSpring(spring);
            if (entity.constraints) for (const constraint of entity.constraints)this.world.addConstraint(constraint);
            if (entity.sprite) {
                this.renderer.addSprite(entity.sprite);
                entity.sprite.owner = entity;
            }
            if (entity.sprites) for (const sprite of entity.sprites){
                this.renderer.addSprite(sprite);
                sprite.owner = entity;
            }
            if (entity.onResize) entity.onResize({
                size: this.renderer.getSize()
            });
            if (entity.children) {
                for (const child of entity.children)if (!child.game) this.addEntity(child);
            }
            if (entity.onAfterAdded) entity.onAfterAdded({
                game: this
            });
            return entity;
        };
        this.timeToSimulate = 0.0;
        this.iterationsRemaining = 0.0;
        // Handle beginning of collision between things.
        // Fired during narrowphase.
        this.beginContact = (contactInfo)=>{
            this.contactList.beginContact(contactInfo);
            const { shapeA: shapeA, shapeB: shapeB, bodyA: bodyA, bodyB: bodyB, contactEquations: contactEquations } = contactInfo;
            const ownerA = shapeA.owner || bodyA.owner;
            const ownerB = shapeB.owner || bodyB.owner;
            // If either owner has been removed from the game, we shouldn't do the contact
            if (!(ownerA && !ownerA.game) || ownerB && !ownerB.game) {
                if (ownerA?.onBeginContact) ownerA.onBeginContact({
                    other: ownerB,
                    thisShape: shapeA,
                    otherShape: shapeB,
                    contactEquations: contactEquations
                });
                if (ownerB?.onBeginContact) ownerB.onBeginContact({
                    other: ownerA,
                    thisShape: shapeB,
                    otherShape: shapeA,
                    contactEquations: contactEquations
                });
            }
        };
        // Handle end of collision between things.
        // Fired during narrowphase.
        this.endContact = (contactInfo)=>{
            this.contactList.endContact(contactInfo);
            const { shapeA: shapeA, shapeB: shapeB, bodyA: bodyA, bodyB: bodyB } = contactInfo;
            const ownerA = shapeA.owner || bodyA.owner;
            const ownerB = shapeB.owner || bodyB.owner;
            // If either owner has been removed from the game, we shouldn't do the contact
            if (!(ownerA && !ownerA.game) || ownerB && !ownerB.game) {
                if (ownerA?.onEndContact) ownerA.onEndContact({
                    other: ownerB,
                    thisShape: shapeA,
                    otherShape: shapeB
                });
                if (ownerB?.onEndContact) ownerB.onEndContact({
                    other: ownerA,
                    thisShape: shapeB,
                    otherShape: shapeA
                });
            }
        };
        // Handle collision between things.
        // Fired after physics step.
        this.impact = (e)=>{
            const ownerA = e.bodyA.owner;
            const ownerB = e.bodyB.owner;
            // If either owner has been removed from the game, we shouldn't do the contact
            if (!(ownerA && !ownerA.game) || ownerB && !ownerB.game) {
                if (ownerA?.onImpact) ownerA.onImpact({
                    other: ownerB
                });
                if (ownerB?.onImpact) ownerB.onImpact({
                    other: ownerA
                });
            }
        };
        this.entities = new (0, $913c3d10ae4e12ec$export$2e2bcd8739ae039)();
        this.entitiesToRemove = new Set();
        this.renderer = new (0, $b63a73ca255be033$export$4474c89b2a999acc)((0, $4fdefd1822880974$export$fdca3ba65b5cceec), (0, $4fdefd1822880974$export$3d0b505b9576cf7e), this.onResize.bind(this));
        this.ticksPerSecond = ticksPerSecond;
        this.tickDuration = 1.0 / this.ticksPerSecond;
        // this.world = new World({ gravity: [0, 0] });
        this.world = world ?? new (0, $4e6dcfd78737b253$export$2e2bcd8739ae039)({
            gravity: [
                0,
                0
            ]
        });
        this.world.on("beginContact", this.beginContact, null);
        this.world.on("endContact", this.endContact, null);
        this.world.on("impact", this.impact, null);
        this.ground = new (0, (/*@__PURE__*/$parcel$interopDefault($83a57dc453139d82$exports))).Body({
            mass: 0
        });
        this.world.addBody(this.ground);
        this.contactList = new (0, $1d29da6ad0b954b4$export$2e2bcd8739ae039)();
        this.audio = audio ?? new AudioContext();
        this.masterGain = this.audio.createGain();
        this.masterGain.connect(this.audio.destination);
    }
    /** Start the event loop for the game. */ async init({ rendererOptions: rendererOptions = {} } = {}) {
        await this.renderer.init(rendererOptions);
        this.io = new (0, $1150a8e0cd0aefe2$export$ac2778e3d733463d)(this.renderer.canvas);
        this.addEntity(this.renderer.camera);
        window.requestAnimationFrame(()=>this.loop(this.lastFrameTime));
    }
    /** See pause() and unpause(). */ togglePause() {
        if (this.paused) this.unpause();
        else this.pause();
    }
    /** TODO: Document onResize */ onResize(size) {
        this.dispatch("resize", {
            size: (0, $6b6a54a072724620$export$e7c866399fa523f5)(size)
        });
    }
    /**
   * Pauses the game. This stops physics from running, calls onPause()
   * handlers, and stops updating `pausable` entities.
   */ pause() {
        if (!this.paused) {
            this.paused = true;
            this.dispatch("pause", undefined);
        }
    }
    /** Resumes the game and calls onUnpause() handlers. */ unpause() {
        this.paused = false;
        this.dispatch("unpause", undefined);
    }
    /** Dispatch an event. */ dispatch(eventName, data, respectPause = true) {
        const effectivelyPaused = respectPause && this.paused;
        for (const entity of this.entities.getHandlers(eventName))if (entity.game && !(effectivelyPaused && !entity.pausable)) {
            const functionName = (0, $c0f9b00b45d3abcb$export$e4d4fc2de3f8add7)(eventName);
            entity[functionName](data);
        }
    }
    /** Shortcut for adding multiple entities. */ addEntities(...entities) {
        for (const entity of entities)this.addEntity(entity);
        return entities;
    }
    /**
   * Remove an entity from the game.
   * The entity will actually be removed during the next removal pass.
   * This is because there are times when it's not safe to remove an entity, like in the middle of a physics step.
   */ removeEntity(entity) {
        entity.game = undefined;
        if (this.world.stepping) this.entitiesToRemove.add(entity);
        else this.cleanupEntity(entity);
        return entity;
    }
    /** Remove all non-persistent entities. I think this is kinda sketchy. */ clearScene(persistenceThreshold = 0) {
        for (const entity of this.entities)if (entity.game && // Not already destroyed
        !this.entitiesToRemove.has(entity) && // not already about to be destroyed
        entity.persistenceLevel <= persistenceThreshold && !entity.parent // We only wanna deal with top-level things, let parents handle the rest
        ) entity.destroy();
    }
    /** The main event loop. Run one frame of the game.  */ loop(time) {
        window.requestAnimationFrame((t)=>this.loop(t));
        this.framenumber += 1;
        const lastFrameDuration = (time - this.lastFrameTime) / 1000;
        this.lastFrameTime = time;
        // TODO: This honestly doesn't work great
        // Keep a rolling average
        if (0 < lastFrameDuration && lastFrameDuration < 0.3) // Ignore weird durations because they're probably flukes from the user
        // changing to a different tab/window or loading a new level or something
        this.averageFrameDuration = (0, $2172aedd5a25ff17$export$3a89f8d6f6bf6c9f)(this.averageFrameDuration, lastFrameDuration, 0.05);
        const renderDt = 1.0 / this.getScreenFps();
        this.elapsedTime += renderDt;
        if (!this.paused) this.elapsedUnpausedTime += renderDt;
        this.slowTick(renderDt * this.slowMo);
        this.timeToSimulate += renderDt * this.slowMo;
        while(this.timeToSimulate >= this.tickDuration){
            this.timeToSimulate -= this.tickDuration;
            this.tick(this.tickDuration);
            if (!this.paused) {
                const stepDt = this.tickDuration;
                this.world.step(stepDt);
                this.cleanupEntities();
                this.contacts();
            }
        }
        this.afterPhysics();
        this.render(renderDt);
    }
    getScreenFps() {
        const duration = this.averageFrameDuration;
        return Math.round(1.0 / duration);
    }
    /** Actually remove all the entities slated for removal from the game. */ cleanupEntities() {
        for (const entity of this.entitiesToRemove)this.cleanupEntity(entity);
        this.entitiesToRemove.clear();
    }
    cleanupEntity(entity) {
        entity.game = undefined; // This should be done by `removeEntity`, but better safe than sorry
        this.entities.remove(entity);
        this.io.removeHandler(entity);
        if (entity.body) this.world.removeBody(entity.body);
        if (entity.bodies) for (const body of entity.bodies)this.world.removeBody(body);
        if (entity.springs) for (const spring of entity.springs)this.world.removeSpring(spring);
        if (entity.constraints) for (const constraint of entity.constraints)this.world.removeConstraint(constraint);
        if (entity.sprite) this.renderer.removeSprite(entity.sprite);
        if (entity.sprites) for (const sprite of entity.sprites)this.renderer.removeSprite(sprite);
        if (entity.onDestroy) entity.onDestroy({
            game: this
        });
    }
    /** Called before physics. */ tick(dt) {
        this.ticknumber += 1;
        this.dispatch("beforeTick", dt);
        this.dispatch("tick", dt);
    }
    /** Called before normal ticks */ slowTick(dt) {
        this.dispatch("slowTick", dt);
    }
    /** Called after physics. */ afterPhysics() {
        this.cleanupEntities();
        this.dispatch("afterPhysics", undefined);
    }
    /** Called before actually rendering. */ render(dt) {
        this.cleanupEntities();
        this.dispatch("render", dt);
        this.dispatch("lateRender", dt);
        this.renderer.render();
    }
    contacts() {
        for (const contactInfo of this.contactList.getContacts()){
            const { shapeA: shapeA, shapeB: shapeB, bodyA: bodyA, bodyB: bodyB, contactEquations: contactEquations } = contactInfo;
            const ownerA = shapeA.owner || bodyA.owner;
            const ownerB = shapeB.owner || bodyB.owner;
            if (ownerA?.onContacting) ownerA.onContacting({
                other: ownerB,
                otherShape: shapeB,
                thisShape: shapeA,
                contactEquations: contactEquations
            });
            if (ownerB?.onContacting) ownerB.onContacting({
                other: ownerA,
                otherShape: shapeA,
                thisShape: shapeB,
                contactEquations: contactEquations
            });
        }
    }
}


var $7b02d682eb115277$exports = {};
"use strict";

$7b02d682eb115277$exports = (parcelRequire("1b2ls"));


parcelRequire("acw62");
var $7e96a608cb33bf79$export$882461b6382ed46c;
var $7e96a608cb33bf79$export$757ceba2d55c277e;
"use strict";
var $11492dca620dcaa5$exports = {};
"use strict";
function $11492dca620dcaa5$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($11492dca620dcaa5$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$11492dca620dcaa5$var$checkDCE();

$11492dca620dcaa5$exports = (parcelRequire("Xw6Mv"));


var $7e96a608cb33bf79$var$i;
$7e96a608cb33bf79$export$882461b6382ed46c = $11492dca620dcaa5$exports.createRoot;
$7e96a608cb33bf79$export$757ceba2d55c277e = $11492dca620dcaa5$exports.hydrateRoot;



class $7d9b0c3658290da5$export$690dd8da38397efd extends (0, $c59361981bac2575$export$2e2bcd8739ae039) {
    constructor(getReactContent, autoRender = true){
        super();
        this.getReactContent = getReactContent;
        this.autoRender = autoRender;
    }
    reactRender() {
        this.reactRoot?.render(this.getReactContent());
    }
    onRender() {
        if (this.autoRender) this.reactRender();
    }
    onAdd() {
        this.el = document.createElement("div");
        document.body.append(this.el);
        this.reactRoot = (0, $7e96a608cb33bf79$export$882461b6382ed46c)(this.el);
    }
    onDestroy() {
        this.el.remove();
        this.reactRoot.unmount();
    }
}


const $7a5c18024ebdae3e$var$SMOOTHING = 0.95;
class $7a5c18024ebdae3e$export$2e2bcd8739ae039 extends (0, $7d9b0c3658290da5$export$690dd8da38397efd) {
    constructor(layerName){
        super(()=>{
            const { fps: fps, fps2: fps2, bodyCount: bodyCount, hugeBodyCount: hugeBodyCount, kinematicBodyCount: kinematicBodyCount, particleBodyCount: particleBodyCount, dynamicBodyCount: dynamicBodyCount, collisions: collisions, entityCount: entityCount, spriteCount: spriteCount } = this.getStats();
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "absolute top-0 left-0 z-1000",
                style: {
                    opacity: this.visible ? 1 : 0
                },
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("ul", {
                    className: "text-white text-xs font-mono flex gap-4",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                            children: [
                                "fps: ",
                                fps,
                                " (",
                                fps2,
                                ")"
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                            children: [
                                "bodies: ",
                                bodyCount,
                                " (",
                                kinematicBodyCount,
                                ", ",
                                particleBodyCount,
                                ",",
                                " ",
                                dynamicBodyCount,
                                ", ",
                                hugeBodyCount,
                                ")"
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                            children: [
                                "collisions: ",
                                collisions
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                            children: [
                                "entities: ",
                                entityCount
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                            children: [
                                "sprites: ",
                                spriteCount
                            ]
                        })
                    ]
                })
            });
        });
        this.persistenceLevel = 100;
        this.averageDuration = 0;
        this.slowFrameCount = 0;
        this.lastUpdate = performance.now();
        this.visible = false;
    }
    onAdd() {
        super.onAdd();
        this.averageDuration = 1 / 60;
    }
    onRender() {
        const now = performance.now();
        const duration = now - this.lastUpdate;
        this.averageDuration = $7a5c18024ebdae3e$var$SMOOTHING * this.averageDuration + (1.0 - $7a5c18024ebdae3e$var$SMOOTHING) * duration;
        this.lastUpdate = now;
        super.onRender();
    }
    getStats() {
        const world = this.game?.world;
        const broadphase = this.game?.world.broadphase;
        return {
            fps: Math.ceil(1000 / this.averageDuration),
            fps2: this.game.getScreenFps(),
            bodyCount: world?.bodies.length ?? 0,
            hugeBodyCount: broadphase.hugeBodies?.size ?? 0,
            dynamicBodyCount: broadphase.dynamicBodies.size,
            kinematicBodyCount: broadphase.kinematicBodies.size,
            particleBodyCount: broadphase.particleBodies.size,
            entityCount: this.game?.entities.all.size ?? 0,
            spriteCount: $7a5c18024ebdae3e$var$getSpriteCount(this.game.renderer.stage),
            collisions: (this.game?.world.broadphase).debugData.numCollisions
        };
    }
    onKeyDown({ key: key }) {
        if (key === "Backquote") this.visible = !this.visible;
    }
}
/** Counts the number of children of a display object. */ function $7a5c18024ebdae3e$var$getSpriteCount(root) {
    let total = 1;
    for (const child of root.children ?? [])total += $7a5c18024ebdae3e$var$getSpriteCount(child);
    return total;
}



parcelRequire("acw62");
// This file autogenerated by generate-asset-types.js
// Do not modify it by hand. Any changes will be overwritten.








































const $bcae27952f7958f2$var$sounds = {
    goalieDown: (parcelRequire("9KJyz")),
    goal: (parcelRequire("e5OlD")),
    goalHorn: (parcelRequire("5kXBn")),
    gateHit: (parcelRequire("kcrfF")),
    gameStart: (parcelRequire("eoXur")),
    gameOver: (parcelRequire("eIOhw")),
    flipperUp: (parcelRequire("e2l3X")),
    flipperUp8: (parcelRequire("3pswo")),
    flipperUp7: (parcelRequire("kVXKs")),
    flipperUp6: (parcelRequire("l8ZP4")),
    flipperUp5: (parcelRequire("4rdo5")),
    flipperUp4: (parcelRequire("7VpP9")),
    flipperUp3: (parcelRequire("7LbxD")),
    flipperUp2: (parcelRequire("fgKYy")),
    flipperHit: (parcelRequire("29cBf")),
    flipperDown: (parcelRequire("eFkZY")),
    flipperDown3: (parcelRequire("j1gLE")),
    flipperDown2: (parcelRequire("12Tew")),
    drain: (parcelRequire("6l3mZ")),
    defenderUp2: (parcelRequire("4mHKx")),
    defenderUp1: (parcelRequire("S2z7r")),
    defenderDown3: (parcelRequire("iZztn")),
    defenderDown2: (parcelRequire("8c0OE")),
    defenderDown1: (parcelRequire("6UeJA")),
    buzz: (parcelRequire("10hc9")),
    buttonUp1: (parcelRequire("luJqe")),
    buttonDown1: (parcelRequire("fgZMo")),
    bumper2: (parcelRequire("cXEQW")),
    bumper1: (parcelRequire("adttp")),
    boing2: (parcelRequire("gUQnr")),
    boing1: (parcelRequire("aQTLX")),
    ballRolling: (parcelRequire("coCKr")),
    ballRollingRawSm57: (parcelRequire("5Df8S")),
    ballRollingRawAt3035: (parcelRequire("eDPcV")),
    ballRolling3: (parcelRequire("68hzO")),
    ballRolling2: (parcelRequire("b3KML")),
    ballOnBallRaw: (parcelRequire("eqETw")),
    ballOnBall2: (parcelRequire("G4aMa")),
    ballOnBall1: (parcelRequire("9Y3eX")),
    ballDrop1: (parcelRequire("1YU51"))
};



const $bcae27952f7958f2$var$images = {
    wallAo1: (parcelRequire("gE90K")),
    wall1: (parcelRequire("4GVgl")),
    favicon: (parcelRequire("as850"))
};
const $bcae27952f7958f2$var$fonts = {};
const $bcae27952f7958f2$var$levels = {};
const $bcae27952f7958f2$var$entityDefs = {};
const $bcae27952f7958f2$var$jsonBlobs = {};
const $bcae27952f7958f2$export$4e841128923ef26 = {
    sounds: $bcae27952f7958f2$var$sounds,
    images: $bcae27952f7958f2$var$images,
    fonts: $bcae27952f7958f2$var$fonts,
    levels: $bcae27952f7958f2$var$levels,
    entityDefs: $bcae27952f7958f2$var$entityDefs,
    jsonBlobs: $bcae27952f7958f2$var$jsonBlobs
};





// Stores all loaded buffers
const $ccca576b723d73ff$var$buffers = new Map();
function $ccca576b723d73ff$export$ac84dee4d6d87cfb(name) {
    return $ccca576b723d73ff$var$buffers.has(name);
}
function $ccca576b723d73ff$export$4addc79a408174e5(name) {
    const buffer = $ccca576b723d73ff$var$buffers.get(name);
    if (!buffer) throw new Error(`Audio Buffer not loaded: ${name}`);
    return buffer;
}
function $ccca576b723d73ff$export$19a3f18ff5ca2035(name) {
    return $ccca576b723d73ff$var$buffers.get(name)?.duration ?? -1;
}
function $ccca576b723d73ff$export$1b9da31cab5f5660(name) {
    return $ccca576b723d73ff$var$buffers.get(name) != undefined;
}
// Keeps track of filesizes, for figuring out how to optimize our asset loading
const $ccca576b723d73ff$var$fileSizes = new Map();
function $ccca576b723d73ff$export$6be99376ef785c18() {
    return [
        ...$ccca576b723d73ff$var$fileSizes.values()
    ].reduce((sum, current)=>sum + current, 0);
}
function $ccca576b723d73ff$export$3884bbcde8456ae4() {
    const entries = [
        ...$ccca576b723d73ff$var$fileSizes.entries()
    ];
    entries.sort(([url1, size1], [url2, size2])=>size2 - size1);
    return entries;
}
function $ccca576b723d73ff$export$b423bdfb9415e6b1(url) {
    if (!$ccca576b723d73ff$var$fileSizes.has(url)) throw new Error(`Sound not loaded: ${url}`);
    return $ccca576b723d73ff$var$fileSizes.get(url);
}
async function $ccca576b723d73ff$export$f00979f1f84fa256(name, url, audioContext) {
    return fetch(url).then((response)=>{
        const bytes = Number(response.headers.get("Content-Length"));
        $ccca576b723d73ff$var$fileSizes.set(url, bytes);
        return response.arrayBuffer();
    }).then((data)=>audioContext.decodeAudioData(data)).then((buffer)=>{
        $ccca576b723d73ff$var$buffers.set(name, buffer);
        return buffer;
    });
}


class $2cad9d9952e2fd36$export$2e2bcd8739ae039 extends (0, $c59361981bac2575$export$2e2bcd8739ae039) {
    constructor(manifest, reactRender){
        super();
        this.manifest = manifest;
        this.progress = {
            fonts: {
                loaded: 0,
                total: 0
            },
            images: {
                loaded: 0,
                total: 0
            },
            sounds: {
                loaded: 0,
                total: 0
            }
        };
        this._promise = new Promise((resolve)=>{
            this._resolve = resolve;
        });
        this.addChild(new (0, $7d9b0c3658290da5$export$690dd8da38397efd)(()=>reactRender(this.progress)));
    }
    async onAdd({ game: game }) {
        await Promise.all([
            this.loadFonts(),
            this.loadSounds(game.audio),
            this.loadImages()
        ]);
        const bytes = (0, $ccca576b723d73ff$export$6be99376ef785c18)();
        console.groupCollapsed(`Audio Loaded: ${(bytes / 2 ** 20).toFixed(1)}MB total`);
        (0, $ccca576b723d73ff$export$3884bbcde8456ae4)().slice(0, 5).forEach(([url, size])=>console.info(url, "\n", `${(size / 1024).toFixed(1)}kB`));
        console.groupEnd();
        this._resolve();
    }
    waitTillLoaded() {
        return this._promise;
    }
    async loadFonts() {
        this.progress.fonts.total = Object.values(this.manifest.fonts).length;
        this.progress.fonts.loaded = 0;
        try {
            await Promise.all(Object.entries(this.manifest.fonts).map(async ([name, src])=>{
                const fontFace = new FontFace(name, `url(${src})`);
                document.fonts.add(await fontFace.load());
                this.progress.fonts.loaded += 1;
            }));
        } catch (e) {
            console.error("Fonts failed to load", e);
        }
    }
    async loadSounds(audioContext) {
        this.progress.sounds.loaded = 0;
        this.progress.sounds.total = Object.values(this.manifest.sounds).length;
        await Promise.all(Object.entries(this.manifest.sounds).map(async ([name, url])=>{
            try {
                await (0, $ccca576b723d73ff$export$f00979f1f84fa256)(name, url, audioContext);
            } catch (e) {
                console.warn(`Sound failed to load: ${url}, ${url}`, e);
            }
            this.progress.sounds.loaded += 1;
        }));
    }
    async loadImages() {
        this.progress.images.loaded = 0;
        this.progress.images.total = Object.values(this.manifest.images).length;
        $f4e4ce59fcdafcd2$export$c8eca95e306f7116.addBundle("images", this.manifest.images);
        try {
            await $f4e4ce59fcdafcd2$export$c8eca95e306f7116.loadBundle("images", (progressPercent)=>{
                this.progress.images.loaded += 1;
            });
        } catch (e) {
            console.error("Images failed to load", e);
        }
    }
    onDestroy() {
        document.getElementById("preloader")?.remove();
    }
}


const $da7e16e29ed26d68$export$910dfe656d5d75a4 = new (0, $2cad9d9952e2fd36$export$2e2bcd8739ae039)((0, $bcae27952f7958f2$export$4e841128923ef26), ({ fonts: fonts, images: images, sounds: sounds })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        style: {
            display: "flex",
            justifyContent: "center",
            padding: "8rem",
            position: "absolute",
            inset: 0
        },
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            style: {
                color: "white",
                display: "flex",
                flexDirection: "column",
                fontFamily: `monospace`,
                fontSize: "1.5rem",
                gap: "1rem"
            },
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    style: {
                        fontFamily: `monospace`,
                        fontSize: "2em"
                    },
                    children: "Loading..."
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            children: "fonts"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("progress", {
                            style: {
                                display: "block"
                            },
                            value: fonts.loaded,
                            max: fonts.total
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            children: "images"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("progress", {
                            style: {
                                display: "block"
                            },
                            value: images.loaded,
                            max: images.total
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            children: "sounds"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("progress", {
                            style: {
                                display: "block"
                            },
                            value: sounds.loaded,
                            max: sounds.total
                        })
                    ]
                })
            ]
        })
    }));



function $25c6ed34d0d559af$export$259b4dd69e654a7a(obj) {
    return Object.keys(obj);
}
function $25c6ed34d0d559af$export$6a29ade99f81ec8a(obj) {
    return Object.entries(obj);
}
function $25c6ed34d0d559af$export$58aefef1ff9edd34(obj, fn) {
    return $25c6ed34d0d559af$export$259b4dd69e654a7a(obj).reduce((acc, key)=>{
        acc[key] = fn(obj[key], key);
        return acc;
    }, {});
}
function $25c6ed34d0d559af$export$357523c63a2253b9(obj, keys) {
    return keys.reduce((acc, key)=>{
        acc[key] = obj[key];
        return acc;
    }, {});
}
function $25c6ed34d0d559af$export$a188e271553f9211(arr, getKey) {
    return $25c6ed34d0d559af$export$6a29ade99f81ec8a(arr.reduce((acc, item)=>{
        const key = getKey(item);
        if (!acc[key]) acc[key] = [];
        acc[key].push(item);
        return acc;
    }, {}));
}


const $5bcc608e810b36d0$export$83e30a963a2d9644 = {
    Wall: new (0, $83a57dc453139d82$exports.Material)(),
    Ball: new (0, $83a57dc453139d82$exports.Material)(),
    Peg: new (0, $83a57dc453139d82$exports.Material)()
};
const $5bcc608e810b36d0$var$MaterialToName = Object.fromEntries((0, $25c6ed34d0d559af$export$6a29ade99f81ec8a)($5bcc608e810b36d0$export$83e30a963a2d9644).map(([name, material])=>[
        material.id,
        name
    ]));
function $5bcc608e810b36d0$export$1cea7f3370526999(material) {
    return $5bcc608e810b36d0$var$MaterialToName[material.id];
}
const $5bcc608e810b36d0$export$fcae83fc05fd103e = [
    new (0, $83a57dc453139d82$exports.ContactMaterial)($5bcc608e810b36d0$export$83e30a963a2d9644.Ball, $5bcc608e810b36d0$export$83e30a963a2d9644.Ball, {
        restitution: 0.8
    }),
    new (0, $83a57dc453139d82$exports.ContactMaterial)($5bcc608e810b36d0$export$83e30a963a2d9644.Ball, $5bcc608e810b36d0$export$83e30a963a2d9644.Wall, {
        restitution: 0.8
    }),
    new (0, $83a57dc453139d82$exports.ContactMaterial)($5bcc608e810b36d0$export$83e30a963a2d9644.Ball, $5bcc608e810b36d0$export$83e30a963a2d9644.Peg, {
        restitution: 0.8
    })
];



parcelRequire("acw62");

class $0e28100eb9c66a46$export$4e08dcf990b776c0 extends (0, $7d9b0c3658290da5$export$690dd8da38397efd) {
    constructor(){
        super(()=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "menu-screen",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "max-w-2xl mx-auto flex flex-col gap-4",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                            children: "Pachinko Roguelike"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            onClick: ()=>{
                                this.game.dispatch("gameStart", undefined);
                                this.destroy();
                            },
                            children: "Start Game"
                        })
                    ]
                })
            }));
    }
}



const $dacf2a27a9098ed7$export$d66e5010c3cf1caa = {
    basic: {
        name: "basic",
        color: 0xccccff,
        radius: 0.35,
        mass: 1
    },
    big: {
        name: "big",
        color: 0xffcccc,
        radius: 0.5,
        mass: 2
    }
};




/**
 * Utility functions for doing things based on random numbers.
 */ // just for shorthand
const $f1ed8354ebe33615$var$r = Math.random;
function $f1ed8354ebe33615$export$1ab1062261c98efe(min, max) {
    if (min == null) return $f1ed8354ebe33615$var$r();
    if (max == null) {
        max = min;
        min = 0;
    }
    return (max - min) * $f1ed8354ebe33615$var$r() + min;
}
function $f1ed8354ebe33615$export$6c5277ffd5bb6b0b() {
    return $f1ed8354ebe33615$export$1ab1062261c98efe(0, Math.PI * 2);
}
function $f1ed8354ebe33615$export$d2675ab7bc8f0cd4() {
    return $f1ed8354ebe33615$export$7877a478dd30fd3d(0, Math.PI / 2, Math.PI, 3 * Math.PI / 2);
}
function $f1ed8354ebe33615$export$4dc4a801a9bb2c7e(mean = 0.0, deviation = 1.0) {
    return deviation * ($f1ed8354ebe33615$var$r() + $f1ed8354ebe33615$var$r() + $f1ed8354ebe33615$var$r() + $f1ed8354ebe33615$var$r() + $f1ed8354ebe33615$var$r() + $f1ed8354ebe33615$var$r() - 3) / 3 + mean;
}
function $f1ed8354ebe33615$export$e0c4b1630ec012c1(chanceOfTrue = 0.5) {
    return $f1ed8354ebe33615$var$r() < chanceOfTrue;
}
function $f1ed8354ebe33615$export$e8015c10d27df017(chanceOfPositive = 0.5) {
    return $f1ed8354ebe33615$export$e0c4b1630ec012c1(chanceOfPositive) ? 1 : -1;
}
function $f1ed8354ebe33615$export$4b740f64b13739ef(min, max) {
    return Math.floor($f1ed8354ebe33615$export$1ab1062261c98efe(min, max));
}
function $f1ed8354ebe33615$export$73b235628570e6fd() {
    return $f1ed8354ebe33615$export$4b740f64b13739ef(0, 256);
}
function $f1ed8354ebe33615$export$9f5ea5e22d955aad(x) {
    const low = Math.floor(x);
    return $f1ed8354ebe33615$export$e0c4b1630ec012c1(x - low) ? low : low + 1;
}
function $f1ed8354ebe33615$export$7877a478dd30fd3d(...options) {
    return options[$f1ed8354ebe33615$export$4b740f64b13739ef(0, options.length)];
}
function $f1ed8354ebe33615$export$b7df5d561049483a(options) {
    return options.splice($f1ed8354ebe33615$export$4b740f64b13739ef(0, options.length), 1)[0];
}
function $f1ed8354ebe33615$export$448332262467e042(a) {
    let i, j;
    i = a.length;
    while(--i > 0){
        j = $f1ed8354ebe33615$export$4b740f64b13739ef(0, i + 1);
        [a[i], a[j]] = [
            a[j],
            a[i]
        ];
    }
    return a;
}
function $f1ed8354ebe33615$export$9292fb87b153dc08(a, seed) {
    let i, j, temp;
    i = a.length;
    while(--i > 0){
        seed = seed * 1103515245 + 12345 | 0;
        j = (0, $2172aedd5a25ff17$export$842a2cf37af977e1)(seed, i + 1);
        temp = a[j];
        a[j] = a[i];
        a[i] = temp;
    }
    return a;
}








const $a3e1554f799f9859$var$ROLLING_FRICTION = 0.001;
const $a3e1554f799f9859$var$GRAVITY = 100;
class $a3e1554f799f9859$export$a83d7c3fa53790c9 extends (0, $c59361981bac2575$export$2e2bcd8739ae039) {
    constructor(position, ballData){
        super();
        this.ballData = ballData;
        this.body = new (0, $83a57dc453139d82$exports.Body)({
            type: (0, $83a57dc453139d82$exports.Body).DYNAMIC,
            mass: ballData.mass,
            position: position,
            ccdSpeedThreshold: 1,
            ccdIterations: 8
        });
        const shape = new (0, $83a57dc453139d82$exports.Circle)({
            radius: ballData.radius
        });
        shape.material = (0, $5bcc608e810b36d0$export$83e30a963a2d9644).Ball;
        this.body.addShape(shape);
        this.sprite = (0, $3e96093e790a5ff7$export$f83f79acb3f2cc85)("ball").circle(0, 0, ballData.radius).fill(this.ballData.color);
    }
    onRender() {
        this.sprite.position.set(...this.body.position);
        this.sprite.rotation = this.body.angle;
    }
    onTick() {
        // Gravity
        this.body.applyForce([
            0,
            $a3e1554f799f9859$var$GRAVITY
        ]);
        // Rolling friction
        this.body.applyForce((0, $6b6a54a072724620$export$e7c866399fa523f5)(this.body.velocity).imul(-$a3e1554f799f9859$var$ROLLING_FRICTION));
    }
}
function $a3e1554f799f9859$export$1fbaed9b1af68dcc(entity) {
    return entity != undefined && entity instanceof $a3e1554f799f9859$export$a83d7c3fa53790c9;
}





const $3e13a2af7667411c$var$DROPPER_SPEED = 10;
class $3e13a2af7667411c$export$f84d6ee381362d24 extends (0, $c59361981bac2575$export$2e2bcd8739ae039) {
    constructor(bounds){
        super();
        this.bounds = bounds;
        this.id = "dropper";
        this.width = 20;
        this.height = 25;
        this.sprite = (0, $3e96093e790a5ff7$export$f83f79acb3f2cc85)("backDecals").circle(0, 0, 0.5).fill({
            color: 0xffff00,
            alpha: 0.5
        });
        this.sprite.position.set(10, 1);
    }
    onTick(dt) {
        const dx = this.game.io.getMovementVector()[0];
        this.sprite.x += dx * dt * $3e13a2af7667411c$var$DROPPER_SPEED;
        this.sprite.x = (0, $2172aedd5a25ff17$export$7d15b64cf5a3a4c4)(this.sprite.x, this.bounds[0], this.bounds[1]);
    }
}



parcelRequire("acw62");

class $1f29681d97ee722a$export$83f20e873a2b9c44 extends (0, $7d9b0c3658290da5$export$690dd8da38397efd) {
    constructor(level){
        super(()=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "absolute top-10 right-10 flex flex-col gap-4",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h2", {
                        className: "text-white text-xl",
                        children: [
                            "Level ",
                            level.levelNumber.toLocaleString()
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h2", {
                        className: "text-white text-lg",
                        children: [
                            level.score.toLocaleString(),
                            " points"
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                        className: "text-white",
                        children: "Balls"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("section", {
                        className: "flex flex-row gap-1 items-stretch",
                        children: level.ballStacks.stacks.map((ballStack, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("ol", {
                                className: "flex flex-col gap-1 items-center",
                                children: [
                                    ballStack.balls.map((ball)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                            className: "rounded bg-slate-300 inline-block px-1",
                                            children: ball.name
                                        })),
                                    level.ballStacks.currentStack === ballStack && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        children: "*"
                                    })
                                ]
                            }, i))
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("menu", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                onClick: ()=>this.game.slowMo = 0.5,
                                children: "0.5x"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                onClick: ()=>this.game.slowMo = 1,
                                children: "1x"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                onClick: ()=>this.game.slowMo = 2,
                                children: "2x"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                onClick: ()=>this.game.slowMo = 3,
                                children: "3x"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                onClick: ()=>this.game.slowMo = 10,
                                children: "10x"
                            })
                        ]
                    })
                ]
            }));
    }
}








var $eicwU = parcelRequire("eicwU");
var $3cebA = parcelRequire("3cebA");
class $93da3db2f1189c77$export$c2b99a0f4c3eed35 extends (0, $c59361981bac2575$export$2e2bcd8739ae039) {
    constructor(position, size, points = 100){
        super();
        this.points = points;
        this.body = new (0, $83a57dc453139d82$exports.Body)({
            type: (0, $83a57dc453139d82$exports.Body).STATIC,
            position: position
        });
        const [width, height] = size;
        const shape = new (0, $83a57dc453139d82$exports.Box)({
            width: width,
            height: height
        });
        shape.sensor = true;
        this.body.addShape(shape);
        this.sprite = new (0, $eicwU.Container)();
        const graphics = new (0, $3cebA.Graphics)().rect(-width / 2, -height / 2, width, height).fill({
            color: 0x000000,
            alpha: 0.5
        });
        this.sprite.addChild(graphics);
        this.sprite.position.set(...position);
    }
    onBeginContact({ other: other }) {
        if ((0, $a3e1554f799f9859$export$1fbaed9b1af68dcc)(other)) this.game?.dispatch("ballInHole", {
            ball: other,
            hole: this
        });
    }
}






class $1f9dee0a642a3a24$export$560b145b997724b8 extends (0, $c59361981bac2575$export$2e2bcd8739ae039) {
    constructor(position){
        super();
        this.body = new (0, $83a57dc453139d82$exports.Body)({
            type: (0, $83a57dc453139d82$exports.Body).STATIC,
            mass: 1,
            position: position
        });
        const radius = 0.15;
        const shape = new (0, $83a57dc453139d82$exports.Circle)({
            radius: radius
        });
        shape.material = (0, $5bcc608e810b36d0$export$83e30a963a2d9644).Peg;
        this.body.addShape(shape);
        this.sprite = (0, $3e96093e790a5ff7$export$f83f79acb3f2cc85)("pegs").circle(0, 0, radius).fill(0xaaaaaa);
        this.sprite.position.set(...this.body.position);
        this.sprite.rotation = this.body.angle;
    }
}
function $1f9dee0a642a3a24$export$7c770b480fed7e55(entity) {
    return entity instanceof $1f9dee0a642a3a24$export$560b145b997724b8;
}







// Assign things to groups so that we can easily enable/disable collisions between different groups
let $3fc6bebdd46ec189$var$i = 0;
const $3fc6bebdd46ec189$var$makeGroup = ()=>1 << $3fc6bebdd46ec189$var$i++;
const $3fc6bebdd46ec189$export$2c542525543f3ad4 = {
    None: 0,
    Environment: $3fc6bebdd46ec189$var$makeGroup(),
    Ball: $3fc6bebdd46ec189$var$makeGroup()
};
const $3fc6bebdd46ec189$export$93c35edfe1e68454 = {
    ...$3fc6bebdd46ec189$export$2c542525543f3ad4,
    All: Object.values($3fc6bebdd46ec189$export$2c542525543f3ad4).reduce((acc, group)=>acc | group, 0)
};
function $3fc6bebdd46ec189$export$e7c83b2fe0ddf2df(groups) {
    return groups.reduce((acc, group)=>acc | $3fc6bebdd46ec189$export$93c35edfe1e68454[group], $3fc6bebdd46ec189$export$93c35edfe1e68454.None);
}
const $3fc6bebdd46ec189$var$groupNames = (0, $25c6ed34d0d559af$export$259b4dd69e654a7a)($3fc6bebdd46ec189$export$93c35edfe1e68454).filter((name)=>name !== "All");
function $3fc6bebdd46ec189$export$43a218787169d5f9(group) {
    if (group === $3fc6bebdd46ec189$export$93c35edfe1e68454.All) return [
        "All"
    ];
    return $3fc6bebdd46ec189$var$groupNames.filter((name)=>group & $3fc6bebdd46ec189$export$93c35edfe1e68454[name]);
}



class $31176d062ddcb5e8$export$2e2bcd8739ae039 extends (0, $c59361981bac2575$export$2e2bcd8739ae039) {
    constructor([x1, y1], [x2, y2]){
        super();
        const width = 0.35;
        const length = (0, $83a57dc453139d82$exports.vec2).dist([
            x1,
            y1
        ], [
            x2,
            y2
        ]);
        const x = (x1 + x2) / 2;
        const y = (y1 + y2) / 2;
        const angle = (0, $6b6a54a072724620$export$e7c866399fa523f5)(x2 - x1, y2 - y1).angle + Math.PI / 2;
        const drawHeight = length + width / 2; // add in width to make things line up nicely
        // TODO: AO Breaks on outside corners
        const aoSprite = (0, $3e96093e790a5ff7$export$365048a7a2b11da6)("wallAo1", "shadows");
        aoSprite.blendMode = "multiply";
        aoSprite.anchor.set(0.5, 0.5);
        aoSprite.width = drawHeight;
        aoSprite.height = width;
        aoSprite.position.set(x, y);
        aoSprite.rotation = angle + Math.PI / 2;
        // TODO: Tile wall sprite rather than just stretch it
        const wallSprite = (0, $3e96093e790a5ff7$export$365048a7a2b11da6)("wall1", "walls");
        wallSprite.anchor.set(0.5, 0.5);
        wallSprite.width = drawHeight;
        wallSprite.height = width * 3;
        wallSprite.position.set(x, y);
        wallSprite.rotation = angle + Math.PI / 2;
        wallSprite.tint = 0xffffff;
        this.sprites = [
            wallSprite
        ];
        this.body = new (0, $83a57dc453139d82$exports.Body)({
            mass: 0,
            position: [
                x,
                y
            ],
            angle: angle
        });
        const shape = new (0, $83a57dc453139d82$exports.Box)({
            width: width,
            height: length
        });
        shape.collisionGroup = (0, $3fc6bebdd46ec189$export$93c35edfe1e68454).Environment;
        shape.collisionMask = (0, $3fc6bebdd46ec189$export$93c35edfe1e68454).All;
        shape.material = (0, $5bcc608e810b36d0$export$83e30a963a2d9644).Wall;
        this.body.addShape(shape);
    }
}


class $f8904864fab21bc3$export$a5651cbbba83c853 extends (0, $c59361981bac2575$export$2e2bcd8739ae039) {
    constructor(width = 20, height = 25){
        super();
        this.width = width;
        this.height = height;
        this.addChild(new (0, $31176d062ddcb5e8$export$2e2bcd8739ae039)([
            0,
            0
        ], [
            this.width,
            0
        ]));
        this.addChild(new (0, $31176d062ddcb5e8$export$2e2bcd8739ae039)([
            this.width,
            0
        ], [
            this.width,
            this.height
        ]));
        this.addChild(new (0, $31176d062ddcb5e8$export$2e2bcd8739ae039)([
            this.width,
            this.height
        ], [
            0,
            this.height
        ]));
        this.addChild(new (0, $31176d062ddcb5e8$export$2e2bcd8739ae039)([
            0,
            this.height
        ], [
            0,
            0
        ]));
        for(let j = 0; j < 8; j++){
            const odd = j % 2 === 1;
            for(let i = 0; i < (odd ? 9 : 10); i++)this.addChild(new (0, $1f9dee0a642a3a24$export$560b145b997724b8)((0, $6b6a54a072724620$export$e7c866399fa523f5)(i * 2 + (odd ? 2 : 1), j * 2 + 5)));
        }
        const nHoles = 5;
        const holeWidth = this.width / nHoles;
        const holeHeight = 2;
        for(let i = 0; i < nHoles; i++)this.addChild(new (0, $93da3db2f1189c77$export$c2b99a0f4c3eed35)((0, $6b6a54a072724620$export$e7c866399fa523f5)((i + 0.5) * holeWidth, this.height - holeHeight / 2), (0, $6b6a54a072724620$export$e7c866399fa523f5)(holeWidth, holeHeight)));
        const wallWidth = 0.4;
        for(let i = 1; i < nHoles; i++){
            const x = i * holeWidth + wallWidth / 2;
            this.addChild(new (0, $31176d062ddcb5e8$export$2e2bcd8739ae039)((0, $6b6a54a072724620$export$e7c866399fa523f5)(x, this.height - (holeHeight + 1)), (0, $6b6a54a072724620$export$e7c866399fa523f5)(x, this.height)));
        }
    }
}


class $e81346e5fa6a13e4$export$ca664994d1d54bff extends (0, $c59361981bac2575$export$2e2bcd8739ae039) {
    constructor(levelNumber, balls){
        super();
        this.id = "level";
        this.width = 20;
        this.height = 25;
        this.score = 0;
        this.selectedStack = 0;
        this.levelNumber = levelNumber;
        this.scoreToBeat = levelNumber * 100;
        this.addChild(new (0, $1f29681d97ee722a$export$83f20e873a2b9c44)(this));
        this.dropper = this.addChild(new (0, $3e13a2af7667411c$export$f84d6ee381362d24)([
            0,
            this.width
        ]));
        this.addChild(new (0, $f8904864fab21bc3$export$a5651cbbba83c853)(this.width, this.height));
        this.ballStacks = new $e81346e5fa6a13e4$var$BallStacks(balls);
    }
    onRender() {
        this.game.camera.center((0, $6b6a54a072724620$export$e7c866399fa523f5)(this.width / 2, this.height / 2));
    }
    async onBallInHole({ ball: ball, hole: hole }) {
        await this.wait(0.5);
        ball.destroy();
        // Calculate score
        this.score += hole.points;
        await this.wait(0.5);
        const playfieldIsClear = this.game?.entities.getByFilter((0, $a3e1554f799f9859$export$1fbaed9b1af68dcc)).length === 0;
        if (playfieldIsClear) {
            if (this.score >= this.scoreToBeat) this.game?.dispatch("levelComplete", {
                level: this
            });
            if (this.ballStacks.isEmpty()) this.game?.dispatch("gameOver", undefined);
        }
    }
    onKeyDown({ key: key, event: event }) {
        switch(key){
            case "Space":
                this.launchBall();
                break;
            case "Tab":
                if (event.shiftKey) this.ballStacks.prevStack();
                else this.ballStacks.nextStack();
                break;
        }
    }
    launchBall() {
        if (!this.ballStacks.currentStack.isEmpty()) {
            const ballData = this.ballStacks.currentStack.pop();
            const [x, y] = this.dropper.getPosition();
            this.addChild(new (0, $a3e1554f799f9859$export$a83d7c3fa53790c9)([
                x + (0, $f1ed8354ebe33615$export$4dc4a801a9bb2c7e)(0, 0.1),
                y
            ], ballData));
        }
    }
}
function $e81346e5fa6a13e4$export$81355ab2cfff89ca(entity) {
    return entity instanceof $e81346e5fa6a13e4$export$ca664994d1d54bff;
}
class $e81346e5fa6a13e4$var$BallStacks {
    constructor(balls, n = 3){
        this.stacks = [];
        this.currentStackIndex = 0;
        const stacks = [];
        // create n stacks
        for(let i = 0; i < n; i++)stacks.push([]);
        const shuffledBalls = (0, $f1ed8354ebe33615$export$448332262467e042)([
            ...balls
        ]);
        // divide the balls evenly into the stacks
        for(let i = 0; i < shuffledBalls.length; i++)stacks[i % n].push(shuffledBalls[i]);
        for (const stack of stacks)this.stacks.push(new $e81346e5fa6a13e4$var$BallStack(stack));
    }
    nextStack() {
        this.currentStackIndex = (this.currentStackIndex + 1) % this.stacks.length;
    }
    prevStack() {
        this.currentStackIndex = (this.currentStackIndex - 1 + this.stacks.length) % this.stacks.length;
    }
    get currentStack() {
        return this.stacks[this.currentStackIndex];
    }
    get ballsRemaining() {
        return this.stacks.reduce((acc, stack)=>acc + stack.balls.length, 0);
    }
    isEmpty() {
        return this.stacks.every((stack)=>stack.isEmpty());
    }
}
class $e81346e5fa6a13e4$var$BallStack {
    constructor(balls){
        this.balls = [];
        this.balls = balls;
    }
    pop() {
        return this.balls.shift();
    }
    peek() {
        return this.balls.at(0);
    }
    isEmpty() {
        return this.balls.length === 0;
    }
}



parcelRequire("acw62");

class $c2cad548d22b70b6$export$66bb9231a6614ad8 extends (0, $7d9b0c3658290da5$export$690dd8da38397efd) {
    constructor(){
        super(()=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: {
                    position: "absolute",
                    top: 0,
                    left: 0
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                        children: "Pause Menu"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        children: "The game is paused"
                    })
                ]
            }));
    }
    onKeyDown({ key: key }) {
        if (key === "Escape") this.destroy();
    }
}



parcelRequire("acw62");



class $45891f1e46050efd$export$234f836bdddddfd4 extends (0, $7d9b0c3658290da5$export$690dd8da38397efd) {
    constructor(gameManager){
        super(()=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "absolute inset-8",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "max-w-2xl mx-auto flex flex-col gap-4",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                            children: "Shop"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("section", {
                            className: "flex gap-1",
                            children: (0, $25c6ed34d0d559af$export$a188e271553f9211)(gameManager.ballDatas, (group)=>group.name).map(([name, ballDatas])=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "rounded bg-slate-300 inline-block px-1",
                                    children: [
                                        name,
                                        "x",
                                        ballDatas.length
                                    ]
                                }))
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                            className: "flex gap-1",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                    onClick: ()=>{
                                        this.game?.dispatch("ballPurchased", {
                                            ballData: (0, $dacf2a27a9098ed7$export$d66e5010c3cf1caa).basic
                                        });
                                    },
                                    children: "Buy Basic Ball"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                    onClick: ()=>{
                                        this.game?.dispatch("ballPurchased", {
                                            ballData: (0, $dacf2a27a9098ed7$export$d66e5010c3cf1caa).big
                                        });
                                    },
                                    children: "Buy Big Ball"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("section", {
                            className: "flex justify-end",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                onClick: ()=>this.end(),
                                children: "Done"
                            })
                        })
                    ]
                })
            }));
    }
    end() {
        this.game?.dispatch("shopScreenEnd", undefined);
        this.destroy();
    }
}


class $25b0331400fe0fe4$export$1df5c89a5d722120 extends (0, $c59361981bac2575$export$2e2bcd8739ae039) {
    nextLevel() {
        this.game?.addEntity(new (0, $e81346e5fa6a13e4$export$ca664994d1d54bff)(this.levelNumber, this.ballDatas));
    }
    onGameStart() {
        this.ballDatas = [
            (0, $dacf2a27a9098ed7$export$d66e5010c3cf1caa).basic,
            (0, $dacf2a27a9098ed7$export$d66e5010c3cf1caa).basic,
            (0, $dacf2a27a9098ed7$export$d66e5010c3cf1caa).basic,
            (0, $dacf2a27a9098ed7$export$d66e5010c3cf1caa).basic,
            (0, $dacf2a27a9098ed7$export$d66e5010c3cf1caa).basic,
            (0, $dacf2a27a9098ed7$export$d66e5010c3cf1caa).basic,
            (0, $dacf2a27a9098ed7$export$d66e5010c3cf1caa).basic,
            (0, $dacf2a27a9098ed7$export$d66e5010c3cf1caa).basic,
            (0, $dacf2a27a9098ed7$export$d66e5010c3cf1caa).basic,
            (0, $dacf2a27a9098ed7$export$d66e5010c3cf1caa).big
        ];
        this.nextLevel();
    }
    onShopScreenEnd() {
        this.nextLevel();
    }
    onLevelComplete({ level: level }) {
        this.levelNumber++;
        level.destroy();
        this.addChild(new (0, $45891f1e46050efd$export$234f836bdddddfd4)(this));
    }
    onBallPurchased({ ballData: ballData }) {
        this.ballDatas = [
            ...this.ballDatas,
            ballData
        ];
    }
    onKeyDown({ key: key }) {
        if (key === "Escape") {
            this.game?.addEntity(new (0, $c2cad548d22b70b6$export$66bb9231a6614ad8)());
            this.game?.pause();
        }
    }
    constructor(...args){
        super(...args);
        this.id = "gameManager";
        this.levelNumber = 0;
        this.ballDatas = [];
    }
}


async function $14adf9d48a6c8b11$var$main() {
    // Make the pixel art crisp
    (0, $aFPUT.TextureStyle).defaultOptions.scaleMode = "linear";
    const game = new (0, $e4c72b6b95368f7f$export$2e2bcd8739ae039)({
        ticksPerSecond: 300
    });
    await game.init({
        rendererOptions: {
            backgroundColor: 0x444454
        }
    });
    // Make the game accessible from the console
    window.DEBUG = {
        game: game
    };
    for (const contactMaterial of (0, $5bcc608e810b36d0$export$fcae83fc05fd103e))game.world.addContactMaterial(contactMaterial);
    const preloader = game.addEntity((0, $da7e16e29ed26d68$export$910dfe656d5d75a4));
    await preloader.waitTillLoaded();
    preloader.destroy();
    game.addEntity(new (0, $25b0331400fe0fe4$export$1df5c89a5d722120)());
    game.addEntity(new (0, $0e28100eb9c66a46$export$4e08dcf990b776c0)());
}
window.addEventListener("load", $14adf9d48a6c8b11$var$main);


//# sourceMappingURL=index.9c413ca1.js.map
